(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Grafika"] = factory();
	else
		root["Grafika"] = factory();
})(this, function() {
return webpackJsonpGrafika([3],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(130);


/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash 4.9.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash -d -o ./foo/lodash.js`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.9.0';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256,
	      FLIP_FLAG = 512;
	
	  /** Used to compose bitmasks for comparison styles. */
	  var UNORDERED_COMPARE_FLAG = 1,
	      PARTIAL_COMPARE_FLAG = 2;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0x/i;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	      rsComboSymbolsRange = '\\u20d0-\\u20f0',
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsQuoteRange = '\\u2018\\u2019\\u201c\\u201d',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsQuoteRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reComplexSymbol = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasComplexSymbol = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
	
	  /** Used to match non-compound words composed of alphanumeric characters. */
	  var reBasicWord = /[a-zA-Z0-9]+/g;
	
	  /** Used to match complex or compound words. */
	  var reComplexWord = RegExp([
	    rsUpper + '?' + rsLower + '+(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsUpperMisc + '+(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
	    rsUpper + '?' + rsLowerMisc + '+',
	    rsUpper + '+',
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasComplexWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'Reflect', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError',
	    'Uint8Array', 'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `exports`. */
	  var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType)
	    ? exports
	    : undefined;
	
	  /** Detect free variable `module`. */
	  var freeModule = (objectTypes[typeof module] && module && !module.nodeType)
	    ? module
	    : undefined;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = (freeModule && freeModule.exports === freeExports)
	    ? freeExports
	    : undefined;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = checkGlobal(freeExports && freeModule && typeof global == 'object' && global);
	
	  /** Detect free variable `self`. */
	  var freeSelf = checkGlobal(objectTypes[typeof self] && self);
	
	  /** Detect free variable `window`. */
	  var freeWindow = checkGlobal(objectTypes[typeof window] && window);
	
	  /** Detect `this` as the global object. */
	  var thisGlobal = checkGlobal(objectTypes[typeof this] && this);
	
	  /**
	   * Used as a reference to the global object.
	   *
	   * The `this` value is used if it's the global object to avoid Greasemonkey's
	   * restricted `window` object, otherwise the `window` object is used.
	   */
	  var root = freeGlobal ||
	    ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) ||
	      freeSelf || thisGlobal || Function('return this')();
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `Map#set` because it doesn't return the map instance in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    var length = args.length;
	    switch (length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * Creates a new array concatenating `array` with `other`.
	   *
	   * @private
	   * @param {Array} array The first array to concatenate.
	   * @param {Array} other The second array to concatenate.
	   * @returns {Array} Returns the new concatenated array.
	   */
	  function arrayConcat(array, other) {
	    var index = -1,
	        length = array.length,
	        othIndex = -1,
	        othLength = other.length,
	        result = Array(length + othLength);
	
	    while (++index < length) {
	      result[index] = array[index];
	    }
	    while (++othIndex < othLength) {
	      result[index++] = other[othIndex];
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    return !!array.length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * The base implementation of methods like `_.max` and `_.min` which accepts a
	   * `comparator` to determine the extremum value.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The iteratee invoked per iteration.
	   * @param {Function} comparator The comparator used to compare values.
	   * @returns {*} Returns the extremum value.
	   */
	  function baseExtremum(array, iteratee, comparator) {
	    var index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var value = array[index],
	          current = iteratee(value);
	
	      if (current != null && (computed === undefined
	            ? current === current
	            : comparator(current, computed)
	          )) {
	        var computed = current,
	            result = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of methods like `_.find` and `_.findKey`, without
	   * support for iteratee shorthands, which iterates over `collection` using
	   * `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @param {boolean} [retKey] Specify returning the key of the found element
	   *  instead of the element itself.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFind(collection, predicate, eachFunc, retKey) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = retKey ? key : value;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromRight) {
	    var length = array.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array ? array.length : 0;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the new array of key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing wrapper metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Checks if `value` is a global object.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {null|Object} Returns `value` if it's a global object, else `null`.
	   */
	  function checkGlobal(value) {
	    return (value && value.Object === Object) ? value : null;
	  }
	
	  /**
	   * Compares values to sort them in ascending order.
	   *
	   * @private
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @returns {number} Returns the sort order indicator for `value`.
	   */
	  function compareAscending(value, other) {
	    if (value !== other) {
	      var valIsNull = value === null,
	          valIsUndef = value === undefined,
	          valIsReflexive = value === value;
	
	      var othIsNull = other === null,
	          othIsUndef = other === undefined,
	          othIsReflexive = other === other;
	
	      if ((value > other && !othIsNull) || !valIsReflexive ||
	          (valIsNull && !othIsUndef && othIsReflexive) ||
	          (valIsUndef && othIsReflexive)) {
	        return 1;
	      }
	      if ((value < other && !valIsNull) || !othIsReflexive ||
	          (othIsNull && !valIsUndef && valIsReflexive) ||
	          (othIsUndef && valIsReflexive)) {
	        return -1;
	      }
	    }
	    return 0;
	  }
	
	  /**
	   * Used by `_.orderBy` to compare multiple properties of a value to another
	   * and stable sort them.
	   *
	   * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	   * specify an order of "desc" for descending or "asc" for ascending sort order
	   * of corresponding values.
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {boolean[]|string[]} orders The order to sort by for each property.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareMultiple(object, other, orders) {
	    var index = -1,
	        objCriteria = object.criteria,
	        othCriteria = other.criteria,
	        length = objCriteria.length,
	        ordersLength = orders.length;
	
	    while (++index < length) {
	      var result = compareAscending(objCriteria[index], othCriteria[index]);
	      if (result) {
	        if (index >= ordersLength) {
	          return result;
	        }
	        var order = orders[index];
	        return result * (order == 'desc' ? -1 : 1);
	      }
	    }
	    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	    // that causes it, under certain circumstances, to provide the same value for
	    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	    // for more details.
	    //
	    // This also ensures a stable sort in V8 and other engines.
	    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	    return object.index - other.index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        result++;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Creates a function that performs a mathematical operation on two values.
	   *
	   * @private
	   * @param {Function} operator The function to perform the operation.
	   * @returns {Function} Returns the new mathematical operation function.
	   */
	  function createMathOperation(operator) {
	    return function(value, other) {
	      var result;
	      if (value === undefined && other === undefined) {
	        return 0;
	      }
	      if (value !== undefined) {
	        result = value;
	      }
	      if (other !== undefined) {
	        result = result === undefined ? other : operator(result, other);
	      }
	      return result;
	    };
	  }
	
	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 0 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * Checks if `value` is a host object in IE < 9.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	   */
	  function isHostObject(value) {
	    // Many host objects are `Object` objects that can coerce to strings
	    // despite having improperly defined `toString` methods.
	    var result = false;
	    if (value != null && typeof value.toString != 'function') {
	      try {
	        result = !!(value + '');
	      } catch (e) {}
	    }
	    return result;
	  }
	
	  /**
	   * Checks if `value` is a valid array-like index.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	   */
	  function isIndex(value, length) {
	    value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	    length = length == null ? MAX_SAFE_INTEGER : length;
	    return value > -1 && value % 1 == 0 && value < length;
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to an array.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    if (!(string && reHasComplexSymbol.test(string))) {
	      return string.length;
	    }
	    var result = reComplexSymbol.lastIndex = 0;
	    while (reComplexSymbol.test(string)) {
	      result++;
	    }
	    return result;
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return string.match(reComplexSymbol);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Use `context` to mock `Date#getTime` use in `_.now`.
	   * var mock = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': getTimeMock };
	   *   }
	   * });
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    context = context ? _.defaults({}, context, _.pick(root, contextProps)) : root;
	
	    /** Built-in constructor references. */
	    var Date = context.Date,
	        Error = context.Error,
	        Math = context.Math,
	        RegExp = context.RegExp,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = context.Array.prototype,
	        objectProto = context.Object.prototype;
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = context.Function.prototype.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objectToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Reflect = context.Reflect,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        clearTimeout = context.clearTimeout,
	        enumerate = Reflect ? Reflect.enumerate : undefined,
	        getOwnPropertySymbols = Object.getOwnPropertySymbols,
	        iteratorSymbol = typeof (iteratorSymbol = Symbol && Symbol.iterator) == 'symbol' ? iteratorSymbol : undefined,
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        setTimeout = context.setTimeout,
	        splice = arrayProto.splice;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetPrototype = Object.getPrototypeOf,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = Object.keys,
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
	    var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array of at least `200` elements
	     * and any iteratees accept only one argument. The heuristic for whether a
	     * section qualifies for shortcut fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `deburr`, `divide`, `each`,
	     * `eachRight`, `endsWith`, `eq`, `escape`, `escapeRegExp`, `every`, `find`,
	     * `findIndex`, `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `first`,
	     * `floor`, `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`,
	     * `forOwnRight`, `get`, `gt`, `gte`, `has`, `hasIn`, `head`, `identity`,
	     * `includes`, `indexOf`, `inRange`, `invoke`, `isArguments`, `isArray`,
	     * `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`, `isBoolean`, `isBuffer`,
	     * `isDate`, `isElement`, `isEmpty`, `isEqual`, `isEqualWith`, `isError`,
	     * `isFinite`, `isFunction`, `isInteger`, `isLength`, `isMap`, `isMatch`,
	     * `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`, `isNumber`,
	     * `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`, `isSafeInteger`,
	     * `isSet`, `isString`, `isUndefined`, `isTypedArray`, `isWeakMap`, `isWeakSet`,
	     * `join`, `kebabCase`, `last`, `lastIndexOf`, `lowerCase`, `lowerFirst`,
	     * `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`, `min`, `minBy`, `multiply`,
	     * `noConflict`, `noop`, `now`, `pad`, `padEnd`, `padStart`, `parseInt`,
	     * `pop`, `random`, `reduce`, `reduceRight`, `repeat`, `result`, `round`,
	     * `runInContext`, `sample`, `shift`, `size`, `snakeCase`, `some`, `sortedIndex`,
	     * `sortedIndexBy`, `sortedLastIndex`, `sortedLastIndexBy`, `startCase`,
	     * `startsWith`, `subtract`, `sum`, `sumBy`, `template`, `times`, `toInteger`,
	     * `toJSON`, `toLength`, `toLower`, `toNumber`, `toSafeInteger`, `toString`,
	     * `toUpper`, `trim`, `trimEnd`, `trimStart`, `truncate`, `unescape`,
	     * `uniqueId`, `upperCase`, `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE ||
	          (arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @returns {Object} Returns the new hash object.
	     */
	    function Hash() {}
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(hash, key) {
	      return hashHas(hash, key) && delete hash[key];
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @param {Object} hash The hash to query.
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(hash, key) {
	      if (nativeCreate) {
	        var result = hash[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(hash, key) ? hash[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @param {Object} hash The hash to query.
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(hash, key) {
	      return nativeCreate ? hash[key] !== undefined : hasOwnProperty.call(hash, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     */
	    function hashSet(hash, key, value) {
	      hash[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	    }
	
	    // Avoid inheriting from `Object.prototype` when possible.
	    Hash.prototype = nativeCreate ? nativeCreate(null) : objectProto;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function MapCache(values) {
	      var index = -1,
	          length = values ? values.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = values[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapClear() {
	      this.__data__ = {
	        'hash': new Hash,
	        'map': Map ? new Map : [],
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapDelete(key) {
	      var data = this.__data__;
	      if (isKeyable(key)) {
	        return hashDelete(typeof key == 'string' ? data.string : data.hash, key);
	      }
	      return Map ? data.map['delete'](key) : assocDelete(data.map, key);
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapGet(key) {
	      var data = this.__data__;
	      if (isKeyable(key)) {
	        return hashGet(typeof key == 'string' ? data.string : data.hash, key);
	      }
	      return Map ? data.map.get(key) : assocGet(data.map, key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapHas(key) {
	      var data = this.__data__;
	      if (isKeyable(key)) {
	        return hashHas(typeof key == 'string' ? data.string : data.hash, key);
	      }
	      return Map ? data.map.has(key) : assocHas(data.map, key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapSet(key, value) {
	      var data = this.__data__;
	      if (isKeyable(key)) {
	        hashSet(typeof key == 'string' ? data.string : data.hash, key, value);
	      } else if (Map) {
	        data.map.set(key, value);
	      } else {
	        assocSet(data.map, key, value);
	      }
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapClear;
	    MapCache.prototype['delete'] = mapDelete;
	    MapCache.prototype.get = mapGet;
	    MapCache.prototype.has = mapHas;
	    MapCache.prototype.set = mapSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates a set cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values ? values.length : 0;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.push(values[index]);
	      }
	    }
	
	    /**
	     * Checks if `value` is in `cache`.
	     *
	     * @private
	     * @param {Object} cache The set cache to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function cacheHas(cache, value) {
	      var map = cache.__data__;
	      if (isKeyable(value)) {
	        var data = map.__data__,
	            hash = typeof value == 'string' ? data.string : data.hash;
	
	        return hash[value] === HASH_UNDEFINED;
	      }
	      return map.has(value);
	    }
	
	    /**
	     * Adds `value` to the set cache.
	     *
	     * @private
	     * @name push
	     * @memberOf SetCache
	     * @param {*} value The value to cache.
	     */
	    function cachePush(value) {
	      var map = this.__data__;
	      if (isKeyable(value)) {
	        var data = map.__data__,
	            hash = typeof value == 'string' ? data.string : data.hash;
	
	        hash[value] = HASH_UNDEFINED;
	      }
	      else {
	        map.set(value, HASH_UNDEFINED);
	      }
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.push = cachePush;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function Stack(values) {
	      var index = -1,
	          length = values ? values.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = values[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = { 'array': [], 'map': null };
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          array = data.array;
	
	      return array ? assocDelete(array, key) : data.map['delete'](key);
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      var data = this.__data__,
	          array = data.array;
	
	      return array ? assocGet(array, key) : data.map.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      var data = this.__data__,
	          array = data.array;
	
	      return array ? assocHas(array, key) : data.map.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__,
	          array = data.array;
	
	      if (array) {
	        if (array.length < (LARGE_ARRAY_SIZE - 1)) {
	          assocSet(array, key, value);
	        } else {
	          data.array = null;
	          data.map = new MapCache(array);
	        }
	      }
	      var map = data.map;
	      if (map) {
	        map.set(key, value);
	      }
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Removes `key` and its value from the associative array.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function assocDelete(array, key) {
	      var index = assocIndexOf(array, key);
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = array.length - 1;
	      if (index == lastIndex) {
	        array.pop();
	      } else {
	        splice.call(array, index, 1);
	      }
	      return true;
	    }
	
	    /**
	     * Gets the associative array value for `key`.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function assocGet(array, key) {
	      var index = assocIndexOf(array, key);
	      return index < 0 ? undefined : array[index][1];
	    }
	
	    /**
	     * Checks if an associative array value for `key` exists.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function assocHas(array, key) {
	      return assocIndexOf(array, key) > -1;
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to search.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Sets the associative array `key` to `value`.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     */
	    function assocSet(array, key, value) {
	      var index = assocIndexOf(array, key);
	      if (index < 0) {
	        array.push([key, value]);
	      } else {
	        array[index][1] = value;
	      }
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function assignInDefaults(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (typeof key == 'number' && value === undefined && !(key in object))) {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths of elements to pick.
	     * @returns {Array} Returns the new array of picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          isNil = object == null,
	          length = paths.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = isNil ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function baseCastArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function baseCastFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a string if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the cast key.
	     */
	    function baseCastKey(key) {
	      return (typeof key == 'string' || isSymbol(key)) ? key : (key + '');
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function baseCastPath(value) {
	      return isArray(value) ? value : stringToPath(value);
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments to numbers.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {boolean} [isFull] Specify a clone including symbols.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          if (isHostObject(value)) {
	            return object ? value : {};
	          }
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (!isArr) {
	        var props = isFull ? getAllKeys(value) : keys(value);
	      }
	      // Recursively populate clone (susceptible to call stack limits).
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new function.
	     */
	    function baseConforms(source) {
	      var props = keys(source),
	          length = props.length;
	
	      return function(object) {
	        if (object == null) {
	          return !length;
	        }
	        var index = length;
	        while (index--) {
	          var key = props[index],
	              predicate = source[key],
	              value = object[key];
	
	          if ((value === undefined &&
	              !(key in Object(object))) || !predicate(value)) {
	            return false;
	          }
	        }
	        return true;
	      };
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    function baseCreate(proto) {
	      return isObject(proto) ? objectCreate(proto) : {};
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an array
	     * of `func` arguments.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments to provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` invoking `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the new array of filtered property names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = isKey(path, object) ? [path] : baseCastPath(path);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[path[index++]];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object)
	        ? result
	        : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
	      // that are composed entirely of index properties, return `false` for
	      // `hasOwnProperty` checks of them.
	      return hasOwnProperty.call(object, key) ||
	        (typeof object == 'object' && key in object && getPrototype(object) === null);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments to numbers.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      if (!isKey(path, object)) {
	        path = baseCastPath(path);
	        object = parent(object, path);
	        path = last(path);
	      }
	      var func = object == null ? object : object[path];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {boolean} [bitmask] The bitmask of comparison flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - Unordered comparison
	     *     2 - Partial comparison
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, bitmask, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = getTag(object);
	        objTag = objTag == argsTag ? objectTag : objTag;
	      }
	      if (!othIsArr) {
	        othTag = getTag(other);
	        othTag = othTag == argsTag ? objectTag : othTag;
	      }
	      var objIsObj = objTag == objectTag && !isHostObject(object),
	          othIsObj = othTag == objectTag && !isHostObject(other),
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	          : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	      }
	      if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't skip the constructor
	     * property of prototypes or treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      return nativeKeys(Object(object));
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't skip the constructor
	     * property of prototypes or treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      object = object == null ? object : Object(object);
	
	      var result = [];
	      for (var key in object) {
	        result.push(key);
	      }
	      return result;
	    }
	
	    // Fallback for IE < 9 with es6-shim.
	    if (enumerate && !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf')) {
	      baseKeysIn = function(object) {
	        return iteratorToArray(enumerate(object));
	      };
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(path, srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      if (!(isArray(source) || isTypedArray(source))) {
	        var props = keysIn(source);
	      }
	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      });
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        newValue = srcValue;
	        if (isArray(srcValue) || isTypedArray(srcValue)) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else {
	            isCommon = false;
	            newValue = baseClone(srcValue, true);
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            isCommon = false;
	            newValue = baseClone(srcValue, true);
	          }
	          else {
	            newValue = objValue;
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      stack.set(srcValue, newValue);
	
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	      }
	      stack['delete'](srcValue);
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], getIteratee());
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property identifiers to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, props) {
	      object = Object(object);
	      return arrayReduce(props, function(result, key) {
	        if (key in object) {
	          result[key] = object[key];
	        }
	        return result;
	      }, {});
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, predicate) {
	      var index = -1,
	          props = getAllKeysIn(object),
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (predicate(value, key)) {
	          result[key] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : object[key];
	      };
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (lastIndex == length || index != previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          }
	          else if (!isKey(index, array)) {
	            var path = baseCastPath(index),
	                object = parent(array, path);
	
	            if (object != null) {
	              delete object[last(path)];
	            }
	          }
	          else {
	            delete array[index];
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments to numbers.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the new array of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      path = isKey(path, object) ? [path] : baseCastPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = path[index];
	        if (isObject(nested)) {
	          var newValue = value;
	          if (index != lastIndex) {
	            var objValue = nested[key];
	            newValue = customizer ? customizer(objValue, key, nested) : undefined;
	            if (newValue === undefined) {
	              newValue = objValue == null
	                ? (isIndex(path[index + 1]) ? [] : {})
	                : objValue;
	            }
	          }
	          assignValue(nested, key, newValue);
	        }
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsUndef = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            isDef = computed !== undefined,
	            isReflexive = computed === computed;
	
	        if (valIsNaN) {
	          var setLow = isReflexive || retHighest;
	        } else if (valIsNull) {
	          setLow = isReflexive && isDef && (retHighest || computed != null);
	        } else if (valIsUndef) {
	          setLow = isReflexive && (retHighest || isDef);
	        } else if (computed == null) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq`.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array) {
	      return baseSortedUniqBy(array);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniqBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniqBy(array, iteratee) {
	      var index = 0,
	          length = array.length,
	          value = array[0],
	          computed = iteratee ? iteratee(value) : value,
	          seen = computed,
	          resIndex = 1,
	          result = [value];
	
	      while (++index < length) {
	        value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	        if (!eq(computed, seen)) {
	          seen = computed;
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = isKey(path, object) ? [path] : baseCastPath(path);
	      object = parent(object, path);
	      var key = last(path);
	      return (object != null && has(object, key)) ? delete object[key] : true;
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var index = -1,
	          length = arrays.length;
	
	      while (++index < length) {
	        var result = result
	          ? arrayPush(
	              baseDifference(result, arrays[index], iteratee, comparator),
	              baseDifference(arrays[index], result, iteratee, comparator)
	            )
	          : arrays[index];
	      }
	      return (result && result.length) ? baseUniq(result, iteratee, comparator) : [];
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var result = new buffer.constructor(buffer.length);
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object) {
	      return copyObjectWith(source, props, object);
	    }
	
	    /**
	     * This function is like `copyObject` except that it accepts a function to
	     * customize copied values.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObjectWith(source, props, object, customizer) {
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : source[key];
	
	        assignValue(object, key, newValue);
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbol properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return rest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = typeof customizer == 'function'
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	     *  for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBaseWrapper(func, bitmask, thisArg) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = reHasComplexSymbol.test(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols ? strSymbols[0] : string.charAt(0),
	            trailing = strSymbols ? strSymbols.slice(1).join('') : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string)), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	     *  for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurryWrapper(func, bitmask, arity) {
	      var Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getPlaceholder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurryWrapper(
	            func, bitmask, createHybridWrapper, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return rest(function(funcs) {
	        funcs = baseFlatten(funcs, 1);
	
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 &&
	              isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	     *  for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
	          isFlip = bitmask & FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            index = length,
	            args = Array(length);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getPlaceholder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurryWrapper(
	            func, bitmask, createHybridWrapper, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new invoker function.
	     */
	    function createOver(arrayFunc) {
	      return rest(function(iteratees) {
	        iteratees = arrayMap(baseFlatten(iteratees, 1, isFlattenableIteratee), getIteratee());
	        return rest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : (chars + '');
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return reHasComplexSymbol.test(chars)
	        ? stringToArray(result).slice(0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	     *  for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toNumber(start);
	        start = start === start ? start : 0;
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toNumber(end) || 0;
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : (toNumber(step) || 0);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper`
	     *  for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurryWrapper(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & CURRY_FLAG,
	          newArgPos = argPos ? copyArray(argPos) : undefined,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	      if (!(bitmask & CURRY_BOUND_FLAG)) {
	        bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, newArgPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = toInteger(precision);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && new Set([1, 2]).size === 2) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] == null
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == BIND_FLAG) {
	        var result = createBaseWrapper(func, bitmask, thisArg);
	      } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
	        result = createCurryWrapper(func, bitmask, arity);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
	        result = createPartialWrapper(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	      var index = -1,
	          isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	          isUnordered = bitmask & UNORDERED_COMPARE_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(array, other);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (isUnordered) {
	          if (!arraySome(other, function(othValue) {
	                return arrValue === othValue ||
	                  equalFunc(arrValue, othValue, customizer, bitmask, stack);
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, customizer, bitmask, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and
	          // booleans to `1` or `0` treating invalid dates coerced to `NaN` as
	          // not equal.
	          return +object == +other;
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object) ? other != +other : object == +other;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/6.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= UNORDERED_COMPARE_FLAG;
	          stack.set(object, other);
	
	          // Recursively compare objects (susceptible to call stack limits).
	          return equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	          objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : baseHas(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      return result;
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a
	     * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
	     * Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = toPairs(object),
	          length = result.length;
	
	      while (length--) {
	        result[length][2] = isStrictComparable(result[length][1]);
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = object[key];
	      return isNative(value) ? value : undefined;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getPlaceholder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the `[[Prototype]]` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {null|Object} Returns the `[[Prototype]]`.
	     */
	    function getPrototype(value) {
	      return nativeGetPrototype(Object(value));
	    }
	
	    /**
	     * Creates an array of the own enumerable symbol properties of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    function getSymbols(object) {
	      // Coerce `object` to an object to avoid non-object errors in V8.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=3443 for more details.
	      return getOwnPropertySymbols(Object(object));
	    }
	
	    // Fallback for IE < 11.
	    if (!getOwnPropertySymbols) {
	      getSymbols = function() {
	        return [];
	      };
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable symbol properties
	     * of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !getOwnPropertySymbols ? getSymbols : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function getTag(value) {
	      return objectToString.call(value);
	    }
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11,
	    // for data views in Edge, and promises in Node.js.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = objectToString.call(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : undefined;
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = isKey(path, object) ? [path] : baseCastPath(path);
	
	      var result,
	          index = -1,
	          length = path.length;
	
	      while (++index < length) {
	        var key = path[index];
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result) {
	        return result;
	      }
	      var length = object ? object.length : 0;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isString(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Creates an array of index keys for `object` values of arrays,
	     * `arguments` objects, and strings, otherwise `null` is returned.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array|null} Returns index keys, else `null`.
	     */
	    function indexKeys(object) {
	      var length = object ? object.length : undefined;
	      if (isLength(length) &&
	          (isArray(object) || isString(object) || isArguments(object))) {
	        return baseTimes(length, String);
	      }
	      return null;
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArrayLikeObject(value) && (isArray(value) || isArguments(value));
	    }
	
	    /**
	     * Checks if `value` is a flattenable array and not a `_.matchesProperty`
	     * iteratee shorthand.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenableIteratee(value) {
	      return isArray(value) && !(value.length == 2 && !isFunction(value[0]));
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol') {
	        return true;
	      }
	      return !isArray(value) &&
	        (isSymbol(value) || reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	          (object != null && value in Object(object)));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return type == 'number' || type == 'boolean' ||
	        (type == 'string' && value != '__proto__') || value == null;
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (BIND_FLAG | BIND_KEY_FLAG | ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == ARY_FLAG) && (bitmask == CURRY_FLAG)) ||
	        ((srcBitmask == ARY_FLAG) && (bitmask == REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (ARY_FLAG | REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & BIND_FLAG ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : copyArray(value);
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : copyArray(source[4]);
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : copyArray(value);
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : copyArray(source[6]);
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = copyArray(value);
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function mergeDefaults(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        baseMerge(objValue, srcValue, undefined, mergeDefaults, stack.set(srcValue, objValue));
	      }
	      return objValue;
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;
	
	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoize(function(string) {
	      var result = [];
	      toString(string).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to process.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array containing chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array ? array.length : 0;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length,
	          array = castArray(arguments[0]);
	
	      if (length < 2) {
	        return length ? copyArray(array) : [];
	      }
	      var args = Array(length - 1);
	      while (length--) {
	        args[length - 1] = arguments[length];
	      }
	      return arrayConcat(array, baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of unique `array` values not included in the other given
	     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. The order of result values is determined by the
	     * order they occur in the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.difference([3, 2, 1], [4, 2]);
	     * // => [3, 1]
	     */
	    var difference = rest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. Result values are chosen from the first array.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([3.1, 2.2, 1.3], [4.4, 2.5], Math.floor);
	     * // => [3.1, 1.3]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = rest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. Result values
	     * are chosen from the first array. The comparator is invoked with two arguments:
	     * (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = rest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate) {
	      return (array && array.length)
	        ? baseFindIndex(array, getIteratee(predicate, 3))
	        : -1;
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate) {
	      return (array && array.length)
	        ? baseFindIndex(array, getIteratee(predicate, 3), true)
	        : -1;
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs ? pairs.length : 0,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return array ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      fromIndex = toInteger(fromIndex);
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return baseIndexOf(array, value, fromIndex);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. The order of result values is determined by the
	     * order they occur in the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [4, 2], [1, 2]);
	     * // => [2]
	     */
	    var intersection = rest(function(arrays) {
	      var mapped = arrayMap(arrays, baseCastArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. Result values are chosen from the first array.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [4.3, 2.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = rest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, baseCastArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. Result values are chosen
	     * from the first array. The comparator is invoked with two arguments:
	     * (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = rest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, baseCastArrayLikeObject);
	
	      if (comparator === last(mapped)) {
	        comparator = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array ? nativeJoin.call(array, separator) : '';
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = (
	          index < 0
	            ? nativeMax(length + index, 0)
	            : nativeMin(index, length - 1)
	        ) + 1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pull(array, 2, 3);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    var pull = rest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pullAll(array, [2, 3]);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
	     *  specified individually or in arrays.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [5, 10, 15, 20];
	     * var evens = _.pullAt(array, 1, 3);
	     *
	     * console.log(array);
	     * // => [5, 15]
	     *
	     * console.log(evens);
	     * // => [10, 20]
	     */
	    var pullAt = rest(function(array, indexes) {
	      indexes = arrayMap(baseFlatten(indexes, 1), String);
	
	      var result = baseAt(array, indexes);
	      basePullAt(array, indexes.sort(compareAscending));
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array ? nativeReverse.call(array) : array;
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     *
	     * _.sortedIndex([4, 5], 4);
	     * // => 0
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var dict = { 'thirty': 30, 'forty': 40, 'fifty': 50 };
	     *
	     * _.sortedIndexBy(['thirty', 'fifty'], 'forty', _.propertyOf(dict));
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy([{ 'x': 4 }, { 'x': 5 }], { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([1, 1, 2, 2], 2);
	     * // => 2
	     */
	    function sortedIndexOf(array, value) {
	      var length = array ? array.length : 0;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5], 4);
	     * // => 1
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy([{ 'x': 4 }, { 'x': 5 }], { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([1, 1, 2, 2], 2);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array ? array.length : 0;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniqBy(array, getIteratee(iteratee))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      return drop(array, 1);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2, 1], [4, 2], [1, 2]);
	     * // => [2, 1, 4]
	     */
	    var union = rest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1, 1.2], [4.3, 2.4], Math.floor);
	     * // => [2.1, 1.2, 4.3]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = rest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = rest(function(arrays) {
	      var comparator = last(arrays);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each
	     * element is kept.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length)
	        ? baseUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseUniq(array, getIteratee(iteratee))
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The comparator is invoked with
	     * two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 },  { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      return (array && array.length)
	        ? baseUniq(array, undefined, comparator)
	        : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to filter.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.without([1, 2, 1, 3], 1, 2);
	     * // => [3]
	     */
	    var without = rest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xor([2, 1], [4, 2]);
	     * // => [1, 4]
	     */
	    var xor = rest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [4.3, 2.4], Math.floor);
	     * // => [1.2, 4.3]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = rest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The comparator is invoked with
	     * two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = rest(function(arrays) {
	      var comparator = last(arrays);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = rest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = rest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths of elements to pick,
	     *  specified individually or in arrays.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     *
	     * _(['a', 'b', 'c']).at(0, 2).value();
	     * // => ['a', 'c']
	     */
	    var wrapperAt = rest(function(paths) {
	      paths = baseFlatten(paths, 1);
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    function find(collection, predicate) {
	      predicate = getIteratee(predicate, 3);
	      if (isArray(collection)) {
	        var index = baseFindIndex(collection, predicate);
	        return index > -1 ? collection[index] : undefined;
	      }
	      return baseFind(collection, predicate, baseEach);
	    }
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    function findLast(collection, predicate) {
	      predicate = getIteratee(predicate, 3);
	      if (isArray(collection)) {
	        var index = baseFindIndex(collection, predicate, true);
	        return index > -1 ? collection[index] : undefined;
	      }
	      return baseFind(collection, predicate, baseEachRight);
	    }
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` invoking `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEach(function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      return (typeof iteratee == 'function' && isArray(collection))
	        ? arrayEach(collection, iteratee)
	        : baseEach(collection, getIteratee(iteratee));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      return (typeof iteratee == 'function' && isArray(collection))
	        ? arrayEachRight(collection, iteratee)
	        : baseEachRight(collection, getIteratee(iteratee));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function, it's
	     * invoked for and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = rest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? apply(func, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `take`, `takeRight`, `template`,
	     * `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getIteratee(predicate, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var array = isArrayLike(collection) ? collection : values(collection),
	          length = array.length;
	
	      return length > 0 ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;
	
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = baseClamp(toInteger(n), 0, length);
	      }
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];
	
	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sampleSize(collection, MAX_ARRAY_LENGTH);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        var result = collection.length;
	        return (result && isString(collection)) ? stringSize(collection) : result;
	      }
	      if (isObjectLike(collection)) {
	        var tag = getTag(collection);
	        if (tag == mapTag || tag == setTag) {
	          return collection.size;
	        }
	      }
	      return keys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Array|Array[]|Function|Function[]|Object|Object[]|string|string[])}
	     *  [iteratees=[_.identity]] The iteratees to sort by, specified individually
	     *  or in arrays.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, function(o) { return o.user; });
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     *
	     * _.sortBy(users, 'user', function(o) {
	     *   return Math.floor(o.age / 10);
	     * });
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    var sortBy = rest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees.length = 1;
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @type {Function}
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred function to be invoked.
	     */
	    var now = Date.now;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind` this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = rest(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getPlaceholder(bind));
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = rest(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getPlaceholder(bindKey));
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrapper(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrapper(func, CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide an options object to indicate whether `func` should be invoked on
	     * the leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent calls
	     * to the debounced function return the result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          result,
	          timerId,
	          lastCallTime = 0,
	          lastInvokeTime = 0,
	          leading = false,
	          maxWait = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxWait = 'maxWait' in options && nativeMax(toNumber(options.maxWait) || 0, wait);
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxWait === false ? result : nativeMin(result, maxWait - timeSinceLastInvoke);
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (!lastCallTime || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxWait !== false && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        clearTimeout(timerId);
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastCallTime = lastInvokeTime = 0;
	        lastArgs = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          // Handle invocations in a tight loop.
	          clearTimeout(timerId);
	          timerId = setTimeout(timerExpired, wait);
	          return invokeFunc(lastCallTime);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one or more milliseconds.
	     */
	    var defer = rest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = rest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrapper(func, FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoizing function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with arguments transformed by
	     * corresponding `transforms`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms] The functions to transform.
	     * arguments, specified individually or in arrays.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, square, doubled);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = rest(function(func, transforms) {
	      transforms = arrayMap(baseFlatten(transforms, 1, isFlattenableIteratee), getIteratee());
	      var funcsLength = transforms.length;
	      return rest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = rest(function(func, partials) {
	      var holders = replaceHolders(partials, getPlaceholder(partial));
	      return createWrapper(func, PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = rest(function(func, partials) {
	      var holders = replaceHolders(partials, getPlaceholder(partialRight));
	      return createWrapper(func, PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes,
	     *  specified individually or in arrays.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, 2, 0, 1);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = rest(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes, 1));
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : toInteger(start), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, array);
	          case 1: return func.call(this, args[0], array);
	          case 2: return func.call(this, args[0], args[1], array);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = array;
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/6.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? 0 : nativeMax(toInteger(start), 0);
	      return rest(function(args) {
	        var array = args[start],
	            otherArgs = args.slice(0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide an options object to indicate whether
	     * `func` should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return partial(wrapper, value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, false, true);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      return baseClone(value, false, true, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, true, true);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      return baseClone(value, true, true, customizer);
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    function gt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    function gte(value, other) {
	      return value >= other;
	    }
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
	      return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	        (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	    }
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @type {Function}
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    function isArrayBuffer(value) {
	      return isObjectLike(value) && objectToString.call(value) == arrayBufferTag;
	    }
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(getLength(value)) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && objectToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = !Buffer ? constant(false) : function(value) {
	      return value instanceof Buffer;
	    };
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objectToString.call(value) == dateTag;
	    }
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element,
	     *  else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (isArrayLike(value) &&
	          (isArray(value) || isString(value) || isFunction(value.splice) ||
	            isArguments(value) || isBuffer(value))) {
	        return !value.length;
	      }
	      if (isObjectLike(value)) {
	        var tag = getTag(value);
	        if (tag == mapTag || tag == setTag) {
	          return !value.size;
	        }
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return !(nonEnumShadows && keys(value).length);
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are **not** supported.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent,
	     *  else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent,
	     *  else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object,
	     *  else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      return (objectToString.call(value) == errorTag) ||
	        (typeof value.message == 'string' && typeof value.name == 'string');
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number,
	     *  else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MAX_VALUE);
	     * // => true
	     *
	     * _.isFinite(3.14);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 8 which returns 'object' for typed array and weak map constructors,
	      // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	      var tag = isObject(value) ? objectToString.call(value) : '';
	      return tag == funcTag || tag == genTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length,
	     *  else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return !!value && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    function isMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values. This method is
	     * equivalent to a `_.matches` function when `source` is partially applied.
	     *
	     * **Note:** This method supports comparing the same values as `_.isEqual`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a native function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && objectToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object,
	     *  else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) ||
	          objectToString.call(value) != objectTag || isHostObject(value)) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return (typeof Ctor == 'function' &&
	        Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObject(value) && objectToString.call(value) == regexpTag;
	    }
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer,
	     *  else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    function isSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && objectToString.call(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	    }
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified,
	     *  else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && objectToString.call(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    function lt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    function lte(value, other) {
	      return value <= other;
	    }
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (iteratorSymbol && value[iteratorSymbol]) {
	        return iteratorToArray(value[iteratorSymbol]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This function is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/6.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3');
	     * // => 3
	     */
	    function toInteger(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      var remainder = value % 1;
	      return value === value ? (remainder ? value - remainder : value) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3);
	     * // => 3
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3');
	     * // => 3
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = isFunction(value.valueOf) ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
	    }
	
	    /**
	     * Converts `value` to a string if it's not one. An empty string is returned
	     * for `null` and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (value == null) {
	        return '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.c = 3;
	     * }
	     *
	     * function Bar() {
	     *   this.e = 5;
	     * }
	     *
	     * Foo.prototype.d = 4;
	     * Bar.prototype.f = 6;
	     *
	     * _.assign({ 'a': 1 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3, 'e': 5 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * function Bar() {
	     *   this.d = 4;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     * Bar.prototype.e = 5;
	     *
	     * _.assignIn({ 'a': 1 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4, 'e': 5 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keysIn(source), object);
	        return;
	      }
	      for (var key in source) {
	        assignValue(object, key, source[key]);
	      }
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObjectWith(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObjectWith(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths of elements to pick,
	     *  specified individually or in arrays.
	     * @returns {Array} Returns the new array of picked elements.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     *
	     * _.at(['a', 'b', 'c'], 0, 2);
	     * // => ['a', 'c']
	     */
	    var at = rest(function(object, paths) {
	      return baseAt(object, baseFlatten(paths, 1));
	    });
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = rest(function(args) {
	      args.push(undefined, assignInDefaults);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
	     * // => { 'user': { 'name': 'barney', 'age': 36 } }
	     *
	     */
	    var defaultsDeep = rest(function(args) {
	      args.push(undefined, mergeDefaults);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFind(object, getIteratee(predicate, 3), baseForOwn, true);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFind(object, getIteratee(predicate, 3), baseForOwnRight, true);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object invoking `iteratee` for each property. The iteratee is invoked with
	     * three arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object invoking
	     * `iteratee` for each property. The iteratee is invoked with three arguments:
	     * (value, key, object). Iteratee functions may exit iteration early by
	     * explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = rest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      var isProto = isPrototype(object);
	      if (!(isProto || isArrayLike(object))) {
	        return baseKeys(object);
	      }
	      var indexes = indexKeys(object),
	          skipIndexes = !!indexes,
	          result = indexes || [],
	          length = result.length;
	
	      for (var key in object) {
	        if (baseHas(object, key) &&
	            !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	            !(isProto && key == 'constructor')) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      var index = -1,
	          isProto = isPrototype(object),
	          props = baseKeysIn(object),
	          propsLength = props.length,
	          indexes = indexKeys(object),
	          skipIndexes = !!indexes,
	          result = indexes || [],
	          length = result.length;
	
	      while (++index < propsLength) {
	        var key = props[index];
	        if (!(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        result[iteratee(value, key, object)] = value;
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        result[key] = iteratee(value, key, object);
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively.Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with seven arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable string keyed properties of `object` that are
	     * not omitted.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [props] The property identifiers to omit,
	     *  specified individually or in arrays.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = rest(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      props = arrayMap(baseFlatten(props, 1), baseCastKey);
	      return basePick(object, baseDifference(getAllKeysIn(object), props));
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      predicate = getIteratee(predicate);
	      return basePickBy(object, function(value, key) {
	        return !predicate(value, key);
	      });
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [props] The property identifiers to pick,
	     *  specified individually or in arrays.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = rest(function(object, props) {
	      return object == null ? {} : basePick(object, baseFlatten(props, 1));
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Array|Function|Object|string} [predicate=_.identity]
	     *  The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      return object == null ? {} : basePickBy(object, getIteratee(predicate));
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = isKey(path, object) ? [path] : baseCastPath(path);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        object = undefined;
	        length = 1;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[path[index]];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    function toPairs(object) {
	      return baseToPairs(object, keys(object));
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 1]] (iteration order is not guaranteed)
	     */
	    function toPairsIn(object) {
	      return baseToPairs(object, keysIn(object));
	    }
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. The iteratee is invoked
	     * with four arguments: (accumulator, value, key, object). Iteratee functions
	     * may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Array|Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getIteratee(iteratee, 4);
	
	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, baseCastFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, baseCastFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object ? baseValues(object, keys(object)) : [];
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toNumber(start) || 0;
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toNumber(end) || 0;
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toNumber(lower) || 0;
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toNumber(upper) || 0;
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search from.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = typeof target == 'string' ? target : (target + '');
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in IE < 9, they can break out of
	     * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the
	     * [HTML5 Security Cheatsheet](https://html5sec.org/) for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=3109 for more details.
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = toString(string).replace(reTrim, '');
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the new array of string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator += '';
	        if (separator == '' && reHasComplexSymbol.test(string)) {
	          var strSymbols = stringToArray(string);
	          return limit === undefined ? strSymbols : strSymbols.slice(0, limit < 0 ? 0 : limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = baseClamp(toInteger(position), 0, string.length);
	      return string.lastIndexOf(target, position) == position;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES delimiter as an alternative to the default "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, assignInDefaults);
	
	      var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard || chars === undefined) {
	        return string.replace(reTrim, '');
	      }
	      chars = (chars + '');
	      if (!chars) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars);
	
	      return strSymbols
	        .slice(charsStartIndex(strSymbols, chrSymbols), charsEndIndex(strSymbols, chrSymbols) + 1)
	        .join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard || chars === undefined) {
	        return string.replace(reTrimEnd, '');
	      }
	      chars = (chars + '');
	      if (!chars) {
	        return string;
	      }
	      var strSymbols = stringToArray(string);
	      return strSymbols
	        .slice(0, charsEndIndex(strSymbols, stringToArray(chars)) + 1)
	        .join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard || chars === undefined) {
	        return string.replace(reTrimStart, '');
	      }
	      chars = (chars + '');
	      if (!chars) {
	        return string;
	      }
	      var strSymbols = stringToArray(string);
	      return strSymbols
	        .slice(charsStartIndex(strSymbols, stringToArray(chars)))
	        .join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? toString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (reHasComplexSymbol.test(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? strSymbols.slice(0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(separator, end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        pattern = reHasComplexWord.test(string) ? reComplexWord : reBasicWord;
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = rest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind,
	     *  specified individually or in arrays.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, 'onClick');
	     * jQuery(element).on('click', view.onClick);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = rest(function(object, methodNames) {
	      arrayEach(baseFlatten(methodNames, 1), function(key) {
	        object[key] = bind(object[key], object);
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` invoking the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.constant(true),                _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs ? pairs.length : 0,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return rest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.filter(users, _.conforms({ 'age': _.partial(_.gt, _, 38) }));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var getter = _.constant(object);
	     *
	     * getter() === object;
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow(_.add, square);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight(square, _.add);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument given to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.identity(object) === object;
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, true));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`. The created function is equivalent to
	     * `_.isMatch` with a `source` partially applied.
	     *
	     * **Note:** This method supports comparing the same values as `_.isEqual`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** This method supports comparing the same values as `_.isEqual`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = rest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = rest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = (isObject(options) && 'chain' in options) ? options.chain : true,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * A no-operation function that returns `undefined` regardless of the
	     * arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.noop(object) === undefined;
	     * // => true
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that returns its nth argument.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     *
	     * func('a', 'b', 'c');
	     * // => 'b'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return function() {
	        return arguments[n];
	      };
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} iteratees The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over(Math.max, Math.min);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} predicates The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery(Boolean, isFinite);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} predicates The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome(Boolean, isFinite);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(true));
	     * // => [true, true, true, true]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     *
	     * var path = ['a', 'b', 'c'],
	     *     newPath = _.toPath(path);
	     *
	     * console.log(newPath);
	     * // => ['a', 'b', 'c']
	     *
	     * console.log(path === newPath);
	     * // => false
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, baseCastKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(value));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    });
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    });
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, gt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee), gt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, lt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee), lt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    });
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    });
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Array|Function|Object|string} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.deburr = deburr;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.multiply = multiply;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = rest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      predicate = getIteratee(predicate, 3);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    if (iteratorSymbol) {
	      lodash.prototype[iteratorSymbol] = wrapperToIterator;
	    }
	    return lodash;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Expose lodash on the free variable `window` or `self` when available. This
	  // prevents errors in cases where lodash is loaded by a script tag in the presence
	  // of an AMD loader. See http://requirejs.org/docs/errors.html#mismatch for more details.
	  (freeWindow || freeSelf || {})._ = _;
	
	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for Node.js.
	    if (moduleExports) {
	      (freeModule.exports = _)._ = _;
	    }
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)(module), (function() { return this; }())))

/***/ },
/* 5 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 6 */,
/* 7 */,
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _math = __webpack_require__(9);
	
	Object.keys(_math).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _math[key];
	    }
	  });
	});
	
	var _promise = __webpack_require__(10);
	
	Object.keys(_promise).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _promise[key];
	    }
	  });
	});
	
	var _util = __webpack_require__(11);
	
	Object.keys(_util).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _util[key];
	    }
	  });
	});
	
	var _array = __webpack_require__(12);
	
	Object.keys(_array).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _array[key];
	    }
	  });
	});
	
	var _base = __webpack_require__(13);
	
	Object.keys(_base).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _base[key];
	    }
	  });
	});
	
	var _canvas = __webpack_require__(14);
	
	Object.keys(_canvas).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _canvas[key];
	    }
	  });
	});

/***/ },
/* 9 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.rad2deg = rad2deg;
	exports.deg2rad = deg2rad;
	exports.clamp = clamp;
	exports.sign = sign;
	exports.parseFloatOr = parseFloatOr;
	// exports rad2deg, deg2rad, parseFloatOr, Magnitude
	
	var r2d = 360.0 / (2.0 * Math.PI);
	var d2r = 1.0 / r2d;
	
	function rad2deg(radians) {
	  return radians * r2d;
	}
	
	function deg2rad(degrees) {
	  return degrees * d2r;
	}
	
	function clamp(n, min, max) {
	  return n > max ? max : n < min ? min : n;
	}
	
	function sign(x) {
	  return x < 0.0 ? -1 : 1;
	}
	
	// Magnitude utilities
	
	function parseFloatOr(s, d) {
	  var v = parseFloat(s);
	  return isNaN(v) ? d : v;
	}
	
	var Magnitude = exports.Magnitude = function (value, type) {
	  if (type === undefined) {
	    type = 'mm';
	  }
	  this.value = value;
	  this.type = type;
	};
	
	Magnitude.prototype = {
	  toString: function () {
	    return this.value.toFixed(4).concat(this.type === '%' ? '%' : '');
	  },
	  toXmlString: function () {
	    return this.toString();
	  },
	  isAbsolute: function () {
	    return this.type !== '%';
	  },
	  absoluteMMValueFor: function (reference) {
	    var value = this.value;
	
	    return this.type === '%' ? value * reference / 100 : this.toMM();
	  },
	  toMM: function () {
	    var aDPI = arguments.length <= 0 || arguments[0] === undefined ? 25.4 : arguments[0];
	
	    if (this.type === '%') {
	      return this.value;
	    }
	    if (this.type === 'mm') {
	      return this.value;
	    }
	    if (this.type === 'cm') {
	      return this.value * 10;
	    }
	    if (this.type === 'in') {
	      return this.value * 25.4;
	    }
	    if (this.type === 'pc') {
	      return this.value * 25.4 / 6;
	    }
	    if (this.type === 'pt') {
	      return this.value * 25.4 / 72;
	    }
	    if (this.type === 'px') {
	      return this.value * 25.4 / aDPI;
	    }
	    return this.value;
	  },
	  toType: function (aToType) {
	    var aDPI = arguments.length <= 1 || arguments[1] === undefined ? 25.4 : arguments[1];
	    return Magnitude.fromMM(this.toMM(), aToType, aDPI);
	  },
	  valueOf: function () {
	    return this.toMM();
	  }
	};
	
	Magnitude.absoluteMMValueFor = function (aValue, reference) {
	  if (!(aValue instanceof Magnitude)) aValue = Magnitude.parse(aValue);
	  return aValue.absoluteMMValueFor(reference);
	};
	
	Magnitude.fromMM = function (aValue, aToType) {
	  var aDPI = arguments.length <= 2 || arguments[2] === undefined ? 25.4 : arguments[2];
	
	  if (aToType === '%') {
	    return aValue;
	  }
	  if (aToType === 'mm') {
	    return aValue;
	  }
	  if (aToType === 'cm') {
	    return aValue / 10;
	  }
	  if (aToType === 'in') {
	    return aValue / 25.4;
	  }
	  if (aToType === 'pc') {
	    return aValue / 25.4 * 6;
	  }
	  if (aToType === 'pt') {
	    return aValue / 25.4 * 72;
	  }
	  if (aToType === 'px') {
	    return aValue / 25.4 * aDPI;
	  }
	  return aValue;
	};
	
	Magnitude._defaultType = 'mm';
	
	Magnitude.setDefaultType = function (aType) {
	  var lTypes = ['mm', 'in', 'px', 'pc', 'pt', 'cm', '%'];
	  if (lTypes.indexOf(aType) !== -1) {
	    Magnitude._defaultType = aType;
	  } else {
	    Magnitude._defaultType = 'mm';
	  }
	};
	
	Magnitude.parse = function (aXmlString) {
	  if (aXmlString) {
	
	    aXmlString = aXmlString.toString().trim();
	
	    var lastChar = aXmlString.length > 0 ? aXmlString[aXmlString.length - 1] : '';
	
	    if (lastChar === '%' || lastChar === 'r') {
	      // 'r' is URL friendly
	      var value = parseFloatOr(aXmlString.substring(0, aXmlString.length - 1), 0.0);
	      return new Magnitude(value, '%');
	    }
	
	    var lTypes = ['mm', 'in', 'px', 'pc', 'pt', 'cm'];
	
	    for (var i = 0; i < lTypes.length; ++i) {
	      var lType = lTypes[i];
	      var idx = aXmlString.lastIndexOf(lType);
	      if (idx !== -1) {
	        return new Magnitude(parseFloat(aXmlString.substring(0, idx)), lType);
	      }
	    }
	
	    return new Magnitude(parseFloatOr(aXmlString, 0.0), Magnitude._defaultType);
	  }
	
	  return null;
	};

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.every$ = exports.findLast$ = exports.find$ = exports.filter$ = exports.reduce$ = exports.forEach$ = exports.or$ = exports.and$ = exports.not$ = exports.invokeMap$ = exports.map$ = exports.wait$ = exports.if$ = exports.createLazyPromise = exports.Deferred = exports.whenEach = exports.whenAll = exports.reject = exports.resolve = exports.createPromise = undefined;
	
	var _lodash = __webpack_require__(4);
	
	/*
	export const createPromise = function(executor) {
	  return new Promise(executor);
	};
	
	export const resolve = function(x) { return Promise.resolve(x); };
	
	export const reject = function(e) { return Promise.reject(e); };
	
	export const whenAll = function(a) { return Promise.all(a); };
	*/
	
	var Cx = window['Cx']; // exports createPromise, whenAll, resolve, reject
	//         if$, not$, and$, or$, map$, forEach$, reduce$, filter$, find$, every$
	
	var createPromise = exports.createPromise = Cx.createPromise;
	
	var resolve = exports.resolve = Cx.resolve;
	
	var reject = exports.reject = Cx.reject;
	
	var whenAll = exports.whenAll = Cx.whenAll;
	
	var whenEach = exports.whenEach = function (things, action) {
	  return whenAll((0, _lodash.map)(things, action));
	};
	
	// Simple jQuery like Deferred pattern, useful for async queues
	// Avoid its use as possible, using createPromise directly
	var Deferred = exports.Deferred = function () {
	  var _this = this;
	
	  this.promise = createPromise(function (resolve, reject) {
	    _this.resolve = resolve;
	    _this.reject = reject;
	  });
	};
	
	// Creates a promise that only excecutes when .run(...)
	// is called. This is useful to avoid the use of the deferred pattern
	// when implementing async queues. If the lazy promise is deleted,
	// the execution will just be canceled
	// This is a simple implementation, that forces users of the
	// lazy promise to know it is not a regular promise. Other implementation
	// hide the start of the execution in the .then function
	// https://github.com/nailgun/q-lazy/blob/master/index.js
	var createLazyPromise = exports.createLazyPromise = function (executor) {
	  var p = void 0;
	  return {
	    promise: createPromise(function (resolve, reject) {
	      return p = { resolve: resolve, reject: reject };
	    }),
	    run: function () {
	      executor(p.resolve, p.reject);
	    }
	  };
	};
	
	var if$ = exports.if$ = function (condition, body) {
	  var p = condition ? body() : null;
	  if (!(p && p.then)) {
	    p = resolve();
	  }
	  if (condition) {
	    p.else_if$ = p.else$ = discarded_else$;
	  } else {
	    p.else_if$ = else_if$;
	    p.else$ = else$;
	  }
	  return p;
	};
	
	function else$(body) {
	  return if$(true, body);
	}
	function else_if$(condition, body) {
	  return if$(condition, body);
	}
	function discarded_else$() {
	  // Forward the if promise
	  return this;
	}
	
	var wait$ = exports.wait$ = function (ms) {
	  return createPromise(function (resolve) {
	    return setTimeout(function () {
	      return resolve();
	    }, ms);
	  });
	};
	
	var map$ = exports.map$ = function (a, f) {
	  return whenAll((0, _lodash.map)(a, f));
	};
	
	var invokeMap$ = exports.invokeMap$ = function () {
	  return whenAll(_lodash.invokeMap.apply(undefined, arguments));
	};
	
	var not$ = exports.not$ = function (p) {
	  return p.then(function (r) {
	    return !r;
	  });
	};
	var and$ = exports.and$ = function (p0, p1) {
	  return whenAll([p0, p1]).then(function (r) {
	    return r[0] && r[1];
	  });
	};
	var or$ = exports.or$ = function (p0, p1) {
	  return whenAll([p0, p1]).then(function (r) {
	    return r[0] || r[1];
	  });
	};
	
	// forEach$ executes promises in order, use whenEach$ if you do not care
	// about order of execution, it will be faster that way
	var forEach$ = exports.forEach$ = function (array, action, context, i) {
	  var c = array.length;
	  if (c > 0) {
	    return action.call(context, array[0], i || 0).then(function (v0) {
	      var va = [v0];
	      return c === 1 ? va : va.concat(forEach$(array.slice(1), action, context, ++i));
	    });
	  } else {
	    return resolve([]);
	  }
	};
	
	// [TODO] tail optimization
	
	var reduce$ = exports.reduce$ = function (ts, f, r) {
	  if (ts.length === 0) {
	    return resolve(r);
	  }
	  var t = ts[0];
	  var rest = ts.slice(1);
	  return f(t, r).then(function (nr) {
	    return reduce$(rest, f, nr);
	  });
	};
	
	var filter$ = exports.filter$ = function (array, check) {
	  return map$(array, check).then(function (result) {
	    var filtered = [];
	    for (var k = 0, kEnd = result.length; k < kEnd; ++k) {
	      if (result[k]) {
	        filtered.push(array[k]);
	      }
	    }
	    return filtered;
	  });
	};
	
	var find$ = exports.find$ = function (array, check) {
	  if (array.length === 0) {
	    return resolve();
	  }
	  var first = array[0];
	  return check(first).then(function (pass) {
	    if (pass) {
	      return resolve(first);
	    } else {
	      return find$(array.slice(1), check);
	    }
	  });
	};
	
	var findLast$ = exports.findLast$ = function (array, check) {
	  if (array.length === 0) {
	    return resolve();
	  }
	  var l = (0, _lodash.last)(array);
	  return check(l).then(function (pass) {
	    if (pass) {
	      return resolve(l);
	    } else {
	      return findLast$(array.slice(0, array.length - 1), check);
	    }
	  });
	};
	
	var every$ = exports.every$ = function (ts, f) {
	  return map$(ts, f).then(function (result) {
	    for (var k = 0, kEnd = result.length; k < kEnd; ++k) {
	      if (!result[k]) {
	        return false;
	      }
	    }
	    return true;
	  });
	};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.supportsCrossOriginImages = exports.detachImageLoadEvent = exports.attachImageLoadEvent = exports.filterRight = exports.findByType = exports.filterByType = exports.remove = exports.setForEach = exports.areNear = exports.areEqual = undefined;
	exports.fairSpread = fairSpread;
	exports.imagePromise = imagePromise;
	
	var _lodash = __webpack_require__(4);
	
	var _promise = __webpack_require__(10);
	
	// exports areEqual, areNear, arrayAreEqual, arrayAreNear
	//         concat, flatten, findByType, filterByType, filterRight,
	//         fairSpread
	
	var arrayAreEqual = void 0,
	    arrayAreNear = void 0;
	
	var areEqual = exports.areEqual = function (o1, o2) {
	  if (o1 && o2) {
	    if (o1.isEqual) {
	      return o1.isEqual(o2);
	    } else if (typeof o1 === 'string') {
	      return o1 === o2;
	    } else if (o1.length !== undefined) {
	      return arrayAreEqual(o1, o2);
	    } else {
	      return (0, _lodash.isEqual)(o1, o2);
	    }
	  } else {
	    return o1 === o2;
	  }
	};
	
	var areNear = exports.areNear = function (o1, o2, eps) {
	  if (o1 && o2) {
	    if (o1.isNear) {
	      return o1.isNear(o2, eps);
	    } else if (o1.length !== undefined) {
	      return arrayAreNear(o1, o2, eps);
	    } else if ((0, _lodash.isNumber)(o1)) {
	      return Math.abs(o1 - o2) < (eps || 0.001);
	    } else {
	      return (0, _lodash.isEqual)(o1, o2);
	    }
	  } else if ((0, _lodash.isNumber)(o1)) {
	    return Math.abs(o1 - o2) < (eps || 0.001);
	  } else {
	    return o1 === o2;
	  }
	};
	
	arrayAreEqual = function (array1, array2) {
	  if (array1.length !== array2.length) {
	    return false;
	  }
	  for (var i = 0, iEnd = array1.length; i < iEnd; ++i) {
	    if (!areEqual(array1[i], array2[i])) {
	      return false;
	    }
	  }
	  return true;
	};
	
	arrayAreNear = function (array1, array2, eps) {
	  if (array1.length !== array2.length) {
	    return false;
	  }
	  for (var i = 0, iEnd = array1.length; i < iEnd; ++i) {
	    if (!areNear(array1[i], array2[i], eps)) {
	      return false;
	    }
	  }
	  return true;
	};
	
	var setForEach = exports.setForEach = function (things, member, value) {
	  (0, _lodash.forEach)(things, function (thing) {
	    thing[member] = value;
	  });
	};
	
	var remove = exports.remove = function (things, v) {
	  var i = things.indexOf(v);
	  if (i !== -1) {
	    things.splice(i, 1);
	  }
	};
	
	var filterByType = exports.filterByType = function (things, Type) {
	  return (0, _lodash.filter)(things, function (t) {
	    return t instanceof Type;
	  });
	};
	
	var findByType = exports.findByType = function (things, Type) {
	  return (0, _lodash.find)(things, function (t) {
	    return t instanceof Type;
	  });
	};
	
	// Return all the elements that pass a truth test.
	var filterRight = exports.filterRight = function (obj, iterator) {
	  var results = [];
	  if (obj.length === 0) {
	    return results;
	  }
	  (0, _lodash.forEachRight)(obj, function (value, index, list) {
	    if (iterator(value, index, list)) {
	      results[results.length] = value;
	    }
	  });
	  return results;
	};
	
	// Spreads an array in 'count' bins with the smallest
	// possible difference in quantity between theme
	
	function fairSpread(a, count) {
	  var c = [];
	  var r = [c];
	  var n = 0,
	      length = a.length,
	      nc = void 0;
	  var size = Math.floor(length / count);
	  var extra = length - count * size;
	
	  nc = size + (extra > 0 ? 1 : 0);
	  while (n < length) {
	    if (nc === 0) {
	      c = [];
	      r.push(c);
	      extra--;
	      nc = size + (extra > 0 ? 1 : 0);
	    }
	    c.push(a[n]);
	    nc--;
	    n++;
	  }
	  return r;
	}
	
	// [TODO] This is not longer needed, remove
	
	var attachImageLoadEvent = exports.attachImageLoadEvent = function (img, handler, scope) {
	  var eventName = 'load';
	  if (img.addEventListener) {
	    img.addEventListener(eventName, function () {
	      handler.call(scope);
	    }, false);
	  } else if (img.attachEvent) {
	    img.attachEvent('on' + eventName, function () {
	      handler.call(scope);
	    });
	  }
	};
	
	var detachImageLoadEvent = exports.detachImageLoadEvent = function (img, handler) {
	  var eventName = 'load';
	  if (img.removeEventListener) {
	    img.removeEventListener(eventName, handler, false);
	  } else if (img.detachEvent) {
	    img.detachEvent('on' + eventName, handler);
	  }
	};
	
	var userAgent = navigator.userAgent.toLowerCase();
	var is_firefox = userAgent.indexOf('firefox') > -1;
	var is_safari = userAgent.indexOf('safari') > -1 && userAgent.indexOf('chrome') === -1 && userAgent.indexOf('android') === -1;
	
	var supportsCrossOriginImages = exports.supportsCrossOriginImages = 'crossOrigin' in new Image() && !is_safari; // image on load is not working if I set image.crossOrigin = "Anonymous"
	
	
	function imagePromise(src) {
	  return (0, _promise.createPromise)(function (resolve) {
	
	    var image = new Image();
	
	    // Avoid tainted canvas issue, IE doesn't support this
	    if (supportsCrossOriginImages) {
	      image.crossOrigin = "Anonymous";
	    }
	
	    var onLoad = function () {
	      detachImageLoadEvent(image, onLoad);
	      resolve(image);
	    };
	    attachImageLoadEvent(image, onLoad);
	    image.src = src;
	  });
	}

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ArrayProperty = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _base = __webpack_require__(13);
	
	var _util = __webpack_require__(11);
	
	// This is the best we could do in ES5
	// An ArrayProperty is an object with keys '0', '1', '2'... and a synced length
	// It works like an array-like object and include extra functionality
	// Collection utilies from lo-dash works on them (filter, find, map, etc, clone)
	// Other functions from lo-dash will not work as expected (cloneDeep, flatten)
	// Use instead cloneDeep, flatten, concat, isArray from Grafika utilities
	// In ES2015 it is possible to extends the native array. We are going to migrate
	// to a better implementation once browsers implements support for this feature.
	
	var aProto = Array.prototype; // exports ArrayProperty, isNativeArray, isArray, toArray, cloneDeep
	
	var ArrayProperty = exports.ArrayProperty = _base.OwnedObject.extend({ typeName: 'ArrayProperty',
	
	  __ArrayLike: true,
	  __CxArray: true,
	
	  get isEmpty() {
	    return this.length === 0;
	  },
	  get isArray() {
	    return true;
	  },
	
	  // config: { onChange, constructItem, releaseItem }
	  init: function (array, owner, config) {
	    (0, _lodash.assign)(this, config);
	    this.length = 0;
	    this.owner(owner || null);
	    this.initArrayProperty();
	    this._add(array || []); // this should be the last line
	  },
	  initArrayProperty: function () {},
	  onChange: function () {},
	  constructItem: function (c) {
	    return c;
	  },
	  releaseItem: function () /*c*/{},
	  size: function () {
	    return this.length;
	  },
	  toArray: function (s, e) {
	    return s === undefined ? aProto.slice.call(this, 0) : e === undefined ? aProto.slice.call(this, s) : aProto.slice.call(this, s, e);
	  },
	  at: function (i, v) {
	    if (v === undefined) {
	      return this[i];
	    }
	    this.replaceAt(i, v);
	  },
	
	
	  // Cx extensions
	
	  textualize: function () {
	    var separator = arguments.length <= 0 || arguments[0] === undefined ? ',' : arguments[0];
	    var length = this.length;
	
	    if (length === 0) {
	      return '';
	    }
	
	    var t = void 0,
	        k = void 0;
	
	    if (this[0].textualize) {
	      t = this[0].textualize();
	      for (k = 1; k < length; ++k) {
	        t += separator + this[k].textualize();
	      }
	    } else {
	      t = this[0];
	      for (k = 1; k < length; ++k) {
	        t += separator + this[k];
	      }
	    }
	    return t;
	  },
	  contains: function (v) {
	    return this.indexOf(v) !== -1;
	  },
	  clone: function (deep) {
	    if (deep === true) {
	      return this.cloneDeep();
	    }
	    var a = [];
	    for (var k = 0, kEnd = this.length; k < kEnd; ++k) {
	      a[k] = this[k];
	    }
	    return new ArrayProperty(a);
	  },
	  cloneDeep: function () {
	    var a = [];
	    for (var k = 0, kEnd = this.length; k < kEnd; ++k) {
	      a[k] = (0, _base.cloneDeep)(this[k]);
	    }
	    return new ArrayProperty(a);
	  },
	  isEqual: function (other) {
	    if (this.length !== other.length) {
	      return false;
	    }
	    for (var i = 0, iEnd = this.length; i < iEnd; ++i) {
	      if (!(0, _util.areEqual)(this[i], other[i])) {
	        return false;
	      }
	    }
	    return true;
	  },
	  clear: function () {
	    if (this.length === 0) {
	      return [];
	    }
	    var e = this._clear();
	    this.onChange.call(this._owner, null, e);
	    return e;
	  },
	  add: function (v) {
	    var a = this._add(v);
	    this.onChange.call(this._owner, a);
	    return a;
	  },
	  set: function (v) {
	    if (v.length === 0 && this.length === 0) {
	      return [];
	    }
	    var e = this._set(v);
	    this.onChange.call(this._owner, e.added, e);
	    return e;
	  },
	  remove: function (v) {
	    var e = this._remove(v);
	    this.onChange.call(this._owner, null, e);
	    return e;
	  },
	  erase: function (i, h) {
	    var e = this._erase(i, h);
	    this.onChange.call(this._owner, null, e);
	    return e;
	  },
	  insert: function (i, v) {
	    var a = this._insert(i, v);
	    this.onChange.call(this._owner, a);
	    return a;
	  },
	  replace: function (o, v) {
	    var e = this._replace(o, v);
	    this.onChange.call(this._owner, e.added, e);
	    return e;
	  },
	  replaceAt: function (i, v) {
	    var e = this._replaceAt(i, v);
	    this.onChange.call(this._owner, e.added, [e]);
	    return e;
	  },
	  moveForward: function (v, n) {
	    this._moveForward(v, n);
	    this.onChange.call(this._owner);
	  },
	  moveBackward: function (v, n) {
	    this._moveBackward(v, n);
	    this.onChange.call(this._owner);
	  },
	
	
	  // Mutator
	
	  pop: function () {
	    var r = aProto.pop.call(this);
	    this._releaseItem(r);
	    this.onChange.call(this._owner, null, [r]);
	    return r;
	  },
	  shift: function () {
	    var r = aProto.shift.call(this);
	    this._releaseItem(r);
	    this.onChange.call(this._owner, null, [r]);
	    return r;
	  },
	  push: function (v) {
	    var a = this._push(v);
	    this.onChange.call(this._owner, [a]);
	  },
	  unshift: function (v) {
	    var a = this._unshift(v);
	    this.onChange.call(this._owner, [a]);
	  },
	  sort: function (f) {
	    aProto.sort.call(this, f);
	    this.onChange.call(this._owner);
	  },
	  reverse: function () {
	    aProto.reverse.call(this);
	    this.onChange.call(this._owner);
	  },
	  splice: function () {
	    var e = this._splice.apply(this, arguments);
	    this.onChange.call(this._owner, e.added, e);
	    return e;
	  },
	
	
	  // Accesor
	
	  concat: function (a) {
	    return (0, _base.concat)(this, a);
	  },
	  join: function (c) {
	    return aProto.join.call(this, c);
	  },
	  slice: function () {
	    return Array.prototype.slice.apply(this, arguments);
	  },
	  toString: function () {
	    return this.slice(0).toString();
	  },
	  indexOf: function (v) {
	    return (0, _lodash.indexOf)(this, v);
	  },
	  lastIndexOf: function (v) {
	    return (0, _lodash.lastIndexOf)(this, v);
	  },
	
	
	  // Iteration
	  forEach: function (f) {
	    return (0, _lodash.forEach)(this, f);
	  },
	  every: function (f) {
	    return (0, _lodash.every)(this, f);
	  },
	  some: function (f) {
	    return (0, _lodash.some)(this, f);
	  },
	  filter: function (f) {
	    return (0, _lodash.filter)(this, f);
	  },
	  find: function (f) {
	    return (0, _lodash.find)(this, f);
	  },
	  map: function (f) {
	    return (0, _lodash.map)(this, f);
	  },
	  reduce: function (f, i) {
	    return (0, _lodash.reduce)(this, f, i);
	  },
	  reduceRight: function (f, i) {
	    return (0, _lodash.reduceRight)(this, f, i);
	  },
	  forEachRight: function (f) {
	    return (0, _lodash.forEachRight)(this, f);
	  },
	  findLast: function (f) {
	    return (0, _lodash.findLast)(this, f);
	  },
	
	
	  // Internals
	
	  _releaseItem: function (v) {
	    this.releaseItem.call(this._owner, v);
	    return v;
	  },
	  _adoptItem: function (v) {
	    return this.constructItem.call(this._owner, v);
	  },
	  _adopt: function (v) {
	    if ((0, _base.isArray)(v)) {
	      var a = [];
	      for (var k = 0, kEnd = v.length; k < kEnd; ++k) {
	        var nv_k = this._adoptItem(v[k]);
	        // if( nv !== null ) // [TODO] use AP.{}
	        a.push(nv_k);
	      }
	      return a;
	    } else {
	      var nv = this._adoptItem(v);
	      return [nv]; //  nv !== null ? [nv] : [] // [TODO] use AP.{}
	    }
	  },
	  _release: function (v) {
	    for (var k = 0, kEnd = v.length; k < kEnd; ++k) {
	      this._releaseItem(v[k]);
	    }
	    return v;
	  },
	  _at: function (i, v) {
	    if (v === undefined) {
	      return this[i];
	    } else {
	      return this._replaceAt(i, v);
	    }
	  },
	  _push: function (v) {
	    var a = this._adoptItem(v);
	    aProto.push.call(this, a);
	    return a;
	  },
	  _unshift: function (v) {
	    var a = this._adoptItem(v);
	    aProto.unshift.call(this, a);
	    return a;
	  },
	  _clear: function () {
	    if (this.length === 0) {
	      return [];
	    }
	    return this._release(aProto.splice.call(this, 0, this.length));
	  },
	  _set: function (v) {
	    if (this.length === 0 && v.length === 0) {
	      var ee = [];ee.added = [];return ee;
	    }
	    var e = this._release(aProto.splice.call(this, 0, this.length));
	    e.added = this._simpleSplice(0, 0, v).added;
	    return e;
	  },
	  _add: function (v) {
	    var e = this._simpleSplice(this.length, 0, v);
	    return e.added;
	  },
	  _insert: function (i, v) {
	    var e = this._simpleSplice(i, 0, v);
	    return e.added;
	  },
	  _erase: function (i, h) {
	    return this._release(aProto.splice.call(this, i, h === undefined ? 1 : h));
	  },
	  _remove: function (v) {
	    if (v === this) {
	      return this._clear();
	    }
	    var r = [];
	    var l = this;
	    var tryToRemove = function (e) {
	      var i = (0, _lodash.indexOf)(l, e);
	      if (i !== -1) {
	        r.push(aProto.splice.call(l, i, 1)[0]);
	      }
	    };
	    if ((0, _base.isArray)(v)) {
	      //_.forEach(v,tryToRemove);
	      for (var k = 0, kEnd = v.length; k < kEnd; ++k) {
	        tryToRemove(v[k]);
	      }
	    } else {
	      tryToRemove(v);
	    }
	    return this._release(r);
	  },
	  _replace: function (o, v) {
	    var r = o === this ? this._clear() : [];
	
	    var l = this;
	    var ii = l.length;
	    var tryToRemove = function (e) {
	      var i = (0, _lodash.indexOf)(l, e);
	      if (i !== -1) {
	        r.push(aProto.splice.call(l, i, 1)[0]);
	        if (i < ii) {
	          ii = i;
	        }
	      }
	    };
	    if ((0, _base.isArray)(o)) {
	      //_.forEach(o,tryToRemove);
	      for (var k = 0, kEnd = o.length; k < kEnd; ++k) {
	        tryToRemove(o[k]);
	      }
	    } else {
	      tryToRemove(o);
	    }
	    r.added = this._insert(ii, v);
	    return this._release(r);
	  },
	  _replaceAt: function (i, v) {
	    var nv = this._adoptItem(v);
	    var e = this[i];
	    this[i] = nv;
	    if (this.length <= i) {
	      this.length = i + 1;
	    }
	
	    this._releaseItem(e);
	
	    var r = [e];
	    r.added = [nv];
	    return r;
	  },
	  _moveForward: function (v, n) {
	    var moveRange = function (array, s, e, nn) {
	      aProto.splice.apply(array, [s + nn, 0].concat(aProto.splice.call(array, s, e - s)));
	    };
	    var l = this;
	    var el = (0, _lodash.map)(l, function () {
	      return null;
	    });
	    var tryToSearch = function (e) {
	      var i = (0, _lodash.indexOf)(l, e);
	      if (i !== -1) {
	        el[i] = e;
	      }
	    };
	    if ((0, _base.isArray)(v)) {
	      if (v === l) {
	        v = v.clone();
	      }
	      //_.forEach(v,tryToSearch);
	      for (var k = 0, kEnd = v.length; k < kEnd; ++k) {
	        tryToSearch(v[k]);
	      }
	    } else {
	      tryToSearch(v);
	    }
	    if (n > 0) {
	      var lend = l.length;
	      for (var _k = el.length - 1; _k >= 0; --_k) {
	        if (el[_k] !== null) {
	          var end = _k + 1;
	          while (_k >= 0 && el[_k] !== null) {
	            --_k;
	          }
	          var start = _k + 1;
	          var nTilEnd = Math.min(n, lend - end);
	          moveRange(l, start, end, nTilEnd);
	          lend = start + nTilEnd;
	        }
	      }
	    } else {
	      var lstart = 0;
	      for (var _k2 = 0, len = el.length; _k2 < len; ++_k2) {
	        if (el[_k2] !== null) {
	          var _start = _k2;
	          while (_k2 < len && el[_k2] !== null) {
	            ++_k2;
	          }
	          var _nTilEnd = -Math.min(-n, _start - lstart);
	          moveRange(l, _start, _k2, _nTilEnd);
	          lstart = _k2 + _nTilEnd;
	        }
	      }
	    }
	  },
	  _moveBackward: function (v, n) {
	    return this._moveForward(v, -n);
	  },
	  _simpleSplice: function (i, h, v) {
	    if (v === undefined) {
	      var e = aProto.splice.call(this, i, h);
	      e.added = [];
	      return this._release(e);
	    } else {
	      if ((0, _base.isArray)(v)) {
	        var anv = this._adopt(v);
	        var _e = aProto.splice.apply(this, [i, h].concat(anv));
	        _e.added = anv;
	        return this._release(_e);
	      } else {
	        var nv = this._adoptItem(v);
	        var _e2 = aProto.splice.call(this, i, h, nv);
	        _e2.added = [nv];
	        return this._release(_e2);
	      }
	    }
	  },
	  _splice: function (i, h) {
	    if (arguments.length === 2) {
	      return this._simpleSplice(i, h);
	    } else {
	      var va = [];
	      for (var na = 2, len = arguments.length; na < len; ++na) {
	        var v = arguments[na];
	        if ((0, _base.isArray)(v)) {
	          va = (0, _base.concat)(va, v);
	        } else {
	          va.push(v);
	        }
	      }
	      return this._simpleSplice(i, h, va);
	    }
	  }
	});
	
	_base.OwnedObject.Type.ArrayProperty = ArrayProperty;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.invalidateOwner = exports.OwnedObject = exports.Base = exports._extendPrototype = exports.toArray = exports.isArray = exports.isNativeArray = undefined;
	exports.clone = clone;
	exports.cloneDeep = cloneDeep;
	exports.concat = concat;
	exports.flatten = flatten;
	exports.flatMap = flatMap;
	exports.forwardPropertiesFrom = forwardPropertiesFrom;
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function error(message) {
	  console.log('[Cx] ' + message);
	  if (_config.Config.debug) {
	    throw message;
	  }
	}
	
	var Type = {};
	
	/**
	* Simple JavaScript Inheritance
	* By John Resig http://ejohn.org/
	* MIT Licensed.
	* Inspired by base2 and Prototype.
	*
	* Event support added by Todd Murdock
	* JQuery-like Properties support added by Matias Capeletto
	*/
	
	// We set this to callParent to avoid modifying objects structure
	// Originally it was deleted
	function noop() {}
	
	var isNativeArray = exports.isNativeArray = Array.isArray;
	
	var isArray = exports.isArray = function (v) {
	  return v && v.__CxArray || isNativeArray(v);
	};
	
	var toArray = exports.toArray = _lodash.toArray;
	
	function clone(v) {
	  return v && v.clone ? v.clone() : (0, _lodash.clone)(v);
	}
	
	function cloneDeep(v) {
	  if (v) {
	    if (v.cloneDeep) {
	      return v.cloneDeep();
	    }
	    if (v.clone) {
	      return v.clone();
	    }
	    if (isNativeArray(v)) {
	      var r = [];
	      for (var k = 0, kEnd = v.length; k < kEnd; ++k) {
	        r[k] = cloneDeep(v[k]);
	      }
	      return r;
	    }
	  }
	  return (0, _lodash.cloneDeep)(v);
	}
	
	function concat(array1, array2) {
	  return (array1.__CxArray ? array1.toArray() : array1).concat(array2 && array2.__CxArray ? array2.toArray() : array2);
	}
	
	function flatten(array, r) {
	  if (r === undefined) {
	    r = [];
	  }
	  for (var k = 0, kEnd = array.length; k < kEnd; ++k) {
	    var ak = array[k];
	    if (isArray(ak)) {
	      flatten(ak, r);
	    } else {
	      r.push(ak);
	    }
	  }
	  return r;
	}
	
	function flatMap(a, f) {
	  return flatten((0, _lodash.map)(a, f));
	}
	
	var initializing = false;
	
	var fnTest = /xyz/.test(function () {
	  xyz;
	}) ? /\bcallParent\b/ : /.*/;
	
	// [TODO] enable doc.clear() idiom <---
	
	var definePropertyImp = function (object, name, member, get, set, onChange) {
	  Object.defineProperty(object, name, {
	    get: get || function () {
	      return this[member];
	    },
	    set: onChange ? set ? function (v) {
	      set.call(this, v);onChange.call(this);
	    } : function (v) {
	      this[member] = v;onChange.call(this);
	    } : set || function (v) {
	      this[member] = v;
	    }
	  });
	};
	
	var defineArrayPropertyImp = function (object, name, member) {
	  Object.defineProperty(object, name, {
	    get: function () {
	      return this[member];
	    },
	    set: function (v) {
	      this[member].set(v);
	    }
	  });
	};
	
	var builtIn = ['number', 'integer', 'angle', 'string', 'boolean', 'magnitude', 'function', 'char'];
	var primitives = ['Point', 'Matrix', 'Matrix22', 'Bounds', 'Frame', 'Segment', 'Quadratic', 'Cubic'];
	
	var _makeConstructFunction = function (typeName, owned) {
	
	  // Explicit not owned objects
	  if (owned === false) {
	    return function (v) {
	      return v;
	    };
	  }
	
	  // Built in primitives
	  if ((0, _lodash.includes)(builtIn, typeName)) {
	    return function (v) {
	      return v;
	    };
	  }
	
	  // Grafika Primitives
	  if ((0, _lodash.includes)(primitives, typeName)) {
	    return function (v) {
	      return v;
	    };
	  }
	
	  var KnowConstructor = Type[typeName];
	  if (KnowConstructor && 'construct' in KnowConstructor) {
	    // base.log(`${typeName} special construct`);
	    return KnowConstructor.construct;
	  }
	
	  // Owned and regular objects (Color, Brush, Pen, Figure)
	
	  return function (v) {
	    if (v === null) {
	      // base.log(`${typeName} is null`);
	      return v;
	    }
	    var Constructor = Type[typeName];
	    var sameObject = v instanceof Constructor;
	    if (Constructor.prototype.isOwnedObject) {
	      if (sameObject) {
	        // base.log(`${v.typeName}/${typeName} adopted by ${this.typeName}`);
	        return v.adopted(this);
	      } else {
	        // base.log(`${v.typeName} used to construct ${typeName} adopted by ${this.typeName}`);
	        return new Constructor(v).owner(this);
	      }
	    } else if (sameObject) {
	      // base.log(`${v.typeName}/${typeName} cloned`);
	      return cloneDeep(v);
	    } else {
	      // base.log(`${v.typeName} used to construct ${typeName} for ${this.typeName}`);
	      return new Constructor(v);
	    }
	  };
	};
	
	// [TODO] Review possible optimizations
	var _makeReleaseFunction = function (owned) {
	  return owned ? function (c) {
	    if (c) {
	      c._owner = null;
	    }return c;
	  } : function (c) {
	    return c;
	  };
	};
	
	var _makeArrayConstructFunction = function (p) {
	  var constructItem = p.constructItem;
	  return function (c) {
	    return (0, _lodash.map)(c, constructItem, this);
	  };
	};
	
	var _makeSetFunction = function (p) {
	  if (!p.set && (p.type === undefined || (0, _lodash.includes)(builtIn, p.type))) {
	    return null;
	  }
	  var set = p.set;
	  var construct = p.construct;
	  var m = p.member;
	  return set ? function (c) {
	    set.call(this, construct.call(this, c));
	  } : function (c) {
	    this[m] = construct.call(this, c);
	  };
	};
	
	function _addMember(prototype, callParent, name, member) {
	
	  // Check if we're overwriting an existing function
	  if ((0, _lodash.isFunction)(member) && (0, _lodash.isFunction)(callParent[name]) && fnTest.test(member)) {
	    prototype[name] = function (name, fn) {
	      return function () {
	        var tmp = this.callParent;
	
	        // Add a new .callParent() method that is the same method
	        // but on the super-class
	        this.callParent = callParent[name];
	
	        // The method only need to be bound temporarily, so we
	        // remove it when we're done executing
	        var ret = fn.apply(this, arguments);
	        this.callParent = tmp;
	
	        return ret;
	      };
	    }(name, member);
	  } else {
	    prototype[name] = member;
	  }
	}
	
	var _extendPrototype = exports._extendPrototype = function (prototype, callParent, config) {
	
	  // Copy members over onto the new prototype
	
	  (0, _lodash.forEach)((0, _lodash.keys)(config), function (name) {
	    var descriptor = Object.getOwnPropertyDescriptor(config, name);
	    if (descriptor.get || descriptor.set) {
	      Object.defineProperty(prototype, name, descriptor);
	    } else {
	      _addMember(prototype, callParent, name, config[name]);
	    }
	  });
	
	  // Handle properties
	
	  var prop = 'Properties',
	      inheritProps = callParent[prop],
	      configProps = config[prop],
	      thisProps = prototype[prop] = inheritProps ? clone(inheritProps) : {};
	
	  if (configProps) {
	
	    // Init member name
	    (0, _lodash.forOwn)(configProps, function (p, name) {
	
	      if (thisProps[name]) {
	        error('Base error, Property redefiniton: ' + name);
	        return;
	      }
	      // getset function (named after the property id)
	      if (prototype[name] !== undefined) {
	        error('Properties can not be overrided');
	      }
	
	      thisProps[name] = p;
	
	      if (p.member === undefined && !p.redirect) {
	        p.member = '_' + name;
	      }
	
	      if (p.redirect) {
	        prototype[name] = p.redirect;
	      } else {
	        if (p.owned !== false) {
	          p.owned = true;
	        }
	        if (p.computed !== true) {
	          p.computed = false;
	        }
	        var _isArray = p.type && typeof p.type === 'string' && p.type.indexOf('[]') !== -1;
	        if (!_isArray) {
	          if (!p.construct) {
	            p.construct = _makeConstructFunction(p.type, p.owned);
	          }
	          var set = _makeSetFunction(p);
	          definePropertyImp(prototype, name, p.member, p.get, set, p.onChange);
	        } else {
	          if (!p.array) {
	            p.array = Base.Type.ArrayProperty;
	          }
	          if (!p.constructItem) {
	            p.constructItem = _makeConstructFunction(p.type.substring(0, p.type.lastIndexOf('[')), p.owned);
	          }
	          if (!p.releaseItem) {
	            p.releaseItem = _makeReleaseFunction(p.owned);
	          }
	          if (!p.construct) {
	            p.construct = _makeArrayConstructFunction(p);
	          }
	
	          defineArrayPropertyImp(prototype, name, p.member);
	        }
	      }
	    });
	  }
	
	  /*
	  const defProps = config['defineProperties'];
	  if( defProps ) {
	    defineProperties(prototype,defProps);
	  }*/
	};
	
	// The base Class implementation (does nothing)
	var CxBase = function () {};
	
	// Create a new Class that inherits from this class
	CxBase.extend = function () {
	
	  var callParent = this.prototype;
	
	  // Instantiate a base class (but only create the instance, don't run the init constructor)
	  initializing = true;
	  var prototype = new this();
	
	  initializing = false;
	
	  var typeName = void 0;
	
	  for (var _len = arguments.length, configs = Array(_len), _key = 0; _key < _len; _key++) {
	    configs[_key] = arguments[_key];
	  }
	
	  (0, _lodash.forEach)(configs, function (config) {
	
	    _extendPrototype(prototype, callParent, config);
	
	    typeName = config.typeName || typeName;
	  });
	
	  // Use T as the varible name because it is shown in the dev tools
	
	  // The dummy class constructor
	  var T = function () {
	
	    if (!initializing) {
	      var _this2, _this3, _this4;
	
	      var _constructor = prototype.constructor;
	
	      for (var _len2 = arguments.length, params = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        params[_key2] = arguments[_key2];
	      }
	
	      if (!(this instanceof _constructor)) {
	        return new (Function.prototype.bind.apply(_constructor, [null].concat(params)))();
	      }
	
	      var debugProps = _config.Config.debugProps && prototype.__debugProps;
	      var _this = this;
	      if (debugProps) {
	        _this = createSafeProxy(this);
	      }
	
	      // Possible optimization, avoid changing object structure later
	      _this.callParent = noop;
	
	      _this._events = new Map();
	
	      // We first init the properties so they can be accesed from the init function
	      (_this2 = _this).initProperties.apply(_this2, params);
	
	      // All construction is actually done in the init method
	      (_this3 = _this).init.apply(_this3, params);
	
	      // After initialization is done
	      (_this4 = _this).afterInit.apply(_this4, params);
	
	      // Start checks
	      if (debugProps) {
	        _this.__debugPropsReady = true;
	        return _this;
	      }
	    }
	  };
	
	  // Populate our constructed prototype object
	  T.prototype = prototype;
	
	  // Enforce the constructor to be what we expect
	  T.prototype.constructor = T;
	
	  // And make this class extendable
	  T.extend = this.extend;
	
	  if (typeName) {
	    Type[typeName] = T;
	  }
	
	  return T;
	};
	
	var Base = exports.Base = CxBase.extend({
	
	  // object.on( 'event', fn, scope )
	  onEvent: function (event, handler, scope) {
	
	    var eventHandlers = this._events.get(event);
	
	    if (!eventHandlers) {
	      error(this.typeName + '.on(' + event + ',...), event doesn\'t exist');
	    }
	    if (!(0, _lodash.isFunction)(handler)) {
	      error(this.typeName + '.on( ' + event + ', ... handler ' + (handler ? 'is not a function' : 'undefined'));
	    }
	
	    eventHandlers.push({ handler: handler, scope: scope });
	    return this;
	  },
	
	
	  // object.on({ 'event1': fn1, 'event2': fn2 }, scope });
	  onEvents: function (events, scope) {
	    var _this5 = this;
	
	    (0, _lodash.forOwn)(events, function (handler, event) {
	      if (!handler) {
	        error(_this5.typeName + '.on( { ' + event + ': ... handler undefined');
	      }
	      if (!(0, _lodash.isFunction)(handler)) {
	        error(_this5.typeName + '.on( { ' + event + ': { fn: fn, scope: scope } ) is unsupported, use .on( { ' + event + ': fn }, scope ) instead');
	      } else {
	        _this5.on(event, handler, scope);
	      }
	    });
	    return this;
	  },
	  on: function (event, handler, scope) {
	    // object.on({ 'event1': fn1, 'event2': fn2 }, scope });
	    if (typeof event !== 'string') {
	      return this.onEvents(event, handler);
	    }
	    return this.onEvent(event, handler, scope);
	  },
	
	
	  // object.un( event, handler, scope );
	  unEvent: function (event, handler, scope) {
	    var eventHandlers = this._events.get(event);
	
	    if (!eventHandlers) {
	      error(this.typeName + '.un( ' + event + ', ... ), event doesn\'t exist');
	    }
	    if (!(0, _lodash.isFunction)(handler)) {
	      error(this.typeName + '.un( ' + event + ', ... ), handler ' + (handler ? 'is not a function' : 'undefined'));
	    }
	
	    // Loop down, just in case handler was added multiple times (and will be removed multiple times)
	    for (var i = eventHandlers.length - 1; i >= 0; i--) {
	      var eventHandler = eventHandlers[i];
	      if (eventHandler.handler === handler && (!scope || eventHandler.scope === scope)) {
	        eventHandlers.splice(i, 1);
	      }
	    }
	  },
	
	
	  // object.un( { 'event1': handler1, 'event2': handler2 }, scope )
	  unEvents: function (config, scope) {
	    var _this6 = this;
	
	    (0, _lodash.forOwn)(config, function (handler, event) {
	      if (!(0, _lodash.isFunction)(handler)) {
	        error(_this6.typeName + '.un( { ' + event + ': { fn: fn, scope: scope } } ) is unsupported, use .un( { ' + event + ': fn }, scope ) instead');
	      }
	      _this6.un(event, handler, scope);
	    });
	    return this;
	  },
	
	
	  // Remove every function that has this scope
	  unScope: function (scope) {
	    this._events.forEach(function (eventHandlers) {
	      // Loop down, just in case handler was added multiple times (and will be removed multiple times)
	      for (var i = eventHandlers.length - 1; i >= 0; --i) {
	        if (eventHandlers[i].scope === scope) {
	          eventHandlers.splice(i, 1);
	        }
	      }
	    });
	    return this;
	  },
	  un: function (event, handler, scope) {
	    if (typeof event !== 'string') {
	      if ((0, _lodash.isPlainObject)(event)) {
	        return this.unEvents(event, handler);
	      } else {
	        return this.unScope(event);
	      }
	    }
	    return this.unEvent(event, handler, scope);
	  },
	
	
	  // this.addEvents('renderstart', rendercomplete');
	  addEvents: function () {
	    var _this7 = this;
	
	    (0, _lodash.forEach)(arguments, function (param) {
	      if (isArray(param)) {
	        _this7.addEvents.apply(_this7, _toConsumableArray(param));
	      } else {
	        _this7._events.set(param, []);
	      }
	    });
	    return this;
	  },
	  hasEvent: function (event) {
	    return this._events.has(event);
	  },
	  enumEvents: function () {
	    return this._events.keys();
	  },
	  fireEvent: function (event) {
	
	    var handlers = this._events.get(event);
	    if (!handlers) {
	      error(this.typeName + '.fireEvent( ' + event + ', ... ), event doesn\'t exist');
	    }
	
	    // Prevent error caused by calls to remove a listener from the handler
	    var c_handlers = clone(handlers);
	
	    for (var _len3 = arguments.length, params = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	      params[_key3 - 1] = arguments[_key3];
	    }
	
	    for (var i = 0, iEnd = c_handlers.length; i < iEnd; ++i) {
	      var _c_handlers$i = c_handlers[i];
	      var handler = _c_handlers$i.handler;
	      var scope = _c_handlers$i.scope;
	
	      handler.apply(scope, params);
	    }
	  },
	
	
	  // Properties
	  copyProperties: function (c) {
	    var properties = this.Properties;
	    var names = (0, _lodash.keys)(properties);
	    for (var k = 0, kEnd = names.length; k < kEnd; ++k) {
	      var p = properties[names[k]];
	      if (!p.redirect) {
	
	        var m = p.member;
	        if (!p.array) {
	          if (c && c[m] !== undefined) {
	            var v = c[m];
	            // [TODO] Currently Matrix, Point, etc are not owned objects
	            // This is a hack to clone them when copying properties. This code needs to get cleaned
	            // up to properly handle this cases. This is a hack until that moment:
	            if (v && v._owner === undefined && v.clone) {
	              v = v.clone();
	            }
	            this[m] = p.construct.call(this, v);
	          } else if (p.def !== undefined) {
	            var _v = p.def && p.def.clone ? p.def.clone() : p.def;
	            this[m] = p.construct.call(this, _v);
	          } else {
	            this[m] = null;
	          }
	        } else {
	          if (c && c[m] !== undefined) {
	            this[m] = new p.array(c[m], this, p);
	          } else {
	            var array = new p.array(p.def ? cloneDeep(p.def) : [], this, p);
	            this[m] = array;
	          }
	        }
	      }
	    }
	  },
	  initProperties: function (c) {
	    var properties = this.Properties;
	    if (c && c.Properties === properties) {
	      // init from same object ( new Obj(this) clonning idiom )
	      this.copyProperties(c);
	    } else {
	      // Init from plain object { p1: ..., p2: ... }
	      // Direct JSON represetnation of objets is allowed
	      var names = (0, _lodash.keys)(properties);
	      for (var k = 0, kEnd = names.length; k < kEnd; ++k) {
	        var name = names[k];
	        var p = properties[name];
	        if (!p.redirect) {
	
	          var m = p.member;
	          if (!p.array) {
	            if (c && c[name] !== undefined) {
	              var v = c[name];
	              this[m] = v !== null && p.construct ? p.construct.call(this, v) : v;
	            } else if (p.def !== undefined) {
	              var _v2 = p.def && p.def.clone ? p.def.clone() : p.def;
	              this[m] = _v2 !== null && p.construct ? p.construct.call(this, _v2) : _v2;
	            } else {
	              this[m] = null;
	            }
	          } else {
	            var a = c && c[name] !== undefined ? c[name] : p.def ? cloneDeep(p.def) : [];
	            this[m] = new p.array(a, this, p);
	          }
	        }
	      }
	    }
	  },
	  init: function () {},
	  afterInit: function () {},
	  setupProperties: function (c) {
	    var properties = this.Properties;
	    // Setup from plain object { p1: ..., p2: ... }
	    // Direct JSON representation of objets is allowed
	    var names = (0, _lodash.keys)(properties);
	    for (var k = 0, kEnd = names.length; k < kEnd; ++k) {
	      var name = names[k];
	      var p = properties[name];
	      if (!p.redirect) {
	
	        if (!p.array) {
	          if (c && c[name] !== undefined) {
	            this[name] = c[name]; // this[name]( c[name] );
	          } else if (p.def !== undefined) {
	            var v = p.def && p.def.clone ? p.def.clone() : p.def;
	            this[name] = v; // this[name]( v ) ;
	          } else {
	            this[p.member] = null;
	          }
	        } else {
	          var a = c && c[name] !== undefined ? c[name] : p.def ? cloneDeep(p.def) : [];
	          if (this[p.member]) {
	            this[p.member].set(a);
	          } else {
	            this[p.member] = new p.array(a, this, p);
	          }
	        }
	      }
	    }
	  },
	  propertiesAreEqual: function (other) {
	    var properties = this.Properties;
	    if (!other || other.Properties !== properties) {
	      return false;
	    }
	    var names = (0, _lodash.keys)(properties);
	    for (var k = 0, kEnd = names.length; k < kEnd; k++) {
	      var p = properties[names[k]];
	      if (!p.computed) {
	        var m = p.member;
	        var v = this[m];
	        if (v && v.isEqual) {
	          if (!v.isEqual(other[m])) {
	            return false;
	          }
	        } else if (v !== other[m]) {
	          return false;
	        }
	      }
	    }
	    return true;
	  },
	
	
	  // Default clone for properties only classes
	  clone: function () {
	    return new this.constructor(this);
	  },
	  isEqual: function (other) {
	    return this.propertiesAreEqual(other);
	  },
	  _bind: function (s) {
	    if (!this[s]) {
	      console.log('_bind: ' + this.typeName + '.' + s + ' is undefined');
	    }
	    this[s] = this[s].bind(this);
	    return this;
	  }
	});
	
	Base.Type = Type;
	
	// Work in progress
	// This will be relocated
	// [TODO] add onOwnerChange
	
	var OwnedObject = exports.OwnedObject = Base.extend({ typeName: 'OwnedObject',
	
	  _owner: null,
	
	  get isOwnedObject() {
	    return true;
	  },
	
	  owner: function (v) {
	    return v === undefined ? this._owner : (this._owner = v, this);
	  },
	  adopted: function (owner) {
	    var a = this._owner === null ? this : cloneDeep(this);
	    a.owner(owner);
	    return a;
	  },
	  init: function () /*c*/{
	    // Enable? if( c && c.owner ) this._owner = c.owner;
	  },
	  invalidate: function () {
	    var owner = this._owner;
	    if (owner && owner.invalidate) {
	      owner.invalidate();
	    }
	  },
	  invalidateView: function () {
	    var owner = this._owner;
	    if (owner && owner.invalidateView) {
	      owner.invalidateView();
	    }
	  }
	});
	
	OwnedObject.adoptObject = function (object, owner) {
	  var adoptedObject = object._owner === null ? object : cloneDeep(object);
	  adoptedObject.owner(owner);
	  return adoptedObject;
	};
	
	OwnedObject.adoptArray = function (array, owner) {
	  return (0, _lodash.map)(array, function (object) {
	    return OwnedObject.adoptObject(object, owner);
	  });
	};
	
	OwnedObject.adopt = function (thing, owner) {
	  return thing.length !== undefined ? OwnedObject.adoptArray(thing, owner) : OwnedObject.adoptObject(thing, owner);
	};
	
	OwnedObject.Type = Type;
	
	// [TODO]
	var invalidateOwner = exports.invalidateOwner = function () {
	  var owner = this._owner;
	  if (owner && owner.invalidate) {
	    owner.invalidate();
	  }
	};
	
	function forwardPropertiesFrom(Type, name, proto) {
	  (0, _lodash.forOwn)(Type.prototype.Properties, function (definition, prop) {
	    if (!Object.hasOwnProperty(proto, prop)) {
	      Object.defineProperty(proto, prop, {
	        get: function () {
	          return this[name][prop];
	        },
	        set: function (value) {
	          this[name][prop] = value;
	        },
	
	        enumerable: true
	      });
	    }
	  });
	  return proto;
	}
	
	// Proxy traps to check properties
	// Use Config.debugProps = true to enable
	
	var propsWhitelist = {};
	(0, _lodash.forEach)(['length', 'then', '__CxArray', 'clone', 'cloneDeep', '_ignoreAttributes', 'decode', 'isText', 'isShape', 'isRaster', 'isGroup', 'isProxyGroup', 'isDocument', 'isPage', 'isLayer', 'is3D'], function (p) {
	  return propsWhitelist[p] = true;
	});
	
	function checkAccess(target, property) {
	  return !(0, _lodash.isSymbol)(property) && !(property in propsWhitelist) && !(property in target);
	}
	
	function checkPropType(type, value) {
	  switch (type) {
	    case 'string':
	    case 'magnitude':
	      if (typeof value !== 'string') {
	        return true;
	      }
	      break;
	    case 'number':
	    case 'angle':
	    case 'integer':
	      if (typeof value !== 'number') {
	        return true;
	      }
	      break;
	    case 'boolean':
	      if (typeof value !== 'boolean') {
	        return true;
	      }
	      break;
	  }
	  return false;
	}
	
	function getPropertyDescriptor(obj, key) {
	  return obj && (Object.getOwnPropertyDescriptor(obj, key) || getPropertyDescriptor(Object.getPrototypeOf(obj), key));
	}
	
	var safeProxy = {
	  get: function (target, property, receiver) {
	    if (target.__debugPropsReady && checkAccess(target, property)) {
	      var _error = 'get error: ' + target.typeName + '.' + property;
	      console.log(_error);
	      target[property](); // better than throw, shows in console even if catched in promises chains
	    }
	    var descriptor = getPropertyDescriptor(receiver, property);
	    if (descriptor && descriptor.get) {
	      return descriptor.get.call(receiver);
	    } else {
	      return target[property];
	    }
	  },
	  set: function (target, property, value, receiver) {
	    if (target.__debugPropsReady && checkAccess(target, property)) {
	      var _error2 = 'set error: ' + target.typeName + '.' + property;
	      console.log(_error2);
	      target[property](); // better than throw, shows in console
	    }
	    var Properties = target.Properties;
	    if (value != null && Properties) {
	      var p = Properties[property];
	      if (p) {
	        var error = checkPropType(p.type, value);
	        if (error) {
	          var _error3 = 'set error: ' + target.typeName + '.' + property + " = " + value + ' (wrong type, should be: ' + p.type + ')';
	          console.log(_error3);
	          throw _error3;
	        }
	      }
	    }
	    var descriptor = getPropertyDescriptor(receiver, property);
	    if (descriptor && descriptor.set) {
	      descriptor.set.call(receiver, value);
	    } else {
	      target[property] = value;
	    }
	    return true;
	  }
	};
	
	function createSafeProxy(object) {
	  // We need to wrap the object in the Proxy before initialization
	  // If not, the _owner of properties will point to the target object
	  // console.log(object.typeName);
	  return new Proxy(object, safeProxy);
	}

/***/ },
/* 14 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clearCanvas = clearCanvas;
	exports.clearContext = clearContext;
	exports.fillContext = fillContext;
	exports.setLineDash = setLineDash;
	exports.moveTo = moveTo;
	exports.lineTo = lineTo;
	exports.strokeSegment = strokeSegment;
	exports.strokeWireframe = strokeWireframe;
	exports.dot = dot;
	exports.strokeDot = strokeDot;
	exports.strokeCross = strokeCross;
	function clearCanvas(canvas) {
	  canvas.width = canvas.width;
	}
	
	function clearContext(context) {
	  clearCanvas(context.canvas);
	}
	
	function fillContext(context) {
	  var canvas = context.canvas;
	
	  context.fillRect(0, 0, canvas.width, canvas.height);
	}
	
	function setLineDash(context, array) {
	  if (context.setLineDash) {
	    context.setLineDash(array);
	  } else {
	    // Firefox
	    context.mozDash = array;
	  }
	}
	
	function moveTo(context, point, transform) {
	  var p = transform ? transform.apply(point) : point;
	  context.moveTo(p.x, p.y);
	}
	
	function lineTo(context, point, transform) {
	  var p = transform ? transform.apply(point) : point;
	  context.lineTo(p.x, p.y);
	}
	
	function strokeSegment(context, from, to, transform) {
	  context.beginPath();
	  moveTo(context, from, transform);
	  lineTo(context, to, transform);
	  context.stroke();
	}
	
	function strokeWireframe(context) {
	  context.lineJoin = 'round';
	  context.strokeStyle = '#f4f4f4';
	  context.lineWidth = 1.5;
	  context.stroke();
	
	  context.strokeStyle = '#141446'; // in the server... '#9999CC';
	  context.lineWidth = 1;
	  context.stroke();
	}
	
	function dot(context, center, radius, transform, fillStyle, strokeStyle, lineWidth) {
	  var c = transform ? transform.apply(center) : center;
	  if (fillStyle) {
	    context.fillStyle = fillStyle;
	  }
	  if (strokeStyle) {
	    context.strokeStyle = strokeStyle;
	  }
	  if (lineWidth !== undefined) {
	    context.lineWidth = lineWidth;
	  }
	  context.beginPath();
	  context.arc(c.x, c.y, radius, 0, 2 * Math.PI, false);
	  if (strokeStyle) {
	    context.stroke();
	  }
	  context.fill();
	}
	
	function strokeDot(context, center, radius, transform, strokeStyle) {
	  var c = transform ? transform.apply(center) : center;
	  if (strokeStyle) {
	    context.strokeStyle = strokeStyle;
	  }
	  context.beginPath();
	  context.arc(c.x, c.y, radius, 0, 2 * Math.PI, false);
	  context.stroke();
	}
	
	function strokeCross(context, center, radius, transform, strokeStyle) {
	  var c = transform ? transform.apply(center) : center;
	  if (strokeStyle) {
	    context.strokeStyle = strokeStyle;
	  }
	  context.beginPath();
	  context.moveTo(c.x - radius, c.y - radius);context.lineTo(c.x + radius, c.y + radius);
	  context.moveTo(c.x - radius, c.y + radius);context.lineTo(c.x + radius, c.y - radius);
	  context.stroke();
	}

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enums = __webpack_require__(16);
	
	Object.keys(_enums).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _enums[key];
	    }
	  });
	});
	
	var _util = __webpack_require__(17);
	
	Object.keys(_util).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _util[key];
	    }
	  });
	});
	
	var _geometry = __webpack_require__(21);
	
	Object.keys(_geometry).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _geometry[key];
	    }
	  });
	});
	
	var _style = __webpack_require__(29);
	
	Object.keys(_style).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _style[key];
	    }
	  });
	});
	
	var _figure = __webpack_require__(35);
	
	Object.keys(_figure).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _figure[key];
	    }
	  });
	});
	
	var _process = __webpack_require__(68);
	
	Object.keys(_process).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _process[key];
	    }
	  });
	});
	
	var _document = __webpack_require__(77);
	
	Object.keys(_document).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _document[key];
	    }
	  });
	});

/***/ },
/* 16 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// We are not using enums anymore because they made the code more complex
	// without adding extra checks. We migrated to direct use of strings
	// This file is left here just as reference
	
	var Enums = exports.Enums = {
	
	  LinesAlignment: ['Left', 'Center', 'Right'],
	
	  FillMode: ['CadX', 'Alternate', 'Winding'],
	
	  BrushTransformMode: ['Fixed', 'Clamp', 'RotateOnly', 'Full', 'StretchX', 'StretchY'],
	
	  DashStyle: ['Solid', 'Dash', 'Dot', 'DashDot', 'DashDotDot'],
	
	  LineCap: ['Flat', 'Square', 'Round', 'Triangle'],
	
	  DashCap: ['Flat', 'Round', 'Triangle'],
	
	  LineJoin: ['Miter', 'Bevel', 'Round', 'MiterClipped', 'AdaptiveMiter'],
	
	  CurveType: ['Bezier3', 'Polyline'],
	
	  FitOnPathHPos: ['Fixed_Left', 'Fixed_CenterTop', 'Fixed_CenterBottom', 'Fixed_Right', 'Stretched', 'Scaled', 'Expanded'],
	
	  FitOnPathVPos: ['Above', // Figures are placed such that the bottom side of its bounding box aligns with the path
	  'Over', // Figures are placed such that the baseline of its bounding box aligns with the path
	  'Below' // Figures are placed such that the top side of its bounding box aligns with the path
	  ],
	
	  FitEllipseFit: ['None', // The text is kept with its current kerning
	  'Scaled', // Each letter is scaled to fit into the target range
	  'Contained', // If the text exceeds the target range, each letter is scaled down.
	  'Stretched', // The kerning is recalculated so the text fits into the target range
	  // keeping the size of letters.
	  'Expanded' // If the text exceeds the target range, the range is scaled up to
	  // fit them.
	  ],
	
	  FitEnvelopeHPos: ['Left', 'Center', 'Right', 'Stretched', 'Expanded'],
	
	  FitEnvelopeVPos: ['Top', 'Center', 'Bottom', 'Stretched', 'Expanded'],
	
	  FitEnvelopeMode: ['Freeform', 'Mixed', 'Uniform', 'Boxed'],
	
	  Effect3DLightSource: ['Up', 'Right', 'Down', 'Left'],
	
	  HAlignment: ['Left', 'Center', 'Right'],
	
	  VAlignment: ['Baseline', 'Top', 'Middle', 'Bottom'],
	
	  CornerType: ['Mittered', 'Chamfered', 'Rounded'],
	
	  HalftoneType: ['Full', 'Circle', 'Ellipse'],
	
	  ReshapeAction: ['Combine', 'Weld', 'FrontMinusBack', 'BackMinusFront', 'Condense', 'BreakApart', 'BreakApartRegions', 'BreakApartByColor'],
	
	  VerticalStyle: ['SingleLine', 'MultiLine'],
	
	  ColorType: ['RGB', 'CMYK', 'CE', 'LAB', 'GRAY']
	};
	
	exports.default = Enums;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _metadata = __webpack_require__(18);
	
	Object.keys(_metadata).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _metadata[key];
	    }
	  });
	});
	
	var _xml = __webpack_require__(19);
	
	Object.keys(_xml).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _xml[key];
	    }
	  });
	});
	
	var _monogramFontHelper = __webpack_require__(20);
	
	Object.keys(_monogramFontHelper).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _monogramFontHelper[key];
	    }
	  });
	});

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Metadata = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _xml = __webpack_require__(19);
	
	var Metadata = exports.Metadata = _gear.OwnedObject.extend({ typeName: 'Metadata',
	
	  get isEmpty() {
	    return this.map.size === 0;
	  },
	
	  set: function (key, value) {
	    this.map.set(key, value);
	  },
	  get: function (key) {
	    return this.map.get(key);
	  },
	  delete: function (key) {
	    this.map.delete(key);
	  },
	  has: function (key) {
	    return this.map.has(key);
	  },
	  keys: function () {
	    return this.map.keys();
	  },
	  forEach: function (func) {
	    this.map.forEach(func);
	  },
	  clone: function () {
	    var metadata = new Metadata();
	    metadata.map = (0, _lodash.clone)(this.map);
	    return metadata;
	  },
	  setupXml: function (node) {
	    var keyValues = (0, _lodash.toArray)(this.map);
	    keyValues.sort(function (a, b) {
	      return a[0] > b[0];
	    });
	    for (var i = 0; i < keyValues.length; i++) {
	      var k = keyValues[i];
	      if (k !== undefined && k.length > 0) node.setAttribute(_xml.Xml.toXmlCase(k[0]), k[1]);
	    }
	  },
	  init: function (config) {
	    var _this = this;
	
	    this.callParent(config);
	    this.map = new Map();
	    (0, _lodash.forOwn)(config, function (value, key) {
	      _this.set(key, value);
	    });
	  }
	});
	
	Metadata.parseXml = function (node, owner) {
	  var p = {};
	  (0, _lodash.forEach)(node.attributes, function (_ref) {
	    var name = _ref.name;
	    var value = _ref.value;
	
	    p[_xml.Xml.toObjectCase(name)] = value;
	  });
	  (0, _lodash.forEach)(owner._ignoreAttributes, function (name) {
	    delete p[name];
	  });
	  (0, _lodash.forEach)(owner.Properties, function (c, name) {
	    var delName = c.tag ? _xml.Xml.toObjectCase(c.tag) : name;
	    delete p[delName];
	  });
	  var metadata = new Metadata(p);
	  metadata.owner(owner);
	  return metadata;
	};
	
	exports.default = Metadata;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Xml = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var Xml = exports.Xml = {};
	
	Xml.fromString = function (string) {
	  var xml = new DOMParser().parseFromString(string, 'text/xml');
	
	  if (!xml || !xml.documentElement || xml.getElementsByTagName('parsererror').length) {
	    console.log('Invalid XML: ' + string);
	  }
	
	  return xml;
	};
	
	Xml.toString = function (v) {
	  return new XMLSerializer().serializeToString(v);
	};
	
	Xml.createEmptyDomDocument = function () {
	  var doc = Xml.fromString('<dummy/>');
	  doc.removeChild(doc.documentElement);
	  return doc;
	};
	
	Xml.appendElement = function (parentElement, elementName) {
	  var element = (parentElement.ownerDocument || parentElement).createElement(elementName);
	  parentElement.appendChild(element);
	  return element;
	};
	
	var children_ = Xml.children_ = function (node) {
	  return node.children || node.childNodes;
	};
	
	Xml.children = function (node, tag) {
	  var r = [];
	  var c = children_(node);
	  for (var k = 0, kEnd = c.length; k < kEnd; ++k) {
	    var ck = c[k];
	    if (ck.nodeName === tag) {
	      r.push(ck);
	    }
	  }
	  return r;
	};
	
	Xml.child = function (node, tag) {
	  var c = children_(node);
	  for (var k = 0, kEnd = c.length; k < kEnd; ++k) {
	    var ck = c[k];
	    if (ck.nodeName === tag) {
	      return ck;
	    }
	  }
	};
	
	function floatArrayFromXmlString(s, separator) {
	  if (separator === undefined) {
	    separator = ',';
	  }
	  var sepVals = s.split(separator);
	  return (0, _lodash.map)(sepVals, parseFloat);
	}
	
	function floatArrayToXmlString(fa, separator) {
	  if (separator === undefined) {
	    separator = ',';
	  }
	  var vals = (0, _lodash.map)(fa, function (v) {
	    return (+v.toFixed(4)).toString();
	  });
	  return vals.join(separator);
	}
	
	// We should support null pens and brushes, like in Cx.Engine?
	
	Xml.fontToXml = function (font) {
	  var xmlNode = Xml.createEmptyDomDocument();
	  font.buildXml(xmlNode);
	  var xml = Xml.toString(xmlNode);
	  return xml;
	};
	
	Xml.penToXml = function (pen) {
	  var xmlNode = Xml.createEmptyDomDocument();
	  pen.buildXml(xmlNode);
	  var xml = Xml.toString(xmlNode);
	  return xml;
	};
	
	Xml.brushToXml = function (brush) {
	  var xmlNode = Xml.createEmptyDomDocument();
	  brush.buildXml(xmlNode);
	  var xml = Xml.toString(xmlNode);
	  return xml;
	};
	
	Xml.getFloatAttr = function (node, tag, defaultValue) {
	  var value = parseFloat(node.getAttribute(tag));
	  return isNaN(value) ? defaultValue : value;
	};
	Xml.getIntAttr = function (node, tag, defaultValue) {
	  var value = parseInt(node.getAttribute(tag));
	  return isNaN(value) ? defaultValue : value;
	};
	Xml.getBoolAttr = function (node, tag, defaultValue) {
	  var value = node.getAttribute(tag);
	  if (value) {
	    return value !== '0' && value.toLowerCase() !== 'false';
	  }
	  return defaultValue;
	};
	
	Xml.getStringArrayAttr = function (node, tag, defaultValue) {
	  var valueString = node.getAttribute(tag);
	  if (valueString) {
	    var separator = ',';
	    return valueString.split(separator);
	  }
	  return defaultValue;
	};
	
	Xml.getFloatArrayAttr = function (node, tag, defaultValue) {
	  var valueString = node.getAttribute(tag);
	  if (valueString) {
	    return floatArrayFromXmlString(valueString);
	  }
	  return defaultValue;
	};
	
	Xml.setFloatAttr = function (node, tag, value) {
	  node.setAttribute(tag, +value.toFixed(4));
	};
	Xml.setIntAttr = function (node, tag, value) {
	  node.setAttribute(tag, value.toFixed(0));
	};
	Xml.setBoolAttr = function (node, tag, value) {
	  node.setAttribute(tag, value ? 'true' : 'false');
	};
	Xml.setFloatArrayAttr = function (node, tag, value) {
	  node.setAttribute(tag, floatArrayToXmlString(value));
	};
	
	Xml.setStringArrayAttr = function (node, tag, value) {
	  var separator = ',';
	  var s = value.join(separator);
	  node.setAttribute(tag, s);
	};
	
	Xml.makeNodeParser = function (obj) {
	  return {
	    decode: function (node, tag, v) {
	      return obj.fromXml(node) || v;
	    },
	    encode: function (node, tag, v) {
	      v.buildXml(node);
	    }
	  };
	};
	Xml.makeAttrParser = function (obj) {
	  return {
	    decode: function (node, tag, v) {
	      return obj.parseXml(node) || v;
	    },
	    encode: function (node, tag, v) {
	      v.setupXml(node);
	    }
	  };
	};
	Xml.makeObjectParser = function (obj) {
	  return obj.fromXml ? Xml.makeNodeParser(obj) : Xml.makeAttrParser(obj);
	};
	
	Xml.makeArrayObjectParser = function (obj) {
	  return {
	    decode: function (node, tag, v) {
	      return obj.arrayFromXml(node) || v;
	    },
	    encode: function (node, tag, v) {
	      return obj.arrayBuildXml ? obj.arrayBuildXml(node, v) : Xml.addObjectArray(node, v);
	    }
	  };
	};
	
	// Xml.Parser
	//---------------------------------------------------------------------------
	
	Xml.Parser = {
	  'number': {
	    decode: function (node, tag, v) {
	      return Xml.getFloatAttr(node, tag, v);
	    },
	    encode: function (node, tag, v) {
	      Xml.setFloatAttr(node, tag, v);
	    }
	  },
	  'integer': {
	    decode: function (node, tag, v) {
	      return Xml.getIntAttr(node, tag, v);
	    },
	    encode: function (node, tag, v) {
	      Xml.setIntAttr(node, tag, v);
	    }
	  },
	  'magnitude': {
	    decode: function (node, tag, v) {
	      return _gear.Magnitude.parse(node.getAttribute(tag)) || v;
	    },
	    encode: function (node, tag, v) {
	      if (v != null) if (v instanceof _gear.Magnitude) node.setAttribute(tag, v.toString());else node.setAttribute(tag, new _gear.Magnitude(v, 'mm').toString());
	    }
	  },
	  'string': {
	    decode: function (node, tag, v) {
	      return node.getAttribute(tag) || v;
	    },
	    encode: function (node, tag, v) {
	      node.setAttribute(tag, v);
	    }
	  },
	  'boolean': {
	    decode: function (node, tag, v) {
	      return Xml.getBoolAttr(node, tag, v);
	    },
	    encode: function (node, tag, v) {
	      Xml.setBoolAttr(node, tag, v);
	    }
	  },
	  'angle': {
	    decode: function (node, tag, v) {
	      return Xml.getFloatAttr(node, tag, v);
	    },
	    encode: function (node, tag, v) {
	      Xml.setFloatAttr(node, tag, v);
	    }
	  },
	  'number[]': {
	    decode: function (node, tag, v) {
	      return Xml.getFloatArrayAttr(node, tag, v);
	    },
	    encode: function (node, tag, v) {
	      Xml.setFloatArrayAttr(node, tag, v);
	    }
	  },
	  'string[]': {
	    decode: function (node, tag, v) {
	      return Xml.getStringArrayAttr(node, tag, v);
	    },
	    encode: function (node, tag, v) {
	      Xml.setStringArrayAttr(node, tag, v);
	    }
	  }
	};
	
	Xml.getParser = function (type) {
	  if (typeof type === 'string') {
	    return Xml.Parser[type];
	  } else {
	    return Xml.makeObjectParser(type);
	  }
	};
	
	Xml.parseProperty = function (node, type, name) {
	  var p = type.prototype.Properties[name],
	      t = p.type;
	  if (p.parser || typeof t === 'string') {
	    var tag = p.tag || Xml.toXmlCase(name);
	    return p.parser ? p.parser.decode(node, tag, p.def) : Xml.Parser[t].decode(node, tag, p.def);
	  } else {
	    return t.fromXml ? t.fromXml(node, p.def) : t.parseXml(node, p.def);
	  }
	};
	Xml.parseProperties = function (node, type) {
	  var r = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	  (0, _lodash.forOwn)(type.prototype.Properties, function (prop, name) {
	    if (!prop.manualParsing) {
	      r[name] = Xml.parseProperty(node, type, name);
	    }
	  });
	  return r;
	};
	
	Xml.setupProperty = function (node, obj, name) {
	  var p = obj.Properties[name],
	      t = p.type;
	  var val = obj[p.member];
	  if (val !== null && !p.doNotEncode) {
	    if (p.parser || typeof t === 'string') {
	      if (!p.dropDef || !(val == p.def || val.__CxArray && val.length === 0 && p.def !== undefined && p.def.length === 0)) {
	        var tag = p.tag || Xml.toXmlCase(name);
	        if (p.parser) {
	          p.parser.encode(node, tag, val);
	        } else {
	          Xml.Parser[t].encode(node, tag, val);
	        }
	      }
	    } else if (val.buildXml) {
	      val.buildXml(node);
	    } else if (!p.dropDef || val != p.def) {
	      val.setupXml(node);
	    }
	  }
	};
	Xml.setupProperties = function (node, obj) {
	  var sortedKeys = Object.keys(obj.Properties);
	  sortedKeys.sort();
	  (0, _lodash.forEach)(sortedKeys, function (propName) {
	    if (!obj.Properties[propName].manualParsing) {
	      Xml.setupProperty(node, obj, propName);
	    }
	  });
	};
	Xml.addDefaultParseXml = function (Type) {
	  if (!Type.parseXml) {
	    // Allow user to define its own
	    Type.parseXml = function (node) {
	      return new Type(Xml.parseProperties(node, Type));
	    };
	  }
	};
	Xml.addDefaultFromXml = function (Type, tag) {
	  if (!Type.fromXml) {
	    // Allow user to define its own
	    Type.fromXml = function (node) {
	      return Xml.getObject(node, Type, tag);
	    };
	  }
	  Xml.addDefaultParseXml(Type);
	};
	
	Xml.addDefaultSetupXml = function (Type) {
	  var proto = Type.prototype;
	  if (!proto.setupXml) {
	    // Allow user to define its own
	    proto.setupXml = function (node) {
	      return Xml.setupProperties(node, this);
	    };
	  }
	};
	Xml.addDefaultBuildXml = function (Type, tag) {
	  var proto = Type.prototype;
	  if (!proto.buildXml) {
	    // Allow user to define its own
	    proto.buildXml = function (parentNode) {
	      return Xml.addObject(parentNode, this, tag);
	    };
	  }
	  Xml.addDefaultSetupXml(Type);
	};
	
	Xml.addFromBuild = function (Type, tag) {
	  Xml.addDefaultBuildXml(Type, tag);
	  Xml.addDefaultFromXml(Type, tag);
	};
	Xml.addParseSetup = function (Type) {
	  Xml.addDefaultParseXml(Type);
	  Xml.addDefaultSetupXml(Type);
	};
	
	Xml.addToXml = function (Type) {
	  var proto = Type.prototype;
	  if (!proto.toXml) {
	    // Allow user to define its own
	    proto.toXml = function () {
	      var xml = Xml.fromString('<Cdl></Cdl>');
	      this.buildXml(xml.documentElement);
	      return xml;
	    };
	  }
	  if (!proto.toXmlString) {
	    // Allow user to define its own
	    proto.toXmlString = function () {
	      return Xml.toString(this.toXml());
	    };
	  }
	};
	
	Xml.toXmlCase = function (string) {
	  return string.charAt(0).toUpperCase() + string.substr(1);
	};
	
	Xml.toObjectCase = function (string) {
	  return string.charAt(0).toLowerCase() + string.substr(1);
	};
	
	// Helpers for objects implementing setupXml and parseXml
	
	Xml.addObject = function (parentNode, object, tag) {
	  var node = Xml.appendElement(parentNode, tag);
	  object.setupXml(node);
	  return node;
	};
	Xml.addObjectArray = function (parentNode, objectArray) {
	  (0, _lodash.forEach)(objectArray, function (object) {
	    object.buildXml(parentNode);
	  });
	};
	
	Xml.getObject = function (parentNode, object, tag) {
	  var node = Xml.child(parentNode, tag);
	  if (node) {
	    return object.parseXml(node);
	  }
	  return null;
	};
	
	// Decode nodes of the form
	// <tag/>
	// <tag/>
	// <tag/>
	Xml.getObjectArray = function (parentNode, type, tag) {
	  // [TODO][XML]
	  var list = [];
	  (0, _lodash.forEach)(children_(parentNode), function (node) {
	    var nodeName = node.nodeName;
	
	    if (nodeName && (!tag || nodeName === tag)) {
	      var obj = type.parseXml(node);
	      if (obj) {
	        list.push(obj);
	      }
	    }
	  });
	  return list;
	};

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MonogramFontHelper = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var MonogramFontHelper = exports.MonogramFontHelper = {};
	
	MonogramFontHelper.load$ = function (config) {
	    var d = Cx.Defer();
	    var j = [];
	    var model = {
	        "Match": { "Archived": false, "Owned": true, "Shared": true,
	            "Tags": [{ "Name": "/designer/" + config + "/Monogram",
	                "Owned": true,
	                "Shared": true,
	                "Archived": false,
	                "Type": "Font",
	                "Links": null }]
	        },
	        "SortBy": "Name",
	        "SortDir": "Asc"
	    };
	    Cx.Core.Font.search$(model).then(function (fonts) {
	        var sub_j = { FamilyName: "", Styles: [] };
	        (0, _lodash.forEach)(fonts.Items, function (font) {
	            //e.g. Stahls Mgram Circle Aviator 1 LTR
	            var n = font.FullName.trim().split(/\s+/);
	            if (n.length >= 3) {
	                if (n[2] != sub_j.FamilyName) {
	                    if (sub_j.Styles.length > 0) j.push(sub_j);
	                    sub_j = { FamilyName: "", Styles: [] };
	                    sub_j.FamilyName = n[2];
	                }
	            }
	            if (sub_j.Styles.indexOf(n[3]) == -1) sub_j.Styles.push(n[3]);
	        });
	        if (sub_j.Styles.length > 0) j.push(sub_j);
	        d.resolve(j);
	    });
	    return d;
	};

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _point = __webpack_require__(22);
	
	Object.keys(_point).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _point[key];
	    }
	  });
	});
	
	var _matrix = __webpack_require__(23);
	
	Object.keys(_matrix).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _matrix[key];
	    }
	  });
	});
	
	var _bounds = __webpack_require__(24);
	
	Object.keys(_bounds).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _bounds[key];
	    }
	  });
	});
	
	var _frame = __webpack_require__(25);
	
	Object.keys(_frame).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _frame[key];
	    }
	  });
	});
	
	var _curve = __webpack_require__(26);
	
	Object.keys(_curve).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _curve[key];
	    }
	  });
	});
	
	var _bezier = __webpack_require__(27);
	
	Object.keys(_bezier).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _bezier[key];
	    }
	  });
	});
	
	var _svgPath = __webpack_require__(28);
	
	Object.keys(_svgPath).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _svgPath[key];
	    }
	  });
	});

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Point = undefined;
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	// exports Point, default: Point
	
	var _Math = Math,
	    _abs = _Math.abs,
	    _atan2 = _Math.atan2,
	    _pow = _Math.pow,
	    _sqrt = _Math.sqrt,
	    _Math_PI = _Math.PI,
	    _Math_2_PI = 2 * _Math_PI,
	    _parseFloat = parseFloat;
	
	var Point = exports.Point = function (x, y) {
	  var _this = this;
	  if (!(_this instanceof Point)) {
	    console.log('[Point] missing new');
	    return new Point(x, y);
	  }
	  if (y === undefined) {
	    console.log('[Point] undefined y');
	    _this.x = x.x;
	    _this.y = x.y;
	  } else {
	    _this.x = x;
	    _this.y = y;
	  }
	};
	
	_gear.Base.Type['Point'] = Point;
	
	exports.default = Point;
	
	
	var _toFixed = function (x) {
	  return +x.toFixed(4);
	};
	
	var _textualize = function () {
	  return _toFixed(this.x) + ' ' + _toFixed(this.y);
	};
	
	var _clone = function () {
	  return new Point(this.x, this.y);
	};
	
	var _scalarMultiply = function (alpha) {
	  this.x *= alpha;
	  this.y *= alpha;
	  return this;
	};
	
	Point.prototype = {
	  constructor: Point,
	  type: 'Point',
	
	  get center() {
	    return this.clone();
	  },
	  set center(c) {
	    this.set(c);
	  },
	
	  sm: _scalarMultiply, // shortcut for scalarMultiply
	  scalarMultiply: _scalarMultiply,
	  add: function (x, y) {
	    if (y !== undefined) {
	      console.log('[Point] add, x,y');
	    }
	    if (y === undefined) {
	      y = x.y;x = x.x;
	    }
	    this.x += x;
	    this.y += y;
	    return this;
	  },
	  add_: function (x, y) {
	    this.x += x;
	    this.y += y;
	    return this;
	  },
	  substract: function (x, y) {
	    if (y !== undefined) {
	      console.log('[Point] substract, x,y');
	    }
	
	    if (y === undefined) {
	      y = x.y;x = x.x;
	    }
	    this.x -= x;
	    this.y -= y;
	    return this;
	  },
	  substract_: function (x, y) {
	    this.x -= x;
	    this.y -= y;
	    return this;
	  },
	  plus_: function (x, y) {
	    return new Point(this.x + x, this.y + y);
	  },
	  plus: function (point) {
	    return new Point(this.x + point.x, this.y + point.y);
	  },
	  minus_: function (x, y) {
	    return new Point(this.x - x, this.y - y);
	  },
	  minus: function (point) {
	    return new Point(this.x - point.x, this.y - point.y);
	  },
	  scaled: function (alpha) {
	    return new Point(this.x * alpha, this.y * alpha);
	  },
	
	
	  copy: _clone,
	  clone: _clone,
	
	  isEqual: function (other) {
	    var eps = 0.001;
	    return _abs(this.x - other.x) < eps && _abs(this.y - other.y) < eps;
	  },
	  isNear: function (other) {
	    var eps = arguments.length <= 1 || arguments[1] === undefined ? 0.001 : arguments[1];
	
	    return _abs(this.x - other.x) <= eps && _abs(this.y - other.y) <= eps;
	  },
	  translate_: function (dx, dy) {
	    // Alias to add_
	    this.x += dx;
	    this.y += dy;
	    return this;
	  },
	  translated_: function (dx, dy) {
	    // Alias to plus_
	    return new Point(this.x + dx, this.y + dy);
	  },
	  translate: function (dx, dy) {
	    if (dy !== undefined) {
	      console.log('[Point] translate, x,y');
	    }
	    if (dy === undefined) {
	      dy = dx.y;dx = dx.x;
	    }
	
	    this.x += dx;this.y += dy;
	    return this;
	  },
	  translated: function (dx, dy) {
	    return this.clone().translate(dx, dy);
	  },
	  transform: function (t) {
	    var np = t.apply(this);
	    this.x = np.x;
	    this.y = np.y;
	    return this;
	  },
	  transformed: function (t) {
	    return t.apply(this);
	  },
	
	
	  toSVG: _textualize,
	  toXmlString: _textualize,
	  textualize: _textualize,
	
	  norm2: function () {
	    return this.x * this.x + this.y * this.y;
	  },
	  norm: function () {
	    return _sqrt(this.x * this.x + this.y * this.y);
	  },
	  normalized: function () {
	    return Point.sm(this, 1 / this.norm());
	  },
	  normalize: function () {
	    this.scalarMultiply(1 / this.norm());
	    return this;
	  },
	  perpendicular: function (side) {
	    var m = side < 0 ? 1 : -1;
	    return new Point(this.y * m, -this.x * m);
	  },
	  isZero: function () {
	    return this.x === 0 && this.y === 0;
	  },
	  confine: function (lx, ly, hx, hy) {
	    if (ly === undefined) {
	      var bounds = lx;
	      lx = bounds.lx;
	      ly = bounds.ly;
	      hx = bounds.hx;
	      hy = bounds.hy;
	    }
	    var _this = this;
	    if (_this.x < lx) {
	      _this.x = lx;
	    }
	    if (_this.x > hx) {
	      _this.x = hx;
	    }
	    if (_this.y < ly) {
	      _this.y = ly;
	    }
	    if (_this.y > hy) {
	      _this.y = hy;
	    }
	    return _this;
	  },
	  confined: function (lx, ly, hx, hy) {
	    return this.clone().confine(lx, ly, hx, hy);
	  },
	  angle: function () {
	    return (0, _gear.rad2deg)(_atan2(this.y, this.x));
	  },
	  angle_rad: function () {
	    return _atan2(this.y, this.x);
	  },
	  set: function (x, y) {
	    if (y !== undefined) {
	      console.log('[Point] set, x,y');
	    }
	    if (y === undefined) {
	      y = x.y;x = x.x;
	    }
	    this.x = x;
	    this.y = y;
	    return this;
	  },
	  set_: function (x, y) {
	    this.x = x;
	    this.y = y;
	    return this;
	  },
	  distanceToLine2: function (from, to) {
	    var q = this.projectToLine(from, to);
	    return Point.distance2(this, q);
	  },
	  projectToLine: function (from, to) {
	    var v = Point.substract(to, from);
	    var segLength = v.norm();
	    if (segLength !== 0) {
	      var dir = Point.sm(v, 1 / segLength);
	      var l = Point.dotProduct(dir, Point.substract(this, from));
	      var u = l / segLength;
	      return Point.sm(from, 1 - u).add(Point.sm(to, u));
	    } else {
	      return from;
	    }
	  },
	
	
	  // Returns the parameter corresponding to the orthogonal projection of
	  // this point on the line supported by the vector pa->pb. In order to avoid
	  // square roots, the returned parameter is multiplied by the length of the
	  // vector. The optional parameter len2 is the squared length of the vector
	  // pa->pb.
	  projectionOnLineParameter: function (pa, pb, len2) {
	    var vec = Point.substract(pb, pa); // vector supporting the line
	    if (len2 === undefined) {
	      len2 = vec.norm2();
	    }
	    // If the squared length of the vector is not zero:
	    if (len2 !== 0) {
	      var vecDir = Point.substract(this, pa); // vector pa->this
	      // Return scalar product of the vectors, times the length of pa->pb (if
	      // vec was normalized, the result of the following operation would be just
	      // the parameter).
	      return vec.x * vecDir.x + vec.y * vecDir.y;
	    } else {
	      return 0.0;
	    }
	  },
	
	
	  // Given a segment pa-pb, returns the segments closest point to this.
	  getProjectionToSeg: function (pa, pb) {
	    var vec = Point.substract(pb, pa); // vector pa->pb
	    var len2 = vec.norm2(); // squared length of the segment pa-pb
	    if (len2 === 0.0) {
	      // if the length of the segment is zero, return an endpoint
	      return pa;
	    }
	    var paramOnLine = this.projectionOnLineParameter(pa, pb, len2);
	    // If paramOnLine is smaller than zero or bigger than the length, then
	    // the projection on the line falls outside the segment. In this case,
	    // we return one of the endpoints.
	    if (paramOnLine <= 0.0) {
	      return pa;
	    }
	    if (paramOnLine >= len2) {
	      // If the parameter on the line times |vec| is bigger or equal to |vec|^2,
	      // this means that the parameter is >= than |vec|.
	      return pb;
	    }
	    // If the parameter is bigger than zero and smaller than the segment length,
	    // then we return the projection of the point on the line, which falls
	    // inside the segment.
	    return Point.interpolate(pa, pb, paramOnLine / len2);
	  }
	};
	
	Point.areEqual = function (a, b) {
	  return a.x === b.x && a.y === b.y;
	};
	
	Point.fromXmlString = function (cdlPoint) {
	  var xy = cdlPoint.split(" ");
	  return new Point(_parseFloat(xy[0]), _parseFloat(xy[1]));
	};
	
	Point.distance = function (a, b) {
	  // do not reuse distance2 for performance
	  var dx = a.x - b.x,
	      dy = a.y - b.y;
	  return _sqrt(dx * dx + dy * dy);
	};
	
	Point.distance2 = function (a, b) {
	  var dx = a.x - b.x,
	      dy = a.y - b.y;
	  return dx * dx + dy * dy;
	};
	
	// Returns: w = minmun angle from a to b, in (-PI,PI].
	// w is the smallest angle you need to ccw-rotate a to reach aB
	// (if w &lt; 0 the rotaton is actually cw)
	// w = 0 if a==b.
	// PRECONDITION: ( b.x != 0 || b.y != 0 ) && ( a.x != 0 || a.y != 0 )
	// Returns: A value in radians over (-PI,+PI]
	var Point_turnAngle_rad = Point.turnAngle_rad = function (a, b) {
	  var angle01 = a.angle_rad(),
	      angle12 = b.angle_rad(),
	      sweep = angle12 - angle01;
	  return sweep < -_Math_PI ? sweep + _Math_2_PI : sweep > _Math_PI ? sweep - _Math_2_PI : sweep;
	};
	
	Point.turnAngle = function (a, b) {
	  return (0, _gear.rad2deg)(Point_turnAngle_rad(a, b));
	};
	
	Point.minus = function (p) {
	  return new Point(-p.x, -p.y);
	};
	
	Point.add = function (pa, pb) {
	  return new Point(pa.x + pb.x, pa.y + pb.y);
	};
	
	var Point_substract = Point.substract = function (pa, pb) {
	  return new Point(pa.x - pb.x, pa.y - pb.y);
	};
	
	Point.sm = Point.scalarMultiply = function (p, alpha) {
	  return new Point(p.x * alpha, p.y * alpha);
	};
	
	Point.dotProduct = function (p1, p2) {
	  return p1.x * p2.x + p1.y * p2.y;
	};
	
	var Point_crossProductZ = Point.crossProductZ = function (p1, p2) {
	  return p1.x * p2.y - p1.y * p2.x;
	};
	
	Point.normalize = function (p) {
	  return Point.sm(p, 1 / p.norm());
	};
	
	Point.FromBezier = function (percent, C1, C2, C3, C4) {
	  var t = 1 - percent;
	  var b1 = t * t * t,
	      b2 = 3 * t * t * (1 - t),
	      b3 = 3 * t * (1 - t) * (1 - t),
	      b4 = (1 - t) * (1 - t) * (1 - t);
	  return new Point(C1.x * b1 + C2.x * b2 + C3.x * b3 + C4.x * b4, C1.y * b1 + C2.y * b2 + C3.y * b3 + C4.y * b4);
	};
	
	Point.FromPolygon = function (percent, pa, pb) {
	  return new Point(pa.x + (pb.x - pa.x) * percent, pa.y + (pb.y - pa.y) * percent);
	};
	
	// Given two points pa and pb, and a parameter t, returns the point
	// which is the result of pa+t*d, where d is the normalized direction of
	// the segment (t=0 gives pa and t=length gives pb).
	Point.interpolate = function (pa, pb, t) {
	  return new Point((1 - t) * pa.x + t * pb.x, (1 - t) * pa.y + t * pb.y);
	};
	
	// Based on: http://www.codeproject.com/Tips/84226/Is-a-Point-inside-a-Polygon
	// And: http://erich.realtimerendering.com/ptinpoly/
	// In addition, when the flag includeEdges is set, we handle here the
	// degenerated situation on which the query point is on the boundary of the
	// polygon, returning true.
	
	Point.isInsidePolygon = function (point, poly) {
	  var includeEdges = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];
	
	  var l = poly.length;
	  var x = point.x,
	      y = point.y;
	  var c = false;
	  for (var i = 0, j = l - 1; i < l; j = i++) {
	    if (poly[i].y > y !== poly[j].y > y) {
	      // assert( poly[i].y != poly[j].y )
	      var pdy = poly[j].y - poly[i].y;
	      var lc = (x - poly[i].x) * pdy;
	      var rc = (poly[j].x - poly[i].x) * (y - poly[i].y);
	      if (pdy > 0 && lc < rc || pdy < 0 && lc > rc) {
	        c = !c;
	      } else if (includeEdges && lc === rc) {
	        // lc === rc when the point is on the edge or on a vertex. In this
	        // case, we return true because the point is inside te polygon. We
	        // don't consider this case inside the next one because, in case the
	        // point is on a polygon vertex, the test will be true for two
	        // consecutive edges, yielding an incorrect result.
	        return true;
	      }
	    }
	    var poly_i = poly[i];
	    if (includeEdges && poly_i.x === x && poly_i.y === y) {
	      // This is true iff the point equals a vertex. We put the test outside
	      // the main test because it may be the case that this is true but the
	      // first test is false.
	      return true;
	    }
	  }
	  return c;
	};
	
	// Based on: http://geomalgorithms.com/a03-_inclusion.html
	
	// orientedSide(): tests if a point is Left|On|Right of an infinite line.
	//    Input:  three points P0, P1, and P2
	//    Return: >0 for P2 left of the line through P0 and P1
	//            =0 for P2  on the line
	//            <0 for P2  right of the line
	//    See: Algorithm 1 "Area of Triangles and Polygons"
	Point.orientedSide = function (p0, p1, p2) {
	  var d = (p1.x - p0.x) * (p2.y - p0.y) - (p2.x - p0.x) * (p1.y - p0.y);
	  return d > 0 ? +1 : d < 0 ? -1 : 0;
	};
	
	// Returns true iff p2 is to the left of the oriented side p0p1.
	// A subtraction will be positive if the minuend is bigger than the subtrahend.
	var Point_isLeft = Point.isLeft = function (p0, p1, p2) {
	  // isSomething should return true/false
	  return (p1.x - p0.x) * (p2.y - p0.y) > (p2.x - p0.x) * (p1.y - p0.y);
	};
	
	// Returns true iff p2 is to the right of the oriented side p0p1.
	var Point_isRight = Point.isRight = function (p0, p1, p2) {
	  return (p1.x - p0.x) * (p2.y - p0.y) < (p2.x - p0.x) * (p1.y - p0.y);
	};
	
	// Returns true iff p0, p1 and p2 are aligned.
	var Point_isAligned = Point.isAligned = function (p0, p1, p2) {
	  return (p1.x - p0.x) * (p2.y - p0.y) === (p2.x - p0.x) * (p1.y - p0.y);
	};
	
	// Input: point is a query point, poly is a hull of points, d2 is some squared
	// distance to compare. Returns true iff there is a point on an edge of poly
	// whose squared distance to point is smaller than or equal to d2.  Precondition:
	// the points of poly are ordered (it doesn't matter if they are CW or CCW).
	Point.isNearPolygon = function (point, poly, d2) {
	  for (var k = 0, kEnd = poly.length; k < kEnd; ++k) {
	    if (Point.distance2(point, point.getProjectionToSeg(poly[k], poly[(k + 1) % kEnd])) <= d2) {
	      return true;
	    }
	  }
	  return false;
	};
	
	// The winding number is not defined when the query point belongs to the
	// curve. Although this function handles that case, it is only used when the
	// winding number is defined.
	Point.windNumber = function (point, poly) {
	  var wn = 0; // the  winding number counter
	
	  var y = point.y;
	  // loop through all edges of the polygon
	  var n = poly.length - 1;
	  for (var i = 0; i < n; i++) {
	    // edge from poly[i] to poly[i+1]
	    if (poly[i].y <= y) {
	      // start py <= y
	      if (poly[i + 1].y > y) {
	        // an upward crossing
	        if (Point_isLeft(poly[i], poly[i + 1], point)) {
	          // point left of edge
	          ++wn; // have  a valid up intersect
	        }
	      }
	    } else {
	      // start py > y
	      if (poly[i + 1].y <= y) {
	        // a downward crossing
	        if (Point_isRight(poly[i], poly[i + 1], point)) {
	          // P right of  edge
	          --wn; // have  a valid down intersect
	        }
	      }
	    }
	  }
	  return wn;
	};
	
	var _offsetForFastTranslate = function (d, scale) {
	  var s = +scale.toFixed(6);
	  return Math.round(d * s) / s;
	};
	
	Point.asFastOffset = function (point, scale) {
	  return new Point(_offsetForFastTranslate(point.x, scale), _offsetForFastTranslate(point.y, scale));
	};
	
	// If some of the segments is a point, this function will not work, because
	// det will be zero. Those cases would need to be handled in a different way,
	// but that is not relevant here because we only need segment intersection
	// functions to check box overlap.
	var _computeSegmentsIntersection = function (as, at, bs, bt) {
	  var adir = Point_substract(at, as),
	      bdir = Point_substract(bt, bs),
	      det = Point_crossProductZ(adir, bdir);
	  if (det !== 0) {
	    var d = Point_substract(bs, as),
	        deta = Point_crossProductZ(d, bdir),
	        detb = Point_crossProductZ(d, adir),
	        tta = deta / det,
	        ttb = detb / det;
	
	    return { intersect: true, ta: tta, tb: ttb };
	  } else {
	    return { intersect: false };
	  }
	};
	
	// This function works in the generic case, that is, when both segments
	// are not degenerted and have at most one intersection point.
	Point.doSegmentsIntersect = function (as, at, bs, bt) {
	  var isec = _computeSegmentsIntersection(as, at, bs, bt);
	  if (isec.intersect) {
	    return isec.ta >= 0 && isec.ta <= 1 && isec.tb >= 0 && isec.tb <= 1;
	  } else {
	    return false;
	  }
	};
	
	_util.Xml.Parser['Point'] = {
	  decode: function (node, tag, v) {
	    var valueString = node.getAttribute(tag);
	    if (valueString) {
	      return Point.fromXmlString(valueString);
	    }
	    return v;
	  },
	  encode: function (node, tag, v) {
	    node.setAttribute(tag, v.toXmlString());
	  }
	};

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Matrix22 = exports.Matrix = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _point = __webpack_require__(22);
	
	var _util = __webpack_require__(17);
	
	// exports Matrix, Matrix22, default: Matrix
	
	var _atan2 = Math.atan2,
	    _abs = Math.abs;
	
	var Matrix = exports.Matrix = function (matrix) {
	  if (!(this instanceof Matrix)) {
	    return new Matrix(matrix);
	  }
	  var _this = this;
	  if (matrix) {
	    _this.s00 = matrix.s00;
	    _this.s01 = matrix.s01;
	    _this.dx = matrix.dx || 0;
	    _this.s10 = matrix.s10;
	    _this.s11 = matrix.s11;
	    _this.dy = matrix.dy || 0;
	  } else {
	    //identity
	    _this.s00 = 1;
	    _this.s01 = 0;
	    _this.dx = 0;
	    _this.s10 = 0;
	    _this.s11 = 1;
	    _this.dy = 0;
	  }
	};
	
	_gear.Base.Type['Matrix'] = Matrix;
	_gear.Base.Type['Matrix22'] = Matrix;
	
	var Matrix22 = exports.Matrix22 = Matrix;
	exports.default = Matrix;
	
	
	function numDef(value, def) {
	  return (0, _lodash.isFinite)(value) ? value : def;
	}
	
	Matrix.stringToMatrix22 = function (string) {
	  var mv = (0, _lodash.map)(string.split(','), parseFloat);
	  var s00 = numDef(mv[0], 1),
	      s01 = numDef(mv[1], 0),
	      s10 = numDef(mv[2], 0),
	      s11 = numDef(mv[3], 1);
	  var det = s00 * s11 - s01 * s10;
	
	  if (det != 0) return new Matrix({ s00: s00, s01: s01, s10: s10, s11: s11, dx: 0, dy: 0 });else return new Matrix({ s00: 1, s01: 0, s10: 0, s11: 1, dx: 0, dy: 0 });
	};
	
	function multiply(l, r) {
	  var l_s00 = l.s00,
	      l_s01 = l.s01,
	      l_s10 = l.s10,
	      l_s11 = l.s11;
	  return new Matrix({
	    s00: l_s00 * r.s00 + l_s01 * r.s10,
	    s01: l_s00 * r.s01 + l_s01 * r.s11,
	    dx: l_s00 * r.dx + l_s01 * r.dy + l.dx,
	    s10: l_s10 * r.s00 + l_s11 * r.s10,
	    s11: l_s10 * r.s01 + l_s11 * r.s11,
	    dy: l_s10 * r.dx + l_s11 * r.dy + l.dy
	  });
	}
	Matrix.multiply = Matrix.m = multiply;
	
	Matrix.concat = function () {
	  // g.assert(arguments.length >= 2,'Matrix.concat');
	  var result = arguments[0];
	  for (var i = 1; i < arguments.length; ++i) {
	    result = multiply(result, arguments[i]);
	  }
	  return result;
	};
	
	function _appended(m) {
	  return multiply(this, m);
	}
	
	function _scaleFactor() {
	  return Math.sqrt(_abs(this.determinant()));
	}
	
	function _isNear(other) {
	  var eps = arguments.length <= 1 || arguments[1] === undefined ? 0.0001 : arguments[1];
	
	  var _this = this;
	  return _abs(_this.s00 - other.s00) < eps && _abs(_this.s01 - other.s01) < eps && _abs(_this.s10 - other.s10) < eps && _abs(_this.s11 - other.s11) < eps && _abs(_this.dx - other.dx) < eps && _abs(_this.dy - other.dy) < eps;
	}
	
	function translate(dx, dy) {
	  if (dy === undefined) {
	    var p = dx;dx = p.x;dy = p.y;
	  }
	  return new Matrix({ s00: 1, s01: 0, s10: 0, s11: 1, dx: dx, dy: dy });
	}
	Matrix.translate = translate;
	
	function rotate_rad(phi) {
	  if (phi !== 0) {
	    var cos = Math.cos(phi);
	    var sin = Math.sin(phi);
	    return new Matrix({ s00: cos, s01: -sin, s10: sin, s11: cos, dx: 0, dy: 0 });
	  } else {
	    return new Matrix();
	  }
	}
	
	function rotate(deg) {
	  return rotate_rad((0, _gear.deg2rad)(deg));
	}
	Matrix.rotate = rotate;
	
	function transformAround(point, matrix) {
	  var x = point.x,
	      y = point.y;
	  return multiply(translate(x, y), multiply(matrix, translate(-x, -y)));
	}
	Matrix.transformAround = transformAround;
	
	function transformRotated(deg, matrix) {
	  var phi = (0, _gear.deg2rad)(deg);
	  return multiply(rotate_rad(phi), multiply(matrix, rotate_rad(-phi)));
	}
	
	function scale(sx, sy, deg) {
	  if (sy === undefined) {
	    sy = sx;
	  }
	  if (deg === undefined) {
	    return new Matrix({ s00: sx, s01: 0, s10: 0, s11: sy, dx: 0, dy: 0 });
	  } else {
	    return transformRotated(deg, scale(sx, sy));
	  }
	}
	Matrix.scale = scale;
	
	function scaleFrom(point, sx, sy, deg) {
	  return transformAround(point, scale(sx, sy, deg));
	}
	Matrix.scaleFrom = scaleFrom;
	
	function rotateAround(point, deg) {
	  return transformAround(point, rotate(deg));
	}
	Matrix.rotateAround = rotateAround;
	
	function shear(sx, sy, deg) {
	  if (deg === undefined) {
	    return new Matrix({ s00: 1.0, s01: sx, s10: sy, s11: 1.0, dx: 0, dy: 0 });
	  } else {
	    return transformRotated(deg, shear(sx, sy));
	  }
	}
	Matrix.shear = shear;
	
	function shearAround(point, sx, sy, deg) {
	  return transformAround(point, shear(sx, sy, deg));
	}
	Matrix.shearAround = shearAround;
	
	function invert(m) {
	  var m_s00 = m.s00,
	      m_s01 = m.s01,
	      m_s10 = m.s10,
	      m_s11 = m.s11;
	  var det = m_s00 * m_s11 - m_s01 * m_s10;
	  return det === 0.0 ? null : new Matrix({
	    s00: m_s11 / det,
	    s01: -m_s01 / det,
	    s10: -m_s10 / det,
	    s11: m_s00 / det,
	    dx: (m_s01 * m.dy - m.dx * m_s11) / det,
	    dy: (m_s10 * m.dx - m.dy * m_s00) / det
	  });
	}
	Matrix.invert = invert;
	
	function _toFixed(x) {
	  return +x.toFixed(4);
	}
	
	function _textualize() {
	  var _this = this,
	      sep = ',';
	  return _toFixed(_this.s00) + sep + _toFixed(_this.s01) + sep + _toFixed(_this.s10) + sep + _toFixed(_this.s11) + sep + _toFixed(_this.dx) + sep + _toFixed(_this.dy);
	}
	
	Matrix.prototype = {
	  constructor: Matrix,
	  type: 'Matrix',
	
	  get matrix() {
	    return this;
	  },
	
	  get matrix22() {
	    var m = this.clone();
	    m.dx = 0;m.dy = 0;
	    return m;
	  },
	
	  set: function (m) {
	    var _this = this;
	    _this.s00 = m.s00;
	    _this.s01 = m.s01;
	    _this.s10 = m.s10;
	    _this.s11 = m.s11;
	    _this.dx = m.dx;
	    _this.dy = m.dy;
	    return this;
	  },
	  apply: function (point) {
	    var _this = this;
	    return new _point.Point(point.x * _this.s00 + point.y * _this.s01 + _this.dx, point.x * _this.s10 + point.y * _this.s11 + _this.dy);
	  },
	  apply_: function (x, y) {
	    var _this = this;
	    return new _point.Point(x * _this.s00 + y * _this.s01 + _this.dx, x * _this.s10 + y * _this.s11 + _this.dy);
	  },
	  applyInplace: function (p) {
	    // Do not reuse other functions for performance
	    var x = p.x,
	        y = p.y,
	        _this = this;
	    p.x = x * _this.s00 + y * _this.s01 + _this.dx;
	    p.y = x * _this.s10 + y * _this.s11 + _this.dy;
	  },
	  isIdentity: function () {
	    var _this = this;
	    return _this.s00 === 1 && _this.s01 === 0 && _this.s10 === 0 && _this.s11 === 1 && _this.dx === 0 && _this.dy === 0;
	  },
	
	
	  appended: _appended,
	  m: _appended,
	
	  determinant: function () {
	    return this.s00 * this.s11 - this.s01 * this.s10;
	  },
	
	  getScaleFactor: _scaleFactor,
	  scaleFactor: _scaleFactor,
	  maxScaleFactor: function () {
	    // This is not exact
	    var sf = this._scaleFactors();
	    return Math.sqrt(Math.max(sf[0], sf[1]));
	  },
	  _scaleFactors: function () {
	    var r = this.angle_rad();
	    var m = multiply(this, rotate_rad(-r));
	    m.dx = m.dy = 0;
	    var sX2 = m.apply_(1, 0).norm2();
	    var sY2 = m.apply_(0, 1).norm2();
	    return [sX2, sY2];
	  },
	  angle_rad: function () {
	    return _atan2(this.s10, this.s00);
	  },
	  angle: function () {
	    return (0, _gear.rad2deg)(_atan2(this.s10, this.s00));
	  },
	  isAlmostIsotropic: function () {
	    var sf = this._scaleFactors();
	    return _abs(1 - sf[0] / sf[1]) < 0.01;
	  },
	
	  isNear: _isNear,
	  isEqual: _isNear,
	  toCssString: function (unit) {
	    var _this = this;
	    return 'matrix(' + _this.s00 + ',' + _this.s01 + ',' + _this.s10 + ',' + _this.s11 + ',' + _this.dx + unit + ',' + -_this.dy + unit + ')';
	  },
	  clone: function () {
	    return new Matrix(this);
	  },
	  invert: function () {
	    return this.set(this.inverted());
	  },
	  inverted: function () {
	    return invert(this);
	  },
	  toMatrix22: function () {
	    return new Matrix({ s00: this.s00, s01: this.s01, s10: this.s10, s11: this.s11 });
	  },
	  toMatrix22String: function () {
	    var sep = ',';
	    return _toFixed(this.s00) + sep + _toFixed(this.s01) + sep + _toFixed(this.s10) + sep + _toFixed(this.s11);
	  },
	  transformContext: function (context) {
	    var t = this;
	    context.transform(t.s00, t.s10, t.s01, t.s11, t.dx, t.dy);
	  },
	
	
	  toMatrixString: _textualize,
	  textualize: _textualize,
	
	  setMatrix22Attr: function (node, tag) {
	    node.setAttribute(tag, this.toMatrix22String());
	  }
	};
	
	function add(m1, m2) {
	  return new Matrix({ s00: m1.s00 + m2.s00, s01: m1.s01 + m2.s01,
	    s10: m1.s10 + m2.s10, s11: m1.s11 + m2.s11,
	    dx: m1.dx + m2.dx, dy: m1.dy + m2.dy });
	}
	Matrix.add = add;
	
	function substract(m1, m2) {
	  return new Matrix({ s00: m1.s00 - m2.s00, s01: m1.s01 - m2.s01,
	    s10: m1.s10 - m2.s10, s11: m1.s11 - m2.s11,
	    dx: m1.dx - m2.dx, dy: m1.dy - m2.dy });
	}
	Matrix.substract = substract;
	
	function scalarMultiply(m, a) {
	  return new Matrix({ s00: m.s00 * a, s01: m.s01 * a,
	    s10: m.s10 * a, s11: m.s11 * a,
	    dx: m.dx * a, dy: m.dy * a });
	}
	Matrix.sm = Matrix.scalarMultiply = scalarMultiply;
	
	Matrix.getMatrix22Attr = function (node, tag, def) {
	  var valueString = node.getAttribute(tag);
	  if (valueString) {
	    return Matrix.stringToMatrix22(valueString);
	  }
	  return def === undefined ? new Matrix() : def;
	};
	
	_util.Xml.Parser['Matrix22'] = {
	  decode: function (node, tag, v) {
	    return Matrix.getMatrix22Attr(node, tag, v);
	  },
	  encode: function (node, tag, v) {
	    v.setMatrix22Attr(node, tag);
	  }
	};

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BoundsBuilder = exports.segmentBounds = exports.bezierBounds = exports.Bounds = undefined;
	
	var _gear = __webpack_require__(8);
	
	var _point = __webpack_require__(22);
	
	var _matrix = __webpack_require__(23);
	
	var _util = __webpack_require__(17);
	
	// exports Bounds, bezierBounds, segmentBounds, BoundsBuilder, default: Bounds
	
	var _Math = Math,
	    _Math_max = _Math.max,
	    _Math_min = _Math.min,
	    _abs = _Math.abs,
	    _floor = _Math.floor,
	    _parseFloat = parseFloat;
	
	var Bounds = exports.Bounds = function (lx, ly, hx, hy) {
	  var _this = this;
	  if (!(_this instanceof Bounds)) {
	    return new Bounds(lx, ly, hx, hy);
	  }
	  if (ly === undefined) {
	    var o = lx;
	    _this.lx = o.lx;
	    _this.ly = o.ly;
	    _this.hx = o.hx;
	    _this.hy = o.hy;
	  } else {
	    _this.lx = lx;
	    _this.ly = ly;
	    _this.hx = hx;
	    _this.hy = hy;
	  }
	};
	
	_gear.Base.Type['Bounds'] = Bounds;
	
	exports.default = Bounds;
	
	
	var _toFixed = function (x) {
	  return +x.toFixed(4);
	};
	
	var _textualize = function () {
	  var _this = this,
	      sep = ' ';
	  return _toFixed(_this.lx) + sep + _toFixed(_this.ly) + sep + _toFixed(_this.hx) + sep + _toFixed(_this.hy);
	};
	
	var _isNear = function (other) {
	  var eps = arguments.length <= 1 || arguments[1] === undefined ? 0.001 : arguments[1];
	
	  var _this = this;
	  return _abs(_this.lx - other.lx) < eps && _abs(_this.ly - other.ly) < eps && _abs(_this.hx - other.hx) < eps && _abs(_this.hy - other.hy) < eps;
	};
	
	Bounds.prototype = {
	  constructor: Bounds,
	  type: 'Bounds',
	  clone: function () {
	    return new Bounds(this);
	  },
	
	  isEqual: _isNear,
	  isNear: _isNear,
	  translated: function (x, y) {
	    return this.clone().translate(x, y);
	  },
	  translate: function (x, y) {
	    if (y === undefined) {
	      y = x.y;x = x.x;
	    }
	    var _this = this;
	    _this.lx += x;_this.ly += y;
	    _this.hx += x;_this.hy += y;
	    return this;
	  },
	  scaled: function (sx, sy) {
	    return this.clone().scale(sx, sy);
	  },
	  scale: function (sx, sy) {
	    if (sy === undefined) {
	      sy = sx;
	    }
	    this.scalingTransform(_matrix.Matrix.scaleFrom(this.center, sx, sy));
	    return this;
	  },
	  scalingTransform: function (t) {
	    var _this = this,
	        P0 = t.apply(_this.lx_ly),
	        P0_x = P0.x,
	        P0_y = P0.y,
	        P1 = t.apply(_this.hx_hy),
	        P1_x = P1.x,
	        P1_y = P1.y;
	    _this.lx = P0_x < P1_x ? P0_x : P1_x;
	    _this.ly = P0_y < P1_y ? P0_y : P1_y;
	    _this.hx = P0_x > P1_x ? P0_x : P1_x;
	    _this.hy = P0_y > P1_y ? P0_y : P1_y;
	    return this;
	  },
	  scalingTransformed: function (t) {
	    return this.clone().scalingTransform(t);
	  },
	  deinterpolate: function (point) {
	    var _this = this,
	        _this_lx = _this.lx,
	        _this_ly = _this.ly;
	    return { x: (point.x - _this_lx) / (_this.hx - _this_lx),
	      y: (point.y - _this_ly) / (_this.hy - _this_ly) };
	  },
	  interpolate: function (x, y) {
	    if (y === undefined) {
	      var p = x;x = p.x;y = p.y;
	    }
	    var iv = new _point.Point((1 - x) * this.lx + x * this.hx, (1 - y) * this.ly + y * this.hy);
	    return iv;
	  },
	
	
	  get center() {
	    return new _point.Point(0.5 * (this.lx + this.hx), 0.5 * (this.ly + this.hy));
	  },
	
	  get lx_ly() {
	    return new _point.Point(this.lx, this.ly);
	  },
	  get lx_hy() {
	    return new _point.Point(this.lx, this.hy);
	  },
	  get hx_ly() {
	    return new _point.Point(this.hx, this.ly);
	  },
	  get hx_hy() {
	    return new _point.Point(this.hx, this.hy);
	  },
	
	  get mx() {
	    return (this.lx + this.hx) / 2;
	  },
	  get my() {
	    return (this.ly + this.hy) / 2;
	  },
	
	  contains: function (x, y) {
	    if (y === undefined) {
	      var p = x;x = p.x;y = p.y;
	    }
	    return x >= this.lx && x <= this.hx && y >= this.ly && y <= this.hy;
	  },
	  inflated: function (dw, dh) {
	    return this.clone().inflate(dw, dh);
	  },
	  inflate: function (dw) {
	    var dh = arguments.length <= 1 || arguments[1] === undefined ? dw : arguments[1];
	
	    this.lx -= dw;
	    this.hx += dw;
	    this.ly -= dh;
	    this.hy += dh;
	    return this;
	  },
	
	
	  get area() {
	    return this.width * this.height;
	  },
	
	  get width() {
	    return this.hx - this.lx;
	  },
	
	  set width(v) {
	    var w = this.width,
	        d = (v - w) / 2;
	    this.lx -= d;
	    this.hx += d;
	  },
	
	  get height() {
	    return this.hy - this.ly;
	  },
	  set height(v) {
	    var h = this.height,
	        d = (v - h) / 2;
	    this.ly -= d;
	    this.hy += d;
	  },
	
	  toXmlString: _textualize,
	  textualize: _textualize,
	
	  draw: function (context) {
	    var lx = _floor(this.lx) + 0.5,
	        ly = _floor(this.ly) + 0.5,
	        hx = _floor(this.hx) + 0.5,
	        hy = _floor(this.hy) + 0.5;
	    context.beginPath();
	    context.moveTo(lx, ly);
	    context.lineTo(lx, hy);
	    context.lineTo(hx, hy);
	    context.lineTo(hx, ly);
	    context.lineTo(lx, ly);
	    context.closePath();
	  },
	  setXmlAttr: function (node, tag) {
	    node.setAttribute(tag, this.toXmlString());
	  }
	};
	
	Bounds.around = function (center, width, height) {
	  return new Bounds(center.x - width / 2, center.y - height / 2, center.x + width / 2, center.y + height / 2);
	};
	
	Bounds.fromBox = function (box) {
	  return new Bounds(box.x, box.y, box.x + box.width, box.y + box.height);
	};
	
	Bounds.fromXmlString = function (s) {
	  var a = s.split(' ');
	  return new Bounds(_parseFloat(a[0]), _parseFloat(a[1]), _parseFloat(a[2]), _parseFloat(a[3]));
	};
	
	// Unrolled performant version
	Bounds.ofPoints = function (points) {
	  if (points.length === 0) {
	    return null;
	  }
	  var p = points[0],
	      lx = p.x,
	      ly = p.y,
	      hx = lx,
	      hy = ly;
	  for (var k = 1, kEnd = points.length; k < kEnd; ++k) {
	    p = points[k];
	    var x = p.x,
	        y = p.y;
	    if (lx > x) {
	      lx = x;
	    } else if (hx < x) {
	      hx = x;
	    }
	    if (ly > y) {
	      ly = y;
	    } else if (hy < y) {
	      hy = y;
	    }
	  }
	  return new Bounds(lx, ly, hx, hy);
	};
	
	// Unrolled performant version
	Bounds.ofPointsAfter = function (points, t) {
	  if (points.length === 0) {
	    return null;
	  }
	
	  // [Inline:Matrix.apply]
	  // const (tpx,tpy) = t.apply( points[0] );
	  var p = points[0],
	      px = p.x,
	      py = p.y,
	      tpx = px * t.s00 + py * t.s01 + t.dx,
	      tpy = px * t.s10 + py * t.s11 + t.dy;
	  // ---
	
	  var lx = tpx,
	      ly = tpy,
	      hx = tpx,
	      hy = tpy;
	  for (var k = 1, kEnd = points.length; k < kEnd; ++k) {
	
	    // [Inline:Matrix.apply]
	    // (tpx,tpy) = t.apply( points[k] );
	    p = points[k];
	    px = p.x;py = p.y;
	    tpx = px * t.s00 + py * t.s01 + t.dx;
	    tpy = px * t.s10 + py * t.s11 + t.dy;
	    // ---
	
	    if (lx > tpx) {
	      lx = tpx;
	    } else if (hx < tpx) {
	      hx = tpx;
	    }
	
	    if (ly > tpy) {
	      ly = tpy;
	    } else if (hy < tpy) {
	      hy = tpy;
	    }
	  }
	  return new Bounds(lx, ly, hx, hy);
	};
	
	// Unrolled performant version
	Bounds.ofThings = function (things) {
	  var count = things.length;
	  if (count === 0) {
	    return null;
	  }
	  var b = things[0].bounds;
	  if (count === 1) {
	    return b;
	  }
	
	  var lx = b.lx,
	      ly = b.ly,
	      hx = b.hx,
	      hy = b.hy;
	  for (var k = 1; k < count; ++k) {
	    b = things[k].bounds;
	    if (lx > b.lx) {
	      lx = b.lx;
	    }
	    if (ly > b.ly) {
	      ly = b.ly;
	    }
	    if (hx < b.hx) {
	      hx = b.hx;
	    }
	    if (hy < b.hy) {
	      hy = b.hy;
	    }
	  }
	  return new Bounds(lx, ly, hx, hy);
	};
	
	// Unrolled performant version
	Bounds.ofThingsAfter = function (things, transform) {
	  var count = things.length;
	  if (count === 0) {
	    return null;
	  }
	  var b = things[0].boundsAfter(transform);
	  if (count === 1) {
	    return b;
	  }
	
	  var lx = b.lx,
	      ly = b.ly,
	      hx = b.hx,
	      hy = b.hy;
	  for (var k = 1; k < count; ++k) {
	    b = things[k].boundsAfter(transform);
	    if (lx > b.lx) {
	      lx = b.lx;
	    }
	    if (ly > b.ly) {
	      ly = b.ly;
	    }
	    if (hx < b.hx) {
	      hx = b.hx;
	    }
	    if (hy < b.hy) {
	      hy = b.hy;
	    }
	  }
	  return new Bounds(lx, ly, hx, hy);
	};
	
	// Returns true iff the intervals [al,ar] and [bl,br] have more than one
	// point in common. For a function which also returns true when the
	// intervals overlap in one point, it suffices to replace the two <'s for
	// <='s. Precondition: al<=ar && bl<=br.
	var _intervalsOverlap = function (al, ar, bl, br) {
	  return al <= bl ? bl < ar : al < br;
	};
	
	// Returns true iff the intervals overlap in x and in y. Technically
	// speaking, the function returns true iff the intersection set has
	// cardinality \aleph_2.
	Bounds.areOverlapping = function (ba, bb) {
	  return _intervalsOverlap(ba.lx, ba.hx, bb.lx, bb.hx) && _intervalsOverlap(ba.ly, ba.hy, bb.ly, bb.hy);
	};
	
	Bounds.intersection = function (ba, bb) {
	  if (Bounds.areOverlapping(ba, bb)) {
	    return new Bounds(_Math_max(ba.lx, bb.lx), _Math_max(ba.ly, bb.ly), _Math_min(ba.hx, bb.hx), _Math_min(ba.hy, bb.hy));
	  } else {
	    return null;
	  }
	};
	
	Bounds.union = function (boundsList) {
	  var ma = Number.MAX_VALUE;
	  var result = { lx: ma, ly: ma, hx: -ma, hy: -ma };
	
	  for (var k = 0, kEnd = boundsList.length; k < kEnd; ++k) {
	    var bounds = boundsList[k];
	    //_.forEach(boundsList,function(bounds) {
	    if (bounds.lx < result.lx) {
	      result.lx = bounds.lx;
	    }
	    if (bounds.ly < result.ly) {
	      result.ly = bounds.ly;
	    }
	    if (bounds.hx > result.hx) {
	      result.hx = bounds.hx;
	    }
	    if (bounds.hy > result.hy) {
	      result.hy = bounds.hy;
	    }
	  } //);
	  return result.lx < ma && result.ly < ma && result.hx > -ma && result.hy > -ma ? new Bounds(result) : new Bounds(0, 0, 1000, 1000);
	};
	
	Bounds.overlapPercentage = function (ba, bb) {
	  var bi = Bounds.intersection(ba, bb);
	  if (bi) {
	    var ba_area = ba.area,
	        bb_area = bb.area,
	        bi_area = bi.area;
	    return bi_area / _Math_min(ba_area, bb_area);
	  }
	  return 0;
	};
	
	Bounds.horizontalOverlapPercentage = function (ba, bb) {
	  var bi = Bounds.intersection(ba, bb);
	  if (bi) {
	    var ba_width = ba.width,
	        bb_width = bb.width,
	        bi_width = bi.width;
	    return bi_width / _Math_min(ba_width, bb_width);
	  }
	  return 0;
	};
	
	var _alignTo = function (align, where) {
	  return align.indexOf(where) !== -1;
	};
	
	Bounds.alignOffset = function (bounds, alignment, toBounds, margin) {
	  var m = margin || 0;
	  var toCenter = toBounds.center;
	  var center = bounds.center;
	  var align = alignment.toLowerCase();
	
	  return new _point.Point(
	
	  // delta x
	  _alignTo(align, 'left') ? toBounds.lx + m - bounds.lx : _alignTo(align, 'center') ? toCenter.x - center.x : _alignTo(align, 'right') ? toBounds.hx - m - bounds.hx : 0,
	
	  // delta y
	  _alignTo(align, 'bottom') ? toBounds.ly + m - bounds.ly : _alignTo(align, 'middle') ? toCenter.y - center.y : _alignTo(align, 'top') ? toBounds.hy - m - bounds.hy : 0);
	};
	
	// Raphael.bezierBBox from https://raw.githubusercontent.com/DmitryBaranovskiy/raphael/master/raphael.js
	var abs = _abs,
	    sqrt = Math.sqrt,
	    pow = Math.pow,
	    mmin = _Math_min,
	    mmax = _Math_max;
	var findDotAtSegment = function (p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
	  var t1 = 1 - t;
	  return {
	    x: pow(t1, 3) * p1x + pow(t1, 2) * 3 * t * c1x + t1 * 3 * t * t * c2x + pow(t, 3) * p2x,
	    y: pow(t1, 3) * p1y + pow(t1, 2) * 3 * t * c1y + t1 * 3 * t * t * c2y + pow(t, 3) * p2y
	  };
	};
	var curveDim = function (p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y) {
	  var a = c2x - 2 * c1x + p1x - (p2x - 2 * c2x + c1x),
	      b = 2 * (c1x - p1x) - 2 * (c2x - c1x),
	      c = p1x - c1x,
	      t1 = (-b + sqrt(b * b - 4 * a * c)) / 2 / a,
	      t2 = (-b - sqrt(b * b - 4 * a * c)) / 2 / a,
	      y = [p1y, p2y],
	      x = [p1x, p2x],
	      dot = void 0;
	  if (abs(t1) > "1e12") {
	    t1 = 0.5;
	  }
	  if (abs(t2) > "1e12") {
	    t2 = 0.5;
	  }
	  if (t1 > 0 && t1 < 1) {
	    dot = findDotAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t1);
	    x.push(dot.x);
	    y.push(dot.y);
	  }
	  if (t2 > 0 && t2 < 1) {
	    dot = findDotAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t2);
	    x.push(dot.x);
	    y.push(dot.y);
	  }
	  a = c2y - 2 * c1y + p1y - (p2y - 2 * c2y + c1y);
	  b = 2 * (c1y - p1y) - 2 * (c2y - c1y);
	  c = p1y - c1y;
	  t1 = (-b + sqrt(b * b - 4 * a * c)) / 2 / a;
	  t2 = (-b - sqrt(b * b - 4 * a * c)) / 2 / a;
	  if (abs(t1) > "1e12") {
	    //[TODO]
	    t1 = 0.5;
	  }
	  if (abs(t2) > "1e12") {
	    t2 = 0.5;
	  }
	  if (t1 > 0 && t1 < 1) {
	    dot = findDotAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t1);
	    x.push(dot.x);
	    y.push(dot.y);
	  }
	  if (t2 > 0 && t2 < 1) {
	    dot = findDotAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t2);
	    x.push(dot.x);
	    y.push(dot.y);
	  }
	  return new Bounds(mmin.apply(0, x), mmin.apply(0, y), mmax.apply(0, x), mmax.apply(0, y));
	};
	
	var bezierBounds = exports.bezierBounds = function (P0, P1, P2, P3) {
	  return curveDim(P0.x, P0.y, P1.x, P1.y, P2.x, P2.y, P3.x, P3.y);
	};
	
	var segmentBounds = exports.segmentBounds = function (P0, P1) {
	  var P0_x = P0.x,
	      P0_y = P0.y,
	      P1_x = P1.x,
	      P1_y = P1.y;
	  return new Bounds(P0_x < P1_x ? P0_x : P1_x, P0_y < P1_y ? P0_y : P1_y, P0_x > P1_x ? P0_x : P1_x, P0_y > P1_y ? P0_y : P1_y);
	};
	
	// [TODO] Remove this abstraction
	var BoundsBuilder = exports.BoundsBuilder = function () {};
	BoundsBuilder.prototype = {
	  update: function (b) {
	    var this_b = this.b;
	    if (!this.b) {
	      this_b = this.b = b.clone();
	    }
	    if (this_b.lx > b.lx) {
	      this_b.lx = b.lx;
	    }
	    if (this_b.ly > b.ly) {
	      this_b.ly = b.ly;
	    }
	    if (this_b.hx < b.hx) {
	      this_b.hx = b.hx;
	    }
	    if (this_b.hy < b.hy) {
	      this_b.hy = b.hy;
	    }
	  },
	  updateWithPoint: function (p) {
	    var this_b = this.b,
	        p_x = p.x,
	        p_y = p.y;
	    if (!this_b) {
	      this_b = this.b = new Bounds(p_x, p_y, p_x, p_y);
	    }
	    if (this_b.lx > p.x) {
	      this_b.lx = p.x;
	    }
	    if (this_b.ly > p.y) {
	      this_b.ly = p.y;
	    }
	    if (this_b.hx < p.x) {
	      this_b.hx = p.x;
	    }
	    if (this_b.hy < p.y) {
	      this_b.hy = p.y;
	    }
	  },
	
	  get bounds() {
	    return this.b;
	  }
	};
	
	Bounds.fromXmlAttr = function (node, tag, def) {
	  var valueString = node.getAttribute(tag);
	  if (valueString) {
	    return Bounds.fromXmlString(valueString);
	  }
	  return def;
	};
	
	_util.Xml.Parser['Bounds'] = {
	  decode: function (node, tag, v) {
	    return Bounds.fromXmlAttr(node, tag, v);
	  },
	  encode: function (node, tag, v) {
	    v.setXmlAttr(node, tag);
	  }
	};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Frame = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _point = __webpack_require__(22);
	
	var _bounds = __webpack_require__(24);
	
	var _util = __webpack_require__(17);
	
	var Point_distance = _point.Point.distance,
	    Point_distance2 = _point.Point.distance2,
	    Point_orientedSide = _point.Point.orientedSide,
	    Point_isLeft = _point.Point.isLeft,
	    Point_isRight = _point.Point.isRight,
	    Point_doSegmentsIntersect = _point.Point.doSegmentsIntersect,
	    _Math_min = Math.min,
	    _Math_max = Math.max; // exports Frame, default: Frame
	
	function toPoint(p) {
	  return new _point.Point(p.x, p.y);
	}
	
	var Frame = exports.Frame = function (p0, p1, p2, p3) {
	  var _this = this;
	  if (!(_this instanceof Frame)) {
	    return new Frame(p0, p1, p2, p3);
	  }
	  if (p1 === undefined) {
	    var frame = p0;
	    if (frame) {
	      _this.p0 = toPoint(frame.p0);
	      _this.p1 = toPoint(frame.p1);
	      _this.p2 = toPoint(frame.p2);
	      _this.p3 = toPoint(frame.p3);
	    } else {
	      _this.p0 = new _point.Point(0, 0);
	      _this.p1 = new _point.Point(0, 0);
	      _this.p2 = new _point.Point(0, 0);
	      _this.p3 = new _point.Point(0, 0);
	    }
	  } else {
	    _this.p0 = toPoint(p0);
	    _this.p1 = toPoint(p1);
	    _this.p2 = toPoint(p2);
	    _this.p3 = toPoint(p3);
	  }
	};
	_gear.Base.Type['Frame'] = Frame;
	
	exports.default = Frame;
	
	
	Frame.fromRect = function (x, y, width, height) {
	  return new Frame({ p0: { x: x, y: y },
	    p1: { x: x + width, y: y },
	    p2: { x: x + width, y: y + height },
	    p3: { x: x, y: y + height } });
	};
	
	var _toFixed = function (v) {
	  return +v.toFixed(4);
	};
	var _pointToFixed = function (p) {
	  return _toFixed(p.x) + ' ' + _toFixed(p.y);
	};
	
	var frame_textualize = function () {
	  var _this = this,
	      sep = ' ';
	  return _pointToFixed(_this.p0) + sep + _pointToFixed(_this.p1) + sep + _pointToFixed(_this.p2) + sep + _pointToFixed(_this.p3);
	};
	
	var frameFromBounds = Frame.fromBounds = function (bounds) {
	  return new Frame({ p0: { x: bounds.lx, y: bounds.ly }, p1: { x: bounds.hx, y: bounds.ly }, p2: { x: bounds.hx, y: bounds.hy }, p3: { x: bounds.lx, y: bounds.hy } });
	};
	Frame.around = function (center, width, height) {
	  return frameFromBounds(_bounds.Bounds.around(center, width, height));
	};
	
	Frame.ofPoints = function (points) {
	  return frameFromBounds(_bounds.Bounds.ofPoints(points));
	};
	
	Frame.prototype = {
	  constructor: Frame,
	  type: 'Frame',
	
	  get bounds() {
	    var _this = this,
	        p0 = _this.p0,
	        p1 = _this.p1,
	        p2 = _this.p2,
	        p3 = _this.p3;
	    return new _bounds.Bounds(_Math_min(p0.x, p1.x, p2.x, p3.x), // lx
	    _Math_min(p0.y, p1.y, p2.y, p3.y), // ly
	    _Math_max(p0.x, p1.x, p2.x, p3.x), // hx
	    _Math_max(p0.y, p1.y, p2.y, p3.y)); // hy
	  },
	  get width() {
	    return Point_distance(this.p0, this.p1);
	  },
	  get height() {
	    return Point_distance(this.p0, this.p3);
	  },
	
	  get width2() {
	    return Point_distance2(this.p0, this.p1);
	  },
	  get height2() {
	    return Point_distance2(this.p0, this.p3);
	  },
	
	  get center() {
	    return this.interpolate(0.5, 0.5);
	  },
	
	  get dir_x() {
	    return this.p1.minus(this.p0).normalize();
	  },
	
	  get dir_y() {
	    return this.p3.minus(this.p0).normalize();
	  },
	
	  clone: function () {
	    return new Frame(this);
	  },
	  isEqual: function (other) {
	    return this.p0.isEqual(other.p0) && this.p1.isEqual(other.p1) && this.p2.isEqual(other.p2) && this.p3.isEqual(other.p3);
	  },
	  isNear: function (other, eps) {
	    return this.p0.isNear(other.p0, eps) && this.p1.isNear(other.p1, eps) && this.p2.isNear(other.p2, eps) && this.p3.isNear(other.p3, eps);
	  },
	  translate: function (dx, dy) {
	    if (dy === undefined) {
	      var o = dx;dx = o.x;dy = o.y;
	    }
	    var _this = this;
	    _this.p0.x += dx;_this.p0.y += dy;
	    _this.p1.x += dx;_this.p1.y += dy;
	    _this.p2.x += dx;_this.p2.y += dy;
	    _this.p3.x += dx;_this.p3.y += dy;
	    return this;
	  },
	  translated: function (dx, dy) {
	    return this.clone().translate(dx, dy);
	  },
	  transform: function (t) {
	    this.p0.transform(t);
	    this.p1.transform(t);
	    this.p2.transform(t);
	    this.p3.transform(t);
	    return this;
	  },
	  transformed: function (t) {
	    return this.clone().transform(t);
	  },
	  changed: function (t) {
	    return new Frame({ p0: t(this.p0), p1: t(this.p1), p2: t(this.p2), p3: t(this.p3) });
	  },
	  interpolate: function (ax, ay) {
	    if (ay === undefined) {
	      var r = ax;ax = r.x;ay = r.y;
	    }
	    var p01 = this.p0.scaled(1 - ax).plus(this.p1.scaled(ax)),
	        p32 = this.p3.scaled(1 - ax).plus(this.p2.scaled(ax));
	
	    return p01.scaled(1 - ay).plus(p32.scaled(ay));
	  },
	  deinterpolate: function () /*point*/{
	    return this.center; // [TODO]
	  },
	
	  toXmlString: frame_textualize,
	  textualize: frame_textualize,
	  // Contains returns true iff the query point is inside the frame. If the
	  // query point is on an edge or vertex of the frame, it is considered to
	  // be inside.
	  // TODO: this function always return true when the four frame vertices
	  // and the query point are aligned. This should be corrected, although in
	  // practice this case never happens.
	  contains: function (p) {
	    var _this = this;
	    switch (Point_orientedSide(_this.p0, _this.p1, p)) {
	      case 1:
	        // left turn
	        return !(Point_isRight(_this.p1, _this.p2, p) || Point_isRight(_this.p2, _this.p3, p) || Point_isRight(_this.p3, _this.p0, p));
	      case -1:
	        // right turn
	        return !(Point_isLeft(_this.p1, _this.p2, p) || Point_isLeft(_this.p2, _this.p3, p) || Point_isLeft(_this.p3, _this.p0, p));
	      default:
	        // are aligned (or there is an error)
	        return !(Point_isRight(_this.p1, _this.p2, p) || Point_isRight(_this.p2, _this.p3, p) || Point_isRight(_this.p3, _this.p0, p)) || !(Point_isLeft(_this.p1, _this.p2, p) || Point_isLeft(_this.p2, _this.p3, p) || Point_isLeft(_this.p3, _this.p0, p));
	    };
	  },
	  extend: function (olx, oly, ohx, ohy) {
	    // [TODO] This could take into account the rotation
	    var _this = this,
	        p0 = _this.p0,
	        p1 = _this.p1,
	        p2 = _this.p2,
	        p3 = _this.p3,
	        p01 = p1.minus(p0).normalize(),
	        p12 = p2.minus(p1).normalize(),
	        p23 = p3.minus(p2).normalize(),
	        p30 = p0.minus(p3).normalize();
	
	    p0.substract(p01.scaled(olx));
	    p0.add(p30.scaled(oly));
	    p1.add(p01.scaled(ohx));
	    p1.substract(p12.scaled(oly));
	    p2.substract(p23.scaled(ohx));
	    p2.add(p12.scaled(ohy));
	    p3.add(p23.scaled(olx));
	    p3.substract(p30.scaled(ohy));
	    return _this;
	  },
	  extended: function (olx, oly, ohx, ohy) {
	    return this.clone().extend(olx, oly, ohx, ohy);
	  },
	  angle: function () {
	    return this.p1.minus(this.p0).angle();
	  },
	  draw: function (context, transform) {
	    context.beginPath();
	    (0, _gear.moveTo)(context, this.p0, transform);
	    (0, _gear.lineTo)(context, this.p1, transform);
	    (0, _gear.lineTo)(context, this.p2, transform);
	    (0, _gear.lineTo)(context, this.p3, transform);
	    context.closePath();
	  },
	  setXmlAttr: function (node, tag) {
	    node.setAttribute(tag, this.toXmlString());
	  }
	};
	
	Frame.translate = function (frame, tx, ty) {
	  return frame.clone().translate(tx, ty);
	};
	
	Frame.transform = function (frame, t) {
	  return frame.clone().transform(t);
	};
	
	Frame.fromXmlString = function (s) {
	  var values = (0, _lodash.map)(s.split(' '), parseFloat);
	  return new Frame({
	    p0: new _point.Point(values[0], values[1]),
	    p1: new _point.Point(values[2], values[3]),
	    p2: new _point.Point(values[4], values[5]),
	    p3: new _point.Point(values[6], values[7])
	  });
	};
	
	var _segmentIntersectsFrameEdges = function (p0, p1, frame) {
	  return Point_doSegmentsIntersect(p0, p1, frame.p0, frame.p1) || Point_doSegmentsIntersect(p0, p1, frame.p1, frame.p2) || Point_doSegmentsIntersect(p0, p1, frame.p2, frame.p3) || Point_doSegmentsIntersect(p0, p1, frame.p3, frame.p0);
	};
	
	var _oneCornerOfFrameInsideAnotherFrame = function (fa, fb) {
	  return fb.contains(fa.p0) || fb.contains(fa.p1) || fb.contains(fa.p2) || fb.contains(fa.p3);
	};
	
	Frame.areOverlapping = function (fa, fb) {
	  //
	  // Bounds-based rejection
	  //
	  var bfa = fa.bounds;
	  var bfb = fb.bounds;
	
	  if (bfa.lx > bfb.hx || bfb.lx > bfa.hx || bfa.ly > bfb.hy || bfb.ly > bfa.hy) {
	    return false;
	  }
	  //
	  // One corner inside or edges of fa against each edge of fb
	  //
	  if (_oneCornerOfFrameInsideAnotherFrame(fa, fb) || _oneCornerOfFrameInsideAnotherFrame(fb, fa) || _segmentIntersectsFrameEdges(fa.p0, fa.p1, fb) || _segmentIntersectsFrameEdges(fa.p1, fa.p2, fb) || _segmentIntersectsFrameEdges(fa.p2, fa.p3, fb) || _segmentIntersectsFrameEdges(fa.p3, fa.p0, fb)) {
	    return true;
	  }
	  return false;
	};
	
	Frame.overlapPercentage = function (fa, fb) {
	  // For now, we are just computing intersection of the bounding boxes.
	  // It will be nice to have an algorithm to compute the real intersection of frames.
	  var ba = fa.bounds;
	  var bb = fb.bounds;
	  return _bounds.Bounds.overlapPercentage(ba, bb);
	};
	
	Frame.fromXmlAttr = function (node, tag, defaultValue) {
	  var valueString = node.getAttribute(tag);
	  if (valueString) {
	    return Frame.fromXmlString(valueString);
	  }
	  return defaultValue;
	};
	
	_util.Xml.Parser['Frame'] = {
	  decode: function (node, tag, v) {
	    return Frame.fromXmlAttr(node, tag, v);
	  },
	  encode: function (node, tag, v) {
	    v.setXmlAttr(node, tag);
	  }
	};

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CurveArcLenCursor = exports.LazyBoundary = exports.Polyline = exports.Curve = exports.Quadratic = exports.Segment = exports.LinealPos = exports.Boundary = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _point = __webpack_require__(22);
	
	var _bounds = __webpack_require__(24);
	
	var _bezier = __webpack_require__(27);
	
	var _util = __webpack_require__(17);
	
	// [TODO] Bring segmentBounds here
	// exports Boundary, Curve, Polyline, Segment, Quadratic, Cubic
	
	var Point_crossProductZ = _point.Point.crossProductZ,
	    Point_dotProduct = _point.Point.dotProduct;
	
	var Boundary = exports.Boundary = _gear.OwnedObject.extend({ typeName: 'Boundary' });
	
	Boundary.fromXml = function (node, tag) {
	  return _util.Xml.getObject(node, this, tag || 'Curve');
	};
	Boundary.parseXml = function (node) {
	  return new LazyBoundary(node).decode();
	};
	
	Boundary.arrayFromXml = function (parentNode, tag) {
	  return (0, _lodash.map)(_util.Xml.children(parentNode, tag), Boundary.parseXml);
	};
	
	// From SCIS_Figures\lineal_pos.cs
	
	var LinealPos = exports.LinealPos = function (arcLen, point, pieceIdx) {
	  this.arcLen = arcLen;
	  this.point = point;
	  this.pieceIdx = pieceIdx;
	};
	
	// Segment
	//--------------------------------------------------------------------------------
	
	var Segment = exports.Segment = function (P0, P1) {
	  this.P0 = P0;
	  this.P1 = P1;
	};
	Segment.prototype = {
	  constructor: Segment,
	  type: 'Segment',
	  clone: function () {
	    return new Segment(this.P0.clone(), this.P1.clone());
	  },
	  isEqual: function (other) {
	    return other instanceof Segment && this.P0.isEqual(other.P0) && this.P1.isEqual(other.P1);
	  },
	  last: function (v) {
	    return v === undefined ? this.P1 : (this.P1 = v, this);
	  },
	
	  get bounds() {
	    return (0, _bounds.segmentBounds)(this.P0, this.P1);
	  },
	  boundsAfter: function (t) {
	    return (0, _bounds.segmentBounds)(t.apply(this.P0), t.apply(this.P1));
	  },
	  transform: function (op) {
	    this.P0.transform(op);
	    this.P1.transform(op);
	  },
	  chainedTransform: function (op) {
	    this.P1.transform(op);
	  },
	  chainedDraw: function (context, transform) {
	    var tP1 = transform ? transform.apply(this.P1) : this.P1;
	    context.lineTo(tP1.x, tP1.y);
	  },
	  chainedToSVG: function () {
	    return " L" + this.P1.toSVG();
	  },
	  chainedToXmlString: function () {
	    return this.P0.toXmlString();
	  },
	  chainedPoints: function (points) {
	    points.push(this.P0);
	  },
	  toXmlString: function () {
	    return this.P0.toXmlString() + ',' + this.P1.toXmlString();
	  },
	  toCubic: function () {
	    return _bezier.Cubic.fromSegment(this.P0.clone(), this.P1.clone());
	  },
	  draw: function (context, transform) {
	    var tP0 = transform ? transform.apply(this.P0) : this.P0;
	    context.moveTo(tP0.x, tP0.y);
	    this.chainedDraw(context, transform);
	  },
	  eval: function (t) {
	    return _point.Point.FromPolygon(t, this.P0, this.P1);
	  },
	  split: function (u) {
	    var PC = _point.Point.sm(this.P0, 1 - u).add(_point.Point.sm(this.P1, u));
	    return {
	      left: new Segment(this.P0.clone(), PC),
	      right: new Segment(PC.clone(), this.P1.clone())
	    };
	  },
	  isFlatEnough2: function () /*threshold2*/{
	    return true;
	  },
	  arcLength: function () {
	    return _point.Point.distance(this.P0, this.P1);
	  },
	  dir: function () {
	    var arcLen = this.arcLength();
	    var dir = this.P1.minus(this.P0);
	    if (arcLen > 0) {
	      dir.sm(1 / arcLen);
	    }
	    return dir;
	  },
	
	
	  // The regular parameter (Time) of a straight line segment is its linear interpolation
	  // parameter U=aL/Length.
	  arcLenToTime: function (x) {
	    var arcLen = this.arcLength();
	    return arcLen > 0 ? x / arcLen : 0;
	  },
	  at: function (x) {
	    return this.eval(this.arcLenToTime(x));
	  },
	  extendedAt: function (x) {
	    return this.eval(this.arcLenToTime(x));
	  },
	  tangentAt: function () /*x*/{
	    return this.dir();
	  },
	  pApprox: function () {
	    var P0 = this.P0,
	        P1 = this.P1;
	    var arcLen = this.arcLength();
	    return {
	      points: [P0, P1],
	      u: [0, 1],
	      l: [0, arcLen],
	      arcLen: arcLen
	    };
	  },
	  reversed: function () {
	    return new Segment(this.P1.clone(), this.P0.clone());
	  },
	  polygonize: function () /*flatness, minPoints*/{
	    return [this.P0.clone(), this.P1.clone()];
	  }
	};
	
	// Quadratic
	//--------------------------------------------------------------------------------
	
	var Quadratic = exports.Quadratic = function (P0, P1, P2) {
	  this.P0 = P0;
	  this.P1 = P1;
	  this.P2 = P2;
	};
	Quadratic.prototype = {
	  constructor: Quadratic,
	  type: 'Quadratic',
	  clone: function () {
	    return new Quadratic(this.P0.clone(), this.P1.clone(), this.P2.clone());
	  },
	  isEqual: function (other) {
	    return other instanceof Quadratic, this.P0.isEqual(other.P0), this.P1.isEqual(other.P1), this.P2.isEqual(other.P2);
	  },
	  last: function (v) {
	    return v === undefined ? this.P2 : (this.P2 = v, this);
	  },
	  chainedTransform: function (op) {
	    this.P1.transform(op);
	    this.P2.transform(op);
	  },
	  chainedDraw: function (context, transform) {
	    var tP1 = transform ? transform.apply(this.P1) : this.P1,
	        tP2 = transform ? transform.apply(this.P2) : this.P2;
	    context.quadraticCurveTo(tP1.x, tP1.y, tP2.x, tP2.y);
	  },
	  chainedToSVG: function () {
	    return " Q" + this.P1.toSVG() + " " + this.P2.toSVG();
	  },
	  chainedToXmlString: function () {
	    return this.P0.toXmlString() + ',' + this.P1.toXmlString();
	  },
	  chainedPoints: function (points) {
	    points.push(this.P0);
	    points.push(this.P1);
	  },
	  toXmlString: function () {
	    return this.chainedToXmlString() + ',' + this.P2.toXmlString();
	  },
	  draw: function (context, transform) {
	    var tP0 = transform ? transform.apply(this.P0) : this.P0;
	    context.moveTo(tP0.x, tP0.y);
	    this.chainedDraw(context, transform);
	  },
	  reversed: function () {
	    return new Quadratic(this.P2.clone(), this.P1.clone(), this.P0.clone());
	  },
	
	
	  get bounds() {
	    var p0 = this.P0;
	    var lv12 = this.P1.clone();
	    lv12 = lv12.scalarMultiply(2);
	    var p1 = _point.Point.add(this.P0, lv12).scalarMultiply(1.0 / 3.0);
	    var p2 = _point.Point.add(this.P2, lv12).scalarMultiply(1.0 / 3.0);
	    var p3 = this.P2;
	
	    return (0, _bounds.bezierBounds)(p0, p1, p2, p3);
	  },
	
	  boundsAfter: function (t) {
	
	    var p0 = this.P0;
	    var lv12 = this.P1.clone();
	    lv12 = lv12.scalarMultiply(2);
	    var p1 = _point.Point.add(this.P0, lv12).scalarMultiply(1.0 / 3.0);
	    var p2 = _point.Point.add(this.P2, lv12).scalarMultiply(1.0 / 3.0);
	    var p3 = this.P2;
	
	    return (0, _bounds.bezierBounds)(t.apply(p0), t.apply(p1), t.apply(p2), t.apply(p3));
	  }
	};
	
	// Cubic
	//----------------------------------------------------------------------------------------------
	// Defined in Bezier.js
	
	// Curve
	//----------------------------------------------------------------------------------------------
	
	var Curve = exports.Curve = Boundary.extend({ typeName: 'Curve',
	  init: function (pieces, closed) {
	    this.pieces = pieces;
	    this.closed = closed;
	  },
	  clone: function () {
	    var copiedPieces = [];
	    var pieces = this.pieces;
	    copiedPieces[0] = pieces[0].clone();
	    for (var i = 1; i < pieces.length; ++i) {
	      copiedPieces[i] = pieces[i].clone();
	      copiedPieces[i].P0 = copiedPieces[i - 1].last();
	    }
	    if (this.closed) {
	      copiedPieces[0].P0 = copiedPieces[pieces.length - 1].last();
	    }
	    return new Curve(copiedPieces, this.closed);
	  },
	  transform: function (op) {
	    var pieces = this.pieces;
	    if (!this.closed) {
	      pieces[0].P0.transform(op);
	    }
	    //_.forEach(pieces,function(p) {
	    for (var k = 0, kEnd = pieces.length; k < kEnd; ++k) {
	      var p = pieces[k];
	      p.chainedTransform(op);
	    } //);
	    return this;
	  },
	  transformed: function (op) {
	    return this.clone().transform(op);
	  },
	
	
	  // unrolled performant version
	  get bounds() {
	    // return Bounds.ofThings(this.pieces);
	
	    var pieces = this.pieces;
	    var count = pieces.length;
	    if (count === 0) {
	      return null;
	    }
	
	    var b = pieces[0].bounds;
	    if (count === 1) {
	      return b;
	    }
	
	    var lx = b.lx,
	        ly = b.ly,
	        hx = b.hx,
	        hy = b.hy;
	    for (var k = 1; k < count; ++k) {
	      var p = pieces[k];
	      if (p.P2) {
	        // quadratic and cubic beziers pieces
	        b = p.bounds;
	        if (lx > b.lx) {
	          lx = b.lx;
	        }
	        if (hx < b.hx) {
	          hx = b.hx;
	        }
	        if (ly > b.ly) {
	          ly = b.ly;
	        }
	        if (hy < b.hy) {
	          hy = b.hy;
	        }
	      } else {
	        // segment piece
	        var P1 = p.P1;
	        var P1x = P1.x,
	            P1y = P1.y;
	        if (lx > P1x) {
	          lx = P1x;
	        } else if (hx < P1x) {
	          hx = P1x;
	        }
	        if (ly > P1y) {
	          ly = P1y;
	        } else if (hy < P1y) {
	          hy = P1y;
	        }
	      }
	    }
	    return new _bounds.Bounds(lx, ly, hx, hy);
	  },
	  boundsAfter: function (t) {
	    // return Bounds.ofThingsAfter(this.pieces,t);
	
	    var pieces = this.pieces;
	    var count = pieces.length;
	    if (count === 0) {
	      return null;
	    }
	    var b = pieces[0].boundsAfter(t);
	    if (count === 1) {
	      return b;
	    }
	
	    var lx = b.lx,
	        ly = b.ly,
	        hx = b.hx,
	        hy = b.hy;
	    for (var k = 1; k < count; ++k) {
	      var p = pieces[k];
	      if (p.P2) {
	        // quadratic and cubic beziers pieces
	        b = p.boundsAfter(t);
	        if (lx > b.lx) {
	          lx = b.lx;
	        }
	        if (hx < b.hx) {
	          hx = b.hx;
	        }
	        if (ly > b.ly) {
	          ly = b.ly;
	        }
	        if (hy < b.hy) {
	          hy = b.hy;
	        }
	      } else {
	        // segment piece
	
	        // [Inline:Matrix.apply]
	        // (tP1x,tP1y) = t.apply(p.P1);
	        var P1 = p.P1;
	        var P1x = P1.x,
	            P1y = P1.y;
	        var tP1x = P1x * t.s00 + P1y * t.s01 + t.dx;
	        var tP1y = P1x * t.s10 + P1y * t.s11 + t.dy;
	
	        if (lx > tP1x) {
	          lx = tP1x;
	        } else if (hx < tP1x) {
	          hx = tP1x;
	        }
	        if (ly > tP1y) {
	          ly = tP1y;
	        } else if (hy < tP1y) {
	          hy = tP1y;
	        }
	      }
	    }
	    return new _bounds.Bounds(lx, ly, hx, hy);
	  },
	  draw: function (context, transform) {
	    var pieces = this.pieces;
	    var p0 = transform ? transform.apply(pieces[0].P0) : pieces[0].P0;
	    context.moveTo(p0.x, p0.y);
	    //_.forEach(pieces,function(p) {
	    for (var k = 0, kEnd = pieces.length; k < kEnd; ++k) {
	      var p = pieces[k];
	      p.chainedDraw(context, transform);
	    } //);
	    if (this.closed) {
	      context.closePath();
	    }
	  },
	  toSVG: function () {
	    var pieces = this.pieces;
	    var svgCurve = 'M' + pieces[0].P0.toSVG();
	    //_.forEach(this.pieces,function(p) {
	    for (var k = 0, kEnd = pieces.length; k < kEnd; ++k) {
	      var p = pieces[k];
	      svgCurve += p.chainedToSVG();
	    } //);
	    if (this.closed) {
	      svgCurve += 'Z';
	    }
	    return svgCurve;
	  },
	  getFirstPoint: function () {
	    return this.pieces[0].P0;
	  },
	  buildXml: function (node, tag) {
	    _util.Xml.addObject(node, this, tag || 'Curve');
	  },
	  setupXml: function (node) {
	    if (!this.closed) {
	      _util.Xml.setBoolAttr(node, 'IsClosed', this.closed);
	    }
	    var xmlCurve = '';
	    var lmo = this.pieces.length - 1;
	    for (var k = 0; k < lmo; k++) {
	      xmlCurve += this.pieces[k].chainedToXmlString() + '|';
	    }
	    if (this.closed) {
	      // In closed curves, the last point is equal to the first one
	      xmlCurve += this.pieces[lmo].chainedToXmlString();
	    } else {
	      // In open curves, we need the last point
	      xmlCurve += this.pieces[lmo].toXmlString();
	    }
	    node.setAttribute('Points', xmlCurve);
	    node.setAttribute('Type', 'Bezier3');
	  },
	  asPieces: function () {
	    return this.pieces;
	  },
	  controlPoints: function () {
	    var pieces = this.pieces;
	    // Returns a polygon with all the control points
	    // return _.map(pieces,function(p) { p.chainedPoints(hull); });
	    var hull = [];
	    for (var k = 0, kEnd = pieces.length; k < kEnd; ++k) {
	      var p = pieces[k];
	      p.chainedPoints(hull);
	    }
	    return hull;
	  },
	  tieExtremePoints: function () {
	    for (var i = 1; i < this.pieces.length; i++) {
	      this.pieces[i - 1].last(this.pieces[i].P0);
	    }
	    if (this.closed) {
	      this.pieces[this.pieces.length - 1].last(this.pieces[0].P0);
	    }
	  },
	  isEqual: function (other) {
	    return other instanceof Curve && this.closed === other.closed && (0, _gear.areEqual)(this.pieces, other.pieces);
	  },
	  splitPiece: function (pi, t) {
	    var p = this.pieces[pi];
	    var np = p.split(t);
	    this.pieces.splice(pi, 1, np.left, np.right);
	    this.tieExtremePoints();
	  },
	  arcLength: function () {
	    var len = 0;
	    var pieces = this.pieces;
	    for (var k = 0, kEnd = pieces.length; k < kEnd; ++k) {
	      len += pieces[k].arcLength();
	    }
	    return len;
	  },
	  polygonRep: function () {
	    var points = [];
	    var pieces = this.pieces;
	    for (var k = 0, kEnd = pieces.length; k < kEnd; ++k) {
	      var pApproxPoints = pieces[k].pApprox().points;
	      var nEnd = pApproxPoints.length - (k === kEnd - 1 ? 0 : 1);
	      for (var n = 0; n < nEnd; ++n) {
	        points.push(pApproxPoints[n]);
	      }
	    }
	    return points;
	  },
	  polygonize: function (flatness, minPoints) {
	    var points = [];
	    var pieces = this.pieces;
	    for (var k = 0, kEnd = pieces.length; k < kEnd; ++k) {
	      var piecePoints = pieces[k].polygonize(flatness, minPoints);
	      var nEnd = piecePoints.length - (k === kEnd - 1 ? 0 : 1);
	      for (var n = 0; n < nEnd; ++n) {
	        points.push(piecePoints[n]);
	      }
	    }
	    return points;
	  },
	  segmentIntersectionPos: function (from, to) {
	    var pieces = this.pieces;
	    var minDist = Number.MAX_VALUE;
	    var minPos = null;
	    var toFrom = to.minus(from);
	    var segmentNorm = toFrom.norm();
	    var dir = _point.Point.sm(toFrom, 1 / segmentNorm);
	    var dirP = dir.perpendicular();
	
	    var arcLen = 0;
	
	    // We can handle segments more efficiently here, it is not that much needed
	    // for FitOnPath so we can leave it for later
	
	    // We could also reject pieces based on their bounds. For the time being,
	    // this is already quite fast
	
	    for (var k = 0, kEnd = pieces.length; k < kEnd; ++k) {
	      var piece = pieces[k];
	      var pApprox = piece.pApprox();
	      var pApproxPoints = pApprox.points;
	
	      for (var i = 0, iEnd = pApproxPoints.length - 1; i < iEnd; ++i) {
	        var as = pApproxPoints[i],
	            at = pApproxPoints[i + 1];
	        var bs = from,
	            bt = to;
	
	        var adir = at.minus(as),
	            bdir = bt.minus(bs),
	            det = Point_crossProductZ(adir, bdir);
	        if (det !== 0) {
	          var d = bs.minus(as),
	              deta = Point_crossProductZ(d, bdir),
	              detb = Point_crossProductZ(d, adir),
	              ttb = detb / det;
	
	          if (ttb >= 0 && ttb <= 1) {
	
	            var tta = deta / det;
	            var tta_0 = tta >= 0,
	                tta_1 = tta <= 1;
	
	            if (tta_0 && tta_1) {
	              // Found intersection... done...
	              // console.log('Intersection '+tta);
	
	              return new LinealPos(arcLen + (pApprox.l[i] * (1 - tta) + pApprox.l[i + 1] * tta), _point.Point.interpolate(as, at, tta), k);
	            }
	
	            var pk = null;
	            if (!tta_0 && tta > -0.2) {
	              // console.log('Almost << '+tta);
	              pk = as;
	            } else if (!tta_1 && tta < 1.2) {
	              // console.log('Almost >> '+tta);
	              pk = at;
	            }
	
	            if (pk) {
	              // Best distance from point to segment
	              var distance = Math.abs(Point_dotProduct(d, dirP));
	              if (distance < minDist) {
	                minDist = distance;
	                minPos = new LinealPos(arcLen + pApprox.l[i + (!tta_0 ? 1 : 0)], pk, k);
	              }
	            }
	          }
	        }
	      }
	
	      arcLen += pApprox.arcLen;
	    }
	
	    return minPos;
	  },
	  reversed: function () {
	    var pieces = this.pieces;
	    var reversedPieces = [];
	    for (var k = pieces.length - 1; k >= 0; --k) {
	      reversedPieces.push(pieces[k].reversed());
	    }
	    return Curve.fromNonTiedPieces(reversedPieces, this.closed);
	  },
	
	  // Return CW or CCW
	  orientation: function () {
	    return computeOrientation(this.controlPoints());
	  }
	});
	
	Curve.fromXmlString = function (curveString, closed) {
	
	  var piecesString = curveString.split("|");
	
	  // const rawPieces = _.map(piecesString,_pointArrayFromXmlString);
	  var rawPieces = [];
	  for (var k = 0, kEnd = piecesString.length; k < kEnd; ++k) {
	    var piece = piecesString[k];
	    rawPieces.push(_pointArrayFromXmlString(piece));
	  }
	
	  // Pieces share the extreme points, handle with care
	
	  var pieces = [];
	  var lastPieceIndex = rawPieces.length - 1;
	  for (var i = 0, iEnd = rawPieces.length; i < iEnd; ++i) {
	
	    var lastPoint = i === lastPieceIndex ? closed ? rawPieces[0][0] : rawPieces[lastPieceIndex][rawPieces[lastPieceIndex].length - 1] : rawPieces[i + 1][0];
	    var currentRawPiece = rawPieces[i];
	
	    if (i != lastPieceIndex || closed) currentRawPiece.push(lastPoint);
	
	    var pieceType = currentRawPiece.length;
	
	    switch (pieceType) {
	      case 2:
	        pieces.push(new Segment(currentRawPiece[0], currentRawPiece[1]));
	        break;
	      case 3:
	        pieces.push(new Quadratic(currentRawPiece[0], currentRawPiece[1], currentRawPiece[2]));
	        break;
	      case 4:
	        pieces.push(new _bezier.Cubic(currentRawPiece[0], currentRawPiece[1], currentRawPiece[2], currentRawPiece[3]));
	        break;
	      default:
	        // This should never happen, but if we have data corruption lets just draw a segment
	        // to at least show something and avoid breaking the app
	
	        // Ignore the piece
	        break;
	    }
	  }
	
	  return new Curve(pieces, closed);
	}, Curve.fromNonTiedPieces = function (pieces, closed) {
	  if (closed && pieces.length > 0) {
	    var P0 = pieces[0].P0;
	    var PE = (0, _lodash.last)(pieces).last();
	    if (!P0.isNear(PE)) {
	      pieces.push(new Segment(PE, P0));
	    }
	  }
	  var curve = new Curve(pieces, closed);
	  curve.tieExtremePoints();
	  return curve;
	};
	
	// Polyline
	//---------------------------------------------------------------------------
	
	var _pointArrayFromXmlString = function (s) {
	  var sepPoints = s.split(',');
	  return (0, _lodash.map)(sepPoints, _point.Point.fromXmlString);
	};
	
	var _pointArrayToXmlString = function (pa) {
	  var vals = (0, _lodash.map)(pa, function (v) {
	    return v.toXmlString();
	  });
	  return vals.join(',');
	};
	
	var Polyline = exports.Polyline = Boundary.extend({ typeName: 'Polyline',
	  init: function (points, closed) {
	    this.points = points;
	    this.closed = closed;
	  },
	  clone: function () {
	    return new Polyline((0, _gear.cloneDeep)(this.points), this.closed);
	  },
	  transform: function (op) {
	    var points = this.points;
	    // invokeMap(points,'transform',op);
	    for (var k = 0, kEnd = points.length; k < kEnd; ++k) {
	      points[k].transform(op);
	    }
	    return this;
	  },
	  transformed: function (op) {
	    return this.clone().transform(op);
	  },
	
	  get bounds() {
	    return _bounds.Bounds.ofPoints(this.points);
	  },
	  boundsAfter: function (transform) {
	    return _bounds.Bounds.ofPointsAfter(this.points, transform);
	  },
	  draw: function (context, transform) {
	    var points = this.points;
	    var length = points.length;
	    var tp0 = transform.apply(points[0]);
	    context.moveTo(tp0.x, tp0.y);
	    for (var i = 1; i < length; ++i) {
	      var tp = transform.apply(points[i]);
	      context.lineTo(tp.x, tp.y);
	    }
	    if (this.closed) {
	      context.closePath();
	    }
	  },
	  toSVG: function () {
	    var points = this.points;
	    var length = points.length;
	
	    var svgCurve = 'M' + points[0].toSVG();
	    for (var i = 1; i < length; ++i) {
	      svgCurve += 'L' + points[i].toSVG();
	    }
	    if (this.closed) {
	      svgCurve += 'Z';
	    }
	    return svgCurve;
	  },
	  getFirstPoint: function () {
	    return this.points[0];
	  },
	  buildXml: function (node, tag) {
	    _util.Xml.addObject(node, this, tag || 'Curve');
	  },
	  setupXml: function (node) {
	    if (!this.closed) {
	      _util.Xml.setBoolAttr(node, 'IsClosed', this.closed);
	    }
	    var xmlCurve = _pointArrayToXmlString(this.points);
	    node.setAttribute('Points', xmlCurve);
	    node.setAttribute('Type', 'Polyline');
	  },
	  asPieces: function () {
	    var pieces = [];
	    for (var k = 1; k < this.points.length; ++k) {
	      pieces.push(new Segment(this.points[k - 1], this.points[k]));
	    }
	    if (this.closed) {
	      pieces.push(new Segment(this.points[this.points.length - 1], this.points[0]));
	    }
	    return pieces;
	  },
	  convertToCurve: function () {
	    var pieces = [];
	    for (var k = 1; k < this.points.length; ++k) {
	      pieces.push(new Segment(this.points[k - 1].clone(), this.points[k].clone()));
	    }
	    if (this.closed) {
	      pieces.push(new Segment(this.points[this.points.length - 1].clone(), this.points[0].clone()));
	    }
	    return Curve.fromNonTiedPieces(pieces, this.closed);
	  },
	  controlPoints: function () {
	    return this.points.slice(0);
	  },
	  isEqual: function (other) {
	    return other instanceof Polyline && this.closed === other.closed && (0, _gear.areEqual)(this.points, other.points);
	  },
	  range: function () {
	    return new IndexRange(0, this.points.length - 1, this.closed);
	  },
	  arcLength: function () {
	    var points = this.points;
	    var length = points.length;
	
	    var len = 0;
	    for (var k = 1; k < length; ++k) {
	      len += _point.Point.distance(points[k], points[k - 1]);
	    }
	    return len;
	  },
	  polygonRep: function () {
	    return this.points;
	  },
	
	  // Return 'CW' or 'CCW'
	  orientation: function () {
	    return computeOrientation(this.points);
	  }
	});
	
	Polyline.fromXmlString = function (pointsString, closed) {
	  var points = _pointArrayFromXmlString(pointsString);
	  return new Polyline(points, closed);
	};
	
	// LazyBoundary
	//----------------------------------------------------------------------------------
	
	var LazyBoundary = exports.LazyBoundary = _gear.OwnedObject.extend({ typeName: 'LazyBoundary',
	  init: function (node) {
	    this._points = node.getAttribute('Points');
	    this._isClosed = _util.Xml.getBoolAttr(node, 'IsClosed', true);
	    this._type = node.getAttribute('Type') || 'Bezier3';
	  },
	
	  lazy: true,
	  clone: function () {
	    return this;
	  },
	  decode: function () {
	    if (this._type === 'Polyline') {
	      return Polyline.fromXmlString(this._points, this._isClosed);
	    } else {
	      return Curve.fromXmlString(this._points, this._isClosed);
	    }
	  },
	  setupXml: function (node) {
	    if (!this._isClosed) {
	      _util.Xml.setBoolAttr(node, 'IsClosed', this._isClosed);
	    }
	    node.setAttribute('Points', this._points);
	    node.setAttribute('Type', this._type);
	  }
	});
	
	// From SCIS_Figures\index_range.cs
	
	// enum Dir { Fwd, Bck }
	
	// Encapsulates a closed range of valid indices [first,last], probably forming a cyclic sequence.<br>
	// It provides index validation and checked methods for advancing a valid index in either direction.
	
	/// first: First valid index on the range
	/// last:  Last valid indes on the range
	/// isCyclic: Specifies whether the range forms a cyclic sequence
	var IndexRange = function (first, last, isCyclic) {
	  this.first = first;
	  this.last = last;
	  this.isCyclic = isCyclic;
	};
	IndexRange.prototype = {
	  count: function () {
	    return this.last - this.first + 1;
	  },
	
	
	  // Returns true if the index is inside the range.
	  isValid: function (idx) {
	    return idx >= this.first && idx <= this.last;
	  },
	
	
	  // Returns true if(idx-delta) is inside the range. This is always true if IsCyclic==true
	  existPrev: function (idx, delta) {
	    return this.isCyclic ? true : idx - (delta === undefined ? 1 : delta) >= this.first;
	  },
	
	
	  // Returns true if(idx+delta) is inside the range. This is always true if IsCyclic==true
	  existNext: function (idx, delta) {
	    return this.isCyclic ? true : idx + (delta === undefined ? 1 : delta) <= this.last;
	  },
	
	
	  // If idx-detla >= First, returns idx-delta; <br>
	  // Else returns Last-(delta-(idx-First))+1.<br>
	  // Precondition: IsValid(idx)<br>
	  // Postcondition: IsValid(idx-delta)<br>
	  // NOTE: If IsCyclic is false and idx==First, in Debug, this will fail the postcondition,
	  // but in Release, it will return Last as if the idx were cyclic.<br>
	  prev: function (idx, _delta) {
	    // g.assert( this.isValid(idx) );
	    var delta = _delta === undefined ? 1 : _delta,
	        first = this.first;
	    return idx - delta >= first ? idx - delta : this.isCyclic ? this.last - (delta - (idx - first)) + 1 : -1;
	  },
	
	
	  // If idx+delta &lt;= Last, returns idx+delta; <br>
	  // Else returns First+(Delta-(Last-idx))-1.<br>
	  // Precondition: IsValid(idx)<br>
	  // Postcondition: IsValid(idx+delta)<br>
	  // NOTE: If IsCyclic is false and idx==Last, in Debug, this will fail the postcondition,
	  // but in Release, it will return First as if the idx were cyclic.<br>
	  next: function (idx, _delta) {
	    // g.assert( this.isValid(idx) );
	    var delta = _delta === undefined ? 1 : _delta,
	        last = this.last;
	    return idx + delta <= last ? idx + delta : this.isCyclic ? this.first + (delta - (last - idx)) - 1 : -1;
	  },
	  distance: function (idx1, idx2) {
	    return !this.isCyclic ? Math.abs(idx2 - idx1) : idx1 <= idx2 ? idx2 - idx1 : this.last - idx1 + (idx2 - this.first) + 1;
	  }
	};
	
	// [PERFORMANCE]
	// Instead of creating new objects for the iteration, we could just modify it inplace
	var Indexed = function (value, range) {
	  this.value = value;
	  this.range = range;
	};
	Indexed.prototype = {
	  existPrev: function () {
	    return this.range.existPrev(this.value);
	  },
	  existNext: function () {
	    return this.range.existNext(this.value);
	  },
	  prev: function () {
	    var range = this.range;
	
	    return new Indexed(range.prev(this.value, 1), range);
	  },
	  next: function () {
	    var range = this.range;
	
	    return new Indexed(range.next(this.value, 1), range);
	  }
	};
	
	// From Figure\curve_boundary_arc_len_cursor.cs
	
	// Piecewise curve made of connected straight-line segments and bezier arcs (of degrees 0,1 and 3)
	
	var CurveArcLenCursor = exports.CurveArcLenCursor = function (curve) {
	  this._curve = curve;
	  this.reset();
	};
	CurveArcLenCursor.prototype = {
	  type: 'CurveArcLenCursor',
	
	  pos: function () {
	    var currL = this._currL;
	    var localL = currL - this._leftL;
	    var point = this._piece.extendedAt(localL); // [TODO]
	    return new LinealPos(currL, point, this._pieceIdx.value); // , new LinealPos(localL, point) ); Child not needed
	  },
	  tangent: function () {
	    var piece = this._piece;
	    var localL = this._currL - this._leftL;
	    if (localL < 0) {
	      localL = 0;
	    } else {
	      var pieceArcLength = piece.arcLength(); // [TODO]
	      if (localL > pieceArcLength) {
	        localL = pieceArcLength;
	      }
	    }
	    return piece.tangentAt(localL); // [TODO]
	  },
	  reset: function () {
	    var curve = this._curve;
	    var pieceIdx = this._pieceIdx = new Indexed(0, new IndexRange(0, curve.pieces.length - 1, curve.closed));
	    this._currL = 0;
	    this._leftL = 0;
	    var piece = this._piece = curve.pieces[pieceIdx.value];
	    this._rightL = piece.arcLength();
	  },
	  move: function (delta) {
	    var newL = this._currL + delta,
	        curve = this._curve;
	    var rem = 0,
	        pieceIdx = this._pieceIdx,
	        piece = void 0;
	
	    if (delta > 0) {
	      while (newL > this._rightL) {
	        if (pieceIdx.existNext()) {
	          pieceIdx = this._pieceIdx = pieceIdx.next();
	          piece = this._piece = curve.pieces[pieceIdx.value];
	          this._leftL = this._rightL;
	          this._rightL = this._leftL + piece.arcLength();
	          // console.log( this._leftL + ' ' + this._rightL );
	        } else {
	          rem = newL - this._rightL;
	          break;
	        }
	      }
	    } else {
	      while (newL < this._leftL) {
	        if (pieceIdx.existPrev()) {
	          pieceIdx = this._pieceIdx = pieceIdx.prev();
	          piece = this._piece = curve.pieces[pieceIdx.value];
	          this._rightL = this._leftL;
	          this._leftL = this._rightL - piece.arcLength();
	        } else {
	          rem = this._leftL - newL;
	          break;
	        }
	      }
	    }
	
	    this._currL = newL;
	    return rem;
	  }
	};
	
	Boundary.createRectangle = function () {
	  var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  var center = void 0,
	      width = void 0,
	      height = void 0;
	  if (config.bounds || config instanceof _bounds.Bounds) {
	    var bounds = config.bounds || config;
	    center = bounds.center;
	    width = bounds.width;
	    height = bounds.height;
	  } else {
	    center = config.center || new _point.Point(0, 0);
	    width = config.width;height = config.height;
	    if (width === undefined) {
	      width = height;
	    }
	    if (height === undefined) {
	      height = width;
	    }
	  }
	  var p0 = _point.Point.add(center, new _point.Point(-width / 2, -height / 2)),
	      p1 = _point.Point.add(center, new _point.Point(width / 2, -height / 2)),
	      p2 = _point.Point.add(center, new _point.Point(width / 2, height / 2)),
	      p3 = _point.Point.add(center, new _point.Point(-width / 2, height / 2));
	  var curve = new Curve([new Segment(p0, p1), new Segment(p1, p2), new Segment(p2, p3), new Segment(p3, p0)], true);
	  return curve;
	};
	
	Boundary.createEllipse = function () {
	  var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  var center = void 0,
	      width = void 0,
	      height = void 0;
	  if (config.bounds || config instanceof _bounds.Bounds) {
	    var bounds = config.bounds || config;
	    center = bounds.center;
	    width = bounds.width;
	    height = bounds.height;
	  } else {
	    center = config.center || new _point.Point(0, 0);
	    width = config.width;height = config.height;
	    if (width === undefined) {
	      width = height;
	    }
	    if (height === undefined) {
	      height = width;
	    }
	  }
	
	  var s = 0.5522911793037017;
	
	  var p0 = _point.Point.add(center, new _point.Point(-width / 2, 0));
	  var q01 = _point.Point.add(center, new _point.Point(-width / 2, -height / 2 * s));
	  var q02 = _point.Point.add(center, new _point.Point(-width / 2 * s, -height / 2));
	
	  var p1 = _point.Point.add(center, new _point.Point(0, -height / 2));
	  var q11 = _point.Point.add(center, new _point.Point(width / 2 * s, -height / 2));
	  var q12 = _point.Point.add(center, new _point.Point(width / 2, -height / 2 * s));
	
	  var p2 = _point.Point.add(center, new _point.Point(width / 2, 0));
	  var q21 = _point.Point.add(center, new _point.Point(width / 2, height / 2 * s));
	  var q22 = _point.Point.add(center, new _point.Point(width / 2 * s, height / 2));
	
	  var p3 = _point.Point.add(center, new _point.Point(0, height / 2));
	  var q31 = _point.Point.add(center, new _point.Point(-width / 2 * s, height / 2));
	  var q32 = _point.Point.add(center, new _point.Point(-width / 2, height / 2 * s));
	
	  var curve = new Curve([new _bezier.Cubic(p0, q01, q02, p1), new _bezier.Cubic(p1, q11, q12, p2), new _bezier.Cubic(p2, q21, q22, p3), new _bezier.Cubic(p3, q31, q32, p0)], true);
	  return curve;
	};
	
	function computeOrientation(points) {
	  var a = 0;
	  for (var k = 0, kEnd = points.length - 1; k < kEnd; ++k) {
	    var p1 = points[k],
	        p2 = points[k + 1];
	    a += (p2.x - p1.x) * (p2.y + p1.y);
	  }
	  return a < 0 ? 'CCW' : 'CW';
	}

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Cubic = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _point = __webpack_require__(22);
	
	var _curve = __webpack_require__(26);
	
	var _bounds = __webpack_require__(24);
	
	// [TODO] Bring bezierBounds here
	
	
	// From SCIS_Figures\bezier_utils.cs
	
	var BezierVectors = function (a, b, c, d, e, f) {
	  var _this = this;
	  _this.a = a;
	  _this.b = b;
	  _this.c = c;
	  _this.d = d;
	  _this.e = e;
	  _this.f = f;
	};
	BezierVectors.prototype = {
	  constructor: BezierVectors,
	  eval: function (u) {
	    var a = this.a,
	        b = this.b,
	        c = this.c,
	        d = this.d;
	    return new _point.Point(((a.x * u + b.x) * u + c.x) * u + d.x, ((a.y * u + b.y) * u + c.y) * u + d.y);
	  },
	  evalTangent: function (u) {
	    var _1u = 1 - u,
	        u2 = u * u,
	        u_1u = u * _1u,
	        _1u2 = _1u * _1u,
	        c = this.c,
	        e = this.e,
	        f = this.f;
	    return new _point.Point(c.x * _1u2 + e.x * u_1u + f.x * u2, c.y * _1u2 + e.y * u_1u + f.y * u2);
	  }
	};
	
	// For the moment, we do not autogenerate bounds, midPoint and squaredHeight
	var BezierCache = function (vectors, startingTangent, endingTangent, pApprox) {
	  this.vectors = vectors;
	  this.startingTangent = startingTangent;
	  this.endingTangent = endingTangent;
	  this.pApprox = pApprox;
	};
	
	var BezierPolygonalApproximation = function (points, l, u, arcLen) {
	  this.points = points;
	  this.l = l;
	  this.u = u;
	  this.arcLen = arcLen;
	};
	
	BezierPolygonalApproximation.prototype = {
	  clone: function () {
	    return new BezierPolygonalApproximation((0, _lodash.cloneDeep)(this.points), (0, _lodash.cloneDeep)(this.l), (0, _lodash.cloneDeep)(this.u), this.arcLen);
	  }
	};
	
	// Generates a polyline approximation of the bezier curve aBez.
	// points contains the polyline vertices.
	// l contains the arc-len of each vertex.
	// Returns the length of the approximating polyline, which represents
	// the approximated length of the bezier curve.
	
	var ApproximatingPolyBuilder = function (piece, flatness, minPoints, useControlPointsForFlatnessTest) {
	  this.f2 = flatness * flatness;
	  var r = this.result = new BezierPolygonalApproximation([], [], [], 0);
	  r.points.push(piece.P0.clone());
	  r.l.push(0);
	  r.u.push(0);
	  this.build(piece, 0, 1, 2 * (minPoints - 1), useControlPointsForFlatnessTest);
	};
	ApproximatingPolyBuilder.prototype = {
	  constructor: ApproximatingPolyBuilder,
	  // Recursion of the function that generates a polyline approximation of the bezier curve aBez.
	  // aL is the accumulated length of the left recursion branch (used to carry the result)
	  // [aU0,aU1] is the interval of polynomial parameters representing the current subcurve.
	  build: function (piece, u0, u1, fmp, useControlPointsForFlatnessTest) {
	    if (fmp > 2 || u1 - u0 > 1e-4 && !piece.isFlatEnough2(this.f2, useControlPointsForFlatnessTest)) {
	      var mu = (u0 + u1) / 2;
	      var ps = piece.split(0.5);
	      this.build(ps.left, u0, mu, fmp / 2, useControlPointsForFlatnessTest);
	      this.build(ps.right, mu, u1, fmp / 2, useControlPointsForFlatnessTest);
	    } else {
	      var result = this.result,
	          piece_last = piece.last();
	      result.points.push(piece_last);
	      var arcLen = _point.Point.distance(piece.P0, piece_last);
	      result.arcLen += arcLen;
	      result.l.push(result.arcLen);
	      result.u.push(u1);
	    }
	  }
	};
	
	var BezierPolygonalApproximation_generateForInternalRepresentation = function (piece) {
	  var builder = new ApproximatingPolyBuilder(piece, 0.01, 2, true);
	  return builder.result;
	};
	
	// Direct polygonizer, just get the points, do not save arc len metrics
	var BezierPolygonizer = function (piece, flatness, minPoints) {
	  this.f2 = flatness * flatness;
	  this.polygon = [piece.P0.clone()];
	  this.build(piece, 0, 1, 2 * (minPoints - 1));
	};
	BezierPolygonizer.prototype = {
	  constructor: BezierPolygonizer,
	  build: function (piece, u0, u1, fmp) {
	    if (fmp > 2 || u1 - u0 > 1e-4 && !piece.isFlatEnough2(this.f2)) {
	      var uh = (u0 + u1) / 2;
	      var pieces = piece.split(0.5);
	      this.build(pieces.left, u0, uh, fmp / 2);
	      this.build(pieces.right, uh, u1, fmp / 2);
	    } else {
	      this.polygon.push(piece.last());
	    }
	  }
	};
	
	var binarySearchLowerBound = function (a, value) {
	  var floor = Math.floor;
	
	  var lo = 0,
	      hi = a.length - 1,
	      mid = void 0;
	  while (lo <= hi) {
	    mid = floor((lo + hi) / 2);
	    if (a[mid] > value) {
	      hi = mid - 1;
	    } else if (a[mid] < value) {
	      lo = mid + 1;
	    } else {
	      return mid;
	    }
	  }
	  return lo;
	};
	
	// Cubic
	//------------------------------------------------------------------------------------
	
	var Cubic = exports.Cubic = function (P0, P1, P2, P3) {
	  this.P0 = P0;
	  this.P1 = P1;
	  this.P2 = P2;
	  this.P3 = P3;
	  this._c = null; // Cache
	};
	Cubic.prototype = {
	  constructor: Cubic,
	  type: 'Cubic',
	
	  clone: function () {
	    return new Cubic(this.P0.clone(), this.P1.clone(), this.P2.clone(), this.P3.clone());
	  },
	  isEqual: function (other) {
	    return other instanceof Cubic && this.P0.isEqual(other.P0) && this.P1.isEqual(other.P1) && this.P2.isEqual(other.P2) && this.P3.isEqual(other.P3);
	  },
	  last: function (v) {
	    return v === undefined ? this.P3 : (this.P3 = v, this);
	  },
	
	
	  get bounds() {
	    return (0, _bounds.bezierBounds)(this.P0, this.P1, this.P2, this.P3);
	  },
	
	  boundsAfter: function (t) {
	    return (0, _bounds.bezierBounds)(t.apply(this.P0), t.apply(this.P1), t.apply(this.P2), t.apply(this.P3));
	  },
	  chainedTransform: function (op) {
	    this.P1.transform(op);
	    this.P2.transform(op);
	    this.P3.transform(op);
	    this._c = null;
	  },
	  chainedDraw: function (context, transform) {
	    var tP1 = transform ? transform.apply(this.P1) : this.P1,
	        tP2 = transform ? transform.apply(this.P2) : this.P2,
	        tP3 = transform ? transform.apply(this.P3) : this.P3;
	    context.bezierCurveTo(tP1.x, tP1.y, tP2.x, tP2.y, tP3.x, tP3.y);
	  },
	  chainedToSVG: function () {
	    return " C" + this.P1.toSVG() + " " + this.P2.toSVG() + " " + this.P3.toSVG();
	  },
	  chainedToXmlString: function () {
	    return this.P0.toXmlString() + ',' + this.P1.toXmlString() + ',' + this.P2.toXmlString();
	  },
	  chainedPoints: function (points) {
	    points.push(this.P0);
	    points.push(this.P1);
	    points.push(this.P2);
	  },
	  toXmlString: function () {
	    return this.chainedToXmlString() + ',' + this.P3.toXmlString();
	  },
	  draw: function (context, transform) {
	    var tP0 = transform ? transform.apply(this.P0) : this.P0;
	    context.moveTo(tP0.x, tP0.y);
	    this.chainedDraw(context, transform);
	  },
	  eval: function (t) {
	    return _point.Point.FromBezier(t, this.P0, this.P1, this.P2, this.P3);
	  },
	  split: function (u) {
	    var mu = 1 - u;
	
	    var P01 = _point.Point.sm(this.P0, mu).add(_point.Point.sm(this.P1, u));
	    var P12 = _point.Point.sm(this.P1, mu).add(_point.Point.sm(this.P2, u));
	    var P23 = _point.Point.sm(this.P2, mu).add(_point.Point.sm(this.P3, u));
	
	    var P012 = _point.Point.sm(P01, mu).add(_point.Point.sm(P12, u));
	    var P123 = _point.Point.sm(P12, mu).add(_point.Point.sm(P23, u));
	
	    var PC = _point.Point.sm(P012, mu).add(_point.Point.sm(P123, u));
	
	    return {
	      left: new Cubic(this.P0.clone(), P01, P012, PC),
	      right: new Cubic(PC.clone(), P123, P23, this.P3.clone())
	    };
	  },
	  isFlatEnough2: function (threshold2) {
	    var e1 = this.P1.distanceToLine2(this.P0, this.P3);
	    var e2 = this.P2.distanceToLine2(this.P0, this.P3);
	    return (e1 > e2 ? e1 : e2) < threshold2;
	  },
	
	
	  // This functions triggers caching
	
	  arcLenToTime: function (x) {
	    var arcLen = this.arcLength();
	
	    if (arcLen >= 1e-15) {
	      if (x <= 0 || x >= arcLen) {
	        return x / arcLen;
	      } else {
	        // Report issue: https://github.com/Stahls/cadx/blob/master/SCIS_Figures/cubic_bezier_piece.cs#L301
	        var pApprox = this.pApprox();
	        var l = pApprox.l,
	            u = pApprox.u;
	        var idx = binarySearchLowerBound(l, x);
	
	        var l_idx_1 = l[idx - 1],
	            l_idx = l[idx];
	        if (idx < l.length && l_idx_1 < x && x <= l_idx && l_idx_1 < l_idx) {
	          var ratio = (x - l_idx_1) / (l_idx - l_idx_1);
	          return u[idx] * ratio + u[idx - 1] * (1 - ratio);
	        } else {
	          return x / arcLen;
	        }
	      }
	    }
	    return 0;
	  },
	  at: function (x) {
	    return this.vectors().eval(this.arcLenToTime(x));
	  },
	  extendedAt: function (x) {
	    // [TODO] Remove dependency to Segment
	    if (x <= 0) {
	      return new _curve.Segment(this.P0, this.P1).extendedAt(x);
	    } else {
	      var arcLen = this.arcLength();
	      if (x >= arcLen) {
	        return new _curve.Segment(this.P3, _point.Point.add(this.P3, this.P3.minus(this.P2))).extendedAt(x - arcLen);
	      } else {
	        return this.at(x);
	      }
	    }
	  },
	  tangentAt: function (x) {
	    return this.vectors().evalTangent(this.arcLenToTime(x));
	  },
	  vectors: function () {
	    if (!this._c) {
	      this.createCache();
	    }
	    return this._c.vectors;
	  },
	  arcLength: function () {
	    if (!this._c) {
	      this.createCache();
	    }
	    return this._c.pApprox.arcLen;
	  },
	  pApprox: function () {
	    if (!this._c) {
	      this.createCache();
	    }
	    return this._c.pApprox;
	  },
	  polygonize: function (flatness, minPoints) {
	    return new BezierPolygonizer(this, flatness, minPoints).polygon;
	  },
	  createCache: function () {
	    var P0 = this.P0,
	        P1 = this.P1,
	        P2 = this.P2,
	        P3 = this.P3;
	    var f = P3.minus(P2).sm(3);
	    var e = P2.minus(P1).sm(6);
	    var d = P0.clone();
	    var c = P1.minus(P0).sm(3);
	    var b = P2.minus(P1).sm(3).substract(c);
	    var a = P3.minus(P0).substract(c).substract(b);
	
	    var vectors = new BezierVectors(a, b, c, d, e, f);
	
	    var startingTangent = vectors.evalTangent(0);
	    var endingTangent = vectors.evalTangent(1);
	
	    var pApprox = BezierPolygonalApproximation_generateForInternalRepresentation(this);
	
	    this._c = new BezierCache(vectors, startingTangent, endingTangent, pApprox);
	  },
	  reversed: function () {
	    return new Cubic(this.P3.clone(), this.P2.clone(), this.P1.clone(), this.P0.clone());
	  }
	};
	
	Cubic.fromSegment = function (P0, P3) {
	  var P1 = _point.Point.sm(_point.Point.sm(P0, 2).plus(P3), 1 / 3);
	  var P2 = _point.Point.sm(P0.plus(_point.Point.sm(P3, 2)), 1 / 3);
	  return new Cubic(P0, P1, P2, P3);
	};
	
	//CP0 = QP0
	//CP3 = QP2
	//CP1 = QP0 + 2/3 *(QP1-QP0)
	//CP2 = QP2 + 2/3 *(QP1-QP2)
	Cubic.fromQuadraticPoints = function (P0, P12, P3) {
	  var P12_2 = _point.Point.sm(P12, 2);
	  var P1 = P0.plus(P12_2).sm(1 / 3);
	  var P2 = P12_2.plus(P3).sm(1 / 3);
	  return new Cubic(P0, P1, P2, P3);
	};

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.curvesFromSvgPath = exports.svgPathStringToArray = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _point = __webpack_require__(22);
	
	var _matrix = __webpack_require__(23);
	
	var _bezier = __webpack_require__(27);
	
	var _curve = __webpack_require__(26);
	
	// exports curvesFromSvgPath
	
	var valuesStringToArray = function (data) {
	  var rp = data.split(/[\s,]+/);
	  var values = [];
	  for (var k = 0; k < rp.length; k++) {
	    var rpk = rp[k];
	    var c = '',
	        dot = false;
	    for (var n = 0; n < rpk.length; n++) {
	      if (n > 0 && rpk[n] === '-' && rpk[n - 1] !== 'e') {
	        values.push(parseFloat(c));
	        c = '';
	        dot = false;
	      }
	      if (rpk[n] === 'e') {
	        dot = false;
	      }
	      if (rpk[n] === '.') {
	        if (dot) {
	          values.push(parseFloat(c));
	          c = '';
	          dot = false;
	        } else {
	          dot = true;
	        }
	      }
	      c += rpk[n];
	    }
	    if (c !== '') {
	      values.push(parseFloat(c));
	    }
	  }
	  return values;
	};
	
	var svgPathStringToArray = exports.svgPathStringToArray = function (s) {
	  var mode = null,
	      path = [],
	      data = '',
	      r = void 0;
	  for (var i = 0; i < s.length; ++i) {
	    switch (s[i]) {
	      case 'Z':case 'z':case 'M':case 'm':case 'L':case 'l':case 'c':case 'C':case 'q':case 'Q':
	      case 'V':case 'v':case 'H':case 'h':case 's':case 'S':
	        if (mode) {
	          r = valuesStringToArray(data);
	          path.push([mode].concat(r));
	        }
	        mode = s[i];
	        data = '';
	        break;
	
	      default:
	        data += s[i];
	    }
	  }
	  if (mode) {
	    r = valuesStringToArray(data);
	    path.push([mode].concat(r));
	  }
	  return path;
	};
	
	var svgCommandToArray = function (c) {
	  var sub = [];
	  var cmd = c.type || c.pathSegTypeAsLetter;
	  switch (cmd) {
	    case "C":
	    case "c":
	      sub.unshift(c.y2);sub.unshift(c.x2);
	    case "Q":
	    case "q":
	      sub.unshift(c.y1);sub.unshift(c.x1);
	    case "M":
	    case "m":
	    case "L":
	    case "l":
	      sub.push(c.x);sub.push(c.y);
	      break;
	    case "A":
	    case "a":
	      sub.push(c.r1);sub.push(c.r2);
	      sub.push(c.angle);
	      sub.push(c.largeArcFlag);
	      sub.push(c.sweepFlag);
	      sub.push(c.x);sub.push(c.y);
	      break;
	    case "H":
	    case "h":
	      sub.push(c.x);
	      break;
	    case "V":
	    case "v":
	      sub.push(c.y);
	      break;
	    case "S":
	    case "s":
	      sub.push(c.x2);sub.push(c.y2);
	      sub.push(c.x);sub.push(c.y);
	      break;
	    case "T":
	    case "t":
	      sub.push(c.x);sub.push(c.y);
	      break;
	  }
	  sub.unshift(cmd);
	  return sub;
	};
	
	// PathDataQuadraticBezierCommands
	// http://www.w3.org/TR/SVGTiny12/paths.html#PathDataQuadraticBezierCommands
	
	// [ [ 'M', 20, 30 ], [ 'L', 50, 40 ], ['Z'] ]
	
	var curvesFromSvgPath = exports.curvesFromSvgPath = function (s, config) {
	
	  if ((0, _lodash.isString)(s)) {
	    s = svgPathStringToArray(s);
	  }
	
	  // We should invert this, convert the array based rep to { type: 'M', x: ... , y: ... }
	  if (!(0, _lodash.isArray)(s[0])) {
	    s = (0, _lodash.map)(s, svgCommandToArray);
	  }
	
	  // Used by font decoding, looks like there is a bug in opentype.js that spits open curves
	  // We play safe and force this open curves to be closed in FontData
	  var closedCurve = true;
	  //const openCurve   = ( config && config.forceClosed ) ? true : false;
	
	  var pieces = null;
	  var curves = [];
	
	  // All the paths starts with a M command
	
	  var lp = new _point.Point(0, 0),
	      cp = lp,
	      lc = lp;
	
	  for (var d = 0; d < s.length; ++d) {
	    var command = s[d];
	    var mode = command[0];
	
	    var relative = void 0,
	        m = void 0;
	
	    var noParse = mode === 'v' || mode === 'V' || mode === 'H' || mode === 'h' || mode === 'A' || mode === 'a' || mode === 'z' || mode === 'Z';
	    var points = [];
	    if (!noParse) {
	      for (var i = 1; i < command.length; i += 2) {
	        points.push(new _point.Point(command[i], command[i + 1]));
	      }
	    }
	    var p0 = void 0,
	        p1 = void 0,
	        p2 = void 0;
	
	    switch (mode) {
	
	      // closepath
	      case 'Z':case 'z':
	        if (pieces && pieces.length > 0) {
	          curves.push(_curve.Curve.fromNonTiedPieces(pieces, closedCurve));
	        }
	        pieces = null;
	        break;
	
	      // moveto
	      case 'M':case 'm':
	        relative = mode === 'm';
	        if (pieces && pieces.length > 0) {
	          curves.push(_curve.Curve.fromNonTiedPieces(pieces, closedCurve));
	        }
	        pieces = [];
	
	        p0 = points[0];
	        if (relative) {
	          p0.add(cp);
	        }
	        lp = p0;
	
	        for (m = 1; m < points.length; ++m) {
	          // lineTo commands
	          p0 = points[m];
	          if (relative) {
	            p0.add(cp);
	          }
	          pieces.push(new _curve.Segment(lp, p0));
	          lp = p0;
	        }
	        cp = lc = lp;
	        break;
	
	      // lineto
	      case 'L':case 'l':
	        relative = mode === 'l';
	
	        for (m = 0; m < points.length; ++m) {
	          // lineTo commands
	          p0 = points[m];
	          if (relative) {
	            p0.add(cp);
	          }
	          pieces.push(new _curve.Segment(lp, p0));
	          lp = p0;
	        }
	        cp = lc = lp;
	        break;
	
	      // horizontal lineto
	      case 'H':case 'h':
	        relative = mode === 'h';
	        for (m = 1; m < command.length; ++m) {
	          var x = command[m];
	          p0 = cp.clone();
	          if (relative) {
	            p0.x += x;
	          } else {
	            p0.x = x;
	          }
	          pieces.push(new _curve.Segment(lp, p0));
	          lp = p0;
	        }
	        cp = lc = lp;
	        break;
	
	      // vertical lineto
	      case 'V':case 'v':
	        relative = mode === 'v';
	        for (m = 1; m < command.length; ++m) {
	          var y = command[m];
	          p0 = cp.clone();
	          if (relative) {
	            p0.y += y;
	          } else {
	            p0.y = y;
	          }
	          pieces.push(new _curve.Segment(lp, p0));
	          lp = p0;
	        }
	        cp = lc = lp;
	        break;
	
	      // curveto
	      case 'C':case 'c':
	        relative = mode === 'c';
	        for (m = 0; m < points.length; m += 3) {
	          p0 = points[m + 0];if (relative) {
	            p0.add(cp);
	          }
	          p1 = points[m + 1];if (relative) {
	            p1.add(cp);
	          }
	          p2 = points[m + 2];if (relative) {
	            p2.add(cp);
	          }
	          pieces.push(new _bezier.Cubic(lp, p0, p1, p2));
	          lc = p1;
	          lp = p2;
	        }
	        cp = lp;
	        break;
	
	      // shorthand/smooth curveto
	      case 'S':case 's':
	        relative = mode === 's';
	        for (m = 0; m < points.length; m += 2) {
	          p0 = new _point.Point(2 * lp.x - lc.x, 2 * lp.y - lc.y);
	          p1 = points[m + 0];if (relative) {
	            p1.add(cp);
	          }
	          p2 = points[m + 1];if (relative) {
	            p2.add(cp);
	          }
	          pieces.push(new _bezier.Cubic(lp, p0, p1, p2));
	          lc = p1;
	          lp = p2;
	        }
	        cp = lp;
	        break;
	
	      // quadratic Bézier curveto Q q
	      case 'Q':case 'q':
	        relative = mode === 'q';
	        for (m = 0; m < points.length; m += 2) {
	          p0 = points[m + 0];if (relative) {
	            p0.add(cp);
	          }
	          p1 = points[m + 1];if (relative) {
	            p1.add(cp);
	          }
	          pieces.push(_bezier.Cubic.fromQuadraticPoints(lp, p0, p1));
	          lc = p0;
	          lp = p1;
	        }
	        cp = lp;
	        break;
	
	      // Shorthand/smooth quadratic Bézier curveto T t
	      case 'T':case 't':
	        relative = mode === 't';
	        for (m = 0; m < points.length; m += 1) {
	          p0 = new _point.Point(2 * lp.x - lc.x, 2 * lp.y - lc.y);
	          p1 = points[m + 0];if (relative) {
	            p1.add(cp);
	          }
	          pieces.push(_bezier.Cubic.fromQuadraticPoints(lp, p0, p1));
	          lc = p0;
	          lp = p1;
	        }
	        cp = lp;
	        break;
	
	      /*
	      * SVG arc representation uses "endpoint parameterisation" where we specify the endpoint of the arc.
	      * This is to be consistent with the other path commands.  However we need to convert this to "centre point
	      * parameterisation" in order to calculate the arc. Handily, the SVG spec provides all the required maths
	      * in section "F.6 Elliptical arc implementation notes".
	      *
	      * Some of this code has been borrowed from the Batik library (Apache-2 license).
	      * https://code.google.com/p/androidsvg/source/browse/src/com/caverock/androidsvg/SVGAndroidRenderer.java#2451
	      */
	      case 'A':case 'a':
	        relative = mode === 'a';
	        for (m = 0; m < command.length; m += 8) {
	          var lastX = lp.x,
	              lastY = lp.y;
	
	          if (relative) {
	            lastX -= cp.x;
	            lastY -= cp.y;
	          }
	
	          var rx = command[m + 1];
	          var ry = command[m + 2];
	
	          var angle = command[m + 3];
	          var largeArcFlag = command[m + 4];
	          var sweepFlag = command[m + 5];
	          var _x = command[m + 6];
	          var _y = command[m + 7];
	
	          if (lastX === _x && lastY === _y) {
	            // If the endpoints (x, y) and (x0, y0) are identical, then this
	            // is equivalent to omitting the elliptical arc segment entirely.
	            // (behaviour specified by the spec)
	            break;
	          }
	
	          // Handle degenerate case (behaviour specified by the spec)
	          if (rx === 0 || ry === 0) {
	            p0 = new _point.Point(lastX, lastY);
	            if (relative) {
	              p0.add(cp);
	            }
	            pieces.push(new _curve.Segment(lp, p0));
	            return;
	          }
	
	          // Sign of the radii is ignored (behaviour specified by the spec)
	          rx = Math.abs(rx);
	          ry = Math.abs(ry);
	
	          // Convert angle from degrees to radians
	          var angleRad = (0, _gear.deg2rad)(angle % 360.0);
	          var cosAngle = Math.cos(angleRad);
	          var sinAngle = Math.sin(angleRad);
	
	          // We simplify the calculations by transforming the arc so that the origin is at the
	          // midpoint calculated above followed by a rotation to line up the coordinate axes
	          // with the axes of the ellipse.
	
	          // Compute the midpoint of the line between the current and the end point
	          var dx2 = (lastX - _x) / 2.0;
	          var dy2 = (lastY - _y) / 2.0;
	
	          // Step 1 : Compute (x1', y1') - the transformed start point
	          var x1 = cosAngle * dx2 + sinAngle * dy2;
	          var y1 = -sinAngle * dx2 + cosAngle * dy2;
	
	          var rx_sq = rx * rx;
	          var ry_sq = ry * ry;
	
	          var x1_sq = x1 * x1;
	          var y1_sq = y1 * y1;
	
	          // Check that radii are large enough.
	          // If they are not, the spec says to scale them up so they are.
	          // This is to compensate for potential rounding errors/differences between SVG implementations.
	          var radiiCheck = x1_sq / rx_sq + y1_sq / ry_sq;
	          if (radiiCheck > 1) {
	            rx = Math.sqrt(radiiCheck) * rx;
	            ry = Math.sqrt(radiiCheck) * ry;
	            rx_sq = rx * rx;
	            ry_sq = ry * ry;
	          }
	
	          // Step 2 : Compute (cx1, cy1) - the transformed centre point
	          var sign = largeArcFlag === sweepFlag ? -1 : 1;
	
	          var sq = (rx_sq * ry_sq - rx_sq * y1_sq - ry_sq * x1_sq) / (rx_sq * y1_sq + ry_sq * x1_sq);
	          sq = sq < 0 ? 0 : sq;
	
	          var coef = sign * Math.sqrt(sq);
	          var cx1 = coef * (rx * y1 / ry);
	          var cy1 = coef * -(ry * x1 / rx);
	
	          // Step 3 : Compute (cx, cy) from (cx1, cy1)
	          var sx2 = (lastX + _x) / 2.0;
	          var sy2 = (lastY + _y) / 2.0;
	          var cx = sx2 + (cosAngle * cx1 - sinAngle * cy1);
	          var cy = sy2 + (sinAngle * cx1 + cosAngle * cy1);
	
	          // Step 4 : Compute the angleStart (angle1) and the angleExtent (dangle)
	          var ux = (x1 - cx1) / rx;
	          var uy = (y1 - cy1) / ry;
	          var vx = (-x1 - cx1) / rx;
	          var vy = (-y1 - cy1) / ry;
	
	          var p = void 0,
	              n = void 0;
	
	          // Compute the angle start
	          n = Math.sqrt(ux * ux + uy * uy);
	          p = ux; // (1 * ux) + (0 * uy)
	          sign = uy < 0 ? -1.0 : 1.0;
	          var angleStart = (0, _gear.rad2deg)(sign * Math.acos(p / n));
	
	          // Compute the angle extent
	          n = Math.sqrt((ux * ux + uy * uy) * (vx * vx + vy * vy));
	          p = ux * vx + uy * vy;
	          sign = ux * vy - uy * vx < 0 ? -1.0 : 1.0;
	          var angleExtent = (0, _gear.rad2deg)(sign * Math.acos(p / n));
	          if (!sweepFlag && angleExtent > 0) {
	            angleExtent -= 360;
	          } else if (sweepFlag && angleExtent < 0) {
	            angleExtent += 360;
	          }
	          angleExtent %= 360;
	          angleStart %= 360;
	
	          // arcPoints is an array of N pieces given by N*(3*points)
	          var arcPoints = arcToBeziers(angleStart, angleExtent);
	
	          // Calculate a transformation matrix that will move and scale these bezier points to the correct location.
	          //matrix
	          var mr = _matrix.Matrix.scale(rx, ry);
	          //rotate (angle);
	          mr = _matrix.Matrix.multiply(_matrix.Matrix.rotate(angle), mr);
	          //translate (cx, cy);
	          mr = _matrix.Matrix.multiply(_matrix.Matrix.translate(cx, cy), mr);
	
	          (0, _lodash.invokeMap)(arcPoints, 'transform', mr);
	
	          for (var k = 0, kEnd = arcPoints.length; k < kEnd; k += 3) {
	            p0 = arcPoints[k + 0];if (relative) {
	              p0.add(cp);
	            }
	            p1 = arcPoints[k + 1];if (relative) {
	              p1.add(cp);
	            }
	            p2 = arcPoints[k + 2];if (relative) {
	              p2.add(cp);
	            }
	            pieces.push(new _bezier.Cubic(lp, p0, p1, p2));
	            lp = p2;
	          }
	        }
	        cp = lp;
	        break;
	
	      default:
	        break;
	    }
	  }
	  if (pieces && pieces.length > 0) {
	    curves.push(_curve.Curve.fromNonTiedPieces(pieces, closedCurve));
	  }
	  return curves;
	};
	
	/*
	* Generate the control points and endpoints for a set of bezier curves that match
	* a circular arc starting from angle 'angleStart' and sweep the angle 'angleExtent'.
	* The circle the arc follows will be centred on (0,0) and have a radius of 1.0.
	*
	* Each bezier can cover no more than 90 degrees, so the arc will be divided evenly
	* into a maximum of four curves.
	*
	* The resulting control points will later be scaled and rotated to match the final
	* arc required.
	*
	* The returned array has the format [x0,y0, x1,y1,...] and excludes the start point
	* of the arc.
	*/
	var arcToBeziers = function (angleStart, angleExtent) {
	  var numSegments = Math.ceil(Math.abs(angleExtent) / 90.0);
	
	  angleStart = (0, _gear.deg2rad)(angleStart);
	  angleExtent = (0, _gear.deg2rad)(angleExtent);
	  var angleIncrement = angleExtent / numSegments;
	
	  // The length of each control point vector is given by the following formula.
	  var controlLength = 4.0 / 3.0 * Math.sin(angleIncrement / 2.0) / (1.0 + Math.cos(angleIncrement / 2.0));
	
	  // numSegments * 3
	  var points = [];
	
	  for (var i = 0; i < numSegments; i++) {
	    var angle = angleStart + i * angleIncrement;
	    // Calculate the control vector at this angle
	    var dx = Math.cos(angle),
	        dy = Math.sin(angle);
	    // First control point
	    points.push(new _point.Point(dx - controlLength * dy, dy + controlLength * dx));
	    // Second control point
	    angle += angleIncrement;
	    dx = Math.cos(angle);
	    dy = Math.sin(angle);
	    points.push(new _point.Point(dx + controlLength * dy, dy - controlLength * dx));
	    // Endpoint of bezier
	    points.push(new _point.Point(dx, dy));
	  }
	  return points;
	};

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colorSpace = __webpack_require__(30);
	
	Object.keys(_colorSpace).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _colorSpace[key];
	    }
	  });
	});
	
	var _color = __webpack_require__(31);
	
	Object.keys(_color).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _color[key];
	    }
	  });
	});
	
	var _brush = __webpack_require__(32);
	
	Object.keys(_brush).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _brush[key];
	    }
	  });
	});
	
	var _pen = __webpack_require__(33);
	
	Object.keys(_pen).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _pen[key];
	    }
	  });
	});
	
	var _colorMap = __webpack_require__(34);
	
	Object.keys(_colorMap).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _colorMap[key];
	    }
	  });
	});

/***/ },
/* 30 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Adapted from: https://github.com/harthur/color-convert/
	/* Copyright (c) 2011 Heather Arthur <fayearthur@gmail.com>
	
	Permission is hereby granted, free of charge, to any person obtaining
	a copy of this software and associated documentation files (the
	"Software"), to deal in the Software without restriction, including
	without limitation the rights to use, copy, modify, merge, publish,
	distribute, sublicense, and/or sell copies of the Software, and to
	permit persons to whom the Software is furnished to do so, subject to
	the following conditions:
	
	The above copyright notice and this permission notice shall be
	included in all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
	OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	*/
	
	/* MIT license */
	
	var xyz2rgb = exports.xyz2rgb = function (xyz) {
	  var x = xyz[0] / 100,
	      y = xyz[1] / 100,
	      z = xyz[2] / 100,
	      r,
	      g,
	      b;
	
	  r = x * 3.2406 + y * -1.5372 + z * -0.4986;
	  g = x * -0.9689 + y * 1.8758 + z * 0.0415;
	  b = x * 0.0557 + y * -0.2040 + z * 1.0570;
	
	  // assume sRGB
	  r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r = r * 12.92;
	
	  g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g = g * 12.92;
	
	  b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b = b * 12.92;
	
	  r = Math.min(Math.max(0, r), 1);
	  g = Math.min(Math.max(0, g), 1);
	  b = Math.min(Math.max(0, b), 1);
	
	  return [r * 255, g * 255, b * 255];
	};
	
	var xyz2lab = exports.xyz2lab = function (xyz) {
	  var x = xyz[0],
	      y = xyz[1],
	      z = xyz[2],
	      l,
	      a,
	      b;
	
	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;
	
	  x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
	  y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
	  z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
	
	  l = 116 * y - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);
	
	  return [l, a, b];
	};
	
	var lab2xyz = exports.lab2xyz = function (lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      x,
	      y,
	      z,
	      y2;
	
	  if (l <= 8) {
	    y = l * 100 / 903.3;
	    y2 = 7.787 * (y / 100) + 16 / 116;
	  } else {
	    y = 100 * Math.pow((l + 16) / 116, 3);
	    y2 = Math.pow(y / 100, 1 / 3);
	  }
	
	  x = x / 95.047 <= 0.008856 ? x = 95.047 * (a / 500 + y2 - 16 / 116) / 7.787 : 95.047 * Math.pow(a / 500 + y2, 3);
	
	  z = z / 108.883 <= 0.008859 ? z = 108.883 * (y2 - b / 200 - 16 / 116) / 7.787 : 108.883 * Math.pow(y2 - b / 200, 3);
	
	  return [x, y, z];
	};
	
	var lab2lch = exports.lab2lch = function (lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      hr,
	      h,
	      c;
	
	  hr = Math.atan2(b, a);
	  h = hr * 360 / 2 / Math.PI;
	  if (h < 0) {
	    h += 360;
	  }
	  c = Math.sqrt(a * a + b * b);
	  return [l, c, h];
	};
	
	var lab2rgb = exports.lab2rgb = function (args) {
	  return xyz2rgb(lab2xyz(args));
	};
	
	var lch2lab = exports.lch2lab = function (lch) {
	  var l = lch[0],
	      c = lch[1],
	      h = lch[2],
	      a,
	      b,
	      hr;
	
	  hr = h / 360 * 2 * Math.PI;
	  a = c * Math.cos(hr);
	  b = c * Math.sin(hr);
	  return [l, a, b];
	};
	
	var lch2xyz = exports.lch2xyz = function (args) {
	  return lab2xyz(lch2lab(args));
	};
	
	var lch2rgb = exports.lch2rgb = function (args) {
	  return lab2rgb(lch2lab(args));
	};
	
	var rgb2hsl = exports.rgb2hsl = function (rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      delta = max - min,
	      h,
	      s,
	      l;
	
	  if (max === min) {
	    h = 0;
	  } else if (r === max) {
	    h = (g - b) / delta;
	  } else if (g === max) {
	    h = 2 + (b - r) / delta;
	  } else if (b === max) {
	    h = 4 + (r - g) / delta;
	  }
	
	  h = Math.min(h * 60, 360);
	
	  if (h < 0) {
	    h += 360;
	  }
	
	  l = (min + max) / 2;
	
	  if (max === min) {
	    s = 0;
	  } else if (l <= 0.5) {
	    s = delta / (max + min);
	  } else {
	    s = delta / (2 - max - min);
	  }
	
	  return [h, s * 100, l * 100];
	};
	
	var rgb2cmyk = exports.rgb2cmyk = function (rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255,
	      c,
	      m,
	      y,
	      k;
	
	  k = Math.min(1 - r, 1 - g, 1 - b);
	  c = (1 - r - k) / (1 - k) || 0;
	  m = (1 - g - k) / (1 - k) || 0;
	  y = (1 - b - k) / (1 - k) || 0;
	  return [c * 100, m * 100, y * 100, k * 100];
	};
	
	var rgb2xyz = exports.rgb2xyz = function (rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255;
	
	  // assume sRGB
	  r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
	  g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
	  b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
	
	  var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
	  var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
	  var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
	
	  return [x * 100, y * 100, z * 100];
	};
	
	var rgb2lab = exports.rgb2lab = function (rgb) {
	  var xyz = rgb2xyz(rgb),
	      x = xyz[0],
	      y = xyz[1],
	      z = xyz[2],
	      l,
	      a,
	      b;
	
	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;
	
	  x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
	  y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
	  z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
	
	  l = 116 * y - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);
	
	  return [l, a, b];
	};
	
	var rgb2lch = exports.rgb2lch = function (args) {
	  return lab2lch(rgb2lab(args));
	};
	
	var hsl2rgb = exports.hsl2rgb = function (hsl) {
	  var h = hsl[0] / 360,
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      t1,
	      t2,
	      t3,
	      rgb,
	      val;
	
	  if (s === 0) {
	    val = l * 255;
	    return [val, val, val];
	  }
	
	  if (l < 0.5) {
	    t2 = l * (1 + s);
	  } else {
	    t2 = l + s - l * s;
	  }
	  t1 = 2 * l - t2;
	
	  rgb = [0, 0, 0];
	  for (var i = 0; i < 3; ++i) {
	    t3 = h + 1 / 3 * -(i - 1);
	    if (t3 < 0) {
	      ++t3;
	    }
	    if (t3 > 1) {
	      --t3;
	    }
	
	    if (6 * t3 < 1) {
	      val = t1 + (t2 - t1) * 6 * t3;
	    } else if (2 * t3 < 1) {
	      val = t2;
	    } else if (3 * t3 < 2) {
	      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
	    } else {
	      val = t1;
	    }
	
	    rgb[i] = val * 255;
	  }
	
	  return rgb;
	};
	
	var cmyk2rgb = exports.cmyk2rgb = function (cmyk) {
	  var c = cmyk[0] / 100,
	      m = cmyk[1] / 100,
	      y = cmyk[2] / 100,
	      k = cmyk[3] / 100,
	      r,
	      g,
	      b;
	
	  r = 1 - Math.min(1, c * (1 - k) + k);
	  g = 1 - Math.min(1, m * (1 - k) + k);
	  b = 1 - Math.min(1, y * (1 - k) + k);
	  return [r * 255, g * 255, b * 255];
	};
	
	var cmyk2hsl = exports.cmyk2hsl = function (args) {
	  return rgb2hsl(cmyk2rgb(args));
	};
	
	var xyz2lch = exports.xyz2lch = function (args) {
	  return lab2lch(xyz2lab(args));
	};
	
	var interpolate_lab = exports.interpolate_lab = function (ca, cb, x) {
	  var ca_0 = ca[0],
	      ca_1 = ca[1],
	      ca_2 = ca[2];
	  return [ca_0 + (cb[0] - ca_0) * x, ca_1 + (cb[1] - ca_1) * x, ca_2 + (cb[2] - ca_2) * x];
	};
	var interpolate_rgb = exports.interpolate_rgb = interpolate_lab;
	
	var interpolate_h = function (ha, hb, x) {
	  var dh = hb - ha;
	  // shortest path
	  if (dh > 180) {
	    dh -= 360;
	  } else if (dh < -180) {
	    dh += 360;
	  }
	  return ha + dh * x;
	};
	
	var interpolate_lch = exports.interpolate_lch = function (ca, cb, x) {
	  var ca_0 = ca[0],
	      ca_1 = ca[1];
	  return [ca_0 + (cb[0] - ca_0) * x, ca_1 + (cb[1] - ca_1) * x, interpolate_h(ca[2], cb[2], x)];
	};
	
	var interpolate_hsl = exports.interpolate_hsl = function (ca, cb, x) {
	  var ca_1 = ca[1],
	      ca_2 = ca[2];
	  return [interpolate_h(ca[0], cb[0], x), ca_1 + (cb[1] - ca_1) * x, ca_2 + (cb[2] - ca_2) * x];
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Color = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	var _colorSpace = __webpack_require__(30);
	
	var _componentToHex = function (c) {
	  var hex = c.toString(16).toUpperCase();
	  return hex.length === 1 ? "0" + hex : hex;
	};
	
	var _hexToInt = function (hex) {
	  return parseInt(hex, 16);
	};
	
	var _floatRepToInt = function (v) {
	  return Math.floor(v * 255);
	};
	
	var Color = exports.Color = _gear.OwnedObject.extend({ typeName: 'Color', __debugProps: true,
	  Properties: {
	    alpha: { type: 'number', def: 1.0, dropDef: true, onChange: _gear.invalidateOwner }, // 0...1.0
	    rgb: { type: 'string', def: '000000', tag: 'RGB', onChange: _gear.invalidateOwner }, // RRGGBB
	    cmyk: { type: 'string', def: null, tag: 'CMYK', dropDef: true, onChange: _gear.invalidateOwner }, // CCMMYYKK
	    lab: { type: 'string', def: null, tag: 'LAB', dropDef: true, onChange: _gear.invalidateOwner },
	    name: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    spotColorName: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    showThrough: { type: 'boolean', def: false, dropDef: true, onChange: _gear.invalidateOwner },
	    tag: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    label: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    tint: { type: 'number', def: 1.0, dropDef: true, onChange: _gear.invalidateOwner }, // 0...1.0
	    printRgb: { type: 'string', def: null, tag: 'PrintRGB', onChange: _gear.invalidateOwner }, // RRGGBB
	    colorType: { type: 'string', def: null, tag: 'ColorType', onChange: _gear.invalidateOwner }, // RGB/CMYK/CE/LAB/GRAY
	    ceRGBHigh: { type: 'string', def: null, tag: 'CERGBHigh', dropDef: true, onChange: _gear.invalidateOwner }, // RRGGBB
	    ceRGBMid: { type: 'string', def: null, tag: 'CERGBMid', dropDef: true, onChange: _gear.invalidateOwner }, // RRGGBB
	    ceRGBShad: { type: 'string', def: null, tag: 'CERGBShad', dropDef: true, onChange: _gear.invalidateOwner }, // RRGGBB
	    printCERGBHigh: { type: 'string', def: null, tag: 'PrintCERGBHigh', dropDef: true, onChange: _gear.invalidateOwner }, // RRGGBB
	    printCERGBMid: { type: 'string', def: null, tag: 'PrintCERGBMid', dropDef: true, onChange: _gear.invalidateOwner }, // RRGGBB
	    printCERGBShad: { type: 'string', def: null, tag: 'PrintCERGBShad', dropDef: true, onChange: _gear.invalidateOwner }, // RRGGBB
	    gray: { type: 'number', def: null, dropDef: true, onChange: _gear.invalidateOwner }, // 0...1.0
	    profile: { type: 'string', def: null, tag: 'Profile', dropDef: true, onChange: _gear.invalidateOwner }
	  },
	
	  init: function (config, alpha) {
	    this.callParent(config);
	    if ((0, _lodash.isString)(config)) {
	      this._rgb = config;
	      if (alpha) {
	        this._alpha = alpha;
	      }
	    }
	  },
	
	
	  // [TODO][PROPS]...
	
	  byteAlpha: function () {
	    return _floatRepToInt(this._alpha);
	  },
	  stringAlpha: function () {
	    return _componentToHex(this.byteAlpha());
	  },
	
	
	  get lch() {
	    return (0, _colorSpace.rgb2lch)(this.rgbArray);
	  },
	  //get lab() { return rgb2lab( this.rgbArray ); },
	  get xyz() {
	    return (0, _colorSpace.rgb2xyz)(this.rgbArray);
	  },
	
	  get rgba() {
	    return 'rgba(' + this.r() + ',' + this.g() + ',' + this.b() + ',' + this._alpha + ')';
	  },
	  get argb() {
	    return this.stringAlpha() + this._rgb.toUpperCase();
	  },
	  get rgbHex() {
	    return _hexToInt(this._rgb);
	  },
	
	  get rgbArray() {
	    return [this.r(), this.g(), this.b()];
	  },
	
	  red: function (v) {
	    if (v === undefined) {
	      return this.r() / 255;
	    } else {
	      return this.r(_floatRepToInt(v));
	    }
	  },
	  green: function (v) {
	    if (v === undefined) {
	      return this.g() / 255;
	    } else {
	      return this.g(_floatRepToInt(v));
	    }
	  },
	  blue: function (v) {
	    if (v === undefined) {
	      return this.b() / 255;
	    } else {
	      return this.b(_floatRepToInt(v));
	    }
	  },
	  acmyk: function () {
	    return this.stringAlpha() + this._cmyk.toUpperCase();
	  },
	  svgColor: function () {
	    return "#" + this._rgb.toUpperCase();
	  },
	  svgOpacity: function () {
	    return this._alpha;
	  },
	  rr: function () {
	    return this._rgb.substring(0, 2);
	  },
	  gg: function () {
	    return this._rgb.substring(2, 4);
	  },
	  bb: function () {
	    return this._rgb.substring(4, 6);
	  },
	  r: function (v) {
	    if (v === undefined) {
	      return _hexToInt(this.rr());
	    } else {
	      var rr = _componentToHex(v);
	      this._rgb = rr + this._rgb.substring(2, 6);
	      return this;
	    }
	  },
	  g: function (v) {
	    if (v === undefined) {
	      return _hexToInt(this.gg());
	    } else {
	      var gg = _componentToHex(v);
	      var rgb = this._rgb;
	      this._rgb = rgb.substring(0, 2) + gg + rgb.substring(4, 6);
	      return this;
	    }
	  },
	  b: function (v) {
	    if (v === undefined) {
	      return _hexToInt(this.bb());
	    } else {
	      var bb = _componentToHex(v);
	      this._rgb = this._rgb.substring(0, 4) + bb;
	      return this;
	    }
	  },
	  isEqual: function (other) {
	    return this.propertiesAreEqual(other);
	  },
	  toOldXmlString: function () {
	    return this.argb + this._name ? "-" + this._name : "";
	  },
	  textualize: function (includeTag) {
	    if (includeTag === undefined) {
	      includeTag = true;
	    }
	    var t = '';
	    var a = this.stringAlpha();
	    if (a !== 'FF') {
	      t += a + ' ';
	    }
	    if (this._rgb) {
	      t += this._rgb.toUpperCase() + ' ';
	    }
	    if (this._cmyk) {
	      t += this._cmyk.toUpperCase() + ' ';
	    }
	    if (this._lab) {
	      t += this._lab.toUpperCase() + ' ';
	    }
	    if (this._ceRGBHigh) {
	      t += this._ceRGBHigh.toUpperCase() + ' ';
	    }
	    if (this._ceRGBMid) {
	      t += this._ceRGBMid.toUpperCase() + ' ';
	    }
	    if (this._ceRGBShad) {
	      t += this._ceRGBShad.toUpperCase() + ' ';
	    }
	    if (this._profile) {
	      t += this._profile.toUpperCase() + ' ';
	    }
	    if (this._name) {
	      t += this._name;
	    }
	    if (this._spotColorName) {
	      t += this._spotColorName;
	    }
	    if (this._showThrough) {
	      t += ' ST ';
	    }
	    if (includeTag && this._tag) {
	      t += ' ' + this._tag;
	    }
	    if (this._tint) {
	      t += this._tint.toString() + ' ';
	    }
	    if (this._gray) {
	      t += this._gray.toString() + ' ';
	    }
	    return t;
	  },
	  replace: function (color, keepTag, keepLabel) {
	    this._replace(color, keepTag, keepLabel);
	    this.invalidate();
	  },
	
	
	  invalidate: _gear.invalidateOwner,
	
	  // Use this function only if you know what you are doing
	  // It replaces the color without invalidating the owner.
	  // Unique color zones machinery use this to avoid reprocessing
	  // figures by also updating the output representations.
	  _replace: function (color) {
	    var keepTag = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	    var keepLabel = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];
	
	
	    var oldTag = this._tag;
	    var oldLabel = this._label;
	
	    this.copyProperties(color);
	
	    if (keepTag) {
	      this._tag = oldTag;
	    }
	    if (keepLabel) {
	      this._label = oldLabel;
	    }
	  }
	});
	_util.Xml.addFromBuild(Color, 'Color');
	_util.Xml.addToXml(Color);
	
	Color.Transparent = function () {
	  return new Color({ alpha: 0, rgb: '000000' });
	};
	Color.Black = function () {
	  return new Color({ rgb: '000000' });
	};
	Color.Gray = function () {
	  return new Color({ rgb: '888888' });
	};
	Color.White = function () {
	  return new Color({ rgb: 'FFFFFF' });
	};
	Color.CutPen = function () {
	  return new Color({ alpha: 0.5, rgb: '00FF00', name: 'CutContour' });
	};
	
	Color.RGB = Color.fromRgb = function (rgb) {
	  var alpha = arguments.length <= 1 || arguments[1] === undefined ? 1 : arguments[1];
	
	  return new Color({ rgb: rgb, alpha: alpha });
	};
	//shouldn't accept float type 
	function componentToHex(c) {
	  var hex = Math.round(c).toString(16);
	  return hex.length === 1 ? "0" + hex : hex;
	}
	Color.fromImageData = function (data) {
	  var r = data[0],
	      g = data[1],
	      b = data[2],
	      a = data[3];
	  return new Color({ rgb: componentToHex(r) + componentToHex(g) + componentToHex(b), alpha: a / 255 });
	};
	
	Color.areEqual = function (ca, cb, includeTag) {
	  return ca.textualize(includeTag) === cb.textualize(includeTag);
	};
	
	Color.lumDiff = function (ca, cb) {
	  // See http://juicystudio.com/article/luminositycontrastratioalgorithm.php
	
	  var la = 0.2126 * Math.pow(ca.red(), 2.2) + 0.7152 * Math.pow(ca.green(), 2.2) + 0.0722 * Math.pow(ca.blue(), 2.2);
	
	  var lb = 0.2126 * Math.pow(cb.red(), 2.2) + 0.7152 * Math.pow(cb.green(), 2.2) + 0.0722 * Math.pow(cb.blue(), 2.2);
	
	  return la > lb ? (la + 0.05) / (lb + 0.05) : (lb + 0.05) / (la + 0.05);
	};
	
	Color.changeLuminosity = function (c, lum) {
	  var cc = c.clone();
	  cc.red(Math.min(Math.max(0, cc.red() * (1 + lum)), 1));
	  cc.green(Math.min(Math.max(0, cc.green() * (1 + lum)), 1));
	  cc.blue(Math.min(Math.max(0, cc.blue() * (1 + lum)), 1));
	  return cc;
	};
	
	Color.highestContrast = function (color, pool) {
	  if (pool === undefined) {
	    pool = [Color.White(), Color.Black()];
	  }
	
	  var r = void 0,
	      rDiff = 0;
	  (0, _lodash.forEach)(pool, function (c) {
	    var d = Color.lumDiff(color, c);
	    if (d > rDiff) {
	      rDiff = d;
	      r = c;
	    }
	  });
	  return r;
	};
	
	Color.removeHash = function (color) {
	  return color.replace('#', '');
	}, Color.arrayFromXml = function (coloredNode) {
	  var list = _util.Xml.getObjectArray(coloredNode, Color, 'Color');
	  return list.length > 0 ? list : Color.arrayFromXmlString(coloredNode);
	};
	Color.arrayFromXmlString = function (coloredNode) {
	  var list = [];
	  var colorsString = coloredNode.getAttribute('Colors');
	  if (colorsString) {
	    var colors = colorsString.split(',');
	    // Add ColorsAlpha ?
	    for (var k = 0, kEnd = colors.length; k < kEnd; ++k) {
	      list.push(Color.fromXmlAttr(colors[k]));
	    }
	  }
	  return list;
	};
	Color.fromXml = function (coloredNode) {
	  var node = _util.Xml.child(coloredNode, 'Color');
	  if (node) {
	    return Color.parseXml(node);
	  } else {
	    // Backward compatibility
	    var colorString = coloredNode.getAttribute('Color');
	    if (colorString) {
	      var alpha = _util.Xml.getFloatAttr(coloredNode, 'Alpha', 255) / 255.0;
	      return Color.fromXmlAttr(colorString, alpha);
	    }
	  }
	  return null;
	};
	Color.fromXmlString = function (xmlString) {
	  var domFigure = _util.Xml.fromString(xmlString);
	  return Color.fromXml(domFigure.documentElement);
	};
	
	Color.fromXmlAttr = function (xmlString, alpha) {
	  if (!xmlString) {
	    return Color.Transparent();
	  }
	  var p = {};
	  if (alpha === undefined) {
	    alpha = 1.0;
	  }
	  p.alpha = alpha;
	  var colorAndName = xmlString.split('-');
	  if (colorAndName.length > 1) {
	    p.name = colorAndName[1];
	  }
	  var parts = colorAndName[0].split('|');
	  if (parts.length === 1) {
	    if (parts[0].length === 8) {
	      p.rgb = parts[0].substring(2);
	    } else {
	      p.rgb = parts[0];
	    }
	  } else if (parts.length === 2) {
	    p.rgb = parts[1];
	  } else if (parts.length === 3) {
	    p.cmyk = parts[1];p.rgb = parts[2];
	  }
	  return new Color(p);
	};
	
	var _getThingColors = function (thing, colors) {
	  return thing.getColors(colors);
	};
	var _reduceThingColors = function (colors, thing) {
	  return thing.getColors(colors);
	};
	
	Color.getColors = function (things, colors) {
	  if ((0, _gear.isArray)(things)) {
	    return (0, _lodash.reduce)(things, _reduceThingColors, []);
	  } else {
	    return _getThingColors(things, colors);
	  }
	};
	
	var collapseZones = function (colors, options, zones) {
	  if (zones === undefined) {
	    zones = [];
	  }
	  var collapseTags = options && options.collapseTags !== undefined ? options.collapseTags : false;
	  var includeTag = !collapseTags;
	  var map = {};
	  var isShowThrough = function (z) {
	    return z.value._showThrough;
	  };
	  //_.forEach( zones, z => {
	  for (var i = 0, iEnd = zones.length; i < iEnd; ++i) {
	    var z = zones[i];
	    map[z.value.textualize(includeTag)] = z.value;
	  } //);
	  //_.forEach(colors,function(c) {
	  for (var k = 0, kEnd = colors.length; k < kEnd; ++k) {
	    var c = colors[k];
	    var cs = c.textualize(includeTag);
	    if (!(cs in map)) {
	      map[cs] = c;
	      var zone = { value: c.clone(), type: 'Combined', '_unique': true, tagsCollapsed: collapseTags };
	
	      // ShowThrough zones goes always to the end
	      if (c._showThrough) {
	        zones.push(zone);
	      } else {
	        var n = (0, _lodash.findIndex)(zones, isShowThrough); // [TODO]
	        if (n !== -1) {
	          zones.splice(n, 0, zone);
	        } else {
	          zones.push(zone);
	        }
	      }
	    }
	  } //);
	  return zones;
	};
	
	Color.zones = function (things, options, zones) {
	  return collapseZones(Color.getColors(things), options, zones);
	};
	
	// This one doesn't invalidate the model, use with care
	Color.fastReplace = function (color, newColor, keepTags, keepLabels) {
	  color._replace(newColor, keepTags, keepLabels); // avoid figure invalidation
	};
	
	Color.replace = function (color, newColor, keepTags, keepLabels) {
	  color.replace(newColor, keepTags, keepLabels);
	};
	
	var _replaceAll = function (colors, replaceFunc, oldColor, newColor, options) {
	  var changed = false;
	  if (colors.length === 0) {
	    // Some figures like full color rasters, may not have any colors to replace.
	    // In this case, we just avoid going forward here so the figure is not invalidated
	    return changed;
	  }
	  oldColor = oldColor.clone(); // Guard against replaceColor(ownedColor,...)
	  var keepTags = options && options.keepTags !== undefined ? options.keepTags : false;
	  var keepLabels = options && options.keepLabels !== undefined ? options.keepLabels : false;
	  var tagsCollapsed = options && options.tagsCollapsed !== undefined ? options.tagsCollapsed : false;
	  var includeTag = !tagsCollapsed;
	  var oldColorString = oldColor.textualize(includeTag);
	  //_.forEach(colors,function(c) {
	  for (var k = 0, kEnd = colors.length; k < kEnd; ++k) {
	    var c = colors[k];
	    var cString = c.textualize(includeTag);
	    if (cString === oldColorString) {
	      replaceFunc(c, newColor, keepTags, keepLabels);
	      changed = true;
	    }
	  } //);
	  return changed;
	};
	
	var replaceThingColor = function (thing, oldColor, newColor, options) {
	  return _replaceAll(_getThingColors(thing), Color.replace, oldColor, newColor, options);
	};
	
	Color.replaceAll = function (things, oldColor, newColor, options) {
	  return _replaceAll(Color.getColors(things), Color.replace, oldColor, newColor, options);
	};
	
	var changeThingZone = function (thing, zone, newValue) {
	  // [TODO] Avoid changing code wiring for the moment, clean up
	  if (thing.changeColorZone) {
	    return thing.changeColorZone(zone, newValue);
	  }
	
	  // [TODO] No need for all this checks, replace for assert later
	  if (zone._unique) {
	    if (zone.value instanceof Color) {
	      if (newValue instanceof Color) {
	        return replaceThingColor(thing, zone.value, newValue, { tagsCollapsed: zone.tagsCollapsed, keepTags: true });
	      }
	    }
	  }
	};
	
	Color.changeZone = function (things, zone, newValue) {
	  if ((0, _gear.isArray)(things)) {
	    for (var k = 0, kEnd = things.length; k < kEnd; ++k) {
	      changeThingZone(things[k], zone, newValue);
	    } //);
	    return things;
	  } else {
	    return changeThingZone(things, zone, newValue);
	  }
	};
	
	// [TODO] This should be a mixin, hacking it for now for the release
	
	Color._this_changeZone = function (zone, newValue) {
	  return changeThingZone(this, zone, newValue);
	};
	
	Color._this_zones = function (options, zones) {
	  return collapseZones(_getThingColors(this), options, zones);
	};
	
	Color._this_replaceColor = function (oldColor, newColor, options) {
	  this.lock();
	  return _replaceAll(_getThingColors(this), Color.replace, oldColor, newColor, options);
	};
	
	Color._this_fastReplaceColor = function (oldColor, newColor, options) {
	  this.lock();
	  return _replaceAll(_getThingColors(this), Color.fastReplace, oldColor, newColor, options);
	};
	
	_util.Xml.Parser['Color'] = _util.Xml.makeObjectParser(Color);
	_util.Xml.Parser['Color[]'] = _util.Xml.makeArrayObjectParser(Color);

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EmptyBrush = exports.RadialHalftoneBrush = exports.LinearHalftoneBrush = exports.RadialGradientBrush = exports.LinearGradientBrush = exports.ColorEngineBrush = exports.PatternBrush = exports.TextureBrush = exports.TextureBrushBase = exports.Brush = exports.BrushBase = undefined;
	exports.isBrushVisible = isBrushVisible;
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _geometry = __webpack_require__(21);
	
	var _util = __webpack_require__(17);
	
	var _color = __webpack_require__(31);
	
	var BrushBase = exports.BrushBase = _gear.OwnedObject.extend({ typeName: 'BrushBase', __debugProps: true });
	
	function isBrushVisible(brush) {
	  return brush !== null && brush !== undefined && !brush.empty() && (brush instanceof Cx.Brush && brush.color !== undefined && !brush.color.showThrough && brush.color.alpha > 0 || //solid brush
	  brush instanceof Cx.TextureBrush) //texture brush
	  ;
	}
	
	// Brush
	//===================================================================================================
	// A solid brush
	
	var Brush = exports.Brush = BrushBase.extend({ typeName: 'Brush',
	
	  type: 'Brush',
	
	  Properties: {
	    color: { type: 'Color', def: _color.Color.Black(), owned: true, onChange: _gear.invalidateOwner },
	    materialId: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    name: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    tag: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    label: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner }
	  },
	
	  init: function (c) {
	    this.callParent(c);
	    // Direct color shorcut
	    if (c && c.color === undefined) {
	      this._color = new _color.Color(c);
	    }
	  },
	  empty: function () {
	    return false;
	  },
	
	  _empty: false,
	  _type: 'Brush',
	
	  getType: function () {
	    return this._type;
	  },
	  getColors: function () {
	    var colors = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    colors.push(this._color);
	    return colors;
	  },
	  setupContext: function (context /*,transform,frame*/) {
	    context.fillStyle = this._color.rgba;
	  },
	  needsClipping: function () {
	    return false;
	  },
	  needsFrame: function () {
	    return false;
	  },
	  textualize: function () {
	    // [TODO] Once MaterialId, Name, Tag and Label are supported in the engine,
	    // this is the correct textualize function:
	    // return textualizeBrushMeta( this, 'Brush: '+ this._color.textualize() );
	    // For the moment, same as it is being done in v5
	    return 'Brush: ' + this._color.textualize();
	  },
	
	  invalidate: _gear.invalidateOwner,
	  quickToDraw: function () {
	    return true;
	  },
	  needsFixedDrawing: function () {
	    return false;
	  },
	  containsLinkedResources: function () {
	    return false;
	  }
	});
	
	// We use 'Brush' in object types to be able to construct a default brush
	// Overwrite the Base construct. We need to review this
	Brush.construct = function (v) {
	  if (v === null) {
	    return v;
	  } else if (v instanceof BrushBase) {
	    return v.adopted(this);
	  } else {
	    return new Brush(v).owner(this);
	  }
	};
	
	Brush.fromRgb = function (rgb, alpha) {
	  return new Brush({ color: _color.Color.fromRgb(rgb, alpha) });
	};
	
	// transformMode: Fixed, Clamp, RotateOnly, Full, StretchX, StretchY
	
	// Canvas used to draw TextureBrushes
	var clippedPatternCanvas = document.createElement('canvas');
	
	var TextureBrushBase = exports.TextureBrushBase = BrushBase.extend({ typeName: 'TextureBrushBase',
	
	  Properties: {
	    textureOffset: { type: 'Point', def: new _geometry.Point(0, 0), dropDef: true, onChange: _gear.invalidateOwner },
	    targetOffset: { type: 'Point', def: new _geometry.Point(0, 0), dropDef: true, onChange: _gear.invalidateOwner },
	    matrix22: { type: 'Matrix22', def: new _geometry.Matrix(), dropDef: true, onChange: _gear.invalidateOwner },
	    transformMode: { type: 'string', def: 'Full', dropDef: true, onChange: _gear.invalidateOwner },
	    clippingBounds: { type: 'Bounds', def: new _geometry.Bounds(0, 0, 1, 1), dropDef: true, onChange: _gear.invalidateOwner },
	    colorMap: { type: 'ColorMap', def: null, owned: true, dropDef: true, onChange: _gear.invalidateOwner },
	    materialId: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    name: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    tag: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    label: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner }
	  },
	
	  // _type: '...',
	
	  textualize: function () {
	    var colorMap = this._colorMap;
	    return textualizeBrushMeta(this, this._type + ': ' + this._imageLink + ' ' + this._textureOffset.textualize() + ' ' + this._targetOffset.textualize() + ' ' + this._matrix22.textualize() + ' ' + this._transformMode + ' ' + this._clippingBounds.textualize() + (colorMap ? ' ' + colorMap.textualize() : ''));
	  },
	  empty: function () {
	    return false;
	  },
	
	  _empty: false,
	  isEqual: function (other) {
	    return this.propertiesAreEqual(other);
	  },
	  getType: function () {
	    return this._type;
	  },
	  getColors: function () {
	    var colors = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    var colorMap = this._colorMap;
	    if (colorMap) {
	      colorMap.getColors(colors);
	    }
	    return colors;
	  },
	  clippingFrame_: function (renderFrame) {
	
	    var _this = this,
	        cache = _this._cache,
	        id = _this.contentId();
	
	    var info = cache.getInfo(id);
	    if (!info) {
	      return _geometry.Frame.fromBounds(new _geometry.Bounds(0, 0, 100, 100));
	    }
	
	    var clip = this.patternBounds(info.width, info.height);
	    var patternWidth = clip.width,
	        patternHeight = clip.height;
	
	    var pt = this.patternTransform(patternWidth, patternHeight, renderFrame);
	    var patternBounds = new _geometry.Bounds(0, 0, patternWidth, patternHeight);
	
	    return _geometry.Frame.fromBounds(patternBounds).transformed(pt);
	  },
	  patternBounds: function (patternWidth, patternHeight) {
	    // pass as params?
	    var clip = this._clippingBounds;
	    var bounds = new _geometry.Bounds(Math.floor(patternWidth * clip.lx), Math.floor(patternHeight * (1 - clip.hy)), Math.ceil(patternWidth * clip.hx), Math.ceil(patternHeight * (1 - clip.ly)));
	
	    // Hack require for GDI+, preserved in Canvas so results are exactly the same as
	    // the engine. I think we should check if this can be eliminated [TODO]
	    // We have added a one pixel guard difference between the actual image and the
	    // brush rectangle. It seems that the clipping functions of GDI+ are not working
	    // quite right in the borders.
	    /*
	    if( bounds.lx < 1 ) { bounds.lx = 1; }
	    if( bounds.ly < 1 ) { bounds.ly = 1; }
	    if( bounds.hx > patternWidth  - 1 ) { bounds.hx = patternWidth  - 1; }
	    if( bounds.hy > patternHeight - 1 ) { bounds.hy = patternHeight - 1; }
	    */
	
	    return bounds;
	  },
	  isStretchTransformMode: function () {
	    var transformMode = this._transformMode;
	    return transformMode === 'Full' || transformMode === 'StretchX' || transformMode === 'StretchY';
	  },
	  targetLinealTransform: function (frame, patternWidth, patternHeight) {
	    var scale = this.computeApplyTransform(frame, patternWidth, patternHeight);
	    if (this.isStretchTransformMode() || this._transformMode === 'RotateOnly') {
	      return _geometry.Matrix.m(_geometry.Matrix.rotate(frame.dir_x.angle()), scale); // [TODO] Check rotation
	    } else {
	      return scale;
	    }
	  },
	  computeApplyTransform: function (frame, patternWidth, patternHeight) {
	    // This is copied from the C# engine. We could review the steps here because
	    // this function is directly called from brush.setupContext.
	
	    // The tiling or stretching is directly controlled by the texture brush lineal
	    // transformation. There is no need to do anything in the case of tiling. When
	    // stretch is needed, we add a scaling in this direction to account for the
	    // needed deformation. In setupContext this transform is going to
	    // be applied after the LinealTransform. We need to take this into account here.
	    // Stretching in any direction is incompatible with a rotation lineal transform.
	    // We would like that the stretching in one direction had no effect over the other
	    // but this is not possible due to wich seems to be a bug in GDI+ regarding
	    // asymmetrical tiles. The stretching is always performed in only one of the
	    // directions mantaining the aspect ratio.
	
	    var transformMode = this._transformMode;
	    var matrix22 = this._matrix22;
	
	    var scalex = 1,
	        scaley = 1;
	    if (transformMode === 'StretchX') {
	      scalex = frame.width / (matrix22.s00 * patternWidth);
	      scaley = scalex;
	    } else if (transformMode === 'StretchY') {
	      scalex = frame.height / (matrix22.s11 * patternHeight);
	      scaley = scalex;
	    } else if (transformMode === 'Full') {
	      scalex = frame.width / (matrix22.s00 * patternWidth);
	      scaley = frame.height / (matrix22.s11 * patternHeight);
	    }
	
	    return _geometry.Matrix.scale(scalex, scaley);
	  },
	  targetPos: function (frame) {
	    return this._transformMode === 'Fixed' ? new _geometry.Point(0, 0) : frame.interpolate(this._targetOffset);
	  },
	  targetRenderPos: function (frame, transformDoc) {
	    return this._transformMode === 'Fixed' ? new _geometry.Point(transformDoc.dx, transformDoc.dy) : frame.interpolate(this._targetOffset);
	  },
	
	
	  // Transform initial bounds to document coordinates ( frame is in doc coordinates )
	
	  patternTransform: function (patternWidth, patternHeight, frame) {
	
	    var targetLinealTransform = this.targetLinealTransform(frame, patternWidth, patternHeight);
	
	    var matrix22 = this._matrix22;
	
	    // Create pattern tile
	    var textureOffset = this._textureOffset;
	    var shift_x = -textureOffset.x * patternWidth;
	    var shift_y = -textureOffset.y * patternHeight;
	
	    // Offset and repeat first pattern to base for second pattern
	    var t = _geometry.Matrix.concat(targetLinealTransform, _geometry.Matrix.scale(1, -1), matrix22, _geometry.Matrix.translate(shift_x, shift_y));
	
	    var targetPos = this.targetPos(frame);
	
	    return _geometry.Matrix.m(_geometry.Matrix.translate(targetPos), t);
	  },
	
	
	  // [TODO] Clean up, use patternTransform and apply view coordinates afterwards
	  // Transform initial bounds to view coordinates ( frame is in view coordinates )
	  patternRenderTransform: function (patternWidth, patternHeight, frame, transformDoc) {
	
	    var targetLinealTransform = this.targetLinealTransform(frame, patternWidth, patternHeight);
	
	    var matrix22 = this._matrix22;
	
	    // Create pattern tile
	    var textureOffset = this._textureOffset;
	    var shift_x = -textureOffset.x * patternWidth;
	    var shift_y = -textureOffset.y * patternHeight;
	
	    // Offset and repeat first pattern to base for second pattern
	    var t = _geometry.Matrix.concat(targetLinealTransform, _geometry.Matrix.scale(1, -1), matrix22, _geometry.Matrix.translate(shift_x, shift_y));
	
	    if (!this.isStretchTransformMode()) {
	      t = _geometry.Matrix.concat(_geometry.Matrix.scale(transformDoc.scaleFactor()), t);
	    }
	
	    var targetPos = this.targetRenderPos(frame, transformDoc);
	
	    return _geometry.Matrix.m(_geometry.Matrix.translate(targetPos), t);
	  },
	  setupContext: function (context, transform, frame, transformDoc) {
	
	    // Obtain image to perform tiling
	    var pattern = this.patternImage(transformDoc.scaleFactor(), transform, frame); // Should this already have into account tiling?
	
	    if (!pattern) {
	      context.fillStyle = 'rgba(0, 100, 0, 0.2)';
	      return;
	    }
	
	    var image = pattern.image;
	    var scale = pattern.scale;
	
	    var patternWidth = image.width * scale,
	        patternHeight = image.height * scale;
	
	    // Clipping support. This is not used that much, we can optimize later
	    // The order is important here, textureOffset are computed against
	    // the non-clipped pattern in the engine. We may review this, for the moment we are trying
	    // to get the exact same result as with the engine
	    var clip = this._clippingBounds;
	    if (clip.lx !== 0 || clip.ly !== 0 || clip.hx !== 1 || clip.hy !== 1) {
	      var patternBounds = this.patternBounds(image.width, image.height);
	      var clipWidth = clippedPatternCanvas.width = patternBounds.width;
	      var clipHeight = patternBounds.height;
	      if (clippedPatternCanvas.height !== clipHeight) {
	        clippedPatternCanvas.height = clipHeight;
	      }
	      var clippedPatternContext = clippedPatternCanvas.getContext('2d');
	      clippedPatternContext.drawImage(image, patternBounds.lx, patternBounds.ly, clipWidth, clipHeight, 0, 0, clipWidth, clipHeight);
	
	      // Use the clipped image as the pattern
	      image = clippedPatternCanvas;
	      patternWidth = image.width * scale;
	      patternHeight = image.height * scale;
	    }
	
	    var t = this.patternRenderTransform(patternWidth, patternHeight, frame, transformDoc);
	
	    // Compensate for image quantum
	
	    t = _geometry.Matrix.m(t, _geometry.Matrix.scale(scale));
	
	    // Scheme adapted from ideas from:
	    // See http://stackoverflow.com/questions/20253210/canvas-pattern-offset
	    // We do not really need to create the tile because we can modify the main context
	    // directly. brush.setupContext is expected to be used before context.fill, and after
	    // the path has been alredy draw
	    context.fillStyle = context.createPattern(image, 'repeat');
	    t.transformContext(context);
	  },
	  patternSizeToDraw: function (zoom, transform, frame, info) {
	
	    var wpx = info.width,
	        hpx = info.height;
	
	    var vw = void 0,
	        vh = void 0;
	    var transformMode = this.transformMode;
	
	    var matrix22_scaleFactor = this._matrix22.maxScaleFactor();
	
	    if (transformMode === 'StretchX') {
	      vw = frame.width * zoom;
	      vh = hpx * vw / wpx;
	    } else if (transformMode === 'StretchY') {
	      vh = frame.height * zoom;
	      vw = wpx * vh / hpx;
	    } else if (transformMode === 'Full') {
	      vh = hpx * frame.height / 450 * zoom * matrix22_scaleFactor;
	      vw = wpx * vh / hpx;
	    } else {
	      // Here we will introduce DPI later
	      var s = zoom * matrix22_scaleFactor;
	      vw = wpx * s;
	      vh = hpx * s;
	    }
	
	    return { width: vw, height: vh };
	  },
	  quantumSizeToDraw: function (zoom, transform, frame, info) {
	
	    var size = this.patternSizeToDraw(zoom, transform, frame, info);
	    //if(!this._drawUsingQuantumSize) return Math.floor(Math.max(size.width, size.height));
	    var quantumSize = this._cache.sizeToDraw(size.width, size.height, info.width, info.height);
	
	    // Performing a color map on an image bigger than 512 pixels is too expensive
	    var colorMapImageMaxSize = _config.Config.colorMapImageMaxSize;
	    if (this._colorMap && quantumSize > colorMapImageMaxSize) {
	      quantumSize = colorMapImageMaxSize;
	    }
	    return quantumSize;
	  },
	  preparedToDraw: function (zoom, transform, frame) {
	    var _this = this,
	        cache = _this._cache,
	        colorMap = _this._colorMap,
	        id = _this.contentId();
	
	    var quantumSize = void 0,
	        image = void 0;
	
	    var info = cache.getInfo(id);
	
	    if (info) {
	      quantumSize = _this.quantumSizeToDraw(zoom, transform, frame, info);
	      image = cache.get(id, quantumSize, colorMap);
	    }
	    return !!image;
	  },
	  prepareToDraw$: function (zoom, transform, frame, fireRedraw) {
	    var _this = this,
	        cache = _this._cache,
	        colorMap = _this._colorMap,
	        id = _this.contentId();
	
	    var quantumSize = void 0,
	        image = void 0;
	
	    var info = cache.getInfo(id);
	
	    if (info) {
	      quantumSize = _this.quantumSizeToDraw(zoom, transform, frame, info);
	      image = cache.get(id, quantumSize, colorMap);
	    }
	
	    if (image) {
	      return (0, _gear.resolve)(image);
	    } else {
	      return (0, _gear.if$)(!info, function () {
	
	        //console.log('asking image info');
	        return _withRedraw(cache.info$(id), fireRedraw, _this);
	      }).then(function () {
	
	        var qs = _this.quantumSizeToDraw(zoom, transform, frame, cache.getInfo(id));
	
	        return _withRedraw(cache.cache$(id, qs, colorMap), fireRedraw, _this);
	      });
	    }
	  },
	  patternImage: function (zoom, transform, frame) {
	    var _this = this,
	        cache = this._cache,
	        colorMap = _this._colorMap,
	        id = _this.contentId(),
	        info = cache.getInfo(id);
	
	    var quantumSize = void 0,
	        image = void 0;
	
	    if (info) {
	      quantumSize = _this.quantumSizeToDraw(zoom, transform, frame, info);
	      image = cache.get(id, quantumSize, colorMap);
	    }
	
	    if (!info || !image) {
	
	      //console.log('asking image info');
	
	      // We need to use a timeout here to clean up the call stack
	      // This is due to Jquery promises, we need to move forward soon
	      setTimeout(function () {
	        _this.prepareToDraw$(zoom, transform, frame, true);
	      }, 0);
	
	      if (info) {
	        image = cache.getBest(id, quantumSize, colorMap);
	      }
	    }
	
	    var scale = void 0;
	    if (image) {
	
	      // console.log('patternImage: ' + quantumSize + ' ' + image.width + ' ' + image.height);
	
	      scale = // ( 25.4 / _this._dpi ) *
	      Math.max(info.width, info.height) / Math.max(image.width, image.height);
	    }
	
	    return image ? { image: image, scale: scale } : null;
	  },
	
	  get topFigure() {
	    var o = this._owner;
	    return o && o.topFigure;
	  },
	  needsClipping: function () {
	    return false;
	  },
	  needsFrame: function () {
	    return true;
	  },
	
	  invalidate: _gear.invalidateOwner,
	  needsFixedDrawing: function () {
	    return this._transformMode === 'Fixed';
	  },
	  quickToDraw: function () {
	    return false;
	  },
	  containsLinkedResources: function () {
	    return true;
	  }
	});
	TextureBrushBase.parseProperties = function (node, Type) {
	  var p = _util.Xml.parseProperties(node, Type);
	
	  // BP: relLX relLY relWidth relHeight
	  var clippingRectString = node.getAttribute('ClippingRect');
	  if (!p.clippingBounds && clippingRectString) {
	    var bounds = _geometry.Bounds.fromXmlString(clippingRectString);
	
	    // width -> hx, height -> hy
	    bounds.hx += bounds.lx;
	    bounds.hy += bounds.ly;
	
	    // inverted ly
	    var ly = bounds.ly,
	        hy = bounds.hy;
	    bounds.ly = 1 - hy;
	    bounds.hy = 1 - ly;
	
	    p.clippingBounds = bounds;
	  }
	
	  // Backward compatibility
	  if (node.getAttribute('AlongX') === 'Stretch') {
	    p.transformMode = 'StretchX';
	  }
	  if (node.getAttribute('AlongY') === 'Stretch') {
	    p.transformMode = 'StretchY';
	  }
	  return p;
	};
	
	// TextureBrush
	//===================================================================================================
	
	var _fireRedraw = function (figure) {
	  return function () {
	    var topFigure = figure.topFigure;
	    if (topFigure) {
	      topFigure.redraw$();
	    }
	  };
	};
	var _withRedraw = function (promise, fireRedraw, figure) {
	  return fireRedraw ? promise.then(_fireRedraw(figure)) : promise;
	};
	
	var TextureBrush = exports.TextureBrush = TextureBrushBase.extend({ typeName: 'TextureBrush',
	
	  type: 'TextureBrush',
	
	  Properties: {
	    imageLink: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    width: { type: 'magnitude', def: null, dropDef: true },
	    height: { type: 'magnitude', def: null, dropDef: true },
	    dpi: { type: 'number', def: 25.4, tag: 'DPI' }
	  },
	
	  _type: 'TextureBrush',
	
	  init: function (config) {
	    //this._drawUsingQuantumSize = Config.drawUsingQuantumSizeBrush;
	    this._cache = _config.Config.QuantumImage;
	    this.callParent(config);
	  },
	  contentId: function () {
	    return this._imageLink;
	  }
	});
	TextureBrush.parseXml = function (node) {
	  var p = TextureBrushBase.parseProperties(node, TextureBrush);
	  return new TextureBrush(p);
	};
	_util.Xml.addFromBuild(TextureBrush, 'TextureBrush');
	_util.Xml.addToXml(TextureBrush);
	
	// PatternBrush
	//===================================================================================================
	
	var PatternBrush = exports.PatternBrush = TextureBrushBase.extend({ typeName: 'PatternBrush',
	
	  type: 'PatternBrush',
	
	  Properties: {
	    link: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    width: { type: 'magnitude', def: null, dropDef: true },
	    height: { type: 'magnitude', def: null, dropDef: true }
	  },
	
	  _type: 'PatternBrush',
	
	  contentId: function () {
	    return this._link;
	  },
	  init: function (config) {
	    //this._drawUsingQuantumSize = Config.drawUsingQuantumSizeBrush;
	    this._cache = _config.Config.FiguresCache;
	    this.callParent(config);
	  }
	});
	PatternBrush.parseXml = function (node) {
	  var p = TextureBrushBase.parseProperties(node, PatternBrush);
	  return new PatternBrush(p);
	};
	_util.Xml.addFromBuild(PatternBrush, 'PatternBrush');
	_util.Xml.addToXml(PatternBrush);
	
	// ColorEngineBrush
	//===================================================================================================
	
	var ColorEngineBrush = exports.ColorEngineBrush = BrushBase.extend({ typeName: 'ColorEngineBrush',
	
	  type: 'ColorEngineBrush',
	
	  Properties: {
	    color: { type: 'Color', def: _color.Color.White(), owned: true, onChange: _gear.invalidateOwner },
	    materialId: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    name: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    tag: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    label: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner }
	  },
	
	  textualize: function () {
	    return textualizeBrushMeta(this, 'ColorEngineBrush: ' + this._color.textualize());
	  },
	  empty: function () {
	    return false;
	  },
	
	
	  _empty: false,
	
	  _type: 'ColorEngineBrush',
	
	  getType: function () {
	    return this._type;
	  },
	  getColors: function (colors) {
	    if (colors === undefined) {
	      colors = [];
	    }
	    colors.push(this._color);
	    return colors;
	  },
	
	  invalidate: _gear.invalidateOwner,
	  needsClipping: function () {
	    return false;
	  },
	  needsFrame: function () {
	    return true;
	  },
	  setupContext: function (context, transform, frame, transformDoc) {},
	  quickToDraw: function () {
	    return true;
	  },
	  needsFixedDrawing: function () {
	    return false;
	  },
	  containsLinkedResources: function () {
	    return false;
	  }
	});
	_util.Xml.addFromBuild(ColorEngineBrush, 'ColorEngineBrush');
	_util.Xml.addToXml(ColorEngineBrush);
	
	// LinearGradientBrush
	//===================================================================================================
	
	var LinearGradientBrush = exports.LinearGradientBrush = BrushBase.extend({ typeName: 'LinearGradientBrush',
	
	  type: 'LinearGradientBrush',
	
	  Properties: {
	    colors: { type: 'Color[]', def: [_color.Color.White(), _color.Color.Black()], owned: true, onChange: _gear.invalidateOwner },
	    positions: { type: 'number[]', def: [0.0, 1.0], onChange: _gear.invalidateOwner },
	    from: { type: 'Point', def: new _geometry.Point(0.0, 0.5), dropDef: true, onChange: _gear.invalidateOwner },
	    to: { type: 'Point', def: new _geometry.Point(1.0, 0.5), dropDef: true, onChange: _gear.invalidateOwner },
	    gammaCorrection: { type: 'boolean', def: true, dropDef: true, onChange: _gear.invalidateOwner },
	    interpolate: { type: 'boolean', def: true, dropDef: true, onChange: _gear.invalidateOwner },
	    materialId: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    name: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    tag: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    label: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner }
	  },
	
	  textualize: function () {
	    return textualizeBrushMeta(this, 'LinearGradientBrush: ' + this._colors.textualize() + ' ' + this._positions.textualize() + ' ' + this._from.textualize() + ' ' + this._to.textualize() + ' ' + this._gammaCorrection);
	  },
	  empty: function () {
	    return false;
	  },
	
	
	  _empty: false,
	
	  _type: 'LinearGradientBrush',
	
	  getType: function () {
	    return this._type;
	  },
	  getColors: function (colors) {
	    if (colors === undefined) {
	      colors = [];
	    }
	    var this_colors = this._colors;
	    //_.forEach(this_colors,function(c) {
	    for (var k = 0, kEnd = this_colors.length; k < kEnd; ++k) {
	      var c = this_colors[k];
	      colors.push(c);
	    } //);
	    return colors;
	  },
	
	  invalidate: _gear.invalidateOwner,
	  needsClipping: function () {
	    return false;
	  },
	  needsFrame: function () {
	    return true;
	  },
	  setupContext: function (context, transform, frame, transformDoc) {
	    var fp = this._interpolate ? frame.interpolate(this._from) : transformDoc.apply(this._from),
	        tp = this._interpolate ? frame.interpolate(this._to) : transformDoc.apply(this._to);
	    var grd = context.createLinearGradient(fp.x, fp.y, tp.x, tp.y);
	    var colors = this._colors;
	    var positions = this._positions;
	    for (var k = 0, kEnd = Math.min(colors.length, positions.length); k < kEnd; ++k) {
	      grd.addColorStop(positions[k], colors[k].rgba);
	    }
	    context.fillStyle = grd;
	  },
	  quickToDraw: function () {
	    return true;
	  },
	  needsFixedDrawing: function () {
	    return false;
	  },
	  containsLinkedResources: function () {
	    return false;
	  }
	});
	_util.Xml.addFromBuild(LinearGradientBrush, 'LinearGradientBrush');
	_util.Xml.addToXml(LinearGradientBrush);
	
	// RadialGradientBrush
	//===================================================================================================
	
	var RadialGradientBrush = exports.RadialGradientBrush = BrushBase.extend({ typeName: 'RadialGradientBrush',
	
	  type: 'RadialGradientBrush',
	
	  Properties: {
	    colors: { type: 'Color[]', def: [_color.Color.White(), _color.Color.Black()], owned: true, onChange: _gear.invalidateOwner },
	    center: { type: 'Point', def: new _geometry.Point(0.5, 0.5), dropDef: false, onChange: _gear.invalidateOwner },
	    positions: { type: 'number[]', def: [1.0], dropDef: false, onChange: _gear.invalidateOwner },
	    materialId: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    name: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    tag: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    label: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    focalPoint: { type: 'Point', def: null, dropDef: true, onChange: _gear.invalidateOwner }
	  },
	
	  textualize: function () {
	    return textualizeBrushMeta(this, this._focalPoint ? 'RadialGradientBrush: ' + this._colors.textualize() + ' ' + this._center.textualize() + ' ' + this._positions.textualize() + ' ' + this._focalPoint.textualize() : 'RadialGradientBrush: ' + this._colors.textualize() + ' ' + this._center.textualize() + ' ' + this._positions.textualize());
	  },
	  init: function (config) {
	    this.callParent(config);
	    if (this._colors.length === 0) {
	      this.colors = this.Properties.colors.def;
	    }
	    var rCount = this._colors.length - 1;
	    if (this._positions.length !== rCount) {
	      var r = [];
	      for (var k = 0; k < rCount; ++k) {
	        r[k] = 1.0 / (rCount - k);
	      }
	      this.positions = r;
	    }
	  },
	
	
	  // [TODO][PROP]
	  centerColor: function (v) {
	    return v === undefined ? this._colors[0] : (this.colors.replaceAt(0, v), this);
	  },
	  outerColors: function () {
	    var cs = this._colors;
	    return cs.slice(1, cs.length);
	  },
	  isEqual: function (other) {
	    return this.propertiesAreEqual(other);
	  },
	  empty: function () {
	    return false;
	  },
	
	  _empty: false,
	  _type: 'RadialGradientBrush',
	  getType: function () {
	    return this._type;
	  },
	  getColors: function () {
	    var colors = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    (0, _lodash.forEach)(this._colors, function (c) {
	      colors.push(c);
	    });
	    return colors;
	  },
	
	  invalidate: _gear.invalidateOwner,
	  needsClipping: function () {
	    return false;
	  },
	  needsFrame: function () {
	    return true;
	  },
	  setupContext: function (context, transform, frame) {
	    var lDiagonal = Math.sqrt(frame.width2 + frame.height2);
	    var centerShift = this._focalPoint ? this._focalPoint.minus(this._center) : new _geometry.Point(0, 0);
	    var cp = frame.interpolate(this._center.minus(centerShift));
	    var fp = frame.interpolate(this._focalPoint || this._center);
	    var radious = lDiagonal / 2;
	
	    var grd = context.createRadialGradient(fp.x, fp.y, 0, cp.x, cp.y, radious);
	    var colors = this._colors;
	    var positions = this._positions;
	    for (var k = 0, kEnd = Math.min(colors.length, positions.length + 1); k < kEnd; ++k) {
	      grd.addColorStop(k === 0 ? 0 : positions[k - 1], colors[k].rgba);
	    }
	    context.fillStyle = grd;
	  },
	  quickToDraw: function () {
	    return true;
	  },
	  needsFixedDrawing: function () {
	    return false;
	  },
	  containsLinkedResources: function () {
	    return false;
	  }
	});
	RadialGradientBrush.parseXml = function (node) {
	  var p = {};
	  _util.Xml.parseProperties(node, RadialGradientBrush, p);
	
	  p.colors = _color.Color.arrayFromXml(node);
	  if (p.colors.length === 0 && node.getAttribute('CenterColor')) {
	    // Backward compatibility
	    var centerColor = _color.Color.fromXmlString(node.getAttribute('CenterColor'));
	    var outerColors = _color.Color.arrayFromXmlString(node.getAttribute('OuterColors'));
	    p.colors = [centerColor].concat(outerColors);
	  }
	  return new RadialGradientBrush(p);
	};
	_util.Xml.addFromBuild(RadialGradientBrush, 'RadialGradientBrush');
	_util.Xml.addToXml(RadialGradientBrush);
	
	// LinearHalftoneBrush
	//===================================================================================================
	
	var LinearHalftoneBrush = exports.LinearHalftoneBrush = BrushBase.extend({ typeName: 'LinearHalftoneBrush',
	
	  type: 'LinearHalftoneBrush',
	
	  Properties: {
	    colors: { type: 'Color[]', def: [_color.Color.White(), _color.Color.Black()], owned: true, onChange: _gear.invalidateOwner },
	    positions: { type: 'number[]', def: [0.0, 1.0], onChange: _gear.invalidateOwner },
	    from: { type: 'Point', def: new _geometry.Point(0.0, 0.5), dropDef: true, onChange: _gear.invalidateOwner },
	    to: { type: 'Point', def: new _geometry.Point(1.0, 0.5), dropDef: true, onChange: _gear.invalidateOwner },
	    maxRadius: { type: 'magnitude', def: new _gear.Magnitude(5, 'mm'), onChange: _gear.invalidateOwner },
	    hType: { type: 'string', def: 'Ellipse', onChange: _gear.invalidateOwner },
	    rotation: { type: 'number', def: 30, onChange: _gear.invalidateOwner },
	    interleave: { type: 'boolean', def: false, onChange: _gear.invalidateOwner },
	    wHRatio: { type: 'number', def: 0.25, onChange: _gear.invalidateOwner },
	    materialId: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    name: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    tag: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    label: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner }
	  },
	
	  textualize: function () {
	    return textualizeBrushMeta(this, 'LinearHalftoneBrush: ' + this._colors.textualize() + ' ' + this._positions.textualize() + ' ' + this._from.textualize() + ' ' + this._to.textualize());
	  },
	  empty: function () {
	    return false;
	  },
	
	
	  _empty: false,
	
	  _type: 'LinearHalftoneBrush',
	
	  getType: function () {
	    return this._type;
	  },
	  getColors: function (colors) {
	    if (colors === undefined) {
	      colors = [];
	    }
	    var this_colors = this._colors;
	    for (var k = 0, kEnd = this_colors.length; k < kEnd; ++k) {
	      var c = this_colors[k];
	      colors.push(c);
	    }
	    return colors;
	  },
	
	  invalidate: _gear.invalidateOwner,
	  needsClipping: function () {
	    return true;
	  },
	  needsFrame: function () {
	    return true;
	  },
	  setupContext: function (aContext, aTransform, aFrame, aTransformDoc) {
	
	    var lfp = aFrame.interpolate(this._from),
	        ltp = aFrame.interpolate(this._to);
	    var lZoom = aTransformDoc.scaleFactor();
	    var lFrameBounds = aFrame.bounds;
	    var lCp = aFrame.center;
	    var lDiagonal = Math.max(_geometry.Point.distance(aFrame.p0, aFrame.p2), _geometry.Point.distance(aFrame.p1, aFrame.p3));
	
	    var lDir = _geometry.Point.substract(ltp, lfp);
	    lDir = lDir.normalized();
	    var lOffset = lDir.scalarMultiply(lDiagonal, lDiagonal);
	    var lfp_extended = _geometry.Point.substract(lfp, lOffset);
	    var ltp_extended = _geometry.Point.add(ltp, lOffset);
	
	    this.drawBrush(lfp, ltp, lfp_extended, ltp_extended, lFrameBounds, lZoom, aContext);
	  },
	  drawBrush: function (aFp, aTp, aFpExt, aTpExt, aFrameBounds, aZoom, aContext) {
	    var lColors = this._colors;
	    var lPositions = this._positions;
	
	    //this is required to fill whats not inside the gradient range
	    this.buildHalftonesFor(0, 1, lColors[0], lColors[0], aFpExt, aFp, aFrameBounds, aContext, aZoom);
	    this.buildHalftonesFor(0, 1, lColors[lColors.length - 1], lColors[lColors.length - 1], aTpExt, aTp, aFrameBounds, aContext, aZoom);
	
	    for (var i = 1; i < lPositions.length; ++i) {
	      this.buildHalftonesFor(lPositions[i - 1], lPositions[i], lColors[i - 1], lColors[i], aFp, aTp, aFrameBounds, aContext, aZoom);
	    }
	  },
	  buildHalftonesFor: function (aSPos, aEPos, aSCol, aECol, aFp, aTp, aFrameBounds, aContext, aZoom) {
	    var lSPoint = _geometry.Point.interpolate(aFp, aTp, aSPos);
	    var lEPoint = _geometry.Point.interpolate(aFp, aTp, aEPos);
	    var lAxisLen = _geometry.Point.distance(lSPoint, lEPoint);
	    if (lAxisLen > 0.0) {
	      var lDir = _geometry.Point.scalarMultiply(_geometry.Point.substract(lEPoint, lSPoint), 1.0 / lAxisLen);
	      var lFillDir = lDir.perpendicular(1);
	      var lMaxPolySide = Math.max(aFrameBounds.width, aFrameBounds.height);
	      var lXOffset = lFillDir.x * lMaxPolySide;
	      var lYOffset = lFillDir.y * lMaxPolySide;
	      var lX1 = lSPoint.x + lXOffset;
	      var lY1 = lSPoint.y + lYOffset;
	      var lX2 = lSPoint.x - lXOffset;
	      var lY2 = lSPoint.y - lYOffset;
	      var lX3 = lEPoint.x - lXOffset;
	      var lY3 = lEPoint.y - lYOffset;
	      var lX4 = lEPoint.x + lXOffset;
	      var lY4 = lEPoint.y + lYOffset;
	
	      aContext.fillStyle = aSCol.rgba;
	      aContext.beginPath();
	      aContext.moveTo(lX1, lY1);
	      aContext.lineTo(lX2, lY2);
	      aContext.lineTo(lX3, lY3);
	      aContext.lineTo(lX4, lY4);
	      aContext.closePath();
	      aContext.fill();
	
	      var lZoomedMaxRadius = this._maxRadius * aZoom;
	
	      if (lZoomedMaxRadius > 0.0 && aECol != aSCol) {
	        var lIterations = Math.ceil(lAxisLen / lZoomedMaxRadius);
	        lIterations = Math.max(1, lIterations);
	
	        var lSizeDelta = lZoomedMaxRadius / lIterations;
	
	        //we want to end exactly so the last circle is only half rendered
	        var lStartOffsetX = lEPoint.x - (lIterations - 1) * lZoomedMaxRadius * lDir.x;
	        var lStartOffsetY = lEPoint.y - (lIterations - 1) * lZoomedMaxRadius * lDir.y;
	
	        //we shift up and down so the pattern is interleaved
	        var lShiftX = 0;
	        var lShiftY = 0;
	
	        if (this._interleave) {
	          lShiftX = lFillDir.x * lZoomedMaxRadius / 4;
	          lShiftY = lFillDir.y * lZoomedMaxRadius / 4;
	        }
	
	        var lAngle = lDir.angle() + this._rotation;
	
	        //A x B = 1
	        //A / B = ratio
	        //B = 1 / A
	        //A / ( 1 / A ) = ratio
	        //(AxA) = ratio
	        //A = sqrt( ratio)
	        //B = 1 / A
	        this._wHRatio = Math.max(this._wHRatio, 0.1);
	        this._wHRatio = Math.min(this._wHRatio, 1.0);
	        var lEllipseW = Math.sqrt(this._wHRatio);
	        var lEllipseH = 1 / lEllipseW;
	
	        for (var i = 0; i < lIterations; ++i) {
	          var lX = lStartOffsetX + i * lZoomedMaxRadius * lDir.x + lShiftX;
	          var lY = lStartOffsetY + i * lZoomedMaxRadius * lDir.y + lShiftY;
	          var lSize = (i + 1) * lSizeDelta;
	          this.fillLineWithElements(lX, lY, aFrameBounds, lFillDir, lDir, lSize, lZoomedMaxRadius, lEllipseW, lEllipseH, lAngle, aECol, aContext);
	          lShiftX = -lShiftX;
	          lShiftY = -lShiftY;
	        }
	      }
	    }
	  },
	  fillLineWithElements: function (aX, aY, aFrameBounds, aFillDir, aDir, aSize, aMaxSize, aEW, aEH, aAngle, aECol, aContext) {
	    var lCurrX = aX;
	    var lCurrY = aY;
	    var lDx = aFillDir.x * aMaxSize;
	    var lDy = aFillDir.y * aMaxSize;
	
	    var hType = this._hType;
	
	    if (hType === 'Ellipse' || hType === 'ParallelEllipse') {
	      aMaxSize *= 1.5; //the ellipse size grows so to avoid missing some on the borders we increase this
	    } else if (hType === 'Full') {
	      var lMaxPolySide = Math.max(aFrameBounds.width, aFrameBounds.height);
	
	      aContext.strokeStyle = aECol.rgba;
	      aContext.lineWidth = aSize;
	      aContext.beginPath();
	      aContext.moveTo(aX + aFillDir.x * lMaxPolySide, aY + aFillDir.y * lMaxPolySide);
	      aContext.lineTo(aX - aFillDir.x * lMaxPolySide, aY - aFillDir.y * lMaxPolySide);
	      aContext.closePath();
	      aContext.stroke();
	      return;
	    }
	
	    while (lCurrX > -aMaxSize + aFrameBounds.lx && lCurrX < aFrameBounds.hx + aMaxSize && lCurrY > -aMaxSize + aFrameBounds.ly && lCurrY < aFrameBounds.hy + aMaxSize) {
	      this.drawElement(aSize, aECol, aContext, lCurrX, lCurrY, aEW, aEH, aAngle);
	
	      lCurrX += lDx;
	      lCurrY += lDy;
	    }
	
	    lCurrX = aX - lDx;
	    lCurrY = aY - lDy;
	
	    while (lCurrX > -aMaxSize + aFrameBounds.lx && lCurrX < aFrameBounds.hx + aMaxSize && lCurrY > -aMaxSize + aFrameBounds.ly && lCurrY < aFrameBounds.hy + aMaxSize) {
	      this.drawElement(aSize, aECol, aContext, lCurrX, lCurrY, aEW, aEH, aAngle);
	      lCurrX -= lDx;
	      lCurrY -= lDy;
	    }
	  },
	  drawElement: function (aSize, aCol, aContext, aCurrX, aCurrY, aEW, aEH, aAngle) {
	    var hType = this._hType;
	    var lRadius = aSize * 0.5;
	
	    if (hType === 'Circle') {
	      aContext.fillStyle = aCol.rgba;
	      aContext.beginPath();
	      aContext.ellipse(aCurrX, aCurrY, lRadius, lRadius, 0, 0, 2 * Math.PI);
	      aContext.closePath();
	      aContext.fill();
	    } else //if (HType == Ellipse)
	      {
	        aContext.fillStyle = aCol.rgba;
	        aContext.beginPath();
	        aContext.ellipse(aCurrX, aCurrY, lRadius * aEW, lRadius * aEH, (0, _gear.deg2rad)(aAngle), 0, 2 * Math.PI);
	        aContext.closePath();
	        aContext.fill();
	      }
	  },
	  quickToDraw: function () {
	    return false;
	  },
	  needsFixedDrawing: function () {
	    return false;
	  },
	  containsLinkedResources: function () {
	    return false;
	  }
	});
	_util.Xml.addFromBuild(LinearHalftoneBrush, 'LinearHalftoneBrush');
	_util.Xml.addToXml(LinearHalftoneBrush);
	
	// RadialHalftoneBrush
	//===================================================================================================
	
	var RadialHalftoneBrush = exports.RadialHalftoneBrush = BrushBase.extend({ typeName: 'RadialHalftoneBrush',
	
	  type: 'RadialHalftoneBrush',
	
	  Properties: {
	    colors: { type: 'Color[]', def: [_color.Color.White(), _color.Color.Black()], owned: true, onChange: _gear.invalidateOwner },
	    center: { type: 'Point', def: new _geometry.Point(0.5, 0.5), dropDef: false, onChange: _gear.invalidateOwner },
	    positions: { type: 'number[]', def: [1.0], dropDef: false, onChange: _gear.invalidateOwner },
	    maxRadius: { type: 'magnitude', def: new _gear.Magnitude(5, 'mm'), onChange: _gear.invalidateOwner },
	    hType: { type: 'string', def: 'Ellipse', onChange: _gear.invalidateOwner },
	    rotation: { type: 'number', def: 30, onChange: _gear.invalidateOwner },
	    interleave: { type: 'boolean', def: false, onChange: _gear.invalidateOwner },
	    wHRatio: { type: 'number', def: 0.25, onChange: _gear.invalidateOwner },
	    materialId: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    name: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    tag: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    label: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner }
	  },
	
	  textualize: function () {
	    return textualizeBrushMeta(this, 'RadialHalftoneBrush: ' + this._colors.textualize() + ' ' + this._center.textualize() + ' ' + this._positions.textualize());
	  },
	  init: function (config) {
	    this.callParent(config);
	    if (this._colors.length === 0) {
	      this.colors = this.Properties.colors.def;
	    }
	    var rCount = this._colors.length - 1;
	    if (this._positions.length !== rCount) {
	      var r = [];
	      for (var k = 0; k < rCount; ++k) {
	        r[k] = 1.0 / (rCount - k);
	      }
	      this.positions = r;
	    }
	  },
	  centerColor: function (v) {
	    return v === undefined ? this._colors[0] : (this.colors.replaceAt(0, v), this);
	  },
	  outerColors: function () {
	    var cs = this._colors;
	    return cs.slice(1, cs.length);
	  },
	  isEqual: function (other) {
	    return this.propertiesAreEqual(other);
	  },
	  empty: function () {
	    return false;
	  },
	
	  _empty: false,
	  _type: 'RadialHalftoneBrush',
	  getType: function () {
	    return this._type;
	  },
	  getColors: function () {
	    var colors = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    (0, _lodash.forEach)(this._colors, function (c) {
	      colors.push(c);
	    });
	    return colors;
	  },
	
	  invalidate: _gear.invalidateOwner,
	  needsClipping: function () {
	    return true;
	  },
	  needsFrame: function () {
	    return true;
	  },
	  setupContext: function (aContext, aTransform, aFrame, aTransformDoc) {
	    var lCp = aFrame.interpolate(this._center);
	    var lRadius = Math.max(_geometry.Point.distance(aFrame.p0, lCp), _geometry.Point.distance(aFrame.p1, lCp), _geometry.Point.distance(aFrame.p2, lCp), _geometry.Point.distance(aFrame.p3, lCp));
	    var lZoom = aTransformDoc.scaleFactor();
	    var lFrameBounds = aFrame.bounds;
	
	    this.drawBrush(lCp, lRadius, lFrameBounds, lZoom, aContext);
	  },
	  drawBrush: function (aCp, aRadius, aFrameBounds, aZoom, aContext) {
	    var lCenterColor = this.centerColor();
	    var lOuterColors = this.outerColors();
	    var lPositions = this._positions;
	
	    var lLast = lPositions.length - 1;
	    this.buildHalftonesFor(aCp, lPositions[lLast] * aRadius, aRadius, lOuterColors[lLast], lOuterColors[lLast], aFrameBounds, aContext, aZoom);
	
	    //we render outter to inner, just for convenience
	    for (var i = lPositions.length; i > 0; --i) {
	      this.buildHalftonesFor(aCp, i === 1 ? 0.0 : lPositions[i - 2] * aRadius, lPositions[i - 1] * aRadius, i === 1 ? lCenterColor : lOuterColors[i - 2], lOuterColors[i - 1], aFrameBounds, aContext, aZoom);
	    }
	  },
	  buildHalftonesFor: function (aCenter, aSRadius, aERadius, aSCol, aECol, aFrameBounds, aContext, aZoom) {
	    var lRadiusLen = aERadius - aSRadius;
	    if (lRadiusLen > 0.0) {
	      aContext.fillStyle = aSCol.rgba;
	      aContext.beginPath();
	      aContext.ellipse(aCenter.x, aCenter.y, aERadius, aERadius, 0, 0, 2 * Math.PI);
	      aContext.closePath();
	      aContext.fill();
	
	      var lZoomedMaxRadius = this._maxRadius * aZoom;
	      if (lZoomedMaxRadius > 0.0) {
	        var lIterations = Math.ceil(lRadiusLen / lZoomedMaxRadius);
	        lIterations = Math.max(1, lIterations);
	
	        var lSizeDelta = lZoomedMaxRadius / lIterations;
	
	        //we want to end exactly so the last circle is only half rendered
	        var lStartOffset = aERadius - (lIterations - 1) * lZoomedMaxRadius;
	
	        //we shift up and down so the pattern is interleaved
	        var lShift = 0;
	
	        if (this._interleave) {
	          lShift = 0.25;
	        }
	
	        //A x B = 1
	        //A / B = ratio
	        //B = 1 / A
	        //A / ( 1 / A ) = ratio
	        //(AxA) = ratio
	        //A = sqrt( ratio)
	        //B = 1 / A
	        this._wHRatio = Math.max(this._wHRatio, 0.1);
	        this._wHRatio = Math.min(this._wHRatio, 1.0);
	        var lEllipseW = Math.sqrt(this._wHRatio);
	        var lEllipseH = 1 / lEllipseW;
	
	        for (var i = 0; i < lIterations; ++i) {
	          var lRadius = lStartOffset + i * lZoomedMaxRadius;
	          var lSize = (i + 1) * lSizeDelta;
	          this.fillCircleWithElements(aCenter, lRadius, lShift, lSize, lZoomedMaxRadius, lEllipseW, lEllipseH, aECol, aContext);
	          lShift = -lShift;
	        }
	      }
	    }
	  },
	  fillCircleWithElements: function (aCenter, aRadius, aShift, aSize, aMaxSize, aEW, aEH, aECol, aContext) {
	    var lDelta = Math.floor(Math.PI * 2.0 * aRadius / aMaxSize);
	    if (lDelta > 0) {
	      var lDeltaAngle = -360.0 / lDelta;
	
	      var lCurrX = aCenter.x;
	      var lCurrY = aCenter.y;
	
	      var hType = this._hType;
	
	      if (hType === 'Full') {
	        aContext.strokeStyle = aECol.rgba;
	        aContext.lineWidth = aSize;
	        aContext.beginPath();
	        aContext.ellipse(aCenter.x, aCenter.y, aRadius, aRadius, 0, 0, 2 * Math.PI);
	        aContext.closePath();
	        aContext.stroke();
	        return;
	      }
	
	      lCurrX += aRadius;
	
	      var lMatrix = _geometry.Matrix.rotateAround(aCenter, aShift * lDeltaAngle);
	      lMatrix.transformContext(aContext);
	
	      for (var i = 0; i < lDelta; ++i) {
	        this.drawElement(aSize, aECol, aContext, lCurrX, lCurrY, aEW, aEH, lDeltaAngle * (i + aShift));
	        lMatrix = _geometry.Matrix.rotateAround(aCenter, lDeltaAngle);
	        lMatrix.transformContext(aContext);
	      }
	      aContext.resetTransform();
	    }
	  },
	  drawElement: function (aSize, aCol, aContext, aCurrX, aCurrY, aEW, aEH, aAngle) {
	    var hType = this._hType;
	    var lRadius = aSize * 0.5;
	
	    if (hType === 'Circle') {
	      aContext.fillStyle = aCol.rgba;
	      aContext.beginPath();
	      aContext.ellipse(aCurrX, aCurrY, lRadius, lRadius, 0, 0, 2 * Math.PI);
	      aContext.closePath();
	      aContext.fill();
	    } else //if (HType == Ellipse or ParallelEllipse)
	      {
	        aContext.fillStyle = aCol.rgba;
	        aContext.beginPath();
	        var lAngle = -this._rotation;
	        if (hType === 'ParallelEllipse') {
	          lAngle -= aAngle;
	        }
	        aContext.ellipse(aCurrX, aCurrY, lRadius * aEW, lRadius * aEH, (0, _gear.deg2rad)(lAngle), 0, 2 * Math.PI);
	        aContext.closePath();
	        aContext.fill();
	      }
	  },
	  quickToDraw: function () {
	    return false;
	  },
	  needsFixedDrawing: function () {
	    return false;
	  },
	  containsLinkedResources: function () {
	    return false;
	  }
	});
	RadialHalftoneBrush.parseXml = function (node) {
	  var p = {};
	  _util.Xml.parseProperties(node, RadialHalftoneBrush, p);
	
	  p.colors = _color.Color.arrayFromXml(node);
	  if (p.colors.length === 0 && node.getAttribute('CenterColor')) {
	    // Backward compatibility
	    var centerColor = _color.Color.fromXmlString(node.getAttribute('CenterColor'));
	    var outerColors = _color.Color.arrayFromXmlString(node.getAttribute('OuterColors'));
	    p.colors = [centerColor].concat(outerColors);
	  }
	  return new RadialHalftoneBrush(p);
	};
	_util.Xml.addFromBuild(RadialHalftoneBrush, 'RadialHalftoneBrush');
	_util.Xml.addToXml(RadialHalftoneBrush);
	
	Brush.Black = function () {
	  return new Brush({ color: _color.Color.Black() });
	};
	Brush.White = function () {
	  return new Brush({ color: _color.Color.White() });
	};
	
	// EmptyBrush
	//===================================================================================================
	// The system uses an empty brush object to simplify the implementation.
	// We avoid checking for nulls in a lot of cases using this scheme.
	
	var EmptyBrush = exports.EmptyBrush = BrushBase.extend({ typeName: 'EmptyBrush',
	
	  type: 'EmptyBrush',
	
	  empty: function () {
	    return true;
	  },
	
	
	  _empty: true,
	  _type: 'Empty',
	
	  isEqual: function (other) {
	    return other instanceof EmptyBrush;
	  },
	  isNear: function (other /*,eps*/) {
	    return other._empty;
	  },
	
	
	  get color() {
	    return _color.Color.Transparent();
	  },
	
	  getType: function () {
	    return 'Empty';
	  },
	  textualize: function () {
	    return 'EmptyBrush';
	  },
	  buildXml: function () {},
	  setupContext: function () {},
	  setupXml: function () {},
	  getColors: function () {
	    var colors = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    return colors;
	  },
	  invalidate: function () {},
	  needsClipping: function () {
	    return false;
	  },
	  needsFrame: function () {
	    return false;
	  },
	  quickToDraw: function () {
	    return true;
	  },
	  needsFixedDrawing: function () {
	    return false;
	  },
	  containsLinkedResources: function () {
	    return false;
	  }
	});
	_util.Xml.addToXml(EmptyBrush);
	
	Brush.empty = new EmptyBrush();
	Brush.empty._owner = {};
	
	Brush.def = function (b, def) {
	  return b._empty ? def : b;
	};
	
	// [TODO] Move each brush to its own source
	
	// Brush.fromXml checks all types of brushes
	Brush._fromXml = function (node) {
	  var brush = _util.Xml.getObject(node, Brush, 'Brush');
	  if (brush !== null && brush.color.tint < 1) {
	    var color = new Cx.Color();
	    var aux_color = new Cx.Color.fromImageData(Cx.interpolate_rgb(Cx.Color.White().rgbArray, brush.color.rgbArray, brush.color.tint));
	    color.copyProperties(brush.color);
	    color.rgb = aux_color.rgb; //copy all properties except from RGB
	    brush.color = color;
	  }
	  return brush;
	};
	Brush.fromXml = function (node) {
	  return Brush._fromXml(node) || TextureBrush.fromXml(node) || PatternBrush.fromXml(node) || LinearGradientBrush.fromXml(node) || RadialGradientBrush.fromXml(node) || LinearHalftoneBrush.fromXml(node) || RadialHalftoneBrush.fromXml(node) || ColorEngineBrush.fromXml(node) || Brush.empty;
	};
	Brush.fromXmlString = function (xmlString) {
	  var domFigure = _util.Xml.fromString(xmlString);
	  return Brush.fromXml(domFigure.documentElement);
	};
	
	_util.Xml.addFromBuild(Brush, 'Brush');
	_util.Xml.addToXml(Brush);
	
	_util.Xml.Parser['Brush'] = _util.Xml.makeObjectParser(Brush);
	
	function textualizeBrushMeta(brush, s) {
	  var materialId = brush.materialId;
	  var name = brush.name;
	  var tag = brush.tag;
	  var label = brush.label;
	
	  if (materialId) {
	    s += ' M: ' + materialId;
	  }
	  if (name) {
	    s += ' N: ' + name;
	  }
	  if (tag) {
	    s += ' T: ' + tag;
	  }
	  if (label) {
	    s += ' L: ' + label;
	  }
	  return s;
	}

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EmptyPen = exports.MaskPen = exports.DisplayPen = exports.CutPen = exports.Pen = exports.PenBase = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _color = __webpack_require__(31);
	
	var _util = __webpack_require__(17);
	
	var PenBase = exports.PenBase = _gear.OwnedObject.extend({ typeName: 'PenBase', __debugProps: true });
	
	// dashStyle: Solid, Dash, Dot, DashDot, DashDotDot
	// startCap: Flat, Square, Round, Triangle, NoAnchor, SquareAnchor, RoundAnchor, DiamondAnchor, ArrowAnchor, AnchorMask
	// endCap: (see above)
	// dashCap: Flat, Round, Triangle
	// lineJoin: Miter, Bevel, Round, MiterClipped
	
	var Pen = exports.Pen = PenBase.extend({ typeName: 'Pen',
	
	  type: 'Pen',
	
	  Properties: {
	    color: { type: 'Color', def: _color.Color.Transparent(), onChange: _gear.invalidateOwner, owned: true },
	    width: { type: 'magnitude', def: new _gear.Magnitude(0, 'mm'), dropDef: true, onChange: _gear.invalidateOwner },
	    dashStyle: { type: 'string', def: 'Solid', dropDef: true, onChange: _gear.invalidateOwner },
	    startCap: { type: 'string', def: 'Flat', dropDef: true, onChange: _gear.invalidateOwner },
	    endCap: { type: 'string', def: 'Flat', dropDef: true, onChange: _gear.invalidateOwner },
	    dashCap: { type: 'string', def: 'Flat', dropDef: true, onChange: _gear.invalidateOwner },
	    lineJoin: { type: 'string', def: 'Round', onChange: _gear.invalidateOwner },
	    miterLimit: { type: 'number', def: 10.0, dropDef: true, onChange: _gear.invalidateOwner },
	    behindFill: { type: 'boolean', def: true, dropDef: true, onChange: _gear.invalidateOwner },
	    name: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    tag: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    label: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner }
	  },
	  empty: function () {
	    return false;
	  },
	
	  _empty: false,
	  _type: 'Pen',
	
	  isEqual: function (other) {
	    return this.propertiesAreEqual(other);
	  },
	  isNear: function (other, eps) {
	    // Quite hacky
	    if (Math.abs(this._width - other._width) > eps) {
	      return false;
	    }
	    var thisWidth = this._width,
	        otherWidth = other._width;
	    this._width = new _gear.Magnitude(0, 'mm');other._width = new _gear.Magnitude(0, 'mm');
	    var near = this.propertiesAreEqual(other);
	    this._width = thisWidth;other._width = otherWidth;
	    return near;
	  },
	  setupContext: function (context, matrix) {
	    context.strokeStyle = this._color.rgba;
	    var w = context.lineWidth = this._width * (matrix ? matrix.scaleFactor() : 1.0);
	    var miterLimit = void 0,
	        lineJoin = void 0;
	    if (this._lineJoin === 'AdaptiveMiter') {
	      // In Corel, the Miter Limit is an angle limit. If the corner has an angle smaller than the
	      // limit it gets belved.
	      var miterAngleLimit = this._miterLimit;
	
	      // We are using the GDI definition (same as the SVG definition), see:
	      // http://msdn.microsoft.com/en-us/library/system.drawing.pen.miterlimit.aspx
	
	      // We can express:
	      // MiterLimit = miterLength/penWidth = sin( miterAngleLimit/2 )
	      var directMiterLimit = 1.0 / Math.sin((0, _gear.deg2rad)(miterAngleLimit) / 2);
	
	      // Corel belves the angle heavily if you get past that angle. So the miter limit
	      // should be reduced to start producing its smooth effect before we reach that angle.
	      var convertionFactor = 1.0; // 0.55 ;
	
	      miterLimit = convertionFactor * directMiterLimit;
	      lineJoin = 'miter';
	    } else {
	      miterLimit = this._miterLimit;
	      lineJoin = this._lineJoin.toLowerCase();
	    }
	    context.lineJoin = lineJoin;
	    context.miterLimit = miterLimit;
	
	    var cap = this._dashCap.toLowerCase(); // Flat is the default, Triangle is not supported.
	
	    var capCorrection = 0;
	    if (cap === 'round') {
	      context.lineCap = cap;
	      capCorrection = w * 0.9;
	    }
	
	    var dashStyle = this._dashStyle;
	    var dash = 3 * w - capCorrection,
	        space = w + capCorrection,
	        dot = w - capCorrection;
	    if (dashStyle !== 'Solid') {
	      (0, _gear.setLineDash)(context, dashStyle === 'Dash' ? [dash, space] : dashStyle === 'Dot' ? [dot, space] : dashStyle === 'DashDot' ? [dash, space, dot, space] : dashStyle === 'DashDotDot' ? [dash, space, dot, space, dot, space] : []);
	    }
	  },
	  getType: function () {
	    return this._type;
	  },
	  getColors: function () {
	    var colors = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    colors.push(this._color);
	    return colors;
	  },
	
	  invalidate: _gear.invalidateOwner
	});
	
	// We use 'Pen' in object types to be able to construct a default brush
	// Overwrite the Base construct. We need to review this
	Pen.construct = function (v) {
	  if (v === null) {
	    return v;
	  } else if (v instanceof PenBase) {
	    return v.adopted(this);
	  } else {
	    return new Pen(v).owner(this);
	  }
	};
	
	Pen.fromWidthRgb = function (width, rgb, alpha) {
	  return new Pen({ width: new _gear.Magnitude(width, 'mm'), color: _color.Color.fromRgb(rgb, alpha) });
	};
	
	var CutPen = exports.CutPen = PenBase.extend({ typeName: 'CutPen',
	
	  type: 'CutPen',
	
	  Properties: {
	    color: { type: 'Color', def: _color.Color.CutPen(), onChange: _gear.invalidateOwner, owned: true },
	    name: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    tag: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    label: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner }
	  },
	
	  behindFill: function () {
	    return false;
	  },
	  empty: function () {
	    return false;
	  },
	
	  _empty: false,
	  _type: 'CutPen',
	  _width: new _gear.Magnitude(0, 'mm'),
	
	  width: function (v) {
	    return v === undefined ? new _gear.Magnitude(0, 'mm') : this; // [TODO] Review this idiom
	  },
	  isEqual: function (other) {
	    return this.propertiesAreEqual(other);
	  },
	  getType: function () {
	    return this._type;
	  },
	  getColors: function () {
	    var colors = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    return colors;
	  },
	  setupContext: function (context) {
	    context.strokeStyle = this._color.rgba;
	    context.lineWidth = 1;
	  },
	
	  invalidate: _gear.invalidateOwner
	});
	_util.Xml.addFromBuild(CutPen, 'CutPen');
	_util.Xml.addToXml(CutPen);
	
	var DisplayPen = exports.DisplayPen = PenBase.extend({ typeName: 'DisplayPen',
	
	  type: 'DisplayPen',
	
	  // Should we add a color as a hint to the apps?
	  Properties: {
	    // color : { type: 'Color', def: Color.CutPen(), onChange:invalidateOwner, owned:true }
	    xType: { type: 'string', def: null, onChange: _gear.invalidateOwner },
	    name: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    tag: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    label: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner }
	  },
	
	  behindFill: function () {
	    return false;
	  },
	  empty: function () {
	    return false;
	  },
	
	  _empty: false,
	  _type: 'DisplayPen',
	  _width: new _gear.Magnitude(0, 'mm'),
	  width: function (v) {
	    return v === undefined ? new _gear.Magnitude(0, 'mm') : this;
	  },
	  // [TODO] Review this idiom
	
	  isEqual: function (other) {
	    return this.propertiesAreEqual(other);
	  },
	  getType: function () {
	    return this._type;
	  },
	  getColors: function () {
	    var colors = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    return colors;
	  },
	
	  invalidate: _gear.invalidateOwner
	});
	_util.Xml.addFromBuild(DisplayPen, 'DisplayPen');
	_util.Xml.addToXml(DisplayPen);
	
	var MaskPen = exports.MaskPen = PenBase.extend({ typeName: 'MaskPen',
	
	  type: 'MaskPen',
	
	  // Should we add a color as a hint to the apps?
	  Properties: {
	    // color : { type: 'Color', def: Color.CutPen(), onChange:invalidateOwner, owned:true }
	    xType: { type: 'string', def: null, onChange: _gear.invalidateOwner },
	    name: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    tag: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    label: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner }
	  },
	
	  behindFill: function () {
	    return false;
	  },
	  empty: function () {
	    return false;
	  },
	
	  _empty: false,
	  _type: 'MaskPen',
	  _width: new _gear.Magnitude(0, 'mm'),
	  width: function (v) {
	    return v === undefined ? new _gear.Magnitude(0, 'mm') : this;
	  },
	  // [TODO] Review this idiom
	
	  isEqual: function (other) {
	    return this.propertiesAreEqual(other);
	  },
	  getType: function () {
	    return this._type;
	  },
	  getColors: function () {
	    var colors = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    return colors;
	  },
	
	  invalidate: _gear.invalidateOwner
	});
	_util.Xml.addFromBuild(MaskPen, 'MaskPen');
	_util.Xml.addToXml(MaskPen);
	
	var EmptyPen = exports.EmptyPen = PenBase.extend({ typeName: 'EmptyPen',
	  type: 'EmptyPen',
	  empty: function () {
	    return true;
	  },
	
	  _empty: true,
	  _type: 'Empty',
	  _width: new _gear.Magnitude(0, 'mm'),
	
	  getType: function () {
	    return 'Empty';
	  },
	
	
	  get width() {
	    return new _gear.Magnitude(0, 'mm');
	  },
	  get color() {
	    return _color.Color.Transparent();
	  },
	  get name() {
	    return null;
	  },
	  get tag() {
	    return null;
	  },
	  get label() {
	    return null;
	  },
	
	  buildXml: function () {},
	  setupXml: function () {},
	  isEqual: function (other) {
	    return other instanceof EmptyPen;
	  },
	  isNear: function (other /*,eps*/) {
	    return other._empty;
	  },
	  getColors: function () {
	    var colors = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    return colors;
	  },
	  invalidate: function () {}
	});
	_util.Xml.addToXml(EmptyPen);
	
	Pen.empty = new EmptyPen();
	Pen.empty._owner = {};
	
	Pen.def = function (p, def) {
	  return p._empty ? def : p;
	};
	
	Pen.arrayFromXml = function (node) {
	  var pcNode = _util.Xml.child(node, 'Pens');
	  if (pcNode) {
	    node = pcNode;
	  }
	  return _util.Xml.getObjectArray(node, Pen, 'Pen'); // [TODO] Support CutPen
	};
	
	Pen.arrayBuildXml = function (node, v) {
	  if ((0, _lodash.isEmpty)(v)) {
	    return;
	  }
	  var pcNode = _util.Xml.appendElement(node, 'Pens');
	  _util.Xml.addObjectArray(pcNode, v);
	};
	
	// Pen.fromXml checks all types of pens
	Pen._fromXml = function (node) {
	  return _util.Xml.getObject(node, Pen, 'Pen');
	};
	Pen.fromXml = function (node) {
	  return Pen._fromXml(node) || CutPen.fromXml(node) || DisplayPen.fromXml(node) || MaskPen.fromXml(node) || Pen.empty;
	};
	Pen.fromXmlString = function (xmlString) {
	  var domFigure = _util.Xml.fromString(xmlString);
	  return Pen.fromXml(domFigure.documentElement);
	};
	
	_util.Xml.addFromBuild(Pen, 'Pen');
	_util.Xml.addToXml(Pen);
	
	_util.Xml.Parser['Pen'] = _util.Xml.makeObjectParser(Pen);
	_util.Xml.Parser['Pen[]'] = _util.Xml.makeArrayObjectParser(Pen);

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RGBMap = exports.ColorEngineMap = exports.MonochromeColors = exports.GradientColorMap = exports.TaggedColors = exports.ColorMap = undefined;
	
	var _config = __webpack_require__(2);
	
	var _brush = __webpack_require__(32);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	var _geometry = __webpack_require__(21);
	
	var _color = __webpack_require__(31);
	
	var _colorSpace = __webpack_require__(30);
	
	var toImageData = function (image) {
	  var context = void 0;
	  if (image instanceof HTMLImageElement) {
	    var canvas = document.createElement('canvas');
	    canvas.width = image.width;
	    canvas.height = image.height;
	    context = canvas.getContext('2d');
	    context.drawImage(image, 0, 0);
	  } else {
	    context = image.getContext('2d');
	  }
	  return context.getImageData(0, 0, image.width, image.height);
	};
	
	var toCanvas = function (imageData) {
	  var canvas = document.createElement('canvas');
	  canvas.width = imageData.width;
	  canvas.height = imageData.height;
	  canvas.getContext('2d').putImageData(imageData, 0, 0);
	  return canvas;
	};
	
	var _floor = Math.floor,
	    _min = Math.min,
	    _max = Math.max,
	    _sqrt = Math.sqrt;
	
	var interpolate_value = function (l1, l2, a) {
	  return l1 + (l2 - l1) * a;
	};
	
	// Scale Functions, convert a true color to gray scale using
	// different strategies
	
	var rgb2 = {
	  CieLightness: function (r, g, b) {
	    // CieLAB color space
	    // https://en.wikipedia.org/wiki/Lab_color_space
	    return (0, _colorSpace.rgb2lab)([r, g, b])[0] / 100;
	  },
	  Luma: function (r, g, b) {
	    // XYZ model using sRGB gamut
	    return (0, _colorSpace.rgb2xyz)([r, g, b])[1] / 100; // 0.2126*r' + 0.7152*g' + 0.722*b'
	  },
	  Luminance: function (r, g, b) {
	    // Same formula a Luma, but using rgb directly
	    // https://en.wikipedia.org/wiki/Luma_(video)
	    return (2126 * r + 7152 * g + 722 * b) / (255 * 10000);
	  },
	  Brightness: function (r, g, b) {
	    // YIQ color space, W3C working draft
	    // https://en.wikipedia.org/wiki/YIQ
	    // http://www.w3.org/TR/AERT#color-contrast
	    return (299 * r + 587 * g + 114 * b) / (255 * 1000);
	  },
	  BrightnessP: function (r, g, b) {
	    // Similar to Adobe Photoshop RGB->Grayscale method?
	    // This is not standard, slow and doesn't have real info
	    // http://alienryderflex.com/hsp.html
	    var red = r / 255,
	        green = g / 255,
	        blue = b / 255;
	    return _sqrt(0.299 * (red * red) + 0.587 * (green * green) + 0.114 * (blue * blue));
	  },
	  Lightness: function (r, g, b) {
	    // HSL color space
	    return (_max(r, g, b) + _min(r, g, b)) / (2 * 255);
	  },
	  Value: function (r, g, b) {
	    // HSV color space
	    return _max(r, g, b) / 255;
	  },
	  Intensity: function (r, g, b) {
	    // HSI color space, just for completeness
	    // https://en.wikipedia.org/wiki/HSL_and_HSV
	    return (r + g + b) / (3 * 255);
	  },
	
	
	  // Color separation
	  Red: function (r /*,g,b*/) {
	    return r / 255;
	  },
	  Green: function (r, g /*,b*/) {
	    return g / 255;
	  },
	  Blue: function (r, g, b) {
	    return b / 255;
	  },
	  LCH: function (r, g, b) {
	    return (0, _colorSpace.rgb2lch)([r, g, b]);
	  },
	  LAB: function (r, g, b) {
	    return (0, _colorSpace.rgb2lab)([r, g, b]);
	  },
	  HSL: function (r, g, b) {
	    return (0, _colorSpace.rgb2hsl)([r, g, b]);
	  },
	  RGB: function (r, g, b) {
	    return [r, g, b];
	  }
	};
	
	var slowScaleFunction = {
	  CieLightness: true,
	  Luma: true,
	  BrightnessP: true
	};
	
	var createScaleFunction = function (scaleMap, res) {
	  var scaleFunction = rgb2[scaleMap];
	  if (slowScaleFunction[scaleMap] && res > 0) {
	    // Avoid converting each pixel to complex color spaces
	    scaleFunction = cachedRGBCubeMap(scaleFunction, interpolate_value, res);
	  }
	  return scaleFunction;
	};
	
	var gradient_map = { LCH: _colorSpace.rgb2lch, LAB: _colorSpace.rgb2lab, HSL: _colorSpace.rgb2hsl, RGB: function (c) {
	    return c;
	  }
	};
	var gradient_mapBack = { LCH: _colorSpace.lch2rgb, LAB: _colorSpace.lab2rgb, HSL: _colorSpace.hsl2rgb, RGB: function (c) {
	    return c;
	  }
	};
	var gradient_interpolate = {
	  LCH: _colorSpace.interpolate_lch, LAB: _colorSpace.interpolate_lab, HSL: _colorSpace.interpolate_hsl, RGB: _colorSpace.interpolate_rgb
	};
	
	var createRGBGradientFunction = function (gradient, res) {
	
	  // 0...1 to get the gradient RGB at that position
	  return function (x) {
	    var x_res = x * res,
	        i = _floor(x_res);
	    return i < 0 ? gradient[0] : i < res ? (0, _colorSpace.interpolate_rgb)(gradient[i], gradient[i + 1], x_res - i) : gradient[res];
	  };
	};
	
	var createRGBGradient = function (colors, positions, gradientType, res) {
	  var gmap = gradient_map[gradientType];
	  var gmapBack = gradient_mapBack[gradientType];
	  var interpolate = gradient_interpolate[gradientType];
	
	  var n = colors.length;
	
	  var mappedColors = (0, _lodash.map)((0, _lodash.map)(colors, 'rgbArray'), gmap);
	  var rgbGradient = [];
	  var first_position = positions[0];
	  var last_position = positions[n - 1];
	
	  var current = 1;
	
	  for (var k = 0; k <= res; ++k) {
	    var pos = k / res;
	    var rgb = void 0;
	
	    if (pos <= first_position) {
	      rgb = colors[0].rgbArray;
	    } else if (pos >= last_position) {
	      rgb = colors[n - 1].rgbArray;
	    } else {
	      while (current < n && positions[current] < pos) {
	        ++current;
	      }
	      var prev = current - 1;
	      var positions_current = positions[current],
	          positions_prev = positions[prev];
	      var a = (pos - positions_prev) / (positions_current - positions_prev);
	      var c = interpolate(mappedColors[prev], mappedColors[current], a);
	      rgb = gmapBack(c);
	    }
	
	    rgbGradient[k] = rgb;
	  }
	
	  return createRGBGradientFunction(rgbGradient, res);
	};
	
	var cachedRGBCubeMap = function (map, interpolate, res) {
	  var v = [];
	  for (var r = 0; r <= res; ++r) {
	    var gb = [];
	    for (var g = 0; g <= res; ++g) {
	      gb.push([]);
	    }
	    v.push(gb);
	  }
	
	  var _res_255 = res / 255,
	      _255_res = 255 / res;
	
	  var _map = function (ri, gi, bi) {
	    var rgb = v[ri][gi][bi];
	    if (!rgb) {
	      rgb = map(ri * _255_res, gi * _255_res, bi * _255_res);
	      v[ri][gi][bi] = rgb;
	    }
	    return rgb;
	  };
	
	  return function (r, g, b) {
	    var rc = r * _res_255,
	        gc = g * _res_255,
	        bc = b * _res_255;
	    var ri = _floor(rc),
	        gi = _floor(gc),
	        bi = _floor(bc);
	    rc -= ri;gc -= gi;bc -= bi;
	
	    // This can be optimized
	    if (ri === res) {
	      ri = res - 1;
	      rc = 1;
	    }
	    if (gi === res) {
	      gi = res - 1;
	      gc = 1;
	    }
	    if (bi === res) {
	      bi = res - 1;
	      bc = 1;
	    }
	
	    var c_000 = _map(ri, gi, bi);
	    var c_100 = _map(ri + 1, gi, bi);
	    var c_010 = _map(ri, gi + 1, bi);
	    var c_110 = _map(ri + 1, gi + 1, bi);
	    var c_001 = _map(ri, gi, bi + 1);
	    var c_101 = _map(ri + 1, gi, bi + 1);
	    var c_011 = _map(ri, gi + 1, bi + 1);
	    var c_111 = _map(ri + 1, gi + 1, bi + 1);
	
	    var c_x00 = interpolate(c_000, c_100, rc);
	    var c_x10 = interpolate(c_010, c_110, rc);
	    var c_x01 = interpolate(c_001, c_101, rc);
	    var c_x11 = interpolate(c_011, c_111, rc);
	
	    var c_xx0 = interpolate(c_x00, c_x10, gc);
	    var c_xx1 = interpolate(c_x01, c_x11, gc);
	
	    var c_xxx = interpolate(c_xx0, c_xx1, bc);
	
	    return c_xxx;
	  };
	};
	
	// We should drop old cached color maps, changing a lot of colors could consume a lot of memory
	var colorMapCache = {};
	var colorMapCacheList = [];
	
	var cachedColorMap = function (fun) {
	  if (!_config.Config.colorMapCaching) {
	    return fun;
	  }
	
	  return function (image, id) {
	    var cm_id = id + '(' + image.width + ',' + image.height + ')[' + this.textualize() + ']';
	    var cachedResult = colorMapCache[cm_id];
	    if (cachedResult) {
	      return cachedResult;
	    }
	    // Not cached, perform the operation
	    var result = fun.call(this, image, id);
	    colorMapCache[cm_id] = result;
	    colorMapCacheList.push(cm_id);
	    if (colorMapCacheList.length > _config.Config.colorMapCacheSize) {
	      var old_cm_id = colorMapCacheList.shift();
	      delete colorMapCache[old_cm_id];
	    }
	    return result;
	  };
	};
	
	// values between 0...255
	// map :: function(r,g,b,a){ return [ r*, g*, b*, a* ]; }
	
	var modifyImageDataRGBA = function (imageData, map) {
	  var data = imageData.data,
	      width = imageData.width,
	      height = imageData.height;
	  var y = void 0,
	      x = void 0,
	      inpos = void 0,
	      outpos = void 0,
	      r = void 0,
	      g = void 0,
	      b = void 0,
	      a = void 0;
	
	  for (y = 0; y < height; ++y) {
	    inpos = y * width * 4; // *4 for 4 ints per pixel
	    outpos = inpos;
	    for (x = 0; x < width; ++x) {
	
	      r = data[inpos++];
	      g = data[inpos++];
	      b = data[inpos++];
	      a = data[inpos++]; // alpha
	
	      // http://www.w3.org/TR/AERT#color-contrast
	      var c = map(r, g, b, a);
	
	      data[outpos++] = c[0];
	      data[outpos++] = c[1];
	      data[outpos++] = c[2];
	      data[outpos++] = c[3];
	    }
	  }
	};
	
	// values between 0...255
	// map :( r,g,b) { return [ r*, g*, b* ]; }
	
	var modifyImageDataRGB = function (imageData, map) {
	  var data = imageData.data,
	      width = imageData.width,
	      height = imageData.height;
	  var y = void 0,
	      x = void 0,
	      inpos = void 0,
	      outpos = void 0,
	      r = void 0,
	      g = void 0,
	      b = void 0;
	
	  for (y = 0; y < height; ++y) {
	    inpos = y * width * 4; // *4 for 4 ints per pixel
	    outpos = inpos;
	    for (x = 0; x < width; ++x) {
	
	      r = data[inpos++];
	      g = data[inpos++];
	      b = data[inpos++];
	
	      ++inpos; // alpha
	
	      // http://www.w3.org/TR/AERT#color-contrast
	      var c = map(r, g, b);
	
	      data[outpos++] = c[0];
	      data[outpos++] = c[1];
	      data[outpos++] = c[2];
	
	      ++outpos; // alpha
	    }
	  }
	};
	
	var ColorMap = exports.ColorMap = _gear.OwnedObject.extend({ typeName: 'ColorMap', __debugProps: true,
	  Properties: {
	    // ...
	  },
	  init: function (config) {
	    this.callParent(config);
	    // ...
	  },
	
	  invalidate: _gear.invalidateOwner
	});
	
	// TaggedColors
	//======================================================================================
	
	
	var TaggedColors = exports.TaggedColors = ColorMap.extend({ typeName: 'TaggedColors',
	
	  Properties: {
	    colors: { type: 'Color[]', def: [_color.Color.Black(), _color.Color.White()], owned: true, onChange: _gear.invalidateOwner }
	  },
	
	  invalidate: _gear.invalidateOwner,
	
	  getColors: function () {
	    var colors = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    (0, _lodash.forEach)(this.colors, function (c) {
	      colors.push(c);
	    });
	    return colors;
	  },
	  textualize: function () {
	    return this._colors.textualize();
	  },
	  recolorized: function (thing) {
	    return this.recolorize(thing.clone());
	  },
	  recolorize: function (thing) {
	    var thingColors = thing.getColors();
	    var colors = this._colors;
	    var toColorMap = {};
	    for (var i = 0, iEnd = colors.length; i < iEnd; ++i) {
	      var color = colors[i],
	          tag = color._tag;
	      if (tag) {
	        toColorMap[tag] = color;
	      }
	      // [TODO] else assert!
	    }
	    for (var k = 0, kEnd = thingColors.length; k < kEnd; ++k) {
	      var tc = thingColors[k];
	      var tc_tag = tc._tag;
	      if (tc_tag) {
	        var toColor = toColorMap[tc_tag];
	        if (toColor) {
	          tc.replace(toColor);
	        }
	      }
	    }
	    return thing;
	  }
	});
	
	_util.Xml.addFromBuild(TaggedColors, 'Colors');
	
	// GradientColorMap
	//======================================================================================
	
	var GradientColorMap = exports.GradientColorMap = ColorMap.extend({ typeName: 'GradientColorMap',
	
	  Properties: {
	    positions: { type: 'number[]', def: [0, 1], onChange: _gear.invalidateOwner },
	    colors: { type: 'Color[]', def: [_color.Color.Black(), _color.Color.White()], owned: true, onChange: _gear.invalidateOwner },
	    scaleMap: { type: 'string', def: 'CieLightness', onChange: _gear.invalidateOwner },
	    gradientType: { type: 'string', def: 'LAB', onChange: _gear.invalidateOwner }
	  },
	
	  invalidate: _gear.invalidateOwner,
	
	  getColors: function () {
	    var colors = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    var this_colors = this._colors;
	    //_.forEach(this_colors,function(c) {
	    for (var k = 0, kEnd = this_colors.length; k < kEnd; ++k) {
	      var c = this_colors[k];
	      colors.push(c);
	    } //);
	    return colors;
	  },
	  rgbGradient: function () {
	    // This can be cached
	    return createRGBGradient(this._colors, this._positions, this._gradientType, _config.Config.GradientColorMap_scaleRes);
	  },
	  textualize: function () {
	    return this._colors.textualize() + '|' + this._positions.textualize();
	  },
	
	  recolorize: cachedColorMap(function (image) {
	    var _this = this;
	
	    var scaleMap = this._scaleMap;
	
	    var imageData = toImageData(image);
	
	    var scaleFunction = createScaleFunction(scaleMap, _config.Config.GradientColorMap_RGBCubeRes);
	    if (scaleFunction) {
	      (function () {
	
	        var rgbGradient = _this.rgbGradient();
	
	        modifyImageDataRGB(imageData, function (r, g, b) {
	          return rgbGradient(scaleFunction(r, g, b));
	        });
	      })();
	    } else {
	      console.log('GradientColorMap, Unsupported ScaleMap: ' + scaleMap);
	    }
	
	    return toCanvas(imageData);
	  })
	});
	
	_util.Xml.addFromBuild(GradientColorMap, 'GradientColorMap');
	
	// MonochromeColors
	//======================================================================================
	
	var MonochromeColors = exports.MonochromeColors = ColorMap.extend({ typeName: 'MonochromeColors',
	
	  Properties: {
	    colors: { type: 'Color[]', def: [_color.Color.White(), _color.Color.Black()], owned: true, onChange: _gear.invalidateOwner }
	  },
	
	  invalidate: _gear.invalidateOwner,
	
	  getColors: function () {
	    var colors = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    var this_colors = this._colors;
	    colors.push(this_colors[0]);
	    colors.push(this_colors[1]);
	    return colors;
	  },
	  textualize: function () {
	    return this._colors.textualize();
	  },
	
	
	  recolorize: cachedColorMap(function (image) {
	
	    // This is a gradient color map that also modifies the alpha values of the output
	    // We may extend gradient color map to also do this, but it is not clear
	    // the best way forward at this point
	
	    var imageData = toImageData(image);
	
	    var scaleFunction = createScaleFunction('Brightness', _config.Config.GradientColorMap_RGBCubeRes);
	
	    // Values are inverted in MonochromeColors
	    var colors = this._colors;
	
	    var color_0 = colors[1],
	        color_1 = colors[0];
	
	    var alpha_0 = color_0._alpha * 255,
	        alpha_1 = color_1._alpha * 255;
	
	    // Discard garbage rgb value for the special case of total transparency
	    if (alpha_0 === 0) {
	      color_0 = color_1;
	    }
	    if (alpha_1 === 0) {
	      color_1 = color_0;
	    }
	
	    var rgbGradient = createRGBGradient([color_0, color_1], [0, 1], 'LAB', _config.Config.GradientColorMap_scaleRes);
	
	    modifyImageDataRGBA(imageData, function (r, g, b /*,a*/) {
	      var value = scaleFunction(r, g, b);
	      var c = rgbGradient(value);
	
	      // Interpolate alpha
	      c[3] = alpha_0 * (1 - value) + alpha_1 * value;
	      return c;
	    });
	
	    return toCanvas(imageData);
	  })
	});
	
	_util.Xml.addFromBuild(MonochromeColors, 'MonochromeColors');
	
	// ColorEngineMap
	//======================================================================================
	
	var ColorEngineMap = exports.ColorEngineMap = ColorMap.extend({ typeName: 'ColorEngineMap',
	
	  Properties: {
	    brush: { type: 'Brush', def: new _brush.ColorEngineBrush({ color: _color.Color.White() }), onChange: _gear.invalidateOwner }
	  },
	
	  invalidate: _gear.invalidateOwner,
	
	  getColors: function () {
	    var colors = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    colors.push(this._brush._color);
	    return colors;
	  },
	  textualize: function () {
	    return this._brush._colors.textualize();
	  },
	
	
	  recolorize: function (image) {
	
	    var imageData = toImageData(image);
	
	    var color = this._brush._color;
	
	    if (color.colorType == 'CE') {
	      var colors;
	
	      (function () {
	        colors = [];
	
	
	        colors.push(_color.Color.fromRgb(color.ceRGBShad));
	        colors.push(_color.Color.fromRgb(color.ceRGBMid));
	        colors.push(_color.Color.fromRgb(color.ceRGBHigh));
	
	        var rgbGradient = createRGBGradient(colors, [0, 0.5, 1], 'RGB', _config.Config.GradientColorMap_scaleRes);
	
	        modifyImageDataRGBA(imageData, function (r, g, b, a) {
	          var c = rgbGradient(b / 255.0);
	          c[3] = a;
	          return c;
	        });
	      })();
	    }
	
	    return toCanvas(imageData);
	  }
	});
	
	_util.Xml.addFromBuild(ColorEngineMap, 'ColorEngineMap');
	
	// RGBMap
	//======================================================================================
	/*
	
	<RGBMap>
	  <Entry SourceRGB="FF0000">
	    <Color RGB="00FF00"/>
	  </Entry>
	  <Entry SourceRGB="FF0000">
	    <Color RGB="00FF00"/>
	  </Entry>
	</RGBMap>
	
	*/
	
	var RGBMapEntry = _gear.OwnedObject.extend({ typeName: 'RGBMapEntry',
	
	  Properties: {
	    sourcePos: { type: 'Point', def: new _geometry.Point(0.5, 0.5), onChange: _gear.invalidateOwner },
	    sourceRGB: { type: 'string', def: '000000', onChange: _gear.invalidateOwner },
	    scope: { type: 'number', def: 0.2, onChange: _gear.invalidateOwner },
	    color: { type: 'Color', def: _color.Color.Black(), owned: true, onChange: _gear.invalidateOwner }
	  },
	  invalidate: _gear.invalidateOwner,
	
	  getColors: function (colors) {
	    colors.push(this._color);
	    return colors;
	  },
	  textualize: function () {
	    return this._sourceRGB + '=>' + this._color.textualize();
	  }
	});
	_util.Xml.addFromBuild(RGBMapEntry, 'Entry');
	
	RGBMapEntry.arrayFromXml = function (node) {
	  return _util.Xml.getObjectArray(node, RGBMapEntry, 'Entry');
	};
	
	var distance = function (a, b) {
	  var d_0 = a[0] - b[0],
	      d_1 = a[1] - b[1],
	      d_2 = a[2] - b[2];
	  return d_0 * d_0 + d_1 * d_1 + d_2 * d_2;
	};
	
	var _0_100 = function (v) {
	  return Math.max(0, Math.min(v, 100));
	};
	
	var _0_360 = function (v) {
	  if (v > 360) {
	    return v - 360;
	  }
	  if (v < 0) {
	    return v + 360;
	  }
	  return v;
	};
	
	// c_factor and f_factor are curves depending on chroma like:
	//
	//  1         ________________________
	//      |   /                        .
	//      |  /                         .
	//      | /                          .
	//  0   |/___________________________._
	//      0   10                     100
	//
	var chromaFactor = function (c) {
	  // 0 ... 100 =>  0 ... 1
	  return c < 10 ? 0.1 * c : 1;
	};
	
	// Simple, this may be the best one
	
	var result_h_a = function (h, cf, sh, sf, th, tf) {
	  // When cf==1, sf==1 and tf==1 we need to apply the easy formula
	  //
	  // result = h + ( th - sh );
	
	  // If cf==0 or sf==0 we need to ignore the pixel hue and just
	  //                   map directly to the target hue
	  //
	  // If tf==0 we need to leave the current hue as is
	
	  var ff = cf * sf;
	
	  return ff * h + (th - ff * sh) * tf;
	};
	
	// Testing different strategies
	
	var result_h_b = function (h, cf, sh, sf, th, tf) {
	  // When cf==1, sf==1 and tf==1 we need to apply the easy formula
	  //
	  var result_h_0 = h + (th - sh);
	
	  // If cf==0 or sf==0 we need to ignore the pixel hue and just
	  //                   map directly to the target hue
	
	  var ff = cf * sf;
	  var result_h_1 = ff * result_h_0 + (1 - ff) * th;
	
	  // If tf==0 we need to leave the current hue as is
	
	  return tf * result_h_1 + (1 - tf) * h;
	};
	
	// Same as b but inverted
	var result_h_c = function (h, cf, sh, sf, th, tf) {
	  // When cf==1, sf==1 and tf==1 we need to apply the easy formula
	  //
	  var result_h_0 = h + (th - sh);
	
	  // If tf==0 we need to leave the current hue as is
	
	  var result_h_1 = tf * result_h_0 + (1 - tf) * h;
	
	  // If cf==0 or sf==0 we need to ignore the pixel hue and just
	  //                   map directly to the target hue
	  var ff = cf * sf;
	  return ff * result_h_1 + (1 - ff) * th;
	};
	
	var rgbMapFunction = function (entries, toDistanceSpace, fromDistanceSpace, distance /*,interpolateSpace,interpolate*/) {
	  var sourceColor = (0, _lodash.map)(entries, function (e) {
	    var c = (0, _color.Color)({ rgb: e.sourceRGB });
	    return toDistanceSpace(c.r(), c.g(), c.b());
	  });
	  var toRGB = (0, _lodash.map)(entries, function (e) {
	    return e.color.rgbArray;
	  });
	
	  var toLCH = (0, _lodash.map)(toRGB, _colorSpace.rgb2lch);
	
	  var sourceLCH = (0, _lodash.map)(entries, function (e) {
	    var c = new _color.Color({ rgb: e.sourceRGB });
	    return (0, _colorSpace.rgb2lch)(c.rgbArray);
	  });
	
	  var lDiff = (0, _lodash.map)(sourceLCH, function (s, i) {
	    return toLCH[i][0] - sourceLCH[i][0];
	  });
	  var cDiff = (0, _lodash.map)(sourceLCH, function (s, i) {
	    return toLCH[i][1] - sourceLCH[i][1];
	  });
	
	  // Hue needs to take into account the chroma of the source and the target
	
	  var sourceHue = (0, _lodash.map)(sourceLCH, function (lch) {
	    return lch[2];
	  });
	
	  var toHue = (0, _lodash.map)(toLCH, function (lch) {
	    return lch[2];
	  });
	
	  var sourceChromaFactor = (0, _lodash.map)(sourceLCH, function (lch) {
	    return chromaFactor(lch[1]);
	  });
	
	  var toChromaFactor = (0, _lodash.map)(toLCH, function (lch) {
	    return chromaFactor(lch[1]);
	  });
	
	  var configHueShiftFunc = _config.Config.hueShiftFunc;
	  var result_h_func = configHueShiftFunc === 'C' ? result_h_c : configHueShiftFunc === 'B' ? result_h_b : result_h_a;
	
	  var sourceLimit = (0, _lodash.map)(entries, function (e) {
	    var n = 255 * e.scope;
	    return distance(toDistanceSpace(0, 0, 0), toDistanceSpace(n, n, n));
	  });
	
	  return function (r, g, b) {
	    var min_k = null,
	        min_distance = Number.MAX_VALUE;
	    for (var k = 0, kEnd = sourceColor.length; k < kEnd; ++k) {
	      var ds = toDistanceSpace(r, g, b);
	      var sc = sourceColor[k];
	      var dist = distance(sc, ds);
	      if (dist <= sourceLimit[k]) {
	        if (dist < min_distance) {
	          min_k = k;
	          min_distance = dist;
	        }
	      }
	    }
	
	    if (min_k !== null) {
	      var _k = min_k;
	
	      // Modify the pixel RGB
	      var lch = (0, _colorSpace.rgb2lch)([r, g, b]);
	
	      var l = lch[0],
	          c = lch[1],
	          h = lch[2];
	
	      // Modify hue taking into account chroma
	      // Do not take into account the source hue if the source color
	      // doesn't have enough chroma
	      // Leave the chroma as is if the target doesn't have enough chroma
	      // Black ( Chroma: 0, Hue: X ) -> White ( Chroma: 0, Hue: X )
	      // Black ( Chroma: 0, Hue: X ) -> Green ( Chroma: 1, Hue: G )
	      // Green ( Chroma: 1, Hue: G ) -> Black ( Chroma: 1, Hue: G )
	      // Green ( Chroma: 1, Hue: G ) -> Red   ( Chroma: 1, Hue: R )
	
	      var sh = sourceHue[_k],
	          th = toHue[_k],
	          cf = chromaFactor(c),
	          // 0...1
	      sf = sourceChromaFactor[_k],
	          // 0...1
	      tf = toChromaFactor[_k]; // 0...1
	
	      var result_h = result_h_func(h, cf, sh, sf, th, tf);
	
	      // Direct modification of lightness and chroma
	      var result_l = l + lDiff[_k];
	      var result_c = c + cDiff[_k];
	
	      var new_rgb = (0, _colorSpace.lch2rgb)([_0_100(result_l), _0_100(result_c), _0_360(result_h)]);
	
	      return new_rgb;
	    }
	    return [r, g, b];
	  };
	};
	
	var RGBMap = exports.RGBMap = ColorMap.extend({ typeName: 'RGBMap',
	
	  Properties: {
	    entries: { type: 'RGBMapEntry[]', def: [], owned: true, onChange: _gear.invalidateOwner },
	    distance: { type: 'string', def: 'LAB', onChange: _gear.invalidateOwner },
	    interpolate: { type: 'string', def: 'LAB', onChange: _gear.invalidateOwner }
	  },
	
	  get topFigure() {
	    var o = this._owner;
	    return o && o.topFigure;
	  },
	  ownerPos_: function (point) {
	    var f = this.topFigure;
	    var bounds = f.globalBounds_();
	    return bounds.deinterpolate(point);
	  },
	  globalPoint_: function (pos) {
	    var f = this.topFigure;
	    var bounds = f.globalBounds_();
	    return bounds.interpolate(pos);
	  },
	
	  invalidate: _gear.invalidateOwner,
	
	  getColors: function () {
	    var colors = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    var this_entries = this._entries;
	    //_.forEach(this_colors,function(c) {
	    for (var k = 0, kEnd = this_entries.length; k < kEnd; ++k) {
	      var e = this_entries[k];
	      e.getColors(colors);
	    } //);
	    return colors;
	  },
	  textualize: function () {
	    return this._entries.textualize();
	  },
	  rgbMapFunction: function () {
	    var rgbMapFunc = rgbMapFunction(this._entries, rgb2[this._distance], null, distance, null);
	
	    var res = _config.Config.RGBMap_RGBCubeRes;
	
	    return res > 0 ? cachedRGBCubeMap(rgbMapFunc, _colorSpace.interpolate_rgb, res) : rgbMapFunc;
	  },
	
	
	  recolorize: cachedColorMap(function (image) {
	    var imageData = toImageData(image);
	
	    modifyImageDataRGB(imageData, this.rgbMapFunction());
	
	    return toCanvas(imageData);
	  })
	});
	RGBMap.Entry = RGBMapEntry;
	
	_util.Xml.addFromBuild(RGBMap, 'RGBMap');
	
	_util.Xml.Parser['RGBMapEntry'] = _util.Xml.makeObjectParser(RGBMapEntry);
	_util.Xml.Parser['RGBMapEntry[]'] = _util.Xml.makeArrayObjectParser(RGBMapEntry);
	
	ColorMap.fromXml = function (node) {
	  return TaggedColors.fromXml(node) || GradientColorMap.fromXml(node) || MonochromeColors.fromXml(node) || RGBMap.fromXml(node) || ColorEngineMap.fromXml(node) || null;
	};
	
	_util.Xml.Parser['ColorMap'] = _util.Xml.makeObjectParser(ColorMap);

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _detail = __webpack_require__(36);
	
	Object.keys(_detail).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _detail[key];
	    }
	  });
	});
	
	var _anchor = __webpack_require__(42);
	
	Object.keys(_anchor).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _anchor[key];
	    }
	  });
	});
	
	var _figure = __webpack_require__(39);
	
	Object.keys(_figure).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _figure[key];
	    }
	  });
	});
	
	var _shape = __webpack_require__(45);
	
	Object.keys(_shape).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _shape[key];
	    }
	  });
	});
	
	var _text = __webpack_require__(50);
	
	Object.keys(_text).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _text[key];
	    }
	  });
	});
	
	var _raster = __webpack_require__(61);
	
	Object.keys(_raster).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _raster[key];
	    }
	  });
	});
	
	var _group = __webpack_require__(59);
	
	Object.keys(_group).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _group[key];
	    }
	  });
	});
	
	var _proxyGroup = __webpack_require__(65);
	
	Object.keys(_proxyGroup).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _proxyGroup[key];
	    }
	  });
	});
	
	var _powerClip = __webpack_require__(49);
	
	Object.keys(_powerClip).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _powerClip[key];
	    }
	  });
	});
	
	var _condition = __webpack_require__(66);
	
	Object.keys(_condition).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _condition[key];
	    }
	  });
	});
	
	var _figures = __webpack_require__(43);
	
	Object.keys(_figures).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _figures[key];
	    }
	  });
	});
	
	var _packing = __webpack_require__(67);
	
	Object.keys(_packing).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _packing[key];
	    }
	  });
	});

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cache = __webpack_require__(37);
	
	Object.keys(_cache).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _cache[key];
	    }
	  });
	});
	
	var _processor = __webpack_require__(38);
	
	Object.keys(_processor).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _processor[key];
	    }
	  });
	});
	
	var _quantumImage = __webpack_require__(44);
	
	Object.keys(_quantumImage).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _quantumImage[key];
	    }
	  });
	});

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FigureCache = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	// [TODO] FigureCache should use a standard Map to hold the cached data
	
	var FigureCache = exports.FigureCache = function (compute, owner, data) {
	  this._data = data || {};
	  this._owner = owner;
	  this._compute = compute;
	};
	
	exports.default = FigureCache;
	
	
	FigureCache.drop = {};
	FigureCache.keep = {};
	
	FigureCache.prototype = {
	  owner: function (v) {
	    return v === undefined ? this._owner : (this._owner = v, this);
	  },
	  clone: function (otherOwner) {
	    var data = {};
	    (0, _lodash.forEach)(this._data, function (value, key) {
	      data[key] = (0, _gear.cloneDeep)(value);
	    });
	    return new FigureCache(this._compute, otherOwner, data);
	  },
	  has: function (key) {
	    return this._data[key] !== undefined;
	  },
	  get: function (key) {
	    var value = this._data[key];
	    if (value === undefined) {
	      value = this._compute[key].call(this._owner);
	      this._data[key] = value;
	    }
	    return value;
	  },
	  set: function (key, value) {
	    this._data[key] = value;
	  },
	  clear: function (key) {
	    if (key === undefined) {
	      this._data = {};
	    } else {
	      delete this._data[key];
	    }
	  },
	  stash: function (key) {
	    var data = this._data;
	    var v = data[key];
	    if (v) {
	      data['stash_' + key] = v.clone();
	    }
	  },
	  unstash: function (key) {
	    var data = this._data;
	    var stash_key = 'stash_' + key;
	    var v = data[stash_key];
	    if (v) {
	      data[key] = v;
	      delete data[stash_key];
	    }
	  },
	  copy: function (fromKey, toKey) {
	    var data = this._data;
	    var value = data[fromKey];
	    if (value) {
	      data[toKey] = value.clone();
	    } else {
	      delete data[toKey];
	    }
	  },
	  update: function (key, updater, f) {
	    var data = this._data;
	    if (updater[f]) {
	      var v = data[key];
	      if (v) {
	        data[key] = updater[f](v);
	      }
	    } else {
	      // Drop it
	      delete data[key];
	    }
	  }
	};

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OutputProcessor = exports.GroupProcessor = exports.Processor = exports.InvalidationStates = exports.updateCache = undefined;
	exports.updateArray$ = updateArray$;
	exports.update$ = update$;
	exports.cache$ = cache$;
	exports.render$ = render$;
	exports.preview$ = preview$;
	exports.commitArray$ = commitArray$;
	exports.commit$ = commit$;
	exports.revertArray$ = revertArray$;
	exports.revert$ = revert$;
	exports.updateMethods = updateMethods;
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _geometry = __webpack_require__(21);
	
	var _figure = __webpack_require__(39);
	
	var _figures = __webpack_require__(43);
	
	function error(m) {
	  console.log(m);
	}
	
	function isDrawingRequest(type) {
	  return type === 'render' || type === 'commit' || type === 'preview';
	}
	
	var cloneProcessor = function (Type, p, otherOwner, partOfGroup, ungrouping) {
	  var np = new Type(otherOwner);
	
	  var cache = p.figure._cache.clone(otherOwner);
	
	  if (ungrouping) {
	
	    if (partOfGroup) {
	      cache.clear('globalPreMatrix');
	      cache.clear('globalPreVectorBounds');
	      cache.clear('globalPreBounds');
	      cache.clear('globalMatrix');
	      cache.clear('globalVectorBounds');
	      cache.clear('globalBounds');
	      cache.clear('globalMaterialBounds');
	      if (!otherOwner.isGroup) {
	        np._invalidateGrouping();
	      }
	    } else {
	      cache.set('globalPreMatrix', new _geometry.Matrix());
	      cache.copy('preVectorBounds', 'globalPreVectorBounds');
	      cache.copy('preBounds', 'globalPreBounds');
	
	      cache.copy('matrix', 'globalMatrix');
	      cache.copy('vectorBounds', 'globalVectorBounds');
	      cache.copy('bounds', 'globalBounds');
	      cache.copy('materialBounds', 'globalMaterialBounds');
	
	      var parent = p.figure._owner;
	      if ((0, _lodash.get)(parent._owner, 'isGroup')) {
	        np._invalidateGrouping();
	      }
	    }
	  }
	
	  otherOwner._cache = cache;
	  return np;
	};
	
	function updateArray$(things, type) {
	  var promises = [];
	  for (var k = 0; k < things.length; ++k) {
	    promises[k] = things[k].update$(type);
	  }
	  return (0, _gear.whenAll)(promises);
	}
	
	function update$(things, type) {
	  if ('update$' in things) {
	    return things.update$(type);
	  }
	  return updateArray$(things, type);
	}
	
	function cache$(things) {
	  return update$(things, 'cache');
	}
	
	function renderArray$(things, type) {
	  return updateArray$(things, type).then(function () {
	
	    (0, _lodash.forEach)((0, _lodash.uniq)((0, _lodash.map)(things, function (thing) {
	      return thing.document;
	    })), function (doc) {
	      doc.fireRenderEvents(type);
	    });
	
	    return things;
	  });
	}
	
	function render$(things) {
	  if ('render$' in things) {
	    return things.render$();
	  }
	  return renderArray$(things, 'render');
	}
	
	function preview$(things) {
	  if ('preview$' in things) {
	    return things.preview$();
	  }
	  return renderArray$(things, 'preview');
	}
	
	function commitArray$(things) {
	  var waitFor = [];
	  return (0, _gear.map$)((0, _lodash.uniq)((0, _lodash.map)(things, function (thing) {
	    var doc = thing.document;
	    if (!doc) {
	      waitFor.push(thing.commit$());
	    }
	    return doc;
	  })), function (doc) {
	    return doc.commit$;
	  }).then(function () {
	    return (0, _gear.whenAll)(waitFor).then(function () {
	      return things;
	    });
	  });
	}
	
	function commit$(things) {
	  if ('commit$' in things) {
	    return things.commit$();
	  }
	  return commitArray$(things);
	}
	
	function revertArray$(things) {
	  return (0, _gear.map$)((0, _lodash.uniq)((0, _lodash.map)(things, function (thing) {
	    return thing.document;
	  })), function (doc) {
	    return doc.revert$;
	  }).then(function () {
	    return things;
	  });
	}
	
	function revert$(things) {
	  if ('revert$' in things) {
	    return things.revert$();
	  }
	  return revertArray$(things);
	}
	
	function renderMethod(type) {
	  return function () {
	    var _this = this;
	
	    return this.update$(type).then(function () {
	      var doc = _this.document;
	      if (doc) {
	        doc.fireRenderEvents(type);
	      }
	    });
	  };
	}
	
	function updateMethods() {
	  return {
	    cache$: function () {
	      return this.update$('cache');
	    },
	
	
	    preview$: renderMethod('preview'),
	
	    render$: renderMethod('render'),
	
	    commit$: function () {
	      var doc = this.document;
	      return doc ? doc.commit$() : this.update$('commit');
	    },
	    revert$: function () {
	      var doc = this.document;
	      return doc ? doc.revert$() : (0, _gear.resolve)();
	    }
	  };
	}
	
	var updateCacheAt = function (figure, updater, target) {
	  var cache = figure._cache;
	
	  // pre metrics are kept
	
	  // metrics are kept if the target of the transform
	  // is not the figure being update
	  if (figure === target) {
	    cache.update('matrix', updater, 'transform');
	    cache.update('vectorBounds', updater, 'vectorBounds');
	    cache.update('bounds', updater, 'bounds');
	    cache.update('materialBounds', updater, 'materialBounds');
	  }
	
	  // global pre metrics are kept if the figure is not grouped, because
	  // they are the same as pre metrics in this case
	  if ((0, _lodash.get)(target._owner, 'isGroup')) {
	    cache.update('globalPreMatrix', updater, 'transform');
	    cache.update('globalPreVectorBounds', updater, 'vectorBounds');
	    cache.update('globalPreBounds', updater, 'bounds');
	  }
	
	  cache.update('globalMatrix', updater, 'transform');
	  cache.update('globalVectorBounds', updater, 'vectorBounds');
	  cache.update('globalBounds', updater, 'bounds');
	  cache.update('globalMaterialBounds', updater, 'materialBounds');
	};
	
	var updateChildsCache = function (group, updater, target) {
	  var gfs = group._figures;
	  //_.forEach(gfs, function(f) {
	  for (var k = 0, kEnd = gfs.length; k < kEnd; ++k) {
	    var f = gfs[k];
	    updateCacheAt(f, updater, target);
	    if (f.isGroup) {
	      updateChildsCache(f, updater, target);
	    }
	  } //);
	};
	
	var clearParentsCache = function (figure) {
	  // Clear parents caches
	  var owner = figure._owner;
	  while ((0, _lodash.get)(owner, 'isGroup')) {
	    owner._cache.clear(); // Clear group cache
	    owner = owner._owner;
	  }
	};
	
	var updateCache = exports.updateCache = function (figure, updater) {
	
	  clearParentsCache(figure);
	
	  // Update target
	  updateCacheAt(figure, updater, figure);
	
	  if (figure.isGroup) {
	    updateChildsCache(figure, updater, figure);
	
	    // Review, updating output figure if it is a group
	    var of = figure._outputFigure;
	    if (of !== figure && (0, _lodash.get)(of, 'isGroup')) {
	      updateChildsCache(of, updater, figure);
	    }
	  }
	};
	
	var _clearInvalidatedFigureLocalCache = function (figure) {
	  figure._cache.clear();
	};
	var _clearInvalidatedFigureCache = function (figure) {
	  figure.deepForEachFigure(_clearInvalidatedFigureLocalCache);
	};
	
	var clearInvalidatedCache = function (figure) {
	  clearParentsCache(figure);
	  _clearInvalidatedFigureCache(figure);
	
	  // Review, updating output figure if it is a group
	  var of = figure._outputFigure;
	  if (of !== figure && (0, _lodash.get)(of, 'isGroup')) {
	    _clearInvalidatedFigureCache(of);
	  }
	};
	
	var _clearGroupedFigureLocalCache = function (figure) {
	  var cache = figure._cache;
	  cache.clear('globalPreMatrix');
	  cache.clear('globalPreVectorBounds');
	  cache.clear('globalPreBounds');
	  cache.clear('globalMatrix');
	  cache.clear('globalVectorBounds');
	  cache.clear('globalBounds');
	  cache.clear('globalMaterialBounds');
	};
	var _clearGroupedFigureCache = function (figure) {
	  figure.deepForEachFigure(_clearGroupedFigureLocalCache);
	};
	
	var clearGroupedCache = function (figure) {
	  clearParentsCache(figure);
	  _clearGroupedFigureCache(figure);
	
	  // Review, updating output figure if it is a group
	  var of = figure._outputFigure;
	  if (of !== figure && (0, _lodash.get)(of, 'isGroup')) {
	    _clearGroupedFigureCache(of);
	  }
	};
	
	// This updater modifies all the cached metrics
	var TranslateCacheUpdater = function (dx, dy) {
	  this.dx = dx;this.dy = dy;
	  this.translate = _geometry.Matrix.translate(dx, dy);
	};
	TranslateCacheUpdater.prototype = {
	  vectorBounds: function (v) {
	    return v.translate(this.dx, this.dy);
	  },
	  bounds: function (v) {
	    return v.translate(this.dx, this.dy);
	  },
	  transform: function (v) {
	    return _geometry.Matrix.m(this.translate, v);
	  }
	};
	
	// This updater modifies all the cached metrics if sx === sy
	var ScaleFromCacheUpdater = function (point, sx, sy, deg) {
	  // Do not update bounds
	  if (sx !== sy) {
	    this.vectorBounds = null;
	    this.bounds = null;
	  }
	  this.scaling = _geometry.Matrix.scaleFrom(point, sx, sy, deg);
	};
	ScaleFromCacheUpdater.prototype = {
	  vectorBounds: function (v) {
	    return v.scalingTransform(this.scaling);
	  },
	  bounds: function (v) {
	    return v.scalingTransform(this.scaling);
	  },
	  transform: function (v) {
	    return _geometry.Matrix.m(this.scaling, v);
	  }
	};
	
	// Bounds needs to be recalculated after applying this updater
	var TransformCacheUpdater = function (matrix) {
	  this.matrix = matrix;
	};
	TransformCacheUpdater.prototype = {
	  transform: function (v) {
	    return _geometry.Matrix.m(this.matrix, v);
	  }
	};
	
	var measureFigure$ = function (figure) {
	
	  // console.log('Clean up cache, ' + broadcastInfo.figureInvalidationState);
	
	  updateCache(figure, {}); // Clean up the post-transform cache, preMetrics are kept
	
	  var of = figure._outputFigure;
	  if (figure !== of) {
	    of.pin = figure.pin.clone();
	    of.matrix22 = figure._matrix22.clone();
	  }
	
	  return (0, _gear.resolve)(figure);
	};
	
	function setSimpleFigureOutput(figure) {
	  if (figure.isEmpty) {
	    figure.outputFigure = figure.createEmptyOutput();
	  } else {
	    if (_config.Config.avoidClonningInputForPrimitives) {
	      // Optimization, the only important thing is to remember to avoid transforming
	      // the figure twice. The code uses ._aliasedOutput() because of this.
	      figure.outputFigure = figure;
	    } else {
	      figure.outputFigure = figure.clone(false);
	    }
	    if (figure.isGroup) {
	      (0, _lodash.forEach)(figure._figures, setSimpleFigureOutput);
	    }
	  }
	}
	
	// [TODO] We should only call generateOutputFigure$ here
	//        each figure needs to take care of the output generation
	//        or in any case, the if condition should be inverted
	
	var processFigure$ = function (figure) {
	  // console.log('localProcessing');
	
	  if (figure.isText || figure.isRaster || figure._processes.length > 0 || !figure._preMatrix22.isIdentity() || figure.isGroup && !figure.onlySimpleShapes()) {
	
	    return figure.generateOutputFigure$().then(function (outputFigure) {
	
	      // We need to recompute all the metrics
	      clearInvalidatedCache(figure);
	      figure.outputFigure = outputFigure;
	      return figure;
	    });
	  } else {
	
	    setSimpleFigureOutput(figure);
	    clearInvalidatedCache(figure);
	    return (0, _gear.resolve)(figure);
	  }
	};
	
	var InvalidationStates = exports.InvalidationStates = {
	
	  // Figure invalidation states
	  //=================================================================================================
	  // A Figure needs to be processed to generate its output representation.
	  // In the case of a Text, for example, we need to get the letters curves from the font and
	  // compose the proper line. If the figure has effects (processes) we need to apply them to the
	  // initial representation in order to produce the deformations (envelope) or add new curves to
	  // create the output (contour).
	  // Finally this representation is transformed and placed in the document using the figure transform
	  // and pin.
	  // We call this 'processing' the figure.
	  // Canvas API needs to know some basic measurements (bounds, matrix) in order to render the
	  // figure representation in the browser.
	  // We call this 'measuring' the figure.
	  //
	  // Figure --[ Processing ]--> Processed Figure --[ Measuring ]--> (bounds, matrix)
	  //
	  // Processing the figure can be quite expensive and except for simple shapes it requires a call to
	  // the server. We need to cache the result of the processing stage to avoid having to re-do it
	  // every time we interact with the figure. The Processor object takes care of this task
	  // generating a processed figure (output representation) for the figure it is attached to.
	  // Measuring the figure requires a bounding box computation that is also expensive but that we are
	  // able to do it locally avoiding the net latency. This measurements also needs to be cached
	  // because they are accesed often by Canvas API and the clients. They are stored in the cache of
	  // the input figure. The cache of the output figure is linked to this cache to avoid unnecesary
	  // computations.
	  // If we only change the pin or the transform, there is no needs to re-do the processing stage and
	  // only a measurement stage must be issued.
	  // There are cases where we can even update the cached processed figure and its measurement (for
	  // example, when translating the figure) and then we can avoid both expensive stages.
	
	  figure: {
	
	    // all
	    //----------------------------------------------------------------------------------------------
	    // The figure needs to be processed and measured. This will be done in the server or locally
	    // depending on the complexity of the figure.
	    all: 2,
	
	    // transform
	    //----------------------------------------------------------------------------------------------
	    // The figure has been processed and only the pin and transformation has changed, so we only
	    // need to recompute the measurements (bounds, matrix).
	    transform: 1,
	
	    // none
	    //----------------------------------------------------------------------------------------------
	    // The figure is in a valid state. The figure was processed and cached in the server and
	    // we now have an up-to-date cache Id to talk to the server about it -or- there is an
	    // up-to-date processed figure object locally.
	    // The figure measurements values are also up-to-date (bounds, matrix)
	    none: 0
	
	  },
	
	  // Views invalidation states
	  //=================================================================================================
	  // Independently of what the figure invalidation state is, the figure needs to be rendered to the
	  // screen. This is done with figure views, that are representations of the figure on the screen
	  // canvas with a certain viewport state (zoom, offset) and rendering params (wireframe).
	  // The Processor can be called with a render or a cache command. We maintain a view
	  // invalidation state that is broadcasted and listened by the views, that update themselves
	  // accordingly. When the processor is call with a cache call, the view invalidation state is not
	  // changed and in the next call to render it will be properly broadcasted to the views.
	  // It is important that the figure invalidation state and the view invalidation state (the one that
	  // will be broadcasted) are maintained separately to allow optimizations. For example, when we
	  // perform a color replacement operation and the figure can be rendered locally there is no need
	  // to do expensive server calls. We can just replace the color in the cached processed figure
	  // locally and set the view invalidation state to 'all'. The figure invalidation state should
	  // be 'none' because both the output representation and the measurements are already up-to-date.
	  // This scheme let us inform the views that a refresh is in place and at the same time tell the
	  // processor that there is no need to recompute anything.
	  // Another example is the optimization implemented when scaling the figure. In this case we can
	  // also just update the output representation and update the measurements directly. Again the
	  // figure invalidation state should be set to 'none' but the view invalidation state should be
	  // 'transform' to inform the views of what we have changed. In the old JS engine this was done
	  // with an intermidiate figure invalidation state called 'scale', but then it was not possible
	  // to properly implement optimizations like the color replacement because that doesn't fit in
	  // a linear invalidation state hierarchy (figure invalidation should be none and view invalidation
	  // must be all).
	
	  views: {
	
	    // all
	    //----------------------------------------------------------------------------------------------
	    // The figure representation needs to be completely updated.
	    all: 3,
	
	    // transform
	    //----------------------------------------------------------------------------------------------
	    // The pre output representation is up-to-date and only the final transformation needs
	    // to be updated. This is important when using local rendering because generating the the raphael
	    // representation can be expensive.
	    transform: 2,
	
	    // viewport
	    //----------------------------------------------------------------------------------------------
	    // When the viewport params are changed, zoom or pan offset we can directly provide visual
	    // feedback before asking for the image in the case of server rendering. For local rendering
	    // it is conceptually cleaner also to only update the viewport transformation and leave the
	    // figure transform as it is.
	    viewport: 1,
	
	    // none
	    //----------------------------------------------------------------------------------------------
	    // The figure view only will be updated if this is the first time it is being rendered.
	    // If not, it should be showing an up-to-date representation of the figure.
	    none: 0
	
	  },
	
	  upgrade: function (type, oldState, newState) {
	    return InvalidationStates[type][oldState] > InvalidationStates[type][newState] ? oldState : newState;
	  },
	  downgrade: function (type, oldState, newState) {
	    return InvalidationStates[type][oldState] < InvalidationStates[type][newState] ? oldState : newState;
	  }
	};
	
	var Processor = exports.Processor = _gear.Base.extend({ typeName: 'Processor',
	
	  // render, updates the figure and fire a render event broadcasting invalidation information for the
	  // views to update themselves.
	
	  // cache, same as update but the figure will be forced to be cached on the server. Use this function
	  // if you want to externally use the cacheId. The Designer2C is currently using this because it draws
	  // figures with a direct call to the server for some dialogs instead of using a Canvas API figure view.
	
	  // If the figure is modified, these functions should be called to invalidate the output representation
	
	  invalidate: function () {
	    clearInvalidatedCache(this.figure);
	    this._invalidate();
	  },
	  _invalidate: function () {
	    this.figureInvalidationState = InvalidationStates.upgrade('figure', this.figureInvalidationState, 'all');
	    this.figure.lock();
	    // g.log('Processor.invalidate > ' + this.figureInvalidationState);
	    this._invalidateView();
	  },
	  invalidateGrouping: function () {
	    if (this.figure._aliasedOutput()) {
	      clearGroupedCache(this.figure);
	      this._invalidateGrouping();
	    } else {
	      // For normal processors, we need to recalculate the output
	      this.invalidate();
	    }
	  },
	  _invalidateGrouping: function () {
	    if (!(_config.Config.computeFigureGeometryLocally && this.figure.supportsLocalMetrics())) {
	      this._invalidateTransform();
	    }
	  },
	
	
	  // If only the pin or the transform are modified, this function should be called and only
	  // the measurements will be re-computed.
	
	  invalidateTransform: function () {
	    updateCache(this.figure, {});
	    this._invalidateTransform();
	  },
	  _invalidateTransform: function () {
	    this.figureInvalidationState = InvalidationStates.upgrade('figure', this.figureInvalidationState, 'transform');
	    // g.log('Processor.invalidateTransform > ' + this.figureInvalidationState);
	    this._invalidateViewTransform();
	  },
	  computePrePin: function () {
	    var of = this.figure._outputFigure;return of ? of._primitive_computePrePin() : error('Using metrics without calling update$');
	  },
	  computePreReferencePoint: function () {
	    var of = this.figure._outputFigure;return of ? of._primitive_computePreReferencePoint() : error('Using metrics without calling update$');
	  },
	  computePreVectorBounds: function () {
	    var of = this.figure._outputFigure;return of ? of._primitive_computePreVectorBounds() : error('Using metrics without calling update$');
	  },
	  computePreBounds: function () {
	    var of = this.figure._outputFigure;return of ? of._primitive_computePreBounds() : error('Using metrics without calling update$');
	  },
	  computeVectorBounds: function () {
	    var of = this.figure._outputFigure;return of ? of._primitive_computeVectorBounds() : error('Using metrics without calling update$');
	  },
	  computeBounds: function () {
	    var of = this.figure._outputFigure;return of ? of._primitive_computeBounds() : error('Using metrics without calling update$');
	  },
	  computeMaterialBounds: function () {
	    var of = this.figure._outputFigure;return of ? of._primitive_computeMaterialBounds() : error('Using metrics without calling update$');
	  },
	  computeGlobalPreVectorBounds: function () {
	    var of = this.figure._outputFigure;return of ? of._primitive_computeGlobalPreVectorBounds() : error('Using metrics without calling update$');
	  },
	  computeGlobalPreBounds: function () {
	    var of = this.figure._outputFigure;return of ? of._primitive_computeGlobalPreBounds() : error('Using metrics without calling update$');
	  },
	  computeGlobalVectorBounds: function () {
	    var of = this.figure._outputFigure;return of ? of._primitive_computeGlobalVectorBounds() : error('Using metrics without calling update$');
	  },
	  computeGlobalBounds: function () {
	    var of = this.figure._outputFigure;return of ? of._primitive_computeGlobalBounds() : error('Using metrics without calling update$');
	  },
	  computeGlobalMaterialBounds: function () {
	    var of = this.figure._outputFigure;return of ? of._primitive_computeGlobalMaterialBounds() : error('Using metrics without calling update$');
	  },
	  computePreVectorBoundsAfter: function (transform) {
	    var of = this.figure._outputFigure;return of ? of._primitive_computePreVectorBoundsAfter(transform) : error('Using metrics without calling update$');
	  },
	  computePreBoundsAfter: function (transform) {
	    var of = this.figure._outputFigure;return of ? of._primitive_computePreBoundsAfter(transform) : error('Using metrics without calling update$');
	  },
	  fineHitTest: function (point, transform, options) {
	    var of = this.figure._outputFigure;return of ? of._fineHitTest(point, transform, options) : true;
	  },
	  representationType: function () {
	    var of = this.figure._outputFigure;
	    return of ? of._representationType() : 'hidden';
	  },
	  draw: function (context, transform, config) {
	    var outputFigure = this.figure.outputFigure;
	
	    if (outputFigure) {
	      outputFigure._draw(context, transform, config);
	    }
	  },
	
	
	  // Some modifications on the figure are routed through more fine grained operations that will possible
	  // avoid expensive processing or measuring stages by direct manipulation of the local figure output representation.
	
	  fastTranslate: function (dx, dy) {
	    // g.log('Processor.fastTranslate');
	    var f = this.figure;
	    updateCache(f, new TranslateCacheUpdater(dx, dy));
	
	    var of = f._outputFigure;
	    if (of && f !== of) {
	      of.translate(dx, dy);
	    }
	    // In the case of server rendering it is an important optimization to be able
	    // to avoid requesting a new image from the server and in the case we have moved an
	    // integer number of pixels we do not need to do it
	    // So there is nothing to invalidate here except when currently processing
	    if (this._currentlyProcessing || this.invalidated()) {
	      // console.log('fastTranslate, while processing');
	      this.invalidateTransform();
	    } else if (f.needsFixedDrawing()) {
	      this.invalidateView();
	    }
	  },
	  translate: function (dx, dy) {
	    // g.log('Processor.translate');
	    var f = this.figure;
	    updateCache(f, new TranslateCacheUpdater(dx, dy));
	
	    var of = f._outputFigure;
	    if (of && f !== of) {
	      of.translate(dx, dy);
	    }
	
	    // We need to retrieve the image again because the subpixels may be wrong
	    // If you now that the image does not need to be updated use fastTranslate
	    this.invalidateViewTransform();
	  },
	  scaleFrom: function (point, sx, sy, deg) {
	    // g.log('Processor.scaleFrom');
	    var f = this.figure;
	    updateCache(f, new ScaleFromCacheUpdater(point, sx, sy, deg));
	
	    var of = f._outputFigure;
	    if (of && f !== of) {
	      of.scaleFrom(point, sx, sy, deg);
	    }
	
	    if (sx === sy) {
	      this.invalidateViewTransform();
	    } else {
	      this.invalidateUpdatedTransform();
	    }
	  },
	  transform: function (matrix) {
	    var f = this.figure;
	    updateCache(f, new TransformCacheUpdater(matrix));
	
	    var of = f._outputFigure;
	    if (of && f !== of) {
	      of.transform(matrix);
	    }
	
	    this.invalidateUpdatedTransform();
	
	    // [TODO] Remove when bounds based pinning is gone
	    if (!f._pin.anchorBased()) {
	      f._fixUpPin$('referencePoint_');
	    }
	  },
	  invalidateChildren: function (aFigure) {
	    aFigure.invalidate();
	    if (aFigure.isGroup) {
	      var figures = aFigure._figures;
	      for (var i = 0, iEnd = figures.length; i < iEnd; ++i) {
	        this.invalidateChildren(figures[i]);
	      }
	    }
	  },
	  replaceColor: function (oldColor, newColor, options) {
	    var f = this.figure;
	
	    var changed = f._replaceColor(oldColor, newColor, options);
	    if (!changed) {
	      return;
	    } // nothing to invalidate
	
	    //we need to invalidate the children or text inside groups is not updated
	    if (f.isGroup) {
	      this.invalidateChildren(f);
	    }
	
	    if (f._powerClipContents.length > 0) {
	      var pFigures = f._powerClipContents[0]._figures;
	      for (var k = 0, kEnd = pFigures.length; k < kEnd; ++k) {
	        var figure = pFigures[k];
	        figure.cacheId = null;
	        figure.invalidate(); // [TODO] Optimize
	      }
	    }
	
	    if (_config.Config.replaceColorsLocallyWhenPossible && _config.Config.computeFigureGeometryLocally && f.supportsLocalMetrics() && // We can not longer use the cached figure,
	    this.representationType() === 'local') // so we need this optimization enabled
	      {
	        var of = f._outputFigure;
	        if (of && f !== of) {
	          of._replaceColor(oldColor, newColor, options);
	        }
	        // We are touching the processed figure directly, we can no longer
	        // use the stored cacheId figure in the server
	        f.cacheId = null;
	        f.lock();
	        this.invalidateView();
	      } else {
	      this.invalidate();
	    }
	  },
	  replaceBrush: function (oldBrush, newBrush) {
	    var f = this.figure;
	
	    var changed = f._replaceBrush(oldBrush, newBrush);
	    if (!changed) {
	      return;
	    } // nothing to invalidate
	
	    //we need to invalidate the children or text inside groups is not updated
	    if (f.isGroup) {
	      this.invalidateChildren(f);
	    }
	
	    if (f._powerClipContents.length > 0) {
	      var pFigures = f._powerClipContents[0]._figures;
	      for (var k = 0, kEnd = pFigures.length; k < kEnd; ++k) {
	        var figure = pFigures[k];
	        figure.cacheId = null;
	        figure.invalidate(); // [TODO] Optimize
	      }
	    }
	
	    if (_config.Config.replaceColorsLocallyWhenPossible && _config.Config.computeFigureGeometryLocally && f.supportsLocalMetrics() && // We can not longer use the cached figure,
	    this.representationType() === 'local') // so we need this optimization enabled
	      {
	        var of = f._outputFigure;
	        if (of && f !== of) {
	          of._replaceBrush(oldBrush, newBrush);
	        }
	        // We are touching the processed figure directly, we can no longer
	        // use the stored cacheId figure in the server
	        f.cacheId = null;
	        f.lock();
	        this.invalidateView();
	      } else {
	      this.invalidate();
	    }
	  },
	
	
	  // We can add a more general function here later
	  setTaggedColors: function (tag, color) {
	    this._setColors('_setTaggedColors', tag, color);
	  },
	  setLabeledColors: function (label, color) {
	    this._setColors('_setLabeledColors', label, color);
	  },
	  _setColors: function (forward, key, color) {
	    var f = this.figure;
	
	    var changed = f[forward](key, color);
	    if (!changed) {
	      return;
	    } // nothing to invalidate
	
	    //we need to invalidate the children or text inside groups is not updated
	    if (f.isGroup) {
	      this.invalidateChildren(f);
	    }
	    if (f._powerClipContents.length > 0) {
	      var pFigures = f._powerClipContents[0]._figures;
	      for (var k = 0, kEnd = pFigures.length; k < kEnd; ++k) {
	        var figure = pFigures[k];
	        figure.cacheId = null;
	        figure.invalidate(); // [TODO] Optimize
	      }
	    }
	
	    if (_config.Config.replaceColorsLocallyWhenPossible && _config.Config.computeFigureGeometryLocally && f.supportsLocalMetrics() && // We can not longer use the cached figure,
	    this.representationType() === 'local') // so we need this optimization enabled
	      {
	        var of = f._outputFigure; // [TODO] Review
	        if (of && f !== of) {
	          of[forward](key, color);
	        }
	        // We are touching the processed figure directly, we can no longer
	        // use the stored cacheId figure in the server
	        f.cacheId = null;
	        f.lock();
	        this.invalidateView();
	      } else {
	      this.invalidate();
	    }
	  },
	  clone: function (otherOwner, partOfGroup, ungrouping) {
	    var f = this.figure;
	    var np = cloneProcessor(Processor, this, otherOwner, partOfGroup, ungrouping);
	    // np.viewsInvalidationState is 'all', to force the rendering in the first draw
	    np.figureInvalidationState = this.currentlyProcessing() ? 'all' : this.figureInvalidationState;
	    otherOwner.cacheId = f._cacheId;
	    var of = f._outputFigure;
	    if (of) {
	      var otherOutputFigure = void 0;
	      if (f === of) {
	        otherOutputFigure = otherOwner;
	      } else {
	        // We need to rewire the PowerClipLink to point to the new figure contents
	        // This uses a cloneLink hook, that seems to be the fastest way to rewire
	        // power clip links, we are not cleaning the links afterwards. We may do it
	        // later to reduce memory consumption, but looks fine for the moment and
	        // we are prefering speed and simplicity here.
	        // Check clone functions for PowerClipContent and PowerClipLink
	        otherOutputFigure = of.clone(false);
	      }
	      otherOwner.outputFigure = otherOutputFigure;
	    }
	    return np;
	  },
	  currentlyProcessing: function () {
	    return this._currentlyProcessing > 0;
	  },
	  invalidated: function () {
	    return this.figureInvalidationState !== 'none' || this.processingFigureInvalidationState !== 'none';
	  },
	  processed: function () {
	    return this.figure._outputFigure !== null;
	  },
	
	
	  // internal functions
	
	  init: function (ownerFigure) {
	
	    this.figure = ownerFigure;
	
	    this._lastPromise = (0, _gear.resolve)();
	
	    this._currentlyProcessing = 0;
	
	    // Read documentation at InvalidationStates
	
	    // Invalidation state of the figure and its processed figure representation
	    this.figureInvalidationState = 'all';
	    this.processingFigureInvalidationState = 'none';
	
	    // Invalidation state that will be broadcasted to the views so they get properly updated
	    this.viewsInvalidationState = 'all';
	  },
	  invalidateView: function (force) {
	    // Disable optimizations if we are currently processing
	    if (!force && (this._currentlyProcessing || this.invalidated())) {
	      this.invalidate();
	    } else {
	      this._invalidateView();
	    }
	  },
	  invalidateUpdatedTransform: function () {
	    this._invalidateUpdatedTransform();
	  },
	  _invalidateUpdatedTransform: function () {
	    // This function is called every time an updater performs a partial update of cached metrics
	    // If we can not recompute the dropped ones locally, then we need to ask them to the server
	    if (_config.Config.computeFigureGeometryLocally && this.figure.supportsLocalMetrics()) {
	
	      // Disable optimizations if we are currently processing
	      if (this._currentlyProcessing || this.invalidated()) {
	        // console.log('Currently processing, hard invalidate transform');
	        this.invalidateTransform();
	      } else {
	        this.invalidateViewTransform();
	      }
	    } else {
	      this._invalidateTransform();
	    }
	  },
	  invalidateViewTransform: function () {
	    // Disable optimizations if we are currently processing
	    if (this._currentlyProcessing || this.invalidated()) {
	      // console.log('Currently processing, hard invalidate transform');
	      this.invalidateTransform();
	    } else {
	      this._invalidateViewTransform();
	    }
	  },
	  _invalidateView: function () {
	    this.viewsInvalidationState = InvalidationStates.upgrade('views', this.viewsInvalidationState, 'all');
	    // g.log('Processor.invalidateView > ' + this.viewsInvalidationState);
	
	    var pccs = this.figure.deepPowerClipContents();
	    for (var k = 0, kEnd = pccs.length; k < kEnd; ++k) {
	      var figures = pccs[k]._figures;
	      for (var n = 0, nEnd = figures.length; n < nEnd; ++n) {
	        figures[n].invalidateView();
	      }
	    }
	  },
	  _invalidateViewTransform: function () {
	    this.figure.lock();
	    this.viewsInvalidationState = InvalidationStates.upgrade('views', this.viewsInvalidationState, 'transform');
	    // g.log('Processor.invalidateViewTransform > ' + this.viewsInvalidationState );
	  },
	
	
	  // Queue process calls. Application of processing will always respect order
	  // of update request even if old request require longer time than new ones.
	
	  update$: function (type) {
	    var _this2 = this;
	
	    if (type === 'preview' && this._currentlyProcessing === 0 && this.figureInvalidationState === 'none' && this.viewsInvalidationState === 'none') {
	      return (0, _gear.resolve)(this.figure);
	    }
	
	    var deferred = new _gear.Deferred();
	
	    var processing = function () {
	
	      ++_this2._currentlyProcessing;
	
	      var figureInvalidationState = _this2.figureInvalidationState;
	      var viewsInvalidationState = _this2.viewsInvalidationState;
	
	      var broadcastInfo = { figureInvalidationState: figureInvalidationState, viewsInvalidationState: viewsInvalidationState };
	
	      _this2.fireProcessingStarted(type, broadcastInfo);
	
	      return _this2.doProcessing(type).then(function () {
	
	        return _this2.fireProcessingSuccess(type, broadcastInfo);
	      }).then(function () {
	
	        --_this2._currentlyProcessing;
	        deferred.resolve(_this2.figure);
	      }).then(null, function (error) {
	        console.log(error);
	
	        --_this2._currentlyProcessing;
	        deferred.reject(_this2.fireProcessingFailure(type, broadcastInfo));
	      });
	    };
	
	    // Queue completion of processing after last promise is done
	    this._lastPromise.then(processing, processing);
	
	    return this._lastPromise = deferred.promise;
	  },
	  doProcessing: function (type) {
	    var figure = this.figure;
	    var figureInvalidationState = this.figureInvalidationState;
	
	    // Ignore preview requests if metrics can not be processed locally, like
	    // in the case of ProxyGroups, the result is still a succesful update for
	    // the rendering code. Bounds will be computed later in the next update,
	    // render or commit.
	
	    if (type === 'preview' && !figure.supportsLocalMetrics()) {
	      return (0, _gear.resolve)();
	    }
	
	    // g.log('Processor.doProcessing, type: ' + type + ', fis: ' + this.figureInvalidationState + ', vis: ' + this.viewsInvalidationState );
	
	    // This is only used for invalidated()
	    this.processingFigureInvalidationState = figureInvalidationState;
	
	    // The figure will be up-to-date after the processing. In case it fails, the state is reverted to
	    // the current processing state. We have to do it this way because further invalidation calls can be
	    // issued while processing (mainly when requesting a full processing to the server)
	    this.figureInvalidationState = 'none';
	
	    var drawingRequest = isDrawingRequest(type);
	    if (drawingRequest) {
	      // Same as above, in the case the processing fails this will be reverted to the processing state
	      this.viewsInvalidationState = 'none';
	    }
	
	    var handleInvalidateInTheServer = figureInvalidationState === 'all' && (!(_config.Config.processLocallyWhenPossible && figure.canBeProcessedLocally()) || !_config.Config.renderLocallyWhenPossible || !_config.Config.computeFigureGeometryLocally || !figure.supportsLocalMetrics()) && !figure.isEmpty;
	
	    if (handleInvalidateInTheServer) {
	      figure.fireEvent('serverinvalidate');
	    }
	    var processUsingServer = handleInvalidateInTheServer || type === 'cache' && (figureInvalidationState === 'all' || !figure._cacheId) || drawingRequest && figure.needsCacheToRender() && !figure._cacheId;
	
	    // Process and meassure figure using Grafika or Core
	
	    if (processUsingServer) {
	
	      // The figure will be processed and cached in the server
	      return _figure.Figure.processUsingServer$(figure, {
	        getOutput: !figure.isProxyGroup,
	        storeInCache: type === 'cache' || !_config.Config.computeFigureGeometryLocally || !figure.supportsLocalMetrics() || !_config.Config.avoidCacheWhenRenderLocally || figure.needsCacheToRender() || _config.Config.renderLocallyWhenPossible
	      });
	    } else if (figureInvalidationState === 'all') {
	
	      // The figure can be processed locally
	      return processFigure$(figure);
	    } else if (figureInvalidationState === 'transform') {
	
	      // Measurements (bounds, matrix) needs to be updated
	
	      if (_config.Config.computeFigureGeometryLocally && figure.supportsLocalMetrics() && figure._outputFigure) {
	
	        return measureFigure$(figure);
	      } else {
	        return _figure.Figure.measureUsingCore$(figure);
	      }
	    } else {
	      return (0, _gear.resolve)();
	    }
	  },
	  fireProcessingSuccess: function (type, broadcastInfo) {
	    var _this3 = this;
	
	    var figure = this.figure;
	    var response = { type: type, figure: figure, broadcastInfo: broadcastInfo };
	
	    // Process PowerClip Input...
	    return figure.processPowerClips$().then(function () {
	
	      _this3.processingFigureInvalidationState = 'none';
	
	      figure.fireEvent('processingcomplete', response);
	
	      if (isDrawingRequest(type)) {
	
	        // We need to review this... it is needed only when using server processing
	        // We can avoid some processing calls by manually setting up PowerClipLinks
	        // in the server output figure response for simple most common cases (Text)
	        //==========================================================================
	        var of = figure._outputFigure;
	        if (of && of !== figure && !figure.usingPowerClipLink()) {
	          // Directly using PowerClipLink
	
	          var pccs = of.deepPowerClipContents();
	
	          if (pccs.length > 0) {
	
	            return (0, _gear.map$)(pccs, function (pcc) {
	              return (0, _gear.invokeMap$)(pcc._figures, 'render$');
	            }).then(function () {
	
	              // console.log('PC after render');
	
	              figure.fireEvent('rendercomplete', response);
	              return figure;
	            });
	          }
	        }
	        //==========================================================================
	
	        // Normal flow
	        figure.fireEvent('rendercomplete', response);
	      }
	
	      return figure;
	    });
	  },
	  fireProcessingFailure: function (type, broadcastInfo, errorMessage) {
	    var figure = this.figure;
	
	    var response = { errorMessage: errorMessage, type: type, figure: figure, broadcastInfo: broadcastInfo };
	
	    // g.log('processing failure');
	    this.figureInvalidationState = InvalidationStates.upgrade('figure', this.figureInvalidationState, broadcastInfo.figureInvalidationState);
	
	    figure.fireEvent('processingfailed', response);
	
	    if (isDrawingRequest(type)) {
	      this.viewsInvalidationState = InvalidationStates.upgrade('views', this.viewsInvalidationState, broadcastInfo.viewsInvalidationState);
	    }
	
	    return response;
	  },
	  fireProcessingStarted: function (type, broadcastInfo) {
	    var figure = this.figure;
	
	    var response = { broadcastInfo: broadcastInfo, figure: figure, type: type };
	    figure.fireEvent('processingstarted', response);
	  }
	});
	
	var GroupProcessor = exports.GroupProcessor = _gear.Base.extend({ typeName: 'GroupProcessor',
	
	  update$: function (type) {
	    var figure = this.figure;
	
	    figure.fireEvent('processingstarted');
	    return (0, _gear.map$)(figure._figures, function (figure) {
	      return figure.update$(type);
	    }).then(function () {
	
	      var broadcastInfo = { figureInvalidationState: 'none',
	        viewsInvalidationState: 'none' };
	      var response = { figure: figure, broadcastInfo: broadcastInfo, type: type };
	
	      figure.fireEvent('processingcomplete', response);
	      figure.fireEvent('rendercomplete', response);
	    });
	  },
	  computePrePin: function () {
	    return this.figure._primitive_computePrePin();
	  },
	  computePreReferencePoint: function () {
	    return this.figure._primitive_computePreReferencePoint();
	  },
	  computePreVectorBounds: function () {
	    var figure = this.figure,
	        figures = figure._figures;
	    if (figure.isGrouped) {
	      return _figures.Figures.vectorBounds_(figures);
	    } else {
	      return _figures.Figures.globalPreVectorBounds_(figures);
	    }
	  },
	  computePreBounds: function () {
	    var figure = this.figure,
	        figures = figure._figures;
	    if (figure.isGrouped) {
	      return _figures.Figures.bounds_(figures);
	    } else {
	      return _figures.Figures.globalPreBounds_(figures);
	    }
	  },
	  computeVectorBounds: function () {
	    var figure = this.figure;
	    if (figure.isGrouped) {
	      return figure._primitive_computeVectorBounds();
	    } else {
	      return _figures.Figures.globalVectorBounds_(figure._figures);
	    }
	  },
	  computeBounds: function () {
	    var figure = this.figure;
	    if (figure.isGrouped) {
	      return this.figure._primitive_computeBounds();
	    } else {
	      return _figures.Figures.globalBounds_(this.figure._figures);
	    }
	  },
	  computeMaterialBounds: function () {
	    var figure = this.figure;
	    if (figure.isGrouped) {
	      return this.figure._primitive_computeMaterialBounds();
	    } else {
	      return _figures.Figures.globalMaterialBounds_(this.figure._figures);
	    }
	  },
	  computeGlobalPreVectorBounds: function () {
	    return _figures.Figures.globalPreVectorBounds_(this.figure._figures);
	  },
	  computeGlobalPreBounds: function () {
	    return _figures.Figures.globalPreBounds_(this.figure._figures);
	  },
	  computeGlobalVectorBounds: function () {
	    return _figures.Figures.globalVectorBounds_(this.figure._figures);
	  },
	  computeGlobalBounds: function () {
	    return _figures.Figures.globalBounds_(this.figure._figures);
	  },
	  computeGlobalMaterialBounds: function () {
	    return _figures.Figures.globalMaterialBounds_(this.figure._figures);
	  },
	  computePreVectorBoundsAfter: function (transform) {
	    return this.figure._primitive_computePreVectorBoundsAfter(transform);
	  },
	  computePreBoundsAfter: function (transform) {
	    return this.figure._primitive_computePreBoundsAfter(transform);
	  },
	  fineHitTest: function () /*point,transform,options*/{
	    return true; //[TODO]
	  },
	  representationType: function () {
	    return 'local'; //[TODO]
	  },
	  draw: function (context, transform, config) {
	    var figures = this.figure._figures;
	    //.forEach(figures,function(f) {
	    for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	      var f = figures[k];
	      f.draw(context, transform, config);
	    } //);
	  },
	  currentlyProcessing: function () {
	    return _figures.Figures.currentlyProcessing(this.figure.figures);
	  },
	  invalidated: function () {
	    return _figures.Figures.invalidated(this.figure.figures);
	  },
	  processed: function () {
	    return (0, _lodash.every)(this.figure.figures, function (f) {
	      return f.processed();
	    });
	  },
	  invalidate: function () {
	    clearInvalidatedCache(this.figure);
	    this._invalidate();
	  },
	  _invalidate: function () {
	    var figures = this.figure._figures;
	    //_.forEach(figures,function(f) {
	    for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	      figures[k]._processor._invalidate();
	    } //);
	  },
	  invalidateGrouping: function () {
	    this.figure.lock();
	    clearGroupedCache(this.figure);
	    this._invalidateGrouping();
	    // g.log('Processor.invalidateTransform > ' + this.figureInvalidationState);
	  },
	  _invalidateGrouping: function () {
	    var figures = this.figure._figures;
	    //_.forEach(figures,function(f) {
	    for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	      figures[k]._processor._invalidateGrouping();
	    } //);
	  },
	  invalidateTransform: function () {
	    this.figure.lock();
	    updateCache(this.figure, {});
	    this._invalidateTransform();
	    // g.log('Processor.invalidateTransform > ' + this.figureInvalidationState);
	  },
	  _invalidateTransform: function () {
	    var figures = this.figure._figures;
	    //_.forEach(figures,function(f) {
	    for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	      figures[k]._processor._invalidateTransform();
	    } //);
	  },
	  invalidateView: function () {
	    (0, _lodash.invokeMap)(this.figure._figures, 'invalidateView');
	    // g.log('Processor.invalidateView > ' + this.viewsInvalidationState);
	  },
	  invalidateUpdatedTransform: function () {
	    this._invalidateUpdatedTransform();
	  },
	  _invalidateUpdatedTransform: function () {
	    var figures = this.figure._figures;
	    //_.forEach(figures,function(f) {
	    for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	      figures[k]._processor._invalidateUpdatedTransform();
	    } //);
	    // g.log('Processor.invalidateViewTransform > ' + this.viewsInvalidationState );
	  },
	  invalidateViewTransform: function () {
	    this.figure.lock();
	    (0, _lodash.invokeMap)(this.figure._figures, 'invalidateViewTransform');
	    // g.log('Processor.invalidateViewTransform > ' + this.viewsInvalidationState );
	  },
	  fastTranslate: function (dx, dy) {
	    updateCache(this.figure, new TranslateCacheUpdater(dx, dy));
	    if (this.invalidated()) {
	      this.invalidateTransform();
	    }
	  },
	  translate: function (dx, dy) {
	    updateCache(this.figure, new TranslateCacheUpdater(dx, dy));
	    this.invalidateViewTransform();
	  },
	  scaleFrom: function (point, sx, sy, deg) {
	    updateCache(this.figure, new ScaleFromCacheUpdater(point, sx, sy, deg));
	    if (sx === sy) {
	      this.invalidateViewTransform();
	    } else {
	      this.invalidateUpdatedTransform();
	    }
	  },
	  transform: function (matrix) {
	    updateCache(this.figure, new TransformCacheUpdater(matrix));
	    this.invalidateUpdatedTransform();
	  },
	  replaceColor: function (oldColor, newColor, options) {
	    var figures = this.figure.figures;
	    //_.forEach(figures,function(f) {
	
	    for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	      figures[k].replaceColor(oldColor, newColor, options);
	    } //);
	  },
	  replaceBrush: function (oldBrush, newBrush) {
	    var figures = this.figure.figures;
	    //_.forEach(figures,function(f) {
	
	    for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	      figures[k].replaceBrush(oldBrush, newBrush);
	    } //);
	  },
	  setTaggedColors: function (tag, color) {
	    var figures = this.figure.figures;
	    //_.forEach(figures,function(f) {
	
	    for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	      figures[k].setTaggedColors(tag, color);
	    } //);
	  },
	  setLabeledColors: function (label, color) {
	    var figures = this.figure.figures;
	    //_.forEach(figures,function(f) {
	
	    for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	      figures[k].setLabeledColors(label, color);
	    } //);
	  },
	  clone: function (otherOwner, partOfGroup, ungrouping) {
	    return cloneProcessor(GroupProcessor, this, otherOwner, partOfGroup, ungrouping);
	  },
	
	
	  // internal functions
	
	  init: function (ownerFigure) {
	    this.figure = ownerFigure;
	  }
	});
	
	var OutputProcessor = exports.OutputProcessor = _gear.Base.extend({ typeName: 'OutputProcessor',
	  render$: function () {
	    error('error');
	  },
	  commit$: function () {
	    error('error');
	  },
	  update$: function () {
	    error('error');
	  },
	  cache$: function () {
	    error('error');
	  },
	  computePreReferencePoint: function () {
	    return this.figure._primitive_computePreReferencePoint();
	  },
	  computePrePin: function () {
	    return this.figure._primitive_computePrePin();
	  },
	  computePreVectorBounds: function () {
	    return this.figure._primitive_computePreVectorBounds();
	  },
	  computePreBounds: function () {
	    return this.figure._primitive_computePreBounds();
	  },
	  computeVectorBounds: function () {
	    return this.figure._primitive_computeVectorBounds();
	  },
	  computeBounds: function () {
	    return this.figure._primitive_computeBounds();
	  },
	  computeMaterialBounds: function () {
	    return this.figure._primitive_computeMaterialBounds();
	  },
	  computeGlobalPreVectorBounds: function () {
	    return this.figure._primitive_computeGlobalPreVectorBounds();
	  },
	  computeGlobalPreBounds: function () {
	    return this.figure._primitive_computeGlobalPreBounds();
	  },
	  computeGlobalVectorBounds: function () {
	    return this.figure._primitive_computeGlobalVectorBounds();
	  },
	  computeGlobalBounds: function () {
	    return this.figure._primitive_computeGlobalBounds();
	  },
	  computeGlobalMaterialBounds: function () {
	    return this.figure._primitive_computeGlobalMaterialBounds();
	  },
	  computePreVectorBoundsAfter: function (transform) {
	    return this.figure._primitive_computePreVectorBoundsAfter(transform);
	  },
	  computePreBoundsAfter: function (transform) {
	    return this.figure._primitive_computePreBoundsAfter(transform);
	  },
	  fineHitTest: function (point, transform, options) {
	    return this.figure._fineHitTest(point, transform, options);
	  },
	  representationType: function () {
	    return this.figure._representationType();
	  },
	  draw: function (context, transform, config) {
	    var outputFigure = this.figure.outputFigure;
	
	    if (outputFigure) {
	      outputFigure._draw(context, transform, config);
	    }
	  },
	  invalidate: function () {},
	  _invalidate: function () {},
	  invalidateTransform: function () {},
	  _invalidateTransform: function () {},
	  invalidateGrouping: function () {},
	  _invalidateGrouping: function () {},
	  invalidateUpdatedTransform: function () {},
	  _invalidateUpdatedTransform: function () {},
	  fastTranslate: function () {},
	  translate: function () {},
	  scaleFrom: function () {},
	  transform: function () {},
	  replaceColor: function () {},
	  replaceBrush: function () {},
	  setTaggedColors: function () {},
	  setLabeledColors: function () {},
	  clone: function (otherOwner) {
	    return new OutputProcessor(otherOwner);
	  },
	  init: function (ownerFigure) {
	    this.figure = ownerFigure;
	  },
	  invalidateView: function () {},
	  invalidateViewTransform: function () {}
	});

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Clipart = exports.Figure = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	var _geometry = __webpack_require__(21);
	
	var _style = __webpack_require__(29);
	
	var _processor = __webpack_require__(38);
	
	var _cache = __webpack_require__(37);
	
	var _process = __webpack_require__(40);
	
	var _processes = __webpack_require__(41);
	
	var _anchor = __webpack_require__(42);
	
	var _figures = __webpack_require__(43);
	
	// > 5
	
	var _lock = function () {
	  this.lock();
	},
	    _invalidate = function () {
	  this.invalidate();
	},
	    _invalidateView = function () {
	  this.invalidateView();
	};
	
	var Figure = exports.Figure = _gear.OwnedObject.extend((0, _processor.updateMethods)(), { typeName: 'Figure', _localId: 0,
	
	  __debugProps: true,
	
	  Properties: {
	    pen: { type: 'Pen', def: _style.Pen.empty, onChange: _invalidate },
	    brush: { type: 'Brush', def: _style.Brush.empty, onChange: _invalidate },
	    alpha: { type: 'number', def: 1.0, dropDef: true, onChange: _invalidateView },
	    id: { type: 'string', def: null, dropDef: true },
	    name: { type: 'string', def: null, dropDef: true },
	    xType: { type: 'string', def: 'CadX.Figure', dropDef: true, onChange: _lock },
	    locked: { type: 'boolean', def: false, dropDef: true, onChange: _lock },
	    hidden: { type: 'boolean', def: false, dropDef: true, onChange: _invalidateView },
	    clipping: { type: 'boolean', def: false, dropDef: true, onChange: _invalidate },
	    clipAbsolute: { type: 'boolean', def: false, dropDef: true, onChange: _invalidate },
	    clippedBy: { type: 'string', def: null, dropdef: true, onChange: _invalidate },
	    processes: { type: 'Process[]', def: [], onChange: _invalidate, array: _processes.Processes },
	
	    powerClipContents: { type: 'PowerClipContent[]', def: [], onChange: _invalidate },
	
	    anchor: { type: 'Anchor', def: new _anchor.AnchorGenerator(), onChange: _invalidate },
	    preMatrix22: { type: 'Matrix22', def: new _geometry.Matrix(), manualParsing: true, onChange: _invalidate },
	    matrix22: { type: 'Matrix22', def: new _geometry.Matrix(), manualParsing: true, onChange: function () {
	        this.invalidateTransform();
	      }
	    },
	    metadata: { type: 'Metadata', def: new _util.Metadata({}), manualParsing: true },
	
	    // Not part of CDL, Grafika specific properties
	    cacheId: { type: 'string', def: null, manualParsing: true, computed: true },
	    outputFigure: { type: 'Figure', def: null, owned: false, manualCloning: true, computed: true, manualParsing: true, onChange: function () {
	        this._onOutputFigureChange();
	      }
	    },
	    highlight: { type: 'boolean', def: false, manualParsing: true, computed: true, onChange: _invalidateView },
	    editingClip: { type: 'boolean', def: false, manualParsing: true, computed: true, onChange: _invalidateView }
	  },
	
	  get isGrouped() {
	    var owner = this._owner;
	    return owner && owner.isGroup;
	  },
	  get isEmpty() {
	    return false;
	  },
	  get isFigure() {
	    return true;
	  },
	
	  // [TODO] pin : we are not making it a real property until the time when bounds based pinning is removed
	  get pin() {
	    return this._pin.getPos();
	  },
	  set pin(pin_) {
	    this.translate(pin_.minus(this.pin));
	  },
	
	  lock: function (originator) {
	    if (this._owner) {
	
	      this._owner.lock(originator || this);
	    }
	  },
	  update$: function (type) {
	    if (type === "commit") {
	      if (this._invalidateOnCommit) {
	        this._processor.invalidate();
	        this._invalidateOnCommit = false;
	      }
	    }
	    return this._processor.update$(type);
	  },
	
	
	  get visible() {
	    return !this._hidden;
	  },
	  set visible(visible_) {
	    this._hidden = !visible_;
	  },
	
	  containsLinkedResources: function () {
	    return !!(0, _lodash.find)(this.getBrushes(), function (brush) {
	      return brush.containsLinkedResources();
	    });
	  },
	  rotate$: function (angle) {
	    var _this2 = this;
	
	    return this.center$().then(function (center) {
	      return _this2.rotateAround(center, angle);
	    });
	  },
	  scale$: function (sx, sy) {
	    var _this3 = this;
	
	    return this.center$().then(function (center) {
	      _this3.scaleFrom(center, sx, sy);
	    });
	  },
	  mirrorX$: function () {
	    return this.scale$(-1, 1);
	  },
	  mirrorY$: function () {
	    return this.scale$(1, -1);
	  },
	  normalizeAngle: function (angle) {
	    var m = this._matrix22;
	    var a = angle,
	        isMirror = m.determinant() < 0;
	    var ra = isMirror ? a - 180 : a;
	    return ra > 180 ? ra - 360 : ra < -180 ? ra + 360 : ra;
	  },
	  angle: function (v, pivot) {
	    var m = this._matrix22;
	    var a = m.angle();
	    if (v === undefined) {
	      return this.normalizeAngle(a);
	    } else {
	      var isMirror = m.determinant() < 0;
	      var na = isMirror ? v - 180 : v;
	      return this.rotateAround(pivot || this.pin, na - a);
	    }
	  },
	  canBeSelected: function () {
	    return !this._locked && !this._hidden && !this.isLockedTemporally() && !this.clippingHidden();
	  },
	
	
	  // Used by the UI, returns false in case the figure is not processed
	  containsPoint: function (point) {
	    return (this._outputFigure || this._cacheId) && this.globalFrame_().contains(point) && this._processor.fineHitTest(point, this.globalMatrix_());
	  },
	  hitTest: function (point) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    if (this.canBeSelected() && this.globalFrame_().contains(point)) {
	      // [TODO] Use 'selectable'?
	      if (options.frameBased || !_config.Config.useCurvesBasedSelection) {
	        return true;
	      }
	      return this._processor.fineHitTest(point, this.globalMatrix_(), options);
	    }
	    return false;
	  },
	  cloneSwap: function (figure) {
	    var c = figure.clone();
	    c.pin = this.pin.clone();
	    c.anchor = this.anchor.clone();
	    c.matrix22 = this.matrix22.clone();
	    return c;
	  },
	  pushLockedTemporally: function () {
	    ++this._lockedTemporally;
	  },
	  popLockedTemporally: function () {
	    if (this._lockedTemporally > 0) {
	      --this._lockedTemporally;
	    }
	  },
	  isLockedTemporally: function () {
	    return this._lockedTemporally > 0;
	  },
	
	
	  // [TODO] We need to replace this with forEachColor abstraction
	  getColors: function () {
	    var colors = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    this.topColors(colors);
	    this.otherColors(colors); // Override in derived classes
	    if (this._processes.length > 0 && this.outputFigure && this.outputFigure !== this) {
	      this.outputFigure.getColors(colors);
	    }
	    if (this.isRaster && this.isMonochrome) {
	      this.colorMap.getColors(colors);
	    }
	    this._processes.getColors(colors);
	    (0, _lodash.forEach)(this.powerClipContents, function (pcc) {
	      pcc.getColors(colors);
	    });
	    return colors;
	  },
	  setTaggedColors: function (tag, color) {
	    // This function goes through the processor to optimize the invalidation
	    this._processor.setTaggedColors(tag, color);
	    return this;
	  },
	  _setTaggedColors: function (tag, color) {
	    var keepTags = true;
	    var keepLabels = true;
	    var colors = this.getColors();
	
	    var changed = false;
	
	    //_.forEach(colors,function(c) {
	    for (var k = 0, kEnd = colors.length; k < kEnd; ++k) {
	      var c = colors[k];
	      if (c._tag === tag) {
	        c._replace(color, keepTags, keepLabels); // avoid figure invalidation
	        changed = true;
	      }
	    } //);
	    return changed;
	  },
	  setLabeledColors: function (label, color) {
	    // This function goes through the processor to optimize the invalidation
	    this._processor.setLabeledColors(label, color);
	    return this;
	  },
	  _setLabeledColors: function (label, color) {
	    var keepTags = true;
	    var keepLabels = true;
	    var colors = this.getColors();
	
	    var changed = false;
	
	    //_.forEach(colors,function(c) {
	    for (var k = 0, kEnd = colors.length; k < kEnd; ++k) {
	      var c = colors[k];
	      if (c._label === label) {
	        c._replace(color, keepTags, keepLabels); // avoid figure invalidation
	        changed = true;
	      }
	    } //);
	    return changed;
	  },
	  replaceColor: function (oldColor, newColor, options) {
	    // [TODO] Simplify? Maybe we do not need this optimization any more
	    //
	    // This function goes through the processor to optimize the invalidation
	    this._processor.replaceColor(oldColor, newColor, options);
	    return this;
	  },
	
	  _replaceColor: _style.Color._this_fastReplaceColor,
	
	  // Old name, alias to keep bc
	  uniqueColorZones: _style.Color._this_zones,
	
	  // Use this one from now on
	  colorZones: _style.Color._this_zones,
	
	  changeColorZone: function (zone, value) {
	    // [TODO] We may not need all this anymore
	    //        simplify, keep this only about colors
	    //        just use => Color._this_changeZone,
	    if (zone._unique) {
	      if (zone.value instanceof _style.Color) {
	        if (value instanceof _style.Color) {
	          this.replaceColor(zone.value, value, { tagsCollapsed: zone.tagsCollapsed, keepTags: true });
	        } else if (value instanceof _style.Brush) {
	          this.replaceColor(zone.value, value.color, { tagsCollapsed: zone.tagsCollapsed, keepTags: true });
	        } else {
	          this.replaceBrush(new _style.Brush(zone.value.clone()), value);
	        }
	      } else {
	        var newBrush = value instanceof _style.Color ? new _style.Brush(value) : value;
	        this.replaceBrush(zone.value, newBrush);
	      }
	    } /*
	      else {
	       // To be used by structured color zones
	      }*/
	  },
	  replaceBrush: function (oldBrush, newBrush) {
	    // This function goes through the processor to optimize the invalidation
	    this._processor.replaceBrush(oldBrush, newBrush);
	    return this;
	  },
	  _replaceBrush: function (oldBrush, newBrush) {
	    var oldBrushString = oldBrush.textualize();
	    var brushes = this.getBrushes();
	
	    var changed = false;
	
	    //_.forEach(brushes,function(c) {
	    for (var k = 0, kEnd = brushes.length; k < kEnd; ++k) {
	      var b = brushes[k];
	      var bString = b.textualize();
	      if (bString === oldBrushString) {
	        // Performance hack
	        var owner = b._owner;
	
	        var tag = b.tag;
	        var label = b.label;
	
	
	        var brush = owner._brush = newBrush.clone();
	        brush._owner = owner;
	
	        // Preserve tags and labels, used to represent clipart structure
	        // Avoid collapsing brushes into a single color, that later can not
	        // be subdivided.
	        brush._tag = tag;
	        brush._label = label;
	
	        changed = true;
	      }
	    } //);
	    return changed;
	  },
	  invalidate: function () {
	    this._processor.invalidate();
	    this.callParent();
	    return this;
	  },
	  invalidateGrouping: function () {
	    this._processor.invalidateGrouping();
	    return this;
	  },
	  invalidateTransform: function () {
	    this._processor.invalidateTransform();
	    return this;
	  },
	  invalidateView: function (force) {
	    this._processor.invalidateView(force);
	    return this;
	  },
	  invalidateViewTransform: function () {
	    this._processor.invalidateViewTransform();
	    return this;
	  },
	  invalidated: function () {
	    return this._processor.invalidated();
	  },
	  processed: function () {
	    return this._processor.processed();
	  },
	  currentlyProcessing: function () {
	    return this._processor.currentlyProcessing();
	  },
	  _clone: function () /*partOfGroup, ungrouping*/{
	    var _this4 = this;
	
	    var p = {};
	    var properties = this.Properties;
	    //_.forEach(properties,function(prop,name ) { [TODO]
	    (0, _lodash.forOwn)(properties, function (prop, name) {
	      if (prop.manualCloning !== true) {
	        var v = _this4[prop.member];
	        p[name] = v !== null ? v.cloneDeep ? v.cloneDeep() : v.clone ? v.clone() : v : null;
	      }
	    });
	    p.pin = this.pin.clone(); // still outside of properties
	    return p;
	  },
	  clone: function (includingProcessor, partOfGroup, ungrouping) {
	    if (includingProcessor === undefined) {
	      includingProcessor = true;
	    }
	    if (partOfGroup === undefined) {
	      partOfGroup = this.isGroup;
	    }
	    if (ungrouping === undefined) {
	      ungrouping = this._owner instanceof Figure.Group;
	    }
	
	    var clonedFigure = new this.constructor(this._clone(partOfGroup, ungrouping));
	    if (includingProcessor) {
	      clonedFigure._processor = this._processor.clone(clonedFigure, partOfGroup, ungrouping);
	    }
	
	    clonedFigure._computedPreScale = this._computedPreScale.clone();
	
	    if (!partOfGroup) {
	      // Clean up the PowerClipContent cloneLink used in PowerClipLink cloning
	      (0, _lodash.forEach)(this.deepPowerClipContents(), function (pcContent) {
	        pcContent._cloneLink = null;
	      });
	    }
	    return clonedFigure;
	  },
	  toXml: function () {
	    var serverCache = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	    var bypassServerCacheAttr = serverCache ? '' : ' _canvasBypassServerCache="' + (0, _lodash.now)() + '"';
	    var xml = _util.Xml.fromString('<Cdl' + bypassServerCacheAttr + '></Cdl>');
	    this.buildXml(xml.documentElement);
	    return xml;
	  },
	  toXmlString: function (serverCache) {
	    return _util.Xml.toString(this.toXml(serverCache));
	  },
	
	
	  // , buildXml: ... // overriden by derived figures
	
	  setupXml: function (node) {
	    var me = this;
	
	    _util.Xml.setupProperties(node, this);
	
	    this._metadata.setupXml(node);
	
	    var preMatrix22 = this._preMatrix22;
	    if (!preMatrix22.isIdentity()) {
	      var preTransformNode = _util.Xml.appendElement(node, 'PreTransform');
	      preMatrix22.setMatrix22Attr(preTransformNode, 'Matrix22');
	    }
	    _anchor.FigureTransform.buildXml(me._matrix22, node);
	    me._pin.buildXml(node);
	  },
	  bakeTransform: function () {
	    this._preMatrix22 = _geometry.Matrix.m(this._matrix22, this._preMatrix22);
	    this._matrix22 = new _geometry.Matrix();
	    this.invalidate();
	  },
	
	
	  // Options are 'left', 'center', 'right' + 'bottom', 'middle', 'top'.
	  align$: function (alignment, to, margin) {
	    var _this5 = this;
	
	    var toBounds = to.bounds || (to.lx !== undefined ? to : null);
	    if (toBounds) {
	      return this._align$(alignment, toBounds, margin);
	    } else {
	      return _figures.Figures.bounds$(to).then(function (toBounds) {
	        return _this5._align$(alignment, toBounds, margin);
	      });
	    }
	  },
	  fitFrame$: function (toFrame) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var me = this;
	    if (!options.ignoreWidth) {
	      options.width = toFrame.width;
	    }
	    if (!options.ignoreHeight) {
	      options.height = toFrame.height;
	    }
	    return me.frame$().then(function (frame) {
	      var s = _figures.Figures._computeSizingScale(frame.width, frame.height, options);
	      return me.transform(_geometry.Matrix.m(_geometry.Matrix.scaleFrom(frame.center, s.sX, s.sY, frame.angle()), _geometry.Matrix.translate(toFrame.center.minus(frame.center))));
	    });
	  },
	  modifyKeeping$: function (what, func) {
	    var _this6 = this;
	
	    return this.update$().then(function () {
	
	      switch (what) {
	        case 'nothing':
	          {
	            return (0, _gear.resolve)(func(_this6)).then(function () {
	              return _this6;
	            });
	          }
	        case 'bounds':
	          {
	            var _ret = function () {
	              var oldBounds = _this6.bounds_();
	              return {
	                v: (0, _gear.resolve)(func(_this6)).then(function () {
	                  return _this6.fit$(oldBounds);
	                })
	              };
	            }();
	
	            if (typeof _ret === "object") return _ret.v;
	          }
	        case 'center':
	          {
	            var _ret2 = function () {
	              var oldCenter = _this6.center_();
	              return {
	                v: (0, _gear.resolve)(func(_this6)).then(function () {
	                  return _this6.center$(oldCenter);
	                })
	              };
	            }();
	
	            if (typeof _ret2 === "object") return _ret2.v;
	          }
	        case 'width':
	          {
	            var _ret3 = function () {
	              var oldBounds = _this6.bounds_();
	              return {
	                v: (0, _gear.resolve)(func(_this6)).then(function () {
	                  return _this6.fit$(oldBounds, { ignoreHeight: true });
	                })
	              };
	            }();
	
	            if (typeof _ret3 === "object") return _ret3.v;
	          }
	        case 'frame':
	          {
	            var _ret4 = function () {
	              var oldFrame = _this6.frame_();
	              return {
	                v: (0, _gear.resolve)(func(_this6)).then(function () {
	                  return _this6.fitFrame$(oldFrame);
	                })
	              };
	            }();
	
	            if (typeof _ret4 === "object") return _ret4.v;
	          }
	        case 'frameCenter':
	          {
	            var _ret5 = function () {
	              var oldFrame = _this6.frame_();
	              return {
	                v: (0, _gear.resolve)(func(_this6)).then(function () {
	                  return _this6.frame$().then(function (frame) {
	                    return _this6.translate(oldFrame.center.minus(frame.center));
	                  });
	                })
	              };
	            }();
	
	            if (typeof _ret5 === "object") return _ret5.v;
	          }
	        case 'frameWidth':
	          {
	            var _ret6 = function () {
	              var oldFrame = _this6.frame_();
	              return {
	                v: (0, _gear.resolve)(func(_this6)).then(function () {
	                  return _this6.fitFrame$(oldFrame, { ignoreHeight: true });
	                })
	              };
	            }();
	
	            if (typeof _ret6 === "object") return _ret6.v;
	          }
	        default:
	        // error('Figure.modifyKeeping, unsupported option');
	      }
	    });
	  },
	  center_: function () {
	    return this.bounds_().center;
	  },
	  center$: function (where, y) {
	    return _figures.Figures.center$([this], where, y);
	  },
	
	
	  // Reference point abstraction, this will be eliminated when we are going to be able to eliminate the bounds based pinning
	  preReferencePoint_: function () {
	    return this._cache.get('preReferencePoint');
	  },
	  referencePoint_: function () {
	    return this.preReferencePoint_().transformed(this.matrix_());
	  },
	  globalPreReferencePoint_: function () {
	    return this.preReferencePoint_().transformed(this.globalPreMatrix_());
	  },
	  globalReferencePoint_: function () {
	    return this.preReferencePoint_().transformed(this.globalMatrix_());
	  },
	  preReferencePoint$: function () {
	    return this.update$().then(this.preReferencePoint_.bind(this));
	  },
	  referencePoint$: function () {
	    return this.update$().then(this.referencePoint_.bind(this));
	  },
	  globalPreReferencePoint$: function () {
	    return this.update$().then(this.globalPreReferencePoint_.bind(this));
	  },
	  globalReferencePoint$: function () {
	    return this.update$().then(this.globalReferencePoint_.bind(this));
	  },
	  _computePreReferencePoint: function () {
	    return this._processor.computePreReferencePoint();
	  },
	
	  // ----------
	
	  vectorFrame$: function () {
	    return this.update$().then(this.vectorFrame_.bind(this));
	  },
	  frame$: function () {
	    return this.update$().then(this.frame_.bind(this));
	  },
	  globalVectorFrame$: function () {
	    return this.update$().then(this.globalVectorFrame_.bind(this));
	  },
	  globalFrame$: function () {
	    return this.update$().then(this.globalFrame_.bind(this));
	  },
	  vectorFrame_: function () {
	    return _geometry.Frame.fromBounds(this.preVectorBounds_()).transformed(this.matrix_());
	  },
	  frame_: function () {
	    var matrix = this.matrix_();
	
	    // if (this.getClippedBy != null) {
	    //   const [lClipContent, lClipParent] = this.getClippedBy();
	    //   if (lClipContent != null) {
	    //     return Frame.fromBounds(lClipContent.preBounds_()).transformed(lClipContent.matrix_()).transformed(matrix);
	    //   }
	    // }
	
	    if (matrix.isAlmostIsotropic()) {
	      return _geometry.Frame.fromBounds(this.preBounds_()).transformed(matrix);
	    } else {
	      return this._computeAnisotropicFrame('matrix_', 'vectorFrame_', 'preBounds_', 'preVectorBounds_');
	    }
	  },
	  globalVectorFrame_: function () {
	    // [TODO] use vectorFrame_
	    return _geometry.Frame.fromBounds(this.globalPreVectorBounds_()).transformed(this.globalTopMatrix_());
	  },
	  globalFrame_: function () {
	    var matrix = this.globalTopMatrix_();
	    if (matrix.isAlmostIsotropic()) {
	      return _geometry.Frame.fromBounds(this.globalPreBounds_()).transformed(matrix);
	    } else {
	      return this._computeAnisotropicFrame('globalTopMatrix_', 'globalVectorFrame_', 'globalPreBounds_', 'globalPreVectorBounds_');
	    }
	  },
	  globalTopMatrix_: function () {
	    var owner = this;
	    while (owner._owner instanceof Figure.Group) {
	      owner = owner._owner;
	    }
	    return owner.matrix_();
	  },
	  _computeAnisotropicFrame: function (matrix, vectorFrame, preBounds, preVectorBounds) {
	    var urb = this[preBounds]();
	    var ub = this[preVectorBounds]();
	    var olx = ub.lx - urb.lx;
	    var ohx = urb.hx - ub.hx;
	    var oly = ub.ly - urb.ly;
	    var ohy = urb.hy - ub.hy;
	    var s = this[matrix]().scaleFactor();
	    return this[vectorFrame]().extended(s * olx, s * oly, s * ohx, s * ohy);
	  },
	
	
	  computedPreScale_: function () {
	    return this._computedPreScale.clone();
	  },
	
	  prePin$: function () {
	    return this.update$().then(this.prePin_.bind(this));
	  },
	  preVectorBounds$: function () {
	    return this.update$().then(this.preVectorBounds_.bind(this));
	  },
	  preBounds$: function () {
	    return this.update$().then(this.preBounds_.bind(this));
	  },
	  matrix$: function () {
	    return this.update$().then(this.matrix_.bind(this));
	  },
	  vectorBounds$: function () {
	    return this.update$().then(this.vectorBounds_.bind(this));
	  },
	  bounds$: function (v) {
	    if (v === undefined) {
	      return this.update$().then(this.bounds_.bind(this));
	    } else {
	      return this.fit$(v);
	    }
	  },
	  materialBounds$: function () {
	    return this.update$().then(this.materialBounds_.bind(this));
	  },
	  globalPreMatrix$: function () {
	    return this.update$().then(this.globalPreMatrix_.bind(this));
	  },
	  globalPreVectorBounds$: function () {
	    return this.update$().then(this.globalPreVectorBounds_.bind(this));
	  },
	  globalPreBounds$: function () {
	    return this.update$().then(this.globalPreBounds_.bind(this));
	  },
	  globalMatrix$: function () {
	    return this.update$().then(this.globalMatrix_.bind(this));
	  },
	  globalVectorBounds$: function () {
	    return this.update$().then(this.globalVectorBounds_.bind(this));
	  },
	  globalBounds$: function () {
	    return this.update$().then(this.globalBounds_.bind(this));
	  },
	  globalMaterialBounds$: function () {
	    return this.update$().then(this.globalMaterialBounds_.bind(this));
	  },
	  globalCenter$: function () {
	    return this.globalBounds$().then(function (bounds) {
	      return bounds.center;
	    });
	  },
	  prePin_: function () {
	    return this._cache.get('prePin');
	  },
	  preVectorBounds_: function () {
	    return this._cache.get('preVectorBounds');
	  },
	  preBounds_: function () {
	    return this._cache.get('preBounds');
	  },
	  matrix_: function () {
	    return this._cache.get('matrix');
	  },
	  vectorBounds_: function () {
	    return this._cache.get('vectorBounds');
	  },
	  bounds_: function () {
	    return this._cache.get('bounds');
	  },
	  materialBounds_: function () {
	    return this._cache.get('materialBounds');
	  },
	  globalPreMatrix_: function () {
	    return this._cache.get('globalPreMatrix');
	  },
	  globalPreVectorBounds_: function () {
	    return this._cache.get('globalPreVectorBounds');
	  },
	  globalPreBounds_: function () {
	    return this._cache.get('globalPreBounds');
	  },
	  globalMatrix_: function () {
	    return this._cache.get('globalMatrix');
	  },
	  globalVectorBounds_: function () {
	    return this._cache.get('globalVectorBounds');
	  },
	  globalBounds_: function () {
	    return this._cache.get('globalBounds');
	  },
	  globalMaterialBounds_: function () {
	    return this._cache.get('globalMaterialBounds');
	  },
	  boundsComputed: function () {
	    return this._cache.has('bounds');
	  },
	
	
	  // If Config.computeFigureGeometryLocally is false (i.e. IE8) then we should never get to these functions
	
	  // Functions triggered by the cache to compute bounds metrics
	  // 1) .bounds$() => .update$() then...
	  // 2) .bounds_() => return cached value or...
	  // 3) .computeBounds_() => forward to...
	  // 4) ._processor.computeBounds() => depending on the processor:
	  //       a) Processor:        forward to .outputFigure._primitive_computeBounds_()
	  //       b) OutputProcessor:  forward directly to ._primitive_computeBounds_()
	  //       c) GroupProcessor:   Figures.bounds_( .figures )
	
	  // preBounds: bounds of the isolated figure without including its own matrix
	  // bounds: bounds of the isolated figure, if it is not grouped is the same as the figure globalPreBounds
	  //         If the parent group is not grouped is the same as the globalBounds
	  // globalPreBounds: bounds of the figure without the top most group or figure transform
	  //                  Used to compute the frame
	  // globalBounds: bounds of the figure in its final position in the document once that all
	  //               group transforms have been applied.
	
	  boundsIsVectorBounds: function () {
	    return false;
	  },
	  _computePrePin: function () {
	    return this._processor.computePrePin();
	  },
	
	
	  // Testing, without optimizations
	  /*
	  , _computePreVectorBounds     () { return this._processor.computePreVectorBounds(); }
	  , _computePreBounds           () { return this._processor.computePreBounds(); }
	  , _computeVectorBounds        () { return this._processor.computeVectorBounds(); }
	  , _computeBounds              () { return this._processor.computeBounds(); }
	  , _computeGlobalPreVectorBounds() { return this._processor.computeGlobalPreVectorBounds(); }
	  , _computeGlobalPreBounds     () { return this._processor.computeGlobalPreBounds(); }
	  , _computeGlobalVectorBounds  () { return this._processor.computeGlobalVectorBounds(); }
	  , _computeGlobalBounds        () { return this._processor.computeGlobalBounds(); }
	  */
	
	  _computePreVectorBounds: function () {
	    return this._processor.computePreVectorBounds();
	  },
	  _computePreBounds: function () {
	    if (this.boundsIsVectorBounds()) {
	      // console.log('>>> optimize preBounds_ using preVectorBounds_');
	      return this.preVectorBounds_().clone();
	    }
	    return this._processor.computePreBounds();
	  },
	  _computeVectorBounds: function () {
	    var parent = this._owner;
	    if (parent instanceof Figure.Group) {
	      if (parent._owner instanceof Figure.Group) {
	        var b = this._optimizeVectorBounds(this.matrix_());
	        return b || this._processor.computeVectorBounds();
	      } else {
	        return this.globalPreVectorBounds_().clone();
	      }
	    } else {
	      return this.globalVectorBounds_().clone();
	    }
	  },
	  _computeBounds: function () {
	    var parent = this._owner;
	    if (parent instanceof Figure.Group) {
	      if (this.boundsIsVectorBounds()) {
	        // console.log('>>> optimize bounds_ using vectorBounds_');
	        return this.vectorBounds_().clone();
	      }
	      if (parent._owner instanceof Figure.Group) {
	        var b = this._optimizeBounds(this.matrix_());
	        return b || this._processor.computeBounds();
	      } else {
	        return this.globalPreBounds_().clone();
	      }
	    } else {
	      return this.globalBounds_().clone();
	    }
	  },
	  _computeMaterialBounds: function () {
	    return this._processor.computeMaterialBounds();
	  },
	  _computeGlobalPreVectorBounds: function () {
	    if (this._owner instanceof Figure.Group) {
	      var b = this._optimizeVectorBounds(this.globalPreMatrix_());
	      return b || this._processor.computeGlobalPreVectorBounds();
	    } else {
	      return this.preVectorBounds_().clone();
	    }
	  },
	  _computeGlobalPreBounds: function () {
	    if (this._owner instanceof Figure.Group) {
	      if (this.boundsIsVectorBounds()) {
	        // console.log('>>> optimize globalPreBounds_ using vectorBounds_');
	        return this.globalPreVectorBounds_().clone();
	      }
	      var b = this._optimizeBounds(this.globalPreMatrix_());
	      return b || this._processor.computeGlobalPreBounds();
	    } else {
	      return this.preBounds_().clone();
	    }
	  },
	  _computeGlobalVectorBounds: function () {
	    var b = this._optimizeVectorBounds(this.globalMatrix_());
	    return b || this._processor.computeGlobalVectorBounds();
	  },
	  _computeGlobalBounds: function () {
	    if (this.boundsIsVectorBounds()) {
	      // console.log('>>> optimize bounds_ using vectorBounds_');
	      return this.globalVectorBounds_().clone();
	    }
	    var b = this._optimizeBounds(this.globalMatrix_());
	    return b || this._processor.computeGlobalBounds();
	  },
	  _computeGlobalMaterialBounds: function () {
	    return this._processor.computeGlobalMaterialBounds();
	  },
	
	
	  // Groups disable this optimization
	  _optimizeVectorBounds: function (t) {
	    if (t.s01 === 0 && t.s10 === 0) {
	      // console.log('>>> optimize vectorBounds_ using preVectorBounds_');
	      var ub = this.preVectorBounds_();
	      return ub.scalingTransformed(t);
	    } else {
	      return null;
	    }
	  },
	  _optimizeBounds: function (t) {
	    if (t.s00 === t.s11 && t.s01 === 0 && t.s10 === 0) {
	      //console.log('>>> optimize bounds_ using preBounds_');
	      var ub = this.preBounds_();
	      return ub.scalingTransformed(t);
	    } else {
	      return null;
	    }
	  },
	  _computePreVectorBoundsAfter: function (t) {
	    return this._processor.computePreVectorBoundsAfter(t);
	  },
	  _computePreBoundsAfter: function (t) {
	    return this._processor.computePreBoundsAfter(t);
	  },
	
	
	  // abstract _primitive_computePreVectorBounds    () {}
	  // abstract _primitive_computePreBounds          () {}
	  // abstract _primitive_computePreVectorBoundsAfter( transform ) {}
	  // abstract _primitive_computePreBoundsAfter      ( transform ) {}
	
	
	  _primitive_computeMaterialBounds: function () {
	    return this._primitive_computePreMaterialBoundsAfter(this.matrix_());
	  },
	  _primitive_computePreMaterialBoundsAfter: function (transform) {
	    return this._primitive_computePreBoundsAfter(transform);
	  },
	  _primitive_computeVectorBounds: function () {
	    return this._primitive_computePreVectorBoundsAfter(this.matrix_());
	  },
	  _primitive_computeBounds: function () {
	    return this._primitive_computePreBoundsAfter(this.matrix_());
	  },
	  _primitive_computeGlobalPreVectorBounds: function () {
	    return this._primitive_computePreVectorBoundsAfter(this.globalPreMatrix_());
	  },
	  _primitive_computeGlobalPreBounds: function () {
	    return this._primitive_computePreBoundsAfter(this.globalPreMatrix_());
	  },
	  _primitive_computeGlobalVectorBounds: function () {
	    return this._primitive_computePreVectorBoundsAfter(this.globalMatrix_());
	  },
	  _primitive_computeGlobalBounds: function () {
	    return this._primitive_computePreBoundsAfter(this.globalMatrix_());
	  },
	  _primitive_computeGlobalMaterialBounds: function () {
	    return this._primitive_computePreMaterialBoundsAfter(this.globalMatrix_());
	  },
	  _primitive_computePrePin: function () {
	    var anchor = this.anchor;
	
	    var pos = anchor._pos.clone();
	    return anchor._absolute ? pos : this.preVectorBounds_().interpolate(pos);
	  },
	
	
	  // Functions triggered by the cache to compute matrix
	
	  // If prePin is given, it is used instead of the cached one
	  _computeMatrix: function (prePin) {
	
	    var pin = this._pin;
	    var matrix22 = this instanceof Figure.Raster ? _geometry.Matrix.m(this._preMatrix22, this._matrix22) : this._matrix22;
	
	    // We currently have two pinning system in CDL:
	    // Bounds based pinning (traditional system):
	    //   In this system the figure is first transformed and constrained. Afterwards
	    //   the bounds of the transformed figure are calculated and is used to compute
	    //   the reference point (with pin.relPos) that will be moved to pin.pos
	    // Anchor based pinning (new system):
	    //   Figures have an anchor (reference point) that can be absolute or relative
	    //   to the preVectorBounds. The figure is transformed with the anchor as pivot
	    //   and later moved to pin.pos using the anchor as reference. This avoids the
	    //   problems with the bounds based pinning system when there are rotations and
	    //   the reference point start jumping from place to place.
	
	    var boundsBasedPinning = pin && !pin.anchorBased();
	
	    // prePin_() could require an expensive call to _computeVectorBounds() and in the
	    // case of bounds based pinning it will be ignored anyways at the end, so better to
	    // avoid it. This produces a noticeable effect in the user experience.
	    var anchor = boundsBasedPinning ? new _geometry.Point(0, 0) : prePin || this.prePin_();
	
	    // Move the figures to the origin, and transform them there
	    var matrix = _geometry.Matrix.m(matrix22, _geometry.Matrix.translate(_geometry.Point.minus(anchor)));
	
	    if (!pin) {
	      return matrix; // Remove this guard, the pin is always defined
	    }
	
	    // Account for old bounds based pinning, this will be removed at one point
	    if (boundsBasedPinning) {
	      var offset = this._computePreVectorBoundsAfter(matrix).interpolate(pin.getRelPos());
	      matrix = _geometry.Matrix.m(_geometry.Matrix.translate(_geometry.Point.minus(offset)), matrix);
	    }
	
	    // Translate the origin to the pin
	    matrix = _geometry.Matrix.m(_geometry.Matrix.translate(this.pin), matrix);
	
	    return matrix;
	  },
	  _computeGlobalPreMatrix: function () {
	    var parent = this._owner;
	    if (parent instanceof Figure.Group) {
	      var t = this.matrix_();
	      return _geometry.Matrix.m(this._owner.globalPreMatrix_(), t);
	    } else {
	      return new _geometry.Matrix();
	    }
	  },
	  _computeGlobalMatrix: function () {
	    var t = this.matrix_();
	    return this._owner instanceof Figure.Group ? _geometry.Matrix.m(this._owner.globalMatrix_(), t) : t;
	  },
	  processPowerClips$: function () {
	    return (0, _gear.invokeMap$)(this.deepPowerClipContents(), 'update$');
	  },
	  generateOutputFigure$: function () {
	    var _this = this;
	
	    // Cache all data before starting, in case the user starts changing the figure
	    var preMatrix22 = _this._preMatrix22.clone();
	    var processes = _this._processes.cloneDeep();
	
	    var matrix22 = _this.matrix22.clone();
	    var pin = _this.pin.clone();
	    var alpha = _this.alpha;
	
	    return _this.inputPrimitiveFigures$().then(function (input) {
	
	      input.preScale = new _geometry.Point(1, 1);
	
	      if (input.figures.length === 0) {
	        return _this.createEmptyOutput();
	      }
	
	      if (!preMatrix22.isIdentity()) {
	        (function () {
	          var ta = _geometry.Matrix.transformAround(input.anchor, preMatrix22);
	          (0, _lodash.forEach)(input.figures, function (figure) {
	            figure.transform(ta);
	          });
	        })();
	      }
	
	      // Allow forwarding of textLayouts for non text processes, so they can be edited
	      input.textLayouts = (0, _lodash.filter)(input.figures, 'isTextLayout');
	
	      // output is one Figure (possible a group)
	      var output = processes.process(input);
	
	      _this._computedPreScale = output._computedPreScale;
	      // console.log(_this._computedPreScale.textualize());
	
	      output.alpha = alpha;
	
	      // Review this two... should we use the latest ones here?
	      output.matrix22 = matrix22;
	      output.pin = pin;
	
	      output.clippedBy = _this.clippedBy;
	      output.clipping = _this.clipping;
	      output.clipAbsolute = _this.clipAbsolute;
	
	      // console.log('Finish text processing');
	
	      return output;
	    });
	  },
	  addClippingRect$: function (aId) {
	    var lDoc = this.document;
	    var me = this;
	    return this.preBounds$().then(function (bounds) {
	      var figure = Figure.Shape.CreateRectangle({
	        center: new _geometry.Point(bounds.mx, bounds.my),
	        width: bounds.width * 0.9,
	        height: bounds.height * 0.9,
	        brush: { color: { rgb: '000000', alpha: 0.0 } }
	      });
	      lDoc.add(figure);
	      figure.clipping = true;
	      figure.id = aId;
	      me.clippedBy = aId;
	      return me.beginEditClip$();
	    });
	  },
	  beginEditClip$: function () {
	    var _getClippedBy = this.getClippedBy();
	
	    var _getClippedBy2 = _slicedToArray(_getClippedBy, 2);
	
	    var lClipContent = _getClippedBy2[0];
	    var lClipParent = _getClippedBy2[1];
	
	    if (lClipContent) {
	      if (!lClipContent.clipAbsolute && !lClipContent.editingClip) {
	        lClipContent.transform(lClipParent.globalMatrix_());
	      }
	      lClipContent.editingClip = true;
	    }
	    return this.document.preview$();
	  },
	  endEditClip$: function () {
	    var _getClippedBy3 = this.getClippedBy();
	
	    var _getClippedBy4 = _slicedToArray(_getClippedBy3, 2);
	
	    var lClipContent = _getClippedBy4[0];
	    var lClipParent = _getClippedBy4[1];
	
	    if (lClipContent) {
	      if (!lClipContent.clipAbsolute) {
	        lClipContent.transform(_geometry.Matrix.invert(lClipParent.globalMatrix_()));
	      }
	      lClipContent.editingClip = false;
	    }
	    return this.document.commit$();
	  },
	  clippingHidden: function () {
	    return this.getClipping() && !this._editingClip;
	  },
	  getClippedBy: function () {
	    var o = this;
	    var lClippedBy = this.clippedBy;
	    var lClipParent = this; //the node that the clipped is relative to
	    while (o && !o.isLayer && !lClippedBy) {
	      var oo = o._owner;
	      if (oo && oo.isGroup) {
	        lClippedBy = oo.clippedBy;
	        lClipParent = oo;
	      }
	      o = oo;
	    }
	
	    var lClipContent = null;
	    if (lClippedBy !== null) {
	      var lDoc = this.document;
	      var lFigures = lDoc.figures;
	      lClipContent = (0, _lodash.find)(lFigures, { _id: lClippedBy });
	    }
	
	    return [lClipContent, lClipParent];
	  },
	  getClipping: function () {
	    var o = this;
	    var lClipping = this.clipping;
	    while (o && !o.isLayer && !lClipping) {
	      var oo = o._owner;
	      if (oo && oo.isGroup) {
	        lClipping = oo.clipping;
	      }
	      o = oo;
	    }
	    return lClipping;
	  },
	  rwPowerClipTransform: function () {
	    // The powerclip transform is simpler than the one needed for polyregions
	    // Because the powerclip figures are always based against the origin, we
	    // just need to apply the matrix22 directly and then move the result to
	    // the pin position. The anchor of the figures doesn't play a role here
	    var o = this._owner,
	        t = _geometry.Matrix.m(_geometry.Matrix.translate(this.pin), this._matrix22);
	    return o instanceof Figure.Group ? _geometry.Matrix.m(o.globalMatrix_(), t) : t;
	  },
	  grouped: function () {
	    return this._owner instanceof Figure.Group;
	  },
	  canEditContent: function () {
	    return this._powerClipContents.length > 0;
	  },
	  createEmptyOutput: function () {
	    return Figure.Shape.CreateRectangle({ center: this.pin, width: 100, height: 100, brush: _style.Brush.empty });
	  },
	
	
	  get document() {
	    var o = this._owner;
	    while (o) {
	      if (o.isDocument) {
	        return o;
	      }
	      o = o._owner;
	    }
	    return null;
	  },
	
	  get page() {
	    var o = this._owner;
	    while (o) {
	      if (o.isPage) {
	        return o;
	      }
	      o = o._owner;
	    }
	    return null;
	  },
	
	  get layer() {
	    var o = this._owner;
	    while (o) {
	      if (o.isLayer) {
	        return o;
	      }
	      o = o._owner;
	    }
	    return null;
	  },
	
	  // Return the top input figure
	  get topFigure() {
	    var o = this;
	    while (o) {
	      var oo = o._owner;
	      if (oo && oo.isLayer) {
	        return o._inputFigure || o;
	      }
	      o = o._owner;
	    }
	    return null;
	  },
	
	  shouldDrawTextureType: function (textureType) {
	    return textureType === 'color';
	  },
	  outputsText: function () {
	    return false;
	  },
	  quickToDraw: function () {
	    return false;
	  },
	  canBeProcessedLocally: function () {
	    return false;
	  },
	  supportsLocalMetrics: function () {
	    return true;
	  },
	  usingPowerClipLink: function () {
	    return this.canBeProcessedLocally();
	    // Possible optimization:
	    // When we use server processing, and there is only one powerclip content we manually
	    // set up the PowerClipLink at the output
	    //  || ( ! this.isGroup && this._powerClipContents.length < 2 );
	  },
	  init: function () {
	    var p = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var _this = this;
	
	    _this.callParent(p);
	    _this._localId = (0, _lodash.uniqueId)();
	
	    _this._inputFigure = null;
	
	    _this._cache = new _cache.FigureCache({
	      preReferencePoint: _this._computePreReferencePoint,
	
	      prePin: _this._computePrePin,
	      preVectorBounds: _this._computePreVectorBounds,
	      preBounds: _this._computePreBounds,
	      matrix: _this._computeMatrix,
	      vectorBounds: _this._computeVectorBounds,
	      bounds: _this._computeBounds,
	      materialBounds: _this._computeMaterialBounds,
	      globalPreMatrix: _this._computeGlobalPreMatrix,
	      globalPreVectorBounds: _this._computeGlobalPreVectorBounds,
	      globalPreBounds: _this._computeGlobalPreBounds,
	      globalMatrix: _this._computeGlobalMatrix,
	      globalVectorBounds: _this._computeGlobalVectorBounds,
	      globalBounds: _this._computeGlobalBounds,
	      globalMaterialBounds: _this._computeGlobalMaterialBounds
	      // [TODO] globalMaterialBounds ?
	
	    }, _this);
	
	    // Pre scale is used to compute the concrete font size, it is the
	    // approximate scaling in x and y of the figure after the preTransform
	    // and being processed. It doesn't include the final transformation.
	    // We do not add this to the cache because it is not something that can
	    // be computed directly from the output figure. It needs to be computed
	    // during the processing of the effect stack and saved
	    _this._computedPreScale = new _geometry.Point(1, 1);
	
	    // Most of this will be eliminated once we no longer needs to support bounds based pinning
	    _this._pin = p.pin ? p.pin instanceof _anchor.Pin ? p.pin : new _anchor.Pin(p.pin, true) : new _anchor.Pin();
	
	    _this._bc = {};
	
	    _this._processor = new _processor.Processor(_this);
	
	    _this._lockedTemporally = 0; // [TODO] make a helper for all this push, pop logic
	
	    _this.initEvents();
	  },
	  initEvents: function () {
	    this.addEvents('rendercomplete', 'processingstarted', 'processingcomplete', 'processingfailed', 'serverinvalidate', 'redrawneeded');
	  },
	
	
	  _ignoreAttributes: [],
	
	  _fixUpPin$: function (referencePoint, previousReferencePoint) {
	    var _this7 = this;
	
	    if (!this._outputFigure) {
	      return (0, _gear.resolve)(); // Hack, we will remove bounds based pinning hopefully soon
	    }
	    var previousPoint = previousReferencePoint || this[referencePoint]();
	    return this.update$().then(function () {
	      var newPoint = _this7[referencePoint]();
	      var offset = previousPoint.minus(newPoint);
	      // console.log('[point] previous: '+previousPoint.toXmlString() + ' > new: '+newPoint.toXmlString()+' > offset: '+offset.toXmlString());
	      _this7.translate(offset.x, offset.y);
	    });
	  },
	  fastTranslate: function (dx, dy) {
	    if (dy === undefined) {
	      var p = dx;dx = p.x;dy = p.y;
	    }
	    if (!_config.Config.useSubpixelPinForServerRendering) {
	      this.translate(dx, dy);
	      return;
	    }
	    var translate = _geometry.Matrix.translate(dx, dy);
	    translate.applyInplace(this._pin);
	    this._processor.fastTranslate(dx, dy);
	    return this;
	  },
	  translate: function (dx, dy) {
	    if (dy === undefined) {
	      var p = dx;dx = p.x;dy = p.y;
	    }
	    var translate = _geometry.Matrix.translate(dx, dy);
	    translate.applyInplace(this._pin);
	    this._processor.translate(dx, dy);
	    return this;
	  },
	  scaleFrom: function (point, sx, sy, deg) {
	    var scaling = _geometry.Matrix.scaleFrom(point, sx, sy, deg);
	    scaling.applyInplace(this._pin);
	    this._matrix22 = _geometry.Matrix.m(_geometry.Matrix.scale(sx, sy, deg), this._matrix22);
	    this._processor.scaleFrom(point, sx, sy, deg);
	    this.checkForTransformIndependent();
	    return this;
	  },
	  checkForTransformIndependent: function () {
	    if (this._processes.length > 0) {
	      if (this._processes.find(function (p) {
	        return p._transformIndependent;
	      })) {
	        this._invalidateOnCommit = true;
	      }
	    }
	  },
	  rotateAround: function (point, deg) {
	    return this.transform(_geometry.Matrix.rotateAround(point, deg));
	  },
	  shearAround: function (point, sx, sy, deg) {
	    return this.transform(_geometry.Matrix.shearAround(point, sx, sy, deg));
	  },
	  transform: function (matrix) {
	    this._matrix22 = _geometry.Matrix.m(matrix.toMatrix22(), this._matrix22);
	    matrix.applyInplace(this._pin);
	    this._processor.transform(matrix);
	
	    if (!matrix.isAlmostIsotropic()) this.checkForTransformIndependent();
	
	    return this;
	  },
	  _align$: function (alignment, toBounds, margin) {
	    var _this8 = this;
	
	    return this.bounds$().then(function (bounds) {
	      return _this8.translate(_geometry.Bounds.alignOffset(bounds, alignment, toBounds, margin));
	    });
	  },
	  _fineHitTest: function () /*point, transform, options*/{
	    return true;
	  },
	  _representationType: function () {
	    return 'server';
	  },
	  _aliasedOutput: function () {
	    return this._outputFigure === this;
	  },
	  _onOutputFigureChange: function () {
	    var of = this._outputFigure;
	    if (of && this !== of) {
	      of._processor = new _processor.OutputProcessor(of);
	      // Important, the cache of the output figure points to the cache of the input figure.
	      // Apart from being a good optimization, it allows us to clone output figures without
	      // worring about caches
	      of._cache = this._cache;
	      // The owner of the output is the same owner as the input figure. This is used to
	      // properly comply with the adopting mechanism and because the figure needs to know
	      // if it is part of a group when computing its matrix
	      of._owner = this._owner;
	      // The inputFigure property is used when computing the topFigure of output polyregions
	      of._inputFigure = this;
	    }
	  },
	
	
	  // overwrite g.OwnedObject owner() function
	  owner: function (v) {
	    if (v === undefined) {
	      return this._owner;
	    }
	    this._owner = v;
	    var of = this._outputFigure;
	    if (of && this !== of) {
	      of._owner = v;
	    }
	    return this;
	  },
	  topColors: function (colors) {
	    if (this._pen) {
	      this._pen.getColors(colors);
	    }
	    if (this._brush) {
	      this._brush.getColors(colors);
	    }
	  },
	  otherColors: function () /*colors*/{},
	  otherPens: function () /*pens*/{},
	  topBrushes: function (brushes) {
	    brushes.push(this._brush);
	  },
	  otherBrushes: function () /*brushes*/{},
	  hasPreview: function () {
	    return true;
	  },
	  needsCacheToRender: function () {
	    return true;
	  },
	  representationType: function () {
	    var owner = this._owner; // If the owner is hidden, do not show the figure
	    if (this.visible && !(owner && owner.hidden)) {
	      var rt = this._processor.representationType();
	      return rt;
	    } else {
	      return 'hidden';
	    }
	  },
	
	
	  // TextureBrush TransformMode Fixed needs to be redrawn even after exact pixel translation
	  needsFixedDrawing: function () {
	    // return some( this.getBrushes(), b => b.needsFixedDrawing() );
	    var brushes = this.getBrushes();
	    for (var k = 0, kEnd = brushes.length; k < kEnd; ++k) {
	      if (brushes[k].needsFixedDrawing()) {
	        return true;
	      }
	    }
	    if (this.clippedBy) {
	      return true;
	    }
	    return false;
	  },
	  deepPowerClipContents: function () {
	    return this._powerClipContents;
	  },
	  powerClipsLocalRendering: function () {
	    var pccs = this._powerClipContents;
	    if (pccs.isEmpty) {
	      return true;
	    }
	    if (_config.Config.renderPowerClipsLocally) {
	      if ((0, _lodash.every)(pccs, function (pcc) {
	        return (0, _lodash.every)(pcc.figures, function (figure) {
	          return !figure.needsCacheToRender();
	        });
	      })) {
	        return true;
	      }
	    }
	    return false;
	  },
	  redraw$: function () {
	    var _this = this;
	    // [TODO] Switching to ES6 promises exposes a bug with locking while
	    // using the SelectTool. This bug will disapear once we swtiching to using
	    // preview$ in tools
	    _this.invalidateView(true);
	    return _this.render$().then(function () {
	      _this.fireEvent('redrawneeded', _this);
	    });
	  },
	  _prepareToDraw$: function (zoom) {
	    return (0, _gear.resolve)(zoom);
	  },
	  prepareToDraw$: function (zoom) {
	    // Ask for a bigger image if need it
	    var outputFigure = this._outputFigure;
	    if (outputFigure) {
	      return outputFigure._prepareToDraw$(zoom);
	    } else {
	      // Check, if we should call update$ here
	      return (0, _gear.resolve)(zoom);
	    }
	  },
	  _preparedToDraw: function () /*zoom*/{
	    return true;
	  },
	  preparedToDraw: function (zoom) {
	    var of = this._outputFigure;
	    return of && of._preparedToDraw(zoom);
	  },
	  draw: function (context, transform) {
	    var config = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	    var ignoreAlpha = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
	
	    // We reuse the figure.draw() function to draw powerclips and grouped
	    // figures by passing as parameter a transform that doesn't correspond with
	    // the transformation from doc coordinates to the final viewport.
	    // TextureBrush between other elements requires to know this transformation
	    // for fixed and non scaling modes.
	    if (!config.transformDoc) {
	      config = (0, _lodash.assign)({ transformDoc: transform }, config);
	    }
	
	    var changeGlobalAlpha = !ignoreAlpha && this._alpha !== 1.0;
	    if (changeGlobalAlpha) {
	      context.save();
	      context.globalAlpha *= this._alpha;
	    }
	    this._processor.draw(context, transform, config);
	
	    if (changeGlobalAlpha) {
	      context.restore();
	    }
	  },
	  clipContext: function (context, transform) {
	    context.beginPath();
	    this.drawForClipping(context, transform);
	    context.clip();
	  },
	  drawForClipping: function (context, transform) {
	    //Each figure knows how to draw itself for clipping
	  },
	  _draw: function (context, transform /*,config*/) {
	    var p = this.pin;
	    var pt = transform.apply(p);
	    context.fillRect(pt.x - 10, pt.y - 10, 20, 20);
	  },
	
	
	  // [TODO] Support for stopping iteration, refactor filter using foreach
	
	  deepForEachFigureLeave: function (f, context) {
	    if (this.isGroup) {
	      var groupedFigures = this._figures;
	      //_.forEach(groupedFigures,function(gf) {
	      for (var k = 0, kEnd = groupedFigures.length; k < kEnd; ++k) {
	        groupedFigures[k].deepForEachFigureLeave(f, context);
	      } //);
	    } else {
	      f.call(context, this);
	    }
	  },
	  deepFindFigureLeave: function (f, context) {
	    if (this.isGroup) {
	      var groupedFigures = this._figures;
	      //_.forEach(groupedFigures,function(gf) {
	      for (var k = 0, kEnd = groupedFigures.length; k < kEnd; ++k) {
	        if (groupedFigures[k].deepFindFigureLeave(f, context)) {
	          return true;
	        }
	      } //);
	      return false;
	    } else {
	      return f.call(context, this);
	    }
	  },
	  deepForEachFigure: function (f, context) {
	    if (f.call(context, this) === false) {
	      return false;
	    }
	    if (this.isGroup) {
	      var groupedFigures = this._figures;
	      //_.forEach(groupedFigures,function(gf) {
	      for (var k = 0, kEnd = groupedFigures.length; k < kEnd; ++k) {
	        if (groupedFigures[k].deepForEachFigure(f, context) === false) {
	          return false;
	        }
	      } //);
	    }
	  },
	  deepFindFigure: function (f, context) {
	    if (f.call(context, this)) {
	      return true;
	    }
	    if (this.isGroup) {
	      var groupedFigures = this._figures;
	      //_.forEach(groupedFigures,function(gf) {
	      for (var k = 0, kEnd = groupedFigures.length; k < kEnd; ++k) {
	        if (groupedFigures[k].deepFindFigure(f, context)) {
	          return true;
	        }
	      } //);
	      return false;
	    }
	    return false;
	  },
	  deepForEachPolyregion: function (f) {
	    this.deepForEachFigureLeave(function (leave) {
	      if (leave.isShape) {
	        (0, _lodash.forEach)(leave._polyregions, f);
	      }
	    });
	  },
	
	
	  // [J-API]
	  //------------------------------------------------------------------------
	  // The following functions will probably change in the near future
	
	  // options : { width, height, locked:true, pin: figurePin }
	  setSize$: function (options) {
	    return _figures.Figures.setSize$([this], options.pin ? options : (0, _lodash.assign)({ pin: this.pin }, options));
	  },
	  fit$: function (bounds, options) {
	    return _figures.Figures.fit$([this], bounds, options); // [TODO]
	  },
	  getFirstEnvelopePoint: function () {
	    var p = (0, _gear.findByType)(this._processes, _process.Process.FitEnvelope);
	    return p ? this.matrix_().apply(p._envelope.getFirstPoint()) : null;
	  },
	  getPens: function (pens) {
	    if (pens === undefined) {
	      pens = [];
	    }
	    pens.push(this._pen);
	    this.otherPens(pens);
	    this._processes.getPens(pens);
	    var pccs = this._powerClipContents;
	    //_.forEach(pccs,function(pcc) {
	    for (var k = 0, kEnd = pccs.length; k < kEnd; ++k) {
	      pccs[k].getPens(pens);
	    } //);
	    return pens;
	  },
	  getBrushes: function () {
	    var brushes = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    this.topBrushes(brushes);
	    this.otherBrushes(brushes);
	    this.processes.getBrushes(brushes);
	    (0, _lodash.forEach)(this.powerClipContents, function (pcc) {
	      pcc.getBrushes(brushes);
	    });
	    return brushes;
	  },
	  uniqueBrushZones: function (options) {
	    var zones = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
	
	    var map = {};
	    //_.forEach( zones, function(z) {
	    for (var i = 0, iEnd = zones.length; i < iEnd; ++i) {
	      var z = zones[i];
	      map[z.value.textualize()] = z.value;
	    } //);
	    var brushes = this.getBrushes([], true);
	    //_.forEach(brushes,function(c) {
	    for (var k = 0, kEnd = brushes.length; k < kEnd; ++k) {
	      var b = brushes[k];
	      var bs = b.textualize();
	      if (!(bs in map)) {
	        map[bs] = b;
	        var zone = { value: b.clone() };
	        zones.push(zone);
	      }
	    } //);
	    return zones;
	  },
	  changeBrushZone: function (zone, value) {
	    this.replaceBrush(zone.value, value);
	  },
	
	
	  // BP
	  untransformedVectorBounds$: function () {
	    return this.preVectorBounds$();
	  },
	  extractPowerClipContents: function () {
	    // [TODO][PC]
	    var powerClipFigures = [];
	    var powerClipContents = this._powerClipContents;
	    (0, _lodash.forEach)(powerClipContents, function (pcc) {
	      var figures = pcc.extractFigures();
	      (0, _lodash.forEach)(figures, function (f) {
	        powerClipFigures.push(f);
	      });
	    });
	
	    this.powerClipClear();
	
	    return powerClipFigures;
	  },
	  powerClipLinkClear: function () {
	    // PowerClipLink currently used in Shape output
	  },
	  powerClipClear: function () {
	
	    // Do not trigger invalidation, We can directly modify the output figure
	    this._powerClipContents._clear();
	
	    var o = this._outputFigure;
	    if (o) {
	      if (o !== this) {
	        o._powerClipContents._clear();
	        o.powerClipLinkClear();
	      }
	      // We are touching the processed figure directly, we can no longer
	      // use the stored cacheId figure in the server
	      this.cacheId = null;
	      this.invalidateView();
	    } else {
	      this.invalidate();
	    }
	  },
	  bc: function (key) {
	    return this._bc[key];
	  }
	});
	
	Figure._baseParseXml = function (node, derived, bcFixes) {
	  var me = this;
	
	  this.setupProperties(_util.Xml.parseProperties(node, derived));
	
	  this._metadata = _util.Metadata.parseXml(node, this);
	
	  var preTransformNode = _util.Xml.child(node, 'PreTransform');
	  if (preTransformNode) {
	    this._preMatrix22 = _geometry.Matrix.getMatrix22Attr(preTransformNode, 'Matrix22');
	  }
	  var figureTransform = _anchor.FigureTransform.fromXml(node);
	  me._matrix22 = figureTransform.matrix;
	
	  me._pin = _anchor.Pin.fromXml(node);
	
	  // Backward compatibility
	  if (bcFixes !== undefined) {
	    (function () {
	
	      // Bounds based pinning => Anchor based pinning
	      //-------------------------------------------------------------------
	      var pin = me._pin;
	      if (pin.use !== 'Anchor') {
	        (function () {
	          var pinRelPos = pin.getRelPos();
	          me._anchor._pos = _geometry.Matrix.rotateAround(new _geometry.Point(0.5, 0.5), -me._matrix22.angle()).apply(pinRelPos);
	
	          me._anchor._absolute = false;
	          pin.use = 'Anchor';
	
	          bcFixes.push(function () {
	            return me.vectorBounds$().then(function (vectorBounds) {
	              var boundsBasedAnchor = vectorBounds.interpolate(pinRelPos);
	              me.translate(me.pin.minus(boundsBasedAnchor));
	            });
	          });
	        })();
	      }
	
	      // Post Constraint
	      //-------------------------------------------------------------------
	      var postConstraint = figureTransform.postConstraint;
	      if (postConstraint && (postConstraint.x || postConstraint.y)) {
	        me._bc.constrain = { width: postConstraint.x, height: postConstraint.y };
	        bcFixes.push(function () {
	          return me.bounds$().then(function (bounds) {
	            var c = { pin: me.pin, locked: false };
	            if (bounds.width > postConstraint.x) {
	              c.width = postConstraint.x;
	            }
	            if (bounds.height > postConstraint.y) {
	              c.height = postConstraint.y;
	            }
	            if (c.width || c.height) {
	              return me.setSize$(c);
	            }
	          });
	        });
	      }
	    })();
	  }
	};
	
	Figure.parseXml = function (node, bcFixes) {
	  if (node) {
	    switch (node.nodeName) {
	      case 'TextBlock':
	        return Figure.Text.parseXml(node, bcFixes);
	      case 'Shape':
	        return Figure.Shape.parseXml(node, bcFixes);
	      case 'Raster':
	        return Figure.Raster.parseXml(node, bcFixes);
	      case 'Group':
	        return Figure.Group.parseXml(node, bcFixes);
	      case 'ProxyGroup':
	        return Figure.ProxyGroup.parseXml(node, bcFixes);
	      case 'Monogram':
	        return Figure.Monogram.parseXml(node, bcFixes);
	    }
	  }
	  return null;
	};
	
	Figure.arrayFromXml = function (node, bcFixes) {
	  var figures = [];
	  var figuresNode = _util.Xml.child(node, 'Figures');
	  if (figuresNode) {
	    node = figuresNode;
	  }
	  (0, _lodash.forEach)(_util.Xml.children_(node), function (figureNode) {
	    var figure = Figure.parseXml(figureNode, bcFixes);
	    if (figure) {
	      figures.push(figure);
	    }
	  });
	  return figures;
	};
	
	Figure.fromXml = function (node) {
	  var children = _util.Xml.children_(node);
	  for (var i = 0, iEnd = children.length; i < iEnd; ++i) {
	    var figure = Figure.parseXml(children[i]);
	    if (figure) {
	      return figure;
	    }
	  }
	};
	
	Figure.fromXmlString = function (xmlString) {
	  var domFigure = _util.Xml.fromString(xmlString);
	  return Figure.fromXml(domFigure.documentElement);
	};
	
	Figure.arrayBuildXml = function (node, v) {
	  var figuresNode = _util.Xml.appendElement(node, 'Figures');
	  _util.Xml.addObjectArray(figuresNode, v);
	};
	
	var Clipart = exports.Clipart = {}; // This will be moved from here
	
	Figure.load$ = Clipart.load$ = function (docModel) {
	  return _figures.Figures.load$(docModel).then(function (figures) {
	    return figures[0];
	  });
	};
	
	_util.Xml.Parser['Figure'] = _util.Xml.makeObjectParser(Figure);
	_util.Xml.Parser['Figure[]'] = _util.Xml.makeArrayObjectParser(Figure);

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Process = undefined;
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	// Process
	//====================================================================================================
	
	var Process = exports.Process = _gear.OwnedObject.extend({ typeName: 'Process', __debugProps: true,
	
	  Properties: {
	    name: { type: 'string', def: null, dropDef: true }
	  },
	
	  requiresText: function () {
	    return false;
	  },
	  outputsText: function () {
	    return false;
	  },
	
	
	  invalidate: _gear.invalidateOwner,
	
	  buildXml: function (parentNode) {
	    _util.Xml.addObject(parentNode, this, this.type);
	  },
	  setupXml: function (node) {
	    _util.Xml.setupProperties(node, this);
	  },
	  canTarget: function (figure) {
	    return !(this.requiresText() && !(figure.isText && !figure.isMultiPart));
	  },
	  canProcess: function () /*figure*/{
	    return false;
	  },
	  getColors: function () {
	    var colors = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    if ('brush' in this) {
	      this.brush.getColors(colors);
	    }
	    if ('pen' in this) {
	      this.pen.getColors(colors);
	    }
	    return colors;
	  },
	  getPens: function () {
	    var pens = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    if ('pen' in this) {
	      pens.push(this.pen);
	    }
	    return pens;
	  },
	  getBrushes: function () {
	    var brushes = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    if ('brush' in this) {
	      brushes.push(this.brush);
	    }
	    return brushes;
	  }
	});
	Process.invalidate = _gear.invalidateOwner;
	
	Process.parseXml = function (node) {
	  var processName = node.nodeName;
	  var ProcessType = Process[processName];
	  if (ProcessType) {
	    return ProcessType.parseXml(node);
	  } else {
	    return null;
	  }
	};
	
	_util.Xml.Parser['Process'] = _util.Xml.makeObjectParser(Process);

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Processes = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	var _figure = __webpack_require__(39);
	
	var _anchor = __webpack_require__(42);
	
	var _process = __webpack_require__(40);
	
	var Processes = exports.Processes = _gear.ArrayProperty.extend({ typeName: 'Process[]',
	
	  // Add processes at the right spot
	
	  add: function (p) {
	    var _this = this;
	
	    if ((0, _gear.isArray)(p)) {
	      return (0, _lodash.compact)((0, _lodash.map)(p, function (pk) {
	        _this.add(pk); // [TODO]
	      }));
	    }
	
	    var requiresText = p.requiresText();
	    if (!requiresText) {
	      return this.callParent(p);
	    }
	
	    // Validate text preservation chain
	    var owner = this._owner;
	    var ownerOutputsText = owner && owner.outputsText();
	
	    if (!ownerOutputsText) {
	      // We can not add this process
	      return null;
	    }
	
	    var k = 0;
	    for (var kEnd = this.length; k < kEnd && this[k].outputsText(); ++k) {
	      void 0;
	    }
	
	    return this.insert(k, p);
	  },
	  canProcess: function (figure) {
	    return this.length === 0 || (0, _lodash.every)(this, function (p) {
	      return p.canProcess(figure);
	    });
	  },
	
	
	  // c : {
	  //   items: [ TextLayout, GShape, GRaster ],
	  //   anchor: ( point ),
	  //   textLayouts: [ TextLayout ]
	  // }
	  process: function (c) {
	
	    // This is work in progress, working for text right now
	    (0, _lodash.forEach)(this, function (p) {
	      var nc = p.process(c);
	      if (nc) {
	        c = nc;
	      }
	    });
	
	    var outputAnchor = c.anchor;
	
	    // Condense output figures (TextLayout,GShape,GRaster) to one figure
	    var outputFigures = c.figures;
	    var figures = [];
	
	    var polyregions = [];
	
	    var buildShape = function () {
	
	      // PowerClipLink remains in output figures, the input powerclip content
	      // is what end ups being drawn directly, if the output figure needs to be
	      // converted to CDL, these links needs to be transformed into proper
	      // PowerClipContent arrays at the figure level
	      var shape = new _figure.Figure.Shape({ polyregions: polyregions,
	        anchor: (0, _anchor.AbsoluteAnchor)(outputAnchor.clone()),
	        pin: outputAnchor.clone() });
	
	      figures.push(shape);
	
	      // Clear the array
	      polyregions.splice(0, polyregions.length);
	    };
	    for (var k = 0, kEnd = outputFigures.length; k < kEnd; ++k) {
	
	      var figure = outputFigures[k];
	      if (figure.isGShape) {
	        polyregions = (0, _gear.concat)(polyregions, figure.polyregions);
	      } else if (figure.isTextLayout) {
	        var gs = figure.toGShape();
	        polyregions = (0, _gear.concat)(polyregions, gs.polyregions);
	      } else if (figure.isRaster) {
	        if (polyregions.length > 0) {
	          buildShape();
	        }
	        figures.push(figure);
	      }
	    }
	    if (polyregions.length > 0) {
	      buildShape();
	    }
	
	    var outputFigure = null;
	    if (figures.length > 1) {
	      // Review, at this point all figures should be primitives
	      // Wire the output of simple shapes, if they are not set
	      // This shouldn't be needed, but we must change group metrics
	      // to be able to avoid it
	      (0, _lodash.forEach)(figures, function (f) {
	        if (!f._outputFigure) {
	          f._outputFigure = f;
	        }
	      });
	
	      outputFigure = new _figure.Figure.Group({ figures: figures, noProcessor: true });
	    } else {
	      outputFigure = figures[0];
	    }
	
	    outputFigure._computedPreScale = c.preScale;
	
	    return outputFigure;
	  },
	  clone: function () {
	    return new Processes(this.callParent());
	  },
	  cloneDeep: function () {
	    return new Processes(this);
	  },
	  clearKeeping$: function (what) {
	    var me = this;
	    var owner = this._owner;
	    if (owner instanceof _figure.Figure) {
	      return owner.modifyKeeping$(what, function () {
	        return me.clear();
	      });
	    } else {
	      return (0, _gear.resolve)(me.clear());
	    }
	  },
	  addKeeping$: function (what, process) {
	    var me = this;
	    var owner = this._owner;
	    if (owner instanceof _figure.Figure) {
	      return owner.modifyKeeping$(what, function () {
	        return me.add(process);
	      });
	    } else {
	      return (0, _gear.resolve)(me.add(process));
	    }
	  },
	  removeKeeping$: function (what, process) {
	    var me = this;
	    var owner = this._owner;
	    if (owner instanceof _figure.Figure) {
	      return owner.modifyKeeping$(what, function () {
	        return me.remove(process);
	      });
	    } else {
	      return (0, _gear.resolve)(me.remove(process));
	    }
	  },
	  getPens: function () {
	    var pens = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    (0, _lodash.forEach)(this, function (p) {
	      p.getPens(pens);
	    });
	    return pens;
	  },
	  getBrushes: function () {
	    var brushes = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    (0, _lodash.forEach)(this, function (p) {
	      p.getBrushes(brushes);
	    });
	    return brushes;
	  },
	  getColors: function () {
	    var colors = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    (0, _lodash.forEach)(this, function (p) {
	      p.getColors(colors);
	    });
	    return colors;
	  },
	  buildXml: function (node) {
	    if (this.length > 0) {
	      var pNode = _util.Xml.appendElement(node, 'Processes');
	      // invokeMap(this,'buildXml',pNode);
	      for (var k = 0, kEnd = this.length; k < kEnd; ++k) {
	        this[k].buildXml(pNode);
	      }
	    }
	    return node;
	  }
	});
	
	Processes.fromXml = function (node, owner) {
	  var processesNode = _util.Xml.child(node, 'Processes');
	  var processes = processesNode ? _util.Xml.getObjectArray(processesNode, _process.Process) : [];
	  return new Processes(processes, owner);
	};
	
	Processes.load$ = function (docModel) {
	  return _figure.Figure.load$(docModel).then(function (figure) {
	    return figure.processes.clone();
	  });
	};
	
	_util.Xml.Parser['Process[]'] = _util.Xml.makeObjectParser(Processes);

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FigureTransform = exports.RelativeAnchor = exports.AbsoluteAnchor = exports.AnchorGenerator = exports.Pin = undefined;
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	var _geometry = __webpack_require__(21);
	
	function parsePos(node) {
	  return new _geometry.Point((0, _gear.parseFloatOr)(node.getAttribute('X'), 0.0), (0, _gear.parseFloatOr)(node.getAttribute('Y'), 0.0));
	}
	
	function setPos(node, pos) {
	  _util.Xml.setFloatAttr(node, 'X', pos.x);
	  _util.Xml.setFloatAttr(node, 'Y', pos.y);
	}
	
	function parseRelPos(node) {
	  return new _geometry.Point((0, _gear.parseFloatOr)(node.getAttribute('RelX'), 0.5), (0, _gear.parseFloatOr)(node.getAttribute('RelY'), 0.5));
	}
	
	function setRelPos(node, relPos) {
	  _util.Xml.setFloatAttr(node, 'RelX', relPos.x);
	  _util.Xml.setFloatAttr(node, 'RelY', relPos.y);
	}
	
	// [TODO] Eliminate Pin, we do not need it anymore. Bounds based pinning is
	//        no longer supported
	
	// Pin
	//--------------------------------------------------------------------------------------
	
	var Pin = exports.Pin = function (pos, useAnchor, relPos) {
	  if (pos instanceof Pin) {
	    return new Pin(pos.getPos(), pos.use, pos.getRelPos());
	  }
	  if (pos === undefined) {
	    this.x = 0.0;this.y = 0.0;
	  } else {
	    this.x = pos.x;this.y = pos.y;
	  }
	  if (useAnchor === undefined) {
	    this.use = "Anchor";
	  } else {
	    this.use = useAnchor ? "Anchor" : "Bounds";
	  }
	  if (relPos === undefined) {
	    this.relX = 0.5;this.relY = 0.5;
	  } else {
	    this.relX = relPos.x;this.relY = relPos.y;
	  }
	  /* We keep the same layout to provide backward compatibility, it will be nice to
	     be able to change this with something like:
	  this.pos       = pos ;
	  this.useAnchor = useAnchor ;
	  this.relPos    = relPos ;
	  */
	};
	Pin.fromXml = function (fNode) {
	  var node = _util.Xml.child(fNode, 'Pin');
	  if (!node) {
	    return new Pin();
	  }
	  var pos = parsePos(node);
	  var useNode = node.getAttribute('Use');
	  var useAnchor = useNode ? useNode.toLowerCase() === 'anchor' : false;
	  var relPos = parseRelPos(node);
	  return new Pin(pos, useAnchor, relPos);
	};
	Pin.prototype = {
	  buildXml: function (fNode) {
	    _util.Xml.addObject(fNode, this, 'Pin');
	  },
	  setupXml: function (node) {
	    if (this.anchorBased()) {
	      node.setAttribute('Use', 'Anchor');
	    } else {
	      setRelPos(node, this.getRelPos());
	    }
	    setPos(node, this.getPos());
	  },
	  getPos: function () {
	    return new _geometry.Point(this.x, this.y);
	  },
	  getRelPos: function () {
	    return new _geometry.Point(this.relX, this.relY);
	  },
	  anchorBased: function () {
	    return this.use.toLowerCase() === 'anchor';
	  },
	  cloneElsewhere: function (newPoint) {
	    return new Pin(newPoint, this.anchorBased(), this.getRelPos());
	  },
	  clone: function () {
	    return new Pin(this.getPos(), this.anchorBased(), this.getRelPos());
	  },
	  isEqual: function (other) {
	    return this.use === other.use && this.getPos().isEqual(other.getPos()) && (this.anchorBased() || this.getRelPos().isEqual(other.getRelPos()));
	  }
	};
	
	// AnchorGenerator
	//--------------------------------------------------------------------------------------
	
	var AnchorGenerator = exports.AnchorGenerator = _gear.OwnedObject.extend({ typeName: 'Anchor',
	
	  Properties: {
	    pos: { type: 'Point', def: new _geometry.Point(0.5, 0.5) }, // [TODO] invalidation
	    absolute: { type: 'boolean', def: false }
	  },
	
	  buildXml: function (fNode) {
	    _util.Xml.addObject(fNode, this, 'Anchor');
	  },
	  setupXml: function (node) {
	    if (this._absolute) {
	      setPos(node, this._pos);
	    } else {
	      setRelPos(node, this._pos);
	    }
	  },
	  of: function (frame) {
	    return this._absolute ? this._pos.clone() : frame.interpolate(this._pos);
	  }
	});
	
	AnchorGenerator.fromXml = function (fNode) {
	  var node = _util.Xml.child(fNode, 'Anchor');
	  if (!node) {
	    return new AnchorGenerator();
	  }
	  return AnchorGenerator.parseXml(node);
	};
	AnchorGenerator.parseXml = function (node) {
	  var absolute = !!node.getAttribute('X');
	  return new AnchorGenerator({
	    absolute: absolute,
	    pos: absolute ? parsePos(node) : parseRelPos(node)
	  });
	};
	
	var AbsoluteAnchor = exports.AbsoluteAnchor = function (pos) {
	  return new AnchorGenerator({ pos: pos, absolute: true });
	};
	
	var RelativeAnchor = exports.RelativeAnchor = function (pos) {
	  return new AnchorGenerator({ pos: pos, absolute: false });
	};
	
	// FigureTransform
	//--------------------------------------------------------------------------------------
	// This class is only intended to help in the decoding and enconding, because the
	// transform of the figure is tied with the postConstraint
	
	var FigureTransform = exports.FigureTransform = {
	  buildXml: function (matrix, node) {
	    var el = _util.Xml.appendElement(node, 'Transform');
	    matrix.setMatrix22Attr(el, 'Matrix22');
	    return el;
	  },
	  fromXml: function (fNode) {
	    var t = _util.Xml.getObject(fNode, this, 'Transform');
	    return t || { matrix: new _geometry.Matrix() };
	  },
	  parseXml: function (node) {
	    var p = {};
	    p.matrix = _geometry.Matrix.getMatrix22Attr(node, 'Matrix22');
	    var c = _util.Xml.getFloatArrayAttr(node, 'Constrain', null);
	    if (c !== null) {
	      p.postConstraint = { x: c[0], y: c[1] };
	    }
	    return p;
	  }
	};
	
	// Extends Xml.Parser
	
	_util.Xml.Parser['Anchor'] = _util.Xml.makeObjectParser(AnchorGenerator);

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Figures = undefined;
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	var _geometry = __webpack_require__(21);
	
	var _style = __webpack_require__(29);
	
	var _processor = __webpack_require__(38);
	
	var Figures = exports.Figures = {};
	
	Figures.toXmlString = function (figures) {
	  var xml = _util.Xml.fromString('<Cdl></Cdl>');
	  (0, _lodash.forEach)(figures, function (figure) {
	    figure.buildXml(xml.documentElement);
	  });
	  return _util.Xml.toString(xml);
	};
	
	Figures.lock = function (figures) {
	  //invokeMap(figures,'lock');
	  for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	    figures[k].lock();
	  }
	  return figures;
	};
	
	Figures.invalidated = function (figures) {
	  // return some( figures, f => f.invalidated() );
	  for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	    if (figures[k].invalidated()) {
	      return true;
	    }
	  }
	  return false;
	};
	
	Figures.currentlyProcessing = function (figures) {
	  // return some( figures, f => f.currentlyProcessing() );
	  for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	    if (figures[k].currentlyProcessing()) {
	      return true;
	    }
	  }
	  return false;
	};
	
	var computeBounds_ = function (figures, boundsType) {
	  if (!(0, _gear.isArray)(figures)) {
	    return figures[boundsType]();
	  }
	  return _geometry.Bounds.union((0, _lodash.invokeMap)(figures, boundsType));
	};
	
	Figures.vectorBounds_ = function (figures) {
	  return computeBounds_(figures, 'vectorBounds_');
	};
	
	Figures.bounds_ = function (figures) {
	  return computeBounds_(figures, 'bounds_');
	};
	
	Figures.materialBounds_ = function (figures) {
	  return computeBounds_(figures, 'materialBounds_');
	};
	
	// Review, to be used with sync bounded things ( Cx.bounds(polyregions) ),
	// this shouldn't be in Figures
	Figures.bounds = function (things) {
	  return computeBounds_(things, 'bounds');
	};
	
	Figures.globalPreVectorBounds_ = function (figures) {
	  return computeBounds_(figures, 'globalPreVectorBounds_');
	};
	
	Figures.globalPreBounds_ = function (figures) {
	  return computeBounds_(figures, 'globalPreBounds_');
	};
	
	Figures.globalVectorBounds_ = function (figures) {
	  return computeBounds_(figures, 'globalVectorBounds_');
	};
	
	Figures.globalBounds_ = function (figures) {
	  return computeBounds_(figures, 'globalBounds_');
	};
	
	Figures.globalMaterialBounds_ = function (figures) {
	  return computeBounds_(figures, 'globalMaterialBounds_');
	};
	
	var computeBounds$ = function (figures, boundsType) {
	  if (!(0, _gear.isArray)(figures)) {
	    return figures[boundsType]();
	  }
	  return (0, _processor.updateArray$)(figures, 'update').then(function () {
	    // Force batch update$
	    return (0, _gear.invokeMap$)(figures, boundsType).then(function (values) {
	      return _geometry.Bounds.union((0, _lodash.compact)(values));
	    });
	  });
	};
	
	Figures.vectorBounds$ = function (figures) {
	  return computeBounds$(figures, 'vectorBounds$');
	};
	
	Figures.bounds$ = function (figures, v, config) {
	  if (v === undefined) {
	    return computeBounds$(figures, 'bounds$');
	  } else {
	    return Figures.fit$(figures, v, config);
	  }
	};
	
	Figures.globalVectorBounds$ = function (figures) {
	  return computeBounds$(figures, 'globalVectorBounds$');
	};
	
	Figures.globalBounds$ = function (figures) {
	  return computeBounds$(figures, 'globalBounds$');
	};
	
	Figures.materialBounds$ = function (figures) {
	  return computeBounds$(figures, 'materialBounds$');
	};
	
	Figures.globalMaterialBounds$ = function (figures) {
	  return computeBounds$(figures, 'globalMaterialBounds$');
	};
	
	Figures._computeSizingScale = function (width, height, options) {
	  var locked = options.locked === undefined ? true : options.locked;
	  var fit = options.fit || 'Min';
	  var ow = options.width ? options.width * (options.scale || 1.0) : undefined;
	  var oh = options.height ? options.height * (options.scale || 1.0) : undefined;
	  var margin = options.margin || 0;
	  var rm = options.relativeMargin;
	
	  var mw = margin,
	      mh = margin;
	  if (rm) {
	    if (ow) {
	      mw = ow * rm;
	    }
	    if (oh) {
	      mh = oh * rm;
	    }
	  }
	  var sX = ow ? (ow - 2 * mw) / width : 1.0,
	      sY = oh ? (oh - 2 * mh) / height : 1.0;
	  if (locked) {
	    if (ow && oh) {
	      switch (fit) {
	        case 'Min':
	          if (sY > sX) {
	            sY = sX;
	          } else {
	            sX = sY;
	          }break;
	        case 'Max':
	          if (sY < sX) {
	            sY = sX;
	          } else {
	            sX = sY;
	          }break;
	        case 'Mean':
	          var sM = Math.sqrt(Math.abs(sX * sY));sX = sY = sM;break;
	      }
	    } else {
	      if (ow) {
	        sY = sX;
	      } else {
	        sX = sY;
	      }
	    }
	  }
	  return { sX: sX, sY: sY };
	};
	
	// options :
	// {
	//   width, height,
	//   locked: true,
	//   fit: ['Max'/'Min'/'Mean'],
	//   pin: boundsCenter,
	//   material: false
	// }
	// Example : Set the width of a figure preserving aspect ratio
	// Figures.setSize$(view.selectedFigures,{width:400})
	Figures.setSize$ = function (figures, options) {
	  var iteration = arguments.length <= 2 || arguments[2] === undefined ? 0 : arguments[2];
	  // [CHECK][D]
	  if (!(0, _gear.isArray)(figures)) {
	    figures = [figures];
	  }
	
	  return Figures[options.boundsType === 'material' ? 'materialBounds$' : 'bounds$'](figures).then(function (bounds) {
	
	    var w = bounds.width,
	        h = bounds.height;
	    if (options.orientation === 'Rotated') {
	      var d = w;w = h;h = d;
	    }
	    var s = Figures._computeSizingScale(w, h, options);
	    if (options.orientation === 'Any') {
	      var sr = Figures._computeSizingScale(h, w, options);
	      if (sr.sX * sr.sY > s.sX * s.sY) {
	        s = sr;
	      }
	    }
	    var pin = options.pin || bounds.center;
	    //_.forEach(figures, function(f) {
	    for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	      figures[k].scaleFrom(pin, s.sX, s.sY);
	    } //);
	
	    return figures;
	  }).then(function (figures) {
	    return Figures[options.boundsType === 'material' ? 'materialBounds$' : 'bounds$'](figures);
	  }).then(function (bounds) {
	    var w = bounds.width,
	        h = bounds.height;
	    if (options.orientation === 'Rotated') {
	      var d = w;w = h;h = d;
	    }
	    var s = Figures._computeSizingScale(w, h, options);
	    if (options.orientation === 'Any') {
	      var sr = Figures._computeSizingScale(h, w, options);
	      if (sr.sX * sr.sY > s.sX * s.sY) {
	        s = sr;
	      }
	    }
	    if (Math.abs(1.0 - s.sX) < 0.00001 && Math.abs(1 - s.sY) < 0.00001) {
	      return figures;
	    } else {
	      if (iteration > 10) //avoid an infinite loop in case we dont converge ( from testing we converge in 3 iterations when pens are present )
	        {
	          return figures;
	        } else {
	        return Figures.setSize$(figures, options, iteration + 1);
	      }
	    }
	  });
	};
	
	var _fit$ = function (figures, toBounds) {
	  var config = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	  if (!config.ignoreWidth) {
	    config.width = toBounds.width;
	  }
	  if (!config.ignoreHeight) {
	    config.height = toBounds.height;
	  }
	  return Figures.center$(figures, toBounds).then(function () {
	    return Figures.setSize$(figures, config);
	  });
	};
	
	Figures.fit$ = function (figures, to, config) {
	  if (!(0, _gear.isArray)(figures)) {
	    figures = [figures];
	  }
	  var toBounds = to.bounds || to.lx !== undefined ? to : null;
	  if (toBounds) {
	    return _fit$(figures, toBounds, config);
	  } else {
	    return Figures.bounds$(to).then(function (toBounds) {
	      return _fit$(figures, toBounds, config);
	    });
	  }
	};
	
	Figures.fastTranslate_ = function (figures, offset) {
	  return (0, _lodash.invokeMap)(figures, 'fastTranslate', offset);
	};
	Figures.fastTranslate = function (figures, x, y, zoom) {
	  var offset = void 0;
	  if (x.x !== undefined) {
	    offset = x;zoom = y;
	  } else {
	    offset = new _geometry.Point(x, y);
	  }
	  if (zoom === undefined) {
	    return Figures.translate(figures, offset);
	  }
	  offset = _geometry.Point.asFastOffset(offset, zoom);
	
	  return Figures.fastTranslate_(figures, offset);
	};
	
	Figures.translate = function (figures, x, y) {
	  if (y === undefined) {
	    y = x.y;x = x.x;
	  }
	  return (0, _lodash.invokeMap)(figures, 'translate', x, y);
	};
	
	Figures.transform = function (figures, matrix) {
	  return (0, _lodash.invokeMap)(figures, 'transform', matrix);
	};
	
	Figures.scaleFrom = function (figures, point, sx, sy, deg) {
	  return (0, _lodash.invokeMap)(figures, 'scaleFrom', point, sx, sy, deg);
	};
	
	Figures.rotateAround = function (figures, point, angle) {
	  return (0, _lodash.invokeMap)(figures, 'rotateAround', point, angle);
	};
	
	Figures.shearAround = function (figures, point, sx, sy, deg) {
	  return (0, _lodash.invokeMap)(figures, 'shearAround', point, sx, sy, deg);
	};
	
	var _center$ = function (figures, point, zoom) {
	  return Figures.bounds$(figures).then(function (bounds) {
	    var offset = point.minus(bounds.center);
	    Figures.fastTranslate(figures, offset, zoom);
	    return figures;
	  });
	};
	
	// [TODO][m]
	Figures.center$ = function (things, to, y) {
	  if (y !== undefined) {
	    to = new _geometry.Point(to, y);
	  }
	  if (to === undefined) {
	    if (things.center) {
	      return (0, _gear.resolve)(things.center);
	    }
	    return Figures.bounds$(things).then(function (bounds) {
	      return bounds.center;
	    });
	  } else {
	    if (to.zoom) {
	      // Optimization, if we can get the zoom, we can fastTranslate the figures
	      return _center$(things, to.center, to.zoom);
	    }
	    var point = to.x !== undefined ? to : to.center ? to.center : null;
	    if (point) {
	      return _center$(things, point);
	    } else {
	      return Figures.center$(to).then(function (point) {
	        return _center$(things, point);
	      });
	    }
	  }
	};
	
	Figures.rotate$ = function (figures, angle) {
	  return Figures.bounds$(figures).then(function (bounds) {
	    var pivot = bounds.center;
	    //_.forEach(figures,function(f) {
	    for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	      figures[k].rotateAround(pivot, angle);
	    } //);
	    return figures;
	  });
	};
	
	Figures.scale$ = function (figures, sx, sy) {
	  return Figures.bounds$(figures).then(function (bounds) {
	    var pivot = bounds.center;
	    //_.forEach(figures,function(f) {
	    for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	      figures[k].scaleFrom(pivot, sx, sy);
	    } //);
	    return figures;
	  });
	};
	
	Figures.mirrorX$ = function (figures) {
	  return Figures.scale$(figures, -1, 1);
	};
	
	Figures.mirrorY$ = function (figures) {
	  return Figures.scale$(figures, 1, -1);
	};
	
	Figures.composedIsometricMatrix22 = function (figures) {
	  var size = figures.length;
	  if (size === 0) {
	    return new _geometry.Matrix();
	  }
	  var rotationSum = 0;
	  var scaleSum = 0;
	  //_.forEach(figures,function(f) {
	  for (var k = 0; k < size; ++k) {
	    var m = figures[k]._matrix22;
	    rotationSum += m.determinant() > 0 ? m.angle() : 0;
	    scaleSum += m.scaleFactor();
	  } //);
	  var scaleMean = scaleSum / size;
	  var rotationMean = rotationSum / size;
	  return _geometry.Matrix.m(_geometry.Matrix.scale(scaleMean, scaleMean), _geometry.Matrix.rotate(rotationMean));
	};
	
	Figures.meanPin = function (figures) {
	  var pinSum = new _geometry.Point(0, 0);
	  //_.forEach(figures,function(f) {
	  for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	    pinSum.add(figures[k].pin);
	  } //);
	  pinSum.scalarMultiply(1.0 / figures.length);
	  return pinSum;
	};
	
	Figures.getBrushes = function (figures) {
	  return (0, _gear.flatten)((0, _lodash.invokeMap)(figures, 'getBrushes'));
	};
	
	Figures.uniqueBrushZones = function (figures, options) {
	  var zones = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];
	
	  return (0, _lodash.reduce)(figures, function (zones, f) {
	    return f.uniqueBrushZones(options, zones);
	  }, zones);
	};
	
	Figures.changeBrushZone = function (figures, zone, newValue) {
	  //.forEach(figures,function(f) {
	  for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	    figures[k].changeBrushZone(zone, newValue);
	  } //);
	  return figures;
	};
	
	Figures.labelBrushZone = function (figures, zone, label) {
	  var targetBrush = zone.value.textualize();
	  (0, _lodash.forEach)(Figures.getBrushes(figures), function (brush) {
	    if (targetBrush === brush.textualize()) {
	      brush._label = label;
	    }
	  });
	  return figures;
	};
	
	Figures.uniqueColorZones = _style.Color.zones;
	
	Figures.changeColorZone = _style.Color.changeZone;
	
	Figures.tagColorZone = function (figures, zone, tag) {
	  if (!(zone.value instanceof _style.Color)) {
	    return;
	  }
	  var color = zone.value.clone();
	  color.tag = tag;
	  //_.forEach(figures,function(f) {
	  for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	    figures[k].replaceColor(zone.value, color, { tagsCollapsed: zone.tagsCollapsed,
	      keepTags: false,
	      keepLabels: false });
	  } //);
	  return figures;
	};
	
	Figures.setTaggedColors = function (figures, tag, color) {
	  //_.forEach(figures,function(f) {
	  for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	    figures[k].setTaggedColors(tag, color);
	  } //);
	  return figures;
	};
	
	Figures.labelColorZone = function (figures, zone, label) {
	  if (!(zone.value instanceof _style.Color)) {
	    return;
	  }
	  var color = zone.value.clone();
	  color.label = label;
	  //_.forEach(figures,function(f) {
	  for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	    figures[k].replaceColor(zone.value, color, { tagsCollapsed: zone.tagsCollapsed,
	      keepTags: true,
	      keepLabels: false });
	  } //);
	  return figures;
	};
	
	Figures.setLabeledColors = function (figures, label, color) {
	  //_.forEach(figures,function(f) {
	  for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	    figures[k].setLabeledColors(label, color);
	  } //);
	  return figures;
	};
	
	Figures.forEachColor = function (figures, fun, scope) {
	  //_.forEach(figures,function(f) {
	  //  _.forEach(f.getColors(),fun,scope);
	  //});
	  for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	    var colors = figures[k].getColors();
	    for (var i = 0, iEnd = colors.length; i < iEnd; ++i) {
	      fun.call(scope, colors[i]);
	    }
	  }
	};
	
	Figures.getByAttribute = function (figures, n, v) {
	  var f = [];
	  for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	    var m = figures[k].metadata.get(n);
	    if (m !== undefined && m === v) f.push(figures[k]);
	  }
	  return f;
	};
	
	// [TODO] Simplify! We may not need this anymore now that we
	//        have local rendering of most of CDL
	Figures.convertColors = function (figures, map, options) {
	  var collapseTags = options && options.collapseTags !== undefined ? options.collapseTags : false;
	  var includeTag = !collapseTags;
	  var keepTags = options && options.keepTags !== undefined ? options.keepTags : true;
	  var keepLabels = options && options.keepLabels !== undefined ? options.keepLabels : true;
	  var zones = [];
	  var colorsMap = {};
	
	  var invalidateGroups = function (figures) {
	    for (var i = 0, iEnd = figures.length; i < iEnd; ++i) {
	      var lFigure = figures[i];
	      if (lFigure.isGroup) {
	        lFigure.invalidate();
	        invalidateGroups(lFigure._figures);
	      }
	    }
	  };
	  invalidateGroups(figures);
	
	  Figures.forEachColor(figures, function (c) {
	    var cs = c.textualize(includeTag);
	    if (!(cs in colorsMap)) {
	      colorsMap[cs] = cs;
	      zones.push({ value: c.clone() });
	    }
	  });
	
	  var changesMap = {};
	  //_.forEach( zones, function(zone,i) {
	  for (var k = 0, kEnd = zones.length; k < kEnd; ++k) {
	    var zone = zones[k];
	    var newColor = map(zone.value, k);
	    if (newColor && newColor !== zone.value) {
	      // to process the output colors
	      changesMap[zone.value.textualize(includeTag)] = newColor.clone();
	    }
	  } //);
	
	  var processFigure = function (f) {
	
	    // If there is an output figure, we also obtain its colors
	    // to optimize the invalidation
	    // [TODO] This will not work for Effect3D because new colors are created
	    //        We need to add further logic here
	
	    if (f._processor instanceof _processor.GroupProcessor) {
	
	      //Make sure to update colors on power clip figures that are on the group
	      if (f._powerClipContents.length > 0) {
	        var patternFigures = f._powerClipContents[0]._figures;
	        //_.forEach(patternFigures, processFigure);
	        for (var _k = 0, _kEnd = patternFigures.length; _k < _kEnd; ++_k) {
	          processFigure(patternFigures[_k]);
	        }
	      }
	      var groupedFigures = f._figures;
	      //_.forEach(groupedFigures, processFigure);
	      for (var i = 0, iEnd = groupedFigures.length; i < iEnd; ++i) {
	        processFigure(groupedFigures[i]);
	      }
	    } else {
	
	      var changed = false;
	
	      var processColor = function (c) {
	        var cs = c.textualize(includeTag);
	        if (cs in changesMap) {
	          c._replace(changesMap[cs], keepTags, keepLabels); // Avoid figure invalidation
	          changed = true;
	        }
	      };
	
	      (0, _lodash.forEach)(f.getColors(), processColor);
	
	      var of = f._outputFigure;
	      if (of && f !== of) {
	        (0, _lodash.forEach)(of.getColors(), processColor);
	      }
	
	      if (changed) {
	
	        if (f._powerClipContents.length > 0) {
	          var pFigures = f._powerClipContents[0]._figures;
	          for (var _k2 = 0, _kEnd2 = pFigures.length; _k2 < _kEnd2; ++_k2) {
	            var figure = pFigures[_k2];
	            figure.cacheId = null;
	            figure.invalidate();
	          }
	        }
	
	        if (_config.Config.replaceColorsLocallyWhenPossible && _config.Config.computeFigureGeometryLocally && f.supportsLocalMetrics() && // We no longer have the cache id
	        f.representationType() === 'local') // so we need this optimization enabled
	          {
	            // We are touching the processed figure directly, we can no longer
	            // use the stored cacheId figure in the server
	            f.cacheId = null;
	            f.lock();
	            f.invalidateView();
	          } else {
	          f.invalidate();
	        }
	      }
	    }
	  };
	  (0, _lodash.forEach)(figures, processFigure);
	  return figures;
	};
	
	Figures.align$ = function (figures, alignment, to, margin) {
	  var toBounds = to && (to.bounds || (to.lx !== undefined ? to : null));
	  if (toBounds) {
	    return (0, _gear.map$)(figures, function (f) {
	      return f.align$(alignment, toBounds, margin);
	    }).then(function () {
	      return figures;
	    });
	  } else {
	    return Figures.bounds$(to || figures).then(function (toBounds) {
	      return (0, _gear.map$)(figures, function (f) {
	        return f.align$(alignment, toBounds, margin);
	      }).then(function () {
	        return figures;
	      });
	    });
	  }
	};
	
	var _groupedAlign$ = function (figures, alignment, toBounds, margin) {
	  return Figures.bounds$(figures).then(function (bounds) {
	    return Figures.translate(figures, _geometry.Bounds.alignOffset(bounds, alignment, toBounds, margin));
	  });
	};
	
	Figures.groupedAlign$ = function (figures, alignment, to, margin) {
	  var toBounds = to.bounds || (to.lx !== undefined ? to : null);
	  if (toBounds) {
	    return _groupedAlign$(figures, alignment, toBounds, margin);
	  } else {
	    return Figures.bounds$(to).then(function (toBounds) {
	      return _groupedAlign$(figures, alignment, toBounds, margin);
	    });
	  }
	};
	
	Figures.preparedToDraw = function (figures, zoom) {
	  return (0, _lodash.every)(figures, function (f) {
	    return f.preparedToDraw(zoom);
	  });
	};
	Figures.prepareToDraw$ = function (figures, zoom) {
	  return (0, _gear.invokeMap$)(figures, 'prepareToDraw$', zoom);
	};
	
	Figures.filterProcessed = function (figures) {
	  var r = [];
	  for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	    var figure = figures[k];
	    if (figure.processed()) {
	      r.push(figure);
	    }
	  }
	  return r;
	};
	
	Figures.forEachText = function (figures, f) {
	  return (0, _lodash.forEach)((0, _lodash.filter)(figures, 'isText'), f);
	};
	
	Figures.forEachShape = function (figures, f) {
	  return (0, _lodash.forEach)((0, _lodash.filter)(figures, 'isShape'), f);
	};
	
	Figures.forEachRaster = function (figures, f) {
	  return (0, _lodash.forEach)((0, _lodash.filter)(figures, 'isRaster'), f);
	};
	
	Figures.forEachGroup = function (figures, f) {
	  return (0, _lodash.forEach)((0, _lodash.filter)(figures, 'isGroup'), f);
	};
	
	Figures.forEachProxyGroup = function (figures, f) {
	  return (0, _lodash.forEach)((0, _lodash.filter)(figures, 'isProxyGroup'), f);
	};
	
	Figures.deepForEachFigure = function (figures, func, context) {
	  if ((0, _gear.isArray)(figures)) {
	    for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	      if (figures[k].deepForEachFigure(func, context) === false) {
	        return false;
	      }
	    }
	  } else {
	    return figures.deepForEachFigure(func, context);
	  }
	};
	
	Figures.figureAtPoint_ = function (fromFigures, point) {
	  var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	
	  // Frame selection (Frame selection fallback)
	  var figures = [];
	  (0, _lodash.forEachRight)(fromFigures, function (f) {
	    if (f.canBeSelected() && f.frame_().contains(point)) {
	      // [TODO] Use 'selectable'?
	      figures.push(f);
	    }
	  });
	
	  // Shortcircuit, avoid expensive curves based selection if not needed
	  if (figures.length === 0) {
	    return null; // Nothing around
	  }
	  if (figures.length === 1) {
	    return figures[0]; // Only one figure
	  }
	
	  // direct selection of figure?
	  if (_config.Config.useCurvesBasedSelection) {
	    var figure = (0, _lodash.find)(figures, function (f) {
	      return f.hitTest(point, options);
	    });
	    if (figure) {
	      return figure;
	    }
	  }
	
	  return figures[0];
	};
	
	/*
	const canvas = document.createElement('canvas');
	canvas.width  = 512;
	canvas.height = 512;
	
	Cx.drawFiguresThumbnail$( canvas, figures ) .then(function(){
	
	log( canvas.toDataURL() );
	
	});
	*/
	
	Figures.drawFiguresThumbnail$ = function (canvas, figures) {
	  var width = canvas.width;
	  var height = canvas.height;
	
	  // This already process all the figures
	
	  return Figures.bounds$(figures).then(function (bounds) {
	
	    var bounds_width = bounds.width,
	        bounds_height = bounds.height;
	    var scaleX = width / bounds_width;
	    var scaleY = height / bounds_height;
	    var scale = Math.min(scaleX, scaleY);
	
	    var transform = _geometry.Matrix.concat(_geometry.Matrix.translate((width - bounds_width * scale) / 2, (height - bounds_height * scale) / 2), _geometry.Matrix.scale(scale, -scale), _geometry.Matrix.translate(-bounds.lx, -bounds.hy));
	
	    var drawConfig = {
	      transformDoc: transform
	    };
	
	    var context = canvas.getContext('2d');
	
	    var zoom = scale;
	    return (0, _gear.invokeMap$)(figures, 'prepareToDraw$', zoom).then(function () {
	
	      (0, _lodash.forEach)(figures, function (figure) {
	        figure.draw(context, transform, drawConfig);
	      });
	
	      return canvas;
	    });
	  });
	};
	
	Figures.setUnit$ = function (figures, fromUnit, toUnit) {
	  var scale = Figures.getScaleForUnitChange(fromUnit, toUnit);
	  return Figures.bounds$(figures).then(function (bounds) {
	    Figures.translate(figures, -bounds.center.x, -bounds.center.y);
	    return Figures.scale$(figures, scale, scale).then(function () {
	      Figures.translate(figures, bounds.center.x * scale, bounds.center.y * scale);
	    });
	  });
	};
	
	Figures.getScaleForUnitChange = function (oldUnit, newUnit) {
	  if (oldUnit == 'mm') {
	    if (newUnit == 'cm') return 1 / 10;
	    if (newUnit == 'in') return 1 / 25.4;
	  }
	
	  if (oldUnit == 'in') {
	    if (newUnit == 'cm') return 2.54;
	    if (newUnit == 'mm') return 25.4;
	  }
	
	  if (oldUnit == 'cm') {
	    if (newUnit == 'mm') return 10;
	    if (newUnit == 'in') return 1 / 2.54;
	  }
	
	  return 1;
	};

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FiguresCache = exports.QuantumImage = exports.QuantumImageBase = undefined;
	exports.downScaleQuantum$ = downScaleQuantum$;
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _geometry = __webpack_require__(21);
	
	var _figures = __webpack_require__(43);
	
	// QuantumImage and FiguresCache may only be used in web apps
	// The caches may be needed in a per request or per user fashion
	// Maybe it is not a bad idea to keep the latest files accessed
	// by a user in memory
	
	var stripExtension = function (id) {
	  var idx = id.indexOf('.');
	  return idx === -1 ? id : id.slice(0, idx);
	};
	
	var promiseThenImage = function (promise, c_id, qs) {
	  return promise.then(function () {
	    return c_id[qs];
	  });
	};
	
	function downScaleQuantum$(image, qs) {
	  var width = image.width;
	  var height = image.height;
	
	
	  if (width < qs && height < qs) {
	    return (0, _gear.resolve)(image);
	  }
	
	  var canvas = document.createElement('canvas');
	
	  var size = Math.max(width, height);
	
	  var sw = void 0,
	      sh = void 0;
	  if (width > height) {
	    sw = 1;
	    sh = height / width;
	  } else {
	    sw = width / height;
	    sh = 1;
	  }
	  canvas.width = qs * sw;
	  canvas.height = qs * sh;
	  var context = canvas.getContext('2d');
	  var scale = qs / size;
	  context.scale(scale, scale);
	  if (_config.Config.smoothRasterOnZoom !== undefined) context.imageSmoothingEnabled = _config.Config.smoothRasterOnZoom;
	  context.drawImage(image, 0, 0);
	  return (0, _gear.imagePromise)(canvas.toDataURL());
	}
	
	var quantumSizes = [128, 256, 512, 768, 1024]; // Check if we need bigger sizes
	var previewQuantumSize = 128; // We should get this value from the server, it is hardcoded right now
	
	if (_config.Config.smallerQuantumSizes) {
	  quantumSizes.unshift(64);
	}
	
	var QuantumImageBase = exports.QuantumImageBase = _gear.Base.extend({ typeName: 'QuantumImageBase',
	
	  init: function () {
	    this._cache = {};
	  },
	  cacheOf: function (id) {
	    var c = this._cache;
	    var c_id = c[id];
	    if (!c_id) {
	      c_id = c[id] = { p: {} };
	    }
	    return c_id;
	  },
	  set: function (id, size, image) {
	    var c_id = this.cacheOf(id);
	    var info = c_id.info;
	    if (info) {
	      (function () {
	        var originalImageSize = Math.max(info.width, info.height);
	        if (originalImageSize <= size) {
	          (0, _lodash.forEach)(quantumSizes, function (qs) {
	            if (originalImageSize <= qs) {
	              c_id[qs] = image;
	              delete c_id.p[qs];
	            }
	          });
	        }
	      })();
	    }
	    c_id[size] = image;
	    delete c_id.p[size];
	  },
	
	
	  /* Implemented in the derived classes
	    recolorizedId( size,colorMap) {
	    return ... id;
	  },
	    recolorizedImage( id,size,colorMap) {
	    return ... image;
	  },
	    */
	
	  get: function (id, size, colorMap) {
	    if (colorMap) {
	      return this.recolorizedImage(id, size, colorMap);
	    } else {
	      return this.cacheOf(id)[size];
	    }
	  },
	  getBest: function (id, size, colorMap) {
	    var _this = this;
	    var image = _this.get(id, size, colorMap);
	    if (image) {
	      return image;
	    }
	
	    var n = (0, _lodash.indexOf)(quantumSizes, size);
	
	    // Look up in bigger scales
	    for (var nup = n + 1; nup < quantumSizes.length; ++nup) {
	      var quantumSizes_nup = quantumSizes[nup];
	      image = _this.get(id, quantumSizes_nup, colorMap);
	      if (image) {
	        return image;
	      }
	    }
	
	    // Look in smaller scales, result will be pixelated
	    for (var ndown = n - 1; ndown >= 0; --ndown) {
	      var quantumSizes_ndown = quantumSizes[ndown];
	      image = _this.get(id, quantumSizes_ndown, colorMap);
	      if (image) {
	        return image;
	      }
	    }
	
	    return null;
	  },
	  downScaleQuantumsLocally: function () {
	    return _config.Config.downScaleQuantumsLocally && (_gear.supportsCrossOriginImages || _config.Config.base64Images);
	  },
	  optimizeQuantumPromises: function (id, info, size, promise) {
	    var c_id = this.cacheOf(id),
	        localDownScale = this.downScaleQuantumsLocally();
	
	    // Assign the same promise to all quantums that are bigger than the image size
	    // Avoid multiple request for bigger sizes
	
	    // Also assign the same promise for smaller quantums in case we are going to
	    // use local downscaling
	
	    var originalImageSize = info ? Math.max(info.width, info.height) : 0;
	    (0, _lodash.forEach)(quantumSizes, function (qs) {
	      if (info && originalImageSize <= qs && originalImageSize < size || qs < size && localDownScale) {
	        c_id.p[qs] = promiseThenImage(promise, c_id, qs);
	      }
	    });
	  },
	
	
	  // Extension defines loadImage$ that returns an image
	  // of the requested size or smaller in case there isn't
	  // more pixel information
	  cache$: function (id, size, colorMap) {
	    var _this = this;
	    var c_id = _this.cacheOf(id);
	
	    var sr_id = this.recolorizedId(size, colorMap);
	
	    // Image quantum is already cached
	    var image = c_id[sr_id];
	    if (image) {
	      return (0, _gear.resolve)(image);
	    }
	
	    // We are asking for this quantum
	    var promise = c_id.p[sr_id];
	    if (promise) {
	      return promise;
	    }
	
	    promise = c_id.p[sr_id] = _this.loadImage$(id, size, colorMap).then(function (image) {
	
	      _this.set(id, sr_id, image);
	
	      // [TODO] this is not used in FiguresCache, we need to abstract things better here
	      //        I leave this one for after the release.
	      //        It is not taking into account colorMap here
	      //-------------------------------------------------------------------------------
	      if (_this.downScaleQuantumsLocally()) {
	        return _this.generateSmallerQuantums$(id, size, image).then(function () {
	          return image;
	        });
	      }
	      return image;
	    });
	    this.optimizeQuantumPromises(id, c_id.info, size, promise);
	    //-------------------------------------------------------------------------------
	
	    return promise;
	  },
	  generateSmallerQuantums$: function (id, size, image) {
	    var _this = this;
	    var c_id = _this.cacheOf(id);
	    var sizes = quantumSizes.slice(0, (0, _lodash.indexOf)(quantumSizes, size));
	    sizes.reverse();
	    return (0, _gear.forEach$)(sizes, function (qs) {
	      return (0, _gear.if$)(!c_id[qs], function () {
	        // console.log('downscaling '+Math.max(image.width,image.height)+' > '+qs);
	        var promise = c_id.p[qs] = downScaleQuantum$(image, qs).then(function (qsImage) {
	          _this.set(id, qs, qsImage);
	        });
	        return promise.then(function () {
	          if (qs !== 768) {
	            // This is the only size that is not a power of 2
	            image = c_id[qs];
	            size = qs;
	          }
	        });
	      });
	    });
	  },
	  setInfo: function (id, info) {
	    var c_id = this.cacheOf(id);
	    c_id.info = info;
	    delete c_id.info_p;
	    return this;
	  },
	  getInfo: function (id) {
	    return this.cacheOf(id).info;
	  },
	
	
	  // Extension defines loadInfo$ that returns
	  // a info object { width: ..., height: ... }
	  info$: function (id) {
	
	    var _this = this,
	        c_id = _this.cacheOf(id);
	
	    // We already have th info for this image
	    var info = c_id.info;
	    if (info) {
	      return (0, _gear.resolve)(info);
	    }
	
	    // We are requesting it to the server, wait for it
	    var infoPromise = c_id.info_p;
	    if (infoPromise) {
	      return infoPromise;
	    }
	
	    // We call read info to get the width and height of the original image.
	    // We also ask for a preview to save us one request and be able to show something right
	    // away to the user, even if it is pixelated
	
	    infoPromise = c_id.info_p = _this.loadInfo$(id, 3).then(function (info) {
	      _this.setInfo(id, info);
	      return info;
	    });
	
	    return infoPromise;
	  },
	  sizeToDraw: function (vw, vh, wpx, hpx) {
	    var sw = void 0,
	        sh = void 0;
	    if (wpx > hpx) {
	      sw = 1;
	      sh = hpx / wpx;
	    } else {
	      sw = wpx / hpx;
	      sh = 1;
	    }
	
	    var qsize = (0, _lodash.find)(quantumSizes, function (qs) {
	      return qs * sw > vw && qs * sh > vh;
	    });
	    var largestQuantumOrFullImage = _config.Config.downloadFullImageOnLargeZoom ? null : (0, _lodash.last)(quantumSizes);
	    var size = qsize || largestQuantumOrFullImage;
	
	    return size;
	  },
	  cloneCache: function (id, aliasId) {
	    this._cache[aliasId] = this._cache[id];
	  }
	});
	
	var QuantumImage = exports.QuantumImage = new (QuantumImageBase.extend({ typeName: 'QuantumImage',
	
	  recolorizedId: function (size /*,colorMap*/) {
	    return size;
	  },
	  recolorizedImage: function (id, size, colorMap) {
	    var image = this.cacheOf(id)[size];
	    return image ? colorMap.recolorize(image, id) : null;
	  },
	  cacheFromFile$: function (id, file) {
	    // console.log('caching from file');
	    var _this = this;
	    var c_id = this.cacheOf(id);
	
	    var qs = (0, _lodash.last)(quantumSizes);
	
	    var promise = c_id.info_p = (0, _gear.imagePromise)(URL.createObjectURL(file)).then(function (image) {
	      var width = image.width,
	          height = image.height;
	      var info = { width: width, height: height };
	      _this.setInfo(id, info);
	
	      // If the jump is too big, it can generate artifacts, first perform an intermidiate
	      // step, then go to the last quantum.
	      return (0, _gear.if$)(Math.max(width, height) > 2.25 * qs, function () {
	        return downScaleQuantum$(image, 2 * qs).then(function (image2qs) {
	          image = image2qs;
	        });
	      }).then(function () {
	
	        return downScaleQuantum$(image, qs).then(function (qsImage) {
	          _this.set(id, qs, qsImage);
	
	          return _this.generateSmallerQuantums$(id, qs, qsImage).then(function () {
	            return info;
	          });
	        });
	      });
	    });
	
	    c_id.p[qs] = promiseThenImage(promise, c_id, qs);
	    this.optimizeQuantumPromises(id, c_id.info, qs, promise);
	
	    return promise;
	  },
	  requestQuantum$: function (aId, size) {
	    var id = stripExtension(aId);
	    var rm = { id: id, size: size };
	    var manager = _config.Config.GlobalResourceManager;
	    if (_config.Config.base64Images) {
	      return manager.renderImage$(rm).then(function (data) {
	        return (0, _gear.imagePromise)(data);
	      });
	    } else {
	      return (0, _gear.imagePromise)(manager.imageUrl(rm));
	    }
	  },
	  loadImage$: function (id, size /*,colorMap */) {
	
	    // The smallest size we can request from the server is previewQuantumSize
	    var _this = this;
	    if (size !== null && size < previewQuantumSize) {
	      return _this.cache$(id, previewQuantumSize).then(function (image) {
	        return (0, _gear.if$)(!_this.downScaleQuantumsLocally(), function () {
	          return _this.generateSmallerQuantums$(id, size, image);
	        }).then(function () {
	          return _this.cacheOf(id)[size];
	        });
	      });
	    } else {
	      return _this.requestQuantum$(id, size);
	    }
	  },
	  loadInfo$: function (id) {
	    var _this = this;
	    var rId = stripExtension(id);
	    var manager = _config.Config.GlobalResourceManager;
	    return manager.imageInfo$({ id: rId,
	      preview: _config.Config.rasterPreview || _config.Config.rasterPreviewForced
	
	    }).then(function (_ref) {
	      var width = _ref.width;
	      var height = _ref.height;
	      var preview = _ref.preview;
	
	
	      var info = { width: width, height: height };
	      if (preview) {
	        var _ret2 = function () {
	          var qs = previewQuantumSize;
	          var promise = _this.cacheOf(id).p[qs] = (0, _gear.imagePromise)(preview).then(function (image) {
	            _this.set(id, qs, image);
	            return info;
	          });
	          return {
	            v: promise
	          };
	        }();
	
	        if (typeof _ret2 === "object") return _ret2.v;
	      }
	      return info;
	    });
	  }
	}))();
	
	/*
	const _testFigures = function() {
	  const cdl = '<Cdl> <Shape> <Anchor X="325.4742" Y="639.3244"/> <Transform Matrix22="1,0,0,1"/> <Pin X="325.4742" Y="639.3244" Use="Anchor"/> <Polyregion FillMode="CadX"> <Brush> <Color RGB="FFFFFF" Tag="A"/> </Brush> <Region Points="111.8118 425.6619|539.1367 425.6619|539.1367 852.9869|111.8118 852.9869"/> </Polyregion> </Shape> <Shape> <Anchor X="218.388" Y="749.2761"/> <Transform Matrix22="1,0,0,1"/> <Pin X="219.4448" Y="746.1059" Use="Anchor"/> <Polyregion FillMode="CadX"> <Brush> <Color RGB="2533AA" Tag="B"/> </Brush> <Region Points="111.4317 642.3197|325.3444 642.3197|325.3444 856.2324|111.4317 856.2324"/> </Polyregion> </Shape> <Shape> <Anchor X="436.7761" Y="748.0695"/> <Transform Matrix22="0.7591,0,0,0.7591"/> <Pin X="431.4924" Y="744.8993" Use="Anchor"/> <Polyregion FillMode="CadX"> <Pen Width="10"> <Color RGB="FFFFFF" Tag="E"/> </Pen> <Brush> <Color RGB="2599AA" Tag="D"/> </Brush> <Region Points="328.618 748.0695,328.618 688.3347,377.0413 639.9114|436.7761 639.9114,496.5108 639.9114,544.9342 688.3347|544.9342 748.0695,544.9342 807.8043,496.5108 856.2276|436.7761 856.2276,377.0413 856.2276,328.618 807.8043"/> </Polyregion> </Shape> <Shape> <Anchor X="436.7761" Y="748.0695"/> <Transform Matrix22="0.776,0,0,0.776"/> <Pin X="217.1815" Y="530.888" Use="Anchor"/> <Polyregion FillMode="CadX"> <Brush> <Color RGB="FF4455" Tag="G"/> </Brush> <Region Points="328.618 748.0695,328.618 688.3347,377.0413 639.9114|436.7761 639.9114,496.5108 639.9114,544.9342 688.3347|544.9342 748.0695,544.9342 807.8043,496.5108 856.2276|436.7761 856.2276,377.0413 856.2276,328.618 807.8043"/> </Polyregion> </Shape> <Shape> <Anchor X="218.388" Y="749.2761"/> <Transform Matrix22="1,0,0,1"/> <Pin X="432.3993" Y="531.3375" Use="Anchor"/> <Polyregion FillMode="CadX"> <Brush> <Color RGB="9933AA" Tag="F"/> </Brush> <Region Points="111.4317 642.3197|325.3444 642.3197|325.3444 856.2324|111.4317 856.2324"/> </Polyregion> </Shape> </Cdl>';
	  return _.cloneDeep(Document.fromXmlString(cdl).figures;
	};
	*/
	
	function _zoomFromInfo(info, size) {
	  return size / Math.max(info.width, info.height);
	}
	
	// [TODO] Do not create one canvas each time?
	function createTile_(figures, bounds, zoom, colorMap) {
	  var transform = _geometry.Matrix.concat(_geometry.Matrix.scale(zoom), // scale quantum to desired size
	  _geometry.Matrix.scale(1, -1), // invert viewport Y coordinate
	  _geometry.Matrix.translate(_geometry.Point.minus(bounds.lx_hy))); // Move lx_hy to origin
	  var canvas = document.createElement('canvas');
	  canvas.width = bounds.width * zoom;
	  canvas.height = bounds.height * zoom;
	  var context = canvas.getContext('2d');
	  (0, _lodash.invokeMap)(figures, 'draw', context, transform, { colorMap: colorMap });
	  return canvas;
	}
	
	var colorMapCacheList = [];
	
	var FiguresCache = exports.FiguresCache = new (QuantumImageBase.extend({ typeName: 'FiguresCache',
	
	  // [TODO] We need to review this abstraction, caching should
	  //        be preview aware
	  //        For the moment, we disable color caching in FiguresCache,
	  //        because it is not expensive to recompute it
	
	  set: function (id, sr_id, image) {
	    var c_id = this.cacheOf(id);
	    c_id[sr_id] = image;
	    delete c_id.p[sr_id];
	
	    // Delete old cached results
	    colorMapCacheList.push({ id: id, sr_id: sr_id });
	    if (colorMapCacheList.length > _config.Config.colorMapCacheSize) {
	      var oc = colorMapCacheList.shift();
	      delete this.cacheOf(oc.id)[oc.sr_id];
	    }
	  },
	
	
	  // Support for tagged colors recolorization with caching
	
	  recolorizedId: function (size, colorMap) {
	    return size + (colorMap ? '|' + colorMap.textualize() : '');
	  },
	  recolorizedImage: function (id, size, colorMap) {
	    var _this = this;
	    var sr_id = _this.recolorizedId(size, colorMap);
	    var c_id = _this.cacheOf(id);
	    var image = c_id[sr_id];
	    if (!image) {
	      var info = c_id.info;
	      if (info) {
	
	        // If we have the info, recolorizing is fast for vector data, just
	        // perform the recolorization synchronously
	        var figures = info.figures;
	        var zoom = _zoomFromInfo(info, size);
	        if (_figures.Figures.preparedToDraw(figures, zoom)) {
	          var canvas = createTile_(figures, info.bounds, zoom, colorMap);
	
	          // Cache it
	          c_id.p[sr_id] = (0, _gear.imagePromise)(canvas.toDataURL()).then(function (image) {
	            _this.set(id, sr_id, image);
	          });
	
	          return canvas;
	        }
	      }
	    }
	    return image;
	  },
	  downScaleQuantumsLocally: function () {
	    return false;
	  },
	  optimizeQuantumPromises: function () /*id,info,size,promise*/{
	    // Do nothing, we have the vector data, so just draw them again.
	    // But if the vector data is too complex, maybe is not a bad idea
	    // to use images downscaling instead of a full redraw
	  },
	  loadInfo$: function (id, retries) {
	    var _this = this;
	    var rId = stripExtension(id);
	    return _figures.Figures.load$({ Id: rId }).then(function (figures) {
	      // return g.wait$(400) .then( () =>  _testFigures() ) .then( figures => {
	      return _figures.Figures.bounds$(figures).then(function (bounds) {
	        var info = { figures: figures, bounds: bounds.clone(),
	          width: bounds.width, height: bounds.height,
	          prepared: {}
	        };
	
	        // Prepare to draw the smallest size, same idea that the QuantumImage preview
	        // that we get from the server
	        var zoom = _zoomFromInfo(info, previewQuantumSize);
	        return _figures.Figures.prepareToDraw$(figures, zoom).then(function () {
	          return info;
	        });
	      });
	    }).catch(function (err) {
	      if (retries > 0) return _this.loadInfo$(id, retries - 1);
	    });
	  },
	  loadImage$: function (id, size, colorMap) {
	    var rId = stripExtension(id);
	    return this.info$(rId).then(function (info) {
	      var figures = info.figures;
	      var zoom = _zoomFromInfo(info, size);
	      return _figures.Figures.prepareToDraw$(figures, zoom).then(function () {
	        var canvas = createTile_(figures, info.bounds, zoom, colorMap);
	        // Review, we can just return the canvas here?
	        return (0, _gear.imagePromise)(canvas.toDataURL());
	      });
	    });
	  }
	}))();
	
	// We need to be able to use these two caches in Brushes and ColorMaps
	// It should be possible, but webpack is not handling circular dependencies
	// correctly, hack it for the moment, use Config as a global variable
	(0, _lodash.assign)(_config.Config, { QuantumImage: QuantumImage, FiguresCache: FiguresCache });

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _region = __webpack_require__(46);
	
	Object.keys(_region).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _region[key];
	    }
	  });
	});
	
	var _polyregion = __webpack_require__(47);
	
	Object.keys(_polyregion).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _polyregion[key];
	    }
	  });
	});
	
	var _shape = __webpack_require__(48);
	
	Object.keys(_shape).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _shape[key];
	    }
	  });
	});

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Region = undefined;
	exports.mapCurvesToRegions = mapCurvesToRegions;
	
	var _config = __webpack_require__(2);
	
	var _gear = __webpack_require__(8);
	
	var _geometry = __webpack_require__(21);
	
	var _util = __webpack_require__(17);
	
	var _style = __webpack_require__(29);
	
	var Region = exports.Region = _gear.OwnedObject.extend({ typeName: 'Region',
	
	  init: function (curves) {
	    this.callParent();
	    this._curves = curves;
	  },
	
	
	  get curves() {
	    return this.decodeCurves();
	  },
	  set curves(curves_) {
	    this._curves = curves_;
	  },
	
	  decodeCurves: function () {
	    var curves = this._curves;
	    if (_config.Config.lazyCdlDecoding) {
	      var length = curves.length;
	      for (var k = 0; k < length; ++k) {
	        var ck = curves[k];
	        if (ck.decode) {
	          this._curves[k] = ck.decode();
	        }
	      }
	    }
	    return curves;
	  },
	  clone: function () {
	    return new Region((0, _gear.cloneDeep)(this._curves));
	  },
	  transform: function (op) {
	    var curves = this.curves;
	    //_.forEach(curves,function(c) {
	    for (var k = 0, kEnd = curves.length; k < kEnd; ++k) {
	      curves[k].transform(op);
	    } //);
	  },
	
	
	  get bounds() {
	    return _geometry.Bounds.ofThings(this.curves);
	  },
	  boundsAfter: function (transform) {
	    return _geometry.Bounds.ofThingsAfter(this.curves, transform);
	  },
	  draw: function (context, transform) {
	    var curves = this.curves;
	    //_.forEach(curves,function(c) {
	    for (var k = 0, kEnd = curves.length; k < kEnd; ++k) {
	      curves[k].draw(context, transform);
	    } //);
	  },
	  toSVG: function () {
	    var svgCurve = '';
	    var curves = this.curves;
	    //_.forEach(curves,function(c) {
	    for (var k = 0, kEnd = curves.length; k < kEnd; ++k) {
	      svgCurve += curves[k].toSVG();
	    } //);
	    return svgCurve;
	  },
	  getFirstPoint: function () {
	    return this.curves[0].getFirstPoint();
	  },
	  buildXml: function (node) {
	    _util.Xml.addObject(node, this, 'Region');
	  },
	  setupXml: function (node) {
	    // The main boundary
	    var _curves = this._curves;
	    _curves[0].setupXml(node);
	    for (var k = 1, kEnd = _curves.length; k < kEnd; ++k) {
	      var hole = _util.Xml.appendElement(node, 'Hole');
	      _curves[k].setupXml(hole);
	    }
	  }
	});
	
	// Because of bacward compatibility, Polyregion.fromXml can return
	// several polyregions. This happens when pens and brushes have been defined
	// at the region level, something that is currently deprecated.
	Region.parseXml = function (node, parentStyle, buildPolyregion) {
	  var curves = [];
	  curves[0] = _config.Config.lazyCdlDecoding ? new _geometry.LazyBoundary(node) : _geometry.Boundary.parseXml(node);
	  var holes = _util.Xml.children(node, 'Hole');
	  //_.forEach(holes, function(h) {
	  for (var k = 0, kEnd = holes.length; k < kEnd; ++k) {
	    var h = holes[k];
	    curves.push(_config.Config.lazyCdlDecoding ? new _geometry.LazyBoundary(h) : _geometry.Boundary.parseXml(h));
	  } //);
	  var region = new Region(curves);
	
	  var pen = _style.Pen.fromXml(node);
	  var brush = _style.Brush.fromXml(node);
	  if (!pen._empty || !brush._empty) {
	    if (parentStyle.pen) {
	      pen = _style.Pen.def(pen, parentStyle.pen.clone());
	    }
	    if (parentStyle.brush) {
	      brush = _style.Brush.def(brush, parentStyle.brush.clone());
	    }
	    buildPolyregion([region], { pen: pen, brush: brush });
	    return null;
	  } else {
	    return region;
	  }
	};
	
	function mapCurvesToRegions(curves) {
	  var regions = [];
	  for (var k = 0, kEnd = curves.length; k < kEnd; ++k) {
	    regions.push(new Region([curves[k]]));
	  }
	  return regions;
	}

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Polyregion = undefined;
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _geometry = __webpack_require__(21);
	
	var _util = __webpack_require__(17);
	
	var _style = __webpack_require__(29);
	
	var _region4 = __webpack_require__(46);
	
	var _Math = Math,
	    _max = _Math.max;
	
	function recolorized(thing, config) {
	  var colorMap = config ? config.colorMap : null;
	  if (colorMap) {
	    return colorMap.recolorized(thing);
	  } else {
	    return thing;
	  }
	}
	
	// Used in hitTest
	function prepateHitTestPolygon(hull, transform) {
	  hull.push(hull[0]);
	  if (transform) {
	    for (var k = 0, kEnd = hull.length; k < kEnd; ++k) {
	      hull[k] = transform.apply(hull[k]);
	    }
	  }
	  return hull;
	}
	
	var Polyregion = exports.Polyregion = _gear.OwnedObject.extend({ typeName: 'Polyregion', __debugProps: true,
	
	  Properties: {
	    regions: { type: 'Region[]', def: [], manualParsing: true, onChange: function () {
	        this.invalidate();
	      } },
	    pen: { type: 'Pen', def: _style.Pen.empty, onChange: _gear.invalidateOwner },
	    brush: { type: 'Brush', def: _style.Brush.empty, onChange: _gear.invalidateOwner },
	    fillMode: { type: 'string', def: 'CadX', set: function (v) {
	        this.setFillMode(v);
	      } },
	    powerClipId: { type: 'string', def: null, onChange: _gear.invalidateOwner },
	    renderFrame: { type: 'Frame', def: null, onChange: _gear.invalidateOwner },
	    renderMatrix: { type: 'Matrix22', def: null, onChange: _gear.invalidateOwner },
	    tags: { type: 'string[]', def: [], dropDef: true, onChange: _gear.invalidateOwner },
	
	    // Used in output figure polyregions, to reference PowerClipContent in the input figure
	    // A PowerClipLink has an extra matrix so we are able to transform the content without cloning it
	    powerClipLink: { type: 'PowerClipLink', def: null, manualParsing: true }
	  },
	
	  setFillMode: function (v) {
	    if (this._fillMode !== v) {
	      if (v !== 'CadX' && this.hasHoles()) {
	        // flatten all holes into regions, soup of curves
	        this._regions = (0, _region4.mapCurvesToRegions)(this.enumCurves());
	      }
	
	      this._fillMode = v;
	      this.invalidateOwner();
	      return this;
	    }
	  },
	  enumCurves: function () {
	    var allCurves = [];
	    var regions = this._regions;
	    for (var k = 0, kEnd = regions.length; k < kEnd; ++k) {
	      var curves = regions[k].curves;
	      for (var c = 0, cEnd = curves.length; c < cEnd; ++c) {
	        allCurves.push(curves[c]);
	      }
	    }
	    return allCurves;
	  },
	  hasHoles: function () {
	    var regions = this._regions;
	    for (var k = 0, kEnd = regions.length; k < kEnd; ++k) {
	      var curves = regions[k].curves;
	      if (curves.length > 1) return true;
	    }
	    return false;
	  },
	
	
	  invalidateOwner: _gear.invalidateOwner,
	
	  get windingRule() {
	    return this.fillMode === 'Winding' && !this.hasHoles() ? 'nonzero' : 'evenodd';
	  },
	  set windingRule(windingRule_) {
	    this.fillMode = windingRule_ === 'nonzero' ? 'Winding' : 'Alternate';
	  },
	
	  init: function (ca, cb) {
	    // Allow Polyregion(regions,config) for backward compatibility
	    this._bounds = null;
	    if ((0, _gear.isArray)(ca)) {
	      this.initProperties(cb);
	      this.callParent(cb);
	      this._regions.set(ca);
	    } else {
	      this.callParent(ca);
	    }
	
	    this.renderMatrixAndRenderFrameFixup();
	  },
	  renderMatrixAndRenderFrameFixup: function () {
	    if (!(this._brush && (this._brush._type == "LinearGradientBrush" || this._brush._type == "RadialGradientBrush" || this._brush._type == "TextureBrush" || this._brush._type == "PatternBrush"))) {
	      this._renderFrame = null;
	      this._renderMatrix = null;
	    }
	  },
	  transform: function (t) {
	
	    // After calling transform, both the renderFrame and renderMatrix needs to be maintained
	    // Do not change the order, it is important to do this before actually transforming the points
	    var renderFrame = this._renderFrame;
	    if (!renderFrame) {
	      renderFrame = this._renderFrame = this.initialRenderFrame();
	    }
	    renderFrame.transform(t);
	
	    var renderMatrix = this._renderMatrix;
	    if (!renderMatrix) {
	      renderMatrix = new _geometry.Matrix();
	    }
	    this._renderMatrix = _geometry.Matrix.m(t, renderMatrix);
	
	    // Now transform the points
	    (0, _lodash.invokeMap)(this._regions, 'transform', t);
	
	    // [TODO][PC] Explore: Should we transform PC Links inside here instead
	    //            of doing it offline?
	
	    this.invalidate();
	    return this;
	  },
	  invalidate: function () {
	    this.outdate();
	    this.callParent();
	  },
	  outdate: function () {
	    this._bounds = null;
	  },
	  buildXml: function (node) {
	    _util.Xml.addObject(node, this, 'Polyregion');
	  },
	  setupXml: function (node) {
	    _util.Xml.setupProperties(node, this);
	    var regions = this._regions;
	    //_.forEach(regions,function(r) {
	    for (var k = 0, kEnd = regions.length; k < kEnd; ++k) {
	      regions[k].buildXml(node);
	    } //);
	  },
	
	
	  get center() {
	    return this.bounds.center;
	  },
	
	  get bounds() {
	    return this._bounds || (this._bounds = _geometry.Bounds.ofThings(this._regions));
	  },
	
	  boundsAfter: function (transform) {
	    return _geometry.Bounds.ofThingsAfter(this._regions, transform);
	  },
	  initialRenderFrame: function () {
	    return _geometry.Frame.fromBounds(this.bounds);
	  },
	
	
	  // This function returns true if the query point falls inside the
	  // Polyregion. The possible options are:
	  // - regionFrames: tells the function to check only the bounds of the regions
	  // of the polyregion. This option is used in text selection.
	  // - distance: don't check the stroke when the pen width is smaller than this
	  // value.
	  hitTest: function (point, transform) {
	    var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	
	    // There are two things to check, the outline and the interior. If the brush
	    // is transparent, we don't check the interior. If the pen is thin, we don't
	    // check the outline.
	    var checkOutline = true,
	        checkInterior = true;
	    var brush = this.rwBrush();
	    var pen = this.rwPen();
	    var scaledPenWidth_2 = pen.width * transform.scaleFactor() / 2;
	    var checkWidth = options.distance === undefined ? 0 : options.distance;
	
	    if (_config.Config.selectUnderTransparentFigures && (brush._empty || brush instanceof _style.Brush && brush.color.alpha === 0)) {
	      checkInterior = false;
	      checkWidth = _max(checkWidth, scaledPenWidth_2);
	    } else {
	      if (pen instanceof _style.Pen && scaledPenWidth_2 >= checkWidth) {
	        checkWidth = scaledPenWidth_2;
	      } else {
	        checkOutline = false;
	      }
	    }
	    var regions = this._regions;
	
	    if (options.regionFrames) {
	      // Simplified hit test used
	      for (var ir = 0, irEnd = regions.length; ir < irEnd; ++ir) {
	        var region = regions[ir];
	        var hull = prepateHitTestPolygon(region.curves[0].controlPoints(), transform);
	        if (_geometry.Bounds.ofPoints(hull).inflate(checkWidth, checkWidth).contains(point)) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    // We compute the squared pen width we will use to perform the hit test (we
	    // want to avoid square roots).
	    var squaredCheckWidth = checkWidth * checkWidth;
	
	    if (this.hasHoles()) {
	      // Iterate over all the regions of the polyregion.
	      for (var _ir = 0, _irEnd = regions.length; _ir < _irEnd; ++_ir) {
	        var _region = regions[_ir];
	        // The first curve is the outer one.
	        var boundary = _region.curves[0];
	        // Check first if the query point is inside the bounds of the outer
	        // curve.
	        var outerCurve = prepateHitTestPolygon(boundary.controlPoints(), transform);
	        var inside = checkInterior && _geometry.Point.isInsidePolygon(point, outerCurve) || checkOutline && _geometry.Point.isNearPolygon(point, outerCurve, squaredCheckWidth);
	        if (inside) {
	          // Check the holes if the point is inside the bounds.
	          var holes = _region.curves.slice(1);
	          // Iterate over the holes of the polyregion until finding a hole
	          // whose bounds contain the query point. If there is no such
	          // hole, then the query point is inside the region.
	          for (var ih = 0; inside && ih < holes.length; ih++) {
	            var holeHull = prepateHitTestPolygon(holes[ih].controlPoints(), transform);
	            // A problem with the following test is that it is performed
	            // using the holes control points. From some applications, this
	            // is OK because the curve is contained in the convex hull of
	            // its control points. But this can give false positives.
	            inside = !(checkInterior && _geometry.Point.isInsidePolygon(point, holeHull) || checkOutline && _geometry.Point.isNearPolygon(point, holeHull, squaredCheckWidth));
	          }
	          // At this point, inside is true if the query point is inside the
	          // boundary of a region and outside all the holes.
	        }
	        if (inside) {
	          return true;
	        }
	        // If inside is false, we keep iterating the regions to determine if
	        // the query point falls inside one of them.
	      }
	      // At this point, we know the query point is outside all the regions
	      // of the polyregion. We finally test the distance to the segments, in
	      // order to see if the query point falls into the pen width.
	    } else {
	      // Create one big hull to test. This hull can be non-convex.
	      var _hull = [];
	      // Iterate over all the regions.
	      for (var _ir2 = 0, _irEnd2 = regions.length; _ir2 < _irEnd2; ++_ir2) {
	        var _region2 = regions[_ir2];
	        var curves = _region2.curves;
	        // Iterate over all the curves of the region.
	        for (var ic = 0; ic < curves.length; ic++) {
	          // polygon must contain the control points (which are its
	          // vertices) and, to respect the format of Cx.Polygon, the last
	          // point is a copy of the first one.
	          var polygon = prepateHitTestPolygon(curves[ic].controlPoints(), transform);
	          // With the new polygon, we can test whether the query point is within
	          // a distance to the region edges. In case it is, we return true.
	          if (checkOutline && _geometry.Point.isNearPolygon(point, polygon, squaredCheckWidth)) {
	            return true;
	          }
	          // Now, the point at (0,0) is added to the list of vertices. This
	          // does the trick of letting all the regions be enclosed in a
	          // continuous hull. If we simply concatenate vertices, we can
	          // generate a region which is bigger than the current hull.
	          _hull.push(transform.apply(new _geometry.Point(0, 0)));
	          _hull = _hull.concat(polygon);
	        }
	      }
	
	      // Close the hull, back to (0,0)
	      _hull.push(transform.apply(new _geometry.Point(0, 0)));
	
	      // Finally, we perform the test to see if the query point is inside the
	      // curves. The closeness to the polygons was already tested.
	      if (this._fillMode === 'Alternate') {
	        // Return true if the point is inside the hull of the control
	        // points.
	        return checkInterior && _geometry.Point.isInsidePolygon(point, _hull, false);
	      } else {
	        // FillMode: Winding
	        // If the winding number of the query point is not zero, the hit test
	        // returns true.
	        // TODO: The latter test must be replaced by the distance to the curve
	        // and not the distance to the hull.
	        return checkInterior && _geometry.Point.windNumber(point, _hull) !== 0;
	      }
	    }
	    return false;
	  },
	  toSVG: function () {
	    var svgCurve = '';
	    var regions = this._regions;
	    //_.forEach(regions,function(r) {
	    for (var k = 0, kEnd = regions.length; k < kEnd; ++k) {
	      svgCurve += regions[k].toSVG();
	    } //);
	    return svgCurve;
	  },
	  getFirstPoint: function () {
	    return this._regions[0].getFirstPoint();
	  },
	  drawFill: function (context, transform, config, matrix, brush) {
	
	    if (matrix === undefined) {
	      matrix = this.globalMatrix_(transform);
	    }
	    if (brush === undefined) {
	      brush = recolorized(this.rwBrush(), config);
	    }
	
	    if (!brush._empty) {
	
	      var frame = void 0; // Avoid computing the render frame if it will not be used
	      if (brush.needsFrame()) {
	        frame = (this.renderFrame || this.initialRenderFrame()).transformed(matrix);
	      }
	
	      var renderMatrix = this._renderMatrix;
	      var rm = renderMatrix ? _geometry.Matrix.m(matrix, renderMatrix) : matrix;
	
	      if (brush.needsClipping()) {
	        context.save();
	        context.clip(this.windingRule);
	        brush.setupContext(context, rm, frame, config.transformDoc);
	        context.restore();
	      } else {
	        context.save();
	        brush.setupContext(context, rm, frame, config.transformDoc);
	        context.fill(this.windingRule);
	        context.restore();
	      }
	    }
	  },
	  drawStroke: function (context, transform, config, matrix, pen) {
	
	    if (matrix === undefined) {
	      matrix = this.globalMatrix_(transform);
	    }
	    if (pen === undefined) {
	      pen = recolorized(this.rwPen(), config);
	    }
	
	    if (!pen._empty) {
	
	      var pen_type = pen._type;
	      if (pen_type === 'MaskPen' || pen_type === 'DisplayPen') {
	        // This polyregion will be picked up later by the view
	        void 0;
	      } else if (pen_type === 'CutPen' || pen._color._alpha > 0.0) {
	        context.save();
	        pen.setupContext(context, matrix);
	        context.stroke();
	        context.restore();
	      }
	    }
	  },
	  drawShowthroughMask: function (drawPath, context, transform, config, matrix) {
	    if (matrix === undefined) {
	      matrix = this.globalMatrix_(transform);
	    }
	
	    var pen = recolorized(this.rwPen(), config);
	    pen = pen.clone();
	    var lColors = pen.getColors();
	    var lNrColors = lColors.length;
	    for (var i = 0; i < lNrColors; i++) {
	      if (lColors[i].showThrough) {
	        lColors[i].alpha = 1;
	        lColors[i].rgb = 'FFFFFF';
	      } else {
	        lColors[i].rgb = '000000';
	      }
	    }
	
	    var penBehindFill = !pen._empty && pen._behindFill;
	    var penAfterFill = !pen._empty && !pen._behindFill;
	
	    var clipped = false;
	
	    drawPath(context, matrix);
	
	    if (penBehindFill && !config.ignorePen) {
	      this.drawStroke(context, transform, config, matrix, pen);
	    }
	
	    var brush = recolorized(this.rwBrush(), config);
	    if (brush.getType() == 'TextureBrush' || brush.getType() == 'PatternBrush') {
	      brush = new _style.Brush({ color: _style.Color.Black() });
	    } else {
	      brush = brush.clone();
	      lColors = brush.getColors();
	      lNrColors = lColors.length;
	      for (var _i = 0; _i < lNrColors; _i++) {
	        if (lColors[_i].showThrough) {
	          lColors[_i].alpha = 1;
	          lColors[_i].rgb = 'FFFFFF';
	        } else {
	          lColors[_i].rgb = '000000';
	        }
	      }
	    }
	
	    this.drawFill(context, transform, config, matrix, brush);
	
	    var pcContent = void 0,
	        pcMatrix = void 0;
	
	    // PowerClip support, using PowerClipLink for output figures
	    // These links directly reference input power clips
	
	    var parent = this._owner;
	    if (parent) {
	
	      var pcLink = this._powerClipLink;
	      if (pcLink) {
	        // console.log(pcLink._content._id);
	        pcContent = pcLink._content;
	        pcMatrix = pcLink._matrix;
	      } else {
	        var pc_id = this._powerClipId;
	        if (pc_id !== null) {
	          var pccs = parent._powerClipContents;
	          pcContent = (0, _lodash.find)(pccs, { _id: pc_id });
	          pcMatrix = new _geometry.Matrix();
	        }
	      }
	
	      if (pcContent) {
	        context.save();
	        context.clip(this.windingRule);
	        clipped = true;
	
	        // Powerclips needs to be transformed with a different rw transform than
	        // the one used for the polyregions paths, they are relative to the pin and not the
	        // the figure anchor.
	        var pcTransform = _geometry.Matrix.concat(transform, parent.rwPowerClipTransform(), pcMatrix);
	        pcContent.draw(context, pcTransform, config);
	        context.restore();
	      }
	    }
	
	    if (penAfterFill && !config.ignorePen) {
	      if (clipped) {
	        // It seems that even if you do a context.save() once you perform a context.clip()
	        // things are screwed for the used path, and it needs to be redrawn
	        drawPath(context, matrix);
	      }
	      this.drawStroke(context, transform, config, matrix, pen);
	    }
	  },
	  drawSolidShowthrough: function (drawPath, context, transform, config, matrix) {
	    if (matrix === undefined) {
	      matrix = this.globalMatrix_(transform);
	    }
	
	    var pen = recolorized(this.rwPen(), config);
	    pen = pen.clone();
	    var lColors = pen.getColors();
	    var lNrColors = lColors.length;
	    for (var i = 0; i < lNrColors; i++) {
	      if (lColors[i].showThrough) {
	        lColors[i].alpha = 1;
	        lColors[i].rgb = config.showthroughColor.rgb;
	      }
	    }
	
	    var penBehindFill = !pen._empty && pen._behindFill;
	    var penAfterFill = !pen._empty && !pen._behindFill;
	
	    var clipped = false;
	
	    drawPath(context, matrix);
	
	    if (penBehindFill && !config.ignorePen) {
	      this.drawStroke(context, transform, config, matrix, pen);
	    }
	
	    var brush = recolorized(this.rwBrush(), config);
	    if (brush.getType() == 'TextureBrush' || brush.getType() == 'PatternBrush') {
	      brush = new _style.Brush({ color: _style.Color.Black() });
	    } else {
	      brush = brush.clone();
	      lColors = brush.getColors();
	      lNrColors = lColors.length;
	      for (var _i2 = 0; _i2 < lNrColors; _i2++) {
	        if (lColors[_i2].showThrough) {
	          lColors[_i2].alpha = 1;
	          lColors[_i2].rgb = config.showthroughColor.rgb;
	        }
	      }
	    }
	
	    this.drawFill(context, transform, config, matrix, brush);
	
	    var pcContent = void 0,
	        pcMatrix = void 0;
	
	    // PowerClip support, using PowerClipLink for output figures
	    // These links directly reference input power clips
	
	    var parent = this._owner;
	    if (parent) {
	
	      var pcLink = this._powerClipLink;
	      if (pcLink) {
	        // console.log(pcLink._content._id);
	        pcContent = pcLink._content;
	        pcMatrix = pcLink._matrix;
	      } else {
	        var pc_id = this._powerClipId;
	        if (pc_id !== null) {
	          var pccs = parent._powerClipContents;
	          pcContent = (0, _lodash.find)(pccs, { _id: pc_id });
	          pcMatrix = new _geometry.Matrix();
	        }
	      }
	
	      if (pcContent) {
	        context.save();
	        context.clip(this.windingRule);
	        clipped = true;
	
	        // Powerclips needs to be transformed with a different rw transform than
	        // the one used for the polyregions paths, they are relative to the pin and not the
	        // the figure anchor.
	        var pcTransform = _geometry.Matrix.concat(transform, parent.rwPowerClipTransform(), pcMatrix);
	        pcContent.draw(context, pcTransform, config);
	        context.restore();
	      }
	    }
	
	    if (penAfterFill && !config.ignorePen) {
	      if (clipped) {
	        // It seems that even if you do a context.save() once you perform a context.clip()
	        // things are screwed for the used path, and it needs to be redrawn
	        drawPath(context, matrix);
	      }
	      this.drawStroke(context, transform, config, matrix, pen);
	    }
	  },
	  drawStrokeAndFill: function (drawPath, context, transform, config, matrix) {
	    if (matrix === undefined) {
	      matrix = this.globalMatrix_(transform);
	    }
	    var pen = recolorized(this.rwPen(), config);
	
	    pen = pen.clone();
	    var lColors = pen.getColors();
	    var lNrColors = lColors.length;
	    for (var i = 0; i < lNrColors; i++) {
	      if (lColors[i].showThrough) {
	        lColors[i].alpha = 0;
	      }
	    }
	
	    var penBehindFill = !pen._empty && pen._behindFill;
	    var penAfterFill = !pen._empty && !pen._behindFill;
	
	    var clipped = false;
	
	    drawPath(context, matrix);
	
	    if (penBehindFill && !config.ignorePen) {
	      this.drawStroke(context, transform, config, matrix, pen);
	    }
	
	    var brush = recolorized(this.rwBrush(), config);
	    if (!(brush.getType() == 'TextureBrush' || brush.getType() == 'PatternBrush')) {
	      brush = brush.clone();
	      lColors = brush.getColors();
	      lNrColors = lColors.length;
	      for (var _i3 = 0; _i3 < lNrColors; _i3++) {
	        if (lColors[_i3].showThrough) {
	          lColors[_i3].alpha = 0;
	        }
	      }
	    }
	
	    this.drawFill(context, transform, config, matrix, brush);
	
	    var pcContent = void 0,
	        pcMatrix = void 0;
	
	    // PowerClip support, using PowerClipLink for output figures
	    // These links directly reference input power clips
	
	    var parent = this._owner;
	    if (parent) {
	
	      var pcLink = this._powerClipLink;
	      if (pcLink) {
	        // console.log(pcLink._content._id);
	        pcContent = pcLink._content;
	        pcMatrix = pcLink._matrix;
	      } else {
	        var pc_id = this._powerClipId;
	        if (pc_id !== null) {
	          var pccs = parent._powerClipContents;
	          pcContent = (0, _lodash.find)(pccs, { _id: pc_id });
	          pcMatrix = new _geometry.Matrix();
	        }
	      }
	
	      if (pcContent) {
	        context.save();
	        context.clip(this.windingRule);
	        clipped = true;
	
	        // Powerclips needs to be transformed with a different rw transform than
	        // the one used for the polyregions paths, they are relative to the pin and not the
	        // the figure anchor.
	        var pcTransform = _geometry.Matrix.concat(transform, parent.rwPowerClipTransform(), pcMatrix);
	        pcContent.draw(context, pcTransform, config);
	        context.restore();
	      }
	    }
	
	    if (penAfterFill && !config.ignorePen) {
	      if (clipped) {
	        // It seems that even if you do a context.save() once you perform a context.clip()
	        // things are screwed for the used path, and it needs to be redrawn
	        drawPath(context, matrix);
	      }
	      this.drawStroke(context, transform, config, matrix, pen);
	    }
	
	    var topFigure = this.topFigure;
	    if (topFigure && topFigure._highlight) {
	      var _brush = recolorized(this.rwBrush(), config);
	      if (!_brush._empty) {
	        context.save();
	        var color = _brush instanceof _style.Brush ? _style.Color.highestContrast(_brush.color) : _style.Color.White();
	        context.globalAlpha = 0.3;
	        context.fillStyle = color.rgba;
	        context.fill(this.windingRule);
	        context.restore();
	      }
	    }
	  },
	  drawWireframe: function (drawPath, context, transform, config, matrix) {
	    context.save();
	    drawPath(context, matrix);
	    (0, _gear.strokeWireframe)(context);
	    context.restore();
	  },
	  drawCustom: function (drawPath, context, transform, config, matrix) {
	    context.save();
	    drawPath(context, matrix);
	    config.customDraw(context, transform, config);
	    context.restore();
	  },
	
	
	  // fillMode CadX works exactly as alternate here
	  clipContext: function (context, transform) {
	    var regions = this.regions;
	
	    var matrix = this.globalMatrix_(transform);
	    context.beginPath();
	    for (var k = 0, kEnd = regions.length; k < kEnd; ++k) {
	      regions[k].draw(context, matrix);
	    }
	    context.clip(this.windingRule);
	    context.beginPath();
	  },
	  drawForClipping: function (context, transform) {
	    var regions = this.regions;
	
	    var matrix = this.globalMatrix_(transform);
	    for (var k = 0, kEnd = regions.length; k < kEnd; ++k) {
	      regions[k].draw(context, matrix);
	    }
	  },
	  draw: function (context, transform) {
	    var _this = this;
	
	    var config = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	
	    if (!config.transformDoc) {
	      config = (0, _lodash.assign)({ transformDoc: transform }, config);
	    }
	
	    var matrix = this.globalMatrix_(transform);
	
	    // This is a little bit complex because when we have powerclips
	    // we need to redraw the path for pen behind fill
	
	    var drawFunction = config.showthroughMask ? 'drawShowthroughMask' : config.wireframe ? 'drawWireframe' : config.showthroughColor && config.showthroughColor.alpha != 0.0 ? 'drawSolidShowthrough' : config.customDraw ? 'drawCustom' : 'drawStrokeAndFill';
	
	    var regions = this._regions;
	    if (this.hasHoles()) {
	      var _loop = function (k, kEnd) {
	        var region = regions[k];
	        _this[drawFunction](function (c, t) {
	          c.beginPath();
	          region.draw(c, t);
	        }, context, transform, config, matrix);
	      };
	
	      //_.forEach(regions,function(r) {
	      for (var k = 0, kEnd = regions.length; k < kEnd; ++k) {
	        _loop(k, kEnd);
	      } //,this);
	    } else {
	      this[drawFunction](function () /*c,t*/{
	        context.beginPath();
	        //_.forEach(regions,function(r) {
	        for (var _k = 0, _kEnd = regions.length; _k < _kEnd; ++_k) {
	          regions[_k].draw(context, matrix);
	        } //);
	      }, context, transform, config, matrix);
	    }
	  },
	  globalMatrix_: function (transform) {
	    var parent = this._owner;
	    if (parent && parent.globalMatrix_) {
	      return _geometry.Matrix.m(transform, parent.globalMatrix_());
	    }
	    return transform;
	  },
	
	
	  // rwPen(): analogous to rwBrush() below.
	  rwPen: function () {
	    var parent = this._owner;
	    if (this._pen) {
	      if (parent && parent.pen) {
	        // the object and the parent have pens
	        return this.combinedPen(parent._pen);
	      } else {
	        // the parent doesn't exist or has no pen
	        return this._pen;
	      }
	    } else {
	      // the object has no pen defined
	      return parent._pen;
	    }
	  },
	
	
	  // rwBrush() returns the brush used by this Polyregion. If the object and
	  // the parent have brushes, it returns a combination of both. If only one
	  // of the object and the parent has brush, it returns it. If noone has
	  // brush, null is returned.
	  rwBrush: function () {
	    var parent = this._owner;
	    if (this._brush) {
	      if (parent && parent.brush) {
	        // the object and the parent have brushes
	        return this.combinedBrush(parent._brush);
	      } else {
	        // the parent doesn't exist or has no brush
	        return this._brush;
	      }
	    } else {
	      // the object has no brush defined
	      return parent._brush;
	    }
	  },
	  combinedBrush: function (shapeBrush) {
	    return _style.Brush.def(this._brush, shapeBrush);
	  },
	  combinedPen: function (shapePen) {
	    var pen = _style.Pen.def(this._pen, shapePen);
	    if (pen._type === 'Pen' && pen._width > 0.0) {
	      // [TODO] push this inside pen.setupContext, avoid creating another pen
	      var renderMatrixScaleFactor = this._renderMatrix ? this._renderMatrix.scaleFactor() : 1.0;
	      pen = pen.clone();
	      pen.width = pen._width * renderMatrixScaleFactor;
	    }
	    return pen;
	  },
	
	  get topFigure() {
	    var owner = this._owner;
	    return owner && owner.topFigure;
	  }
	});
	
	Polyregion.createFromBoundary = function (boundary, config) {
	  return new Polyregion([new _region4.Region([boundary])], config);
	};
	
	Polyregion.listFromXml = function (node) {
	  var polyregionNodes = _util.Xml.children(node, 'Polyregion');
	  var polyregions = [];
	  //_.forEach(polyregionNodes, function(pn) {
	  for (var k = 0, kEnd = polyregionNodes.length; k < kEnd; ++k) {
	    var pn = polyregionNodes[k];
	    // Because of backward compatibility, Polyregion.fromXml can return
	    // several polyregions. This happens when pens and brushes have been defined
	    // at the region level, something that is currently deprecated.
	    Polyregion.parseXml(pn, polyregions);
	  } //);
	  return polyregions;
	};
	
	// Because of backward compatibility, Polyregion.fromXml can return
	// several polyregions. This happens when pens and brushes have been defined
	// at the region level, something that is currently deprecated.
	Polyregion.parseXml = function (node) {
	  var polyregions = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
	
	
	  var p = _util.Xml.parseProperties(node, Polyregion);
	
	  var buildPolyregion = function (regions, config) {
	    if (regions.length > 0) {
	      polyregions.push(new Polyregion(regions, config));
	    }
	  };
	
	  var regionNodes = _util.Xml.children(node, 'Region');
	  var regions = [];
	  //_.forEach(regionNodes, function(rn) {
	  for (var k = 0, kEnd = regionNodes.length; k < kEnd; ++k) {
	    var rn = regionNodes[k];
	    // A region that have a pen or a brush can generate polyregions
	    var _region3 = _region4.Region.parseXml(rn, p, buildPolyregion);
	    if (!_region3) {
	      buildPolyregion(regions, p);
	      regions = [];
	    } else {
	      regions.push(_region3);
	    }
	  } //);
	
	  buildPolyregion(regions, p);
	};
	
	Polyregion.CreateRectangle = function (config) {
	  var boundary = _geometry.Boundary.createRectangle(config);
	  var polyregion = Polyregion.createFromBoundary(boundary);
	  if (config.brush) {
	    polyregion.brush = config.brush;
	  }
	  if (config.pen) {
	    polyregion.pen = config.pen;
	  }
	  return polyregion;
	};
	
	Polyregion.CreatePolyline = function (config) {
	  var boundary = new _geometry.Polyline(config.points, config.closed || false);
	  var polyregion = Polyregion.createFromBoundary(boundary);
	  polyregion.pen = config.pen || (0, _style.Pen)({ width: 1.0, color: (0, _style.Color)({ rgb: '000000' }) });
	  return polyregion;
	};
	
	_util.Xml.Parser['Polyregion'] = _util.Xml.makeObjectParser(Polyregion);
	_util.Xml.Parser['Polyregion[]'] = _util.Xml.makeArrayObjectParser(Polyregion);

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toSingleGShape = exports.GShape = exports.Shape = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _xml = __webpack_require__(19);
	
	var _geometry = __webpack_require__(21);
	
	var _figure = __webpack_require__(39);
	
	var _anchor = __webpack_require__(42);
	
	var _powerClip = __webpack_require__(49);
	
	var _region = __webpack_require__(46);
	
	var _polyregion = __webpack_require__(47);
	
	var _invalidate = function () {
	  this.invalidate();
	};
	
	var paintedPolyregion = function (p) {
	  return !p._brush._empty; // && ! ( p._pen._empty || p._pen._alpha === 0 );
	};
	
	var _manageDeprecatedUnarrangedAttr = function (shape, shapeNode) {
	  if (shapeNode.getAttribute('FillMode') || shapeNode.getAttribute('IsUnarranged')) {
	    (function () {
	
	      var shapeIsUnarranged = _xml.Xml.getBoolAttr(shapeNode, 'IsUnarranged', false);
	      var fillMode = shapeNode.getAttribute('FillMode') || 'Alternate';
	      var polyregions = shape._polyregions;
	      if (shapeIsUnarranged) {
	        (function () {
	          var renderFrame = polyregions[0]._renderFrame;
	          var curves = [];
	          (0, _lodash.forEach)(polyregions, function (p) {
	            (0, _lodash.forEach)(p.regions, function (r) {
	              curves = curves.concat(r._curves); // We use _curves to avoid tryigering lazy CDL decoding
	            });
	          });
	          // [TODO-STYLE]
	          var unarrangedPolyregion = new _polyregion.Polyregion([new _region.Region(curves)], { fillMode: fillMode, renderFrame: renderFrame });
	          polyregions.set([unarrangedPolyregion]);
	        })();
	      } else if (_config.Config.convertShapeFillMode) {
	        (function () {
	          // unarranged is false, but fillmode is in the parent
	          // Each region should be converted to a polyregion
	          var arrangedPolyregions = [];
	          (0, _lodash.forEach)(polyregions, function (p) {
	            (0, _lodash.forEach)(p.regions, function (r) {
	              // [TODO-STYLE] p.pen.clone(), p.brush.clone() ),
	              arrangedPolyregions.push(new _polyregion.Polyregion([r], { fillMode: fillMode, renderFrame: p._renderFrame, brush: p._brush, pen: p._pen }));
	            });
	          });
	          polyregions.set(arrangedPolyregions);
	        })();
	      }
	    })();
	  }
	};
	
	var Shape = exports.Shape = _figure.Figure.Shape = _figure.Figure.extend({ typeName: 'Shape',
	
	  type: 'Shape',
	
	  Properties: {
	    polyregions: { type: 'Polyregion[]', def: [], owned: true, manualParsing: true, onChange: _invalidate }
	  },
	
	  get isShape() {
	    return true;
	  },
	
	  _ignoreAttributes: _figure.Figure.prototype._ignoreAttributes.concat(['fillMode', 'isUnarranged']),
	
	  invalidate: function () {
	    (0, _lodash.invokeMap)(this.polyregions, 'outdate');
	    this.callParent();
	  },
	
	
	  /* // [TODO]
	  brush( v ) {
	    if(v!==undefined) { // Remove all the polyregions pens
	      forEach(this._polyregions, p => { p.brush = Brush.empty; });
	    }
	    return this.callParent(v);
	  },
	  pen( v ) {
	    if(v!==undefined) { // Remove all the polyregions pens
	      forEach(this._polyregions, p => { p.pen = Pen.empty; });
	    }
	    return this.callParent(v);
	  },
	  */
	
	  getFirstPoint: function () {
	    return this.matrix_().apply(this._polyregions[0].getFirstPoint());
	  },
	  buildXml: function (parentNode) {
	    _xml.Xml.addObject(parentNode, this, 'Shape');
	  },
	  setupXml: function (node) {
	    this.callParent(node);
	    var ps = this._polyregions;
	    //_.forEach(ps,function(p) {
	    for (var k = 0, kEnd = ps.length; k < kEnd; ++k) {
	      ps[k].buildXml(node);
	    } //);
	  },
	  polyregionAtPoint_: function (point, options) {
	    var transform = this.globalMatrix_();
	    // The transform argument here is temporal, we need to better managed the cached
	    // geometry information so it is also available for the output figure to use
	    var polyregions = this.polyregions;
	
	    for (var k = polyregions.length - 1; k >= 0; --k) {
	      var p = polyregions[k];
	      if (p.hitTest(point, transform, options)) {
	        return p;
	      }
	    }
	  },
	
	
	  // Returns an array of curves that are already transformed by the shape transform
	  flattenCurves$: function () {
	    var ps = this.polyregions;
	    return this.globalMatrix$().then(function (shapeMatrix) {
	      var flattenCurves = [];
	      for (var k = 0, kEnd = ps.length; k < kEnd; ++k) {
	        var curves = ps[k].enumCurves();
	        for (var c = 0, cEnd = curves.length; c < cEnd; ++c) {
	          flattenCurves.push(curves[c].transformed(shapeMatrix));
	        }
	      }
	      return flattenCurves;
	    });
	  },
	  boundsIsVectorBounds: function () {
	    return this._pen._empty && (0, _lodash.every)(this.polyregions, function (p) {
	      return p._pen._empty;
	    }) && this._processes.length === 0;
	  },
	  _primitive_computePreReferencePoint: function () {
	    return this._polyregions[0].getFirstPoint();
	  },
	  _primitive_computePreVectorBounds: function () {
	    // console.log('    <> Shape._primitive_computePreVectorBounds');
	    return _geometry.Bounds.ofThings(this._polyregions);
	  },
	  _primitive_computePreVectorBoundsAfter: function (transform) {
	    // console.log('    <> Shape._primitive_computePreVectorBoundsAfter '+transform.toMatrixString());
	    return _geometry.Bounds.ofThingsAfter(this._polyregions, transform);
	  },
	  _primitive_computePreBounds: function () {
	    return this._primitive_computePreBoundsAfter(new _geometry.Matrix());
	  },
	  _primitive_computePreBoundsAfter: function (transform) {
	    // console.log('    <> Shape._primitive_computePreBoundsAfter '+transform.toMatrixString());
	    var shapePen = this._pen;
	    var transformScaleFactor = transform.scaleFactor();
	    var boundsBuilder = new _geometry.BoundsBuilder();
	    var ps = this._polyregions;
	    //_.forEach(ps,function(p) {
	    for (var k = 0, kEnd = ps.length; k < kEnd; ++k) {
	      var p = ps[k];
	      var pen = p.combinedPen(shapePen, true);
	      var bounds = p.boundsAfter(transform).clone();
	      if (pen._width > 0) {
	        // Add half the pen width to each side of the bounds
	        var pwc = 0.5 * (pen._width * transformScaleFactor);
	        bounds.inflate(pwc, pwc);
	      }
	      boundsBuilder.update(bounds);
	    } //);
	    return boundsBuilder.bounds;
	  },
	
	
	  _primitive_computePreMaterialBoundsAfter: function (transform) {
	    // console.log('    <> Shape._primitive_computePreBoundsAfter '+transform.toMatrixString());
	    var shapePen = this._pen;
	    var shapeBrush = this._brush;
	    var transformScaleFactor = transform.scaleFactor();
	    var boundsBuilder = new _geometry.BoundsBuilder();
	    var ps = this._polyregions;
	
	    //_.forEach(ps,function(p){
	    for (var k = 0, kEnd = ps.length; k < kEnd; ++k) {
	      var p = ps[k];
	      var brush = p.combinedBrush(shapeBrush);
	      var pen = p.combinedPen(shapePen, true);
	
	      var realBrush = !(brush._color && brush._color.showThrough);
	      var realPen = pen._width > 0 && !pen._color.showThrough;
	
	      // console.log( realBrush + ' ' + realPen );
	      if (realBrush || realPen) {
	
	        var bounds = p.boundsAfter(transform).clone();
	        if (realPen) {
	          // Add half the pen width to each side of the bounds
	          var pwc = 0.5 * (pen._width * transformScaleFactor);
	          bounds.inflate(pwc, pwc);
	        }
	        boundsBuilder.update(bounds);
	      }
	    } //);
	    return boundsBuilder.bounds;
	  },
	
	  _preparedToDraw: function (zoom) {
	    return (0, _lodash.every)(this.polyregions, function (p) {
	      var brush = p.rwBrush();
	      if ('preparedToDraw' in brush) {
	        // [TODO] Abstract
	        var matrix = p.globalMatrix_(_geometry.Matrix.scale(zoom));
	        var frame = (p.renderFrame || p.initialRenderFrame()).transformed(matrix);
	        return brush.preparedToDraw(zoom, matrix, frame);
	      }
	      return true;
	    });
	  },
	  _prepareToDraw$: function (zoom) {
	    var promises = [];
	    var polyregions = this._polyregions;
	    for (var k = 0, kEnd = polyregions.length; k < kEnd; ++k) {
	      var p = polyregions[k];
	      var brush = p.rwBrush();
	      if ('prepareToDraw$' in brush) {
	        // [TODO] Abstract
	        var matrix = p.globalMatrix_(_geometry.Matrix.scale(zoom));
	        var frame = (p.renderFrame || p.initialRenderFrame()).transformed(matrix);
	        promises.push(brush.prepareToDraw$(zoom, matrix, frame));
	      }
	    }
	    return (0, _gear.whenAll)(promises);
	  },
	  quickToDraw: function () {
	    // We can do something better later here, maybe count points
	    var polyregions = this._polyregions;
	    return polyregions.length === 1 && polyregions[0]._regions.length < 10 && this._powerClipContents.length === 0 && this._brush.quickToDraw() && polyregions[0]._brush.quickToDraw();
	  },
	  processesAreSupported: function () {
	    var _this2 = this;
	
	    var processes = this.processes;
	
	    return processes.length === 0 || (0, _lodash.every)(processes, function (process) {
	      return process.canProcess(_this2);
	    });
	  },
	  canBeProcessedLocally: function () {
	    return this._representationType() === 'local';
	  },
	  fillRuleSupported: function () {
	    if (_config.Helper.isIE_let(10)) {
	      // IE9 and IE10 doesn't support HTML5 Canvas fillRule evenodd
	      var polyregions = this.polyregions;
	
	      for (var k = 0, kEnd = polyregions.length; k < kEnd; ++k) {
	        if (polyregions[k]._fillMode === 'Alternate') {
	          return false;
	        }
	      }
	    }
	    return true;
	  },
	  needsCacheToRender: function () {
	    if (_config.Config.alwaysRenderLocally) {
	      return false;
	    }
	    if (!_config.Config.renderLocallyWhenPossible) {
	      return true;
	    }
	    return !(this.powerClipsLocalRendering() && this.fillRuleSupported());
	  },
	  _representationType: function () {
	    if (_config.Config.alwaysRenderLocally) {
	      return 'local';
	    }
	    if (!_config.Config.renderLocallyWhenPossible) {
	      return 'server';
	    }
	    if (this.processesAreSupported() && this.powerClipsLocalRendering() && this.fillRuleSupported()) {
	      return 'local';
	    } else {
	      return 'server';
	    }
	  },
	  drawForClipping: function (context, transform) {
	    var cps = this._polyregions;
	    for (var k = 0, kEnd = cps.length; k < kEnd; ++k) {
	      var p = cps[k];
	      p.drawForClipping(context, transform);
	    }
	  },
	  _draw: function (context, transform, config) {
	    var overlayedNoClip = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
	
	    if (this.clippingHidden()) {
	      return;
	    }
	    context.save();
	
	    if (!overlayedNoClip) {
	      var _getClippedBy = this.getClippedBy();
	
	      var _getClippedBy2 = _slicedToArray(_getClippedBy, 2);
	
	      var lClipContent = _getClippedBy2[0];
	      var lClipParent = _getClippedBy2[1];
	
	      if (lClipContent) {
	        if (lClipContent.editingClip) {
	          this._draw(context, transform, config, true);
	        }
	        var lOldTransform = transform;
	        if (!lClipContent.clipAbsolute && !lClipContent.editingClip) {
	          transform = _geometry.Matrix.m(transform, lClipParent.globalMatrix_());
	        }
	        lClipContent.clipContext(context, transform);
	        //DEBUG
	        // const ps = lClipContent._polyregions;
	        // for(let k=0,kEnd=ps.length;k<kEnd;++k) { const p = ps[k];
	        //   p.draw(context,transform,config);
	        // }
	        //END DEBUG
	        transform = lOldTransform;
	      }
	    }
	
	    if (overlayedNoClip) {
	      context.globalAlpha = 0.2;
	    }
	    var ps = this._polyregions;
	    //_.forEach(ps,function(p) {
	    for (var k = 0, kEnd = ps.length; k < kEnd; ++k) {
	      var p = ps[k];
	      p.draw(context, transform, config);
	    } //);
	
	    context.restore();
	  },
	
	
	  // The transform argument here is temporal, we need to better managed the cached
	  // geometry information so it is also available for the output figure to use
	  _fineHitTest: function (point, transform, options) {
	    var polyregions = this.polyregions;
	    //_.some(ps,...)
	
	    for (var k = polyregions.length - 1, kEnd = 0; k >= kEnd; --k) {
	      if (polyregions[k].hitTest(point, transform, options)) {
	        if (options) {
	          options.polyregionHit = polyregions[k];
	        }
	        return true;
	      }
	    }
	    return false;
	  },
	
	
	  // [TODO][PROP]
	  powerClip: function (v) {
	    if (v === undefined) {
	      return this._powerClipContents[0];
	    }
	    this.powerClipContents = v;
	    (0, _gear.setForEach)(this.polyregions, 'powerClipId', v.id);
	    return this;
	  },
	  addPowerClipContents: function (v) {
	    var pcContents = this._powerClipContents;
	    var polyregions = this._polyregions;
	    var p = (0, _lodash.findLast)(polyregions, '_powerClipId');
	    if (!p) {
	      (0, _gear.setForEach)(this.polyregions, 'powerClipId', 'PowerClip-0');
	      p = (0, _lodash.last)(polyregions);
	    }
	    var id = p._powerClipId || (0, _lodash.uniqueId)("PC");
	    var pccN = _powerClip.PowerClipContent.createForFigure(id, v, this);
	    var pcc = (0, _lodash.find)(pcContents, '_id', id);
	    if (pcc) {
	      pcc._figures._add(pccN._figures._clear());
	
	      if (this.usingPowerClipLink()) {
	        this.invalidateView();
	      } else {
	        this.invalidate();
	      }
	    } else {
	      pcContents._add(pccN);
	
	      var o = this._outputFigure;
	      if (o && o === this && (0, _lodash.every)(v, function (f) {
	        return !f.needsCacheToRender();
	      })) {
	        this.invalidateView();
	      } else {
	        this.invalidate();
	      }
	    }
	
	    return this;
	  },
	  breakApartPolyregions: function () {
	    var _this = this;
	    var fc = _this.clone();
	    var polyregions = fc._polyregions;
	    // fc.polyregions = [];
	    var prePin = _this._computeInitialPrePin();
	    return (0, _lodash.map)(polyregions, function (p) {
	      var fp = fc.clone();
	      fp.polyregions = [p];
	      fp.anchor = (0, _anchor.AbsoluteAnchor)(prePin); // [TODO] Better anchoring?
	      return fp;
	    });
	  },
	  regroupShapes: function (shapes) {
	
	    var prePin = this._computeInitialPrePin();
	    var this_matrix_inv = this.matrix_().inverted();
	
	    var new_polyregions = (0, _gear.flatMap)(shapes, function (shape) {
	      var matrix = _geometry.Matrix.m(this_matrix_inv, shape.matrix_());
	      return (0, _lodash.map)(shape.polyregions, function (polyregion) {
	        var cp = polyregion.clone();
	        cp.transform(matrix);
	        if (cp._brush._empty) {
	          cp.brush = shape._brush;
	        }
	        if (cp._pen._empty) {
	          cp.pen = shape._pen;
	        }
	        return cp;
	      });
	    });
	
	    this.anchor = (0, _anchor.AbsoluteAnchor)(prePin);
	    this.polyregions = new_polyregions;
	
	    return this;
	  },
	  otherColors: function (colors) {
	    (0, _lodash.forEach)(this.polyregions, function (p) {
	      p.brush.getColors(colors);
	      p.pen.getColors(colors);
	    });
	    return colors;
	  },
	  getPens: function () {
	    var pens = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	
	    // In the special case of shape, an empty pen means no default
	    // The important pens are the ones in the polyregions
	    if (!this._pen.empty()) {
	      pens.push(this._pen);
	    }
	    this._processes.getPens(pens);
	    this.otherPens(pens);
	
	    var pccs = this._powerClipContents;
	    for (var k = 0, kEnd = pccs.length; k < kEnd; ++k) {
	      pccs[k].getPens(pens);
	    }
	
	    var prs = this._polyregions;
	    for (var _k = 0, _kEnd = prs.length; _k < _kEnd; ++_k) {
	      var lPen = prs[_k].pen;
	      if (!lPen.empty()) {
	        pens.push(lPen);
	      }
	    }
	
	    return pens;
	  },
	  getBrushes: function () {
	    var brushes = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	    var forUniqueZones = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	
	    // In the special case of shape, an empty brush means no default
	    // The important brushes are the ones in the polyregions
	    var defaultBrush = this._brush,
	        defaultBrush_empty = defaultBrush._empty;
	
	    var polyregionBrushes = this.otherBrushes([], forUniqueZones);
	
	    var polyregions = this._polyregions;
	
	    var ignoreDefaultBrush = forUniqueZones && (defaultBrush_empty || (0, _lodash.every)(polyregions, paintedPolyregion));
	
	    var ignorePolyregionBrushes = !ignoreDefaultBrush && forUniqueZones && !defaultBrush_empty && !(0, _lodash.some)(polyregions, paintedPolyregion);
	
	    if (!ignoreDefaultBrush) {
	      brushes.push(defaultBrush);
	    }
	
	    this._processes.getBrushes(brushes);
	
	    var powerClipContents = this.powerClipContents;
	
	    for (var k = 0, kEnd = powerClipContents.length; k < kEnd; ++k) {
	      powerClipContents[k].getBrushes(polyregionBrushes, forUniqueZones);
	    }
	
	    if (!ignorePolyregionBrushes) {
	      for (var i = 0, iEnd = polyregionBrushes.length; i < iEnd; ++i) {
	        brushes.push(polyregionBrushes[i]);
	      }
	    }
	
	    return brushes;
	  },
	  otherBrushes: function (brushes, forUniqueZones) {
	    var ps = this._polyregions;
	    //_.forEach(ps,function(p) {
	    for (var k = 0, kEnd = ps.length; k < kEnd; ++k) {
	      var p = ps[k];
	      var brush = p._brush;
	      if (!forUniqueZones || !brush._empty) {
	        brushes.push(brush);
	      }
	    } //);
	    return brushes;
	  },
	  _computeInitialPrePin: function () {
	    var ag = this._anchor;
	    var pos = ag._pos.clone();
	    return ag._absolute ? pos : this._primitive_computePreVectorBounds().interpolate(pos);
	  },
	  powerClipLinkClear: function () {
	    this.callParent();
	    var ps = this._polyregions;
	    //_.forEach(ps,function(p) {
	    for (var k = 0, kEnd = ps.length; k < kEnd; ++k) {
	      ps[k]._powerClipLink = null;
	    } //);
	  },
	  inputPrimitiveFigures$: function () {
	
	    return (0, _gear.resolve)({
	      figures: [this.toGShape()],
	      anchor: this._computeInitialPrePin()
	    });
	  },
	  toPrimitive: function () {
	    var s = this.toGShape();
	    s.transform(this.matrix_(), this._computeInitialPrePin());
	    return s;
	  },
	  canEditContent: function () {
	    return this._processes.length === 0;
	  },
	
	
	  // This is not a good name, it is not including matrix22 and pin
	  // Maybe... preGShape
	  toGShape: function () {
	    var _this = this,
	        this_polyregions = _this._polyregions,
	        powerClipContents = _this._powerClipContents;
	    var frame = _geometry.Frame.fromBounds(_geometry.Bounds.ofThings(this_polyregions));
	    var polyregions = (0, _lodash.map)(this_polyregions, function (p) {
	      var cp = p.clone();
	      if (cp._brush._empty) {
	        cp.brush = _this._brush.clone();
	      }
	      if (cp._pen._empty) {
	        cp.pen = _this._pen.clone();
	      }
	      cp._renderFrame = frame.clone();
	
	      // Keep a PowerClipLink in the polyregion
	      var pcId = p._powerClipId;
	      if (pcId) {
	        var pcContent = (0, _lodash.find)(powerClipContents, { _id: pcId });
	        if (pcContent) {
	          cp._powerClipLink = new _powerClip.PowerClipLink({ content: pcContent });
	        }
	      }
	
	      return cp;
	    });
	    return new GShape({ polyregions: polyregions });
	  }
	});
	
	Shape.parseXml = function (shapeNode, bcFixes) {
	
	  var shape = new Shape();
	
	  _figure.Figure._baseParseXml.call(shape, shapeNode, Shape, bcFixes); // call the parent
	
	  shape.polyregions = _polyregion.Polyregion.listFromXml(shapeNode);
	
	  // Backward compatibility, use unarrange and fillmode at the polyregion level
	  _manageDeprecatedUnarrangedAttr(shape, shapeNode);
	
	  return shape;
	};
	
	Shape.CreateRectangle = function (config) {
	  var center = config.center || (config.bounds ? config.bounds.center : new _geometry.Point(0, 0));
	  var polyregion = _polyregion.Polyregion.CreateRectangle(config);
	  var shape = new Shape({
	    anchor: (0, _anchor.AbsoluteAnchor)(center.clone()),
	    pin: center,
	    polyregions: [polyregion]
	  });
	  config.center = center;
	  return shape;
	};
	
	Shape.CreatePolyline = function (config) {
	  var center = _geometry.Bounds.ofPoints(config.points).center;
	  var polyregion = _polyregion.Polyregion.CreatePolyline(config);
	  var shape = new Shape({
	    anchor: (0, _anchor.AbsoluteAnchor)(center.clone()),
	    pin: center,
	    polyregions: [polyregion]
	  });
	  return shape;
	};
	
	var createFromPolyregions = Shape.createFromPolyregions = function (polyregions, config) {
	  var center = _geometry.Bounds.ofThings(polyregions).center;
	  return Shape((0, _lodash.assign)({
	    polyregions: polyregions,
	    anchor: (0, _anchor.AbsoluteAnchor)(center),
	    pin: center.clone()
	  }, config));
	};
	
	var createFromPolyregion = Shape.createFromPolyregion = function (polyregion, config) {
	  return createFromPolyregions([polyregion], config);
	};
	
	var createFromCurves = Shape.createFromCurves = function (curves, config) {
	  var p = {
	    fillMode: 'Winding',
	    regions: (0, _region.mapCurvesToRegions)(curves)
	  };
	  (0, _lodash.extend)(p, config || {}); // pen and brush
	  return createFromPolyregion((0, _polyregion.Polyregion)(p));
	};
	
	Shape.createFromCurve = function (curve, config) {
	  return createFromCurves([curve], config);
	};
	
	// Internal Shape for processesing
	
	var GShape = exports.GShape = _gear.Base.extend({ typeName: 'GShape',
	
	  Properties: {
	    polyregions: { type: 'Polyregion[]', def: [], owned: true }
	  },
	
	  get isGShape() {
	    return true;
	  },
	
	  transform: function (t, prePin) {
	    // [TODO][PC]
	    var ps = this._polyregions;
	
	    for (var k = 0, kEnd = ps.length; k < kEnd; ++k) {
	      var p = ps[k];
	
	      p.transform(t);
	
	      // This just transforms the power clip link, not the content
	      var powerClipLink = p._powerClipLink;
	      if (powerClipLink && prePin) {
	        var tpp = _geometry.Matrix.m(t, _geometry.Matrix.translate(prePin));
	        powerClipLink.transform(tpp);
	      }
	    }
	  },
	  vectorBounds: function () {
	    return _geometry.Bounds.ofThings(this._polyregions);
	  },
	
	
	  get bounds() {
	    var boundsBuilder = new _geometry.BoundsBuilder();
	    var ps = this._polyregions;
	    for (var k = 0, kEnd = ps.length; k < kEnd; ++k) {
	      var p = ps[k];
	      var bounds = p.bounds;
	      var pen = p.pen;
	      var renderMatrix = p._renderMatrix;
	      var pen_width = pen._width * (renderMatrix ? renderMatrix.scaleFactor() : 1);
	      if (pen_width > 0) {
	        // Add half the pen width to each side of the bounds
	        var pwc = 0.5 * pen_width;
	        bounds.inflate(pwc, pwc);
	      }
	      boundsBuilder.update(bounds);
	    }
	    return boundsBuilder.bounds;
	  },
	
	  removePowerClips: function () {
	    var ps = this._polyregions;
	    for (var k = 0, kEnd = ps.length; k < kEnd; ++k) {
	      var p = ps[k];
	      p._powerClipId = null;
	      p._powerClipLink = null;
	    }
	  },
	  setRenderFrame: function (frame) {
	    var ps = this._polyregions;
	    for (var k = 0, kEnd = ps.length; k < kEnd; ++k) {
	      ps[k]._renderFrame = frame.clone();
	    }
	  },
	  invalidate: function () {
	    // ...
	  }
	});
	
	var toSingleGShape = exports.toSingleGShape = function (figures) {
	  var keepRenderMatrix = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	  var polyregions = [];
	  for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	    var figure = figures[k];
	    if (figure.isGShape) {
	      polyregions = (0, _gear.concat)(polyregions, figure.polyregions);
	    } else {
	      var gs = figure.toGShape();
	      polyregions = (0, _gear.concat)(polyregions, gs.polyregions);
	    }
	  }
	  var lRet = new GShape({ polyregions: polyregions });
	  if (keepRenderMatrix) {
	    for (var c = 0, cEnd = polyregions.length; c < cEnd; ++c) {
	      lRet.polyregions[c].renderMatrix = polyregions[c].renderMatrix;
	    }
	  }
	  return lRet;
	};

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PowerClipLink = exports.PowerClipContent = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	var _geometry = __webpack_require__(21);
	
	var _figure = __webpack_require__(39);
	
	var _processor = __webpack_require__(38);
	
	var PowerClipContent = exports.PowerClipContent = _gear.OwnedObject.extend({ typeName: 'PowerClipContent', __debugProps: true,
	
	  Properties: {
	    id: { type: 'string', def: null },
	    figures: { type: 'Figure[]', def: [], onChange: function () {
	        this.invalidate();
	      }
	    }
	  },
	
	  init: function (c) {
	    this._localId = (0, _lodash.uniqueId)();
	    this._cloneLink = null;
	    this.callParent(c);
	  },
	  clone: function () {
	    var clonedContent = new PowerClipContent({ id: this._id, figures: this._figures.cloneDeep() });
	
	    // This is used by PowerClipLink clone while cloning the output figure
	    // So the links points to the new content
	    this._cloneLink = clonedContent;
	
	    return clonedContent;
	  },
	  update$: function () {
	    return (0, _processor.updateArray$)(this._figures);
	  },
	  transform: function (t) {
	    var figures = this._figures;
	    //_.forEach(this._figures,function(f) {
	    for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	      figures[k].transform(t);
	    } //);
	    return this;
	  },
	  unclippedFigures: function () {
	    var _this = this;
	
	    return (0, _lodash.map)(this.figures, function (f) {
	      return _figure.Figure._ungrouped(f.clone(), _this);
	    });
	  },
	  extractFigures: function () {
	    var figures = this._figures.clear(),
	        owner = this.owner();
	    if (owner) {
	      return (0, _lodash.map)(figures, function (f) {
	        return _figure.Figure._ungrouped(f, owner);
	      });
	    } else {
	      return figures;
	    }
	  },
	  getColors: function () {
	    var colors = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    (0, _lodash.forEach)(this.figures, function (figure) {
	      figure.getColors(colors);
	    });
	    return colors;
	  },
	  getPens: function () {
	    var pens = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    (0, _lodash.forEach)(this.figures, function (figure) {
	      figure.getPens(pens);
	    });
	    return pens;
	  },
	  getBrushes: function () {
	    var brushes = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	    var forUniqueZones = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	    (0, _lodash.forEach)(this.figures, function (figure) {
	      figure.getBrushes(brushes, forUniqueZones);
	    });
	    return brushes;
	  },
	  lock: function (originator) {
	    if (this._owner) {
	      this._owner.lock(originator || this);
	    }
	  },
	  draw: function (context, transform, config) {
	    var figures = this._figures;
	    //_.forEach(this._figures,function(f) {
	    for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	      figures[k].draw(context, transform, config);
	    } //);
	  },
	  add: function (figures) {
	    return this._figures.add(figures);
	  }
	});
	_util.Xml.addFromBuild(PowerClipContent, 'PowerClipContent');
	
	// [TODO] simplify
	PowerClipContent.arrayFromXml = function (node) {
	  var pcNode = _util.Xml.child(node, 'PowerClipContents');
	  if (pcNode) {
	    node = pcNode;
	  }
	  return _util.Xml.getObjectArray(node, PowerClipContent, 'PowerClipContent');
	};
	
	PowerClipContent.arrayBuildXml = function (node, v) {
	  if ((0, _lodash.isEmpty)(v)) {
	    return;
	  }
	  var pcNode = _util.Xml.appendElement(node, 'PowerClipContents');
	  _util.Xml.addObjectArray(pcNode, v);
	};
	
	_util.Xml.Parser['PowerClipContent'] = _util.Xml.makeObjectParser(PowerClipContent);
	_util.Xml.Parser['PowerClipContent[]'] = _util.Xml.makeArrayObjectParser(PowerClipContent);
	
	PowerClipContent.createForFigure = function (id, figures, owner) {
	  //_.forEach(figures,function(f) {
	  for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	    _figure.Figure._group(figures[k], owner);
	  } //);
	  return PowerClipContent({ id: id, figures: figures });
	};
	
	// A PowerClipLink is a reference to a PowerClipContent bundle with a transform matrix
	// It is used to held references in output figures to the actual powerclip content in
	// in the input. This is done to avoid the need to create clones of the powerclip content
	// while processing the input figure, something that can lead to poor performance specially
	// for powerclip content nesteed in groups.
	// The other objective with this abstraction is to avoid the need to reprocess the whole
	// input figure in case something changed in one of the powerclip figures. The only thing
	// that will be invalidated are the powerclips, and the parent figure can just be redraw
	// after that. This is needed to achieve snappy real time edition of powerclip content.
	
	var PowerClipLink = exports.PowerClipLink = _gear.OwnedObject.extend({ typeName: 'PowerClipLink',
	
	  Properties: {
	    content: { type: 'PowerClipContent', def: null, owned: false },
	    matrix: { type: 'Matrix', def: new _geometry.Matrix() }
	  },
	
	  transform: function (t) {
	    this.matrix = _geometry.Matrix.m(t, this.matrix);
	  },
	  clone: function () {
	    var content = this._content,
	        cloneLink = content._cloneLink;
	
	    return new PowerClipLink({
	      content: cloneLink || content,
	      matrix: this._matrix.clone()
	    });
	  }
	});

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fontData = __webpack_require__(51);
	
	Object.keys(_fontData).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _fontData[key];
	    }
	  });
	});
	
	var _font = __webpack_require__(52);
	
	Object.keys(_font).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _font[key];
	    }
	  });
	});
	
	var _properties = __webpack_require__(53);
	
	Object.keys(_properties).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _properties[key];
	    }
	  });
	});
	
	var _textChar = __webpack_require__(54);
	
	Object.keys(_textChar).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _textChar[key];
	    }
	  });
	});
	
	var _textLayout = __webpack_require__(55);
	
	Object.keys(_textLayout).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _textLayout[key];
	    }
	  });
	});
	
	var _autoCreateMultiPart = __webpack_require__(56);
	
	Object.keys(_autoCreateMultiPart).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _autoCreateMultiPart[key];
	    }
	  });
	});
	
	var _multiPart = __webpack_require__(57);
	
	Object.keys(_multiPart).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _multiPart[key];
	    }
	  });
	});
	
	var _text = __webpack_require__(58);
	
	Object.keys(_text).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _text[key];
	    }
	  });
	});
	
	var _monogram = __webpack_require__(60);
	
	Object.keys(_monogram).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _monogram[key];
	    }
	  });
	});

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FontData = exports.Glyph = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _geometry = __webpack_require__(21);
	
	var _window = window;
	var opentype = _window.opentype;
	
	
	var isLower = function (c) {
	  return c >= 'a' && c <= 'z';
	};
	var isUpper = function (c) {
	  return c >= 'A' && c <= 'Z';
	};
	var isAlpha = function (c) {
	  return isLower(c) || isUpper(c);
	};
	
	var computedSlantedAdvance = function (aX, aY, lineDirection) {
	  var dX = Math.abs(lineDirection.x);
	  var dY = Math.abs(lineDirection.y);
	  var phi = Math.atan2(dY, dX);
	  return dX >= dY ? aX / Math.cos(phi) : aY / Math.sin(phi);
	};
	
	var Glyph = exports.Glyph = _gear.Base.extend({ typeName: 'Glyph',
	
	  // [TODO] Use properties
	
	  init: function (char, outlines, bounds, hPos, advanceX, advanceY, originalIdx) {
	    this._char = char;
	    this._outlines = outlines;
	    this._bounds = bounds;
	    this._hPos = hPos;
	    this._advanceX = advanceX;
	    this._advanceY = advanceY;
	    this._originalIdx = originalIdx;
	  },
	  clone: function () {
	    return new Glyph(this._char, (0, _gear.clone)(this._outlines), this._bounds, this._hPos, this._advanceX, this._advanceY, this._originalIdx);
	  },
	  scaled: function (scale) {
	    var outlines = (0, _gear.cloneDeep)(this._outlines);
	    var s = _geometry.Matrix.scale(scale);
	    if (outlines) {
	      (0, _lodash.forEach)(outlines, function (o) {
	        return o.transform(s);
	      });
	    }
	    return new Glyph(this._char, outlines, this._bounds.scalingTransformed(s), this._hPos * scale, this._advanceX * scale, this._advanceY * scale, this._originalIdx);
	  }
	});
	
	// MissingGlyphsBehavior { Skip, UseSpace, UseSquare }
	
	var FontData = exports.FontData = _gear.Base.extend({ typeName: 'FontData',
	
	  Properties: {
	    sizeReferenceChar: { type: 'char', def: 'M' },
	    automaticCaseReplacement: { type: 'boolean', def: true },
	    missingGlyphsBehavior: { type: 'string', def: 'UseSquare' }
	  },
	
	  height: function (scale) {
	    return this._height * scale;
	  },
	  ascent: function (scale) {
	    return this._ascent * scale;
	  },
	  descent: function (scale) {
	    return this._descent * scale;
	  },
	  upperSize: function (scale) {
	    return this._upperSize * scale;
	  },
	  lineSpacing: function (scale) {
	    return this._lineSpacing * scale;
	  },
	  width: function (scale) {
	    return this._width * scale;
	  },
	  spaceWidth: function (scale) {
	    return this._spaceWidth * scale;
	  },
	  spaceHeight: function (scale) {
	    return this._spaceHeight * scale;
	  },
	  sizeOfReferenceChar: function (scale) {
	    return this._sizeOfReferenceChar * scale;
	  },
	
	
	  /*
	  init(  fontInfo, requestedGlyphs ) {
	      this._fontInfo = fontInfo;
	      this._kTable = {};
	    this._glyphs = {};
	    this._glyphsString = "";
	      this.parseInfo(fontInfo,requestedGlyphs);
	      const tm = fontInfo.Metrics;
	      this._referenceSize = tm.RequestedSize || tm.Size;
	      // Parse metrics, we leave them at the reference size to be able to share the
	    // same font for multiple font sizes. The desire size is passed as a parameter when
	    // asked for the metrics
	      this._ascent      = tm.Ascent ;
	    this._descent     = tm.Descent;
	    this._height      = tm.Height ;
	    this._lineSpacing = tm.LineSpacing ;
	      this._width       = tm.AverageWidth;
	      // See http://www.emdpi.com/fontsize.html
	    // Maybe we should find a better name for this property
	    this._upperSize = tm.UpperSize;
	      this._spaceWidth  = tm.SpaceWidth;
	    this._spaceHeight = tm.SpaceHeight;
	      this.initFontData();
	  },
	  */
	
	  // Call after FontData internal properties have been initialized to
	  // compute the sizeOfReferenceChar (used by autoSize=true and some processes)
	  initFontData: function () {
	
	    var sizeOfReferenceChar = void 0;
	    var r = this.findSizeReferenceChar();
	    if (r && r._outlines) {
	      sizeOfReferenceChar = _geometry.Bounds.ofThings(r._outlines).height;
	    } else {
	      var ascent = this._ascent,
	          height = this._height;
	      if (ascent > 0) {
	        sizeOfReferenceChar = ascent;
	      } else if (height > 0) {
	        sizeOfReferenceChar = height * 0.9;
	      } else {
	        sizeOfReferenceChar = this._referenceSize;
	      }
	    }
	
	    this._sizeOfReferenceChar = sizeOfReferenceChar;
	  },
	  findSizeReferenceChar: function () {
	    var glyphs = this._glyphs;
	
	    var lSequenceToAttempt = [this._sizeReferenceChar, // M by default
	    'M', '1', 'A', '2', '3', '4', '5', '6', '7', '8', '9', 'W', 'I', 't', 'j'];
	
	    for (var index = 0; index < lSequenceToAttempt.length; index++) {
	      var lReferenceChar = lSequenceToAttempt[index];
	      var r = glyphs[lReferenceChar];
	      if (r && r._outlines) {
	        return r;
	      }
	    }
	
	    return null;
	  },
	
	
	  // This is scale needs to be given to metrics and createGlyphs
	  // so we can keep only one Font for all sizes and autoSize value
	  scaleForSize: function (desiredSize, autoSize) {
	
	    var referenceSize = autoSize ? this._sizeOfReferenceChar : this._referenceSize;
	
	    return desiredSize / referenceSize;
	  },
	  getKerning: function (a, b) {
	    return this._kTable[a + b] || 0;
	  },
	  createGlyphs: function (text, scale, extraCharSpacing, extraWordSpacing, lineDirection, correctZeroAdvance) {
	
	    this.prepareGlyphs(text); // For fonts that are fully cached in memory
	    var r = [];
	    // Find spacing magnitudes in milimeters
	    var absoluteExtraCharSpacingX = _gear.Magnitude.absoluteMMValueFor(extraCharSpacing, this._spaceWidth * scale),
	        absoluteExtraCharSpacingY = _gear.Magnitude.absoluteMMValueFor(extraCharSpacing, this._spaceHeight * scale),
	        absoluteExtraWordSpacing = _gear.Magnitude.absoluteMMValueFor(extraWordSpacing, this._spaceWidth * scale);
	
	    var length = text.length;
	
	    var hPos = 0,
	        lastChar = ' ',
	        prevWasSpace = false;
	
	    for (var i = 0; i < length; ++i) {
	      var char = text[i];
	      var almostHorizontal = Math.abs(lineDirection.x) > 0.9;
	      var isSpace = char === ' ';
	
	      var glyph = this.createGlyph(char, scale);
	      if (glyph) {
	
	        if (i > 0) {
	
	          if (almostHorizontal) {
	            var kerning = lineDirection.x > 0 ? this.getKerning(lastChar, char) : this.getKerning(char, lastChar);
	            hPos += kerning * scale;
	          }
	
	          if (!(isSpace || prevWasSpace)) {
	            hPos += computedSlantedAdvance(absoluteExtraCharSpacingX, absoluteExtraCharSpacingY, lineDirection);
	          }
	        }
	
	        glyph._hPos = hPos;
	        glyph._originalIdx = i + 1;
	
	        var ax = glyph._advanceX;
	        var ay = glyph._advanceY;
	
	        if (correctZeroAdvance) {
	          if (ax == 0) ax = glyph._bounds.width * 1.05;
	          if (ay == 0) ay = glyph._bounds.height * 1.05;
	        }
	
	        var advance = computedSlantedAdvance(ax, ay, lineDirection);
	
	        if (isSpace) {
	          advance += absoluteExtraWordSpacing;
	          prevWasSpace = true;
	        } else {
	          prevWasSpace = false;
	        }
	
	        hPos += advance;
	
	        r.push(glyph);
	
	        lastChar = char;
	      }
	    }
	    return r;
	  },
	  prepareGlyphs: function () /* chars */{
	    return null; // Default implementation
	  },
	  createGlyph: function (char, scale) {
	
	    var glyphs = this._glyphs;
	    var glyph = glyphs[char];
	
	    // A TTF might have glyphs which are well defined but have no outline. Spaces are the common example, but
	    // a font having just numbers and/or upper case letters will have defined glyphs, with no outline, for the other letters
	    if (!glyph || !glyph._outlines) {
	
	      if (isAlpha(char)) {
	        if (this._automaticCaseReplacement) {
	          var replacementChar = isLower(char) ? char.toUpperCase() : char.toLowerCase();
	
	          glyph = glyphs[replacementChar];
	        }
	      }
	
	      if (char !== ' ' && (!glyph || !glyph._outlines)) {
	
	        switch (this._missingGlyphsBehavior) {
	          case 'Skip':
	            return null;
	          case 'UseSpace':
	            return glyph || this.createDefaultGlyph(char, null, scale);
	          case 'UseSquare':
	            return this.createDefaultGlyph(char, this.createRectangularOutline(scale), scale);
	        }
	      }
	    }
	    return glyph.scaled(scale);
	  },
	  createDefaultGlyph: function (char, outlines, scale) {
	    var width = this.width(scale);
	    return new Glyph(char, outlines, (0, _geometry.Bounds)(0, 0, width, width), 0, width, width, 0);
	  },
	  createRectangularOutline: function (scale) {
	    var width = this.width(scale);
	    var l = width * 0.1;
	    var h = width * 0.9;
	    var box = _geometry.Boundary.createRectangle(new _geometry.Bounds(l, l, h, h));
	    return [box];
	  }
	});
	
	// Opentype.js based FontData
	// Useful resources:
	// https://www.microsoft.com/typography/otspec/os2.htm
	// http://fontforge.github.io/fontinfo.html
	
	var LocalFontData = FontData.extend({ typeName: 'LocalFontData',
	
	  init: function (otFont) {
	
	    this._otFont = otFont;
	
	    // console.log(otFont);
	
	    this._kTable = {};
	    this._glyphs = {};
	    this._glyphsString = "";
	
	    this.parseKerning();
	
	    // Parse needed glyphs for metrics
	    this.parseGlyphs(' MAX');
	
	    // tmSizeInPoints == otFont.unitsPerEm
	
	    // Parse metrics, we leave them at the reference size to be able to share the
	    // same font for multiple font sizes. The desire size is passed as a parameter when
	    // asked for the metrics
	
	    var tables = otFont.tables;
	    var os2 = tables.os2;
	    var hhea = tables.hhea;
	
	
	    var ascent = this._ascent = os2 ? os2.usWinAscent : hhea.ascender;
	    var descent = this._descent = os2 ? os2.usWinDescent : -hhea.descender + hhea.lineGap;
	
	    var height = this._height = ascent + descent; // tm.Height ;
	    this._lineSpacing = height; // tm.LineSpacing ; In the engine these are equal
	
	    var size = this._referenceSize = otFont.unitsPerEm;
	
	    // See http://www.emdpi.com/fontsize.html
	    // Maybe we should find a better name for this property
	    this._upperSize = size - descent; // ascent - internalLeading
	
	    var space = this._glyphs[' '];
	    this._spaceWidth = space._advanceX; // tm.SpaceWidth;
	    this._spaceHeight = space._advanceY; // tm.SpaceHeight;
	
	    this._width = os2 ? os2.xAvgCharWidth : this._spaceWidth; // tm.AverageWidth;
	
	    this.initFontData();
	  },
	  prepareGlyphs: function (chars) {
	    this.parseGlyphs(chars);
	  },
	  parseGlyphs: function (requestedGlyphs) {
	    var _this = this;
	
	    //debugger;
	    var otFont = this._otFont;
	
	    var glyphs = this._glyphs;
	
	    (0, _lodash.forEach)(requestedGlyphs, function (c) {
	      if (!glyphs[c]) {
	
	        var otGlyph = otFont.charToGlyph(c);
	        if (otGlyph) {
	
	          var aX = otGlyph.advanceWidth,
	              aY = otGlyph.advanceHeight,
	              outlines = null,
	              bounds = void 0;
	
	          var otPath = otGlyph.path;
	          var otCommands = otPath.commands;
	
	          if (otCommands.length > 0) {
	            // Looks like there is a bug in opentype.js, we need to force
	            // paths to be closed because there can be missing Z commands
	            // Check the O in Varsity for an example
	            outlines = (0, _geometry.curvesFromSvgPath)(otCommands, { forceClosed: true });
	          }
	
	          if (outlines && outlines.length > 0) {
	            bounds = _geometry.Bounds.ofThings(outlines);
	          } else {
	            outlines = null;
	            bounds = (0, _geometry.Bounds)(0, 0, aX, aY);
	          }
	
	          glyphs[c] = new Glyph(c, outlines, bounds, 0, aX, aY, 0);
	        }
	
	        _this._glyphsString += c;
	      }
	    });
	  },
	  parseKerning: function () {
	    var kTable = this._kTable;
	
	    var otFont = this._otFont;
	    var otKern = otFont.kerningPairs;
	
	    (0, _lodash.forOwn)(otKern, function (kern, ab) {
	      var a_b = ab.split(',');
	      var a = otFont.glyphIndexToName(parseInt(a_b[0]));
	      var b = otFont.glyphIndexToName(parseInt(a_b[1]));
	      kTable[a + b] = parseFloat(kern);
	    });
	  }
	});
	
	var localFontDataStore = {};
	var localFontDataStoreBySrc = {};
	var localFontDataStorePromise = {};
	
	FontData.localLoad$ = function (font, src) {
	  var t = font.textualize();
	
	  var lf = localFontDataStore[t];
	
	  // Collapse font data from the same source, even if they
	  // come from different fonts
	  if (!lf) {
	    lf = localFontDataStoreBySrc[src];
	    if (lf) {
	      localFontDataStore[t] = lf;
	    }
	  }
	
	  if (lf) {
	    return (0, _gear.resolve)(lf);
	  }
	
	  // Check if we are already asking this file, and just
	  // wait for it in that case
	  var promise = localFontDataStorePromise[src];
	  if (promise) {
	    return promise;
	  }
	
	  // Start a new request
	  promise = localFontDataStorePromise[src] = (0, _gear.createPromise)(function (resolve, reject) {
	
	    opentype.load(src, function (err, font) {
	      if (err) {
	        console.log(err.toString());
	        return reject();
	      }
	
	      var lf = localFontDataStoreBySrc[src] = localFontDataStore[t] = new LocalFontData(font);
	
	      // Remove the promise, we are done here
	      delete localFontDataStorePromise[src];
	
	      resolve(lf);
	    });
	  });
	  return promise;
	};

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Font = undefined;
	
	var _config = __webpack_require__(2);
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	var Font = exports.Font = _gear.OwnedObject.extend({ typeName: 'Font',
	
	  Properties: {
	
	    id: { type: 'string', def: null, dropDef: true, tag: 'Guid', onChange: _gear.invalidateOwner },
	
	    name: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	
	    familyName: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    fullName: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    postscriptName: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	
	    weight: { type: 'string', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	
	    isBold: { type: 'boolean', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    isItalic: { type: 'boolean', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    isStrikeout: { type: 'boolean', def: null, dropDef: true, onChange: _gear.invalidateOwner },
	    isUnderline: { type: 'boolean', def: null, dropDef: true, onChange: _gear.invalidateOwner }
	  },
	
	  uiName: function () {
	    return this._fullName || this._familyName || this._postscriptName || this._name || this._id;
	  },
	  textualize: function () {
	    return this.toXmlString();
	  },
	  cache$: function () {
	    var manager = _config.Config.GlobalResourceManager;
	    return manager.loadFontData$(this, '', 'M');
	  },
	  thumbnailUrl: function (config) {
	    return _config.Config.GlobalResourceManager.fontThumbnailUrl(this, config);
	  }
	});
	
	Font.parseXml = function (node) {
	  var p = _util.Xml.parseProperties(node, Font);
	  if (!p.id && !p.fullName && !p.postscriptName && !p.familyName && !p.name) {
	    p.familyName = 'Arial';
	  }
	  return new Font(p);
	};
	
	_util.Xml.addFromBuild(Font, 'Font');
	_util.Xml.addToXml(Font);
	
	Font.fromXmlString = function (xmlString) {
	  var domFigure = _util.Xml.fromString(xmlString);
	  return Font.fromXml(domFigure.documentElement);
	};
	
	Font.defaultFont = function () {
	  return new Font({ familyName: 'Stahls varsity' });
	};

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TextProperties = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	var _figure = __webpack_require__(39);
	
	var _font = __webpack_require__(52);
	
	var def = function (v, d) {
	  return v != null ? v : d;
	};
	var defNum = function (v, d) {
	  return (0, _lodash.isFinite)(v) ? v : d;
	};
	
	var TextProperties = exports.TextProperties = _figure.Figure.TextProperties = _gear.OwnedObject.extend({ typeName: 'TextProperties', __debugProps: true,
	
	  Properties: {
	    font: { type: 'Font', get: function () {
	        return this._font;
	      },
	
	      // [TODO] This shouldn't be needed, clients need to pass font objects
	      set: function (v) {
	        this._font = v instanceof _font.Font ? v.clone() : new _font.Font(v);return this;
	      },
	
	      owned: true, manualParsing: true, onChange: _gear.invalidateOwner },
	    fontSize: { type: 'magnitude', get: function () {
	        return this._fontSize;
	      },
	      manualParsing: true, onChange: _gear.invalidateOwner },
	    fontAutoSize: { type: 'boolean', get: function () {
	        return def(this._fontAutoSize, true);
	      },
	      manualParsing: true, onChange: _gear.invalidateOwner },
	    lineDirection: { type: 'number', get: function () {
	        return defNum(this._lineDirection, 0.0);
	      },
	      onChange: _gear.invalidateOwner },
	    charDirection: { type: 'number', get: function () {
	        return defNum(this._charDirection, 90.0);
	      },
	      onChange: _gear.invalidateOwner },
	    extraCharSpacing: { type: 'magnitude', get: function () {
	        return this._extraCharSpacing || new _gear.Magnitude(0.0, 'mm');
	      },
	      set: function (v) {
	        this._extraCharSpacing = v;
	      },
	      manualParsing: true, onChange: _gear.invalidateOwner },
	    extraWordSpacing: { type: 'magnitude', get: function () {
	        return this._extraWordSpacing || new _gear.Magnitude(0.0, 'mm');
	      },
	      set: function (v) {
	        this._extraWordSpacing = v;
	      },
	      manualParsing: true, onChange: _gear.invalidateOwner },
	    extraLineSpacing: { type: 'magnitude', get: function () {
	        return this._extraLineSpacing || new _gear.Magnitude(0.0, 'mm');
	      },
	      set: function (v) {
	        this._extraLineSpacing = v;
	      },
	      manualParsing: true, onChange: _gear.invalidateOwner },
	    columnSpacing: { type: 'magnitude', get: function () {
	        return this._columnSpacing;
	      },
	      onChange: _gear.invalidateOwner },
	    columnCount: { type: 'integer', get: function () {
	        return defNum(this._columnCount, 1);
	      },
	      onChange: _gear.invalidateOwner },
	    linesPerColumn: { type: 'integer', get: function () {
	        return defNum(this._linesPerColumn, 0);
	      },
	      onChange: _gear.invalidateOwner },
	    linesAlign: { type: 'string', get: function () {
	        return this._linesAlign || 'Center';
	      },
	      onChange: _gear.invalidateOwner },
	    fillMode: { type: 'string', get: function () {
	        return this._fillMode || 'Winding';
	      },
	      onChange: _gear.invalidateOwner },
	    powerClipId: { type: 'string', get: function () {
	        return this._powerClipId;
	      },
	      onChange: _gear.invalidateOwner },
	    verticalStyle: { type: 'string', get: function () {
	        return this._verticalStyle || 'SingleLine';
	      },
	      onChange: _gear.invalidateOwner },
	    perCharPolyregions: { type: 'boolean', get: function () {
	        return def(this._perCharPolyregions, false);
	      },
	      onChange: _gear.invalidateOwner }
	  },
	
	  init: function (c) {
	    this.callParent(c);
	    if (!c.font) {
	      this._font = _font.Font.defaultFont();
	    }
	  },
	  merge: function (defaults) {
	    var _this = this;
	
	    var prop = {};
	    //some stuff is not set on null here, we need to check against default values...
	    (0, _lodash.forEach)(this.Properties, function (p, name) {
	      var m = p.member;
	      prop[name] = def(_this[m], defaults[m]);
	    });
	    if (prop.extraCharSpacing == 0) prop.extraCharSpacing = defaults.extraCharSpacing;
	    if (prop.extraWordSpacing == 0) prop.extraWordSpacing = defaults.extraWordSpacing;
	    if (prop.extraLineSpacing == 0) prop.extraLineSpacing = defaults.extraLineSpacing;
	    if (prop.lineDirection == 0) prop.lineDirection = defaults.lineDirection;
	    if (prop.charDirection == 90) prop.charDirection = defaults.charDirection;
	    if (prop.columnCount == 1) prop.columnCount = defaults.columnCount;
	    if (prop.linesPerColumn == 0) prop.linesPerColumn = defaults.linesPerColumn;
	    if (prop.linesAlign == 'Center') prop.linesAlign = defaults.linesAlign;
	    if (prop.fillMode == 'Winding') prop.fillMode = defaults.fillMode;
	    if (prop.verticalStyle == 'SingleLine') prop.verticalStyle = defaults.verticalStyle;
	    return new TextProperties(prop);
	  },
	  setupXml: function (node) {
	    // For the text properties we should not use defaults, because their presence means
	    // that they should overwrite the parent value.
	    _util.Xml.setupProperties(node, this);
	    var font = this._font,
	        extraCharSpacing = this._extraCharSpacing,
	        extraWordSpacing = this._extraWordSpacing,
	        extraLineSpacing = this._extraLineSpacing,
	        fontSize = this._fontSize,
	        fontAutoSize = this._fontAutoSize;
	
	    var owner = this.owner;
	
	    var fontNotNull = font !== null,
	        extraCharSpacingNotNull = extraCharSpacing !== null && extraCharSpacing != 0,
	        extraWordSpacingNotNull = extraWordSpacing !== null && extraWordSpacing != 0,
	        extraLineSpacingNotNull = extraLineSpacing !== null && extraLineSpacing != 0,
	        fontSizeNotNull = fontSize !== null || owner.isText && !owner.isMultiPart,
	        fontAutoSizeNotNull = fontAutoSize !== null;
	
	    if (fontNotNull || extraCharSpacingNotNull || extraWordSpacingNotNull || extraLineSpacingNotNull || fontSizeNotNull || fontAutoSizeNotNull) {
	      var fontNode = fontNotNull ? font.buildXml(node) : _util.Xml.appendElement(node, 'Font');
	
	      if (fontAutoSizeNotNull) {
	        _util.Xml.setBoolAttr(fontNode, 'AutoSize', fontAutoSize);
	      }
	
	      if (extraCharSpacingNotNull) {
	        if (extraCharSpacing instanceof _gear.Magnitude) fontNode.setAttribute('ExtraCharSpacing', extraCharSpacing.toString());else fontNode.setAttribute('ExtraCharSpacing', new _gear.Magnitude(extraCharSpacing, 'mm').toString());
	      }
	
	      if (extraLineSpacingNotNull) {
	        if (extraLineSpacing instanceof _gear.Magnitude) fontNode.setAttribute('ExtraLineSpacing', extraLineSpacing.toString());else fontNode.setAttribute('ExtraLineSpacing', new _gear.Magnitude(extraLineSpacing, 'mm').toString());
	      }
	
	      if (extraWordSpacingNotNull) {
	        if (extraWordSpacing instanceof _gear.Magnitude) fontNode.setAttribute('ExtraWordSpacing', extraWordSpacing.toString());else fontNode.setAttribute('ExtraWordSpacing', new _gear.Magnitude(extraWordSpacing, 'mm').toString());
	      }
	      // Get default value, to force encoding for single part text
	      if (fontSizeNotNull) {
	        if (fontSize instanceof _gear.Magnitude) fontNode.setAttribute('Size', fontSize.toString());else fontNode.setAttribute('Size', new _gear.Magnitude(fontSize, 'mm').toString());
	      }
	    }
	  }
	});
	
	TextProperties.parseXml = function (node) {
	  var p = _util.Xml.parseProperties(node, TextProperties);
	  p.font = _font.Font.fromXml(node);
	  var fontNode = _util.Xml.child(node, 'Font');
	  if (fontNode) {
	    p.fontSize = _gear.Magnitude.parse(fontNode.getAttribute('Size')) || new _gear.Magnitude(54.2, 'mm'); // Magnitude
	    p.fontAutoSize = _util.Xml.getBoolAttr(fontNode, 'AutoSize', null);
	
	    p.extraCharSpacing = _gear.Magnitude.parse(fontNode.getAttribute('ExtraCharSpacing')); // Magnitude
	    if (p.extraCharSpacing === null) {
	      p.extraCharSpacing = _gear.Magnitude.parse(fontNode.getAttribute('Spacing')) || new _gear.Magnitude(0.0, 'mm'); // Magnitude
	    }
	
	    p.extraWordSpacing = _gear.Magnitude.parse(fontNode.getAttribute('ExtraWordSpacing')) || new _gear.Magnitude(0.0, 'mm'); // Magnitude
	
	    p.extraLineSpacing = _gear.Magnitude.parse(fontNode.getAttribute('ExtraLineSpacing')); // Magnitude
	    if (p.extraLineSpacing === null) {
	      p.extraLineSpacing = _gear.Magnitude.parse(fontNode.getAttribute('LineSpacing')) || new _gear.Magnitude(0.0, 'mm'); // Magnitude
	    }
	  }
	  return new TextProperties(p);
	};

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TextChar = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _geometry = __webpack_require__(21);
	
	var interpolate = _geometry.Point.interpolate;
	
	// engine @ Engine/Figure/TextChar
	
	/* We use directly strings in Javascript, using PIVOT.xxx is not secure anyways
	const PIVOT = {
	  LXLY: 0,
	  MXLY: 1,
	  HXLY: 2,
	  HXMY: 3,
	  HXHY: 4,
	  LXHY: 6,
	  LXMY: 7,
	  LXBY: 9,
	  HXBY: 11,
	  Grip: 12,
	  BottomCenterGrip: 13,
	  TopCenterGrip: 14,
	  MiddleCenterGrip: 15,
	  BaselineCenterGrip: 16,
	  BaselineRightGrip: 17
	};
	*/
	
	var TextChar = exports.TextChar = _gear.OwnedObject.extend({ typeName: 'TextChar',
	
	  Properties: {
	
	    // Quick access to layout information
	    lineIdx: { type: 'integer', def: 0 },
	    idx: { type: 'integer', def: 0 },
	    originalIdx: { type: 'integer', def: 0 },
	
	    // Review, text processes sequences requires charData to not be owned
	    charData: { type: 'TextCharData', def: null, owned: false },
	
	    char: { type: 'char', def: null },
	    bounds: { type: 'Bounds', def: null },
	    grip: { type: 'Point', def: null },
	    bottomCenterGrip: { type: 'Point', def: null },
	    baselineCenterGrip: { type: 'Point', def: null },
	    middleCenterGrip: { type: 'Point', def: null },
	    topCenterGrip: { type: 'Point', def: null },
	    baselineRightGrip: { type: 'Point', def: null },
	    advanceX: { type: 'number', def: 0 },
	    advanceY: { type: 'number', def: 0 },
	    hPos: { type: 'number', def: 0 },
	    originalHPos: { type: 'number', def: 0 }
	  },
	
	  init: function (config) {
	    this._outlines = config.outlines;
	    this._frame = _geometry.Frame.fromBounds(this._bounds);
	  },
	  clone: function () {
	    // console.log('cloning TextChar');
	    var c = new TextChar(this);
	    c._frame = this._frame.clone();
	    c._outlines = (0, _gear.cloneDeep)(this._outlines);
	    return c;
	  },
	
	
	  // [TODO]
	  bearingLX: function () {
	    return this._bounds.lx - this._grip.x;
	  },
	  bearingHX: function () {
	    return this._bounds.hx - this._grip.x;
	  },
	  bearingHY: function () {
	    return this._bounds.hy - this._grip.y;
	  },
	  bearingLY: function () {
	    return this._grip.y - this._bounds.ly;
	  },
	  computedSlantedAdvance: function (lineDirection) {
	    var dx = Math.abs(lineDirection.x),
	        dy = Math.abs(lineDirection.y),
	        phi = Math.atan2(dy, dx);
	
	    return lineDirection.scaled(dx >= dy ? this._advanceX / Math.cos(phi) : this._advanceY / Math.sin(phi));
	  },
	  namedPoint: function (name) {
	    var frame = this._frame;
	    switch (name) {
	      case 'Grip':
	        return this._grip;
	      case 'BottomCenterGrip':
	        return this._bottomCenterGrip;
	      case 'BaselineCenterGrip':
	        return this._baselineCenterGrip;
	      case 'TopCenterGrip':
	        return this._topCenterGrip;
	      case 'MiddleCenterGrip':
	        return this._middleCenterGrip;
	      case 'BaselineRightGrip':
	        return this._baselineRightGrip;
	
	      case 'LXBY':
	        return this._grip.plus(frame.dir_x.sm(this.bearingLX()));
	      case 'HXBY':
	        return this._grip.plus(frame.dir_x.sm(this.bearingHX()));
	
	      case 'LXLY':
	        return frame.p0;
	      case 'HXLY':
	        return frame.p1;
	      case 'HXMY':
	        return interpolate(frame.p1, frame.p2, 0.5);
	      case 'HXHY':
	        return frame.P2;
	      case 'LXHY':
	        return frame.p3;
	      case 'LXMY':
	        return interpolate(frame.p3, frame.p0, 0.5);
	    }
	  },
	
	
	  /* Maybe we do not need this?
	  transform( t ) {
	    this._grip.transform(t);
	      const d = t.decompose();
	    if( d.scaleX != 1.0 || d.scaleY != 1.0 ) {
	      this._hPos     *= d.scaleX;
	      this._advanceX *= d.scaleX;
	      this._advanceY *= d.scaleY;
	    }
	      this.transformGripPoints(t);
	    this.transformShape(t);
	  },
	  */
	
	  transform: function (t) {
	    this.transformShape(t);
	    this.transformGripPoints(t);
	  },
	  displace: function (dx, dy) {
	    var t = _geometry.Matrix.translate(dx, dy);
	    this.transformShape(t);
	    this.transformGripPoints(t);
	  },
	  placeAt: function (pivot, p) {
	    var t = _geometry.Matrix.translate(p.minus(this.namedPoint(pivot)));
	    this.transformShape(t);
	    this.transformGripPoints(t);
	  },
	  scaleAround: function (pivot, sX, sY) {
	    var t = _geometry.Matrix.scaleFrom(this.namedPoint(pivot), sX, sY);
	    this.transformShape(t);
	    this.transformGripPoints(t);
	
	    this._advanceX *= sX;
	    this._advanceY *= sY;
	  },
	  rotateAround: function (pivot, phi) {
	    var t = _geometry.Matrix.rotateAround(this.namedPoint(pivot), phi);
	    this.transformShape(t);
	    this.transformGripPoints(t);
	  },
	  mirrorAround: function (pivot, h, v) {
	    this.scaleAround(pivot, h ? -1 : 1, v ? -1 : 1);
	  },
	  transformGripPoints: function (t) {
	    this._grip.transform(t);
	    this._bottomCenterGrip.transform(t);
	    this._baselineCenterGrip.transform(t);
	    this._middleCenterGrip.transform(t);
	    this._topCenterGrip.transform(t);
	    this._baselineRightGrip.transform(t);
	  },
	  transformShape: function (t) {
	    this._frame.transform(t);
	
	    this._bounds = this._frame.bounds;
	
	    var outlines = this._outlines;
	    if (outlines) {
	      (0, _lodash.invokeMap)(outlines, 'transform', t);
	    }
	  },
	
	
	  // Used by Deform processes (like FitOnEnvelope) so Text tool can track char positions
	  transformBasicPoints: function (t) {
	    this._frame.transform(t);
	    this._bounds = this._frame.bounds;
	    this.transformGripPoints(t);
	  }
	});
	
	TextChar.fromGlyph = function (glyph, lineIdx, idx, charData) {
	
	  var bounds = glyph._bounds,
	      hPos = glyph._hPos,
	      mx = bounds.mx;
	
	  return new TextChar({
	    lineIdx: lineIdx,
	    idx: idx,
	    originalIdx: glyph._originalIdx,
	    charData: charData,
	
	    char: glyph._char,
	    outlines: (0, _gear.cloneDeep)(glyph._outlines),
	    bounds: bounds.clone(),
	    advanceX: glyph._advanceX,
	    advanceY: glyph._advanceY,
	    hPos: hPos,
	    originalHPos: hPos,
	
	    grip: new _geometry.Point(0, 0),
	    bottomCenterGrip: new _geometry.Point(mx, bounds.ly),
	    baselineCenterGrip: new _geometry.Point(mx, 0),
	    middleCenterGrip: new _geometry.Point(mx, bounds.my),
	    topCenterGrip: new _geometry.Point(mx, bounds.hy),
	    baselineRightGrip: new _geometry.Point(bounds.hx, 0)
	  });
	};
	
	// [TODO] This could be simplified
	
	// engine @ Engine/Figure/TextCharTransformations
	// We can represent this transformations with functors to simplify the code
	
	TextChar.Transformer = _gear.OwnedObject.extend({ typeName: 'TextCharTransformer',
	  init: function (t) {
	    this.t = t;
	  },
	  transform: function (char) {
	    char.transform(this.t);
	  },
	  clone: function () {
	    return new TextChar.Transformer(this.t);
	  }
	});
	
	TextChar.Displacer = _gear.OwnedObject.extend({ typeName: 'TextCharDisplacer',
	  init: function (dx, dy) {
	    this.dx = dx;
	    this.dy = dy;
	  },
	  transform: function (char) {
	    char.displace(this.dx, this.dy);
	  },
	  clone: function () {
	    return new TextChar.Displacer(this.dx, this.dy);
	  }
	});
	
	TextChar.TangencialDisplacer = _gear.OwnedObject.extend({ typeName: 'TextCharTangencialDisplacer',
	  init: function (h, v) {
	    this.h = h;
	    this.v = v;
	  },
	  transform: function (char) {
	    var h = this.h,
	        v = this.v;
	    var dirX = char._frame.dir_x;
	    var offset = dirX.scaled(h).plus(dirX.perpendicular().scaled(v));
	    char.displace(offset.x, offset.y);
	  },
	  clone: function () {
	    return new TextChar.TangencialDisplacer(this.h, this.v);
	  }
	});
	
	TextChar.PinPlacer = _gear.OwnedObject.extend({ typeName: 'TextCharPinPlacer',
	  init: function (pivot, pos) {
	    this.pivot = pivot;
	    this.pos = pos;
	  },
	  transform: function (char) {
	    char.placeAt(this.pivot, this.pos);
	  },
	  clone: function () {
	    return new TextChar.PinPlacer(this.pivot, this.pos);
	  }
	});
	
	TextChar.PivotedScaler = _gear.OwnedObject.extend({ typeName: 'TextCharPivotedScaler',
	  init: function (pivot, sx, sy) {
	    this.pivot = pivot;
	    this.sx = sx;
	    this.sy = sy;
	  },
	  transform: function (char) {
	    char.scaleAround(this.pivot, this.sx, this.sy);
	  },
	  clone: function () {
	    return new TextChar.PivotedScaler(this.pivot, this.sx, this.sy);
	  }
	});
	
	TextChar.PivotedRotator = _gear.OwnedObject.extend({ typeName: 'TextCharPivotedRotator',
	  init: function (pivot, phi) {
	    this.pivot = pivot;
	    this.phi = phi;
	  },
	  transform: function (char) {
	    char.rotateAround(this.pivot, this.phi);
	  },
	  clone: function () {
	    return new TextChar.PivotedRotator(this.pivot, this.phi);
	  }
	});
	
	TextChar.PivotedMirrorer = _gear.OwnedObject.extend({ typeName: 'TextCharPivotedMirrorer',
	  init: function (pivot, h, v) {
	    this.pivot = pivot;
	    this.h = h;
	    this.v = v;
	  },
	  transform: function (char) {
	    char.mirrorAround(this.pivot, this.h, this.v);
	  },
	  clone: function () {
	    return new TextChar.PivotedMirrorer(this.pivot, this.h, this.v);
	  }
	});

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TextLayout = exports.TextLine = exports.TextCharData = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _geometry = __webpack_require__(21);
	
	var _shape = __webpack_require__(45);
	
	var _anchor = __webpack_require__(42);
	
	var _powerClip = __webpack_require__(49);
	
	var _textChar = __webpack_require__(54);
	
	// engine @ Engine/Figure/CdlTextBlock
	
	// parentText.CreateTextFigureForPart( textPart ) => text
	// textPart.asTextBlock( parentText ) => text
	
	// InputAnchor {
	//  if( IsSimple ) return SingleInputTextFigure.Anchor ;
	//  else           return base.InputAnchor ;
	//}
	
	
	// engine @ Engine/Figure/TextCharData
	
	var TextCharData = exports.TextCharData = _gear.OwnedObject.extend({ typeName: 'TextCharData',
	
	  init: function () {
	    this._extraKerning = 0;
	    this._transformers = [];
	  },
	  clone: function () {
	    console.log('clone TextCharData');
	    var c = TextCharData();
	    c._extraKerning = this._extraKerning;
	    c._transformers = (0, _gear.cloneDeep)(this._transformers);
	    return c;
	  }
	});
	
	function createTextPolyregion(regions, text) {
	  return new _shape.Polyregion({
	    regions: regions, brush: text._brush, pen: text._pen,
	    powerClipId: text.powerClipId, powerClipLink: text._powerClipLink,
	    fillMode: 'Winding'
	  });
	}
	
	// engine @ Engine/Figure/TextFigure
	// engine @ Engine/Figure/TextLayout
	// engine @ Engine/Figure/TextLine
	
	var TextLine = exports.TextLine = _gear.OwnedObject.extend({ typeName: 'TextLine',
	
	  init: function (chars, baseline) {
	    this._chars = chars;
	    this._baseline = baseline;
	
	    var bounds = this.bounds;
	    if (bounds) {
	      bounds.ly = baseline.P0.y;
	
	      this._ascentFrame = _geometry.Frame.fromBounds(bounds);
	      // this._stableFrame =
	    } else {
	      this._ascentFrame = null;
	    }
	  },
	  clone: function () {
	    var c = new TextLine();
	    c._chars = (0, _gear.cloneDeep)(this._chars);
	    c._baseline = (0, _gear.cloneDeep)(this._baseline);
	    c._ascentFrame = (0, _gear.clone)(this._ascentFrame);
	    return c;
	  },
	  transformBasicPoints: function (t) {
	    (0, _lodash.forEach)(this._chars, function (c) {
	      c.transformBasicPoints(t);
	    });
	    this._baseline.transform(t);
	  },
	  transform: function (t) {
	    (0, _lodash.forEach)(this._chars, function (c) {
	      c._charData._transformers.push(new _textChar.TextChar.Transformer(t));
	      c.transform(t);
	    });
	    this._baseline.transform(t);
	  },
	  bearingLX: function () {
	    var fc = this._chars[0];
	    return fc ? fc.bearingLX() : 0;
	  },
	
	
	  get bounds() {
	    var regions = this.regions;
	    return regions.length > 0 ? _geometry.Bounds.ofThings(regions) : null;
	  },
	
	  // Return nulls in the glyphs that are not found in the font
	  allChars: function () {
	    var ac = [];
	    var chars = this._chars;
	    for (var k = 0, kEnd = chars.length; k < kEnd; ++k) {
	      var ck = chars[k];
	
	      var missing = ck._originalIdx - 1 - ac.length;
	      while (missing > 0) {
	        ac.push(null);
	        missing--;
	      }
	      ac.push(chars[k]);
	    }
	    return ac;
	  },
	
	
	  get regions() {
	    var regions = [];
	    (0, _lodash.forEach)(this._chars, function (char) {
	      (0, _lodash.forEach)(char._outlines, function (o) {
	        regions.push(new _shape.Region([o.clone()]));
	      });
	
	      /*
	      if( char._shape ) {
	        _.forEach( char._shape._multiregions, mr => {
	          _.forEach( mr._regions, r => {
	            regions.push( r.clone() );
	          });
	        });
	      }
	      */
	    });
	    return regions;
	  },
	
	  polyregion: function (text) {
	    var regions = this.regions;
	    if (regions.length === 0) {
	      return null;
	    }
	
	    var mr = createTextPolyregion(regions, text);
	
	    mr._renderFrame = _geometry.Frame.fromBounds(mr.bounds);
	    return mr;
	  },
	  perCharPolyregions: function (text) {
	
	    var polyregions = [];
	
	    (0, _lodash.forEach)(this._chars, function (char) {
	
	      var regions = [];
	      (0, _lodash.forEach)(char._outlines, function (o) {
	        regions.push(new _shape.Region([o.clone()]));
	      });
	
	      if (regions.length > 0) {
	        polyregions.push(createTextPolyregion(regions, text));
	      }
	    });
	    return polyregions;
	  }
	});
	
	var TextLayout = exports.TextLayout = _gear.OwnedObject.extend({ typeName: 'TextLayout',
	
	  get isTextLayout() {
	    return true;
	  },
	
	  init: function (text) {
	    this._text = text;
	
	    // Dictionary LineIdx,CharId => CharData
	    this._charData = { 0: {} };
	
	    this._textLines = null; // array of TextLine
	
	    this._transform = new _geometry.Matrix();
	  },
	  clone: function () {
	    var tf = new TextLayout();
	
	    var rep = this._textLines;
	    tf._textLines = rep ? (0, _gear.cloneDeep)(rep) : null;
	
	    tf._charData = (0, _gear.cloneDeep)(this._charData);
	
	    tf._transform = this._transform.clone();
	
	    return tf;
	  },
	  charData: function (lineIdx, charIdx) {
	    var charData = this._charData;
	    var entry = charData[lineIdx];
	    if (!entry) {
	      entry = charData[lineIdx] = {};
	    }
	    var cd = entry[charIdx];
	    if (!cd) {
	      cd = entry[charIdx] = new TextCharData();
	    }
	    return cd;
	  },
	
	
	  get text() {
	    return this._text;
	  },
	
	  get polyregions() {
	    var text = this._text;
	
	    var polyregions = [];
	    (0, _lodash.forEach)(this.textLines(), function (textLine) {
	      if (text.perCharPolyregions) {
	        polyregions = (0, _gear.concat)(polyregions, textLine.perCharPolyregions(text));
	      } else {
	        polyregions.push(textLine.polyregion(text));
	      }
	    });
	
	    polyregions = (0, _lodash.compact)(polyregions);
	
	    var transform = this._transform;
	    if (!transform.isIdentity()) {
	      (0, _lodash.invokeMap)(polyregions, 'transform', transform);
	    }
	
	    return polyregions;
	  },
	
	  shape: function () {
	    // console.log('>> shape');
	    var textLines = this.textLines(),
	        text = this._text;
	    if (textLines.length > 0) {
	      var shape = (0, _shape.Shape)({ polyregions: this.polyregions });
	
	      shape.anchor = (0, _anchor.AbsoluteAnchor)(this.prePin());
	      shape.alpha = text.alpha;
	      return shape;
	    } else {
	      return text.createEmptyOutput();
	    }
	  },
	  toGShape: function () {
	    var text = this._text,
	        powerClipContents = text._powerClipContents;
	    var polyregions = this.polyregions;
	    (0, _lodash.forEach)(polyregions, function (p) {
	      var pcId = p._powerClipId;
	      if (pcId && !p._powerClipLink) {
	        var pcContent = (0, _lodash.find)(powerClipContents, { _id: pcId });
	        if (pcContent) {
	          p._powerClipLink = new _powerClip.PowerClipLink({ content: pcContent });
	        }
	      }
	    });
	    return new _shape.GShape({ polyregions: polyregions });
	  },
	  prePin: function () {
	    // We need to discuss if this is the best way to define the text anchor
	    var textLines = this.textLines(),
	        text = this._text;
	    var anchorLine = (0, _lodash.find)(textLines, '_ascentFrame');
	    if (anchorLine) {
	      return text._anchor.of(anchorLine._ascentFrame);
	    } else {
	      return new _geometry.Point(0, 0);
	    }
	  },
	  spaceWidth: function () {
	    return this._text.spaceWidth_();
	  },
	  ascent: function () {
	    return this._text.ascent_();
	  },
	  descent: function () {
	    return this._text.descent_();
	  },
	  sizeOfReferenceChar: function () {
	    return this._text.sizeOfReferenceChar_();
	  },
	  isWidthwise: function () {
	    return this._text.isWidthwise();
	  },
	  pivot: function () {
	    var eld = this._text.effectiveLineDirection();
	    return Math.abs(eld.x) >= Math.abs(eld.y) ? eld.x > 0 ? 'Grip' : 'BaselineRightGrip' : eld.y > 0 ? 'BottomCenterGrip' : 'TopCenterGrip';
	  },
	  invalidate: function () {
	    this._textLines = null;
	  },
	  textLines: function () {
	    if (!this._textLines) {
	      this._textLines = this.createTextLines();
	    }
	    return this._textLines;
	  },
	  charAt: function (lineIdx, idx) {
	    var textLines = this.textLines();
	    if (lineIdx >= 1 && lineIdx <= textLines.length) {
	      var lineChars = textLines[lineIdx - 1]._chars;
	      if (idx >= 1 && lineIdx <= lineChars.length) {
	        return lineChars[idx - 1];
	      }
	    }
	    return null;
	  },
	  createChars: function () {
	    var _this = this,
	        text = _this._text,
	        fontData = text._fontData,
	        glyphs = [];
	
	    var lines = [];
	
	    var text_lines = text._fontDataLines; // Used a cached version of the lines
	    if (text.doMultilineVerticalText()) {
	      var singleVerticalLine = text_lines[0];
	      (0, _lodash.forEach)(singleVerticalLine, function (char) {
	        lines.push(char);
	      });
	    } else {
	      lines = text_lines;
	    }
	
	    var maxLineLength = 0;
	
	    (0, _lodash.forEach)(lines, function (lineString) {
	
	      if (lineString.length > 0) {
	        var lineGlyphs = fontData.createGlyphs(lineString, text.fontDataScale_(), text.extraCharSpacing, text.extraWordSpacing, text.effectiveLineDirection(), text.correctZeroAdvance());
	
	        if (lineGlyphs.length > 0) {
	          var lastGlyph = (0, _lodash.last)(lineGlyphs);
	          var thisLineLength = lastGlyph._hPos + lastGlyph._advanceX;
	          if (thisLineLength > maxLineLength) {
	            maxLineLength = thisLineLength;
	          }
	        }
	        glyphs.push(lineGlyphs);
	      } else {
	        // Empty line
	        glyphs.push([]);
	      }
	    });
	
	    var linesAlign = text.linesAlign;
	    if (glyphs.length > 1 && linesAlign !== 'Left') {
	      (0, _lodash.forEach)(glyphs, function (lineGlyphs) {
	        if (lineGlyphs.length > 0) {
	          (function () {
	            var lastGlyph = (0, _lodash.last)(lineGlyphs);
	            var lineLength = lastGlyph._hPos + lastGlyph._advanceX;
	            var maxLineDiff = maxLineLength - lineLength;
	
	            var offset = linesAlign === 'Center' ? maxLineDiff / 2 : linesAlign === 'Right' ? maxLineDiff : 0;
	
	            (0, _lodash.forEach)(lineGlyphs, function (glyph) {
	              glyph._hPos += offset;
	            });
	          })();
	        }
	      });
	    }
	
	    // Maybe we can fusion glyph and TextChar
	    var chars = [];
	    (0, _lodash.forEach)(glyphs, function (thisLineGlyphs, ln) {
	      var thisLineChars = [];
	      chars.push(thisLineChars);
	      var lineIdx = ln + 1;
	      (0, _lodash.forEach)(thisLineGlyphs, function (glyph, cn) {
	        var idx = cn + 1;
	        thisLineChars.push(_textChar.TextChar.fromGlyph(glyph, lineIdx, idx, _this.charData(lineIdx, idx)));
	      });
	    });
	    return chars;
	  },
	  createTextLines: function () {
	    var _this = this,
	        chars = _this.createChars(),
	        text = _this._text,
	        fontData = text._fontData,
	        fontDataScale = text.fontDataScale_();
	
	    var effectiveExtraLineSpacing = text.effectiveExtraLineSpacing_(),
	        effectiveLinesPerColumn = text.effectiveLinesPerColumn(chars.length),
	        effectiveLineDirection = text.effectiveLineDirection(),
	        absoluteColumnSpacing = text.columnSpacing ? _gear.Magnitude.absoluteMMValueFor(text.columnSpacing, fontData.spaceWidth(fontDataScale)) : 0,
	        pivot = _this.pivot();
	
	    var lineIndexInColumn = 0,
	        baselineS = new _geometry.Point(0, 0),
	        nextColumnBaselineS = new _geometry.Point(0, 0),
	        nextLineV = effectiveLineDirection.perpendicular(-1).sm(fontData.lineSpacing(fontDataScale) + effectiveExtraLineSpacing);
	
	    var lines = [];
	
	    (0, _lodash.forEach)(chars, function (charsInThisLine, ln) {
	      var lineIdx = ln + 1;
	      if (charsInThisLine.length > 0) {
	        (function () {
	
	          var accExtrakerning = 0;
	          (0, _lodash.forEach)(charsInThisLine, function (char, cn) {
	            var idx = cn + 1;
	            var data = _this.charData(lineIdx, idx);
	
	            var extrakerning = data._extraKerning;
	            var newHPos = char._originalHPos + accExtrakerning + extrakerning;
	            char.placeAt(pivot, baselineS.plus(effectiveLineDirection.scaled(newHPos)));
	            char._hPos = newHPos;
	
	            (0, _lodash.forEach)(data._transformers, function (tct) {
	              tct.transform(char);
	            });
	
	            accExtrakerning += extrakerning;
	          });
	
	          var lastChar = (0, _lodash.last)(charsInThisLine);
	
	          var baselindeT = lastChar.namedPoint(pivot).plus(lastChar.computedSlantedAdvance(effectiveLineDirection));
	
	          var baseline = new _geometry.Segment(baselineS.clone(), baselindeT);
	
	          if (lineIndexInColumn === 0) {
	            nextColumnBaselineS = baselindeT.clone();
	          }
	
	          if (baselindeT.x > nextColumnBaselineS.x) {
	            nextColumnBaselineS.x = baselindeT.x;
	          }
	
	          lines.push(new TextLine(charsInThisLine, baseline));
	        })();
	      } else {
	        lines.push(new TextLine([], new _geometry.Segment(baselineS.clone(), baselineS.plus(effectiveLineDirection))));
	      }
	
	      ++lineIndexInColumn;
	
	      if (effectiveLinesPerColumn !== null && lineIndexInColumn >= effectiveLinesPerColumn) {
	        lineIndexInColumn = 0;
	        baselineS = nextColumnBaselineS.plus(effectiveLineDirection.scaled(absoluteColumnSpacing));
	      } else {
	        baselineS = baselineS.plus(nextLineV);
	      }
	    });
	
	    return lines;
	  },
	  transformBasicPoints: function (t) {
	    (0, _lodash.forEach)(this.textLines(), function (line) {
	      line.transformBasicPoints(t);
	    });
	  },
	
	
	  // [IMPORTANT]
	  // This function is only used by pretransform, and is a copy of what the engine does
	  // The pre transform is not really applied before all the processes, but after the ones
	  // that output texts (FitOnPath, BookEnd, etc).
	  // So this transform is kept and is applied when toGShape is called
	  // This actually breaks when using PreTransform and FitOnPath.
	  // We should fix this, but I do not know if we should care about a feature that is
	  // not well defined and is not exposed in current designers
	  transform: function (t) {
	    this._transform = _geometry.Matrix.m(t, this._transform);
	  }
	});

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.autoCreateMultiPartText$ = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _geometry = __webpack_require__(21);
	
	var _style = __webpack_require__(29);
	
	var _process = __webpack_require__(40);
	
	var _anchor = __webpack_require__(42);
	
	var _figure = __webpack_require__(39);
	
	var _figures = __webpack_require__(43);
	
	var _processor = __webpack_require__(38);
	
	var _multiPart = __webpack_require__(57);
	
	// Given a list of texts, combine them to create a multipart text.
	// The phrase is given by the order of the parts. If two parts have the same line
	// and they are overlapping, they are consider a shadow or contour effect.
	// If one of the texts is already multipart, then its phrase will be used
	// Calls callback.call(scope,multiPartText)
	
	var autoCreateMultiPartText$ = exports.autoCreateMultiPartText$ = function (figures, parentMatrix22, parentPin) {
	
	  // Separte multipart texts [TODO] flatMap
	  var texts = [];
	  (0, _lodash.forEach)((0, _lodash.filter)(figures, 'isText'), function (t) {
	    if (t.isMultiPart) {
	      texts = (0, _gear.concat)(texts, t.breakIntoParts());
	    } else {
	      texts.push(t);
	    }
	  });
	
	  return (0, _processor.updateArray$)(texts).then(function () {
	
	    if (texts.length === 0) {
	      return null;
	    }
	    if (texts.length === 1) {
	      return texts[0].clone();
	    }
	
	    // We have at least two figures to dealt with
	
	    _figures.Figures.lock(texts);
	
	    var textParts = (0, _lodash.map)(texts, function (text) {
	      return { figure: text, frame: text.vectorFrame_() };
	    });
	
	    var composedTransform = parentMatrix22 || _figures.Figures.composedIsometricMatrix22(texts);
	    var composedPinPos = parentPin || _figures.Figures.meanPin(texts);
	
	    // Transform the frames so we allow the user to feed us with transformed text chains
	    var inverseComposedTransform = _geometry.Matrix.invert(composedTransform);
	    (0, _lodash.forEach)(textParts, function (t) {
	      t.frame.transform(inverseComposedTransform);
	      t.pos = t.frame.interpolate({ x: 0.5, y: 0.5 });
	    });
	
	    // Find the composedLine and basic ranges checking if the parts are duplicates
	    // or sequences of texts
	    var composedLine = '';
	
	    // Sort the parts horizontally, we ignore Z order
	
	    var sortedTextParts = textParts.slice(0); // clone only the array, not the contents
	    sortedTextParts.sort(function (a, b) {
	      return a.pos.x - b.pos.x;
	    });
	
	    var areSequenced = function (current, prev) {
	      var haveSameLine = current.figure.text === prev.figure.text;
	      var overlapPercentage = _geometry.Bounds.horizontalOverlapPercentage(current.frame.bounds, prev.frame.bounds);
	      // Frame.overlapPercentage(current.frame,prev.frame);
	      var areOverlapping = overlapPercentage > 0.5;
	      return !(haveSameLine && areOverlapping);
	    };
	
	    var allLinesAreEqual = true;
	    (0, _lodash.forEach)(sortedTextParts, function (current, k) {
	      if (k > 0 && current.figure.text !== sortedTextParts[k - 1].figure.text) {
	        allLinesAreEqual = false;
	      }
	    });
	
	    var rangeStart = 1;
	    (0, _lodash.forEach)(sortedTextParts, function (current, k) {
	      var sequenced = k > 0 && !allLinesAreEqual && areSequenced(current, sortedTextParts[k - 1]);
	      if (sequenced) {
	        var prevLine = sortedTextParts[k - 1].figure.text;
	        rangeStart += prevLine.length;
	        composedLine += prevLine;
	      }
	      var currentLine = current.figure.text;
	      current.range = new _multiPart.TextRange({ start: rangeStart, end: rangeStart + currentLine.length });
	    });
	    var lastPart = sortedTextParts[sortedTextParts.length - 1];
	    var lastLine = lastPart.figure.text;
	    composedLine += lastLine;
	
	    // We need to correct the ranges so they will work later when the user change the line
	    // with one of a different size.
	    // If the last part only has one letter, we consider it a bookend effect
	    // The range of the last letter will be {-1,0} so it always matches only the last one
	    var bookendEffect = composedLine.length >= 3 && lastLine.length === 1;
	    if (bookendEffect) {
	      (0, _lodash.forEach)(textParts, function (t) {
	        if (t.range.end - 1 === composedLine.length) {
	          t.range = _multiPart.TextRange.LastLetter();
	        } else if (t.range.end === composedLine.length) {
	          t.range.end = -1;
	
	          // For the middle range, we apply the same technique that TX was using in their
	          // templates: adding an stretching envelope to force the content to fit the
	          // current space. This will make the multipart text look good when the user
	          // will select another phrase.
	          var processes = t.figure._processes;
	          var process = (0, _gear.findByType)(processes, _process.Process.FitEnvelope);
	          if (!process) {
	            process = _process.Process.FitEnvelope.createFromFigure(t.figure);
	            processes.add(process);
	            t.figure._fixUpPin$('getFirstEnvelopePoint');
	            // This is an async operation, see comment [*] below
	          }
	        }
	      });
	    } else {
	      // Set to match til the end of the line
	      (0, _lodash.forEach)(textParts, function (t) {
	        if (t.range.end - 1 === composedLine.length) {
	          t.range.end = 0;
	        }
	      });
	    }
	
	    // The order of the textParts must not be changed to respect the user Z order
	    return _figure.Figure.createMultiPartText(composedLine, composedTransform, composedPinPos, textParts);
	  });
	};
	
	// Given a line, a transform, a pinPos and a list of {figure,range} its creates a
	// multipart text
	_figure.Figure.createMultiPartText = function (line, matrix22, pin, figureParts) {
	  var textParts = (0, _lodash.map)(figureParts, function (fp) {
	    return _multiPart.TextPart.createFromText(fp.figure, fp.range, matrix22, pin);
	  });
	  return _figure.Figure.Text({
	    brush: _style.Brush.empty,
	    pen: _style.Pen.empty,
	    text: line,
	    anchor: (0, _anchor.AbsoluteAnchor)(new _geometry.Point(0, 0)),
	    matrix22: matrix22,
	    pin: pin,
	    textParts: textParts
	  });
	};

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TextPart = exports.TextRange = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	var _geometry = __webpack_require__(21);
	
	var _style = __webpack_require__(29);
	
	var _process = __webpack_require__(40);
	
	var _processes = __webpack_require__(41);
	
	var _figure = __webpack_require__(39);
	
	var _anchor = __webpack_require__(42);
	
	var _properties = __webpack_require__(53);
	
	/// <summary>
	/// Two indices that denote a substring from an arbitrary-length string.
	/// Positive indices start from 1 to indicate a position left-to-right.
	///   For example, 2 in "abcd" indicates the 'b'.
	/// Negative indices start from -1 to indicate a position right-to-left.
	///   For example, -2 in "abcd" indicates the 'c'.
	/// The value of 0 is reserved to indicate one position past the end of the string.
	/// The two indices denote an open interval, thus:
	///
	///   TextRange(1,0).slice("abcd") == "abcd"
	///   TextRange(1,0).slice("abcdefg") == "abcdefg"
	///   TextRange(1,0).slice("abcd") == "abc"
	///   TextRange(1,-1).slice("abcdefg") == "abcdef"
	///   TextRange(-3,0).slice("abcd") == "bcd"
	///   TextRange(-3,0).slice("abcdefg") == "efg"
	///   TextRange(-3,-2).slice("abcd") == "b"
	///   TextRange(-4,-2).slice("abcdefg") == "de"
	///
	/// If the second index corresponds to a position that is not past the first index,
	/// the range represents an empty string:
	///
	///   TextRange(3,3).slice("abcd") == ""
	///   TextRange(3,2).slice("abcd") == ""
	///   TextRange(-3,-3).slice("abcd") == ""
	///   TextRange(-3,-4).slice("abcd") == ""
	///
	/// If the first index corresponds to a position outside the string,
	/// the range represents an empty string:
	///
	///   TextRange(5,0).slice("abcd") == ""
	///   TextRange(1000,0).slice("abcd") == ""
	///
	/// If the second index corresponds to a position outside the string,
	/// it indicates the one position right past the end of the string,
	/// so it becomes equivalent to the value 0
	///
	///   TextRange(1,0).slice("abcdefg") == "abcdefg"
	///   TextRange(1,8).slice("abcdefg") == "abcdefg"
	///   TextRange(1,9).slice("abcdefg") == "abcdefg"
	///   TextRange(1,1000).slice("abcdefg") == "abcdefg"
	/// </summary>
	
	var TextRange = exports.TextRange = _figure.Figure.TextRange = _gear.OwnedObject.extend({ typeName: 'TextRange', __debugProps: true,
	
	  init: function () {
	    var p = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    this.callParent();
	    this.start = p.start || 1;
	    this.end = p.end || 0;
	  },
	  slice: function (string) {
	    var len = string.length,
	        start = this.start,
	        end = this.end;
	
	    var from = start < 0 ? Math.max(0, len + start) : start > 0 ? Math.min(start - 1, len - 1) : 0;
	
	    var to = end < 0 ? Math.max(1, len + end) : end > 0 ? Math.min(end - 1, len) : len;
	
	    return to - from > 0 ? string.substring(from, to) : '';
	  },
	  setupXml: function (node) {
	    var rangeString = this.start + ' ' + this.end;
	    node.setAttribute('TextRange', rangeString);
	  },
	  clone: function () {
	    return new TextRange({ start: this.start, end: this.end });
	  },
	  isEqual: function (other) {
	    return this.start === other.start && this.end === other.end;
	  }
	});
	
	TextRange.parseXml = function (node) {
	  var rangeString = node.getAttribute('TextRange');
	  return TextRange.parseXmlString(rangeString);
	};
	TextRange.parseXmlString = function (string) {
	  var p = {};
	  if (string) {
	    var l = string.split(' ');
	    p.start = parseInt(l[0]);
	    p.end = parseInt(l[1]);
	  }
	  return new TextRange(p);
	};
	TextRange.LastLetter = function () {
	  return new TextRange({ start: -1, end: 0 });
	};
	
	_util.Xml.Parser['TextRange'] = _util.Xml.makeAttrParser(TextRange);
	
	var textPartPowerClipLink = function (textPart, parent) {
	  /*
	  const prePin = parent._computeInitialPrePin();
	  const figureMatrix =  parent._computeMatrix(prePin);
	  const cm = Mx.multiply( parentMatrix, figureMatrix );
	  const pcMatrix = Mx.multiply(cm,Mx.translate(prePin));
	  */
	
	  var powerClipContents = parent.powerClipContents;
	  var powerClipLink = parent.powerClipLink;
	
	
	  if (powerClipLink) {
	    // console.log('Transform PC-Link: ' + pcMatrix.textualize() + ' , prePin: ' + prePin.textualize() );
	    return powerClipLink.clone();
	  } else {
	    var powerClipId = textPart.powerClipId;
	
	    if (powerClipId) {
	      var pcContent = (0, _lodash.find)(powerClipContents, { id: powerClipId });
	      if (pcContent) {
	        // console.log('Build PC-Link: ' + pcMatrix.textualize() + ' , prePin: ' + prePin.textualize() );
	        return new _gear.Base.Type.PowerClipLink({ content: pcContent });
	      }
	    }
	  }
	};
	
	// TextPart
	//----------------------------------------------------------------------------------------
	
	var TextPart = exports.TextPart = _figure.Figure.TextPart = _gear.OwnedObject.extend((0, _gear.forwardPropertiesFrom)(_properties.TextProperties, 'properties', { typeName: 'TextPart', __debugProps: true,
	
	  Properties: {
	    pen: { type: 'Pen', def: _style.Pen.empty, owned: true, onChange: _gear.invalidateOwner },
	    brush: { type: 'Brush', def: _style.Brush.empty, owned: true, onChange: _gear.invalidateOwner },
	    anchor: { type: 'Anchor', def: new _anchor.AnchorGenerator(), owned: true, onChange: _gear.invalidateOwner },
	    preMatrix22: { type: 'Matrix22', def: new _geometry.Matrix(), manualParsing: true, onChange: _gear.invalidateOwner },
	    matrix22: { type: 'Matrix22', def: new _geometry.Matrix(), manualParsing: true, onChange: _gear.invalidateOwner },
	    textRange: { type: 'TextRange', def: new TextRange(), owned: true, onChange: _gear.invalidateOwner },
	    processes: { type: 'Process[]', def: [], owned: true,
	      onChange: _gear.invalidateOwner, array: _processes.Processes },
	    properties: { type: 'TextProperties', owned: true, def: null, manualParsing: true, onChange: _gear.invalidateOwner }
	  },
	
	  get pin() {
	    return this._pin.getPos();
	  },
	  set pin(pin_) {
	    this._pin = this._pin.cloneElsewhere(pin_);
	  },
	
	  translate: function (x, y) {
	    var p = y === undefined ? x : new _geometry.Point(x, y);
	    this.pin = this.pin.plus(p);
	    return this;
	  },
	
	
	  // [TODO] Once pin is simplified, this will be the standard clone
	  clone: function () {
	    return new TextPart({
	      pen: this._pen.clone(),
	      brush: this._brush.clone(),
	      anchor: this._anchor.clone(),
	      preMatrix22: this._preMatrix22.clone(),
	      matrix22: this._matrix22.clone(),
	      textRange: this._textRange.clone(),
	      processes: this._processes.cloneDeep(),
	      properties: this._properties.clone(),
	      pin: this._pin.clone()
	    });
	  },
	  outputsText: function () {
	    return true;
	  },
	  getColors: function () {
	    var colors = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    this._brush.getColors(colors);
	    this._pen.getColors(colors);
	    this._processes.getColors(colors);
	    return colors;
	  },
	  getPens: function () {
	    var pens = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    pens.push(this._pen);
	    this._processes.getPens(pens);
	    return pens;
	  },
	  getBrushes: function () {
	    var brushes = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    brushes.push(this._brush);
	    this._processes.getBrushes(brushes);
	    return brushes;
	  },
	  mergedProperties: function (parent) {
	    return {
	      text: this._textRange.slice(parent.text),
	      properties: this._properties.merge(parent._properties),
	      brush: _style.Brush.def(this._brush, parent._brush),
	      pen: _style.Pen.def(this._pen, parent._pen),
	      processes: (0, _gear.cloneDeep)(this._processes),
	      anchor: this._anchor.clone(),
	      preMatrix22: this._preMatrix22.clone()
	    };
	  },
	  preText: function (parent) {
	    var p = this.mergedProperties(parent);
	    p.matrix22 = this.matrix22;
	    p.pin = this.pin;
	    p.powerClipLink = textPartPowerClipLink(this, parent);
	    return new _figure.Figure.Text(p);
	  },
	  asTextBlock: function (parent) {
	
	    var p = this.mergedProperties(parent);
	
	    // We partially support parents effects like Shadow and Contour
	    // Envelope is outside the limits.
	    p.processes = (0, _gear.concat)((0, _gear.cloneDeep)(parent.processes), p.processes);
	
	    // This is complex because we want to clone every user defined property
	    // We should review if there is a better mechanism for this
	    var pKeys = (0, _lodash.keys)(p);
	    (0, _lodash.forEach)(parent.Properties, function (prop, name) {
	      if (prop.manualCloning !== true && name !== 'cacheId' && name !== 'textParts' && !(0, _lodash.includes)(pKeys, name)) {
	        var v = parent[prop.member];
	        p[name] = v !== null ? v.cloneDeep ? v.cloneDeep() : v.clone ? v.clone() : v : null;
	      }
	    });
	
	    var text = new _figure.Figure.Text(p);
	
	    _figure.Figure._ungroup(text, parent, this);
	    text.invalidate();
	
	    text._textPartSource = this;
	    return text;
	  },
	  replaceWithText: function (text, parent) {
	
	    this.properties = text._properties;
	    this.brush = text._brush;
	    this.pen = text._pen;
	
	    this.processes = text._processes;
	
	    this.anchor = text.anchor.clone();
	    this.preMatrix22 = text.preMatrix22.clone();
	
	    _figure.Figure._group(this, parent, text);
	  },
	  init: function () {
	    var p = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    if (!p.properties) {
	      this.properties = new _properties.TextProperties();
	    }
	    this._pin = new _anchor.Pin(p.pin);
	    if (!p.anchor && !p._anchor) {
	      this.anchor = new _anchor.AnchorGenerator({ pos: new _geometry.Point(0.5, 0), absolute: false }); // [TODO]
	    }
	  },
	  buildXml: function (parentNode) {
	    _util.Xml.addObject(parentNode, this, 'TextPart');
	  },
	  setupXml: function (node) {
	    _util.Xml.setupProperties(node, this);
	    this._properties.setupXml(node);
	    var preMatrix22 = this._preMatrix22;
	    if (!preMatrix22.isIdentity()) {
	      var preTransformNode = _util.Xml.appendElement(node, 'PreTransform');
	      preMatrix22.setMatrix22Attr(preTransformNode, 'Matrix22');
	    }
	    _anchor.FigureTransform.buildXml(this._matrix22, node);
	    this._pin.buildXml(node);
	  }
	}));
	
	TextPart.arrayFromXml = function (parentNode) {
	  return _util.Xml.getObjectArray(parentNode, TextPart, 'TextPart');
	};
	TextPart.parseXml = function (node) {
	  var p = _util.Xml.parseProperties(node, TextPart);
	  p.properties = _properties.TextProperties.parseXml(node);
	  var preTransformNode = _util.Xml.child(node, 'PreTransform');
	  if (preTransformNode) {
	    p.preMatrix22 = _geometry.Matrix.getMatrix22Attr(preTransformNode, 'Matrix22');
	  }
	  p.matrix22 = _anchor.FigureTransform.fromXml(node).matrix;
	  p.pin = _anchor.Pin.fromXml(node);
	  return new TextPart(p);
	};
	TextPart.createFromText = function (text, range, parentMatrix22, parentPin) {
	
	  var tp = new TextPart({
	    properties: text._properties.clone(),
	    brush: text._brush,
	    pen: text._pen,
	    textRange: range,
	    anchor: text._anchor.clone(),
	    preMatrix22: text._preMatrix22.clone(),
	    matrix22: text._matrix22.clone(),
	    pin: text.pin.clone()
	  });
	
	  // Force anchor to absolute (0,0), right now it is the only anchor supported
	  // by multi part and groups. We need to review this.
	  var parentAnchor = (0, _anchor.AbsoluteAnchor)(new _geometry.Point(0, 0));
	  _figure.Figure._group(tp, { anchor: parentAnchor,
	    matrix22: parentMatrix22,
	    pin: parentPin }, text);
	
	  // The processes needs to know from what kind of figure they are being called
	  // so this has to be done after creation, we can review how to improve this code
	  tp.processes = text._processes.cloneDeep(tp);
	  return tp;
	};
	
	// Are equal exept for pin, brush and pen
	TextPart.areClones = function (tp1, tp2) {
	  return tp1._textRange.isEqual(tp2._textRange) && tp1._anchor.isEqual(tp2._anchor) && tp1._preMatrix22.isEqual(tp2._preMatrix22) && tp1._matrix22.isEqual(tp2._matrix22) && (0, _gear.areEqual)(tp1._processes, tp2._processes) && tp1._properties.isEqual(tp2._properties);
	};
	
	_figure.Figure.simplifyTextParts = function (figure) {
	  var changeset = _figure.Figure.findTextPartsChangeSet(figure);
	  if (changeset.parts.length > 0) {
	    var _ret = function () {
	      var text = figure.clone();
	      var textParts = text._textParts;
	      changeset.parts.sort(function (a, b) {
	        return b - a;
	      }); // Descending order
	      (0, _lodash.forEach)(changeset.parts, function (p) {
	        textParts.splice(p, 1);
	      });
	      if (textParts.length === 1) {
	        var part = textParts[0];
	        var range = part._textRange;
	        if (range.start === 1 && range.end === 0) {
	          // We can convert this text into a single line text
	          text = part.asTextBlock(text);
	        }
	      }
	      text._processes.add(changeset.processes);
	      return {
	        v: text
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  } else {
	    return figure.clone();
	  }
	};
	
	_figure.Figure.textPartsCanBeSimplified = function (figure) {
	  return figure.isText && _figure.Figure.findTextPartsChangeSet(figure).parts.length > 0;
	};
	
	_figure.Figure.findTextPartsChangeSet = function (figure) {
	  var changeset = { parts: [], processes: [] };
	
	  if (figure.isMultiPart) {
	    var _ret2 = function () {
	      var parts = figure._textParts.clone();parts.reverse();
	      var clones = {};
	      var mainParts = [];
	      var grouped = [];
	      var count = 0;
	      var i = 0,
	          k = 1,
	          n = parts.length;
	      for (; k < n; ++i, ++k) {
	        if ((0, _lodash.includes)(grouped, i)) {
	          continue;
	        }
	        for (var j = k; j < n; ++j) {
	          if (TextPart.areClones(parts[i], parts[j])) {
	            if (!clones[i]) {
	              clones[i] = [];
	              mainParts.push(i);
	              ++count;
	            }
	            clones[i].push(j);
	            grouped.push(j);
	            ++count;
	          }
	        }
	      }
	      if (count !== n) {
	        return {
	          v: changeset
	        };
	      }
	
	      var maxMainPenWidth = 0;
	      (0, _lodash.forEach)(mainParts, function (pi) {
	        var pw = parts[pi].pen._width;
	        if (pw > maxMainPenWidth) {
	          maxMainPenWidth = pw;
	        }
	      });
	
	      var cn = mainParts.length;
	      var mc = clones[mainParts[0]];
	
	      // Every part must share the same final transform
	      var matrix22 = parts[mainParts[0]]._matrix22;
	      var invMatrix22 = matrix22.inverted();
	
	      for (var t = mc.length - 1; t >= 0; --t) {
	        var parts_mc_t = parts[mc[t]];
	        var pinOffset0 = parts_mc_t.pin.transformed(invMatrix22).minus(parts[mainParts[0]].pin.transformed(invMatrix22));
	        var brush = parts_mc_t._brush;
	        var pen = parts_mc_t._pen;
	
	        var mainParts_l = void 0,
	            l = void 0;
	        for (l = 1; l < cn; ++l) {
	          mainParts_l = mainParts[l];
	          var oc = clones[mainParts_l];
	          if (t >= oc.length) {
	            return {
	              v: changeset
	            };
	          }
	          var parts_oc_t = parts[oc[t]];
	
	          if (!matrix22.isEqual(parts_oc_t._matrix22)) {
	            return {
	              v: changeset
	            };
	          }
	
	          var pinOffsetl = parts_oc_t.pin.transformed(invMatrix22).minus(parts[mainParts_l].pin.transformed(invMatrix22));
	
	          if (!pinOffset0.isNear(pinOffsetl, 0.05)) {
	            // do not mind a little bit of offset
	            return {
	              v: changeset
	            };
	          }
	
	          var equalStyle = brush.isEqual(parts_oc_t._brush) && pen.isNear(parts_oc_t._pen, 0.05); // do not mind a little bit of difference
	          if (!equalStyle) {
	            return {
	              v: changeset
	            };
	          }
	        }
	
	        // We can represent these parts as a single process
	        var changeParts = [];
	        for (var d = 0; d < cn; ++d) {
	          var index = parts.length - 1 - clones[mainParts[d]][t];
	          changeParts.push(index);
	        }
	        var outline = pinOffset0.isEqual(new _geometry.Point(0, 0));
	        if (!outline) {
	          if (changeset.processes.length > 0) {
	            // Shadow can only be the last process
	            // Abort the changes
	            return {
	              v: { parts: [], processes: [] }
	            };
	          }
	          var process = new _process.Process.RasterShadow({
	            offsetX: pinOffset0.x, offsetY: pinOffset0.y,
	            // The shadow process modifies the pen when it is empty
	            pen: pen._empty ? (0, _style.Pen)({ width: 0, color: _style.Color.Transparent() }) : pen,
	            brush: brush
	          });
	
	          changeset.processes.push(process);
	          changeset.parts = changeset.parts.concat(changeParts);
	        } else {
	          (function () {
	            // We keep extending the pen contours
	            var pc = changeset.processes[0];
	            if (!(pc instanceof _process.Process.PenContour)) {
	              pc = new _process.Process.PenContour({ pens: [] });
	              changeset.processes.unshift(pc);
	            }
	            var pw = pen._width - maxMainPenWidth;
	            // Correct other pen widths, they are accumulative in PenContour
	            var pc_pens = pc._pens;
	            (0, _lodash.forEach)(pc_pens, function (p) {
	              p.width = p._width - pw;
	            });
	            var cpen = pen.clone();
	            cpen.width = pw;
	            pc_pens.unshift(cpen);
	            changeset.parts = changeset.parts.concat(changeParts);
	          })();
	        }
	      }
	    }();
	
	    if (typeof _ret2 === "object") return _ret2.v;
	  }
	
	  return changeset;
	};

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Text = undefined;
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	var _geometry = __webpack_require__(21);
	
	var _style = __webpack_require__(29);
	
	var _figure = __webpack_require__(39);
	
	var _anchor = __webpack_require__(42);
	
	var _shape = __webpack_require__(45);
	
	var _powerClip = __webpack_require__(49);
	
	var _group = __webpack_require__(59);
	
	var _textLayout = __webpack_require__(55);
	
	var _properties = __webpack_require__(53);
	
	var _multiPart = __webpack_require__(57);
	
	function joinLines(lines) {
	  return (0, _lodash.join)(lines, '\r\n');
	}
	
	function splitLines(line) {
	  return line.split(/\r\n|[\n\v\f\r\x85\u2028\u2029]/);
	}
	
	_figure.Figure.TextLayout = _textLayout.TextLayout;
	
	var Text = exports.Text = _figure.Figure.Text = _figure.Figure.extend((0, _gear.forwardPropertiesFrom)(_properties.TextProperties, 'properties', { typeName: 'Text',
	
	  type: 'Text',
	
	  Properties: {
	    text: { type: 'string', def: 'Text', manualParsing: true, onChange: function () {
	        this.invalidate();
	      }
	    },
	    properties: { type: 'TextProperties', def: null, manualParsing: true, onChange: function () {
	        this.invalidate();
	      }
	    },
	    textParts: { type: 'TextPart[]', def: [], manualParsing: true, onChange: function () {
	        this.invalidate();
	      }
	    },
	
	    // Used in output figure polyregions and text figures from multi part text, to reference PowerClipContent in the input figure
	    // A PowerClipLink has an extra matrix so we are able to transform the content without cloning it
	    powerClipLink: { type: 'PowerClipLink', def: null, owned: true, manualParsing: true }
	  },
	
	  get isText() {
	    return true;
	  },
	  get isMultiPartText() {
	    return this._textParts.length > 0;
	  },
	  get isSimpleText() {
	    return !this.isMultiPart && !this.isTypeset;
	  },
	  get isTypeset() {
	    return this.lines.length > 1;
	  },
	  get isMultiPart() {
	    return this.isMultiPartText;
	  },
	  get isSimple() {
	    return this.isSimpleText;
	  },
	  get isEmpty() {
	    return this._text === '';
	  },
	
	  _ignoreAttributes: _figure.Figure.prototype._ignoreAttributes.concat((0, _lodash.keys)(_properties.TextProperties.prototype.Properties)),
	
	  containsLinkedResources: function () {
	    return true;
	  },
	
	
	  get lines() {
	    return splitLines(this._text);
	  },
	  set lines(lines_) {
	    this.invalidate();
	    this._text = joinLines(lines_);
	  },
	
	  get font() {
	    if (!this.isMultiPart) {
	      return this._properties.font;
	    }
	    // Multipart (this code will be cleaned later)
	    var currentXmlFont = null,
	        allEqual = true;
	
	    (0, _lodash.forEach)(this._textParts, function (tp) {
	      var xmlFont = _util.Xml.fontToXml(tp._properties.font); // [TODO] Remove usage of Xml.fontToXml
	      if (!currentXmlFont) {
	        currentXmlFont = xmlFont;
	      } else if (currentXmlFont !== xmlFont) {
	        allEqual = false;
	      }
	    });
	    return allEqual ? this._textParts[0]._properties.font : null;
	  },
	  set font(font_) {
	    if (!this.isMultiPart) {
	      this._properties.font = font_;
	    } else {
	      this.invalidate();
	      (0, _lodash.forEach)(this.textParts, function (tp) {
	        tp._properties.font = font_;
	      });
	    }
	  },
	
	  replaceStyle: function (figure) {
	    this.callParent(figure);
	    // [TODO] Check if this is correct with TextParts
	    this.properties = figure.properties;
	  },
	  drawForClipping: function (context, transform) {
	    this.outputFigure.drawForClipping(context, transform);
	  },
	
	
	  // [TODO][PROP]
	  powerClip: function (v) {
	    var powerClipContents = this._powerClipContents;
	    if (v === undefined) {
	      return powerClipContents[0];
	    }
	    powerClipContents.set(v);
	    this.powerClipId = v._id;
	    return this;
	  },
	  addPowerClipContents: function (v) {
	    var id = this.powerClipId || (0, _lodash.uniqueId)("PC");
	    var onTextPart = false;
	    (0, _lodash.forEach)(this.textParts, function (tp) {
	      if (tp.powerClipId) {
	        id = tp.powerClipId;
	        onTextPart = true;
	      }
	    });
	
	    var powerClipContents = this._powerClipContents;
	    var pccN = _powerClip.PowerClipContent.createForFigure(id, v, this);
	
	    var pcc = (0, _lodash.find)(powerClipContents, '_id', id);
	    if (!pcc) {
	      powerClipContents._set(pccN);
	      if (!onTextPart) this._properties._powerClipId = id;
	      pcc = pccN;
	
	      this.invalidate();
	    } else {
	      pcc._figures._add(pccN._figures);
	
	      if (this.usingPowerClipLink()) {
	        this.invalidateView();
	      } else {
	        this.invalidate();
	      }
	    }
	  },
	  replaceParts: function (parts) {
	    var _this2 = this;
	
	    this.textParts = (0, _lodash.compact)((0, _lodash.map)(parts, function (p) {
	      var source = p._textPartSource;
	      if (source) {
	        source.replaceWithText(p, _this2);
	        return source;
	      }
	    }));
	
	    this.invalidate();
	    return this;
	  },
	  regroupParts$: function (parts) {
	    var _this = this;
	    return _figure.Figure.autoCreateMultiPartText$(parts, _this.matrix22, _this.pin).then(function (text) {
	      _this.text = text.text;
	      _this.anchor = text.anchor;
	      _this.preMatrix22 = new _geometry.Matrix();
	      _this.matrix22 = text.matrix22;
	      _this.pin = text.pin;
	      _this.textParts = text.textParts.clear();
	      return _this;
	    });
	  },
	  breakIntoParts: function () {
	    var _this3 = this;
	
	    return (0, _lodash.map)(this._textParts, function (p) {
	      return p.asTextBlock(_this3);
	    });
	  },
	  canEditContent: function () {
	    return this.isMultiPart && this._processes.length === 0 || this.callParent();
	  },
	  buildXml: function (parentNode) {
	    _util.Xml.addObject(parentNode, this, 'TextBlock');
	  },
	  setupXml: function (node) {
	    // Each line is represented in CDL as a <Line>...</Line> entry
	    (0, _lodash.forEach)(this.lines, function (line) {
	      _util.Xml.appendElement(node, 'Line').textContent = line;
	    });
	    this._properties.setupXml(node);
	    _util.Xml.addObjectArray(node, this._textParts);
	    this.callParent(node);
	  },
	  createEmptyOutput: function () {
	    return _shape.Shape.CreateRectangle({ center: this.pin, width: this.fontSize, height: this.fontSize, brush: _style.Brush.empty });
	  },
	  processesAreSupported: function () {
	    return this._processes.canProcess(this);
	  },
	  supportedLocalMultiPart: function () {
	    var textParts = this._textParts;
	    return textParts.length === 0 || (0, _lodash.every)(textParts, function (t) {
	      return t.processes.canProcess(t);
	    });
	  },
	  canBeProcessedLocally: function () {
	    return _config.Config.localText && !_config.Helper.isIE_let(9) && this.processesAreSupported() && this.supportedLocalMultiPart() && !this.needsCacheToRender();
	  },
	
	
	  concreteFontSize_: function () {
	    var preScale = this._computedPreScale;
	    var matrix = this.globalMatrix_();
	    var urm = _geometry.Matrix.m(_geometry.Matrix.rotate(-matrix.angle()), matrix);
	    // console.log( preScale.x + ' ' + ( preScale.x * urm.s00 ) + ' | ' + preScale.y + ' ' + ( preScale.y * urm.s11 ) );
	    return this.fontSize * Math.min(preScale.x * Math.abs(urm.s00), preScale.y * Math.abs(urm.s11));
	  },
	
	  fontDataScale_: function () {
	    // assert( this._fontData );
	    return this._fontDataScale;
	  },
	  fontData$: function () {
	    var me = this;
	    var lines = (0, _gear.clone)(this.lines);
	    var manager = _config.Config.GlobalResourceManager;
	    return manager.loadFontData$(me.font, me.text, 'M').then(function (fontData) {
	      me._fontData = fontData;
	
	      // Cache information, as a precaution in case somebody changes the model
	      // while processing. We need to review when we are unlocking canvas to avoid
	      // actions to interfere one another
	      me._fontDataScale = fontData.scaleForSize(me.fontSize, me.fontAutoSize);
	      me._fontDataLines = lines;
	      return fontData;
	    });
	  },
	  inputPrimitiveFigures$: function () {
	    var _this = this;
	
	    if (this.isEmpty) {
	      _this.font.cache$();
	      return (0, _gear.resolve)({ figures: [] });
	    }
	
	    var textParts = _this._textParts;
	    if (textParts.length > 0) {
	
	      return (0, _gear.map$)(textParts, function (textPart) {
	        return textPart.preText(_this).generateOutputFigure$();
	      }).then(function (r) {
	
	        var figures = (0, _group._toPrimitives)(r);
	
	        var ag = _this._anchor;
	        var pos = ag._pos;
	
	        var prePin = null;
	        if (ag._absolute) {
	          prePin = pos.clone();
	        } else {
	          var vectorBounds = _geometry.Bounds.union((0, _lodash.invokeMap)(figures, 'vectorBounds'));
	          prePin = vectorBounds.interpolate(pos);
	        }
	
	        return { figures: figures, anchor: prePin };
	      });
	    } else {
	      // Simple text
	
	      return _this.fontData$().then(function () {
	
	        var textLayout = (0, _textLayout.TextLayout)(_this);
	
	        var prePin = textLayout.prePin();
	
	        var textLines = textLayout._textLines;
	        if (textLines.length === 0 || textLines.length === 1 && textLines[0]._chars.length === 0) {
	          return { figures: [], anchor: prePin };
	        }
	
	        // Keep a reference to the textLayout, we are going to use it in the tools
	        _this._textLayout = textLayout;
	
	        return { figures: [textLayout], anchor: prePin };
	      });
	    }
	  },
	  charAtPoint_: function (point) {
	    if (this.isEmpty) {
	      return null;
	    }
	    var charContainsPoint = function (char) {
	      return char._frame.transformed(matrix).contains(point);
	    };
	    var layout = this._textLayout;
	    var textLines = layout.textLines();
	    var matrix = this.matrix_();
	    for (var k = 0, kEnd = textLines.length; k < kEnd; ++k) {
	      var line = textLines[k];
	      var char = (0, _lodash.find)(line._chars, charContainsPoint);
	      if (char) {
	        return char;
	      }
	    }
	    return null;
	  },
	
	
	  // internal
	
	  _clone: function () {
	    var p = this.callParent();
	    p.textParts = (0, _gear.cloneDeep)(this._textParts);
	    return p;
	  },
	  clone: function (includingProcessor, partOfGroup, ungrouping) {
	    var t = this.callParent(includingProcessor, partOfGroup, ungrouping);
	
	    var textLayout = this._textLayout;
	    if (textLayout) {
	      t._textLayout = this._textLayout.clone();
	      t._textLayout._text = t;
	    }
	
	    t._fontData = this._fontData;
	    t._fontDataScale = this._fontDataScale;
	    return t;
	  },
	  outputsText: function () {
	    return true;
	  },
	  init: function () {
	    var p = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	
	    this.callParent(p);
	
	    if (!p.properties) {
	      this.properties = new _properties.TextProperties(p);
	    }
	
	    // Used while generating the outputFigure, kept for internal tools that
	    // modifies the text layout without a full reprocessing (for example
	    // CharsTransform)
	    this._textLayout = null;
	    this._fontData = null;
	    this._fontDataScale = null;
	    this._fontDataLines = null;
	
	    // Change default, [TODO] idiom for this?
	    if (this._textParts.length === 0 && p.brush === undefined) {
	      this.brush = new _style.Brush({ color: _style.Color.Black() });
	    }
	
	    if (!p.anchor && !p._anchor) {
	      this.anchor = new _anchor.AnchorGenerator({ pos: new _geometry.Point(0.5, 0), absolute: false });
	    }
	  },
	  otherColors: function (colors) {
	    var textParts = this._textParts;
	    //_.forEach(textParts,function(tp) {
	    for (var k = 0, kEnd = textParts.length; k < kEnd; ++k) {
	      textParts[k].getColors(colors);
	    } //);
	    return colors;
	  },
	  otherPens: function (pens) {
	    var textParts = this._textParts;
	    //_.forEach(textParts,function(tp) {
	    for (var k = 0, kEnd = textParts.length; k < kEnd; ++k) {
	      textParts[k].getPens(pens);
	    } //);
	    return pens;
	  },
	  otherBrushes: function (brushes) {
	    var textParts = this._textParts;
	    //_.forEach(textParts,function(tp) {
	    for (var k = 0, kEnd = textParts.length; k < kEnd; ++k) {
	      textParts[k].getBrushes(brushes);
	    } //);
	    return brushes;
	  },
	  needsCacheToRender: function () {
	    if (_config.Config.alwaysRenderLocally) {
	      return false;
	    }
	    if (!_config.Config.renderLocallyWhenPossible) {
	      return true;
	    }
	    return !this.powerClipsLocalRendering();
	  },
	  hitTest: function (point) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    options.regionFrames = _config.Config.useCharactersBoundsBasedSelection;
	    if (this.canBeSelected() && this.globalFrame_().contains(point)) {
	      // [TODO] 'selectable'
	      if (options.frameBased || !_config.Config.useCurvesBasedSelection) {
	        return true;
	      }
	      return this._processor.fineHitTest(point, this.globalMatrix_(), options);
	    }
	    return false;
	  },
	  correctZeroAdvance: function () {
	    return true;
	  },
	  lineDirectionVector: function () {
	    return _geometry.Matrix.rotate(this.lineDirection).apply_(1, 0);
	  },
	  charDirectionVector: function () {
	    return _geometry.Matrix.rotate(this.charDirection).apply_(1, 0);
	  },
	  isVertical: function () {
	    var ld = this.lineDirectionVector();
	    return Math.abs(ld.y) > Math.abs(ld.x);
	  },
	  doMultilineVerticalText: function () {
	    return this.isVertical() && this.lines.length === 1 && this.verticalStyle === 'MultiLine';
	  },
	  effectiveLineDirection: function () {
	    return this.doMultilineVerticalText() ? new _geometry.Point(1, 0) : this.lineDirectionVector();
	  },
	  effectiveLinesPerColumn: function (charsCount) {
	    var linesPerColumn = this.linesPerColumn,
	        columnCount = this.columnCount;
	    return linesPerColumn > 0 ? linesPerColumn : columnCount > 0 ? Math.ceil(charsCount / columnCount) : null;
	  },
	  effectiveExtraLineSpacing_: function () {
	    var fontHeight = this._fontData.height(this._fontDataScale);
	    return _gear.Magnitude.absoluteMMValueFor(this.extraLineSpacing, fontHeight);
	  },
	
	
	  // [TODO] Review
	  spaceWidth_: function () {
	    return this._fontData.spaceWidth(this._fontDataScale);
	  },
	  ascent_: function () {
	    return this._fontData.ascent(this._fontDataScale);
	  },
	  descent_: function () {
	    return this._fontData.descent(this._fontDataScale);
	  },
	  sizeOfReferenceChar_: function () {
	    return this._fontData.sizeOfReferenceChar(this._fontDataScale);
	  },
	
	
	  // True is chars are placed widthwise; false if they are placed heightwise.\n
	  // When chars are placed widthwise, each next char is positioned based on their widths,
	  // otherwise is position based on their heights.\n
	  // Chars are placed widthwise whenever the 'CharDirection' is at least at 45ڠfrom
	  // the 'LineDirection' (that is, when they are perpendicular to the flow of text).
	  isWidthwise: function () {
	    var c45Degrees = 0.707108679; // Sqrt( 2 ) / 2 ;
	    return Math.abs(_geometry.Point.dotProduct(this.charDirectionVector(), this.effectiveLineDirection())) <= c45Degrees;
	  },
	  isLeftToRight: function () {
	    var lineAngle = this.effectiveLineDirection().angle();
	    return lineAngle <= Math.PI / 2.0 || lineAngle >= 3 / 2.0 * Math.PI;
	  }
	}));
	
	Text.parseXml = function (node, bcFixes) {
	
	  var text = new Text();
	
	  _figure.Figure._baseParseXml.call(text, node, Text, bcFixes);
	
	  // Each line is represented in CDL as a <Line>...</Line> entry
	  text._text = joinLines((0, _lodash.map)(_util.Xml.children(node, 'Line'), 'textContent'));
	
	  text.properties = _properties.TextProperties.parseXml(node);
	
	  text.textParts = _multiPart.TextPart.arrayFromXml(node);
	
	  return text;
	};

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Group = exports._toPrimitives = undefined;
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	var _geometry = __webpack_require__(21);
	
	var _processor = __webpack_require__(38);
	
	var _figure = __webpack_require__(39);
	
	var _figures = __webpack_require__(43);
	
	var _shape = __webpack_require__(45);
	
	var _powerClip = __webpack_require__(49);
	
	var _anchor = __webpack_require__(42);
	
	var consumePolyregionsIntoGShape = function (polyregions, primitives) {
	  if (polyregions.length > 0) {
	    var gs = new _shape.GShape({ polyregions: polyregions });
	    polyregions.splice(0, polyregions.length);
	    primitives.push(gs);
	  }
	};
	
	var extractPolyregionsAndRasters = function (figures, parentMatrix, polyregions, primitives) {
	  (0, _lodash.forEach)(figures, function (f) {
	
	    if (f.isRaster) {
	      consumePolyregionsIntoGShape(polyregions, primitives);
	
	      var r = f.clone();
	      if (!parentMatrix.isIdentity()) {
	        r.transform(parentMatrix);
	      }
	      primitives.push(r);
	      return;
	    }
	
	    // Shape
	
	    var prePin = f._computeInitialPrePin();
	    var figureMatrix = f._computeMatrix(prePin);
	    var cm = _geometry.Matrix.m(parentMatrix, figureMatrix);
	    var pcMatrix = _geometry.Matrix.m(cm, _geometry.Matrix.translate(prePin));
	
	    if (f.isGroup) {
	      extractPolyregionsAndRasters(f.figures, cm, polyregions, primitives);
	    } else {
	      (function () {
	        var f_polyregions = f._polyregions,
	            f_powerClipContents = f._powerClipContents;
	
	        var c_f_polyregions = (0, _gear.cloneDeep)(f_polyregions);
	
	        (0, _lodash.forEach)(c_f_polyregions, function (p) {
	          var pcLink = p._powerClipLink;
	          if (pcLink) {
	            // The polyregion could already have the pcLink
	            // console.log('Transform PC-Link: ' + pcMatrix.textualize() + ' , prePin: ' + prePin.textualize() );
	            pcLink.transform(pcMatrix);
	          } else {
	            var pcId = p._powerClipId;
	            if (pcId) {
	              var pcContent = (0, _lodash.find)(f_powerClipContents, { _id: pcId });
	              if (pcContent) {
	                // console.log('Build PC-Link: ' + pcMatrix.textualize() + ' , prePin: ' + prePin.textualize() );
	                p._powerClipLink = new _powerClip.PowerClipLink({ content: pcContent, matrix: pcMatrix });
	              }
	            }
	          }
	        });
	
	        (0, _lodash.forEach)((0, _lodash.map)(c_f_polyregions, function (cp) {
	          if (!cm.isIdentity()) {
	            // console.log('Transform polyregion: '+ cp._powerClipId + ' '+cm.textualize());
	            cp.transform(cm);
	            var pen = cp.pen;
	            if (pen) {
	              pen._width *= cm.scaleFactor();
	            }
	          }
	          return cp;
	        }), function (pc) {
	          polyregions.push(pc);
	        });
	      })();
	    }
	  });
	};
	
	var _toPrimitives = exports._toPrimitives = function (figures) {
	  var primitives = [],
	      polyregions = [];
	  extractPolyregionsAndRasters(figures, new _geometry.Matrix(), polyregions, primitives);
	  consumePolyregionsIntoGShape(polyregions, primitives);
	  return primitives;
	};
	
	var _canUseGroupProcessor = function (figures) {
	  // return _.every( filter(figures,'isGroup')
	  //               , function(group) { return group.canUseGroupProcessor(); });
	  for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	    var figure = figures[k];
	    if (figure.isGroup && !figure.canUseGroupProcessor()) {
	      return false;
	    }
	  }
	  return true;
	};
	
	// [TODO] Take into account Anchor, for now this is only working for <Anchor X="0" Y="0"/>
	_figure.Figure._group = function (figure, parent) {
	  var source = arguments.length <= 2 || arguments[2] === undefined ? figure : arguments[2];
	
	  if (parent.matrix22.isIdentity()) {
	    // Simple group, no need to change the figures matrix. We can keep the metrics
	    // and avoid proessing server calls for proxyGroups
	    figure.translate(_geometry.Point.minus(parent.pin));
	    return figure;
	  } else {
	    var matrix22 = source.matrix22;
	    var invertedParentMatrix22 = parent.matrix22.inverted();
	    figure.pin = invertedParentMatrix22.apply(source.pin.minus(parent.pin));
	    figure.matrix22 = _geometry.Matrix.m(invertedParentMatrix22, matrix22);
	    return figure;
	  }
	};
	
	// We only enter here when the parent trasnform is the identity, and we
	// are regrouping into a top group.
	// We could optimize further here. It is to complex for the moment, we may
	// want to explore better abstractions
	
	var stashGlobalMetrics = function (figure) {
	  figure.deepForEachFigure(function (cf) {
	    var cache = cf._cache;
	    cache.stash('globalMatrix');
	    cache.stash('globalVectorBounds');
	    cache.stash('globalBounds');
	    cache.stash('globalMaterialBounds');
	  });
	};
	
	var unstashGlobalMetrics = function (figure) {
	  figure.deepForEachFigure(function (cf) {
	    var cache = cf._cache;
	
	    cache.copy('globalMatrix', 'globalPreMatrix');
	    cache.copy('globalVectorBounds', 'globalPreVectorBounds');
	    cache.copy('globalBounds', 'globalPreBounds');
	
	    cache.unstash('globalMatrix');
	    cache.unstash('globalVectorBounds');
	    cache.unstash('globalBounds');
	    cache.unstash('globalMaterialBounds');
	  });
	};
	
	_figure.Figure._fastGroup = function (figure, parent) {
	
	  stashGlobalMetrics(figure);
	
	  figure.translate(_geometry.Point.minus(parent.pin));
	
	  unstashGlobalMetrics(figure);
	
	  return figure;
	};
	
	_figure.Figure._grouped = function (figure, parent) {
	  return _figure.Figure._group(figure.clone(), parent);
	};
	
	_figure.Figure._ungroup = function (figure, parent) {
	  var source = arguments.length <= 2 || arguments[2] === undefined ? figure : arguments[2];
	
	  var matrix22 = source.matrix22;
	  var parentMatrix22 = parent.matrix22;
	  var parentPin = parent.pin;
	  if (parent.anchor.absolute) {
	    parentPin = parentPin.minus(parentMatrix22.apply(parent.anchor.pos));
	  } else {
	    var bounds = parent.preBounds_();
	    parentPin = parentPin.minus(bounds.interpolate(parent.anchor.pos.x, parent.anchor.pos.y));
	  }
	  figure.pin = parentMatrix22.apply(source.pin).plus(parentPin);
	  figure.matrix22 = _geometry.Matrix.m(parentMatrix22, matrix22);
	  figure.invalidate();
	  return figure;
	};
	_figure.Figure._ungrouped = function (figure, parent) {
	  return _figure.Figure._ungroup(figure.clone(), parent);
	};
	
	var Group = exports.Group = _figure.Figure.Group = _figure.Figure.extend({ typeName: 'Group',
	
	  type: 'Group',
	
	  Properties: {
	    figures: { type: 'Figure[]', def: [],
	      onChange: function () {
	        this.invalidate();
	      },
	
	      manualParsing: true,
	      manualCloning: true
	    }
	  },
	
	  get isGroup() {
	    return true;
	  },
	
	  invalidate: function () {
	    this._updateProcessor();
	    return this.callParent();
	  },
	  defaultAnchor: function () {
	    return (0, _anchor.AbsoluteAnchor)(new _geometry.Point(0, 0));
	  },
	  topColors: function () {},
	  // override, no top colors in group
	  otherColors: function (colors) {
	    var figures = this._figures;
	    //_.forEach(figures,function(f) {
	    for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	      figures[k].getColors(colors);
	    } //);
	    return colors;
	  },
	  otherPens: function (pens) {
	    var figures = this._figures;
	    //_.forEach(figures,function(f) {
	    for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	      figures[k].getPens(pens);
	    } //);
	    return pens;
	  },
	  topBrushes: function () {},
	  // override, no top brushes in group
	  otherBrushes: function (brushes) {
	    var figures = this._figures;
	    //_.forEach(figures,function(f) {
	    for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	      figures[k].getBrushes(brushes);
	    } //);
	    return brushes;
	  },
	  setupXml: function (node) {
	
	    var figuresNode = _util.Xml.appendElement(node, 'Figures');
	    _util.Xml.addObjectArray(figuresNode, this._figures);
	
	    this.callParent(node);
	  },
	  canEditContent: function () {
	    return this._processes.length === 0;
	  },
	  canBeProcessedLocally: function (figures) {
	    return this.processesAreSupported() && (0, _lodash.every)(figures || this.figures, function (f) {
	      return f.canBeProcessedLocally();
	    });
	    /*
	    return this._processes.length === 0 && _.every(figures||this._figures,f=> {
	      // We have to review this pattern. Right now the Processor code doesn't support local processing
	      // of groups that has text on them. This will be changed later.
	      return f.canBeProcessedLocally() && ! ( f.isText );
	    });*/
	  },
	  _representationType: function () {
	    return this.needsCacheToRender() || !this.canBeProcessedLocally() ? 'server' : 'local';
	  },
	  processesAreSupported: function () {
	    var _this = this;
	
	    var processes = this.processes;
	
	    return processes.length === 0 || (0, _lodash.every)(processes, function (process) {
	      return process.canProcess(_this);
	    });
	  },
	  onlySimpleShapes: function () {
	    return this.processes.length === 0 && (0, _lodash.every)(this.figures, function (figure) {
	      if (figure.isShape) {
	        return figure.processes.length === 0 && figure.canBeProcessedLocally();
	      }
	      if (figure.isGroup) {
	        return figure.onlySimpleShapes();
	      }
	      return false;
	    });
	  },
	  hasPreview: function () {
	    return false;
	  },
	  deepPowerClipContents: function () {
	    var pccs = this._powerClipContents;
	    var figures = this.figures;
	
	    for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	      pccs = (0, _gear.concat)(pccs, figures[k].deepPowerClipContents());
	    }
	    return pccs;
	  },
	  needsCacheToRender: function () {
	    return (0, _lodash.some)(this.figures, function (f) {
	      return f.needsCacheToRender();
	    });
	  },
	
	
	  // Disable bounds using preBounds optimization
	  _optimizeVectorBounds: function () {
	    return null;
	  },
	  _optimizeBounds: function () {
	    return null;
	  },
	  _fineHitTest: function (point, transform, options) {
	    for (var k = this.figures.length - 1, kEnd = 0; k >= kEnd; --k) {
	      var figure = this.figures[k];
	      if (figure._fineHitTest(point, figure.globalMatrix_(), options)) {
	        return true;
	      }
	    }
	    return false;
	  },
	  _computePreReferencePoint: function () {
	    return this._figures[0].referencePoint_();
	  },
	  _primitive_computePreVectorBounds: function () {
	    // console.log('Group._primitive_computePreVectorBounds');
	    return _geometry.Bounds.union((0, _lodash.map)(this.figures, function (f) {
	      return f._primitive_computeVectorBounds();
	    }));
	  },
	  _primitive_computePreBounds: function () {
	    // console.log('Group._primitive_computePreBounds');
	    return _geometry.Bounds.union((0, _lodash.map)(this.figures, function (f) {
	      return f._primitive_computeBounds();
	    }));
	  },
	  _primitive_computePreVectorBoundsAfter: function (transform) {
	    // console.log('Group._primitive_computePreVectorBoundsAfter');
	    return _geometry.Bounds.union((0, _lodash.map)(this.figures, function (f) {
	      return f._primitive_computePreVectorBoundsAfter(_geometry.Matrix.m(transform, f.matrix_()));
	    }));
	  },
	  _primitive_computePreBoundsAfter: function (transform) {
	    // console.log('Group._primitive_computePreBoundsAfter');
	    return _geometry.Bounds.union((0, _lodash.map)(this.figures, function (f) {
	      return f._primitive_computePreBoundsAfter(_geometry.Matrix.m(transform, f.matrix_()));
	    }));
	  },
	
	
	  _primitive_computePreMaterialBoundsAfter: function (transform) {
	    // console.log('Group._primitive_computePreMaterialBoundsAfter');
	    return _geometry.Bounds.union((0, _lodash.compact)((0, _lodash.map)(this.figures, function (f) {
	      return f._primitive_computePreMaterialBoundsAfter(_geometry.Matrix.m(transform, f.matrix_()));
	    })));
	  },
	
	  _prepareToDraw$: function (zoom) {
	    return (0, _gear.invokeMap$)(this.figures, '_prepareToDraw$', zoom);
	  },
	  prepareToDraw$: function (zoom) {
	    // Ask for a bigger image if need it
	    if (this._processor instanceof _processor.GroupProcessor) {
	      return (0, _gear.invokeMap$)(this.figures, 'prepareToDraw$', zoom);
	    } else {
	      // [TODO] this.callParent(zoom);
	      // Ask for a bigger image if need it
	      var outputFigure = this._outputFigure;
	      if (outputFigure) {
	        return outputFigure._prepareToDraw$(zoom);
	      } else {
	        // Check, if we should call update$ here
	        return (0, _gear.resolve)(zoom);
	      }
	    }
	  },
	  _preparedToDraw: function (zoom) {
	    return (0, _lodash.every)(this.figures, function (f) {
	      return f._preparedToDraw(zoom);
	    });
	  },
	  preparedToDraw: function (zoom) {
	    // Ask for a bigger image if need it
	    if (this._processor instanceof _processor.GroupProcessor) {
	      return _figures.Figures.preparedToDraw(this._figures, zoom);
	    } else {
	      return this.callParent(zoom);
	    }
	  },
	  drawForClipping: function (context, transform) {
	    var figures = this.figures;
	
	    for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	      var f = figures[k];
	      f.drawForClipping(context, transform);
	    }
	  },
	  _draw: function (context, transform, config) {
	    var figures = this.figures;
	    //_.forEach(figures,function(f) {
	
	    for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	      var f = figures[k];
	      var output = f.outputFigure || f;
	
	      var alpha = output._alpha;
	      var changeGlobalAlpha = alpha !== 1.0;
	      if (changeGlobalAlpha) {
	        context.save();
	        context.globalAlpha *= alpha;
	      }
	
	      output._draw(context, transform, config);
	
	      if (changeGlobalAlpha) {
	        context.restore();
	      }
	    } //);
	  },
	  init: function () {
	    var c = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    this.callParent(c);
	
	    // [TODO] see below
	    if (!c || !c.anchor && !c._anchor) {
	      this._anchor = (0, _anchor.AbsoluteAnchor)(new _geometry.Point(0, 0));
	    }
	
	    if (!c.noProcessor) {
	      this._updateProcessor();
	    }
	  },
	  ungroup: function (figures) {
	    var _this2 = this;
	
	    if (figures === undefined) {
	      figures = this._figures.clone();
	    }
	    this._figures.remove(figures);
	    (0, _lodash.forEach)(figures, function (figure) {
	      _figure.Figure._ungroup(figure, _this2);
	    });
	    return figures;
	  },
	
	
	  get ungroupedFigures() {
	    var _this3 = this;
	
	    return (0, _lodash.map)(this.figures, function (figure) {
	      return _figure.Figure._ungrouped(figure, _this3);
	    });
	  },
	
	  regroup: function (figures) {
	    var _this4 = this;
	
	    this._updateProcessor(figures);
	
	    var isTopGroup = !this.isGrouped;
	    var fastGrouping = this.matrix22.isIdentity() && isTopGroup;
	
	    var owner = this;
	    while (owner && owner.isGroup) {
	      owner._cache.clear();
	      owner = owner._owner;
	    }
	
	    var groupedFigures = (0, _lodash.map)(figures, function (figure) {
	      var gf = _gear.OwnedObject.adoptObject(figure, null);
	      if (fastGrouping) {
	
	        _figure.Figure._fastGroup(gf, _this4);
	      } else {
	        _figure.Figure._group(gf, _this4);
	
	        // Clear the metrics by hand, we need a revision of how we are handling
	        // invalidation of subfigures for this to work correctly
	        (0, _processor.updateCache)(gf, {});
	      }
	
	      return gf;
	    });
	
	    var this_figures = this._figures;
	
	    if (this._processor instanceof _processor.Processor) {
	      this_figures.set(groupedFigures);
	    } else {
	      this_figures._set(groupedFigures); // avoid events
	      if (!fastGrouping) {
	        this.invalidateGrouping();
	      }
	    }
	
	    return this;
	  },
	  _clone: function (partOfGroup, ungrouping) {
	    var p = this.callParent();
	    p.figures = (0, _lodash.map)(this.figures, function (f) {
	      return f.clone(true, partOfGroup, ungrouping);
	    });
	    return p;
	  },
	  supportsLocalMetrics: function () {
	    return (0, _lodash.every)(this.figures, function (f) {
	      return f.supportsLocalMetrics();
	    });
	  },
	  containsRasters: function (figures) {
	    return (0, _lodash.some)(figures || this.figures, function (f) {
	      return f.isRaster || f.isGroup && f.containsRasters();
	    });
	  },
	  containsLinkedResources: function () {
	    return !!_figures.Figures.deepFindFigureLeave(this, function (figure) {
	      return figure.containsLinkedResources();
	    });
	  },
	  canUseGroupProcessor: function (figures) {
	    return this._anchor._absolute && _canUseGroupProcessor(figures || this.figures);
	  },
	  _updateProcessor: function (figures) {
	
	    var useGroupProcessor = _config.Config.enablePerFigureBasedGroupRendering && _config.Config.computeFigureGeometryLocally && this.canUseGroupProcessor(figures) && this.processes.length === 0 &&
	    // Use a common processor for simple grouped shapes
	    // We can allow a common processor for grouped rasters too. We need to think
	    // if this is a good strategy, it could be faster for overlay or background
	    // rasters combined with shapes
	    !(this.canBeProcessedLocally(figures) && !this.containsRasters(figures)) && !(_config.Helper.isIE_let(10) && this._xType === "System.Clipart");
	    if (useGroupProcessor) {
	      if (!(this._processor instanceof _processor.GroupProcessor)) {
	        // console.log('using group processor');
	        // Every figure is processed on his own
	        this._processor = new _processor.GroupProcessor(this);
	      }
	    } else {
	      if (!(this._processor instanceof _processor.Processor)) {
	        // console.log('using normal processor');
	        // The whole group is processed as one figure
	        this._processor = new _processor.Processor(this);
	      }
	    }
	  },
	  _computeInitialPrePin: function () {
	    return this._anchor.pos.clone(); // Always absolute for groups
	  },
	  inputPrimitiveFigures$: function () {
	    var _this5 = this;
	
	    return (0, _gear.map$)(this.figures, function (f) {
	      if (f.isShape && f._processes.length === 0) {
	        f.outputFigure = f;
	        return f;
	      } else {
	        return f.update$().then(function () {
	          return f.outputFigure;
	        });
	      }
	    }).then(function (processedFigures) {
	
	      var prePin = _this5._computeInitialPrePin();
	
	      var figures = _toPrimitives(processedFigures);
	
	      return { figures: figures, anchor: prePin };
	    });
	  }
	});
	// [TODO] We need this...
	// Group.prototype.Properties.anchor.def = AbsoluteAnchor( new Point(0,0) );
	
	_util.Xml.addFromBuild(Group, 'Group');
	
	Group.parseXml = function (node, bcFixes) {
	  var group = new Group();
	
	  _figure.Figure._baseParseXml.call(group, node, Group, bcFixes);
	
	  var figuresNode = _util.Xml.child(node, 'Figures');
	  var figures = figuresNode ? _figure.Figure.arrayFromXml(figuresNode, bcFixes) : [];
	  group.figures = figures;
	
	  if (!group.figures || !group.figures.length) return null;
	
	  return group;
	};
	
	_util.Xml.Parser['Group'] = _util.Xml.makeObjectParser(Group);
	_util.Xml.Parser['Group[]'] = _util.Xml.makeArrayObjectParser(Group);
	
	Group.create = function (figures) {
	  var group = new Group({ noProcessor: true });
	
	  // We are not going to define a composed matrix for the group anymore
	  // These has two benefits: frame is aligned to x-y and metrics do not need to be recomputed
	  // group.matrix22 = Figures.composedIsometricMatrix22(figures);
	  group.pin = _figures.Figures.meanPin(figures);
	
	  group.regroup(figures);
	
	  return group;
	};

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Monogram = undefined;
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	var _geometry = __webpack_require__(21);
	
	var _style = __webpack_require__(29);
	
	var _figure = __webpack_require__(39);
	
	var _anchor = __webpack_require__(42);
	
	var _shape = __webpack_require__(45);
	
	var _powerClip = __webpack_require__(49);
	
	var _group = __webpack_require__(59);
	
	var _textLayout = __webpack_require__(55);
	
	var _font = __webpack_require__(52);
	
	var defNum = function (v, d) {
	  return isFinite(v) ? v : d;
	};
	
	var Monogram = exports.Monogram = _figure.Figure.Monogram = _figure.Figure.extend({
	  typeName: 'Monogram',
	
	  type: 'Monogram',
	
	  Properties: {
	    line: { type: 'string', def: 'ABC', manualParsing: false, onChange: function () {
	        this.invalidate();
	      }
	    },
	    frameSystem: { type: 'string', def: 'Circle', manualParsing: false, onChange: function () {
	        this.invalidate();
	      }
	    },
	    fontStyle: { type: 'string', def: 'Standard', manualParsing: false, onChange: function () {
	        this.invalidate();
	      }
	    },
	    size: { type: 'magnitude', def: new _gear.Magnitude(54.2, 'mm'), manualParsing: false, onChange: function () {
	        this.invalidate();
	      }
	    },
	
	    // Used in output figure polyregions and text figures from multi part text, to reference PowerClipContent in the input figure
	    // A PowerClipLink has an extra matrix so we are able to transform the content without cloning it
	    powerClipLink: { type: 'PowerClipLink', def: null, owned: true, manualParsing: true }
	  },
	
	  get isText() {
	    return true;
	  },
	  get isMultiPartText() {
	    return false;
	  },
	  get isSimpleText() {
	    return !this.isMultiPart && !this.isTypeset;
	  },
	  get isTypeset() {
	    return this.text.length > 1;
	  },
	  get isMultiPart() {
	    return this.isMultiPartText;
	  },
	  get isSimple() {
	    return this.isSimpleText;
	  },
	  get isEmpty() {
	    return this._effectiveText.length == 0;
	  },
	  get font() {
	    return this._effectiveFont;
	  },
	  get fontName() {
	    var lLine = this.line.substr(0, 3);
	    return 'Stahls Mgram ' + this.frameSystem + ' ' + this.fontStyle + ' ' + lLine.length + ' LTR';
	  },
	
	  containsLinkedResources: function () {
	    return true;
	  },
	  drawForClipping: function (context, transform) {
	    this.outputFigure.drawForClipping(context, transform);
	  },
	
	
	  // [TODO][PROP]
	  powerClip: function (v) {
	    var powerClipContents = this._powerClipContents;
	    if (v === undefined) {
	      return powerClipContents[0];
	    }
	    powerClipContents.set(v);
	    this.powerClipId = v._id;
	    return this;
	  },
	  addPowerClipContents: function (v) {
	    var id = this.powerClipId || (0, _lodash.uniqueId)("PC");
	    var powerClipContents = this._powerClipContents;
	    var pccN = _powerClip.PowerClipContent.createForFigure(id, v, this);
	
	    var pcc = (0, _lodash.find)(powerClipContents, '_id', id);
	    if (!pcc) {
	      powerClipContents._set(pccN);
	      this._properties._powerClipId = id;
	      pcc = pccN;
	
	      this.invalidate();
	    } else {
	      pcc._figures._add(pccN._figures);
	
	      if (this.usingPowerClipLink()) {
	        this.invalidateView();
	      } else {
	        this.invalidate();
	      }
	    }
	  },
	  buildXml: function (parentNode) {
	    _util.Xml.addObject(parentNode, this, 'Monogram');
	  },
	
	  //setupXml(node) { this.callParent(node); },
	  createEmptyOutput: function () {
	    return _shape.Shape.CreateRectangle({ center: this.pin, width: this.size, height: this.size, brush: _style.Brush.empty });
	  },
	  processesAreSupported: function () {
	    return this._processes.canProcess(this);
	  },
	  supportedLocalMultiPart: function () {
	    return true;
	  },
	  canBeProcessedLocally: function () {
	    return _config.Config.localText && !_config.Helper.isIE_let(9) && this.processesAreSupported() && this.supportedLocalMultiPart() && !this.needsCacheToRender();
	  },
	
	
	  concreteFontSize_: function () {
	    var preScale = this._computedPreScale;
	    var matrix = this.globalMatrix_();
	    var urm = _geometry.Matrix.m(_geometry.Matrix.rotate(-matrix.angle()), matrix);
	    // console.log( preScale.x + ' ' + ( preScale.x * urm.s00 ) + ' | ' + preScale.y + ' ' + ( preScale.y * urm.s11 ) );
	    return this.fontSize * Math.min(preScale.x * Math.abs(urm.s00), preScale.y * Math.abs(urm.s11));
	  },
	
	  fontDataScale_: function () {
	    // assert( this._fontData );
	    return this._fontDataScale;
	  },
	  fontData$: function () {
	    console.log("  fontData$");
	    var me = this;
	    var manager = _config.Config.GlobalResourceManager;
	    return manager.loadFontData$(me._effectiveFont, me._effectiveText, '~').then(function (fontData) {
	      me._fontData = fontData;
	      // Cache information, as a precaution in case somebody changes the model
	      // while processing. We need to review when we are unlocking canvas to avoid
	      // actions to interfere one another
	      me._fontDataScale = fontData.scaleForSize(me.size, true);
	      me._fontDataLines = [me._effectiveText];
	
	      console.log("    fontDataScale: " + me._fontDataScale);
	
	      return fontData;
	    });
	  },
	  inputPrimitiveFigures$: function () {
	    var _this = this;
	
	    console.log("  inputPrimitiveFigures$");
	
	    console.log("    Size: " + this.size);
	
	    console.log("    Original Line: " + this.line);
	
	    var lLine = this.line.substr(0, 3);
	
	    var lEffectiveChars = [];
	
	    switch (lLine.length) {
	      case 1:
	        lEffectiveChars.push(lLine.charAt(0).toUpperCase());
	        break;
	      case 2:
	        lEffectiveChars.push(lLine.charAt(0).toUpperCase());
	        lEffectiveChars.push(lLine.charAt(1).toLowerCase());
	        break;
	      case 3:
	        var lMiddleUnicode = lLine.charAt(1).toUpperCase().charCodeAt(0);
	        var lAdjustedMiddleUnicode = lMiddleUnicode - 0x41 + 0x2500;
	        var lMiddleChar = String.fromCharCode(lAdjustedMiddleUnicode);
	
	        lEffectiveChars.push(lLine.charAt(0).toUpperCase());
	        lEffectiveChars.push(lMiddleChar);
	        lEffectiveChars.push(lLine.charAt(2).toLowerCase());
	    }
	
	    if (lEffectiveChars.length == 0) {
	      console.log("    Monogram is empty");
	      return (0, _gear.resolve)({ figures: [], anchor: new _geometry.Point(0, 0) });
	    }
	
	    this._effectiveText = lEffectiveChars.join("");
	    console.log("    EffectiveText: " + this._effectiveText);
	
	    console.log('    FrameSystem: ' + this.frameSystem);
	    console.log('    FontStyle: ' + this.fontStyle);
	
	    var lEffectiveFontFullName = 'Stahls Mgram ' + this.frameSystem + ' ' + this.fontStyle + ' ' + lEffectiveChars.length + ' LTR';
	    console.log("    Effective Font Fullname: " + lEffectiveFontFullName);
	
	    this._effectiveFont = new _font.Font({ fullName: lEffectiveFontFullName });
	
	    return _this.fontData$().then(function () {
	
	      var textLayout = (0, _textLayout.TextLayout)(_this);
	
	      var textLines = textLayout.textLines();
	      if (textLines == null || textLines.length === 0 || textLines.length === 1 && textLines[0]._chars.length === 0) {
	        console.log("    no chars!");
	        return { figures: [], anchor: new _geometry.Point(0, 0) };
	      }
	
	      // Keep a reference to the textLayout, we are going to use it in the tools
	      _this._textLayout = textLayout;
	
	      return { figures: [textLayout], anchor: new _geometry.Point(0, 0) };
	    });
	  },
	
	
	  // internal
	
	  _clone: function () {
	
	    console.log('MONOGRAM clone()');
	    var p = this.callParent();
	    return p;
	  },
	  clone: function (includingProcessor, partOfGroup, ungrouping) {
	
	    console.log('MONOGRAM _clone(includingProcessor:' + includingProcessor + ',partOfGroup:' + partOfGroup + ',ungrouping:' + ungrouping + ')');
	
	    var t = this.callParent(includingProcessor, partOfGroup, ungrouping);
	
	    var textLayout = this._textLayout;
	    if (textLayout) {
	      t._textLayout = this._textLayout.clone();
	      t._textLayout._text = t;
	    }
	
	    t._fontData = this._fontData;
	    t._fontDataScale = this._fontDataScale;
	    t._fontDataLines = this._fontDataLines;
	    t._effectiveText = this._effectiveText;
	    t._effectiveFont = this._effectiveFont;
	
	    return t;
	  },
	  outputsText: function () {
	    return true;
	  },
	  init: function () {
	    var p = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	
	    console.log("MONOGRAM init: " + p);
	
	    this.callParent(p);
	
	    // Used while generating the outputFigure, kept for internal tools that
	    // modifies the text layout without a full reprocessing (for example
	    // CharsTransform)
	    this._textLayout = null;
	    this._fontData = null;
	    this._fontDataScale = null;
	    this._fontDataLines = null;
	
	    this.extraCharSpacing = new _gear.Magnitude(0, 'mm');
	    this.extraWordSpacing = new _gear.Magnitude(0, 'mm');
	    this.columnSpacing = new _gear.Magnitude(0, 'mm');
	    this.linesAlign = 'Left';
	
	    this._effectiveText = "";
	    this._effectiveFont = "";
	
	    if (p.brush === undefined) {
	      this.brush = new _style.Brush({ color: _style.Color.Black() });
	    }
	
	    this.anchor = new _anchor.AnchorGenerator({ pos: new _geometry.Point(0, 0), absolute: true });
	  },
	  needsCacheToRender: function () {
	    if (_config.Config.alwaysRenderLocally) {
	      return false;
	    }
	    if (!_config.Config.renderLocallyWhenPossible) {
	      return true;
	    }
	    return !this.powerClipsLocalRendering();
	  },
	  hitTest: function (point) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    options.regionFrames = _config.Config.useCharactersBoundsBasedSelection;
	    if (this.canBeSelected() && this.globalFrame_().contains(point)) {
	      // [TODO] 'selectable'
	      if (options.frameBased || !_config.Config.useCurvesBasedSelection) {
	        return true;
	      }
	      return this._processor.fineHitTest(point, this.globalMatrix_(), options);
	    }
	    return false;
	  },
	
	
	  // [TODO] Review
	  spaceWidth_: function () {
	    return this._fontData.spaceWidth(this._fontDataScale);
	  },
	  ascent_: function () {
	    return this._fontData.ascent(this._fontDataScale);
	  },
	  descent_: function () {
	    return this._fontData.descent(this._fontDataScale);
	  },
	  sizeOfReferenceChar_: function () {
	    return this._fontData.sizeOfReferenceChar(this._fontDataScale);
	  },
	  isWidthwise: function () {
	    return true;
	  },
	  doMultilineVerticalText: function () {
	    return false;
	  },
	  effectiveLineDirection: function () {
	    return new _geometry.Point(1, 0);
	  },
	  charDirectionVector: function () {
	    return new _geometry.Point(0, 1);
	  },
	  effectiveExtraLineSpacing_: function () {
	    return 0;
	  },
	  effectiveLinesPerColumn: function (charsCount) {
	    return 1;
	  },
	  correctZeroAdvance: function () {
	    return false;
	  }
	});
	
	Monogram.parseXml = function (node, bcFixes) {
	
	  var monogram = new Monogram();
	
	  _figure.Figure._baseParseXml.call(monogram, node, Monogram, bcFixes);
	
	  return monogram;
	};
	
	/*
	
	 _fontDataLines
	 */

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Raster = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	var _geometry = __webpack_require__(21);
	
	var _style = __webpack_require__(29);
	
	var _hslShift = __webpack_require__(62);
	
	var _figure = __webpack_require__(39);
	
	var _shape = __webpack_require__(45);
	
	var _quantumImage = __webpack_require__(44);
	
	var _powerClip = __webpack_require__(49);
	
	var _invalidate = function () {
	  this.invalidate();
	};
	
	var Raster = exports.Raster = _figure.Figure.Raster = _figure.Figure.extend({ typeName: 'Raster',
	
	  type: 'Raster',
	
	  Properties: {
	    imageLink: { type: 'string', def: null, dropDef: true, onChange: _invalidate },
	    encodedImage: { type: 'string', def: null, dropDef: true, onChange: _invalidate },
	    width: { type: 'magnitude', def: new _gear.Magnitude(0, 'px'), dropDef: true },
	    height: { type: 'magnitude', def: new _gear.Magnitude(0, 'px'), dropDef: true },
	    dpi: { type: 'number', def: 25.4, tag: 'DPI', onChange: _invalidate },
	    hueShift: { type: 'number', def: 0.0, onChange: _invalidate },
	    saturationShift: { type: 'number', def: 0.0, onChange: _invalidate },
	    lightShift: { type: 'number', def: 0.0, onChange: _invalidate },
	    colorMap: { type: 'ColorMap', def: null, dropDef: true, onChange: _invalidate }
	  },
	
	  get isRaster() {
	    return true;
	  },
	  get isMonochrome() {
	    return this._colorMap instanceof _style.MonochromeColors;
	  },
	
	  init: function (domNode) {
	    this._cachedImage = null;
	    this.callParent(domNode);
	  },
	  containsLinkedResources: function () {
	    return true;
	  },
	  canBeProcessedLocally: function () {
	    return !this.needsCacheToRender();
	  },
	  _representationType: function () {
	    return this.needsCacheToRender() ? 'server' : 'local';
	  },
	  needsCacheToRender: function () {
	    if (!_config.Config.renderLocallyWhenPossible) {
	      return true;
	    }
	    return !_config.Config.localRaster;
	  },
	  quickToDraw: function () {
	    return false; // ! this._colorMap;
	  },
	  preparedToDraw: function (zoom) {
	    if (this._encodedImage != null) {
	      return true;
	    } else {
	      var quantumSize = _config.Config.bypassQuantums ? null : this.quantumSizeToDraw(zoom);
	      return !!_quantumImage.QuantumImage.get(this._imageLink, quantumSize);
	    }
	  },
	  prepareToDraw$: function (zoom) {
	    if (this._encodedImage != null) {
	      // do something ?
	    } else {
	      var quantumSize = _config.Config.bypassQuantums ? null : this.quantumSizeToDraw(zoom);
	      return _quantumImage.QuantumImage.cache$(this._imageLink, quantumSize);
	    }
	  },
	  quantumSizeToDraw: function (zoom) {
	    var frame = this.globalFrame_();
	
	    var vw = frame.width * zoom;
	    var vh = frame.height * zoom;
	
	    var wpx = this.width_px(),
	        hpx = this.height_px();
	
	    return _quantumImage.QuantumImage.sizeToDraw(vw, vh, wpx, hpx);
	  },
	  _draw: function (context, transform, config) {
	    var _this2 = this;
	
	    var overlayedNoClip = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
	
	    var _this = this;
	
	    context.save();
	
	    if (!overlayedNoClip) {
	      var _getClippedBy = this.getClippedBy();
	
	      var _getClippedBy2 = _slicedToArray(_getClippedBy, 2);
	
	      var lClipContent = _getClippedBy2[0];
	      var lClipParent = _getClippedBy2[1];
	
	      if (lClipContent) {
	        if (lClipContent.editingClip) {
	          context.restore();
	          _this._draw(context, transform, config, true);
	          context.save();
	        }
	        var lOldTransform = transform;
	        if (!lClipContent.clipAbsolute && !lClipContent.editingClip) {
	          transform = _geometry.Matrix.m(transform, lClipParent.globalMatrix_());
	        }
	        lClipContent.clipContext(context, transform);
	        //DEBUG
	        // const ps = lClipContent._polyregions;
	        // for(let k=0,kEnd=ps.length;k<kEnd;++k) { const p = ps[k];
	        //   p.draw(context,transform,config);
	        // }
	        //END DEBUG
	        transform = lOldTransform;
	      }
	    }
	
	    var wireframe = config && config.wireframe;
	    if (wireframe) {
	      context.globalAlpha *= 0.5;
	    }
	
	    var imageLink = _this._imageLink,
	        width_px = _this.width_px(),
	        height_px = _this.height_px();
	
	    // Draw the raster using the best resolution we have til the moment
	    var zoom = transform.scaleFactor();
	
	    var quantumSize = _this.quantumSizeToDraw(zoom);
	
	    var colorMap = this._colorMap;
	    var colorMapImageMaxSize = _config.Config.colorMapImageMaxSize;
	
	    if (colorMap && (quantumSize === null || quantumSize > colorMapImageMaxSize)) {
	      // quantumSize could be null if we are retrieving the full image
	      // and the full image is larger than the maximum element 
	      // in the quantumSizes array in quantum-image.js
	      quantumSize = colorMapImageMaxSize;
	    } else if (_config.Config.bypassQuantums) {
	      // no color map & bypass => retrieve full image
	      quantumSize = null;
	    }
	
	    var image = void 0;
	    if (this._cachedImage != null) {
	      image = this._cachedImage;
	    } else if (this._encodedImage != null) {
	      setTimeout(function () {
	        (0, _gear.imagePromise)('data:image/png;base64,' + _this2._encodedImage).then(function (image) {
	          _this._cachedImage = image;
	          var topFigure = _this.topFigure;
	          if (topFigure) {
	            topFigure.redraw$();
	          }
	        });
	      }, 0);
	    } else {
	      image = _quantumImage.QuantumImage.get(imageLink, quantumSize);
	
	      if (!image) {
	
	        // We need to use a timeout here to clean up the call stack
	        // This is due to Jquery promises, we need to move forward soon
	        setTimeout(function () {
	          _quantumImage.QuantumImage.cache$(imageLink, quantumSize).then(function () {
	            var topFigure = _this.topFigure;
	            if (topFigure) {
	              topFigure.redraw$();
	            }
	          });
	        }, 0);
	
	        image = _quantumImage.QuantumImage.getBest(imageLink, quantumSize);
	      }
	    }
	
	    var t = _geometry.Matrix.m(transform, _this.globalMatrix_());
	
	    t = _geometry.Matrix.concat(t, _geometry.Matrix.translate(0, _this.height_mm()), _geometry.Matrix.scale(1, -1), _geometry.Matrix.scale(25.4 / _this._dpi));
	
	    if (image) {
	
	      var imageSize = Math.max(image.width, image.height);
	
	      if (colorMap) {
	        // Pass unique id string for caching, size cache is taken care internally
	        // console.log('recolorize');
	        var lCM = colorMap;
	        if (config.showthroughColor && config.showthroughColor.alpha != 0.0) {
	          lCM = colorMap.clone();
	          var lNrColors = lCM.colors.length;
	          for (var i = 0; i < lNrColors; i++) {
	            if (lCM.colors[i].showThrough) {
	              lCM.colors[i].rgb = config.showthroughColor.rgb;
	              lCM.colors[i].alpha = 1.0;
	            }
	          }
	        }
	
	        image = lCM.recolorize(image, imageLink);
	      }
	
	      var hueShift = this._hueShift;
	      var saturationShift = this._saturationShift;
	      var lightShift = this._lightShift;
	      if (hueShift != 0 || saturationShift != 0 || lightShift != 0) {
	        image = (0, _hslShift.hslShift_gl)(image, hueShift, saturationShift, lightShift);
	      }
	
	      var preImageScale = Math.max(width_px, height_px) / imageSize;
	
	      var matrix = _geometry.Matrix.m(t, _geometry.Matrix.scale(preImageScale));
	      matrix.transformContext(context);
	      if (_config.Config.smoothRasterOnZoom !== undefined) context.imageSmoothingEnabled = _config.Config.smoothRasterOnZoom;
	      context.drawImage(image, 0, 0);
	    } else {
	      // While waiting for the first quantum, draw a semi transparent mask
	      t.transformContext(context);
	      context.rect(0, 0, width_px, height_px);
	      context.fillStyle = 'rgba(0, 100, 0, 0.2)';
	      context.fill();
	    }
	
	    if (wireframe) {
	      var frame = _this.globalFrame_();
	      frame.draw(context, transform);
	
	      context.lineWidth = 1;
	      (0, _gear.setLineDash)(context, [4, 3]);
	      (0, _gear.strokeWireframe)(context);
	    }
	
	    context.restore();
	
	    if (overlayedNoClip) {
	      context.save();
	      context.beginPath();
	      t.transformContext(context);
	      context.rect(0, 0, width_px, height_px);
	      context.fillStyle = 'rgba(255, 255, 255, 0.5)';
	      context.fill(this.windingRule);
	      context.restore();
	    }
	  },
	  pixelsToMillimeters: function (pixels) {
	    return pixels / this._dpi * 25.4;
	  },
	  globalDpi$: function (v) {
	    var me = this;
	    return this.update$().then(function () {
	      var gdpi = me.globalDpi_();
	      if (v === undefined) {
	        return gdpi;
	      } else {
	        return me.scale$(gdpi / v);
	      }
	    });
	  },
	  globalDpi_: function () {
	    if (this._owner instanceof _powerClip.PowerClipContent) {
	      var pc = this._owner;
	      if (pc._owner instanceof _figure.Figure) {
	        return this._dpi / (pc._owner.matrix_().scaleFactor() * this.matrix_().scaleFactor());
	      }
	    }
	    var lFinalMatrix = this.matrix_();
	    var lParent = this._owner;
	    while (lParent != null && lParent.isGroup) {
	      lFinalMatrix = _geometry.Matrix.m(lParent.matrix_(), lFinalMatrix);
	      lParent = lParent._owner;
	    }
	
	    return this._dpi / lFinalMatrix.scaleFactor();
	  },
	  boundsIsVectorBounds: function () {
	    return true;
	  },
	
	
	  // Only pixels are supported right now
	  // We may allow different metrics here, coding in the CDL directly the pixels
	  // to avoid any slow down
	
	  width_px: function () {
	    if (this._width) {
	      return this._width.toType('px');
	    }
	    return 0;
	  },
	  height_px: function () {
	    if (this._height) {
	      return this._height.toType('px');
	    }
	    return 0;
	  },
	  width_mm: function () {
	    return this.pixelsToMillimeters(this.width_px());
	  },
	  height_mm: function () {
	    return this.pixelsToMillimeters(this.height_px());
	  },
	  _primitive_computePreReferencePoint: function () {
	    return new _geometry.Point(0, 0);
	  },
	  _primitive_computePreVectorBounds: function () {
	    if (this._width && this._height && this._dpi) {
	      return new _geometry.Bounds(0, 0, this.width_mm(), this.height_mm());
	    } else {
	      return new _geometry.Bounds(0, 0, 100, 100);
	    }
	  },
	  _primitive_computePreVectorBoundsAfter: function (transform) {
	    return _geometry.Frame.fromBounds(this._primitive_computePreVectorBounds()).transformed(transform).bounds;
	  },
	  _primitive_computePreBounds: function () {
	    return this._primitive_computePreVectorBounds();
	  },
	  _primitive_computePreBoundsAfter: function (transform) {
	    return this._primitive_computePreVectorBoundsAfter(transform);
	  },
	  hasPreview: function () {
	    return false;
	  },
	  otherBrushes: function (brushes) {
	    var colorMap = this._colorMap;
	    if (colorMap && colorMap.brush) {
	      brushes.push(colorMap.brush);
	    }
	  },
	  otherColors: function () {
	    var colors = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    var colorMap = this._colorMap;
	    if (colorMap) {
	      colorMap.getColors(colors);
	    }
	    return colors;
	  },
	  buildXml: function (parentNode) {
	    _util.Xml.addObject(parentNode, this, 'Raster');
	  },
	  generateOutputFigure$: function () {
	    var _this = this,
	        imageLink = _this._imageLink;
	
	    if (this._encodedImage != null) {
	      return (0, _gear.resolve)(_this);
	    } else if (imageLink) {
	      if (_this._width && _this._height && !_config.Config.rasterPreviewForced) {
	        // We do not need to call read info, we have all the info needed cached in the CDL
	
	        if (!_quantumImage.QuantumImage.getInfo(imageLink)) {
	          _quantumImage.QuantumImage.setInfo(imageLink, { width: _this.width_px(),
	            height: _this.height_px() });
	        }
	
	        return (0, _gear.resolve)(_this);
	      } else {
	
	        return _quantumImage.QuantumImage.info$(imageLink).then(function (info) {
	
	          // Once we start accepting different units, we need to change this
	          // This is left for a future extension
	          _this._width = _gear.Magnitude.parse(info.width + 'px');
	          _this._height = _gear.Magnitude.parse(info.height + 'px');
	
	          return _this;
	        });
	      }
	    } else {
	      // [TODO]
	      console.log('imageLink is empty');
	      return (0, _gear.resolve)(null);
	    }
	  },
	  toPrimitive: function () {
	    return this.clone(); // We may create a GRaster
	  },
	  toGShape: function () {
	    var frame = this.frame_();
	    var p0 = frame.p0.clone(),
	        p1 = frame.p1.clone(),
	        p2 = frame.p2.clone(),
	        p3 = frame.p3.clone();
	    var curve = (0, _geometry.Curve)([(0, _geometry.Segment)(p0, p1), (0, _geometry.Segment)(p1, p2), (0, _geometry.Segment)(p2, p3), (0, _geometry.Segment)(p3, p0)], true);
	    var regions = [(0, _shape.Region)([curve])];
	    return (0, _shape.GShape)({ polyregions: [(0, _shape.Polyregion)({ regions: regions })] });
	  }
	});
	
	Raster.parseXml = function (node, bcFixes) {
	  var raster = new Raster();
	
	  _figure.Figure._baseParseXml.call(raster, node, Raster, bcFixes);
	
	  // [BC] Remove Pen in case of old CDLs
	  var penNode = _util.Xml.child(node, 'Pen');
	  if (penNode && penNode.getAttribute('Color')) {
	    // Old pen type, CDL 1.0
	    raster.pen = (0, _style.EmptyPen)();
	  }
	
	  return raster;
	};

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hslShift_gl = undefined;
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	var _geometry = __webpack_require__(21);
	
	var _color = __webpack_require__(31);
	
	var _colorSpace = __webpack_require__(30);
	
	var _colorShift = __webpack_require__(63);
	
	var toImageData = function (image) {
	  var context = void 0;
	  if (image instanceof HTMLImageElement) {
	    var canvas = document.createElement('canvas');
	    canvas.width = image.width;
	    canvas.height = image.height;
	    context = canvas.getContext('2d');
	    context.drawImage(image, 0, 0);
	  } else {
	    context = image.getContext('2d');
	  }
	  return context.getImageData(0, 0, image.width, image.height);
	};
	
	var toCanvas = function (imageData) {
	  var canvas = document.createElement('canvas');
	  canvas.width = imageData.width;
	  canvas.height = imageData.height;
	  canvas.getContext('2d').putImageData(imageData, 0, 0);
	  return canvas;
	};
	
	var _floor = Math.floor,
	    _min = Math.min,
	    _max = Math.max,
	    _sqrt = Math.sqrt;
	
	var interpolate_value = function (l1, l2, a) {
	  return l1 + (l2 - l1) * a;
	};
	
	// values between 0...255
	// map :: function(r,g,b,a){ return [ r*, g*, b*, a* ]; }
	
	var modifyImageDataRGBA = function (imageData, map) {
	  var data = imageData.data,
	      width = imageData.width,
	      height = imageData.height;
	  var y = void 0,
	      x = void 0,
	      inpos = void 0,
	      outpos = void 0,
	      r = void 0,
	      g = void 0,
	      b = void 0,
	      a = void 0;
	
	  for (y = 0; y < height; ++y) {
	    inpos = y * width * 4; // *4 for 4 ints per pixel
	    outpos = inpos;
	    for (x = 0; x < width; ++x) {
	
	      r = data[inpos++];
	      g = data[inpos++];
	      b = data[inpos++];
	      a = data[inpos++]; // alpha
	
	      // http://www.w3.org/TR/AERT#color-contrast
	      var c = map(r, g, b, a);
	
	      data[outpos++] = c[0];
	      data[outpos++] = c[1];
	      data[outpos++] = c[2];
	      data[outpos++] = c[3];
	    }
	  }
	};
	
	// values between 0...255
	// map :( r,g,b) { return [ r*, g*, b* ]; }
	
	var modifyImageDataRGB = function (imageData, map) {
	  var data = imageData.data,
	      width = imageData.width,
	      height = imageData.height;
	  var y = void 0,
	      x = void 0,
	      inpos = void 0,
	      outpos = void 0,
	      r = void 0,
	      g = void 0,
	      b = void 0;
	
	  for (y = 0; y < height; ++y) {
	    inpos = y * width * 4; // *4 for 4 ints per pixel
	    outpos = inpos;
	    for (x = 0; x < width; ++x) {
	
	      r = data[inpos++];
	      g = data[inpos++];
	      b = data[inpos++];
	
	      ++inpos; // alpha
	
	      // http://www.w3.org/TR/AERT#color-contrast
	      var c = map(r, g, b);
	
	      data[outpos++] = c[0];
	      data[outpos++] = c[1];
	      data[outpos++] = c[2];
	
	      ++outpos; // alpha
	    }
	  }
	};
	
	// HSLShift
	//======================================================================================
	var hslShift = function (image, hShift, sShift, lShift) {
	  var imageData = toImageData(image);
	
	  modifyImageDataRGB(imageData, function (r, g, b) {
	    var c = (0, _colorSpace.rgb2hsl)([r, g, b]);
	    c[0] += hShift;
	    while (c[0] > 360) {
	      c[0] -= 360;
	    }
	    while (c[0] < 0) {
	      c[0] += 360;
	    }
	
	    c[1] += sShift * 100;
	    if (c[1] < 0) c[1] = 0;else if (c[1] > 100) c[1] = 100;
	
	    c[2] += lShift * 100;
	    if (c[2] < 0) c[2] = 0;else if (c[2] > 100) c[2] = 100;
	
	    return (0, _colorSpace.hsl2rgb)(c);
	  });
	
	  return toCanvas(imageData);
	};
	
	// HSLShift
	//======================================================================================
	var mGlCanvas = null;
	var mGlCtx = null;
	var mEffect = null;
	var hslShift_gl = exports.hslShift_gl = function (image, hShift, sShift, lShift) {
	
	  if (mGlCanvas == null) {
	    mGlCanvas = document.createElement('canvas');
	    mGlCtx = mGlCanvas.getContext('webgl', { premultipliedAlpha: false });
	
	    if (mGlCtx != null) {
	      mGlCtx.pixelStorei(mGlCtx.UNPACK_ALIGNMENT, 1);
	      mEffect = new _colorShift.ColorShiftEffect(mGlCtx);
	
	      //pass in clipspace coordiantes to vertex shader
	      var lPositionsBuffer = mGlCtx.createBuffer();
	      mGlCtx.bindBuffer(mGlCtx.ARRAY_BUFFER, lPositionsBuffer);
	      mGlCtx.bufferData(mGlCtx.ARRAY_BUFFER, new Float32Array([-1.0, -1.0, 1.0, -1.0, -1.0, 1.0, -1.0, 1.0, 1.0, -1.0, 1.0, 1.0]), mGlCtx.STATIC_DRAW);
	
	      //pass in texture coordinates to vertext shader
	      var lTexCoordBuffer = mGlCtx.createBuffer();
	      mGlCtx.bindBuffer(mGlCtx.ARRAY_BUFFER, lTexCoordBuffer);
	      mGlCtx.bufferData(mGlCtx.ARRAY_BUFFER, new Float32Array([0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 0.0, 1.0, 1.0]), mGlCtx.STATIC_DRAW);
	
	      //pass in clipspace coordiantes to vertex shader
	      mGlCtx.bindBuffer(mGlCtx.ARRAY_BUFFER, lPositionsBuffer);
	      mGlCtx.enableVertexAttribArray(mEffect.a_position);
	      mGlCtx.vertexAttribPointer(mEffect.a_position, 2, mGlCtx.FLOAT, false, 0, 0);
	
	      //pass in texture coordinates to vertext shader
	      mGlCtx.bindBuffer(mGlCtx.ARRAY_BUFFER, lTexCoordBuffer);
	      mGlCtx.enableVertexAttribArray(mEffect.a_texCoord);
	      mGlCtx.vertexAttribPointer(mEffect.a_texCoord, 2, mGlCtx.FLOAT, false, 0, 0);
	    }
	  }
	
	  if (mGlCtx == null) {
	    return hslShift(image, hShift, sShift, lShift); //Fallback to slow implementation
	  }
	
	  mGlCanvas.width = image.width;
	  mGlCanvas.height = image.height;
	  mGlCtx.viewport(0, 0, mGlCanvas.width, mGlCanvas.height);
	
	  var texture = mGlCtx.createTexture();
	  mGlCtx.activeTexture(mGlCtx.TEXTURE0);
	  mGlCtx.bindTexture(mGlCtx.TEXTURE_2D, texture);
	  mGlCtx.texImage2D(mGlCtx.TEXTURE_2D, 0, mGlCtx.RGBA, mGlCtx.RGBA, mGlCtx.UNSIGNED_BYTE, image);
	  if (mGlCtx.getError() != mGlCtx.NO_ERROR) {
	    return hslShift(image, hShift, sShift, lShift); //Fallback to slow implementation
	  }
	  mGlCtx.texParameteri(mGlCtx.TEXTURE_2D, mGlCtx.TEXTURE_WRAP_S, mGlCtx.CLAMP_TO_EDGE);
	  mGlCtx.texParameteri(mGlCtx.TEXTURE_2D, mGlCtx.TEXTURE_WRAP_T, mGlCtx.CLAMP_TO_EDGE);
	  mGlCtx.texParameteri(mGlCtx.TEXTURE_2D, mGlCtx.TEXTURE_MIN_FILTER, mGlCtx.NEAREST);
	  mGlCtx.texParameteri(mGlCtx.TEXTURE_2D, mGlCtx.TEXTURE_MAG_FILTER, mGlCtx.NEAREST);
	
	  mEffect.update(hShift, sShift, lShift);
	  mGlCtx.drawArrays(mGlCtx.TRIANGLES, 0, 6);
	
	  return mGlCanvas;
	};

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColorShiftEffect = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _effect = __webpack_require__(64);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColorShiftEffect = exports.ColorShiftEffect = function (_Effect) {
	  _inherits(ColorShiftEffect, _Effect);
	
	  function ColorShiftEffect(aGl) {
	    _classCallCheck(this, ColorShiftEffect);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ColorShiftEffect).call(this, aGl));
	
	    _this.fragmentShader = "\n        precision mediump float;\n        // our texture\n        uniform sampler2D u_image0;\n\n        // the texCoords passed in from the vertex shader.\n        varying vec2 v_texCoord;\n\n        uniform float u_hShift;\n        uniform float u_sShift;\n        uniform float u_lShift;\n\n        vec3 rgb2hsv(vec3 c)\n        {\n        // vec4 K = vec4(0.0, -1.0 / 3.0, 2.0 / 3.0, -1.0);\n        // vec4 p = mix(vec4(c.bg, K.wz), vec4(c.gb, K.xy), step(c.b, c.g));\n        // vec4 q = mix(vec4(p.xyw, c.r), vec4(c.r, p.yzx), step(p.x, c.r));\n\n        // float d = q.x - min(q.w, q.y);\n        // float e = 1.0e-10;\n        // return vec3(abs(q.z + (q.w - q.y) / (6.0 * d + e)), d / (q.x + e), q.x);\n            \n          float lmin = min(min(c.r, c.g), c.b);\n          float lmax = max(max(c.r, c.g), c.b);\n          float delta = lmax - lmin;\n          vec3 hsl;\n\n          if(lmax == lmin) {\n            hsl.x = 0.0;\n          }\n          else if(c.r == lmax) {\n            hsl.x = (c.g - c.b) / delta;\n          }\n          else if(c.g == lmax) {\n            hsl.x = 2.0 + (c.b - c.r) / delta;\n          }\n          else if(c.b == lmax) {\n            hsl.x = 4.0 + (c.r - c.g)/ delta;\n          }\n\n          hsl.x = min(hsl.x * 60.0, 360.0);\n\n          if(hsl.x < 0.0) {\n            hsl.x += 360.0;\n          }\n\n          hsl.z = (lmin + lmax) / 2.0;\n\n          if(lmax == lmin) {\n            hsl.y = 0.0;\n          }\n          else if(hsl.z <= 0.5) {\n            hsl.y = delta / (lmax + lmin);\n          }\n          else {\n            hsl.y = delta / (2.0 - lmax - lmin);\n          }\n\n          return vec3(hsl.x, hsl.y, hsl.z);\n        }\n\n        vec3 hsv2rgb(vec3 c)\n        {\n            // vec4 K = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);\n            // vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);\n            // return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);\n          \n          float h = c.x / 360.0;\n          float s = c.y;\n          float l = c.z;\n          float t1, t2, t3, val;\n          vec3 rgb = vec3(0.0, 0.0, 0.0);\n\n          if(s == 0.0) {\n            return vec3(val, val, val);\n          }\n\n          if(l < 0.5) {\n            t2 = l * (1.0 + s);\n          }\n          else {\n            t2 = l + s - l * s;\n          }\n          t1 = 2.0 * l - t2;\n\n          t3 = h + 1.0 / 3.0;\n          if( t3 < 0.0 ) { ++t3; }\n          if( t3 > 1.0 ) { --t3; }\n          if(6.0 * t3 < 1.0) {\n            val = t1 + (t2 - t1) * 6.0 * t3;\n          }\n          else if(2.0 * t3 < 1.0) {\n            val = t2;\n          }\n          else if(3.0 * t3 < 2.0) {\n            val = t1 + (t2 - t1) * (2.0 / 3.0 - t3) * 6.0;\n          }\n          else {\n            val = t1;\n          }\n          rgb.x = val;\n\n          t3 = h;\n          if( t3 < 0.0 ) { ++t3; }\n          if( t3 > 1.0 ) { --t3; }\n          if(6.0 * t3 < 1.0) {\n            val = t1 + (t2 - t1) * 6.0 * t3;\n          }\n          else if(2.0 * t3 < 1.0) {\n            val = t2;\n          }\n          else if(3.0 * t3 < 2.0) {\n            val = t1 + (t2 - t1) * (2.0 / 3.0 - t3) * 6.0;\n          }\n          else {\n            val = t1;\n          }\n          rgb.y = val;\n\n          t3 = h - 1.0 / 3.0;\n          if( t3 < 0.0 ) { ++t3; }\n          if( t3 > 1.0 ) { --t3; }\n          if(6.0 * t3 < 1.0) {\n            val = t1 + (t2 - t1) * 6.0 * t3;\n          }\n          else if(2.0 * t3 < 1.0) {\n            val = t2;\n          }\n          else if(3.0 * t3 < 2.0) {\n            val = t1 + (t2 - t1) * (2.0 / 3.0 - t3) * 6.0;\n          }\n          else {\n            val = t1;\n          }\n          rgb.z = val;\n\n          return rgb;\n        }\n\n        void main() {\n        // Look up a color from the texture.\n        vec4 bg = texture2D(u_image0, v_texCoord);\n        vec3 hsv = rgb2hsv(bg.rgb);\n\n        gl_FragColor = vec4( hsv2rgb(vec3( \n                                              mod((hsv.x+u_hShift),360.0)\n                                            , min(max(hsv.y+u_sShift,0.0),1.0)\n                                            , min(max(hsv.z+u_lShift,0.0),1.0)))\n                                            , bg.a );\n        }\n        ";
	
	    _this.vertexShader = "\n        attribute vec2 a_position;\n        attribute vec2 a_texCoord;\n        varying vec2 v_texCoord;\n        void main() {\n        gl_Position = vec4(a_position * vec2(1,-1), 0, 1);\n        v_texCoord = a_texCoord;\n        }\n    ";
	
	    _this.addShader(_this.vertexShader, _this.gl.VERTEX_SHADER);
	    _this.addShader(_this.fragmentShader, _this.gl.FRAGMENT_SHADER);
	
	    //link the program
	    _this.gl.linkProgram(_this.program);
	
	    //throw exception if program doesn't link
	    if (!_this.gl.getProgramParameter(_this.program, _this.gl.LINK_STATUS)) {
	      var lastError = _this.gl.getProgramInfoLog(_this.program);
	      _this.gl.deleteProgram(_this.program);
	      throw lastError;
	    }
	
	    _this.u_image0 = _this.gl.getUniformLocation(_this.program, "u_image0");
	    _this.u_hShift = _this.gl.getUniformLocation(_this.program, "u_hShift");
	    _this.u_sShift = _this.gl.getUniformLocation(_this.program, "u_sShift");
	    _this.u_lShift = _this.gl.getUniformLocation(_this.program, "u_lShift");
	
	    _this.a_position = _this.gl.getAttribLocation(_this.program, "a_position");
	    _this.a_texCoord = _this.gl.getAttribLocation(_this.program, "a_texCoord");
	
	    _this.activate();
	    _this.gl.uniform1i(_this.u_image0, 0); // texture unit image
	    return _this;
	  }
	
	  _createClass(ColorShiftEffect, [{
	    key: "update",
	    value: function update(hShift, sShift, lShift) {
	      this.activate();
	      this.gl.uniform1f(this.u_hShift, hShift);
	      this.gl.uniform1f(this.u_sShift, sShift);
	      this.gl.uniform1f(this.u_lShift, lShift);
	    }
	  }]);

	  return ColorShiftEffect;
	}(_effect.Effect);

/***/ },
/* 64 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//Shaders need to expose a_position and a_texCoord 
	
	var Effect = exports.Effect = function () {
	  function Effect(aGl) {
	    _classCallCheck(this, Effect);
	
	    this.gl = aGl;
	    this.program = this.gl.createProgram();
	  }
	
	  _createClass(Effect, [{
	    key: "addShader",
	    value: function addShader(aShaderSource, aShaderType) {
	      //create the shader.
	      var lShader = this.gl.createShader(aShaderType);
	      //load the shader source
	      this.gl.shaderSource(lShader, aShaderSource);
	      //compile the shader
	      this.gl.compileShader(lShader);
	
	      //throw exception if the shader doesn't compile
	      if (!this.gl.getShaderParameter(lShader, this.gl.COMPILE_STATUS)) {
	        var lastError = this.gl.getShaderInfoLog(lShader);
	        this.gl.deleteShader(lShader);
	        throw lastError;
	      }
	
	      //attach the shader to the program
	      this.gl.attachShader(this.program, lShader);
	    }
	  }, {
	    key: "activate",
	    value: function activate() {
	      this.gl.useProgram(this.program);
	    }
	  }]);

	  return Effect;
	}();

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProxyGroup = undefined;
	
	var _config = __webpack_require__(2);
	
	var _util = __webpack_require__(17);
	
	var _geometry = __webpack_require__(21);
	
	var _figure = __webpack_require__(39);
	
	var _shape = __webpack_require__(45);
	
	var _anchor = __webpack_require__(42);
	
	var _invalidate = function () {
	  this.invalidate();
	};
	
	var ProxyGroup = exports.ProxyGroup = _figure.Figure.ProxyGroup = _figure.Figure.extend({ typeName: 'ProxyGroup',
	
	  type: 'ProxyGroup',
	
	  Properties: {
	    link: { type: 'string', def: null, dropDef: true, onChange: _invalidate },
	    width: { type: 'magnitude', def: null, dropDef: true },
	    height: { type: 'magnitude', def: null, dropDef: true },
	    colorMap: { type: 'ColorMap', def: null, dropDef: true, owned: true, onChange: _invalidate }
	  },
	
	  get isProxyGroup() {
	    return true;
	  },
	
	  containsLinkedResources: function () {
	    return true;
	  },
	  _primitive_computePreReferencePoint: function () {
	    // console.log('_primitive_computePreReferencePoint');
	    return new _geometry.Point(0, 0);
	  },
	  _primitive_computePreVectorBounds: function () {
	    // console.log('_primitive_computePreVectorBounds');
	    if (this._width && this._height) {
	      var w = this._width.toMM(),
	          h = this._height.toMM();
	      return new _geometry.Bounds(-w / 2, -h / 2, w / 2, h / 2);
	    } else {
	      return new _geometry.Bounds(-50, -50, 50, 50);
	    }
	  },
	  _primitive_computePreVectorBoundsAfter: function (transform) {
	    // console.log('_primitive_computePreVectorBoundsAfter');
	    return _geometry.Frame.fromBounds(this._primitive_computePreVectorBounds()).transformed(transform).bounds;
	  },
	  _primitive_computePreBounds: function () {
	    // console.log('_primitive_computePreBounds');
	    return this._primitive_computePreVectorBounds();
	  },
	  _primitive_computePreBoundsAfter: function (transform) {
	    // console.log('_primitive_computePreVectorBoundsAfter');
	    return this._primitive_computePreVectorBoundsAfter(transform);
	  },
	  supportsLocalMetrics: function () {
	    // We need to use the server to compute metrics of proxy groups
	    // In order to compute the grouped figure bounds we need to use the
	    // transform of the parent, so the only way we can work this out is
	    // to use the parent group like a proxy group and let the server do
	    // all the work
	    return false;
	  },
	  needsCacheToRender: function () {
	    return true;
	  },
	  _representationType: function () {
	    return 'server';
	  },
	  hasPreview: function () {
	    return false;
	  },
	  otherColors: function () {
	    var colors = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    var colorMap = this._colorMap;
	    if (colorMap) {
	      colorMap.getColors(colors);
	    }
	    return colors;
	  },
	  buildXml: function (parentNode) {
	    _util.Xml.addObject(parentNode, this, 'ProxyGroup');
	  }
	});
	
	ProxyGroup.parseXml = function (node, bcFixes) {
	  var proxyGroup = new ProxyGroup();
	
	  _figure.Figure._baseParseXml.call(proxyGroup, node, ProxyGroup, bcFixes);
	
	  return proxyGroup;
	};
	
	var ProxyGroupOutput = _shape.Shape.extend({ typeName: 'ProxyGroupOutput',
	  needsCacheToRender: function () {
	    return true;
	  },
	  _representationType: function () {
	    return 'server';
	  }
	});
	
	_figure.Figure.createProxyGroupOutput = function (figure, preBounds, prePin) {
	  if (_config.Config.serverProxyGroupMetrics) {
	    // If we use server metrics, there is no need for local bounds computation
	    return figure;
	  } else {
	    // We create a rectangular outline shape so the proxygroup works like a raster
	    // wrt metrics. This makes the system faster because we can use local metrics.
	    var polyregion = _shape.Polyregion.CreateRectangle({ bounds: preBounds });
	    return new ProxyGroupOutput({
	      polyregions: [polyregion],
	      anchor: (0, _anchor.AbsoluteAnchor)(prePin),
	      matrix22: figure._matrix22,
	      pin: figure.pin
	    });
	  }
	};

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FigureConditions_Mixin = undefined;
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _figure = __webpack_require__(39);
	
	var conditions = _figure.Figure._condition = {};
	var arrayConditions = _figure.Figure._arrayCondition = {};
	
	var composeCondition = function (fo, fn) {
	  return function (x) {
	    return fo(x) && fn(x);
	  };
	};
	var composeCondition$ = function (fo, fn) {
	  return function (x) {
	    return (0, _gear.and$)(fo(x), fn(x));
	  };
	};
	
	var addCondition = function (conditions, name, cond) {
	  if (typeof name !== 'string') {
	    return (0, _lodash.forEach)(name, function (c, n) {
	      addCondition(conditions, n, c);
	    });
	  }
	
	  // Support for alias, like Figure.arrayCondition('groupable', '2+');
	  if (typeof cond === 'string') {
	    if (cond[0] === '!') {
	      cond = cond.slice(1);
	      cond = cond[cond.length - 1] === '$' ? function () {
	        return (0, _gear.not$)(conditions[cond]);
	      } : function () {
	        return !conditions[cond];
	      };
	    } else {
	      cond = conditions[cond];
	    }
	  }
	
	  var cc = conditions[name];
	  if (cc) {
	    if (name[name.length - 1] === '$') {
	      conditions[name] = composeCondition$(cc, cond);
	    } else {
	      conditions[name] = composeCondition(cc, cond);
	    }
	  } else {
	    conditions[name] = cond;
	  }
	};
	
	var Figure_condition = _figure.Figure.condition = function (name, cond) {
	  addCondition(conditions, name, cond);
	};
	var Figure_arrayCondition = _figure.Figure.arrayCondition = function (name, cond) {
	  addCondition(arrayConditions, name, cond);
	};
	
	var restoreConditions = null;
	var restoreArrayConditions = null;
	
	_figure.Figure.saveConditions = function () {
	  restoreConditions = (0, _gear.clone)(conditions);
	  restoreArrayConditions = (0, _gear.clone)(arrayConditions);
	};
	_figure.Figure.restoreConditions = function () {
	  conditions = (0, _gear.clone)(restoreConditions);
	  arrayConditions = (0, _gear.clone)(restoreArrayConditions);
	};
	
	var FigureConditions_Mixin = exports.FigureConditions_Mixin = {
	  init: function (config) {
	    this.callParent.apply(this, arguments);
	
	    this._conditions = {};
	    this._arrayConditions = {};
	
	    var cc = config.condition;
	    if (cc) {
	      this.condition(cc);
	    }
	    var acc = config.arrayCondition;
	    if (acc) {
	      this.arrayCondition(acc);
	    }
	  },
	  condition: function (name, cond) {
	    addCondition(this._conditions, name, cond);
	  },
	  arrayCondition: function (name, cond) {
	    addCondition(this._arrayConditions, name, cond);
	  },
	  _createCondition: function (conditions, this_conditions, name) {
	    var tc = void 0,
	        fc = void 0;
	    if (name[0] === '!') {
	      name = name.slice(1);
	      tc = this_conditions[name];if (tc) {
	        tc = tc.bind(this);
	      }
	      fc = conditions[name];
	      return tc && fc ? function (v) {
	        return !fc(v) && !tc(v);
	      } : tc && !fc ? function (v) {
	        return !tc(v);
	      } : !tc && fc ? function (v) {
	        return !fc(v);
	      } : null;
	    } else {
	      tc = this_conditions[name];if (tc) {
	        tc = tc.bind(this);
	      }
	      fc = conditions[name];
	      return tc && fc ? function (v) {
	        return fc(v) && tc(v);
	      } : tc && !fc ? tc : !tc && fc ? fc : null;
	    }
	  },
	  _createCondition$: function (conditions, this_conditions, name) {
	    var tc = void 0,
	        fc = void 0;
	    if (name[0] === '!') {
	      name = name.slice(1);
	      tc = this_conditions[name];if (tc) {
	        tc = tc.bind(this);
	      }
	      fc = conditions[name];
	      return tc && fc ? function (v) {
	        return (0, _gear.not$)((0, _gear.or$)(fc(v), tc(v)));
	      } : tc && !fc ? function (v) {
	        return (0, _gear.not$)(tc(v));
	      } : !tc && fc ? function (v) {
	        return (0, _gear.not$)(fc(v));
	      } : null;
	    } else {
	      tc = this_conditions[name];if (tc) {
	        tc = tc.bind(this);
	      }
	      fc = conditions[name];
	      return tc && fc ? function (v) {
	        return (0, _gear.and$)(fc(v), tc(v));
	      } : tc && !fc ? tc : !tc && fc ? fc : null;
	    }
	  },
	  _condition: function (name) {
	    return this._createCondition(conditions, this._conditions, name);
	  },
	  _arrayCondition: function (name) {
	    return this._createCondition(arrayConditions, this._arrayConditions, name);
	  },
	  _condition$: function (name) {
	    return this._createCondition$(conditions, this._conditions, name);
	  },
	  _arrayCondition$: function (name) {
	    return this._createCondition$(arrayConditions, this._arrayConditions, name);
	  },
	  is: function (figure, condition) {
	    var _this = this;
	
	    if (arguments.length === 2) {
	      if (typeof condition === 'string') {
	        return this._condition(condition)(figure);
	      }
	    } else {
	      condition = Array.prototype.slice.call(arguments, 1);
	    }
	    return (0, _lodash.every)(condition, function (c) {
	      return _this.is(figure, c);
	    });
	  },
	  is$: function (figure, condition) {
	    var _this2 = this;
	
	    if (arguments.length === 2) {
	      if (typeof condition === 'string') {
	        if (condition[condition.length - 1] === '$') {
	          return this._condition$(condition)(figure);
	        } else {
	          return (0, _gear.resolve)(this.is(figure, condition));
	        }
	      }
	    } else {
	      condition = Array.prototype.slice.call(arguments, 1);
	    }
	    return (0, _gear.every$)(condition, function (c) {
	      return _this2.is$(figure, c);
	    });
	  },
	  are: function (figures, condition) {
	    var _this3 = this;
	
	    if (typeof figures === 'string') {
	      figures = this[figures];
	    }
	
	    if (figures.length === 0) {
	      return false;
	    }
	    if (arguments.length === 2) {
	      if (typeof condition === 'string') {
	        var ac = this._arrayCondition(condition);
	        var fc = this._condition(condition);
	        // assert( ac || fc, 'Undefined Condition: '+condition );
	        if (ac && !ac(figures)) {
	          return false;
	        }
	        return fc ? (0, _lodash.every)(figures, fc) : true;
	      }
	    } else {
	      condition = Array.prototype.slice.call(arguments, 1);
	    }
	    return (0, _lodash.every)(condition, function (c) {
	      return _this3.are(figures, c);
	    });
	  },
	  are$: function (figures, condition) {
	    var _this4 = this;
	
	    if (typeof figures === 'string') {
	      figures = this[figures]();
	    }
	    if (figures.length === 0) {
	      return (0, _gear.resolve)(false);
	    }
	
	    if (arguments.length === 2) {
	      if (typeof condition === 'string') {
	        if (condition[condition.length - 1] === '$') {
	          var ac = this._arrayCondition$(condition);
	          var fc = this._condition$(condition);
	          // assert( ac || fc, 'Undefined Condition: '+condition );
	          if (ac && fc) {
	            return (0, _gear.and$)(ac(figures), (0, _gear.every$)(figures, fc));
	          } else if (ac) {
	            return ac(figures);
	          } else if (fc) {
	            return (0, _gear.every$)(figures, fc);
	          } else {
	            return (0, _gear.resolve)(false);
	          }
	        } else {
	          return (0, _gear.resolve)(this.are(figures, condition));
	        }
	      }
	    } else {
	      condition = Array.prototype.slice.call(arguments, 1);
	    }
	    return (0, _gear.every$)(condition, function (c) {
	      return _this4.are$(figures, c);
	    });
	  },
	  only: function (figures, condition) {
	    if (typeof figures === 'string') {
	      figures = this[figures];
	    }
	
	    if (figures.length === 0) {
	      return [];
	    }
	    if (arguments.length === 2) {
	      if (typeof condition === 'string') {
	        var ac = this._arrayCondition(condition);
	        var fc = this._condition(condition);
	        // assert( ac || fc, 'Undefined Condition: '+condition );
	        if (ac && !ac(figures)) {
	          return [];
	        }
	        return fc ? (0, _lodash.filter)(figures, fc) : true;
	      }
	    } else {
	      condition = Array.prototype.slice.call(arguments, 1);
	    }
	    var result = this.only(figures, condition[0]);
	    for (var k = 1, kEnd = condition.length; k < kEnd; ++k) {
	      result = this.only(result, condition[k]);
	    }
	    return result;
	  },
	  only$: function (figures, condition) {
	    var _this5 = this;
	
	    if (typeof figures === 'string') {
	      figures = this[figures]();
	    }
	    if (figures.length === 0) {
	      return (0, _gear.resolve)([]);
	    }
	
	    if (arguments.length === 2) {
	      if (typeof condition === 'string') {
	        if (condition[condition.length - 1] === '$') {
	          var _ret = function () {
	            var ac = _this5._arrayCondition$(condition);
	            var fc = _this5._condition$(condition);
	            // assert( ac || fc, 'Undefined Condition: '+condition );
	            if (ac) {
	              return {
	                v: ac(figures).then(function (r) {
	                  return r ? fc ? (0, _gear.filter$)(figures, fc) : figures : [];
	                })
	              };
	            } else if (fc) {
	              return {
	                v: (0, _gear.filter$)(figures, fc)
	              };
	            } else {
	              return {
	                v: (0, _gear.resolve)([])
	              };
	            }
	          }();
	
	          if (typeof _ret === "object") return _ret.v;
	        } else {
	          return (0, _gear.resolve)(this.only(figures, condition));
	        }
	      }
	    } else {
	      condition = Array.prototype.slice.call(arguments, 1);
	    }
	    return (0, _gear.reduce$)(condition, function (c, fs) {
	      return _this5.only$(fs, c);
	    }, figures, this);
	  },
	  saveConditions: function () {
	    this._restoreConditions = (0, _gear.clone)(this._conditions);
	    this._restoreArrayConditions = (0, _gear.clone)(this._arrayConditions);
	  },
	  restoreConditions: function () {
	    this._conditions = (0, _gear.clone)(this._restoreConditions);
	    this._arrayConditions = (0, _gear.clone)(this._restoreArrayConditions);
	  }
	};
	
	// Modify global figure conditions
	
	var notIsland = function (figure) {
	  return !figure.metadata.get('textureIslandName');
	};
	
	Figure_condition('selectable', function (figure) {
	  return figure.canBeSelected() || !notIsland(figure);
	});
	
	Figure_condition('copyable', function () {
	  return true;
	});
	Figure_condition('removable', function () {
	  return true;
	});
	Figure_condition('movable', function () {
	  return true;
	});
	Figure_condition('scalable', notIsland);
	Figure_condition('rotatable', function () {
	  return true;
	});
	Figure_condition('skewable', notIsland);
	Figure_condition('groupable', notIsland);
	Figure_condition('ungroupable', function (figure) {
	  return figure.isGroup;
	});
	Figure_condition('clipboardable', notIsland);
	Figure_condition('textureIsland', function (figure) {
	  return !!figure.metadata.get('textureIslandName');
	});
	
	// [TODO] Needs polishing
	Figure_condition('contentEditable', function (figure) {
	  return figure.canEditContent() && _config.Config.enableContentEdition;
	});
	
	Figure_condition('aspectRatioChangeable', function () {
	  return true;
	});
	
	Figure_condition('nodeEditable', function (figure) {
	  return figure.isShape && figure.processes.length === 0 && figure.canBeProcessedLocally() && notIsland(figure);
	});
	
	Figure_arrayCondition('0', function (figures) {
	  return figures.length === 0;
	});
	Figure_arrayCondition('1', function (figures) {
	  return figures.length === 1;
	});
	Figure_arrayCondition('1+', function (figures) {
	  return figures.length >= 1;
	});
	Figure_arrayCondition('2', function (figures) {
	  return figures.length === 2;
	});
	Figure_arrayCondition('2+', function (figures) {
	  return figures.length >= 2;
	});
	Figure_arrayCondition('3', function (figures) {
	  return figures.length === 3;
	});
	
	Figure_arrayCondition('zorderable', function (figures) {
	  if (figures.length === 0) {
	    return false;
	  }
	  var owner = figures[0]._owner;
	  return (0, _lodash.every)((0, _lodash.invokeMap)(figures, 'owner'), owner);
	});
	
	Figure_arrayCondition('groupable', '2+');
	
	Figure_condition('shape', function (figure) {
	  return figure.isShape;
	});
	
	Figure_condition('text', function (figure) {
	  return figure.isText;
	});
	Figure_condition('simpleText', function (figure) {
	  return figure.isText && figure.isSimple;
	});
	Figure_condition('typesetText', function (figure) {
	  return figure.isText && figure.isTypeset;
	});
	Figure_condition('multiPartText', function (figure) {
	  return figure.isText && figure.isMultiPart;
	});
	
	Figure_condition('raster', function (figure) {
	  return figure.isRaster;
	});
	Figure_condition('fullColorRaster', function (figure) {
	  return figure.isRaster && !figure.isMonochrome;
	});
	Figure_condition('monochromeRaster', function (figure) {
	  return figure.isRaster && figure.isMonochrome;
	});
	
	Figure_condition('group', function (figure) {
	  return figure.isGroup;
	});
	
	Figure_condition('proxyGroup', function (figure) {
	  return figure.isProxyGroup;
	});

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Packing = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _geometry = __webpack_require__(21);
	
	var _figures = __webpack_require__(43);
	
	var _gear = __webpack_require__(8);
	
	var _group = __webpack_require__(59);
	
	var Packing = exports.Packing = {};
	
	var pack_q = function (size, page, margin) {
	  return Math.floor((page + margin) / (size + margin));
	};
	
	var directPack = function (w, h, lx, ly, qx, qy, margin) {
	  var positions = [];
	  for (var y = 0; y < qy; ++y) {
	    for (var x = 0; x < qx; ++x) {
	      positions.push(new _geometry.Point(lx + x * (w + margin), ly + y * (h + margin)));
	    }
	  }
	  return positions;
	};
	
	var directExtraPack = function (w, h, lx, ly, qx, qy, margin) {
	  var positions = [];
	  for (var x = 0; x < qx; ++x) {
	    for (var y = 0; y < qy; ++y) {
	      positions.push(new _geometry.Point(lx + x * (w + margin), ly + y * (h + margin)));
	    }
	  }
	  return positions;
	};
	
	var oneDirectionSimpleGangData = function (objX, objY, pageX, pageY, margin) {
	  var mainQx = pack_q(objX, pageX, margin);
	  var mainQy = pack_q(objY, pageY, margin);
	  var mainQ = mainQx * mainQy;
	
	  var remX = pageX - mainQx * (objX + margin);
	  var rightQx = pack_q(objY, remX, margin);
	  var rightQy = pack_q(objX, pageY, margin);
	  var rightQ = rightQx * rightQy;
	
	  var remY = pageY - mainQy * (objY + margin);
	  var topQx = pack_q(objY, pageX, margin);
	  var topQy = pack_q(objX, remY, margin);
	  var topQ = topQx * topQy;
	
	  return rightQ > 0 ? { count: mainQ + rightQ,
	    main: { qx: mainQx, qy: mainQy },
	    extra: { place: 'right', qx: rightQx, qy: rightQy } } : { count: mainQ + topQ,
	    main: { qx: mainQx, qy: mainQy },
	    extra: topQ > 0 ? { place: 'top', qx: topQx, qy: topQy } : null };
	};
	
	var simpleGangData = function (objX, objY, pageX, pageY, margin) {
	  var rs = oneDirectionSimpleGangData(objX, objY, pageX, pageY, margin);
	  var rr = oneDirectionSimpleGangData(objY, objX, pageX, pageY, margin);
	  return rs.count >= rr.count ? (rs.rotated = false, rs) : (rr.rotated = true, rr);
	};
	
	var simpleGangPositions = function (w, h, pageW, pageH, margin, maxNumber) {
	  var r = simpleGangData(w, h, pageW, pageH, margin);
	  var rotatedPack = r.rotated;
	  var e = r.extra;
	
	  if (rotatedPack) {
	    var a = w;w = h;h = a;
	  } // w <--> h
	
	  var mp_hx = r.main.qx * (w + margin);
	  if (e && e.place === 'top') {
	    var e_hx = e.qx * (h + margin);
	    if (e_hx > mp_hx) {
	      mp_hx = e_hx;
	    }
	  }
	  var mp_hy = r.main.qy * (h + margin);
	  if (e && e.place === 'right') {
	    var e_hy = e.qy * (w + margin);
	    if (e_hy > mp_hy) {
	      mp_hy = e_hy;
	    }
	  }
	
	  // Offset to center result
	  var offset_x = (pageW - (mp_hx + (e && e.place === 'right' ? e.qx * (h + margin) : 0) - margin)) / 2;
	  var offset_y = (pageH - (mp_hy + (e && e.place === 'top' ? e.qy * (w + margin) : 0) - margin)) / 2;
	
	  var main = directPack(w, h, offset_x, offset_y, r.main.qx, r.main.qy, margin);
	  var extra = !r.extra ? [] : directExtraPack(h, w, (e.place === 'right' ? mp_hx : 0) + offset_x, (e.place === 'top' ? mp_hy : 0) + offset_y, e.qx, e.qy, margin);
	
	  if (maxNumber !== undefined) {
	    if (main.length > maxNumber) {
	      (function () {
	        main = (0, _lodash.take)(main, maxNumber);
	
	        // Extra vertical offset
	        var min_y = (0, _lodash.min)(main, 'y').y,
	            max_y = (0, _lodash.max)(main, 'y').y + h;
	        var desired_min_y = (pageH - (max_y - min_y)) / 2;
	        var o_y = desired_min_y - min_y;
	        var o_x = 0;
	
	        if (extra.length > 0) {
	          extra = [];
	          // Extra horizontal offset
	          var min_x = (0, _lodash.min)(main, 'x').x,
	              max_x = (0, _lodash.max)(main, 'x').x + w,
	              desired_min_x = (pageW - (max_x - min_x)) / 2;
	
	          o_x = desired_min_x - min_x;
	        }
	
	        (0, _lodash.forEach)(main, function (s) {
	          s.x += o_x;s.y += o_y;
	        });
	        (0, _lodash.forEach)(extra, function (s) {
	          s.x += o_x;s.y += o_y;
	        });
	      })();
	    } else {
	      extra = (0, _lodash.take)(extra, maxNumber - main.length);
	    }
	  }
	
	  return rotatedPack ? { straight: extra, rotated: main } : { straight: main, rotated: extra };
	};
	
	Packing.simpleGangCount$ = function (figures, pageW, pageH, margin) {
	  return _figures.Figures.bounds$(figures).then(function (bounds) {
	    return Packing.simpleGangCount(bounds.width, bounds.height, pageW, pageH, margin);
	  });
	};
	
	Packing.simpleGangPositions$ = function (figures, pageW, pageH, margin, maxNumber) {
	  return _figures.Figures.bounds$(figures).then(function (bounds) {
	    var w = bounds.width,
	        h = bounds.height;
	    return simpleGangPositions(w, h, pageW, pageH, margin, maxNumber);
	  });
	};
	
	Packing.simpleGang$ = function (figure, pageW, pageH, margin, maxNumber) {
	  return figure.bounds$().then(function (bounds) {
	    var w = bounds.width,
	        h = bounds.height;
	    var positions = simpleGangPositions(w, h, pageW, pageH, margin, maxNumber);
	    if (maxNumber === undefined) {
	      maxNumber = positions.length;
	    }
	
	    var offset = _geometry.Point.minus(bounds.lx_ly);
	    var cloneFigure = function (pos, rotated) {
	      var pf = figure.clone();
	      pf.translate(offset);
	      if (rotated) {
	        pf.rotateAround(new _geometry.Point(0, 0), -90);
	        pf.translate(0, bounds.width);
	      }
	      pf.translate(pos);
	      return pf;
	    };
	
	    var packedFigures = [];
	    (0, _lodash.forEach)(positions.straight, function (pos) {
	      packedFigures.push(cloneFigure(pos, false));
	    });
	    (0, _lodash.forEach)(positions.rotated, function (pos) {
	      packedFigures.push(cloneFigure(pos, true));
	    });
	
	    return packedFigures;
	  });
	};
	
	Packing.simpleGangCount = function (objX, objY, pageX, pageY, margin) {
	  return simpleGangData(objX, objY, pageX, pageY, margin).count;
	};
	
	// guillotine packing
	var wrapWithGroup = function (item) {
	  var wrapped = null;
	
	  if (item.typeName === "Document") {
	    wrapped = _group.Group.create(item.figures);
	    wrapped.wasGrouped = true;
	  } else if (item.constructor === Array && item[0].isFigure === true) {
	    wrapped = _group.Group.create(item);
	    wrapped.wasGrouped = true;
	  } else if (item.isFigure === true) wrapped = item;
	
	  return wrapped;
	};
	
	var createBin = function (lx, ly, hx, hy) {
	  return {
	    frame: new _geometry.Bounds(lx, ly, hx, hy),
	    freeSpaces: [new _geometry.Bounds(lx, ly, hx, hy)],
	    items: []
	  };
	};
	
	var tryToFitInBin = function (item, bounds, bin, margin, fitFunction, allowRotation) {
	  var itemBounds = bounds;
	
	  var bestFit = Infinity;
	  var bestFitIndex = -1;
	  var bestLx = 0.0;
	  var bestLy = 0.0;
	  var bestWidth = 0.0;
	  var bestHeight = 0.0;
	  var rotation = false;
	  var freeSpaceIndex = 0;
	
	  while (freeSpaceIndex < bin.freeSpaces.length) {
	    var freeSpace = bin.freeSpaces[freeSpaceIndex];
	    var isFrameLx = freeSpace.lx == bin.frame.lx;
	    var isFrameLy = freeSpace.ly == bin.frame.ly;
	    var isFrameHx = freeSpace.hx == bin.frame.hx;
	    var isFrameHy = freeSpace.hy == bin.frame.hy;
	    var lx = freeSpace.lx + (isFrameLx ? 0 : margin / 2);
	    var ly = freeSpace.ly + (isFrameLy ? 0 : margin / 2);
	    var extraWidth = (isFrameLx ? 0 : margin / 2) + (isFrameHx && lx + itemBounds.width + margin / 2 >= freeSpace.hx ? 0 : margin / 2);
	    var extraHeight = (isFrameLy ? 0 : margin / 2) + (isFrameHy && ly + itemBounds.height + margin / 2 >= freeSpace.hy ? 0 : margin / 2);
	    var freeWidth = freeSpace.width;
	    var freeHeight = freeSpace.height;
	    var sameWidth = Math.abs(freeWidth - (itemBounds.width + extraWidth)) < 1e-8;
	    var sameHeight = Math.abs(freeHeight - (itemBounds.height + extraHeight)) < 1e-8;
	    var sameWidthRotated = Math.abs(freeWidth - (itemBounds.height + extraWidth)) < 1e-8;
	    var sameHeightRotated = Math.abs(freeHeight - (itemBounds.width + extraHeight)) < 1e-8;
	    var fits = (sameWidth || freeWidth > itemBounds.width + extraWidth) && (sameHeight || freeHeight > itemBounds.height + extraHeight);
	    var fitsRotated = (sameWidthRotated || freeWidth > itemBounds.height + extraWidth) && (sameHeightRotated || freeHeight > itemBounds.width + extraHeight);
	    var preferRotation = false;
	    var currentFit = Infinity;
	
	    switch (fitFunction) {
	      case "bssf":
	        if (fits) currentFit = Math.min(freeWidth - (itemBounds.width + extraWidth), freeHeight - (itemBounds.height + extraHeight));
	
	        if (allowRotation && fitsRotated) {
	          var rotatedFit = Math.min(freeWidth - (itemBounds.height + extraWidth), freeHeight - (itemBounds.width + extraHeight));
	          preferRotation = rotatedFit < currentFit;
	          if (preferRotation) currentFit = rotatedFit;
	        }
	        break;
	      case "baf":
	      default:
	        // same as baf
	        if (fits) currentFit = freeWidth * freeHeight - (itemBounds.width + extraWidth) * (itemBounds.height + extraHeight);
	
	        if (allowRotation && fitsRotated) {
	          var _rotatedFit = freeWidth * freeHeight - (itemBounds.height + extraWidth) * (itemBounds.width + extraHeight);
	          preferRotation = _rotatedFit < currentFit;
	          if (preferRotation) currentFit = _rotatedFit;
	        }
	    }
	
	    if (currentFit < bestFit) {
	      bestFit = currentFit;
	      bestFitIndex = freeSpaceIndex;
	      rotation = preferRotation;
	      bestLx = lx;
	      bestLy = ly;
	      bestWidth = (preferRotation ? itemBounds.height : itemBounds.width) + extraWidth;
	      bestHeight = (preferRotation ? itemBounds.width : itemBounds.height) + extraHeight;
	    }
	
	    freeSpaceIndex++;
	  }
	
	  if (bestFitIndex == -1) return false;
	
	  // move item to position inside free space
	  moveToFinalPosition(item, itemBounds, bestLx, bestLy, rotation);
	
	  // add item to bin
	  bin.items.push(item);
	
	  // split the unused space, if any
	  split(bin, bestFitIndex, bestWidth, bestHeight);
	
	  return true;
	};
	
	var moveToFinalPosition = function (item, itemBounds, lx, ly, rotation) {
	  var transformation = rotation ? new _geometry.Matrix22({ s00: 0, s01: -1, s10: 1, s11: 0, dx: lx + itemBounds.height + itemBounds.ly, dy: ly - itemBounds.lx }) : new _geometry.Matrix22({ s00: 1, s01: 0, s10: 0, s11: 1, dx: lx - itemBounds.lx, dy: ly - itemBounds.ly });
	  item.transform(transformation);
	};
	
	var addFreeSpace = function (bin, freeSpace) {
	  var grew = false;
	  do {
	    grew = false;
	    var freeSpaceIndex = 0;
	    var currentFreeSpace = bin.freeSpaces[freeSpaceIndex];
	
	    while (freeSpaceIndex < bin.freeSpaces.length) {
	      if (_geometry.Bounds.areOverlapping(freeSpace, currentFreeSpace)) {
	        if (freeSpace.lx == currentFreeSpace.lx && freeSpace.hx == currentFreeSpace.hx) {
	          var builder = new _geometry.BoundsBuilder();
	          builder.update(freeSpace);
	          builder.updateWithPoint(new _geometry.Point(freeSpace.lx, Math.min(freeSpace.ly, currentFreeSpace.ly)));
	          builder.updateWithPoint(new _geometry.Point(freeSpace.lx, Math.max(freeSpace.hy, currentFreeSpace.hy)));
	          freeSpace = builder.bounds;
	          currentFreeSpace = bin.freeSpaces.splice(freeSpaceIndex, 1);
	          grew = true;
	        } else if ((freeSpace.ly == currentFreeSpace.hy || freeSpace.hy == currentFreeSpace.ly) && ( // vertically adjacent
	        freeSpace.lx < currentFreeSpace.lx || freeSpace.hx > currentFreeSpace.hx) && !(freeSpace.lx > currentFreeSpace.lx || freeSpace.hx < currentFreeSpace.hx) && // ensure we don't grow in x, only shrink
	        (freeSpace.width - currentFreeSpace.width) * freeSpace.height * 5 < currentFreeSpace.height * currentFreeSpace.width) {
	          // heuristic: remove excess area area of freeSpace to merge with currentFreeSpace
	          // if that means we can gain at least 5 times the area removed (which means a single bigger free space)
	          freeSpace.lx = currentFreeSpace.lx;
	          freeSpace.hx = currentFreeSpace.hx;
	          var _builder = new _geometry.BoundsBuilder();
	          _builder.update(freeSpace);
	          _builder.updateWithPoint(new _geometry.Point(freeSpace.lx, Math.min(freeSpace.ly, currentFreeSpace.ly)));
	          _builder.updateWithPoint(new _geometry.Point(freeSpace.lx, Math.max(freeSpace.hy, currentFreeSpace.hy)));
	          freeSpace = _builder.bounds;
	          currentFreeSpace = bin.freeSpaces.splice(freeSpaceIndex, 1);
	          grew = true;
	        } else if (freeSpace.ly == currentFreeSpace.ly && freeSpace.hy == currentFreeSpace.hy) {
	          var _builder2 = new _geometry.BoundsBuilder();
	          _builder2.update(freeSpace);
	          _builder2.updateWithPoint(new _geometry.Point(Math.min(freeSpace.lx, currentFreeSpace.lx), freeSpace.ly));
	          _builder2.updateWithPoint(new _geometry.Point(Math.max(freeSpace.hx, currentFreeSpace.hx), freeSpace.ly));
	          freeSpace = _builder2.bounds;
	          currentFreeSpace = bin.freeSpaces.splice(freeSpaceIndex, 1);
	          grew = true;
	        } else if ((freeSpace.lx == currentFreeSpace.hx || freeSpace.hx == currentFreeSpace.lx) && ( // horizontally adjacent
	        freeSpace.ly < currentFreeSpace.ly || freeSpace.hy > currentFreeSpace.hy) && !(freeSpace.ly > currentFreeSpace.ly || freeSpace.hy < currentFreeSpace.hy) && // ensure we don't grow in y, only shrink
	        (freeSpace.height - currentFreeSpace.height) * freeSpace.width * 5 < currentFreeSpace.height * currentFreeSpace.width) {
	          // heuristic: remove excess area area of freeSpace to merge with lIter
	          // if that means we can gain at least 5 times the area removed (which means a single bigger free space)
	          freeSpace.ly = currentFreeSpace.ly;
	          freeSpace.hy = currentFreeSpace.hy;
	          var _builder3 = new _geometry.BoundsBuilder();
	          _builder3.update(freeSpace);
	          _builder3.updateWithPoint(new _geometry.Point(Math.min(freeSpace.lx, currentFreeSpace.lx), freeSpace.ly));
	          _builder3.updateWithPoint(new _geometry.Point(Math.max(freeSpace.hx, currentFreeSpace.hx), freeSpace.ly));
	          freeSpace = _builder3.bounds;
	          currentFreeSpace = bin.freeSpaces.splice(freeSpaceIndex, 1);
	          grew = true;
	        } else freeSpaceIndex++;
	      } else freeSpaceIndex++;
	    }
	  } while (grew);
	
	  bin.freeSpaces.push(freeSpace);
	};
	
	var splitHorizontally = function (bin, freeSpace, width, height) {
	  var lx = freeSpace.lx;
	  var ly = freeSpace.ly;
	  var hx = freeSpace.hx;
	  var hy = freeSpace.hy;
	
	  if (height < freeSpace.height) {
	    var newSpace = new _geometry.Bounds(lx, ly + height, hx, hy);
	    addFreeSpace(bin, newSpace);
	  }
	
	  if (width < freeSpace.width) {
	    var _newSpace = new _geometry.Bounds(lx + width, ly, hx, ly + height);
	    addFreeSpace(bin, _newSpace);
	  }
	};
	
	var splitVertically = function (bin, freeSpace, width, height) {
	  var lx = freeSpace.lx;
	  var ly = freeSpace.ly;
	  var hx = freeSpace.hx;
	  var hy = freeSpace.hy;
	
	  if (height < freeSpace.height) {
	    var newSpace = new _geometry.Bounds(lx, ly + height, lx + width, hy);
	    addFreeSpace(bin, newSpace);
	  }
	
	  if (width < freeSpace.width) {
	    var _newSpace2 = new _geometry.Bounds(lx + width, ly, hx, hy);
	    addFreeSpace(bin, _newSpace2);
	  }
	};
	
	var split = function (bin, freeSpaceIndex, width, height) {
	  var space = bin.freeSpaces[freeSpaceIndex];
	  bin.freeSpaces.splice(freeSpaceIndex, 1);
	
	  if (space.width < space.height) splitHorizontally(bin, space, width, height);else splitVertically(bin, space, width, height);
	};
	
	/*
	 config = {
	  width: 100,
	  height: 100,
	  margins: {
	    "top": 0,
	    "bottom": 0,
	    "left": 0,
	    "right": 0,
	    "inner": 5
	  },
	  options: { 
	    "allowRotation": true,
	    "fitFunction": "BAF" // or BSSF,
	    "groupInputIfNeeded": false,
	    "drawBins": true
	  }
	};
	*/
	Packing.guillotine$ = function (items, config) {
	  var bins = [];
	  var margins = config.margins;
	  var options = config.options;
	  var width = config.width;
	  var height = config.height;
	
	  var fitFunction = (options.fitFunction || "baf").toLowerCase();
	  var allowRotation = options.allowRotation !== false;
	  var groupInputIfNeeded = options.groupInputIfNeeded === true;
	  var drawBins = options.drawBins !== false;
	  var leftMargin = margins.left > 0 ? margins.left : 0;
	  var rightMargin = margins.right > 0 ? margins.right : 0;
	  var topMargin = margins.top > 0 ? margins.top : 0;
	  var bottomMargin = margins.bottom > 0 ? margins.bottom : 0;
	  var workingItems = [];
	
	  bins.push(createBin(leftMargin, bottomMargin, width - rightMargin, height - topMargin));
	
	  var binWidth = bins[0].frame.width;
	  var binHeight = bins[0].frame.height;
	
	  var boundPromises = [];
	  for (var i = 0, c = items.length; i < c; ++i) {
	    var item = groupInputIfNeeded ? wrapWithGroup(items[i]) : items[i];
	    workingItems.push(item);
	    boundPromises.push(item.bounds$());
	  }
	
	  return (0, _gear.whenAll)(boundPromises).then(function (results) {
	    // check that that all the items are smaller than a bin's dimension
	    var sorted = [];
	
	    for (var _i = 0; _i < results.length; ++_i) {
	      var bounds = results[_i];
	      if ((bounds.height > binHeight || bounds.width > binWidth) && allowRotation && (bounds.width > binHeight || bounds.height > binWidth)) {
	        throw new Error("an item is larger than the bin");
	      }
	      sorted.push({ item: workingItems[_i], bounds: bounds });
	    }
	
	    // sort desc by area
	    sorted = sorted.sort(function (x, y) {
	      return y.bounds.area - x.bounds.area;
	    });
	
	    for (var _i2 = 0; _i2 < sorted.length; ++_i2) {
	      var _sorted$_i = sorted[_i2];
	      var _item = _sorted$_i.item;
	      var _bounds = _sorted$_i.bounds;
	
	
	      var j = 0,
	          l = bins.length;
	      while (j < l && !tryToFitInBin(_item, _bounds, bins[j], margins.inner, fitFunction, allowRotation)) {
	        j++;
	      }if (j >= l) {
	        var lastBin = bins[bins.length - 1];
	        var newBin = createBin(lastBin.frame.lx, lastBin.frame.ly + height, lastBin.frame.hx, lastBin.frame.hy + height);
	        bins.push(newBin);
	        tryToFitInBin(_item, _bounds, newBin, margins.inner, fitFunction, allowRotation);
	      }
	    }
	
	    if (groupInputIfNeeded) for (var _i3 = 0; _i3 < bins.length; ++_i3) {
	      bins[_i3].items = bins[_i3].items.map(function (x) {
	        return x.wasGrouped ? x.ungroup() : x;
	      });
	    }return (0, _gear.if$)(drawBins, function () {
	      var binBounds = [];
	
	      for (var _i4 = 0; _i4 < bins.length; ++_i4) {
	        binBounds.push(Cx.bounds$(bins[_i4].items));
	      }return Cx.whenAll(binBounds, function (results) {
	        for (var _i5 = 0; _i5 < results.length; ++_i5) {
	          var currentBin = bins[_i5];
	          var lx = results[_i5].lx - (width - results[_i5].width) / 2;
	          var ly = results[_i5].ly - (height - results[_i5].height) / 2;
	          var binFrame = new _geometry.Bounds(lx, ly, lx + width, ly + height);
	          currentBin.items.push(Cx.Shape.CreateRectangle({ bounds: binFrame, pen: new Cx.Pen({ color: Cx.Color.Black }) }));
	        }
	
	        return bins;
	      });
	    }).else$(function () {
	      return Cx.resolve(bins);
	    });
	  });
	};
	
	//binPack
	var getFiguresToPack$ = function (item) {
	  var document = item.document;
	  var width = item.width;
	  var height = item.height;
	  var quantity = item.quantity;
	  var aspectRatio = item.aspectRatio;
	
	
	  if (quantity === 0) {
	    throw new Error("must contain at least 1 repetition of this item");
	  }
	
	  var docFigures = [];
	  for (var i = 0; i < document.figures.length; i++) {
	    docFigures.push(document.figures[i]);
	  }
	
	  var ar = aspectRatio || {};
	  var locked = ar.locked === undefined ? false : ar.locked,
	      constrainWidth = ar.constrainWidth === undefined ? false : ar.constrainWidth,
	      constrainHeight = ar.constrainHeight === undefined ? false : ar.constrainHeight;
	
	  return _figures.Figures.bounds$(docFigures).then(function (bounds) {
	    var scaleX = width / bounds.width;
	    var scaleY = height / bounds.height;
	    if (locked) {
	      if (constrainWidth != constrainHeight) scaleX = scaleY = constrainWidth ? scaleX : scaleY;else if (constrainWidth) {
	        if (scaleX * bounds.height > height) scaleX = scaleY;
	        if (scaleY * bounds.width > width) scaleY = scaleX;
	      }
	    }
	    return _figures.Figures.scale$(docFigures, scaleX, scaleY);
	  }).then(function (scaledFigures) {
	    var toPack = [];
	    for (var _i6 = 0, c = quantity; _i6 < c; ++_i6) {
	      toPack.push(_group.Group.create(scaledFigures));
	    }
	    return toPack;
	  });
	};
	
	/*
	let items = [{
	    document: ...,
	    width: 100,
	    height: 100,
	    quantity: 5,
	    aspectRatio: {
	      locked: true,
	      constrainWidth: true,
	      constrainHeight: true
	    }
	  },
	  ...
	];
	*/
	Packing.binPack$ = function (items, config) {
	  var figuresToPackP = [];
	  for (var i = 0; i < items.length; ++i) {
	    figuresToPackP.push(getFiguresToPack$(items[i]));
	  }
	
	  return (0, _gear.whenAll)(figuresToPackP).then(function (figuresToPackR) {
	    var figuresToPack = figuresToPackR.flat();
	    return Packing.guillotine$(figuresToPack, config);
	  });
	};
	
	var placeInRow = function (rowItems, ly, gap) {
	  var lx = 0,
	      rowHeight = 0;
	  for (var i = 0, c = rowItems.length; i < c; ++i) {
	    var _rowItems$i = rowItems[i];
	    var item = _rowItems$i.item;
	    var bounds = _rowItems$i.bounds;
	
	    item.translate(lx - bounds.lx, ly - bounds.ly);
	    lx += bounds.width + gap;
	    rowHeight = Math.max(bounds.height, rowHeight);
	  }
	  return rowHeight;
	};
	
	/*
	config =
	{
	  width: 100,
	  rotateAllInput: false,
	  sortInput: false,
	  itemsGap: 5
	};
	*/
	Packing.stack$ = function (items, config) {
	  var stackingWidth = config.width || 1000;
	  var gap = config.itemsGap || 5;
	
	  var promises = [];
	  var workingItems = [];
	
	  var _loop = function (i, c) {
	    var wrappedItem = { item: wrapWithGroup(items[i]) };
	    workingItems.push(wrappedItem);
	    promises.push((0, _gear.if$)(config.rotateAllInput === true, function () {
	      return wrappedItem.item.rotate$(90).then(function (x) {
	        return x.bounds$();
	      });
	    }).else$(function () {
	      return wrappedItem.item.bounds$();
	    }));
	  };
	
	  for (var i = 0, c = items.length; i < c; ++i) {
	    _loop(i, c);
	  }
	
	  return (0, _gear.whenAll)(promises).then(function (results) {
	    var itemCount = workingItems.length;
	    for (var _i7 = 0; _i7 < itemCount; ++_i7) {
	      workingItems[_i7].bounds = results[_i7];
	    }if (config.sortInput === true) workingItems = workingItems.sort(function (x, y) {
	      return y.bounds.width - x.bounds.width;
	    });
	
	    var rowWidth = 0,
	        s = 0,
	        ly = 0;
	
	    for (var _i8 = 0; _i8 < itemCount; ++_i8) {
	      var currentItemWidth = workingItems[_i8].bounds.width;
	      rowWidth += currentItemWidth;
	
	      if (rowWidth > stackingWidth) {
	        var e = _i8;
	        rowWidth = currentItemWidth;
	        if (e === s) e++, rowWidth = 0;
	
	        ly += placeInRow(workingItems.slice(s, e), ly, gap) + gap;
	        s = e;
	      } else rowWidth += gap; // add gap before next item
	    }
	
	    // place the last row
	    placeInRow(workingItems.slice(s, itemCount), ly, gap);
	
	    return workingItems.map(function (x) {
	      return x.item.wasGrouped ? x.item.ungroup() : x.item;
	    });
	  });
	};

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _process = __webpack_require__(40);
	
	Object.keys(_process).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _process[key];
	    }
	  });
	});
	
	var _processes = __webpack_require__(41);
	
	Object.keys(_processes).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _processes[key];
	    }
	  });
	});
	
	var _clip = __webpack_require__(69);
	
	Object.keys(_clip).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _clip[key];
	    }
	  });
	});
	
	var _decorate = __webpack_require__(70);
	
	Object.keys(_decorate).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _decorate[key];
	    }
	  });
	});
	
	var _deform = __webpack_require__(72);
	
	Object.keys(_deform).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _deform[key];
	    }
	  });
	});
	
	var _envelope = __webpack_require__(73);
	
	Object.keys(_envelope).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _envelope[key];
	    }
	  });
	});
	
	var _fitOnPath = __webpack_require__(74);
	
	Object.keys(_fitOnPath).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _fitOnPath[key];
	    }
	  });
	});
	
	var _raster = __webpack_require__(75);
	
	Object.keys(_raster).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _raster[key];
	    }
	  });
	});
	
	var _text = __webpack_require__(76);
	
	Object.keys(_text).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _text[key];
	    }
	  });
	});

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	var _process = __webpack_require__(40);
	
	// Split
	//===============================================================================================
	
	var Split = _process.Process.Split = _process.Process.extend({ typeName: 'SplitProcess',
	  type: 'Split',
	  Properties: {
	    overlap: { type: 'magnitude', def: new _gear.Magnitude(0, 'mm'), onChange: _gear.invalidateOwner, dropDef: true },
	    pos: { type: 'magnitude', def: new _gear.Magnitude(0.5, 'mm'), onChange: _gear.invalidateOwner, dropDef: true },
	    turn: { type: 'number', def: 0, onChange: _gear.invalidateOwner, dropDef: true },
	    gap: { type: 'magnitude', def: new _gear.Magnitude(10, 'mm'), onChange: _gear.invalidateOwner, dropDef: true }
	  }
	});
	_util.Xml.addFromBuild(Split);

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	var _geometry = __webpack_require__(21);
	
	var _style = __webpack_require__(29);
	
	var _process = __webpack_require__(40);
	
	var _figure = __webpack_require__(35);
	
	var _shape = __webpack_require__(45);
	
	var _kdTree = __webpack_require__(71);
	
	var _text = __webpack_require__(50);
	
	// CavitiesFilterProcess
	//===============================================================================================
	
	var CavitiesFilter = _process.Process.CavitiesFilter = _process.Process.extend({ typeName: 'CavitiesFilterProcess',
	  type: 'CavitiesFilter',
	  Properties: {
	    minDiameter: { type: 'magnitude', def: null, onChange: _gear.invalidateOwner, dropDef: true },
	    quality: { type: 'string', def: 'Default', onChange: _gear.invalidateOwner, dropDef: true }
	  }
	});
	_util.Xml.addFromBuild(CavitiesFilter);
	
	// Border
	//===============================================================================================
	
	var Border = _process.Process.Border = _process.Process.extend({ typeName: 'BorderProcess',
	  type: 'Border',
	  Properties: {
	    pen: { type: 'Pen', def: new _style.Pen({ color: _style.Color.Black() }), onChange: _gear.invalidateOwner },
	    brush: { type: 'Brush', def: _style.Brush.empty, onChange: _gear.invalidateOwner },
	    dX: { type: 'magnitude', def: null, onChange: _gear.invalidateOwner, dropDef: true },
	    dY: { type: 'magnitude', def: null, onChange: _gear.invalidateOwner, dropDef: true },
	    gap: { type: 'magnitude', def: null, onChange: _gear.invalidateOwner, dropDef: true },
	    separate: { type: 'boolean', def: false, onChange: _gear.invalidateOwner, dropDef: true }
	  }
	});
	_util.Xml.addFromBuild(Border);
	
	// Contour
	//===============================================================================================
	
	var Contour = _process.Process.Contour = _process.Process.extend({ typeName: 'ContourProcess',
	  type: 'Contour',
	  Properties: {
	    pen: { type: 'Pen', def: _style.Pen.empty, onChange: _gear.invalidateOwner },
	    brush: { type: 'Brush', def: _style.Brush.empty, onChange: _gear.invalidateOwner },
	    offset: { type: 'magnitude', def: new _gear.Magnitude(0, 'mm'), onChange: _gear.invalidateOwner, dropDef: true },
	    steps: { type: 'integer', def: 0, onChange: _gear.invalidateOwner, dropDef: true },
	    inside: { type: 'boolean', def: false, onChange: _gear.invalidateOwner, dropDef: true },
	    outside: { type: 'boolean', def: true, onChange: _gear.invalidateOwner, dropDef: true },
	    includeHoles: { type: 'boolean', def: true, onChange: _gear.invalidateOwner, dropDef: true },
	    combine: { type: 'boolean', def: false, onChange: _gear.invalidateOwner, dropDef: true },
	    lineJoin: { type: 'string', def: 'Miter', onChange: _gear.invalidateOwner, dropDef: true },
	    chamfer_D: { type: 'number', def: 0.1, onChange: _gear.invalidateOwner, dropDef: true },
	    chamfer_L: { type: 'number', def: 0.1, onChange: _gear.invalidateOwner, dropDef: true },
	    roundRadius: { type: 'magnitude', def: new _gear.Magnitude(0.1, 'mm'), onChange: _gear.invalidateOwner, dropDef: true },
	    roundMaxAngle: { type: 'number', def: 120, onChange: _gear.invalidateOwner, dropDef: true },
	    advancedSpacing: { type: 'boolean', def: false, onChange: _gear.invalidateOwner, dropDef: true },
	    gap: { type: 'number', def: 0.0, onChange: _gear.invalidateOwner, dropDef: true, doNotEncode: true }
	  },
	  init: function (c) {
	    // optional
	    this.callParent();
	    this.advancedSpacing = this.advancedSpacing || this.gap != 0.0;
	  },
	
	
	  canProcess: function () /* figure */{
	    return (//=Config.contourFastPreview &&
	      this.pen._empty && this.brush instanceof _style.Brush && !(this.brush instanceof _style.TextureBrush) && !(this.brush instanceof _style.PatternBrush) && this.steps <= 1 && !this.inside && this.outside // && Contour.useFastPreviewFor(this)
	
	    );
	  },
	  addPenContourExtraParams: function (p) {
	    if (p.lineJoin == 'Miter') {
	      return Object.assign(p, { miterLimit: 3 });
	    } else {
	      return p;
	    }
	  },
	  process: function (c) {
	    var penContour = new PenContour({ pens: [new _style.Pen(this.addPenContourExtraParams({ width: this._offset * 2,
	        color: this.brush.color,
	        lineJoin: this.lineJoin
	      }))],
	      advancedSpacing: this.advancedSpacing
	    });
	    return penContour.process(c);
	  }
	});
	_util.Xml.addFromBuild(Contour);
	
	// Apps can define to avoid fast preview depending on other contour properties
	Contour.useFastPreviewFor = function () /* contour */{
	  return true;
	};
	
	// Pen Contour
	//===============================================================================================
	
	var createContourFigure = function (base, pen, size) {
	  var shape = base.clone();
	  var frame = _geometry.Frame.fromBounds(shape.bounds);
	  (0, _lodash.forEach)(shape.polyregions, function (p) {
	    var renderMatrix = p._renderMatrix;
	    var effectivePen = pen.clone();
	    effectivePen.width = size * (renderMatrix ? renderMatrix.scaleFactor() : 1);
	    p._renderFrame = frame.clone();
	    p.pen = effectivePen;
	  });
	
	  return shape;
	};
	
	var getBaseWidth = function (shape) {
	  var maxInputWidth = 0;
	  (0, _lodash.forEach)(shape._polyregions, function (p) {
	    var renderMatrix = p._renderMatrix;
	    var inputWidth = p._pen.width * (renderMatrix ? renderMatrix.scaleFactor() : 1);
	    if (inputWidth > maxInputWidth) {
	      maxInputWidth = inputWidth;
	    }
	  });
	  return maxInputWidth;
	};
	
	var PenContour = _process.Process.PenContour = _process.Process.extend({ typeName: 'PenContourProcess',
	  type: 'PenContour',
	  Properties: { pens: { type: 'Pen[]', def: [], onChange: _gear.invalidateOwner },
	    advancedSpacing: { type: 'boolean', def: false, onChange: _gear.invalidateOwner, dropDef: true }
	  },
	  getColors: function () {
	    var colors = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    this.callParent(colors);
	    (0, _lodash.forEach)(this.pens, function (pen) {
	      pen.getColors(colors);
	    });
	    return colors;
	  },
	  canProcess: function () /* figure */{
	    return _config.Config.localPenContour;
	  },
	  nearEqual: function (a, b) {
	    var eps = arguments.length <= 2 || arguments[2] === undefined ? 0.001 : arguments[2];
	    return Math.abs(a - b) <= eps;
	  },
	  nearTableEqual: function (table, value) {
	    var _this = this;
	
	    var r = void 0;
	    (0, _lodash.forEach)(Object.keys(table), function (v) {
	      if (_this.nearEqual(v, value) && r === undefined) r = table[v];
	    });
	    return r;
	  },
	  process: function (c) {
	    var _this2 = this;
	
	    // Figures: [ TextLayout, GShape, Raster ]
	    var figures = c.figures;
	    if (figures.length === 0) {
	      return;
	    } // I think we can remove this check
	    var base = (0, _figure.toSingleGShape)(figures, true);
	
	    // Remove powerclips from contour figure, they will just make everything slower
	    base.removePowerClips();
	
	    var size = getBaseWidth(base);
	
	    var maxOffset = size;
	
	    if (this.advancedSpacing) {
	      var _pens = this._pens;
	      for (var k = 0, kEnd = _pens.length; k < kEnd; ++k) {
	        var pen = _pens[k];
	        maxOffset += pen.width / 2;
	      }
	    }
	
	    var extraKerningChanges = 0;
	
	    (0, _lodash.forEach)(figures, function (textLayout) {
	      if (textLayout instanceof _text.TextLayout) {
	        var shouldOutdate = false;
	
	        if (_this2.advancedSpacing) {
	          var lines = textLayout.textLines();
	
	          var pairs = [];
	          var default_gapX = 0.0;
	          var default_gapY = 0.0;
	
	          var fontData = textLayout.text._fontData;
	
	          if (fontData != null) {
	            var table = fontData.metaData;
	
	            if (table != null) {
	              var fontSize = textLayout.text.properties.fontSize;
	
	              //const sizeTable = table[fontSize.toFixed(4)] ;
	
	              var sizeTable = _this2.nearTableEqual(table, fontSize);
	
	              if (sizeTable !== undefined) {
	                //const all_pairs = sizeTable[maxOffset.toFixed(4)] ;
	
	                var all_pairs = _this2.nearTableEqual(sizeTable, maxOffset);
	
	                if (all_pairs !== undefined) {
	                  for (var i = 0, _c = all_pairs.length; i < _c; ++i) {
	                    var entry = all_pairs[i];
	
	                    var tlc = entry['L'];
	                    var trc = entry['R'];
	                    var tsx = entry['S'];
	                    var tsy = entry['Y'];
	
	                    if (tlc !== undefined && trc !== undefined && (tsx !== undefined || tsy !== undefined)) {
	                      pairs.push(entry);
	                    } else if (tlc === undefined && trc === undefined && (tsx !== undefined || tsy !== undefined)) {
	                      default_gapX = tsx !== undefined ? tsx : 0.0;
	                      default_gapY = tsy !== undefined ? tsy : 0.0;
	                    }
	                  }
	                }
	              }
	            }
	          }
	
	          for (var li = 0, lc = lines.length; li < lc; ++li) {
	            var line = lines[li];
	
	            var chars = line._chars;
	
	            for (var ci = 0, cc = chars.length, cl = chars.length - 1; ci < cl; ++ci) {
	              var leftc = chars[ci]._char;
	              var rightc = chars[ci + 1]._char;
	
	              var extraKerningX = default_gapX;
	              var extraKerningY = default_gapY;
	
	              for (var _i = 0, _c2 = pairs.length; _i < _c2; ++_i) {
	                var _entry = pairs[_i];
	                var _tlc = _entry['L'];
	                var _trc = _entry['R'];
	                var _tsx = _entry['S'];
	                var _tsy = _entry['Y'];
	
	                if (_tlc !== undefined && _trc !== undefined && (_tsx !== undefined || _tsy !== undefined)) {
	                  if (_tlc === leftc && _trc === rightc) {
	                    extraKerningX = _tsx !== undefined ? _tsx : 0.0;
	                    extraKerningY = _tsy !== undefined ? _tsy : 0.0;
	                    break;
	                  }
	                }
	              }
	
	              if (extraKerningX != 0.0 || extraKerningY != 0.0) {
	                var extraKerning = Math.abs(_geometry.Point.dotProduct(textLayout.text.effectiveLineDirection(), new _geometry.Point(extraKerningX, extraKerningY)));
	
	                textLayout.charData(li + 1, ci + 2)._extraKerning = extraKerning;
	
	                ++extraKerningChanges;
	
	                shouldOutdate = true;
	              }
	            }
	          }
	        }
	
	        if (shouldOutdate) {
	          textLayout.invalidate();
	          textLayout.textLines();
	        }
	      }
	    });
	
	    if (extraKerningChanges > 0) {
	      base = (0, _figure.toSingleGShape)(figures, true);
	      base.removePowerClips();
	    }
	
	    var pens = this._pens;
	    var contours = [];
	    var behindFill = false;
	    for (var _k = 0, _kEnd = pens.length; _k < _kEnd; ++_k) {
	      var _pen = pens[_k];
	      size += _pen.width;
	      var lFigure = createContourFigure(base, _pen, size);
	      if (_pen._behindFill) {
	        behindFill = true;
	      }
	      contours.push(lFigure);
	    }
	
	    if (behindFill) {
	      for (var _k2 = 0, _kEnd2 = contours.length; _k2 < _kEnd2; ++_k2) {
	        c.figures.unshift(contours[_k2]);
	      }
	    } else {
	      for (var _k3 = contours.length - 1, _kEnd3 = 0; _k3 >= _kEnd3; --_k3) {
	        c.figures.push(contours[_k3]);
	      }
	    }
	  }
	});
	_util.Xml.addFromBuild(PenContour);
	
	// Shadow
	//===============================================================================================
	
	var Shadow = _process.Process.Shadow = _process.Process.extend({ typeName: 'ShadowProcess',
	  type: 'Shadow',
	  Properties: {
	    pen: { type: 'Pen', def: _style.Pen.empty, onChange: _gear.invalidateOwner },
	    brush: { type: 'Brush', def: _style.Brush.empty, onChange: _gear.invalidateOwner },
	    offsetX: { type: 'magnitude', def: new _gear.Magnitude(0, 'mm'), onChange: _gear.invalidateOwner, dropDef: true },
	    offsetY: { type: 'magnitude', def: new _gear.Magnitude(0, 'mm'), onChange: _gear.invalidateOwner, dropDef: true },
	    gap: { type: 'magnitude', def: new _gear.Magnitude(0, 'mm'), onChange: _gear.invalidateOwner, dropDef: true },
	    simplify: { type: 'boolean', def: false, onChange: _gear.invalidateOwner, dropDef: true }
	  }
	});
	_util.Xml.addFromBuild(Shadow);
	
	// RasterShadow
	//===============================================================================================
	
	var RasterShadowGap = _process.Process.RasterShadowGap = _gear.OwnedObject.extend({ typeName: 'RasterShadowGap',
	  Properties: {
	    pen: { type: 'Pen', def: _style.Pen.empty, onChange: _gear.invalidateOwner }
	  },
	  getColors: function () {
	    var colors = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    this._pen.getColors(colors);
	    return colors;
	  }
	});
	_util.Xml.addFromBuild(RasterShadowGap, 'Gap');
	
	var RasterShadow = _process.Process.RasterShadow = _process.Process.extend({ typeName: 'RasterShadowProcess',
	  type: 'RasterShadow',
	  Properties: {
	    pen: { type: 'Pen', def: _style.Pen.empty, onChange: _gear.invalidateOwner },
	    brush: { type: 'Brush', def: _style.Brush.empty, onChange: _gear.invalidateOwner },
	    offsetX: { type: 'magnitude', def: new _gear.Magnitude(0, 'mm'), onChange: _gear.invalidateOwner, dropDef: true },
	    offsetY: { type: 'magnitude', def: new _gear.Magnitude(0, 'mm'), onChange: _gear.invalidateOwner, dropDef: true },
	    gap: { type: 'RasterShadowGap', def: null, onChange: _gear.invalidateOwner, dropDef: true, manualParsing: true }
	  },
	  getColors: function () {
	    var colors = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    this.callParent(colors);
	    var gap = this._gap;
	    if (gap) {
	      gap.getColors(colors);
	    }
	    return colors;
	  },
	  setupXml: function (node) {
	    _util.Xml.setupProperties(node, this);
	    var gap = this._gap;
	    if (gap) {
	      gap.buildXml(node);
	    }
	  },
	  canProcess: function () /*figure*/{
	    return _config.Config.localRasterShadow;
	  },
	  process: function (c) {
	    var pen = this._pen,
	        brush = this._brush,
	        figures = c.figures;
	    if (pen._empty && brush._empty) {
	      return;
	    }
	
	    var base = (0, _figure.toSingleGShape)(figures);
	
	    // Remove powerclips from contour figure, they will just make everything slower
	    // We may add an option later to include powerclips in the Base
	    base.removePowerClips();
	
	    var frame = _geometry.Frame.fromBounds(base.vectorBounds());
	
	    var gapFigure = null,
	        effectiveGap = 0;
	
	    var gap = this.gap;
	
	    if (gap) {
	      (function () {
	
	        var maxInputWidth = getBaseWidth(base);
	
	        var gapPen = gap._pen;
	        var effectiveGapPen = gapPen.clone();
	        effectiveGapPen.width = gapPen.width + maxInputWidth;
	
	        effectiveGap = effectiveGapPen.width;
	
	        gapFigure = base.clone();
	
	        gapFigure.setRenderFrame(frame);
	
	        var gapBrush = (0, _style.Brush)({ color: gapPen.color });
	
	        (0, _lodash.forEach)(gapFigure._polyregions, function (p) {
	          p._renderMatrix = null;
	          p.pen = effectiveGapPen;
	          p.brush = gapBrush;
	        });
	
	        figures.unshift(gapFigure);
	      })();
	    }
	
	    var effectivePen = pen;
	    var effectiveBrush = brush;
	
	    // [CHECK]
	    /* This was in the engine but it shouldn't be triggered consistently
	       because it is only looking at the GShape pen and brush and not
	       at the polyregions
	    if( effectivePen._empty && ! base._pen._empty && ! brush._emty ) {
	      effectivePen = base._pen.clone();
	      effectivePen.color = brush.color;
	    }
	      if( effectiveBrush._empty && ! base._brush._empty && ! pen._empty ) {
	      effectiveBrush = base._brush.clone();
	      effectivePen.color = pen.color;
	    }
	    */
	
	    var t = _geometry.Matrix.translate(this._offsetX + effectiveGap, this._offsetY + effectiveGap);
	
	    base.setRenderFrame(frame.transformed(t));
	
	    (0, _lodash.forEach)(base._polyregions, function (p) {
	      p._renderMatrix = null;
	      p.pen = effectivePen;
	      p.brush = effectiveBrush;
	      p.transform(t);
	    });
	
	    figures.unshift(base);
	  }
	});
	RasterShadow.parseXml = function (node) {
	  var p = _util.Xml.parseProperties(node, RasterShadow);
	  var gapNode = _util.Xml.child(node, 'Gap');
	  if (gapNode) {
	    p.gap = RasterShadowGap.parseXml(gapNode);
	  }
	  return new RasterShadow(p);
	};
	_util.Xml.addFromBuild(RasterShadow);
	
	// Effect3d
	//===============================================================================================
	
	var Effect3d = _process.Process.Effect3d = _process.Process.extend({ typeName: 'Effect3dProcess',
	  type: 'Effect3d',
	  Properties: {
	    borderIntensity: { type: 'number', def: 0.7, onChange: _gear.invalidateOwner },
	    borderSize: { type: 'magnitude', def: new _gear.Magnitude(1.0, 'mm'), onChange: _gear.invalidateOwner },
	    contourOffset: { type: 'magnitude', def: new _gear.Magnitude(1.0, 'mm'), onChange: _gear.invalidateOwner },
	    contourRegularizeW: { type: 'magnitude', def: new _gear.Magnitude(0.0, 'mm'), onChange: _gear.invalidateOwner },
	    lightGap: { type: 'magnitude', def: new _gear.Magnitude(2.0, 'mm'), onChange: _gear.invalidateOwner },
	    lightIntensity: { type: 'number', def: 0.7, onChange: _gear.invalidateOwner },
	    lightSize: { type: 'magnitude', def: new _gear.Magnitude(3.0, 'mm'), onChange: _gear.invalidateOwner },
	    lightSource: { type: 'string', def: 'Up', onChange: _gear.invalidateOwner },
	    shadowIntensity: { type: 'number', def: 0.35, onChange: _gear.invalidateOwner },
	    shadowSizePercentage: { type: 'number', def: 0.95, onChange: _gear.invalidateOwner },
	    slopeIntensity: { type: 'number', def: 0.3, onChange: _gear.invalidateOwner },
	    slopeSize: { type: 'magnitude', def: new _gear.Magnitude(1.5, 'mm'), onChange: _gear.invalidateOwner }
	  }
	});
	_util.Xml.addFromBuild(Effect3d);
	
	// Extrude3d
	//===============================================================================================
	
	var Extrude3D = _process.Process.Extrude3D = _process.Process.extend({ typeName: 'Extrude3DProcess',
	  type: 'Extrude3D',
	  Properties: {
	    pen: { type: 'Pen', def: _style.Pen.empty, onChange: _gear.invalidateOwner },
	    brush: { type: 'Brush', def: _style.Brush.empty, onChange: _gear.invalidateOwner },
	    depth: { type: 'magnitude', def: new _gear.Magnitude(0.0, 'mm'), onChange: _gear.invalidateOwner },
	    vanishingPoint: { type: 'Point', def: new _geometry.Point(0, 0), onChange: _gear.invalidateOwner },
	    rotationX: { type: 'angle', def: 0, onChange: _gear.invalidateOwner, dropDef: true },
	    rotationY: { type: 'angle', def: 0, onChange: _gear.invalidateOwner, dropDef: true },
	    rotationZ: { type: 'angle', def: 0, onChange: _gear.invalidateOwner, dropDef: true }
	  }
	});
	_util.Xml.addFromBuild(Extrude3D);
	
	// SimStitch
	//===============================================================================================
	
	var SimStitch = _process.Process.SimStitch = _process.Process.extend({ typeName: 'SimStitchProcess',
	  type: 'SimStitch',
	  Properties: {
	    pen: { type: 'Pen', def: _style.Pen.empty, onChange: _gear.invalidateOwner },
	    brush: { type: 'Brush', def: _style.Brush.empty, onChange: _gear.invalidateOwner },
	    width: { type: 'magnitude', def: new _gear.Magnitude(3.0, 'mm'), onChange: _gear.invalidateOwner },
	    density: { type: 'magnitude', def: new _gear.Magnitude(2.0, 'mm'), onChange: _gear.invalidateOwner },
	    overlap: { type: 'number', def: 75.0, onChange: _gear.invalidateOwner },
	    tackdown: { type: 'magnitude', def: new _gear.Magnitude(0.5, 'mm'), onChange: _gear.invalidateOwner },
	    onlyStitching: { type: 'boolean', def: false, onChange: _gear.invalidateOwner },
	    transformIndependent: { type: 'boolean', def: false, onChange: _gear.invalidateOwner },
	    thickness: { type: 'magnitude', def: new _gear.Magnitude(0.5842, 'mm'), onChange: _gear.invalidateOwner }
	  },
	  canProcess: function () /*figure*/{
	    return false;
	  }
	});
	
	_util.Xml.addFromBuild(SimStitch);
	
	// Engrave
	//===============================================================================================
	
	var collapseIntoSinglePolyregion = function (shape) {
	
	  var polyregions = shape._polyregions;
	
	  var collapsedPolyregion = polyregions[0];
	
	  // This process forces fillMode winding, in case it was CadX, it will
	  // convert holes into regions
	  collapsedPolyregion.setFillMode('Winding');
	
	  var curves = collapsedPolyregion.enumCurves();
	  while (polyregions.length > 1) {
	    var extraPolyregion = (0, _lodash.last)(polyregions);
	    var extraCurves = extraPolyregion.enumCurves();
	    for (var c = 0, cEnd = extraCurves.length; c < cEnd; ++c) {
	      curves.push(extraCurves[c]);
	    }
	    polyregions.pop();
	  }
	
	  collapsedPolyregion.regions = (0, _figure.mapCurvesToRegions)(curves);
	};
	
	// Gets the orientation of the outer most curve from an a list of curves
	var outerMostOrientation = function (curves) {
	  var bottomCurve,
	      bottomCurve_ly = Number.MAX_VALUE;
	  for (var i = 0, iEnd = curves.length; i < iEnd; ++i) {
	    var curve = curves[i];
	    var ly = curve.bounds.ly;
	    if (ly < bottomCurve_ly) {
	      bottomCurve_ly = ly;
	      bottomCurve = curve;
	    }
	  }
	  return bottomCurve.orientation();
	};
	
	var Engrave = _process.Process.Engrave = _process.Process.extend({ typeName: 'EngraveProcess',
	  type: 'Engrave',
	  Properties: {
	    // curves
	  },
	  init: function (c) {
	    this.callParent();
	    this._curves = c.curves || [];
	  },
	
	  get curves() {
	    return this._curves;
	  },
	  isEqual: function (other) {
	    return this.propertiesAreEqual(other) && (0, _gear.areEqual)(this._curves, other._curves);
	  },
	  setupXml: function (node) {
	    _util.Xml.setupProperties(node, this);
	    var curves = this._curves;
	    for (var k = 0, kEnd = curves.length; k < kEnd; ++k) {
	      curves[k].setupXml(_util.Xml.appendElement(node, 'Curve'));
	    }
	  },
	  clone: function () {
	    var c = new Engrave(this);
	    c._curves = (0, _gear.cloneDeep)(this._curves);
	    return c;
	  },
	  canProcess: function () /*figure*/{
	    return true;
	  },
	  process: function (c) {
	
	    if (this.curves.length === 0) {
	      return;
	    }
	
	    var figures = c.figures;
	
	    // Path is centered around the anchor, leave c.anchor untouched after this
	    var curves = (0, _lodash.invokeMap)(this.curves, 'transformed', _geometry.Matrix.translate(c.anchor));
	
	    var shape = (0, _figure.toSingleGShape)(figures);
	
	    // Every polyregion is collapsed into the first one, to support multi line
	    // text and mutlipart text.
	    collapseIntoSinglePolyregion(shape);
	
	    var collapsedPolyregion = shape._polyregions[0];
	
	    // Check if the path needs to be reversed
	
	    var shapeOrientation = outerMostOrientation(collapsedPolyregion.enumCurves()),
	        curvesOrientation = outerMostOrientation(curves);
	
	    var reverseCurves = shapeOrientation === curvesOrientation;
	
	    for (var k = 0, kEnd = curves.length; k < kEnd; ++k) {
	      var curve = curves[k];
	      if (reverseCurves) {
	        curve = curve.reversed();
	      }
	
	      collapsedPolyregion._regions.add(new _figure.Region([curve]));
	    }
	
	    shape.setRenderFrame(shape.bounds);
	
	    c.figures = [shape];
	  }
	});
	
	Engrave.parseXml = function (node) {
	  var p = _util.Xml.parseProperties(node, Engrave);
	  p.curves = _geometry.Boundary.arrayFromXml(node, 'Curve');
	  return new Engrave(p);
	};
	_util.Xml.addFromBuild(Engrave);
	
	// OutlineRhinestone
	//=============================================================================
	
	/*var processHelperFunctionsIfNeeded = function(/*shape, curves or whatever* /) {
	  // ...
	};*/
	
	var areOverlapping = function (rhinestone1, rhinestone2) {
	  var dx = rhinestone1.x - rhinestone2.x;
	  var dy = rhinestone1.y - rhinestone2.y;
	  var dist2 = dx * dx + dy * dy;
	  var r1_plus_r2 = rhinestone1.radius + rhinestone2.radius;
	  var r1_minus_r2 = rhinestone1.radius - rhinestone2.radius;
	  return r1_minus_r2 * r1_minus_r2 <= dist2 && dist2 <= r1_plus_r2 * r1_plus_r2;
	};
	
	var noOverlapping = function (rhinestone, ctx) {
	  var max_neighbors = Math.min(ctx.rhinestones.length, ctx.max_comparisons);
	  var nearest = ctx.tree.nearest(rhinestone, max_neighbors);
	  var rhinestones = Array.from(nearest, function (x) {
	    return x[0];
	  });
	  var i = 0,
	      len = rhinestones.length;
	  while (i < len && !areOverlapping(rhinestone, rhinestones[i])) {
	    i++;
	  }return i >= len;
	};
	
	var getRhinestone = function (center, config) {
	  var circleBoundary = _geometry.Boundary.createEllipse({ center: center, height: config.diameter });
	  var circle = _shape.Shape.createFromCurve(circleBoundary, { pen: config.pen, brush: config.brush }).toGShape();
	  return {
	    shape: circle,
	    x: center.x,
	    y: center.y,
	    radius: config.diameter / 2 + config.pen.width
	  };
	};
	
	var addRhinestone = function (ctx, p, config) {
	  var rhinestone = getRhinestone(p, config);
	  if (ctx.rhinestones.length === 0) {
	    ctx.rhinestones.push(rhinestone);
	    ctx.tree.insert(rhinestone);
	  } else if (noOverlapping(rhinestone, ctx)) {
	    ctx.rhinestones.push(rhinestone);
	    ctx.tree.insert(rhinestone);
	  }
	  return ctx;
	};
	
	var getRhinestonesOnShapeInterior = function (ctx, shape, config, shift) {
	  var bounds = shape.bounds;
	  var polyregions = shape.polyregions;
	  var shiftDistance = 0;
	  var separation = config.separation;
	  var halfSeparation = separation / 2;
	  for (var i = bounds.ly, iteration = 0, iEnd = bounds.hy; i < iEnd; i += separation, ++iteration) {
	    if (shift) {
	      shiftDistance = iteration % 2 == 0 ? 0 : halfSeparation;
	    }
	    for (var j = bounds.lx + shiftDistance, jEnd = bounds.hx; j < jEnd; j += separation) {
	      var p = new _geometry.Point(j, i);
	      for (var k = 0, kEnd = polyregions.length; k < kEnd; ++k) {
	        if (polyregions[k].hitTest(p, new _geometry.Matrix())) {
	          ctx = addRhinestone(ctx, p, config);
	          break;
	        }
	      }
	    }
	  }
	  return ctx;
	};
	
	var getCurveRhinestones = function (ctx, curve, config) {
	  var curveArcLength = curve.arcLength();
	  if (curveArcLength > config.separation) {
	    var separation = config.separation > 0.0 ? config.separation : 1;
	    var j = 0;
	    for (var i = 0, iEnd = curve.pieces.length; i < iEnd; i++) {
	      var piece = curve.pieces[i];
	      var pieceArcLength = piece.arcLength();
	      while (j < pieceArcLength) {
	        ctx = addRhinestone(ctx, piece.at(j), config);
	        j += separation;
	      }
	      j -= pieceArcLength;
	    }
	  }
	  return ctx;
	};
	
	var getRhinestonesOnShapeCurves = function (ctx, shape, config) {
	  var polyregions = shape.polyregions;
	  for (var i = 0, iEnd = polyregions.length; i < iEnd; ++i) {
	    var curves = polyregions[i].enumCurves();
	    for (var k = 0, kEnd = curves.length; k < kEnd; ++k) {
	      ctx = getCurveRhinestones(ctx, curves[k], config);
	    }
	  }
	  return ctx;
	};
	
	var Rhinestone = _process.Process.Rhinestone = _process.Process.extend({
	  typeName: 'RhinestoneProcess',
	  type: 'Rhinestone',
	  Properties: {
	    method: { type: 'string', def: 'curve', onChange: _gear.invalidateOwner, dropDef: true },
	    separation: { type: 'number', def: 1.5, onChange: _gear.invalidateOwner, dropDef: true },
	    size: { type: 'number', def: 1.5, onChange: _gear.invalidateOwner, dropDef: true },
	    bFactor: { type: 'number', def: 1.5, onChange: _gear.invalidateOwner, dropDef: true },
	    maxComparisons: { type: 'number', def: 10, onChange: _gear.invalidateOwner, dropDef: true },
	    pen: { type: 'Pen', def: _style.Pen.empty, onChange: _gear.invalidateOwner },
	    brush: { type: 'Brush', def: _style.Brush.empty, onChange: _gear.invalidateOwner }
	  },
	  init: function (c) {
	    // optional
	    this.callParent();
	    this._curves = c.curves || [];
	  },
	  isEqual: function (other) {
	    // optional
	  },
	  setupXml: function (node) {
	    _util.Xml.setupProperties(node, this);
	  },
	  clone: function () {
	    var c = new Rhinestone(this);
	    return c;
	  },
	  canProcess: function () /*figure*/{
	    return true;
	  },
	  process: function (c) {
	    if (c.rhinestone_ctx === undefined) {
	      // create rhinestone context
	      c.rhinestone_ctx = {
	        rhinestones: [],
	        tree: new _kdTree.kdTree([], _geometry.Point.distance2, ['x', 'y']),
	        max_comparisons: this._maxComparisons
	      };
	    } else if (c.rhinestone_ctx.tree.balanceFactor() > this._bFactor) {
	      // rebalance k-d tree
	      c.rhinestone_ctx.tree = new _kdTree.kdTree(c.rhinestone_ctx.rhinestones, _geometry.Point.distance2, ['x', 'y']);
	    }
	    var shape = (0, _figure.toSingleGShape)(c.figures);
	    var config = {
	      pen: this._pen,
	      brush: this._brush,
	      separation: this._separation,
	      diameter: this._size
	    };
	
	    switch (this._method.toLowerCase()) {
	      case 'mfill':
	        c.rhinestone_ctx = getRhinestonesOnShapeInterior(c.rhinestone_ctx, shape, config, false);
	        break;
	      case 'sfill':
	        c.rhinestone_ctx = getRhinestonesOnShapeInterior(c.rhinestone_ctx, shape, config, true);
	        break;
	      case 'curve': // default is curve
	      default:
	        c.rhinestone_ctx = getRhinestonesOnShapeCurves(c.rhinestone_ctx, shape, config);
	        break;
	    }
	    var rhinestoneShapes = Array.from(c.rhinestone_ctx.rhinestones, function (r) {
	      return r.shape;
	    });
	    c.figures = [shape].concat(rhinestoneShapes);
	    shape.setRenderFrame(shape.bounds);
	  }
	});
	
	Rhinestone.parseXml = function (node) {
	  var p = _util.Xml.parseProperties(node, Rhinestone);
	  return new Rhinestone(p);
	};
	_util.Xml.addFromBuild(Rhinestone);

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * k-d Tree JavaScript - V 1.01
	 *
	 * https://github.com/ubilabs/kd-tree-javascript
	 *
	 * @author Mircea Pricop <pricop@ubilabs.net>, 2012
	 * @author Martin Kleppe <kleppe@ubilabs.net>, 2012
	 * @author Ubilabs http://ubilabs.net, 2012
	 * @license MIT License <http://www.opensource.org/licenses/mit-license.php>
	 */!function(t,n){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (n), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):n("object"==typeof exports?exports:t)}(this,function(t){function n(t,n,o){this.obj=t,this.left=null,this.right=null,this.parent=o,this.dimension=n}function o(t){this.content=[],this.scoreFunction=t}o.prototype={push:function(t){this.content.push(t),this.bubbleUp(this.content.length-1)},pop:function(){var t=this.content[0],n=this.content.pop();return this.content.length>0&&(this.content[0]=n,this.sinkDown(0)),t},peek:function(){return this.content[0]},remove:function(t){for(var n=this.content.length,o=0;o<n;o++)if(this.content[o]==t){var i=this.content.pop();return void(o!=n-1&&(this.content[o]=i,this.scoreFunction(i)<this.scoreFunction(t)?this.bubbleUp(o):this.sinkDown(o)))}throw new Error("Node not found.")},size:function(){return this.content.length},bubbleUp:function(t){for(var n=this.content[t];t>0;){var o=Math.floor((t+1)/2)-1,i=this.content[o];if(!(this.scoreFunction(n)<this.scoreFunction(i)))break;this.content[o]=n,this.content[t]=i,t=o}},sinkDown:function(t){for(var n=this.content.length,o=this.content[t],i=this.scoreFunction(o);;){var e=2*(t+1),r=e-1,l=null;if(r<n){var u=this.content[r],h=this.scoreFunction(u);h<i&&(l=r)}if(e<n){var s=this.content[e];this.scoreFunction(s)<(null==l?i:h)&&(l=e)}if(null==l)break;this.content[t]=this.content[l],this.content[l]=o,t=l}}},t.kdTree=function(t,i,e){function r(t,o,i){var l,u,h=o%e.length;return 0===t.length?null:1===t.length?new n(t[0],h,i):(t.sort(function(t,n){return t[e[h]]-n[e[h]]}),l=Math.floor(t.length/2),u=new n(t[l],h,i),u.left=r(t.slice(0,l),o+1,u),u.right=r(t.slice(l+1),o+1,u),u)}var l=this;Array.isArray(t)?this.root=r(t,0,null):function(t){function n(t){t.left&&(t.left.parent=t,n(t.left)),t.right&&(t.right.parent=t,n(t.right))}l.root=t,n(l.root)}(t),this.toJSON=function(t){t||(t=this.root);var o=new n(t.obj,t.dimension,null);return t.left&&(o.left=l.toJSON(t.left)),t.right&&(o.right=l.toJSON(t.right)),o},this.insert=function(t){function o(n,i){if(null===n)return i;var r=e[n.dimension];return t[r]<n.obj[r]?o(n.left,n):o(n.right,n)}var i,r,l=o(this.root,null);null!==l?(i=new n(t,(l.dimension+1)%e.length,l),r=e[l.dimension],t[r]<l.obj[r]?l.left=i:l.right=i):this.root=new n(t,0,null)},this.remove=function(t){function n(o){if(null===o)return null;if(o.obj===t)return o;var i=e[o.dimension];return t[i]<o.obj[i]?n(o.left,o):n(o.right,o)}function o(t){function n(t,o){var i,r,l,u,h;return null===t?null:(i=e[o],t.dimension===o?null!==t.left?n(t.left,o):t:(r=t.obj[i],l=n(t.left,o),u=n(t.right,o),h=t,null!==l&&l.obj[i]<r&&(h=l),null!==u&&u.obj[i]<h.obj[i]&&(h=u),h))}var i,r,u;if(null===t.left&&null===t.right)return null===t.parent?void(l.root=null):(u=e[t.parent.dimension],void(t.obj[u]<t.parent.obj[u]?t.parent.left=null:t.parent.right=null));null!==t.right?(r=(i=n(t.right,t.dimension)).obj,o(i),t.obj=r):(r=(i=n(t.left,t.dimension)).obj,o(i),t.right=t.left,t.left=null,t.obj=r)}var i;null!==(i=n(l.root))&&o(i)},this.nearest=function(t,n,r){function u(o){function r(t,o){f.push([t,o]),f.size()>n&&f.pop()}var l,h,s,c,a=e[o.dimension],g=i(t,o.obj),p={};for(c=0;c<e.length;c+=1)c===o.dimension?p[e[c]]=t[e[c]]:p[e[c]]=o.obj[e[c]];h=i(p,o.obj),null!==o.right||null!==o.left?(u(l=null===o.right?o.left:null===o.left?o.right:t[a]<o.obj[a]?o.left:o.right),(f.size()<n||g<f.peek()[1])&&r(o,g),(f.size()<n||Math.abs(h)<f.peek()[1])&&null!==(s=l===o.left?o.right:o.left)&&u(s)):(f.size()<n||g<f.peek()[1])&&r(o,g)}var h,s,f;if(f=new o(function(t){return-t[1]}),r)for(h=0;h<n;h+=1)f.push([null,r]);for(l.root&&u(l.root),s=[],h=0;h<Math.min(n,f.content.length);h+=1)f.content[h][0]&&s.push([f.content[h][0].obj,f.content[h][1]]);return s},this.balanceFactor=function(){function t(n){return null===n?0:Math.max(t(n.left),t(n.right))+1}function n(t){return null===t?0:n(t.left)+n(t.right)+1}return t(l.root)/(Math.log(n(l.root))/Math.log(2))}},t.BinaryHeap=o});


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	var _geometry = __webpack_require__(21);
	
	var _figure = __webpack_require__(35);
	
	var _process = __webpack_require__(40);
	
	var _envelope = __webpack_require__(73);
	
	// Constrain
	//===============================================================================================
	
	// Scale Chars using PivotedScaler, that works when using together
	// with FitOnPath, and after BookEnd
	
	// Only works for lineDirection % PI/2 == 0
	var scaleChars = function (layout, sx, sy) {
	
	  var lines = layout.textLines();
	  var pivot = layout.pivot();
	  var isHorizontal = !layout.text.isVertical();
	
	  for (var i = 0, iEnd = lines.length; i < iEnd; ++i) {
	    var lineChars = lines[i]._chars,
	        count = lineChars.length;
	
	    var accExtraKerning = 0,
	        accOriginalExtraKerning = 0;
	
	    if (count > 0) {
	      // const totalShift = 0;
	      var lineIdx = i + 1;
	      for (var j = 0; j < count; ++j) {
	        var char = lineChars[j];
	        var idx = j + 1;
	
	        // Pick the scaling command for this char, if any
	        var charData = layout.charData(lineIdx, idx);
	
	        var transformers = charData._transformers;
	
	        transformers.push(new _figure.TextChar.PivotedScaler(pivot, sx, sy));
	
	        var originalExtraKerning = charData._extraKerning;
	        var previousHPos = char._originalHPos + accOriginalExtraKerning + originalExtraKerning;
	        accOriginalExtraKerning += originalExtraKerning;
	
	        var desiredHPos = previousHPos * (isHorizontal ? sx : sy);
	        var diffHPos = desiredHPos - previousHPos - accExtraKerning;
	
	        charData._extraKerning += diffHPos;
	
	        accExtraKerning += diffHPos;
	      }
	    }
	
	    layout.invalidate();
	  }
	};
	
	function computeScaleRange(size, minSize, maxSize) {
	  return {
	    min: minSize > 0 ? minSize / size : 0,
	    max: maxSize > 0 ? maxSize / size : Number.MAX_VALUE
	  };
	}
	
	function computeScale(range, fit) {
	
	  var s_min = range.min,
	      s_max = range.max;
	
	  if (s_min > s_max) {
	    // We can not respect the constrain: MaxWidth, MaxHeight takes precedence
	    // ignore s_min
	    s_min = 0;
	  }
	
	  switch (fit) {
	
	    case 'Stretched':
	      return s_max;
	
	    case 'Compressed':
	      return s_min;
	
	    default:
	      // Use minimun deformation
	      return Math.min(Math.max(s_min, 1), s_max);
	  }
	}
	
	function effectiveFit(fit, minSize, maxSize) {
	  return minSize === 0 && fit === 'Compressed' || maxSize === 0 && fit === 'Stretched' ? 'Contained' : fit;
	}
	
	var Constrain = _process.Process.Constrain = _process.Process.extend({ typeName: 'ConstrainProcess',
	
	  type: 'Constrain',
	
	  Properties: {
	    maxWidth: { type: 'magnitude', def: new _gear.Magnitude(0, 'mm'), onChange: _gear.invalidateOwner, dropDef: true },
	    maxHeight: { type: 'magnitude', def: new _gear.Magnitude(0, 'mm'), onChange: _gear.invalidateOwner, dropDef: true },
	    minWidth: { type: 'magnitude', def: new _gear.Magnitude(0, 'mm'), onChange: _gear.invalidateOwner, dropDef: true },
	    minHeight: { type: 'magnitude', def: new _gear.Magnitude(0, 'mm'), onChange: _gear.invalidateOwner, dropDef: true },
	    isometric: { type: 'boolean', def: false, onChange: _gear.invalidateOwner, dropDef: true },
	    hFit: { type: 'string', def: 'Contained', onChange: _gear.invalidateOwner, dropDef: true },
	    vFit: { type: 'string', def: 'Contained', onChange: _gear.invalidateOwner, dropDef: true }
	  },
	
	  outputsText: function () {
	    return true;
	  },
	  canProcess: function () /*figure*/{
	    return true;
	  },
	
	
	  // Guard against setting stretching and compressing
	  // without a Max or Min value
	
	  get effectiveHFit() {
	    return effectiveFit(this.hFit, this.minWidth, this.maxWidth);
	  },
	  get effectiveVFit() {
	    return effectiveFit(this.vFit, this.minHeight, this.maxHeight);
	  },
	
	  get effectiveIsometricFit() {
	    var hFit = this.effectiveHFit,
	        vFit = this.effectiveVFit;
	
	    // Stretched takes precedence
	    return hFit === 'Stretched' || vFit === 'Stretched' ? 'Stretched' : hFit === 'Compressed' || vFit === 'Compressed' ? 'Compressed' : 'Contained';
	  },
	
	  createTransform: function (bounds) {
	
	    var scaleRange_x = computeScaleRange(bounds.width, this.minWidth, this.maxWidth),
	        scaleRange_y = computeScaleRange(bounds.height, this.minHeight, this.maxHeight);
	
	    var sx = void 0,
	        sy = void 0;
	
	    if (this.isometric) {
	
	      var scaleRange = {
	        min: Math.max(scaleRange_x.min, scaleRange_y.min),
	        max: Math.min(scaleRange_x.max, scaleRange_y.max)
	      };
	
	      sx = sy = computeScale(scaleRange, this.effectiveIsometricFit);
	    } else {
	      sx = computeScale(scaleRange_x, this.effectiveHFit);
	      sy = computeScale(scaleRange_y, this.effectiveVFit);
	    }
	
	    return { sx: sx, sy: sy };
	  },
	
	  process: function (c) {
	    var figures = c.figures;
	    var outFigures = [];
	
	    var bounds = computeBounds(toGShapesAndRasterBounds(figures));
	
	    var constrain = this.createTransform(bounds);
	    var constrainMatrix = _geometry.Matrix.scale(constrain.sx, constrain.sy);
	
	    (0, _lodash.forEach)(figures, function (figure) {
	      var figureToChangePen = figure;
	
	      if (figure instanceof _figure.TextLayout) {
	        // &&  ) {
	        //we cant modify pen if we do this
	        //if( this.keepTextFor(figure) ) {
	        //scaleChars(figure,constrain.sx,constrain.sy);
	        //outFigures.push(figure);
	        //}
	        //else 
	        {
	
	          // Give up... constrain like a shape, loose textLayout
	          var outFigure = figure.toGShape();
	          figureToChangePen = outFigure;
	          modifyCurves(outFigure, function (c) {
	            // do not call .transform because it modifies powerclips,
	            // we will clean up this in future versions
	            c.transform(constrainMatrix);
	          });
	          outFigures.push(outFigure);
	
	          // Transform the basic points of the textLayout so
	          // we are able to edit this text inline
	          figure.transformBasicPoints(constrainMatrix);
	        }
	      } else if (figure instanceof _figure.GShape) {
	        modifyCurves(figure, function (c) {
	          // do not call .transform because it modifies powerclips,
	          // we will clean up this in future versions
	          c.transform(constrainMatrix);
	        });
	        outFigures.push(figure);
	      } else {
	        figure.transform(constrainMatrix);
	        outFigures.push(figure);
	      }
	
	      (0, _lodash.forEach)(figureToChangePen.polyregions, function (p) {
	        if (p.pen && p.pen._type === 'Pen' && p.pen._width > 0.0) {
	          var pen = p.pen.clone();
	          pen.width = pen.width * constrain.sx;
	          p.pen = pen;
	        }
	      });
	
	      if (figureToChangePen.pen && figureToChangePen.pen._type === 'Pen' && figureToChangePen.pen._width > 0.0) {
	        var pen = figureToChangePen.pen.clone();
	        pen.width = pen.width * constrain.sx;
	        figureToChangePen.pen = pen;
	      }
	    });
	
	    // [TODO] Check TextLayout
	
	    var anchor = constrainMatrix.apply(c.anchor);
	
	    setRenderFrame((0, _lodash.filter)(figures, function (figure) {
	      return figure instanceof _figure.GShape;
	    }), _geometry.Frame.fromBounds(bounds.scalingTransform(constrainMatrix)));
	
	    c.figures = outFigures;
	    c.anchor = anchor;
	    c.preScale = constrainMatrix.apply(c.preScale);
	  },
	
	
	  // This is horrible but I do not see a way out for the moment without
	  // removing the extraKerning abstraction
	  // We only support
	  //  Constrain => BookEnd => ... tex   => FitOnPath is fine
	  //  BookEnd => Constrain => ... shape => VerticalArch is fine
	  keepTextFor: function (textLayout) {
	    var ldv = textLayout.text.lineDirectionVector();
	    return textLayout.textLines().length === 1 && (Math.abs(ldv.x) < 1E-10 || Math.abs(ldv.y) < 1E-10) && !(0, _lodash.find)(textLayout.textLines(), function (textLine) {
	      return (0, _lodash.find)(textLine._chars, function (char) {
	        return char._charData._transformers.length > 0;
	      });
	    });
	  }
	});
	
	_util.Xml.addFromBuild(Constrain);
	
	// VerticalArch
	//===============================================================================================
	
	var modifyCurves = function (figure, modifier) {
	  var polyregions = figure.polyregions;
	
	  for (var p = 0, pEnd = polyregions.length; p < pEnd; ++p) {
	    var polyregion = polyregions[p];
	    var regions = polyregion._regions;
	    for (var r = 0, rEnd = regions.length; r < rEnd; ++r) {
	      var curves = regions[r].curves;
	      for (var c = 0, cEnd = curves.length; c < cEnd; ++c) {
	        modifier(curves[c]);
	      }
	    }
	    polyregion.invalidate();
	  }
	  return figure;
	};
	
	var convertSegmentsToBeziers = function (figure) {
	  return modifyCurves(figure.clone(), function (c) {
	    var pieces = c.pieces;
	    for (var i = 0, iEnd = pieces.length; i < iEnd; ++i) {
	      var piece = pieces[i];
	      if (piece instanceof _geometry.Segment) {
	        var P0 = piece.P0,
	            P3 = piece.P1;
	        var P1 = _geometry.Point.sm(P0, 2).add(P3).sm(1 / 3),
	            P2 = _geometry.Point.add(P0, _geometry.Point.sm(P3, 2)).sm(1 / 3);
	
	        pieces[i] = new _geometry.Cubic(P0, P1, P2, P3);
	      }
	    }
	  });
	};
	
	var preprocessInput = function (figure, highResolution, keepLines, polyParams) {
	  var target = null;
	  if (highResolution) {
	    throw 'local highResolution not supported';
	    // Not supported...
	    var poly = figure.polygonize(polyParams); // [TODO]
	    if (poly) {
	      target = keepLines ? poly : poly.supersamplePolyline(); // [TODO]
	    }
	  } else {
	    target = keepLines ? figure.clone() : convertSegmentsToBeziers(figure);
	  }
	  return target;
	};
	
	var BC_VerticalArchTransformation = function (inLX, inHX, ellWidth, ellHeight, arcStartDeg, arcEndDeg, isometric) {
	  // g.assert( inLX < inHX ) ;
	
	  this._isometric = isometric === undefined ? false : isometric;
	
	  this._inMX = (inLX + inHX) / 2;
	
	  var arcStart = (0, _gear.deg2rad)(arcStartDeg),
	      arcEnd = (0, _gear.deg2rad)(arcEndDeg);
	
	  // g.assert(arcStart >= 0 && arcStart <= 2 * Math.PI ) ;
	  // g.assert(arcEnd   >= 0 && arcEnd   <= 2 * Math.PI ) ;
	
	  // g.assert( ( arcStart <= Math.PI && arcStart <= Math.PI ) ||
	  //            ( arcStart >  Math.PI && arcStart >  Math.PI ) ) ;
	
	  var upper = this._upper = arcStart > arcEnd;
	
	  // g.assert( upper ? arcStart > arcEnd : arcStart < arcEnd ) ;
	
	  var sweep = upper ? arcStart - arcEnd : arcEnd - arcStart;
	
	  this._arcMiddle = (arcStart + arcEnd) / 2;
	
	  var xAxis = this._xAxis = ellWidth / 2;
	  this._yAxis = ellHeight / 2;
	
	  this._xCircleArcLen = sweep * xAxis;
	
	  var domLX = xAxis * Math.cos(arcStart);
	  var domHX = xAxis * Math.cos(arcEnd);
	
	  // g.assert(domLX < domHX ) ;
	
	  var domWidth = this._domWidth = domHX - domLX;
	
	  var inWidth = inHX - inLX;
	
	  this._scale = domWidth < inWidth ? domWidth / inWidth : 1;
	};
	
	BC_VerticalArchTransformation.prototype = {
	  apply: function (point) {
	
	    var inMX = this._inMX;
	    var DX = (point.x - inMX) * this._scale;
	    var U = DX / this._domWidth;
	    var L = U * this._xCircleArcLen;
	    var W = L / this._xAxis;
	
	    var phi = this._arcMiddle + (this._upper ? -W : +W);
	
	    var DY = this._yAxis * Math.sin(phi);
	
	    // This scales agains the Y=0 axis. The process also transforms the
	    // anchor so positioning is respected even if the text baseline is not
	    // at zero
	    var posY = point.y;
	    if (this._isometric) {
	      posY *= this._scale;
	    }
	
	    return new _geometry.Point(inMX + DX, posY + DY);
	  }
	};
	
	var VerticalArchTransformation = function (inLX, inHX, ellWidth, ellHeight, arcStartDeg, arcEndDeg, isometric) {
	
	  this._isometric = isometric === undefined ? false : isometric;
	
	  // g.assert( inLX < inHX ) ;
	
	  // http://www.mathopenref.com/coordparamellipse.html
	
	  // g.assert( inLX < inHX ) ;
	
	  this._inMX = (inLX + inHX) / 2;
	
	  var arcStart = (0, _gear.deg2rad)(arcStartDeg),
	      arcEnd = (0, _gear.deg2rad)(arcEndDeg);
	
	  // g.assert(arcStart >= 0 && arcStart <= 2 * Math.PI ) ;
	  // g.assert(arcEnd   >= 0 && arcEnd   <= 2 * Math.PI ) ;
	
	  // g.assert( ( arcStart <= Math.PI && arcStart <= Math.PI ) ||
	  //            ( arcStart >  Math.PI && arcStart >  Math.PI ) ) ;
	
	  this._upper = arcStart > arcEnd;
	
	  // g.assert( upper ? arcStart > arcEnd : arcStart < arcEnd ) ;
	
	  var xAxis = this._xAxis = ellWidth / 2;
	  this._yAxis = ellHeight / 2;
	
	  var domLX = xAxis * Math.cos(arcStart);
	  var domHX = xAxis * Math.cos(arcEnd);
	
	  // g.assert(domLX < domHX ) ;
	
	  var domWidth = this._domWidth = domHX - domLX;
	  this._domMiddle = (domHX + domLX) / 2;
	
	  var inWidth = inHX - inLX;
	
	  this._scale = domWidth < inWidth ? domWidth / inWidth : 1;
	};
	
	VerticalArchTransformation.prototype = {
	  apply: function (point) {
	    var inMX = this._inMX;
	    var dX = (point.x - inMX) * this._scale;
	    var u = (dX - this._domMiddle) / this._xAxis;
	
	    var w = 1 - u * u;
	    if (w < 0) {
	      w = 0;
	    }
	    var dY = this._yAxis * Math.sqrt(w) * (this._upper ? 1 : -1);
	
	    // This scales agains the Y=0 axis. The process also transforms the
	    // anchor so positioning is respected even if the text baseline is not
	    // at zero
	    var posY = point.y;
	    if (this._isometric) {
	      posY *= this._scale;
	    }
	
	    return new _geometry.Point(inMX + dX, posY + dY);
	  }
	};
	
	var VerticalArch = _process.Process.VerticalArch = _process.Process.extend({ typeName: 'VerticalArchProcess',
	  type: 'VerticalArch',
	  Properties: {
	    height: { type: 'magnitude', def: new _gear.Magnitude(0, 'mm'), onChange: _gear.invalidateOwner, dropDef: true },
	    width: { type: 'magnitude', def: new _gear.Magnitude(0, 'mm'), onChange: _gear.invalidateOwner, dropDef: true },
	    from: { type: 'angle', def: 170, onChange: _gear.invalidateOwner, dropDef: true },
	    to: { type: 'angle', def: 10, onChange: _gear.invalidateOwner, dropDef: true },
	    mode: { type: 'string', def: 'Legacy', onChange: _gear.invalidateOwner, dropDef: true }, // Or Ellipse
	    isometric: { type: 'boolean', def: false, onChange: _gear.invalidateOwner, dropDef: true }
	  },
	
	  isInverted: function () {
	    return this._from < this._to || this._width === 0 || this._height === 0;
	  },
	  canProcess: function () /*figure*/{
	    return _config.Config.localVerticalArch;
	  },
	  createTransform: function (bounds) {
	    var Transform = this._mode === 'Legacy' ? BC_VerticalArchTransformation : VerticalArchTransformation;
	    return new Transform(bounds.lx, bounds.hx, this._width, this._height, this._from, this._to, this._isometric);
	  },
	  process: function (c) {
	
	    var figures = c.figures;
	
	    var shapes = toGShapesAndRasterBounds(figures);
	
	    var bounds = computeVectorBounds(shapes);
	
	    var outFigures = [];
	
	    var arch = this.createTransform(bounds);
	
	    (0, _lodash.forEach)(shapes, function (source) {
	      // CDL doesn't expose highResolution and keepLines for this process
	      // We will port that if needed later
	      var target = convertSegmentsToBeziers(source);
	      if (target) {
	
	        modifyCurves(target, function (c) {
	          c.transform(arch);
	        });
	
	        outFigures.push(target);
	      }
	    });
	
	    // Transform char basic points
	    (0, _lodash.forEach)(c.textLayouts, function (layout) {
	      layout.transformBasicPoints(arch);
	    });
	
	    var anchor = arch.apply(c.anchor);
	
	    setRenderFrame(outFigures, _geometry.Frame.fromBounds(computeVectorBounds(outFigures)));
	
	    c.figures = outFigures;
	    c.anchor = anchor;
	  },
	  maxHeightForBounds: function (bounds, textHeight) {
	    return _VerticalArch_maxHeightForBounds(bounds, textHeight, this._to);
	  }
	});
	_util.Xml.addFromBuild(VerticalArch);
	
	// areaHeight = ( 1-sin(to) ) * height + 2 * textHeight
	// areaWidth  = cos(to) * width
	
	var _VerticalArch_maxHeightForBounds = VerticalArch.maxHeightForBounds = function (bounds, textHeight, to) {
	  return 2 * (bounds.height - textHeight) / (1 - Math.abs(Math.sin((0, _gear.deg2rad)(to))));
	};
	
	var _VerticalArch_maxWidthForBounds = VerticalArch.maxWidthForBounds = function (bounds, textHeight, to) {
	  return bounds.width / Math.abs(Math.cos((0, _gear.deg2rad)(to)));
	};
	
	VerticalArch.createForBounds = function (bounds, textHeight, to) {
	  if (to === undefined) {
	    to = 10;
	  }
	  return new VerticalArch({ width: _VerticalArch_maxWidthForBounds(bounds, textHeight, to),
	    height: _VerticalArch_maxHeightForBounds(bounds, textHeight, to),
	    to: to, from: 180 - to });
	};
	
	// Perspective
	//===============================================================================================
	
	var Perspective = _process.Process.Perspective = _process.Process.extend({ typeName: 'PerspectiveProcess',
	  type: 'Perspective',
	  Properties: {
	    hPoint: { type: 'Point', def: null, onChange: _gear.invalidateOwner, dropDef: true },
	    vPoint: { type: 'Point', def: null, onChange: _gear.invalidateOwner, dropDef: true }
	  }
	});
	_util.Xml.addFromBuild(Perspective);
	
	// FitEnvelope
	//===============================================================================================
	
	function computeOutScale(x1, y1, x2, y2, transform, original) {
	  return _geometry.Point.substract(transform.apply(new _geometry.Point(x1, y1)), transform.apply(new _geometry.Point(x2, y2))).norm() / original;
	}
	
	function constructMixedFreeformCoonsPatch(envelopeCurves) {
	  var d = new MixedFreeformPolyCurve(envelopeCurves.d);
	  var u = new MixedFreeformPolyCurve(envelopeCurves.u);
	  var l = new MixedFreeformPolyCurve(envelopeCurves.l);
	  var r = new MixedFreeformPolyCurve(envelopeCurves.r);
	  return new CoonsPatch(d, u, l, r);
	}
	
	function constructFreeformCoonsPatch(envelopeCurves) {
	  var d = new FreeformPolyCurve(envelopeCurves.d);
	  var u = new FreeformPolyCurve(envelopeCurves.u);
	  var l = new FreeformPolyCurve(envelopeCurves.l);
	  var r = new FreeformPolyCurve(envelopeCurves.r);
	  return new CoonsPatch(d, u, l, r);
	}
	
	function toVectorOfPoints(curve) {
	  return curve.polygonize(0.1, 2);
	}
	
	function toUniformWalkPolylineCurve(curve) {
	  var convertedPoints = toVectorOfPoints(curve);
	  return new WalkPolylineCurve(convertedPoints, 'Uniform');
	}
	
	function constructUniformCoonsPatch(envelopeCurves) {
	  var d = toUniformWalkPolylineCurve(envelopeCurves.d);
	  var u = toUniformWalkPolylineCurve(envelopeCurves.u);
	  var l = toUniformWalkPolylineCurve(envelopeCurves.l);
	  var r = toUniformWalkPolylineCurve(envelopeCurves.r);
	  return new CoonsPatch(d, u, l, r);
	}
	
	function toLinearWalkPolylineCurve(curve, dir) {
	  var convertedPoints = toVectorOfPoints(curve);
	  return new WalkPolylineCurve(convertedPoints, 'Linear', dir);
	}
	
	function constructBoxedCoonsPatch(envelopeCurves) {
	  var horizontalDir = new _geometry.Point(1.0, 0.0);
	  var verticalDir = new _geometry.Point(0.0, 1.0);
	  var d = toLinearWalkPolylineCurve(envelopeCurves.d, horizontalDir);
	  var u = toLinearWalkPolylineCurve(envelopeCurves.u, horizontalDir);
	  var l = toLinearWalkPolylineCurve(envelopeCurves.l, verticalDir);
	  var r = toLinearWalkPolylineCurve(envelopeCurves.r, verticalDir);
	  return new CoonsPatch(d, u, l, r);
	}
	
	var MeshWrap = function (coonsPatch, bounds) {
	  this._bounds = bounds;
	  this._coonsPatch = coonsPatch;
	};
	MeshWrap.prototype = {
	  apply: function (point) {
	    var b = this._bounds;
	
	    var tx = (point.x - b.lx) / b.width,
	        ty = (point.y - b.ly) / b.height;
	
	    if (tx < 0) {
	      tx = 0;
	    } else if (tx > 1) {
	      tx = 1;
	    }
	    if (ty < 0) {
	      ty = 0;
	    } else if (ty > 1) {
	      ty = 1;
	    }
	
	    return this._coonsPatch.eval(tx, ty);
	  }
	};
	
	// From ScisoftEngine/MeshWrap/coons_patch_impl.hpp
	// From ScisoftEngine/MeshWrap/envelope.hpp
	// Envelope and CoonsPatch are merged compared to the engine
	
	var CoonsPatch = function (d, u, l, r) {
	  this.d = d;
	  this.u = u;
	  this.l = l;
	  this.r = r;
	  this.P00 = d.first();
	  this.P01 = d.last();
	  this.P10 = u.first();
	  this.P11 = u.last();
	};
	CoonsPatch.prototype = {
	  eval: function (u, v) {
	    var mu = 1 - u,
	        mv = 1 - v;
	
	    var du = this.d.eval(u);
	    var uu = this.u.eval(u);
	    var lv = this.l.eval(v);
	    var rv = this.r.eval(v);
	
	    //   (1-v)*CurveD(u) + v*CurveU(u)    ---> col
	    // + (1-u)*CurveL(v) + u*CurveR(v)    ---> row
	    // - | (1-u) u | * | mP00 mP01 | * | (1-v) v |
	    //                 | mP10 mP11 |
	
	    var col = du.sm(mv).add(uu.sm(v));
	    var row = lv.sm(mu).add(rv.sm(u));
	
	    var q = _geometry.Point.sm(this.P00, mu).add(_geometry.Point.sm(this.P01, u)).sm(mv).add(_geometry.Point.sm(this.P10, mu).add(_geometry.Point.sm(this.P11, u)).sm(v));
	
	    var p = _geometry.Point.add(col, row).substract(q);
	
	    return p;
	  }
	};
	
	// From ScisoftEngine/MeshWrap/cubic_bezier_polycurve.hpp
	
	var PieceData = function (piece, localLen, totalLen) {
	  this.piece = piece;
	  this.localLen = localLen;
	  this.totalLen = totalLen;
	};
	
	// Pieces are maintained in a tree-like structure for fast matching of parameter values->pieces.
	
	var MixedFreeformPolyCurve = function (curve) {
	  var pieces = this._pieces = curve.pieces;
	
	  var piecesData = [];
	
	  var totalLen = 0;
	  for (var k = 0, kEnd = pieces.length; k < kEnd; ++k) {
	    var piece = pieces[k];
	    var localLen = piece.arcLength();
	    totalLen += localLen;
	    piecesData.push(new PieceData(piece, localLen, totalLen));
	  }
	
	  this._arcLen = totalLen;
	  this._piecesData = piecesData;
	};
	
	MixedFreeformPolyCurve.prototype = {
	  eval: function (t) {
	    var l = t * this._arcLen;
	    /* Piece_Vector::const_iterator u = std::upper_bound(mPieces.begin()
	                                                        ,mPieces.end()
	                                                        ,Piece::CreateWithTotalLen(lL)
	                                                        ,Piece::ComesAfter()
	                                                        ); */
	    var piecesData = this._piecesData;
	    var n = (0, _lodash.sortedIndexBy)(piecesData, { totalLen: l }, function (pd) {
	      return pd.totalLen;
	    });
	    var pieceData = piecesData[n];
	
	    if (pieceData) {
	      var localLen = pieceData.totalLen - l;
	      var localT = 1 - localLen / pieceData.localLen;
	      return pieceData.piece.eval(localT);
	    } else {
	      return (0, _lodash.last)(this._pieces).eval(1);
	    }
	  },
	  first: function () {
	    return this._pieces[0].P0;
	  },
	  last: function () {
	    return (0, _lodash.last)(this._pieces).last();
	  }
	};
	
	var FreeformPolyCurve = function (curve) {
	  this._pieces = curve.pieces;
	};
	FreeformPolyCurve.prototype = {
	  eval: function (t) {
	    var pieces = this._pieces,
	        piecesN = pieces.length;
	    var l = t * piecesN;
	    var pieceIndex = Math.floor(l);
	    if (pieceIndex < piecesN) {
	      var localT = l - pieceIndex;
	      return pieces[pieceIndex].eval(localT);
	    } else {
	      return (0, _lodash.last)(pieces).eval(1);
	    }
	  },
	  first: function () {
	    return this._pieces[0].P0;
	  },
	  last: function () {
	    return (0, _lodash.last)(this._pieces).last();
	  }
	};
	
	// From ScisoftEngine/MeshWrap/walk_polyline_curve.hpp
	
	// A quick eval polyline bezier curve with uniform walk over the path.
	var WalkPolylineCurve = function (curve, type, dir) {
	  this._curve = curve;
	  switch (type) {
	    case 'Uniform':
	      this.distance = this._uniformDistance;
	      break;
	    case 'Linear':
	      this._dir = dir.normalized();
	      this.distance = this._linearDistance;
	      break;
	  }
	  this._preprocess();
	};
	WalkPolylineCurve.prototype = {
	
	  // Diferent distances strategies
	
	  // type 'uniform'
	  _uniformDistance: _geometry.Point.distance,
	
	  // type 'linear'
	  _linearDistance: function (pa, pb) {
	    return Math.abs(_geometry.Point.dotProduct(pb.minus(pa), this._dir));
	  },
	  first: function () {
	    return this._curve[0];
	  },
	  last: function () {
	    return this._curve[this._curve.length - 1];
	  },
	
	
	  get bounds() {
	    return this._curve.bounds;
	  },
	
	  eval: function (t) {
	    // 0 <= t <= 1
	    var curve = this._curve,
	        curveSize = curve.length,
	        partialLength = this._partialLength,
	        segmentsLength = this._segmentsLength;
	
	    var lt = t * this._curveLength;
	
	    var i = (0, _lodash.sortedIndex)(partialLength, lt);
	
	    if (i >= curveSize) {
	      return curve[curveSize - 1].clone();
	    } else if (i <= 0) {
	      return curve[0].clone();
	    } else {
	      var segLength = segmentsLength[i - 1];
	      var u = (lt - partialLength[i - 1]) / segLength;
	      return _geometry.Point.sm(curve[i - 1], 1 - u).add(_geometry.Point.sm(curve[i], u));
	    }
	  },
	  curveLength: function () {
	    return this._curveLength;
	  },
	  _preprocess: function () {
	    var curve = this._curve;
	    var curveSize = curve.length;
	
	    var curveLength = 0;
	    var segmentsLength = [];
	    var partialLength = [];
	
	    var p = curve[0];
	
	    for (var k = 1; k < curveSize; ++k) {
	      var q = curve[k];
	      var dis = this.distance(q, p);
	      segmentsLength[k - 1] = dis;
	      partialLength[k - 1] = curveLength;
	      curveLength += dis;
	      p = q;
	    }
	    segmentsLength[curveSize - 1] = 0;
	    partialLength[curveSize - 1] = curveLength;
	
	    this._curveLength = curveLength;
	    this._segmentsLength = segmentsLength;
	    this._partialLength = partialLength;
	  }
	};
	
	function computeMinMaxCurve2CurveDistance(a, b) {
	  var a_arcLen = a.arcLength();
	  var b_arcLen = b.arcLength();
	
	  var cSamples = 10;
	
	  var da = a_arcLen / cSamples;
	  var db = b_arcLen / cSamples;
	
	  var cursorA = new _geometry.CurveArcLenCursor(a);
	  var cursorB = new _geometry.CurveArcLenCursor(b);
	
	  var min2 = Number.MAX_VALUE,
	      max2 = Number.MIN_VALUE;
	
	  for (var i = 0; i < cSamples; ++i) {
	    var PA = cursorA.pos().point,
	        PB = cursorB.pos().point;
	
	    var d2 = _geometry.Point.distance2(PA, PB);
	    if (d2 < min2) {
	      min2 = d2;
	    }
	    if (d2 > max2) {
	      max2 = d2;
	    }
	
	    cursorA.move(da);
	    cursorB.move(db);
	  }
	
	  return { min: Math.sqrt(min2), max: Math.sqrt(max2) };
	}
	
	var MeshWrapTransformation = function (envelopeCurves, bounds, mode) {
	  this._envelopeCurves = envelopeCurves;
	  this._bounds = bounds;
	  this._mode = mode;
	  this._meshWrap = this.createMeshWrap();
	};
	
	MeshWrapTransformation.prototype = {
	  apply: function (point) {
	    var mw = this._meshWrap;
	    if (mw) {
	      return mw.apply(point);
	    } else {
	      return point;
	    }
	  },
	  createCoonsPatch: function () {
	    var envelopeCurves = this._envelopeCurves;
	    switch (this._mode) {
	      case 'Uniform':
	        return constructUniformCoonsPatch(envelopeCurves);
	      case 'Boxed':
	        return constructBoxedCoonsPatch(envelopeCurves);
	      case 'Freeform':
	        return constructFreeformCoonsPatch(envelopeCurves);
	      default:
	      case 'Mixed':
	        return constructMixedFreeformCoonsPatch(envelopeCurves);
	    }
	  },
	  createMeshWrap: function () {
	    var coonsPatch = this.createCoonsPatch();
	    return new MeshWrap(coonsPatch, this._bounds);
	  }
	};
	
	function setRenderFrame(figures, frame) {
	  for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	    var figure = figures[k];
	    var polyregions = figure.polyregions;
	
	    for (var p = 0, pEnd = polyregions.length; p < pEnd; ++p) {
	      polyregions[p]._renderFrame = frame.clone();
	    }
	  }
	}
	
	function computeEnvelopeSize(envelopeCurves) {
	  return {
	    width: computeMinMaxCurve2CurveDistance(envelopeCurves.l, envelopeCurves.r),
	    height: computeMinMaxCurve2CurveDistance(envelopeCurves.d, envelopeCurves.u)
	  };
	}
	
	function toGShapesAndRasterBounds(figures) {
	  var rFigures = [];
	  for (var i = 0, iEnd = figures.length; i < iEnd; i++) {
	    var figure = figures[i];
	    rFigures.push(figure.toGShape ? figure.toGShape() : figure.clone());
	  }
	  return rFigures; // [TODO] Raster .toGShape()
	}
	
	function computeVectorBounds(figures) {
	  var bb = new _geometry.BoundsBuilder();
	  for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	    bb.update(figures[k].vectorBounds());
	  }
	  return bb.bounds;
	}
	
	function computeBounds(figures) {
	  var bb = new _geometry.BoundsBuilder();
	  for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	    bb.update(figures[k].bounds);
	  }
	  return bb.bounds;
	}
	
	var FitEnvelope = _process.Process.FitEnvelope = _process.Process.extend({ typeName: 'FitEnvelopeProcess',
	
	  type: 'FitEnvelope',
	
	  Properties: {
	    mode: { type: 'string', def: 'Mixed', dropDef: true, onChange: _gear.invalidateOwner },
	    vPos: { type: 'string', def: 'Stretched', onChange: _gear.invalidateOwner },
	    hPos: { type: 'string', def: 'Stretched', onChange: _gear.invalidateOwner },
	    highResolution: { type: 'boolean', def: false, onChange: _gear.invalidateOwner },
	    keepLines: { type: 'boolean', def: false, onChange: _gear.invalidateOwner },
	    addBearingX: { type: 'boolean', def: false, dropDef: true, onChange: _gear.invalidateOwner },
	    stableBaseline: { type: 'boolean', def: false, dropDef: true, onChange: _gear.invalidateOwner }
	  },
	
	  init: function (c) {
	    this.callParent(c);
	    this._envelope = c && c.envelope || null;
	  },
	  isEqual: function (other) {
	    return this.propertiesAreEqual(other) && this._envelope.isEqual(other._envelope);
	  },
	  envelope: function (v) {
	    return v === undefined ? this._envelope : (this._envelope = v, this.invalidate(), this);
	  },
	  setupXml: function (node) {
	    _util.Xml.setupProperties(node, this);
	    this._envelope.buildXml(node);
	  },
	  equalizeFor$: function (figure) {
	    var _this = this;
	
	    return figure.preVectorBounds$().then(function (uBounds) {
	      // Equalize the envelope to fit the current bounds of the figure
	      return _this._envelope.setSize({ height: uBounds.height });
	    });
	  },
	  clone: function () {
	    var c = new FitEnvelope(this);
	    c.envelope(this._envelope.clone());
	    return c;
	  },
	  canProcess: function (figure) {
	    return _config.Config.localFitEnvelope && this._highResolution === false && !((this._addBearingX || this._stableBaseline) && figure.isText && figure._textParts.length > 0);
	  },
	  process: function (c, forcedAnchor) {
	    var useEnvelopeFrame = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];
	    var figures = c.figures;
	
	
	    var shape = (0, _figure.toSingleGShape)(figures);
	
	    var bounds = shape.vectorBounds();
	
	    var envelope = this._envelope;
	
	    var envelopeFrame = _geometry.Frame.fromBounds(envelope.vectorBounds());
	
	    var envelopeCurves = {
	      d: envelope.d(),
	      r: envelope.r(),
	      u: envelope.u().reversed(),
	      l: envelope.l().reversed()
	    };
	    var envelopeSize = computeEnvelopeSize(envelopeCurves);
	
	    var stableBaseline = this._stableBaseline,
	        addBearingX = this._addBearingX;
	    if (stableBaseline || addBearingX) {
	      var layout = figures[0];
	      if (layout instanceof _figure.TextLayout) {
	        var textLine = (0, _lodash.head)(layout.textLines());
	        if (stableBaseline) {
	          var baselineY = textLine._baseline.P0.x;
	          var ascent = layout.ascent();
	          var descent = layout.descent();
	          bounds = new _geometry.Bounds(bounds.lx, Math.min(bounds.ly, baselineY - descent), bounds.hx, Math.max(bounds.hy, baselineY + ascent));
	        } else if (addBearingX) {
	          var bearingLX = textLine.bearingLX();
	          if (bearingLX > 0) {
	            bounds = bounds.clone();
	            bounds.lx -= bearingLX;
	          }
	        }
	      }
	    }
	
	    var scale = 1;
	
	    var originalBounds = bounds.clone();
	
	    var hPos = this._hPos,
	        vPos = this._vPos;
	    var hPosStretched = hPos === 'Stretched',
	        vPosStretched = vPos === 'Stretched',
	        hPosExpanded = hPos === 'Expanded',
	        vPosExpanded = vPos === 'Expanded';
	
	    if (hPosStretched && !vPosStretched) {
	      scale = envelopeSize.width.max / bounds.width;
	      bounds.scalingTransform(_geometry.Matrix.scale(scale));
	    }
	
	    if (vPosStretched && !hPosStretched) {
	      scale = envelopeSize.height.max / bounds.height;
	      bounds.scalingTransform(_geometry.Matrix.scale(scale));
	    }
	
	    bounds = bounds.clone();
	    var w = bounds.width;
	    var h = bounds.height;
	
	    var minWidth = envelopeSize.width.min;
	    var minHeight = envelopeSize.height.min;
	
	    if (w < minWidth && !hPosStretched && !hPosExpanded) {
	      var gapH = minWidth - w;
	
	      var gapL = 0,
	          gapR = 0;
	      switch (hPos) {
	        case 'Right':
	          gapL = gapH;gapR = 0;break;
	        case 'Center':
	          gapL = gapR = gapH / 2;break;
	        case 'Left':
	          gapL = 0;gapR = gapH;break;
	      }
	      bounds.lx -= gapL;
	      bounds.hx += gapR;
	    }
	
	    if (h < minHeight && !vPosStretched && !vPosExpanded) {
	      var gapV = minHeight - h;
	
	      var gapB = 0,
	          gapT = 0;
	      switch (vPos) {
	        case 'Top':
	          gapB = gapV;gapT = 0;break;
	        case 'Center':
	          gapB = gapT = gapV / 2;break;
	        case 'Bottom':
	          gapB = 0;gapT = gapV;break;
	      }
	      bounds.ly -= gapB;
	      bounds.hy += gapT;
	    }
	
	    var outFigures = [];
	
	    var wrap = new MeshWrapTransformation(envelopeCurves, bounds, this._mode);
	
	    var target = preprocessInput(shape, this._highResolution, this._keepLines); // [TODO], used for highResolution: this._polyParams) ;
	    if (target) {
	
	      if (scale !== 1) {
	        modifyCurves(target, function (c) {
	          c.transform(_geometry.Matrix.scale(scale));
	        });
	      }
	
	      modifyCurves(target, function (c) {
	        c.transform(wrap);
	      });
	
	      outFigures.push(target);
	    }
	
	    // Transform char basic points
	    (0, _lodash.forEach)(c.textLayouts, function (layout) {
	      if (scale !== 1) {
	        layout.transformBasicPoints(_geometry.Matrix.scale(scale));
	      }
	      layout.transformBasicPoints(wrap);
	    });
	
	    // We respect the alignment decided in the envelope options
	    var anchor = forcedAnchor || envelopeFrame.center;
	
	    // Approximate deformation
	    //   o --------- o --------- o
	    //   |                       |
	    //   o --------- o --------- o
	    //
	    var originalWidth = originalBounds.width,
	        originalHeight = originalBounds.height;
	
	    // bounds is already a scaled version of originalBounds
	    var lx = bounds.lx,
	        mx = bounds.mx,
	        hx = bounds.hx,
	        ly = bounds.ly,
	        my = bounds.my,
	        hy = bounds.hy;
	
	    var outScaleX = Math.min(computeOutScale(lx, ly, hx, ly, wrap, originalWidth), computeOutScale(lx, my, hx, my, wrap, originalWidth), computeOutScale(lx, hy, hx, hy, wrap, originalWidth));
	
	    var outScaleY = Math.min(computeOutScale(lx, ly, lx, hy, wrap, originalHeight), computeOutScale(mx, ly, mx, hy, wrap, originalHeight), computeOutScale(hx, ly, hx, hy, wrap, originalHeight));
	
	    c.preScale = new _geometry.Point(c.preScale.x * outScaleX, c.preScale.y * outScaleY);
	
	    var renderFrame = useEnvelopeFrame || !target ? envelopeFrame : _geometry.Frame.fromBounds(target.vectorBounds());
	
	    setRenderFrame(outFigures, renderFrame);
	
	    // [TODO] Expanded options needs to be checked... There is a new option added to the process
	    //        called FitEnvelopeToInput. It seems they are very similar.
	    if (hPosExpanded || vPosExpanded) {
	      (function () {
	        var hScale = hPosExpanded ? bounds.width / envelopeFrame.width : 1;
	        var vScale = vPosExpanded ? bounds.height / envelopeFrame.height : 1;
	        var scaling = _geometry.Matrix.scale(hScale, vScale);
	        (0, _lodash.forEach)(outFigures, function (figure) {
	          modifyCurves(figure, function (c) {
	            c.transform(scaling);
	          });
	        });
	        anchor = scaling.apply(anchor);
	      })();
	    }
	
	    /* [TODO]
	    if( Config.debugEnvelope ) {
	      GRegion lEnvRegion = new GRegion(lEnv.CurveD.Copy());
	      lEnvRegion.AddHole(lEnv.CurveR.Copy());
	      lEnvRegion.AddHole(lEnv.CurveU.Copy());
	      lEnvRegion.AddHole(lEnv.CurveL.Copy());
	      GMultiRegion lEnvMR = new GMultiRegion(lEnvRegion);
	      lEnvMR.FillMode = GFillMode.Alternate ;
	      lEnvMR.AssignStyle(new GColorPen(GColor.Black),null);
	      ShapeFigure lEnvFig = new ShapeFigure( new GShape(lEnvMR) ) ;
	      aOutput.Add(lEnvFig);
	    }
	    */
	
	    c.figures = outFigures;
	    c.anchor = anchor;
	  }
	});
	
	FitEnvelope.parseXml = function (node) {
	  var p = _util.Xml.parseProperties(node, FitEnvelope);
	  p.envelope = _envelope.Envelope.fromXml(node);
	  if (p.vPos === 'Middle') {
	    p.vPos = 'Center';
	  }
	  return new FitEnvelope(p);
	};
	
	_util.Xml.addFromBuild(FitEnvelope);
	
	FitEnvelope.createFromFigure = function (figure) {
	  return new FitEnvelope({ vPos: 'Stretched', hPos: 'Stretched',
	    envelope: _envelope.Envelope.createFromFigure(figure) });
	};
	
	// SmartEnvelope
	//=============================================================================
	
	// [TODO] convert to js naming conventions
	
	var CreateItalicEnvelope = function (aBBox, aHeight, aExtraAscentHeight, aExtraDescentHeight) {
	  // We need to divide the calculation so the envelope width for the reference size characters
	  // remains equal to the width of the bbox
	  var lFactor = Math.tan((0, _gear.deg2rad)(71));
	
	  var lHeightOffsetX = aHeight / lFactor;
	  var lExtraAscentHeightOffsetX = aExtraAscentHeight / lFactor;
	  var lExtraDescentHeightOffsetX = aExtraDescentHeight / lFactor;
	
	  var lLXLY = aBBox.lx_ly.plus(new _geometry.Point(-lExtraDescentHeightOffsetX, 0));
	  var lHXLY = aBBox.hx_ly.plus(new _geometry.Point(-lHeightOffsetX - lExtraDescentHeightOffsetX, 0));
	  var lHXHY = aBBox.hx_hy.plus(new _geometry.Point(lExtraAscentHeightOffsetX, 0));
	  var lLXHY = aBBox.lx_hy.plus(new _geometry.Point(lExtraAscentHeightOffsetX + lHeightOffsetX, 0));
	
	  var lPiecesD = CreateStraightBeziers(lLXLY, lHXLY);
	  var lPiecesR = CreateStraightBeziers(lHXLY, lHXHY);
	  var lPiecesU = CreateStraightBeziers(lHXHY, lLXHY);
	  var lPiecesL = CreateStraightBeziers(lLXHY, lLXLY);
	
	  var lCurveD = new _geometry.Curve(lPiecesD, false);
	  var lCurveR = new _geometry.Curve(lPiecesR, false);
	  var lCurveU = new _geometry.Curve(lPiecesU, false);
	  var lCurveL = new _geometry.Curve(lPiecesL, false);
	
	  return new _envelope.Envelope([lCurveD, lCurveR, lCurveU, lCurveL]);
	};
	
	var CreateStraightBeziers = function (aFrom, aTo) {
	  var distanceY = arguments.length <= 2 || arguments[2] === undefined ? 0 : arguments[2];
	
	  // lMiddle was computed in C# as
	  // GEO.CreateMidPoint(aFrom,aTo) + new GVector(0,distanceY);
	  var lMiddle = new _geometry.Point((aFrom.x + aTo.x) / 2, (aFrom.y + aTo.y) / 2 + distanceY);
	  return [_geometry.Cubic.fromSegment(aFrom, lMiddle), _geometry.Cubic.fromSegment(lMiddle, aTo)];
	};
	
	var CreateArchBeziers = function (aFrom, aTo, distanceY) {
	  // Is Gpoint in C# the same as Point in JS?
	  var lMiddle = new _geometry.Point((aFrom.x + aTo.x) / 2, aFrom.y + distanceY);
	  var lControlX = (lMiddle.x - aFrom.x) / 3; // It will be negative if aFrom.x > aTo.x
	  // Is GCubicBezierPiece in C# the same as Cubic in JS?
	  return [new _geometry.Cubic(aFrom, new _geometry.Point(aFrom.x + lControlX, aFrom.y + 0.75 * distanceY), new _geometry.Point(aFrom.x + 2 * lControlX, lMiddle.y), lMiddle), new _geometry.Cubic(lMiddle, new _geometry.Point(lMiddle.x + lControlX, lMiddle.y), new _geometry.Point(lMiddle.x + 2 * lControlX, aFrom.y + 0.75 * distanceY), aTo)];
	};
	
	var CreateSlantBeziers = function (aFrom, aTo, distanceY) {
	  var lNewFrom, lNewTo;
	  if (aFrom.x < aTo.x) {
	    lNewFrom = aFrom;
	    lNewTo = new _geometry.Point(aTo.x, aTo.y + distanceY);
	  } else {
	    lNewFrom = new _geometry.Point(aFrom.x, aFrom.y + distanceY);
	    lNewTo = aTo;
	  }
	  var lMiddle = new _geometry.Point((lNewFrom.x + lNewTo.x) / 2, (lNewFrom.y + lNewTo.y) / 2);
	  return [_geometry.Cubic.fromSegment(lNewFrom, lMiddle), _geometry.Cubic.fromSegment(lMiddle, lNewTo)];
	};
	
	var SmartEnvelope = _process.Process.SmartEnvelope = _process.Process.extend({
	  typeName: 'SmartEnvelopeProcess',
	  type: 'SmartEnvelope',
	  Properties: {
	
	    kind: { type: 'string', tag: 'Type', def: 'Straight', onChange: _gear.invalidateOwner, dropDef: true },
	    width: { type: 'magnitude', def: new _gear.Magnitude(0, 'mm'), onChange: _gear.invalidateOwner, dropDef: true },
	    height: { type: 'magnitude', def: new _gear.Magnitude(0, 'mm'), onChange: _gear.invalidateOwner, dropDef: true },
	
	    // We only exposed Type and Width for the moment in CDL, this needs to be added to CxEngine
	    hPos: { type: 'string', def: 'Center', onChange: _gear.invalidateOwner, dropDef: true },
	    vPos: { type: 'string', def: 'Center', onChange: _gear.invalidateOwner, dropDef: true },
	    mode: { type: 'string', def: 'FreeForm', onChange: _gear.invalidateOwner, dropDef: true },
	    highResolution: { type: 'boolean', def: false, onChange: _gear.invalidateOwner, dropDef: true },
	    keepLines: { type: 'boolean', def: false, onChange: _gear.invalidateOwner, dropDef: true },
	    addBearingX: { type: 'boolean', def: false, onChange: _gear.invalidateOwner, dropDef: true }
	  },
	
	  canProcess: function () {
	    return _config.Config.localSmartEnvelope;
	  },
	
	
	  // forcedAnchor is an out parameter
	  createEnvelope: function (figures, inputAnchor) {
	
	    var forcedAnchor = inputAnchor.clone();
	
	    var lBBox = computeVectorBounds(toGShapesAndRasterBounds(figures));
	
	    // Forced Width for the envelope
	    if (this.width > 0) {
	      // Correct anchor so it is relative to the envelope instead of the input figure
	      forcedAnchor.x = lBBox.mx + (forcedAnchor.x - lBBox.mx) * this.width / lBBox.width;
	
	      lBBox = new _geometry.Bounds(lBBox.mx - this.width / 2, lBBox.ly, lBBox.mx + this.width / 2, lBBox.hy);
	    }
	
	    // [TODO] What happens when there are multiple figures?
	
	    var lBaselineY = 0;
	    var lDescentExtraHeight = 0;
	    var lAscentExtraHeight = 0;
	    var lHeight = lBBox.height;
	
	    var layout = figures[0];
	    if (layout instanceof _figure.TextLayout) {
	
	      var lFirstLine = layout.textLines()[0];
	      // The baseline is a segment, we need the y-coordinate of its origin.
	      lBaselineY = lFirstLine._baseline.P0.y;
	
	      var lAscent = layout.ascent();
	      var lDescent = layout.descent();
	
	      // The envelopes are defined against the size of the uppercase M for AutoSize: true
	
	      // [TODO] Take into account PreTransform?
	
	      lDescentExtraHeight = lDescent;
	
	      lHeight = layout.sizeOfReferenceChar(); // Size of M, this should also work for AutoSize: false
	      lAscentExtraHeight = lAscent - lHeight;
	
	      lBBox = new _geometry.Bounds(lBBox.lx, Math.min(lBBox.ly, lBaselineY - lDescent), lBBox.hx, Math.max(lBBox.hy, lBaselineY + lAscent));
	    }
	
	    if (this.kind === 'Italic') {
	      // Italic doesn't work like the rest of the envelopes
	      var envelope = CreateItalicEnvelope(lBBox, lHeight, lAscentExtraHeight, lDescentExtraHeight);
	      return { envelope: envelope, forcedAnchor: forcedAnchor };
	    }
	
	    //     _________________________________
	    //    |                                 |  lAscentExtraHeight
	    //     ---------------------------------
	    //    |                                 |
	    //    |                                 |  lHeight
	    //    |                                 |
	    //     ---------------------------------
	    //    |_________________________________|  lDescentExtraHeight
	    //
	
	    var lCreateCurves;
	    var lUpDeformation = 0;
	    var lDownDeformation = 0;
	
	    switch (this.kind) {
	
	      case 'Bowtie':
	        lUpDeformation = -0.25;
	        lDownDeformation = 0.25;
	        lCreateCurves = CreateStraightBeziers;
	        break;
	
	      case 'Bridge':
	        lUpDeformation = 0;
	        lDownDeformation = 0.425;
	        lCreateCurves = CreateArchBeziers;
	        break;
	
	      case 'DoubleBridge':
	        lUpDeformation = -0.25;
	        lDownDeformation = 0.25;
	        lCreateCurves = CreateArchBeziers;
	        break;
	
	      case 'NewSlant':
	        // Constant angle for all width/height
	        // angle = atan( 4 / 15 ), make this a parameter?
	        var lSlantDeformation = lBBox.width * 4 / 15 / lHeight;
	        lUpDeformation = lSlantDeformation;
	        lDownDeformation = lSlantDeformation;
	        lCreateCurves = CreateSlantBeziers;
	        break;
	
	      case 'Pennant':
	        lUpDeformation = -0.25;
	        lDownDeformation = 0.25;
	        lCreateCurves = CreateSlantBeziers;
	        break;
	
	      case 'ReverseArch':
	        lUpDeformation = -0.5;
	        lDownDeformation = -0.5;
	        lCreateCurves = CreateArchBeziers;
	        break;
	
	      case 'ReverseBridge':
	        lUpDeformation = -0.425;
	        lDownDeformation = 0;
	        lCreateCurves = CreateArchBeziers;
	        break;
	
	      case 'VerticalArch':
	        lUpDeformation = 0.5;
	        lDownDeformation = 0.5;
	        lCreateCurves = CreateArchBeziers;
	        break;
	
	      case 'Straight':
	      default:
	        lUpDeformation = 0;
	        lDownDeformation = 0;
	        lCreateCurves = CreateStraightBeziers;
	        break;
	    }
	
	    // Assumming baseline at 0 (it will be added later), values for the envelope
	    // as defined for uppercase letters
	    var lDown = lDownDeformation * lHeight;
	    var lUp = lHeight + lUpDeformation * lHeight;
	    var lDeformationHeight = lUp - lDown;
	
	    // Values for the real envelope so it produces the same effect
	    var lDownY = lBaselineY + lDown - lDescentExtraHeight * (lDeformationHeight / 2) / (lHeight / 2);
	    var lUpY = lBaselineY + lUp + lAscentExtraHeight * (lDeformationHeight / 2) / (lHeight / 2);
	
	    // Use here the lCreateCurves function assigned above.
	    var lPiecesD = lCreateCurves(lBBox.lx_ly, lBBox.hx_ly, lDownY - lBBox.ly);
	    var lPiecesU = lCreateCurves(lBBox.hx_hy, lBBox.lx_hy, lUpY - lBBox.hy);
	    var lPiecesR = CreateStraightBeziers((0, _lodash.last)(lPiecesD).last(), lPiecesU[0].P0);
	    var lPiecesL = CreateStraightBeziers((0, _lodash.last)(lPiecesU).last(), lPiecesD[0].P0);
	
	    var lCurveD = new _geometry.Curve(lPiecesD, false);
	    var lCurveR = new _geometry.Curve(lPiecesR, false);
	    var lCurveU = new _geometry.Curve(lPiecesU, false);
	    var lCurveL = new _geometry.Curve(lPiecesL, false);
	
	    return { envelope: new _envelope.Envelope([lCurveD, lCurveR, lCurveU, lCurveL]), forcedAnchor: forcedAnchor };
	  },
	  process: function (c) {
	    var _createEnvelope = this.createEnvelope(c.figures, c.anchor);
	
	    var envelope = _createEnvelope.envelope;
	    var forcedAnchor = _createEnvelope.forcedAnchor;
	
	
	    var stableBaseline = true;
	
	    // Use FitEnvelopeProcess from deform.js
	    var fitEnv = new _process.Process.FitEnvelope({
	      mode: this.mode,
	      vPos: this.vPos,
	      hPos: this.hPos,
	      highResolution: this.highResolution,
	      keepLines: this.keepLines,
	      addBearingX: this.addBearingX,
	      stableBaseline: stableBaseline,
	      envelope: envelope
	    });
	
	    return fitEnv.process(c, forcedAnchor, false); // use figure bounds instead of envelope frame for render frame
	  }
	});
	
	_util.Xml.addFromBuild(SmartEnvelope);
	
	//=============================================================================
	// Skeleton for creating a new process
	//=============================================================================
	
	/*
	// NewProcess
	//=============================================================================

	var processHelperFunctionsIfNeeded = function(/*shape, curves or whatever* /) {
	  // ...
	};

	const NewProcess = Process.NewProcess = Process.extend({
	  typeName: 'NewProcessProcess',
	  type: 'NewProcess',
	  Properties: {
	    // ...
	  },
	  canProcess(/*figure* /){
	    // can we apply this process locally?
	    // we can rely on a variable in config.js
	    return Config.localNewProcess;
	    // or just
	    return true;
	  },
	  // c: { figures, anchor, textLayouts }
	  process( c ){
	    // code for the process
	  }
	});

	Xml.addFromBuild(NewProcess);


	// If there are properties that needs to be parsed or cloned manually...

	const NewProcess = Process.NewProcess = Process.extend({
	  typeName: 'NewProcessProcess',
	  type: 'NewProcess',
	  Properties: {
	    // ...
	  },
	  init( c ) {
	    // optional
	  },
	  isEqual( other ) {
	    // optional
	  },
	  setupXml( node ) {
	    Xml.setupProperties(node,this);
	    // code for building XML from this node
	  },
	  clone() {
	    var c = new NewProcess(this);
	    // code to clone this process
	    return c;
	  },
	  canProcess(/*figure* /){
	    // can we apply this process locally?
	    // we can rely on a variable in config.js
	    return Config.localNewProcess;
	    // or just
	    return true;
	  },
	  process( c ){
	    // code for the process
	  }
	});

	NewProcess.parseXml = function(node) {
	  var p = // what to look for in the XML document
	  return new NewProcess(p);
	};
	Xml.addFromBuild(NewProcess);
	*/

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Envelope = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	var _geometry = __webpack_require__(21);
	
	var _style = __webpack_require__(29);
	
	var _figure = __webpack_require__(35);
	
	var Envelope = exports.Envelope = function (curves) {
	  this.curves = curves;
	};
	
	Envelope.prototype = {
	  d: function () {
	    return this.curves[0];
	  },
	  r: function () {
	    return this.curves[1];
	  },
	  u: function () {
	    return this.curves[2];
	  },
	  l: function () {
	    return this.curves[3];
	  },
	  getFirstPoint: function () {
	    return this.curves[0].getFirstPoint().clone();
	  },
	  buildXml: function (parentNode) {
	    _util.Xml.addObject(parentNode, this, 'Envelope');
	  },
	  setupXml: function (node) {
	    var curves = this.curves;
	    var appendElement = _util.Xml.appendElement;
	    //_.forEach(curves,function(c) {
	
	    for (var k = 0, kEnd = curves.length; k < kEnd; ++k) {
	      curves[k].setupXml(appendElement(node, 'Curve'));
	    } //);
	  },
	  transform: function (t) {
	    (0, _lodash.forEach)(this.curves, function (curve) {
	      curve.transform(t);
	    });
	    return this;
	  },
	  vectorBounds: function () {
	    return _geometry.Bounds.ofThings(this.curves);
	  },
	
	
	  get bounds() {
	    return _geometry.Bounds.ofThings(this.curves);
	  },
	  get center() {
	    return this.bounds.center;
	  },
	
	  setSize: function (options) {
	    // [TODO] Add more functionality options.locked, options.width, etc... abstract from Figures.setSize$
	    var bounds = this.vectorBounds();
	    var scale = options.height ? options.height / bounds.height : 1.0;
	    this.transform(_geometry.Matrix.scaleFrom(bounds.center, scale, scale));
	  },
	  isEqual: function (other) {
	    // Envelopes that are offseted with respect to each other are considered equal
	    var this_offset = _geometry.Matrix.translate(_geometry.Point.minus(this.vectorBounds().center));
	    var other_offset = _geometry.Matrix.translate(_geometry.Point.minus(other.vectorBounds().center));
	    var this_curves = this.curves,
	        other_curves = other.curves;
	    return this_curves[0].transformed(this_offset).isEqual(other_curves[0].transformed(other_offset)) && this_curves[1].transformed(this_offset).isEqual(other_curves[1].transformed(other_offset)) && this_curves[2].transformed(this_offset).isEqual(other_curves[2].transformed(other_offset)) && this_curves[3].transformed(this_offset).isEqual(other_curves[3].transformed(other_offset));
	  },
	  asBoundary: function () {
	    var pieces = [];
	    (0, _lodash.forEach)(this.curves, function (c) {
	      pieces = pieces.concat((0, _gear.cloneDeep)(c.pieces));
	    });
	    return _geometry.Curve.fromNonTiedPieces(pieces, true);
	  },
	  asShape: function () {
	    var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var boundary = this.asBoundary();
	    if (!config.pen) {
	      config.pen = new _style.Pen({ width: 1, color: _style.Color.Black() });
	    }
	    var polyregion = _figure.Polyregion.createFromBoundary(boundary, config);
	    return _figure.Shape.createFromPolyregion(polyregion);
	  },
	  clone: function () {
	    return new Envelope((0, _gear.cloneDeep)(this.curves));
	  }
	};
	
	Envelope.fromXml = function (parentNode) {
	  return _util.Xml.getObject(parentNode, this, 'Envelope');
	};
	Envelope.parseXml = function (node) {
	  var curves = _geometry.Boundary.arrayFromXml(node, 'Curve');
	  return new Envelope(curves);
	};
	
	Envelope.createFromFrame = function (frame) {
	  var _frame$clone = frame.clone();
	
	  var p0 = _frame$clone.p0;
	  var p1 = _frame$clone.p1;
	  var p2 = _frame$clone.p2;
	  var p3 = _frame$clone.p3;
	
	  var cubicFromSegment = _geometry.Cubic.fromSegment,
	      interpolate = _geometry.Point.interpolate;
	  var pm01 = interpolate(p0, p1, 0.5),
	      pm12 = interpolate(p1, p2, 0.5),
	      pm23 = interpolate(p2, p3, 0.5),
	      pm30 = interpolate(p3, p0, 0.5);
	  var curves = [new _geometry.Curve([cubicFromSegment(p0, pm01), cubicFromSegment(pm01, p1.clone())], false), new _geometry.Curve([cubicFromSegment(p1, pm12), cubicFromSegment(pm12, p2.clone())], false), new _geometry.Curve([cubicFromSegment(p2, pm23), cubicFromSegment(pm23, p3.clone())], false), new _geometry.Curve([cubicFromSegment(p3, pm30), cubicFromSegment(pm30, p0.clone())], false)];
	  return new Envelope(curves);
	};
	
	Envelope.createFromBounds = function (bounds) {
	  var frame = _geometry.Frame.fromBounds(bounds);
	  return Envelope.createFromFrame(frame);
	};
	
	Envelope.createFromFigure = function (figure) {
	  // [TODO] _ or $
	  return Envelope.createFromBounds(figure.preVectorBounds_());
	};

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	var _geometry = __webpack_require__(21);
	
	var _text = __webpack_require__(50);
	
	var _process = __webpack_require__(40);
	
	// Some of this objects may end up in separate files later. For the moment, we group here all the
	// abstractions that are only used by FitOnPath
	
	
	// enum VPos: Indicates how the figures are vertically placed along the path
	//
	//   Above : Figures are placed such that the bottom side of its bounding box aligns with the path
	//   Over  : Figures are placed such that the baseline of its bounding box aligns with the path
	//   Below : Figures are placed such that the top side of its bounding box aligns with the path
	
	// enum Anchor: Indicates what horizontal grip is used for positioning chars
	//   Grip, Left, Middle, Right
	
	// enum _OldFit: Deprcated: this should be replaced by a combination of EFit and some numerical parameters.
	//   Fixed_Left, Fixed_CenterTop, Fixed_CenterBottom, Fixed_Right, Stretched, Scaled, Expanded
	
	var CPos = function (value, isAngular) {
	  this.value = value;
	  this.isAngular = isAngular;
	};
	
	var LinealCPos = function (value) {
	  return new CPos(value, false);
	};
	var AngularCPos = function (value) {
	  return new CPos(value, true);
	};
	
	var ItemInfo = function (pos) {
	  this.pos = pos;
	  this.loc = null;
	  this.locTan = null;
	  this.rotation = 0;
	  this.scaleX = 1;
	  this.scaleY = 1;
	};
	
	var Item = function (char, lineIdx, charIdx, ascent, descent, widthwise, vp, anchor) {
	  this.char = char;
	  this.lineIdx = lineIdx;
	  this.charIdx = charIdx;
	
	  var frame = char._frame; // was char.Shape.Frame ?
	
	  var grip = new _geometry.Point(0, 0);
	
	  var hDir = frame.dir_x;
	  var vDir = frame.dir_y;
	
	  // Trace.WriteLine( string.Format("  Wrapping char '{0}' HPos='{1}'", aChar.ID, aChar.HPos) ) ;
	
	  var width = this.width = frame.width;
	  var hPos = char._hPos;
	
	  switch (anchor) {
	
	    case 'Grip':
	      this.info = new ItemInfo(hPos);
	      grip = widthwise ? char._grip : char._topCenterGrip;
	      this.pivot = vp === 'Over' ? widthwise ? 'Grip' : 'BaselineCenterGrip' : vp === 'Above' ? 'BottomCenterGrip' : 'TopCenterGrip';
	      break;
	
	    case 'Left':
	      var dx = char.bearingLX();
	      this.info = new ItemInfo(hPos + dx);
	      grip = _geometry.Point.add(char._grip, _geometry.Point.sm(hDir, dx));
	
	      this.pivot = vp === 'Over' ? widthwise ? 'LXBY' : 'BaselineCenterGrip' : vp === 'Above' ? 'LXLY' : 'LXHY';
	      break;
	
	    case 'Middle':
	      this.info = new ItemInfo(hPos + _geometry.Point.distance(char._grip, char._baselineCenterGrip));
	      grip = widthwise ? char._baselineCenterGrip : char._topCenterGrip;
	
	      this.pivot = vp === 'Over' ? 'BaselineCenterGrip' : vp === 'Above' ? 'BottomCenterGrip' : 'TopCenterGrip';
	      break;
	
	    case 'Right':
	      var dx_w = char.bearingLX() + width;
	      this.info = new ItemInfo(hPos + dx_w);
	      grip = _geometry.Point.add(char._grip, _geometry.Point.sm(hDir, dx_w));
	
	      this.pivot = vp === 'Over' ? widthwise ? 'HXBY' : 'BaselineCenterGrip' : vp === 'Above' ? 'HXLY' : 'HXHY';
	      break;
	  }
	
	  this.baseGrip = grip;
	
	  this.topGrip = _geometry.Point.add(grip, _geometry.Point.sm(vDir, ascent));
	  this.bottomGrip = _geometry.Point.add(grip, _geometry.Point.sm(vDir, descent));
	
	  this.hook = vp === 'Over' ? this.baseGrip : vp === 'Above' ? this.bottomGrip : this.topGrip;
	};
	
	//
	// Algorithm:
	//  1.Compute the Path Length.
	//  2.Compute the 'final' Positions based on the placement options and the initial positions.
	//  4.Locate each final Position along the curve and place each grip in it's Location
	//
	// A "Position", as passed in 'aPos', is an arc-length lineal parameter that indicates
	// the distance from the grip to the path origin.
	//
	// A "Location" is a place along the path that corresponds to a given Position.
	// The mapping from Positions to Locations is done by parametrizing the path by arc-length.
	// A Location encapsulates a point and a normalized tangent vector.
	//
	// The "initial" Position for each figure is given by aPos[i]
	// The "final" Positions for each figure is given by aPos[i] adjusted according to the variouis
	// placement options. In the particular case of "left" aligment, the final positions are directly
	// the initials.
	//
	
	var _wrapChars = function (layout, lineIdx, vPlacement, anchor) {
	  var items = [];
	
	  var ascent = layout.ascent(); // [TODO]
	  var descent = layout.descent();
	  var widthwise = layout.isWidthwise();
	
	  (0, _lodash.forEach)(layout.textLines()[lineIdx - 1]._chars, function (char, i) {
	
	    if (char._outlines) {
	      items.push(new Item(char, lineIdx, i + 1, ascent, descent, widthwise, vPlacement, anchor));
	    }
	  });
	
	  return items;
	};
	
	var _wrapPos = function (path, pos) {
	  if (path.closed) {
	    var arcLen = path.arcLength();
	    while (pos > arcLen) {
	      pos -= arcLen;
	    }
	    while (pos < 0) {
	      pos += arcLen;
	    }
	  }
	  // Trace.WriteLine( string.Format("    Position={0}",aPos) ) ;
	  return pos;
	};
	
	var _getAngularPosition = function (path, angle, steadyAngles) {
	  var pathBounds = path.bounds;
	  var center = pathBounds.center;
	  var rayDir = _geometry.Matrix.rotate(angle).apply_(1, 0);
	
	  if (steadyAngles) {
	    var width = pathBounds.width,
	        height = pathBounds.height;
	    if (rayDir.y < rayDir.x) {
	      rayDir.y *= height / width;
	    } else {
	      rayDir.x *= width / height;
	    }
	    rayDir.normalize();
	  }
	
	  var rayEndP = _geometry.Point.add(center, _geometry.Point.sm(rayDir, _geometry.Point.distance(pathBounds.lx_ly, pathBounds.hx_hy))); // [TODO]
	
	  return path.segmentIntersectionPos(center, rayEndP);
	};
	
	var _arcLenPosValue = function (path, cpos, steadyAngles) {
	  var value = cpos.value;
	  return cpos.isAngular ? _getAngularPosition(path, value, steadyAngles).arcLen : value;
	};
	
	// Computes the final Position for each figure according to the various placement options.
	// Each "position" is given by a double value.
	var _computePositions = function (textLen, bearingLX, path, fit, aPathRange_Beg, aPathRange_End, aPathPin, steadyAngles, textPin, mirrorX, items) {
	
	  var pathLen = path.arcLength(),
	      pathRange_Beg = 0,
	      pathRange_End = 0,
	      pathPin = 0,
	      factorX = 1,
	      factorY = 1;
	
	  if (path.closed) {
	    pathRange_Beg = _arcLenPosValue(path, aPathRange_Beg, steadyAngles);
	    pathRange_End = _arcLenPosValue(path, aPathRange_End, steadyAngles);
	    pathPin = _arcLenPosValue(path, aPathPin, steadyAngles);
	  } else {
	    // assert( ! aPathRange_Beg.isAngular );
	    // assert( ! aPathRange_End.isAngular );
	    // assert( ! aPathPin      .isAngular );
	
	    pathRange_Beg = aPathRange_Beg.value;
	    pathRange_End = aPathRange_End.value;
	    pathPin = aPathPin.value;
	  }
	
	  var pathRange = pathLen - pathRange_Beg - (pathLen - pathRange_End); // pathRange_End - pathRange_Beg
	
	  var textRange = textLen;
	
	  var ratio = pathRange / textRange;
	
	  if (fit === 'Expanded') {
	    // [TODO]
	    if (ratio < 1) {
	      var invRatio = 1 / ratio;
	      path.transform(_geometry.Matrix.scaleFrom(path.bounds.center, invRatio));
	      pathRange *= invRatio;
	      pathLen *= invRatio;
	      pathRange_Beg *= invRatio;
	      pathRange_End *= invRatio;
	      pathPin *= invRatio;
	      ratio = 1;
	    }
	  }
	
	  // [WHY?]
	  if (path.closed && (fit === 'Scaled' || fit === 'Stretched') && pathRange === pathLen) {
	
	    ratio = (pathRange - bearingLX * ratio) / textRange;
	  }
	
	  // Trace.WriteLine( string.Format("  Computing path positions. PathLen={0} PathPin={1} TextLen={2} TextPin={3}",lPathLen, lPathPin, lTextLen, aTextPin) ) ;
	  var shift = void 0;
	
	  switch (fit) {
	    case 'None':
	    case 'Expanded':
	      shift = pathPin - textPin;
	
	      if (mirrorX) {
	        var firstItem = (0, _lodash.head)(items);
	        var lastItem = (0, _lodash.last)(items);
	
	        var initialShift = -_geometry.Point.distance(firstItem.char._grip, firstItem.char._baselineCenterGrip);
	
	        // NOTE: When the Path is open, Corel mirrors horizontally fom the last char's grip and not from the past-the-end grip (right edge of the text)
	        var currCPos = lastItem.char._hPos + shift + (path.closed ? lastItem.char._advanceX : 0) + initialShift;
	
	        for (var i = 0, c = items.length, l = c - 1; i < c; ++i) {
	          var item = items[i];
	
	          var advanceX = i < l ? items[i + 1].info.pos - item.info.pos : 0;
	
	          item.info.pos = _wrapPos(path, currCPos);
	
	          currCPos -= advanceX;
	        }
	      } else {
	        (0, _lodash.forEach)(items, function (item) {
	          item.info.pos = _wrapPos(path, item.info.pos + shift);
	        });
	      }
	      break;
	
	    case 'Contained':
	    case 'ContainedHorizontally':
	
	      if (textRange > pathRange) {
	
	        factorX = ratio;
	
	        if (fit === 'ContainedHorizontally') {
	          factorY = Math.sign(ratio) === 1 ? 1.0 : -1.0;
	        } else {
	          factorY = ratio;
	        }
	
	        shift = pathRange_Beg - bearingLX * factorX;
	      } else {
	        factorX = factorY = 1.0;
	        shift = pathPin - textPin - bearingLX;
	      }
	
	      (0, _lodash.forEach)(items, function (item) {
	        item.info.pos = _wrapPos(path, item.info.pos * factorX + shift);
	      });
	      break;
	
	    case 'Stretched':
	    case 'Scaled':
	
	      factorX = factorY = fit === 'Scaled' ? ratio : ratio > 0 ? 1 : -1;
	
	      (0, _lodash.forEach)(items, function (item) {
	        item.info.pos = _wrapPos(path, item.info.pos * ratio);
	      });
	      break;
	  }
	
	  return new _geometry.Point(factorX, factorY);
	};
	
	// Determines the "Location" along the curve for each figure "Position".
	// These locations are given by an arc-length parametrization of the path.
	// Each "Location" encapsulates a point (on the path) and a tangent vector.
	var _createLocations = function (path, fwd, offset, items) {
	  // Trace.WriteLine( string.Format("  Computing locations") ) ;
	  var cursor = new _geometry.CurveArcLenCursor(path);
	
	  for (var k = 0, lastU = 0, kEnd = items.length; k < kEnd; ++k) {
	    var info = items[k].info;
	
	    var U = fwd ? info.pos + offset : path.arcLength() - offset - info.pos;
	    var deltaU = U - lastU;
	    cursor.move(deltaU);
	    info.loc = cursor.pos();
	    info.locTan = cursor.tangent();
	
	    // Trace.WriteLine( string.Format("Offset={0} CPos={1} U={2} P={3}",aOffset,lInfo.Pos,lU,lInfo.Loc.Point) ) ;
	    lastU = U;
	  }
	};
	
	// Places each figure along the path.
	// The "place" is given by the Location computed for each figure.
	// The following linear transformation is applied to each figure:
	//
	//   Displacement = Loc[i].Grip - Hook(i)
	//     Where Hook(i) = Item[i].Grip + VerticalShift
	//       Where VerticalShift = Item[i].Grip - Item[i].GripAlongBottom IF "Above"
	//                             Item[i].GripAlongTop - Item[i].Grip    IF "Below"
	//                             ZERO                                     OTHERWISE
	//
	//   Rotation = Angle w.r.t X-axis Loc[i].Tan
	//
	//   Scaling = NewWidth/Width(i)
	//     Where Width(i) = Item[i].BBox.Width
	//           NewWidth = PathLen / Count ;
	//
	
	var _createResult = function (layout, dontRotate, scale, mirrorX, mirrorY, items) {
	
	  (0, _lodash.forEach)(items, function (item) {
	    var rotation = dontRotate ? 0 : item.info.locTan.angle();
	
	    if (dontRotate) {
	      scale = new _geometry.Point(Math.abs(scale.x), Math.abs(scale.y));
	    }
	
	    var pos = item.info.loc.point;
	
	    item.info.rotation = rotation;
	    item.info.scaleX = scale.x;
	    item.info.scaleY = scale.y;
	
	    var charData = item.char._charData;
	    var transformers = charData._transformers;
	    if (mirrorX || mirrorY) {
	      transformers.push(new _text.TextChar.PivotedMirrorer(item.pivot, mirrorX, mirrorY));
	    }
	    if (Math.abs(scale.x) !== 1 || Math.abs(scale.y) !== 1) {
	      // [WHY?]
	      transformers.push(new _text.TextChar.PivotedScaler(item.pivot, scale.x, scale.y));
	    }
	    if (rotation !== 0) {
	      transformers.push(new _text.TextChar.PivotedRotator(item.pivot, rotation));
	    }
	
	    transformers.push(new _text.TextChar.PinPlacer(item.pivot, pos));
	  });
	};
	
	var fitOnPath = function (layout, lineIdx, path, vPlacement, hPlacement, fit, aPathRange_Beg, aPathRange_End, aPathPin, textPin, // This value should be properly scaled
	dontRotate, fwd, mirrorX, mirrorY, offset, useExtendedTextLength, steadyAngles) {
	
	  // Trace.WriteLine( string.Format("Fitting TextOnPath") ) ;
	
	  // >> GCurveBoundary lPath = aPath.Copy();
	
	  // It seems we do not need this, the first line baseline is always at the origin for the moment
	  // const baselineFrom = layout.textLines()[0]._baseline.P0;
	  // if( ! baselineFrom.isZero() ) {
	  //  layout.transform( Matrix.translate( Point.minus(baselineFrom) ) ); // This won't work directly
	  // }
	
	  var items = _wrapChars(layout, lineIdx, vPlacement, hPlacement, textPin);
	
	  var textLine = layout.textLines()[lineIdx - 1];
	  var textLength = useExtendedTextLength ? textLine._baseline.arcLength() : textLine.bounds.width; // TODO
	  var bearingLX = useExtendedTextLength ? textLine.bearingLX() : 0;
	
	  if (fit === 'Expanded') {
	    path = path.clone();
	  }
	  var scale = _computePositions(textLength, bearingLX, path, // If fit === Expanded, the path can be modified
	  fit, aPathRange_Beg, aPathRange_End, aPathPin, steadyAngles, textPin, mirrorX, items);
	
	  _createLocations(path, fwd, offset, items);
	  _createResult(layout, dontRotate, scale, mirrorX, mirrorY, items);
	
	  layout.invalidate();
	};
	
	var createSingleQuadCircularBezier = function (quad, ccw) {
	  var a = 4 / 3 * (Math.sqrt(2) - 1);
	
	  var N = [1, 1, a, 0];
	
	  var signX = quad === 0 || quad === 3 ? 1 : -1;
	  var signY = quad === 0 || quad === 1 ? 1 : -1;
	
	  var p = [];
	  for (var i = 0; i < 4; ++i) {
	    p.push(new _geometry.Point(signX * N[signX === signY ? i : 3 - i], signY * N[signX === signY ? 3 - i : i]));
	  }
	  if (!ccw) {
	    p.reverse();
	  }
	  return new _geometry.Cubic(p[0], p[1], p[2], p[3]);
	};
	
	var buildEllipse = function (center, mainAxisEndP, ratio, startQuad, orientation) {
	  var pieces = [];
	  var ccw = orientation === 'CCW';
	  for (var i = startQuad + (ccw ? 0 : 1), c = 0; c < 4; ++c, i = i + (ccw ? +1 : -1)) {
	    var q = i < 0 ? i + 4 : i;
	    var piece = createSingleQuadCircularBezier(q, ccw);
	    pieces.push(piece);
	  }
	
	  var curve = _geometry.Curve.fromNonTiedPieces(pieces, true);
	
	  var majAxis = _geometry.Point.substract(mainAxisEndP, center);
	  var rotAngle = majAxis.angle();
	  var xLen = majAxis.norm();
	  var yLen = xLen * ratio;
	
	  curve.transform(_geometry.Matrix.concat(_geometry.Matrix.translate(center), _geometry.Matrix.rotate(rotAngle), _geometry.Matrix.scale(xLen, yLen)));
	
	  return curve;
	};
	
	var createEllipse = function (center, a, b, orientation) {
	  var mainAxisEndP = _geometry.Point.add(center, a);
	  var a_norm2 = a.norm2();
	  var b_norm2 = b.norm2();
	  var ratio = b_norm2 > 0 && a_norm2 > 0 ? Math.sqrt(b_norm2 / a_norm2) : 1;
	  return buildEllipse(center, mainAxisEndP, ratio, 0, orientation);
	};
	
	var FitOnPathBasedProcess = _process.Process.extend({ typeName: 'FitOnPathBasedProcess',
	
	  Properties: {
	    steadyAngles: { type: 'boolean', def: false, onChange: _gear.invalidateOwner, dropDef: true }
	  },
	
	  canProcess: function (figure) {
	    if (!_config.Config.localFitOnPath) {
	      return false;
	    }
	    // [TODO] CharsTransform should always be used after the fit on path, but the inverse
	    //        is working in the engine and Canvas can not cope with it right now
	    var processes = figure._processes;
	    var charsTransform = (0, _gear.findByType)(processes, _process.Process.CharsTransform);
	    if (charsTransform && processes.indexOf(charsTransform) < processes.indexOf(this)) {
	      return false;
	    }
	    return true;
	  },
	  process: function (c) {
	    var _this = this;
	
	    var path = this.path();
	
	    (0, _lodash.forEach)(c.figures, function (figure) {
	      if (figure instanceof _text.TextLayout) {
	        _this.applyTo(figure, path);
	      }
	    });
	
	    c.anchor = path.bounds.center;
	  },
	  requiresText: function () {
	    return true;
	  },
	  outputsText: function () {
	    return true;
	  }
	});
	
	// ClassicArc
	//===============================================================================================
	
	var ClassicArc = _process.Process.ClassicArc = FitOnPathBasedProcess.extend({ typeName: 'ClassicArcProcess',
	
	  type: 'ClassicArc',
	
	  Properties: {
	    width: { type: 'magnitude', def: new _gear.Magnitude(500, 'mm'), onChange: _gear.invalidateOwner },
	    height: { type: 'magnitude', def: new _gear.Magnitude(100, 'mm'), onChange: _gear.invalidateOwner },
	    from: { type: 'angle', def: 170, onChange: _gear.invalidateOwner, dropDef: true },
	    to: { type: 'angle', def: 10, onChange: _gear.invalidateOwner, dropDef: true },
	    dontRotate: { type: 'boolean', def: false, onChange: _gear.invalidateOwner, dropDef: true },
	    fit: { type: 'string', def: 'Contained', onChange: _gear.invalidateOwner, dropDef: true }
	  },
	
	  path: function () {
	    // Create ellipse
	    var ellipse = createEllipse(new _geometry.Point(0, 0), new _geometry.Point(-Math.abs(this._width) / 2, 0), new _geometry.Point(0, Math.abs(this._height) / 2), 'CW');
	    return ellipse;
	  },
	  applyTo: function (layout, ellipse) {
	    var from = this._from,
	        to = this._to;
	    var upperArc = to < from;
	    if (ellipse === undefined) {
	      ellipse = this.path();
	    }
	
	    var arcStart = AngularCPos(from);
	    var arcEnd = AngularCPos(to);
	    var arcPin = AngularCPos((from + to) / 2);
	
	    /* [TODO]
	    if( Config.debugFitOnPath ) {
	      // const arcStartPos = _arcLenPosValue(ellipse, from);
	      // const arcEndPos   = _arcLenPosValue(ellipse, to  );
	      // const lDPath = new ShapeFigure(lEllipse.Copy());
	      // lDPath.AssignStyle( new GColorPen(GColor.Black), null ) ;
	      // const lDArc = new ShapeFigure( new GPolygonalBoundary(false, lArcStartPos.Point, lEllipse.BBox.MXMY, lArcEndPos.Point) ) ;
	      // lDArc.AssignStyle( new GColorPen(GColor.Black), null ) ;
	      // aOutput.Add(lDPath);
	      // aOutput.Add(lDArc);
	    }
	    */
	
	    fitOnPath(layout, 1, //st line,
	    ellipse, upperArc ? 'Over' : 'Below', 'Middle', this._fit, arcStart, arcEnd, arcPin, (0, _lodash.head)(layout.textLines())._baseline.arcLength() / 2, this._dontRotate, true, false, false, 0, false, this._steadyAngles);
	
	    layout.invalidate();
	    layout.textLines();
	  },
	  maxHeightForBounds: function (bounds, textHeight) {
	    return _ClassicArc_maxHeightForBounds(bounds, textHeight, this._to);
	  }
	});
	_util.Xml.addFromBuild(ClassicArc);
	
	// In ClassicArc, we need to account for the text rotation to compute the width
	
	// areaHeight = ( 1-sin(to) ) * height + 2 * textHeight
	// areaWidth  = cos(to) * ( width + 2 * textHeight )  Worst case, math to complex
	
	var _ClassicArc_maxHeightForBounds = ClassicArc.maxHeightForBounds = function (bounds, textHeight, to) {
	  return 2 * (bounds.height - textHeight) / (1 - Math.abs(Math.sin((0, _gear.deg2rad)(to))));
	};
	
	var _ClassicArc_maxWidthForBounds = ClassicArc.maxWidthForBounds = function (bounds, textHeight, to) {
	  return (bounds.width - 2 * textHeight) / Math.abs(Math.cos((0, _gear.deg2rad)(to)));
	};
	
	ClassicArc.createForBounds = function (bounds, textHeight, to) {
	  if (to === undefined) {
	    to = 20;
	  }
	  return new ClassicArc({ width: _ClassicArc_maxWidthForBounds(bounds, textHeight, to),
	    height: _ClassicArc_maxHeightForBounds(bounds, textHeight, to),
	    to: to, from: 180 - to,
	    fit: 'ContainedHorizontally',
	    steadyAngles: true });
	};
	
	// FitEllipse
	//===============================================================================================
	
	var FitEllipse = _process.Process.FitEllipse = FitOnPathBasedProcess.extend({ typeName: 'FitEllipseProcess',
	
	  type: 'FitEllipse',
	
	  Properties: {
	    height: { type: 'magnitude', def: new _gear.Magnitude(0, 'mm'), onChange: _gear.invalidateOwner, dropDef: true },
	    width: { type: 'magnitude', def: new _gear.Magnitude(0, 'mm'), onChange: _gear.invalidateOwner, dropDef: true },
	    rotation: { type: 'angle', def: 0, onChange: _gear.invalidateOwner, dropDef: true },
	    placement: { type: 'number', def: 90, onChange: _gear.invalidateOwner, dropDef: true },
	    mirror: { type: 'boolean', def: false, onChange: _gear.invalidateOwner, dropDef: true },
	    inside: { type: 'boolean', def: false, onChange: _gear.invalidateOwner, dropDef: true },
	    dontRotate: { type: 'boolean', def: false, onChange: _gear.invalidateOwner, dropDef: true },
	    fit: { type: 'string', def: 'None', onChange: _gear.invalidateOwner, dropDef: true }
	  },
	
	  path: function () {
	    // Create ellipse
	
	    var ellipse = createEllipse(new _geometry.Point(0, 0), new _geometry.Point(-Math.abs(this._width) / 2, 0), new _geometry.Point(0, Math.abs(this._height) / 2), 'CW');
	
	    if (this._rotation !== 0) {
	      ellipse.transform(_geometry.Matrix.rotate(this._rotation));
	    }
	    if (this._mirror) {
	      ellipse.transform(_geometry.Matrix.scale(-1, 1));
	    }
	
	    return ellipse;
	  },
	  applyTo: function (layout, ellipse) {
	    if (ellipse === undefined) {
	      ellipse = this.path();
	    }
	    var mirror = this._mirror;
	    var vPos = this._inside ? mirror ? 'Over' : 'Below' : mirror ? 'Below' : 'Over';
	
	    var lPathRange_Beg = LinealCPos(0);
	    var lPathRange_End = LinealCPos(ellipse.arcLength());
	    var lPathPin = AngularCPos(this._placement);
	    var lMax = 0;
	    for (var lLine = 0; lLine < layout.textLines().length; lLine++) {
	      var lLen = layout.textLines()[lLine]._baseline.arcLength();
	      lMax = Math.max(lMax, lLen);
	    }
	    var lTextPin = lMax / 2;
	    var lOldY = 0;
	    for (var _lLine = 0; _lLine < layout.textLines().length; _lLine++) {
	      var lH = layout.textLines()[_lLine]._baseline.P0.y; //bounds.height;
	      ellipse.transform(_geometry.Matrix.translate(0, lH - lOldY));
	      lOldY = lH;
	      fitOnPath(layout, _lLine + 1, ellipse, vPos, 'Middle', this._fit, lPathRange_Beg, lPathRange_End, lPathPin, lTextPin, this._dontRotate, true, false, false, 0, false, this._steadyAngles);
	    }
	
	    layout.invalidate();
	    layout.textLines();
	  }
	});
	_util.Xml.addFromBuild(FitEllipse);
	
	// FitOnPath
	//===============================================================================================
	
	var FitOnPath = _process.Process.FitOnPath = FitOnPathBasedProcess.extend({ typeName: 'FitOnPathProcess',
	  type: 'FitOnPath',
	  Properties: {
	    vPos: { type: 'string', def: 'Over', onChange: _gear.invalidateOwner }, // [TODO]enum
	    hPos: { type: 'string', def: 'Fixed_CenterTop', onChange: _gear.invalidateOwner },
	    anchor: { type: 'string', def: 'Middle', onChange: _gear.invalidateOwner, dropDef: true },
	    offset: { type: 'magnitude', def: new _gear.Magnitude(0.0, 'mm'), onChange: _gear.invalidateOwner, dropDef: true },
	    distanceFromPath: { type: 'magnitude', def: new _gear.Magnitude(0.0, 'mm'), onChange: _gear.invalidateOwner, dropDef: true },
	    placeOnOtherSide: { type: 'boolean', def: false, onChange: _gear.invalidateOwner, dropDef: true },
	    fwd: { type: 'boolean', def: true, onChange: _gear.invalidateOwner, dropDef: true },
	    dontRotate: { type: 'boolean', def: false, onChange: _gear.invalidateOwner, dropDef: true },
	    overhang: { type: 'boolean', def: false, onChange: _gear.invalidateOwner, dropDef: true },
	    mirrorX: { type: 'boolean', def: false, onChange: _gear.invalidateOwner, dropDef: true },
	    mirrorY: { type: 'boolean', def: false, onChange: _gear.invalidateOwner, dropDef: true }
	  },
	  init: function (c) {
	    this.callParent();
	    this._path = c.path || null;
	  },
	  isEqual: function (other) {
	    return this.propertiesAreEqual(other) && this._path.isEqual(other._path);
	  },
	  path: function (v) {
	    return v === undefined ? this._path : (this._path = v, this.invalidate(), this);
	  },
	  setupXml: function (node) {
	    _util.Xml.setupProperties(node, this);
	    this._path.buildXml(node, 'Path');
	  },
	  clone: function () {
	    var c = new FitOnPath(this);
	    c.path(this._path.clone());
	    return c;
	  },
	  applyTo: function (layout, path) {
	
	    // For FitOnPath to work correctly, the baseline should start at (0.0,0.0)
	
	    if (path === undefined) {
	      path = this._path;
	    }
	    var baselineLen = (0, _lodash.head)(layout.textLines())._baseline.arcLength();
	    var pathLen = path.arcLength();
	
	    var hPlacement = this._hPos;
	    var fit = hPlacement === 'Scaled' ? 'Scaled' : hPlacement === 'Stretched' ? 'Stretched' : hPlacement === 'Expanded' ? 'Expanded' : 'None';
	
	    var textPin = void 0,
	        pathPin = void 0;
	
	    if (path.closed) {
	      textPin = 0.5 * baselineLen;
	
	      switch (hPlacement) {
	        case 'Fixed_Left':
	          pathPin = AngularCPos(180);
	          break;
	
	        case 'Fixed_Right':
	          pathPin = AngularCPos(0);
	          break;
	
	        case 'Fixed_CenterTop':
	          pathPin = AngularCPos(90);
	          break;
	
	        case 'Fixed_CenterBottom':
	          pathPin = AngularCPos(270);
	          break;
	
	        default:
	          pathPin = AngularCPos(0);
	          break;
	      }
	    } else {
	      switch (hPlacement) {
	        case 'Fixed_Left':
	          textPin = 0;
	          pathPin = LinealCPos(0);
	          break;
	
	        case 'Fixed_Right':
	          textPin = baselineLen;
	          pathPin = LinealCPos(pathLen);
	          break;
	
	        case 'Fixed_CenterTop':
	        case 'Fixed_CenterBottom':
	          textPin = 0.5 * baselineLen;
	          pathPin = LinealCPos(0.5 * pathLen);
	          break;
	
	        default:
	          textPin = 0;
	          pathPin = LinealCPos(0);
	          break;
	      }
	    }
	
	    /* [TODO]
	    if( Config.debugFitOnPath ) {
	      // const dPath = new ShapeFigure(Path.Copy());
	      // lDPath.AssignStyle( new GColorPen(GColor.Black), null ) ;
	      // aOutput.Add(lDPath);
	    }
	    */
	
	    fitOnPath(layout, 1, //st line
	    path, this._vPos, this._anchor, fit, LinealCPos(0), LinealCPos(pathLen), pathPin, textPin, this._dontRotate, this._fwd, this._mirrorX, this._mirrorY, this._offset, this._overhang, this._steadyAngles);
	
	    layout.invalidate();
	    layout.textLines();
	  }
	});
	
	// [Patch] We will coerce all enums in future versions
	// There was a bug in CorelWorX generating wrong VPos values:
	var vPosValues = ['Above', 'Over', 'Below'];
	
	FitOnPath.parseXml = function (node) {
	  var p = _util.Xml.parseProperties(node, _process.Process.FitOnPath);
	  p.path = _geometry.Boundary.fromXml(node, 'Path');
	  if (!(0, _lodash.includes)(vPosValues, p.vPos)) {
	    p.vPos = 'Over';
	  }
	  return new FitOnPath(p);
	};
	_util.Xml.addFromBuild(FitOnPath);

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	var _process = __webpack_require__(40);
	
	// Distress
	//===============================================================================================
	
	var Distress = _process.Process.Distress = _process.Process.extend({ typeName: 'DistressProcess',
	
	  type: 'Distress',
	
	  Properties: {
	    scratchesLevel: { type: 'number', def: 0.5, onChange: _gear.invalidateOwner, dropDef: true },
	    rustLevel: { type: 'number', def: 0.5, onChange: _gear.invalidateOwner, dropDef: true },
	    foldsLevel: { type: 'number', def: 0.5, onChange: _gear.invalidateOwner, dropDef: true },
	    onOffThreshold: { type: 'number', def: 0.0, onChange: _gear.invalidateOwner, dropDef: true }
	  }
	});
	_util.Xml.addFromBuild(Distress);

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CharTransformList = exports.CharTransform = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	var _text = __webpack_require__(50);
	
	var _process = __webpack_require__(40);
	
	var _Scale = function (sx, sy, vAlign) {
	  this.sx = sx;
	  this.sy = sy;
	  this.vAlign = vAlign;
	};
	_Scale.prototype = {
	  transformer: function () {
	    var pivot = void 0;
	    switch (this.vAlign) {
	      case 'Baseline':
	        pivot = 'Grip';break;
	      case 'Bottom':
	        pivot = 'BottomCenterGrip';break;
	      case 'Top':
	        pivot = 'TopCenterGrip';break;
	      // case 'Middle'  :
	      default:
	        pivot = 'MiddleCenterGrip';break;
	    }
	    return new _text.TextChar.PivotedScaler(pivot, this.sx, this.sy);
	  },
	  computePreShift: function (char) {
	    var w = char._frame.width;
	    var centerShift = (this.sx - 1) / 2 * w;
	    switch (this.vAlign) {
	      case 'Baseline':
	        return 0;
	      case 'Bottom':
	        return centerShift;
	      case 'Top':
	        return centerShift;
	      // case 'Middle'  :
	      default:
	        return centerShift;
	    }
	  },
	  computePostShift: function (char) {
	    var w = char._frame.width,
	        m = char.bearingLX();
	    var sx = this.sx;
	    var centerShift = (sx - 1) / 2 * w;
	    switch (this.vAlign) {
	      case 'Baseline':
	        return (sx - 1) * (w + m);
	      case 'Bottom':
	        return centerShift;
	      case 'Top':
	        return centerShift;
	      // case VAlignment.Middle  :
	      default:
	        return centerShift;
	    }
	  },
	  clone: function () {
	    return new _Scale(this.sx, this.sy, this.vAlign);
	  }
	};
	
	var CharScalingProcess = _process.Process.extend({ typeName: 'CharScalingProcess',
	
	  canProcess: function () /*figure*/{
	    return true;
	  },
	  process: function (c) {
	    var _this2 = this;
	
	    (0, _lodash.forEach)(c.figures, function (figure) {
	      if (figure instanceof _text.TextLayout) {
	        _this2.applyTo(figure);
	      }
	    });
	  },
	  applyTo: function (layout) {
	
	    var lines = layout.textLines();
	
	    for (var i = 0, iEnd = lines.length; i < iEnd; ++i) {
	      var lineChars = lines[i]._chars;
	      var count = lineChars.length;
	
	      if (count > 0) {
	        var totalShift = 0;
	        var lineIdx = i + 1;
	        for (var j = 0; j < count; ++j) {
	
	          var char = lineChars[j];
	
	          // Pick the scaling command for this char, if any
	          var idx = j + 1;
	          var scale = this.scaleAt(lineIdx, idx, layout);
	          if (scale) {
	
	            var charData = layout.charData(lineIdx, idx);
	            charData._transformers.push(scale.transformer());
	
	            if (scale.sx !== 1) {
	              if (j > 0) {
	                var preShift = scale.computePreShift(char);
	                charData._extraKerning += preShift;
	                totalShift += preShift;
	              }
	              if (j + 1 < count) {
	                var postShift = scale.computePostShift(char);
	                layout.charData(lineIdx, idx + 1)._extraKerning += postShift;
	                totalShift += postShift;
	              }
	            }
	          }
	        }
	
	        // Unless left alignment was choosen, pull back all char to align.
	        var hAlign = this._hAlignment;
	
	        var backShift = 0;
	
	        if (hAlign === 'Center') {
	          backShift = totalShift / 2;
	        } else if (hAlign === 'Right') {
	          backShift = totalShift;
	        }
	
	        if (backShift !== 0) {
	          layout.charData(lineIdx, 1)._extraKerning -= backShift;
	        }
	      }
	
	      layout.invalidate();
	    }
	  }
	});
	
	// Capital
	//===============================================================================================
	
	var Capital = _process.Process.Capital = CharScalingProcess.extend({ typeName: 'CapitalProcess',
	
	  type: 'Capital',
	
	  Properties: {
	    scaleX: { type: 'number', def: 1, onChange: _gear.invalidateOwner, dropDef: true },
	    scaleY: { type: 'number', def: 1, onChange: _gear.invalidateOwner, dropDef: true },
	    hAlignment: { type: 'string', def: 'Center', onChange: _gear.invalidateOwner, dropDef: true },
	    vAlignment: { type: 'string', def: 'Baseline', onChange: _gear.invalidateOwner, dropDef: true },
	    pattern: { type: 'string', def: 'First Last', onChange: _gear.invalidateOwner, dropDef: true }
	  },
	
	  requiresText: function () {
	    return true;
	  },
	  outputsText: function () {
	    return true;
	  },
	
	
	  // Implement scaleAt used by CharScalingProcess base
	  scaleAt: function (lineIdx, charIdx, layout) {
	    var pattern = this._pattern;
	    var first = pattern.indexOf('First') !== -1,
	        middle = pattern.indexOf('Middle') !== -1,
	        last = pattern.indexOf('Last') !== -1;
	
	    var c = layout.textLines()[lineIdx - 1]._chars.length;
	    var m = Math.floor(c / 2);
	
	    var scaleThis = first && charIdx === 1 || last && charIdx === c;
	
	    if (!scaleThis && middle) {
	      scaleThis = charIdx === m + 1;
	
	      if (!scaleThis && c % 2 === 0) {
	        scaleThis = charIdx === m;
	      }
	    }
	    return scaleThis ? new _Scale(this._scaleX, this._scaleY, this._vAlignment) : null;
	  }
	});
	_util.Xml.addFromBuild(Capital);
	
	// BookEnd
	//===============================================================================================
	
	var BookEnd = _process.Process.BookEnd = CharScalingProcess.extend({ typeName: 'BookEndProcess',
	
	  type: 'BookEnd',
	
	  Properties: {
	    headSX: { type: 'number', def: 1, onChange: _gear.invalidateOwner, dropDef: true },
	    headSY: { type: 'number', def: 1, onChange: _gear.invalidateOwner, dropDef: true },
	    tailSX: { type: 'number', def: 1, onChange: _gear.invalidateOwner, dropDef: true },
	    tailSY: { type: 'number', def: 1, onChange: _gear.invalidateOwner, dropDef: true },
	    hAlignment: { type: 'string', def: 'Center', onChange: _gear.invalidateOwner, dropDef: true },
	    vAlignment: { type: 'string', def: 'Baseline', onChange: _gear.invalidateOwner, dropDef: true }
	  },
	
	  requiresText: function () {
	    return true;
	  },
	  outputsText: function () {
	    return true;
	  },
	
	
	  // Implement scaleAt used by CharScalingProcess base
	  headScale: function () {
	    return new _Scale(this._headSX, this._headSY, this._vAlignment);
	  },
	  tailScale: function () {
	    return new _Scale(this._tailSX, this._tailSY, this._vAlignment);
	  },
	  scaleAt: function (lineIdx, charIdx, layout) {
	    if (charIdx === 1) {
	      return this.headScale();
	    }
	    if (charIdx === layout.textLines()[lineIdx - 1]._chars.length) {
	      return this.tailScale();
	    }
	    return null;
	  }
	});
	_util.Xml.addFromBuild(BookEnd);
	
	// CharsTransform
	//===============================================================================================
	// This is implemented in the engine using a Generalized Char transformation, replacing
	// Char scaling process used in BookEnd and Capital. We may migrate to that design later,
	// this is the commit https://github.com/Stahls/cadx/commit/b9fd3c6475e8ee8d0d19bc624de5fc0a794db691
	/*
	  <CharsTransform>
	    <Char Idx="2">
	      <TangencialTranslate OffsetH="10%" OffsetV="10%"/>
	    </Char>
	  </CharsTransform>
	*/
	
	var CharTransform = exports.CharTransform = _gear.OwnedObject.extend({ typeName: 'CharTransform' });
	
	var TangencialOffset = CharTransform.TangencialOffset = CharTransform.extend({ typeName: 'TangencialOffsetCharTransform',
	  Properties: {
	    h: { type: 'magnitude', def: new _gear.Magnitude(0.0, 'mm'), onChange: _gear.invalidateOwner },
	    v: { type: 'magnitude', def: new _gear.Magnitude(0.0, 'mm'), onChange: _gear.invalidateOwner }
	  },
	  applyTo: function (layout, char) {
	    var spaceWidth = layout.spaceWidth();
	    var h = _gear.Magnitude.absoluteMMValueFor(this._h, spaceWidth);
	    var v = _gear.Magnitude.absoluteMMValueFor(this._v, spaceWidth);
	    var displacer = new _text.TextChar.TangencialDisplacer(h, v);
	    displacer.transform(char);
	    char._charData._transformers.push(displacer);
	  }
	});
	_util.Xml.addFromBuild(TangencialOffset, 'TangencialOffset');
	
	CharTransform.parseXml = function (node) {
	  switch (node.nodeName) {
	    case 'TangencialOffset':
	      return TangencialOffset.parseXml(node);
	  }
	  return null;
	};
	
	var CharTransformList = exports.CharTransformList = _gear.OwnedObject.extend({ typeName: 'CharTransformList',
	
	  Properties: {
	    lineIdx: { type: 'integer', def: 1, dropDef: true, onChange: _gear.invalidateOwner },
	    idx: { type: 'integer', def: 1, onChange: _gear.invalidateOwner },
	    transforms: { type: 'CharTransform[]', def: [], onChange: _gear.invalidateOwner, manualParsing: true }
	  },
	
	  setupXml: function (node) {
	    _util.Xml.setupProperties(node, this);
	    (0, _lodash.forEach)(this._transforms, function (t) {
	      t.buildXml(node);
	    });
	  }
	});
	CharTransformList.parseXml = function (node) {
	  var p = _util.Xml.parseProperties(node, CharTransformList);
	
	  p.transforms = [];
	  (0, _lodash.forEach)(_util.Xml.children_(node), function (ctNode) {
	    var ct = CharTransform.parseXml(ctNode);
	    if (ct) {
	      p.transforms.push(ct);
	    }
	  });
	  return new CharTransformList(p);
	};
	_util.Xml.addFromBuild(CharTransformList, 'Char');
	
	var CharsTransform = _process.Process.CharsTransform = _process.Process.extend({ typeName: 'CharsTransformProcess',
	
	  type: 'CharsTransform',
	
	  Properties: {
	    chars: { type: 'CharTransformList[]', def: [], owned: true, onChange: _gear.invalidateOwner, manualParsing: true }
	  },
	
	  requiresText: function () {
	    return true;
	  },
	  outputsText: function () {
	    return true;
	  },
	  setupXml: function (node) {
	    _util.Xml.setupProperties(node, this);
	    (0, _lodash.forEach)(this._chars, function (t) {
	      t.buildXml(node);
	    });
	  },
	  canProcess: function () /*figure*/{
	    return true;
	  },
	  process: function (c) {
	    var _this = this;
	    (0, _lodash.forEach)(c.figures, function (figure) {
	      if (figure instanceof _text.TextLayout) {
	        _this.applyTo(figure);
	      }
	    });
	  },
	  applyTo: function (layout) {
	    (0, _lodash.forEach)(this._chars, function (c) {
	      var lineIdx = c._lineIdx,
	          idx = c._idx;
	      var char = layout.charAt(lineIdx, idx);
	      if (char) {
	        (0, _lodash.forEach)(c._transforms, function (t) {
	          t.applyTo(layout, char);
	        });
	      }
	    });
	  }
	});
	
	CharsTransform.parseXml = function (node) {
	  var p = _util.Xml.parseProperties(node, CharsTransform);
	  p.chars = [];
	  (0, _lodash.forEach)(_util.Xml.children(node, 'Char'), function (ctNode) {
	    var ct = CharTransformList.parseXml(ctNode);
	    if (ct) {
	      p.chars.push(ct);
	    }
	  });
	  return new CharsTransform(p);
	};
	_util.Xml.addFromBuild(CharsTransform);

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _document = __webpack_require__(78);
	
	Object.keys(_document).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _document[key];
	    }
	  });
	});
	
	var _document3d = __webpack_require__(83);
	
	Object.keys(_document3d).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _document3d[key];
	    }
	  });
	});
	
	var _page = __webpack_require__(80);
	
	Object.keys(_page).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _page[key];
	    }
	  });
	});
	
	var _layer = __webpack_require__(79);
	
	Object.keys(_layer).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _layer[key];
	    }
	  });
	});
	
	var _contentLayer = __webpack_require__(81);
	
	Object.keys(_contentLayer).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _contentLayer[key];
	    }
	  });
	});

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.registerDocumentType = exports.Document = exports.documentEvents = exports.DocumentTag = exports.DocumentBackground = undefined;
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	var _style = __webpack_require__(29);
	
	var _geometry = __webpack_require__(21);
	
	var _figure = __webpack_require__(35);
	
	var _layer = __webpack_require__(79);
	
	var _page = __webpack_require__(80);
	
	var _template = __webpack_require__(82);
	
	var DocumentBackground = exports.DocumentBackground = _gear.OwnedObject.extend({ typeName: 'DocumentBackground',
	
	  Properties: {
	    brush: { type: 'Brush', def: _style.Brush.empty, onChange: function () {}
	    },
	    id: { type: 'string', def: null }
	  }
	});
	
	function overlapsWith(bounds) {
	  return function (figure) {
	    return figure.bounds$().then(function (figureBounds) {
	      return _geometry.Bounds.areOverlapping(figureBounds, bounds);
	    });
	  };
	}
	
	function canVisualBackOne$(array, figures) {
	  var from = 0;
	  return (0, _gear.find$)(figures, function (figure) {
	    var i = array.indexOf(figure);
	    if (i !== -1) {
	      return figure.bounds$().then(function (bounds) {
	        return (0, _gear.find$)(array.slice(from, i), overlapsWith(bounds)).then(function (overlappingFigureBelow) {
	          from = i;
	          return !!overlappingFigureBelow;
	        });
	      });
	    }
	    return (0, _gear.resolve)(false);
	  }).then(function (figure) {
	    return !!figure;
	  });
	}
	
	function visualBackOne$(array, figures) {
	  var from = arguments.length <= 2 || arguments[2] === undefined ? 0 : arguments[2];
	
	
	  if (figures.length === 0) {
	    return (0, _gear.resolve)();
	  }
	
	  var k = 0;
	  var figure = figures[k];
	  var i = array.indexOf(figure);
	  if (i !== -1) {
	
	    return figure.bounds$().then(function (bounds) {
	      return (0, _gear.findLast$)(array.slice(from, i), overlapsWith(bounds)).then(function (overlappingFigureBelow) {
	
	        if (overlappingFigureBelow) {
	          var range = [figure];
	          while (k < figures.length - 1) {
	            var nextFigure = figures[k + 1];
	            if (array.indexOf(nextFigure) === i - 1) {
	              range.push(nextFigure);
	              ++k;
	            } else {
	              break;
	            }
	          }
	          array.remove(range);
	          from = array.indexOf(overlappingFigureBelow);
	          array.insert(from, range);
	        }
	        return visualBackOne$(array, figures.slice(k + 1, figures.length), from);
	      });
	    });
	  } else {
	    return visualBackOne$(array, figures.slice(1, figures.length), from);
	  }
	}
	
	function canVisualForwardOne$(array, figures) {
	  var until = array.length;
	  return (0, _gear.findLast$)(figures, function (figure) {
	    var i = array.indexOf(figure);
	    if (i !== -1) {
	      return figure.bounds$().then(function (bounds) {
	        return (0, _gear.find$)(array.slice(i + 1, until), overlapsWith(bounds)).then(function (overlappingFigureAbove) {
	          until = i;
	          return !!overlappingFigureAbove;
	        });
	      });
	    }
	    return (0, _gear.resolve)(false);
	  }).then(function (figure) {
	    return !!figure;
	  });
	}
	
	function visualForwardOne$(array, figures) {
	  var until = arguments.length <= 2 || arguments[2] === undefined ? array.length : arguments[2];
	
	
	  if (figures.length === 0) {
	    return (0, _gear.resolve)();
	  }
	
	  var k = figures.length - 1;
	  var figure = figures[k];
	  var i = array.indexOf(figure);
	  if (i !== -1) {
	
	    return figure.bounds$().then(function (bounds) {
	      return (0, _gear.find$)(array.slice(i + 1, until), overlapsWith(bounds)).then(function (overlappingFigureAbove) {
	
	        if (overlappingFigureAbove) {
	          var range = [figure];
	          while (k > 0) {
	            var nextFigure = figures[k - 1];
	            if (array.indexOf(nextFigure) === i - 1) {
	              range.unshift(nextFigure);
	              --k;
	            } else {
	              break;
	            }
	          }
	          array.remove(range);
	          until = array.indexOf(overlappingFigureAbove);
	          array.insert(until + 1, range);
	        }
	        return visualForwardOne$(array, figures.slice(0, k), until);
	      });
	    });
	  } else {
	    return visualForwardOne$(array, figures.slice(0, figures.length - 1), until);
	  }
	}
	
	var DocumentTag = exports.DocumentTag = _gear.Base.extend({ typeName: 'DocumentTag',
	
	  Properties: {
	    id: { type: 'string', def: null },
	    name: { type: 'string', def: '' },
	    shared: { type: 'boolean', def: false },
	    owned: { type: 'boolean', def: false },
	    archived: { type: 'boolean', def: false },
	    type: { type: 'string', def: null }
	  }
	});
	
	var documentEvents = exports.documentEvents = ['load', 'saved', 'propertiesupdated', 'lock', 'unlock', 'preview', // [TODO] 'previewstarted' ?
	
	'render', 'commitstarted', 'commitrun', 'commit', 'revert', 'renderstarted', 'rendercomplete', 'renderfailed', 'undo', 'redo', 'commitcontent', 'historycommitstarted', 'figureschanged', 'layerschanged', 'pageschanged', 'activelayerchanged', 'activepagechanged',
	
	// Used only in Doc3D
	'materialschanged', 'model3dchanged', 'modeldata3dchanged'];
	
	var Document = exports.Document = _gear.Base.extend({ typeName: 'Document', __debugProps: true,
	
	  Properties: {
	    id: { type: 'string', def: null, manualParsing: true },
	    name: { type: 'string', def: '', manualParsing: true },
	    class1: { type: 'string', def: null, manualParsing: true },
	    class2: { type: 'string', def: null, manualParsing: true },
	    class3: { type: 'string', def: null, manualParsing: true },
	    notes: { type: 'string', def: '', manualParsing: true },
	    category: { type: 'string', def: null, manualParsing: true },
	    owned: { type: 'boolean', def: true, manualParsing: true },
	    archived: { type: 'boolean', def: false, manualParsing: true },
	    modified: { type: 'string', def: null, manualParsing: true },
	    docType: { type: 'string', def: 'Doc', manualParsing: true },
	    externalId: { type: 'string', def: null, manualParsing: true },
	    metrics: { type: 'string', def: 'mm', manualParsing: true },
	    xType: { type: 'string', def: null },
	    undoLimit: { type: 'integer', def: 10, manualParsing: true },
	    background: { type: 'DocumentBackground', def: new DocumentBackground(), manualParsing: true },
	    pages: { type: 'Page[]', def: [],
	      onChange: function (added, removed) {
	        this.lock();
	        this.fireEvent('pageschanged', this, added, removed);
	        if (!(0, _lodash.includes)(this._pages, this._activePage)) {
	          this.activePage = this._pages[0];
	        }
	      },
	
	      manualParsing: true
	    },
	    activePage: { type: 'Page', def: null, owned: false,
	      get: function () {
	        if (!this._activePage) {
	          this.activePage = this._pages[0];
	        }
	        return this._activePage;
	      },
	      set: function (page) {
	        if (this._activePage !== page) {
	          this._activePage = page;
	          this._activePageChanged = true;
	          this.fireEvent('activepagechanged', this, page);
	        }
	      },
	
	      manualParsing: true,
	      manualCloning: true
	    },
	    tags: { type: 'DocumentTag[]', def: [], manualParsing: true },
	    metadata: { type: 'Metadata', def: new _util.Metadata({}), manualParsing: true }
	  },
	
	  get isDocument() {
	    return true;
	  },
	
	  get activePageIndex() {
	    return (0, _lodash.indexOf)(this._pages, this.activePage);
	  },
	  set activePageIndex(i) {
	    this.activePage = this._pages[i];
	  },
	
	  get activePageFigures() {
	    return this.activePage.figures;
	  },
	  get activePageLayers() {
	    return this.activePage.layers;
	  },
	
	  get activeLayer() {
	    return this.activePage.activeLayer;
	  },
	  set activeLayer(layer) {
	    this.activePage.activeLayer = layer;
	  },
	
	  get activeLayerIndex() {
	    return this.activePage.activeLayerIndex;
	  },
	  set activeLayerIndex(i) {
	    this.activePage.activeLayerIndex = i;
	  },
	
	  get activeLayerFigures() {
	    return this.activeLayer.figures;
	  },
	
	  get layers() {
	    return this.activePage.layers;
	  },
	
	  get figures() {
	    var r = [],
	        pages = this._pages;
	    for (var k = 0; k < pages.length; ++k) {
	      r = r.concat(pages[k].figures);
	    }
	    return r;
	  },
	  set figures(figures_) {
	    this.releasePages();
	    this.activeLayer.figures = figures_;
	  },
	
	  release: function (fs) {
	    return fs === undefined ? this.activeLayerFigures.clear() : this.activeLayerFigures.remove(fs);
	  },
	  releaseFigures: function () {
	    var figures = this.figures;
	
	    this.remove(figures);
	    return figures;
	  },
	  releaseLayers: function () {
	    return this.activePage._layers.clear();
	  },
	  releasePages: function () {
	    var pages = this.pages;
	
	    var releasedPages = pages.toArray();
	    pages.set(new _page.Page());
	    return releasedPages;
	  },
	  backOne: function (figures) {
	    this.activeLayerFigures.moveBackward(figures, 1);
	  },
	  toBack: function (figures) {
	    var activeLayerFigures = this.activeLayerFigures;
	
	    activeLayerFigures.moveBackward(figures, activeLayerFigures.length);
	  },
	  forwardOne: function (figures) {
	    this.activeLayerFigures.moveForward(figures, 1);
	  },
	  toFront: function (figures) {
	    var activeLayerFigures = this.activeLayerFigures;
	
	    activeLayerFigures.moveForward(figures, activeLayerFigures.length);
	  },
	  canVisualForwardOne$: function (figures) {
	    return canVisualForwardOne$(this.activeLayerFigures, figures);
	  },
	  visualForwardOne$: function (figures) {
	    return visualForwardOne$(this.activeLayerFigures, figures);
	  },
	  visualBackOne$: function (figures) {
	    return visualBackOne$(this.activeLayerFigures, figures);
	  },
	  canVisualBackOne$: function (figures) {
	    return canVisualBackOne$(this.activeLayerFigures, figures);
	  },
	  lock: function (originator) {
	    if (!this._lock && !this.previewing) {
	      this._lock = true;
	      this.fireEvent('lock', this, originator);
	    }
	  },
	  unlock: function (originator) {
	    if (this._lock) {
	      this._lock = false;
	      this.fireEvent('unlock', this, originator);
	    }
	  },
	  changing: function () {
	    return this._lock;
	  },
	  _update$: function (type) {
	    return (0, _figure.updateArray$)(this._pages, type);
	  },
	  update$: function (type) {
	    var _this2 = this;
	
	    return this._update$(type).then(function () {
	      return _this2;
	    });
	  },
	  cache$: function () {
	    return this.update$('cache');
	  },
	
	
	  get previewing() {
	    return this._previewing;
	  },
	
	  fireRenderEvents: function (type) {
	    if (type === 'preview') {
	      this._previewing = true;
	    } else if (type === 'commit') {
	      this._previewing = false;
	    }
	
	    this.fireEvent('rendercomplete', this, type);
	    this.fireEvent(type, this);
	
	    this._activePageChanged = false;
	    this._activeLayerChanged = false;
	  },
	  updateAndRender$: function (type) {
	    var _this3 = this;
	
	    this.fireEvent('renderstarted', this, type);
	    return this._update$(type).then(function () {
	      _this3.fireRenderEvents(type);
	      return _this3;
	    });
	  },
	  render$: function () {
	    return this.updateAndRender$('render');
	  },
	  preview$: function () {
	    this.unlock();
	    return this.updateAndRender$('preview');
	  },
	  commit$: function () {
	    var _this4 = this;
	
	    this._isSaved = false;
	    var waitList = [];
	    this.fireEvent('commitstarted', this, waitList);
	    return (0, _gear.whenAll)(waitList).then(function () {
	
	      _this4.fireEvent('commitrun', _this4);
	      _this4.markUndo();
	      if (_this4._dropPreviousHistoryOnNextCommit) {
	        _this4._dropPreviousHistoryOnNextCommit = false;
	        _this4.dropPreviousHistory();
	      }
	      _this4.unlock(); // [CHECK]
	      return _this4.updateAndRender$('commit');
	    });
	  },
	  revert$: function () {
	    return this._applyUndoRedo(this.history[this._currentHistoryPosition], 'revert');
	  },
	  prepareToDraw$: function (zoom) {
	    return (0, _gear.map$)(this._pages, function (page) {
	      return page.prepareToDraw$(zoom);
	    });
	  },
	  clone: function () {
	    var api = this.activePageIndex;
	    var c = new this.constructor(this);
	    c.id = null;
	    c._activePage = c._pages[api];
	    return c;
	  },
	  toXmlString: function () {
	    var appendElement = _util.Xml.appendElement;
	
	    var docXml = _util.Xml.fromString('<Cdl></Cdl>');
	    var root = docXml.documentElement;
	    if (this._metrics && this._metrics !== 'mm') {
	      var lMetricsNode = appendElement(root, 'Metrics');
	      lMetricsNode.setAttribute('Unit', this._metrics);
	    }
	    var background = this._background,
	        background_id = background._id,
	        background_brush = background._brush,
	        emptyBackground = background_brush._empty && !background_id;
	    var layers = this.activePageLayers;
	    var pages = this.pages;
	    // root.setAttribute('xmlns', 'http://www.vectorx.com/2007/Cdl');
	
	    if (pages.length === 1 && pages[0].isDefault() && layers.length === 1 && layers[0].isDefault() && emptyBackground && this._metadata.isEmpty) {
	      _util.Xml.addObjectArray(root, layers[0]._figures);
	    } else {
	      var docNode = appendElement(root, 'Document');
	      _util.Xml.setupProperties(docNode, this);
	      this._metadata.setupXml(docNode);
	      if (!emptyBackground) {
	        var backgroundNode = appendElement(docNode, 'Background');
	        background_brush.buildXml(backgroundNode);
	        if (background_id) {
	          backgroundNode.setAttribute('Id', background_id);
	        }
	      }
	      if (pages.length === 1 && pages[0].isDefault()) {
	        (0, _lodash.invokeMap)(layers, 'buildXml', appendElement(docNode, 'Layers'));
	      } else {
	        (0, _lodash.invokeMap)(pages, 'buildXml', appendElement(docNode, 'Pages'));
	      }
	      this.extraSetupProperties(docNode);
	    }
	    return _util.Xml.toString(docXml);
	  },
	  extraSetupProperties: function () /* docNode */{},
	  updateProperties: function (p) {
	    // [TODO] Create updateProperties for these?
	    if (p) {
	      if (p.name) {
	        this.name = p.name;
	      }
	      if (p.class1) {
	        this.class1 = p.class1;
	      }
	      if (p.class2) {
	        this.class2 = p.class2;
	      }
	      if (p.class3) {
	        this.class3 = p.class3;
	      }
	      if (p.modified) {
	        this.modified = p.modified;
	      }
	      if (p.notes) {
	        this.notes = p.notes;
	      }
	      if (p.category) {
	        this.category = p.category;
	      }
	      this.fireEvent('propertiesupdated', this);
	    }
	  },
	  prepareToSave$: function () {
	    return this.commitAllContent$();
	  },
	  saveCopy$: function () {
	    var attrs = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    if (!attrs.copy) {
	      attrs.copy = true;
	    }
	    return this.save$(attrs);
	  },
	
	
	  // Example: { label: '', notes: '', category: '', docType: '', isCuttable: true }
	  save$: function () {
	    var _this5 = this;
	
	    var attrs = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	
	    var _this = this;
	    return _this.prepareToSave$().then(function () {
	
	      // Automatically create a new document if the user doesn't own it
	      if (!_this._owned || attrs.copy === true) {
	        _this.id = null;
	      }
	
	      if (attrs.name) {
	        _this.name = attrs.name;
	      }
	      if (attrs.class1) {
	        _this.class1 = attrs.class1;
	      }
	      if (attrs.class2) {
	        _this.class2 = attrs.class2;
	      }
	      if (attrs.class3) {
	        _this.class3 = attrs.class3;
	      }
	      if (attrs.modified) {
	        _this.modified = attrs.modified;
	      }
	      if (attrs.notes) {
	        _this.notes = attrs.notes;
	      }
	      if (attrs.category) {
	        _this.category = attrs.category;
	      }
	      if (attrs.docType) {
	        _this.docType = attrs.docType;
	      }
	      if (attrs.externalId) {
	        _this.externalId = attrs.externalId;
	      }
	      if (attrs.metrics) {
	        _this.metrics = attrs.metrics;
	      }
	
	      var manager = _this5._resources || _config.Config.GlobalResourceManager;
	      return manager.saveDocument$(_this5).then(function () {
	
	        _this._isSaved = true;
	        _this.fireEvent('saved', _this);
	        return _this;
	      });
	    });
	  },
	  pushMarkUndoDisabled: function () {
	    ++this.disableMarkUndo;
	  },
	  popMarkUndoDisabled: function () {
	    if (this.disableMarkUndo > 0) {
	      --this.disableMarkUndo;
	    }
	  },
	  markUndo: function () {
	    // [TODO] Rename
	    if (_config.Config.enableDocumentHistory && this.disableMarkUndo === 0 && this._undoLimit > 0) {
	      while (this._currentHistoryPosition > this._undoLimit) {
	        this.history.shift();
	        --this._currentHistoryPosition;
	      }
	      var stateData = this._pagesState();
	      ++this._currentHistoryPosition;
	      this.history = (0, _lodash.take)(this.history, this._currentHistoryPosition);
	      this.history.push(stateData);
	    }
	  },
	  canUndo: function () {
	    return this._currentHistoryPosition > 0;
	  },
	  undo: function () {
	    if (this.canUndo()) {
	      this._currentHistoryPosition--;
	      return this._applyUndoRedo(this.history[this._currentHistoryPosition], 'undo');
	    } else {
	      return (0, _gear.reject)();
	    }
	  },
	  canRedo: function () {
	    return this._currentHistoryPosition < this.history.length - 1;
	  },
	  redo: function () {
	    if (this.canRedo()) {
	      ++this._currentHistoryPosition;
	      return this._applyUndoRedo(this.history[this._currentHistoryPosition], 'redo');
	    } else {
	      return (0, _gear.reject)();
	    }
	  },
	  dropPreviousHistory: function () {
	    this.history.splice(0, this._currentHistoryPosition);
	    this._currentHistoryPosition = 0;
	  },
	  dropPreviousHistoryOnNextCommit: function () {
	    this._dropPreviousHistoryOnNextCommit = true;
	  },
	
	
	  // Template interface
	
	  addClipart$: function (clipart) {
	    return (0, _template.Template)(this).addClipart$(clipart);
	  },
	  replaceClipart$: function (old, clipart) {
	    return (0, _template.Template)(this).replaceClipart$(old, clipart);
	  },
	  autoCreateMultiPartText$: function (figures) {
	    var _this6 = this;
	
	    return (0, _figure.autoCreateMultiPartText$)(figures).then(function (multiPartText) {
	      _this6.replace(figures, multiPartText);
	      return _this6;
	    });
	  },
	  breakMultiPartText: function (text) {
	    var parts = text.breakIntoParts();
	    this.replace(text, parts);
	    return this;
	  },
	  group: function (figures) {
	    var group = _figure.Group.create(figures);
	    this.replace(figures, group);
	    return this;
	  },
	  ungroup: function (figures) {
	    if (!(0, _gear.isArray)(figures)) {
	      figures = [figures];
	    }
	    for (var k = 0, kEnd = figures.length; k < kEnd; ++k) {
	      var group = figures[k];
	      var parts = group.ungroupedFigures;
	      this.replace(group, parts);
	    }
	    return this;
	  },
	  extractPowerClipContents: function (figure) {
	    this.lock();
	    this.add(figure.extractPowerClipContents());
	    return this;
	  },
	  addPowerClipContents: function (figure, content) {
	    this.lock();
	    figure.addPowerClipContents(this.remove(content));
	    return this;
	  },
	  fixPowerClipContents: function () {
	    this.lock();
	    for (var k = 0, kEnd = this.figures.length; k < kEnd; ++k) {
	      var figure = this.figures[k];
	      figure.deepForEachFigure(this._fixFigurePowerClipContents);
	    }
	  },
	  _fixFigurePowerClipContents: function (figure) {
	    var pccs = figure._powerClipContents;
	    if (pccs != null && pccs.length == 1) {
	      if (figure._properties._powerClipId && figure._properties._powerClipId != "") {
	        var id = (0, _lodash.uniqueId)("PC");
	        pccs[0]._id = id;
	        figure._properties._powerClipId = id;
	      }
	    }
	  },
	  spawnContentLayersFor: function (figure, point) {
	    this.activePage.spawnContentLayersFor(figure, point);
	  },
	  editingContent: function () {
	    return this.activePage.editingContent();
	  },
	  _commitContent$: function () {
	    var _this7 = this;
	
	    return this.activePage.commitContent$().then(function (figure) {
	      _this7.fireEvent('commitcontent', _this7);
	      return figure;
	    });
	  },
	  commitContent$: function () {
	    return this._commitContent$().then(this.commit$);
	  },
	  _commitAllContent$: function () {
	    var _this = this;
	    return _this.editingContent() ? _this._commitContent$().then(function () {
	      return _this._commitAllContent$();
	    }) : (0, _gear.resolve)();
	  },
	  commitAllContent$: function () {
	    var _this = this;
	    var editingContent = _this.editingContent();
	    return _this._commitAllContent$().then(function () {
	      return editingContent ? _this.commit$() : null;
	    });
	  },
	  reshape$: function (figures, action) {
	    var _this8 = this;
	
	    this.lock();
	    return _figure.Figures.reshape$(figures, action).then(function (newFigures) {
	      var replaceFigures = action === 'frontMinusBack' ? (0, _lodash.last)(figures) : action === 'backMinusFront' ? (0, _lodash.head)(figures) : figures;
	      _this8.replace(replaceFigures, newFigures);
	      return _this8;
	    });
	  },
	  optimize$: function (figures) {
	    var _this9 = this;
	
	    return (0, _gear.map$)((0, _lodash.filter)(figures, { document: this }), function (figure) {
	      var manager = _this9._resources || _config.Config.GlobalResourceManager;
	      return manager.optimizeFigures$([figure]).then(function (newFigures) {
	        figure.owner()._figures.replace(figure, newFigures[0]);
	      });
	    }).then(function () {
	      return _this9;
	    });
	  },
	
	
	  // internals
	
	  init: function () {
	    var o = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	
	    this.addEvents(documentEvents);
	
	    // this.label    => name
	    // this.isStored => archived
	
	    // Bind commit$ and revert$ to the document so they can be used directly in callbacks
	    this._bind('commit$');
	    this._bind('preview$');
	    this._bind('revert$');
	    this._bind('render$');
	
	    this._lock = false;
	    this._previewing = false;
	
	    this._isSaved = false;
	
	    this._dropPreviousHistoryOnNextCommit = false;
	
	    // Used for syncronization, so views can fire change event
	    this._activePageChanged = false;
	    this._activeLayerChanged = false;
	
	    if (this._pages.length === 0) {
	      this._pages.set(new _page.Page());
	    }
	    if (this.Properties !== o.Properties) {
	      // If we are not doing a clone, support direct figures and layers
	      // setting (for one page documents)
	
	      if ((0, _gear.isArray)(o.layers)) {
	        this.layers = o.layers;
	      }
	      if ((0, _gear.isArray)(o.figures)) {
	        this.figures = o.figures;
	      }
	    }
	
	    this._activePage = this._pages[0];
	
	    this.disableMarkUndo = 0;
	    this.history = [this._emptyPagesState()];
	    this._currentHistoryPosition = 0;
	  },
	
	
	  // Cross pages and layers add, remove and replace
	
	  add: function (v) {
	    return this.activePage.activeLayer._figures.add(v);
	  },
	  remove: function (v) {
	    var e = [];
	    if ((0, _gear.isArray)(v)) {
	      (0, _lodash.forEach)((0, _gear.clone)(v), function (figure) {
	        e = e.concat(figure.layer.figures.remove(figure));
	      });
	    } else {
	      e = e.concat(v.layer.figures.remove(v));
	    }
	    return e;
	  },
	  replace: function (o, n) {
	    var to = (0, _gear.isArray)(o) ? (0, _lodash.last)(o) : o;
	    var layer = to.layer;
	    var activeLayer = this.activeLayer;
	
	    var i = layer === activeLayer ? layer.figures.indexOf(to) : activeLayer.figures.length;
	    var added = activeLayer._figures.insert(i, n);
	    var e = this.remove(o);
	    e.added = added;
	    return e;
	  },
	  clear: function () {
	    return this.releasePages();
	  },
	  forEachFigure: function (func) {
	    var pages = this.pages;
	
	    for (var k = 0, kEnd = pages.length; k < kEnd; ++k) {
	      var stop = pages[k].forEachFigure(func);
	      if (stop) {
	        return false;
	      }
	    }
	  },
	  isSaved: function () {
	    return this._isSaved;
	  },
	  _pagesState: function (state) {
	    return state ? (0, _gear.cloneDeep)(state) : (0, _gear.cloneDeep)(this._pages);
	  },
	  _emptyPagesState: function () {
	    return [new _page.Page()];
	  },
	  _applyUndoRedo: function (stateData, type) {
	    var _this = this;
	    _this.lock();
	    var waitList = [];
	    _this.fireEvent('historycommitstarted', _this, waitList, type);
	    return (0, _gear.whenAll)(waitList).then(function () {
	
	      // Check maintaining current active layer
	      var api = _this.activePageIndex;
	      var pages = _this._pagesState(stateData);
	      _this.pushMarkUndoDisabled();
	      // Try to keep the current active page, it will be good to store more information
	      var page = _this._activePage = pages[api < pages.length ? api : 0];
	      _this._pages.set(pages);
	      _this.fireEvent('activepagechanged', _this, page);
	
	      return _this.commit$().then(function () {
	
	        _this.fireEvent(type, _this);
	        _this.popMarkUndoDisabled();
	      });
	    });
	  },
	  vectorBounds_: function () {
	    return _figure.Figures.vectorBounds_(this.activeLayerFigures);
	  },
	  bounds_: function () {
	    return _figure.Figures.bounds_(this.activeLayerFigures);
	  },
	  vectorBounds$: function () {
	    return _figure.Figures.vectorBounds$(this.activeLayerFigures);
	  },
	  bounds$: function () {
	    return _figure.Figures.bounds$(this.activeLayerFigures);
	  },
	  extraXmlParsing: function () /* docNode */{}
	});
	
	Document.fromXmlString = function (xmlString, bcFixes) {
	  var domDoc = _util.Xml.fromString(xmlString);
	  return Document.fromXml(domDoc.documentElement, bcFixes);
	};
	
	Document.fromXml = function (node, bcFixes) {
	  var Type = Document,
	      xType = null;
	
	  var p = {};
	
	  // Support <Document><Pages>... and <Document><Layers>..., this will be cleaner in the future
	  var docNode = _util.Xml.child(node, 'Document');
	  var lMetricsNode = _util.Xml.child(node, 'Metrics');
	
	  var background = new DocumentBackground();
	
	  if (docNode) {
	    var backgroundNode = _util.Xml.child(docNode, 'Background');
	    if (backgroundNode) {
	      var brush = _style.Brush.fromXml(backgroundNode),
	          id = backgroundNode.getAttribute('Id');
	      background = new DocumentBackground({ brush: brush, id: id });
	    }
	
	    var pagesNode = _util.Xml.child(docNode, 'Pages');
	    if (pagesNode) {
	      node = pagesNode;
	    } else {
	      var layersNode = _util.Xml.child(docNode, 'Layers');
	      if (layersNode) {
	        node = layersNode;
	      }
	    }
	    xType = docNode.getAttribute('XType');
	    Type = _documentType[xType] || Document;
	
	    p = _util.Xml.parseProperties(docNode, Type);
	  }
	
	  p.pages = (Type.PageType || _page.Page).arrayFromXml(node, bcFixes);
	  p.background = background;
	  var doc = new Type(p);
	  if (docNode) {
	    doc._metadata = _util.Metadata.parseXml(docNode, doc);
	  }
	  if (lMetricsNode) {
	    var lMetricsType = lMetricsNode.getAttribute('Unit');
	    doc._metrics = lMetricsType;
	    _gear.Magnitude.setDefaultType(lMetricsType);
	  } else {
	    _gear.Magnitude.setDefaultType('mm');
	  }
	  doc.extraXmlParsing(docNode);
	
	  return doc;
	};
	
	var _backwardCompatibleDecoding$ = Document.backwardCompatibleDecoding$ = function (func, cdl) {
	  var bcFixes = [];
	  var doc = func(cdl, bcFixes);
	  return bcFixes.length > 0 ? (0, _gear.map$)(bcFixes, function (bpFix) {
	    return bpFix();
	  }).then(function () {
	    return doc;
	  }) : (0, _gear.resolve)(doc);
	};
	
	Document.fromXmlString$ = function (xml) {
	  return _backwardCompatibleDecoding$(Document.fromXmlString, xml);
	};
	Document.fromXml$ = function (xml) {
	  return _backwardCompatibleDecoding$(Document.fromXml, xml);
	};
	
	Document.load$ = function (config, options) {
	  return _config.Config.GlobalResourceManager.loadDocument$(config, options);
	};
	
	_layer.Layers.load$ = function (config, options) {
	  return Document.load$(config, options).then(function (doc) {
	    return doc.releaseLayers();
	  });
	};
	
	_figure.Figures.load$ = function (docModel) {
	  return _layer.Layers.load$(docModel).then(function (layers) {
	    return (0, _lodash.reduce)(layers, function (all, l) {
	      return (0, _gear.concat)(all, l.release());
	    }, []); // [TODO] flatMap
	  });
	};
	
	_figure.Figures.fromXmlString = function (string) {
	  return Document.fromXmlString(string).releaseFigures();
	};
	
	var _documentType = {
	  'System.Document': Document
	};
	
	var registerDocumentType = exports.registerDocumentType = function (xType, documentType) {
	  _documentType[xType] = documentType;
	};
	
	exports.default = Document;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Layers = exports.Layer = undefined;
	exports.topTargetLayer = topTargetLayer;
	exports.filterTargetLayers = filterTargetLayers;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	var _figure = __webpack_require__(35);
	
	var editContentAlpha = 0.3;
	
	var Layer = exports.Layer = _gear.OwnedObject.extend((0, _figure.updateMethods)(), { typeName: 'Layer', __debugProps: true,
	
	  Properties: {
	    id: { type: 'string', def: null, dropDef: true },
	    name: { type: 'string', def: null, dropDef: true },
	    locked: { type: 'boolean', def: false, dropDef: true },
	    hidden: { type: 'boolean', def: false, dropDef: true, onChange: function () {
	        this.invalidateView();
	      }
	    },
	    xType: { type: 'string', def: null, dropDef: true },
	    figures: { type: 'Figure[]', def: [],
	      onChange: function (added, removed) {
	        this.lock();
	        var doc = this.document;
	        if (doc) {
	          doc.fireEvent('figureschanged', doc, added, removed);
	        }
	      },
	
	      manualParsing: true
	    },
	    metadata: { type: 'Metadata', def: new _util.Metadata({}), manualParsing: true }
	  },
	
	  get isLayer() {
	    return true;
	  },
	
	  get document() {
	    var page = this.page;
	
	    return page && page.document;
	  },
	
	  get page() {
	    return this._owner;
	  },
	
	  isDefault: function () {
	    return !this._id && !this._name && !this._xType && !this._locked && !this._hidden && this._metadata.isEmpty;
	  },
	
	
	  get visible() {
	    return !this.hidden;
	  },
	  set visible(visible_) {
	    this.hidden = !visible_;
	  },
	
	  get active() {},
	
	  buildXml: function (node) {
	    return _util.Xml.addObject(node, this, 'Layer');
	  },
	  setupXml: function (node) {
	    _util.Xml.setupProperties(node, this);
	    this._metadata.setupXml(node);
	    var figuresNode = _util.Xml.appendElement(node, 'Figures');
	    _util.Xml.addObjectArray(figuresNode, this._figures);
	    return node;
	  },
	  add: function (figures) {
	    return this._figures.add(figures);
	  },
	  remove: function (figures) {
	    return this._figures.remove(figures);
	  },
	  replace: function (old, newFigures) {
	    return this._figures.replace(old, newFigures);
	  },
	  release: function (figures) {
	    return figures === undefined ? this._figures.clear() : this._figures.remove(figures);
	  },
	  lock: function (originator) {
	    if (this._owner) {
	      this._owner.lock(originator || this);
	    }
	  },
	  update$: function (type) {
	    return (0, _figure.updateArray$)(this._figures, type);
	  },
	  forEachFigure: function (func) {
	    return (0, _lodash.forEach)(this.figures, func);
	  },
	  bounds$: function () {
	    return _figure.Figures.bounds$(this._figures);
	  },
	  prepareToDraw$: function (zoom) {
	    return (0, _gear.invokeMap$)(this.figures, 'prepareToDraw$', zoom);
	  },
	  spawnContentLayersFor: function (figure, point) {
	    var Cx_CL = Layer.ContentLayer,
	        _this = this,
	        figures = _this.release();
	    var i = figures.indexOf(figure);
	
	    // Save a partial version of the original figure that will be used to assemble back
	    // the original one. The content layer create function can steal figure content where
	    // appropriate
	    this.figures = [figure];
	
	    var background = Cx_CL.Background({ original: _this, figures: figures.slice(0, i) }),
	        content = Cx_CL.extract(_this, figure, point),
	        foreground = Cx_CL.Foreground({ original: _this, figures: figures.slice(i + 1) });
	
	    return {
	      layers: (0, _gear.flatten)([background, content.layers, foreground]),
	      active: content.main
	    };
	  },
	  beforeDraw: function (context, config) {
	    if (config.editingContent) {
	      context.globalAlpha *= editContentAlpha;
	    }
	  },
	  afterDraw: function (context, config) {
	    if (config.editingContent) {
	      context.globalAlpha /= editContentAlpha;
	    }
	  }
	});
	
	var LayerType = function (node) {
	  var ct = node.getAttribute('ContentType');
	  if (ct) {
	    return Layer.ContentLayer[ct];
	  }
	  return Layer;
	};
	
	Layer.parseXml = function (node, bcFixes) {
	  var p = _util.Xml.parseProperties(node, Layer);
	  var figuresNode = _util.Xml.child(node, 'Figures');
	  p.figures = figuresNode ? _figure.Figure.arrayFromXml(figuresNode, bcFixes) : [];
	  var layer = new LayerType(node)(p);
	  layer._metadata = _util.Metadata.parseXml(node, layer);
	  return layer;
	};
	
	Layer.arrayFromXml = function (node, bcFixes) {
	  var layers = [];
	  var notLayeredfigures = [];
	
	  (0, _lodash.forEach)(_util.Xml.children_(node), function (child) {
	    if (child.nodeName === 'Layer') {
	      if (notLayeredfigures.length > 0) {
	        // Create a new unnamed layer
	        layers.push(new Layer({ figures: notLayeredfigures }));
	        notLayeredfigures = [];
	      }
	      layers.push(Layer.parseXml(child, bcFixes));
	    } else {
	      var figure = _figure.Figure.parseXml(child, bcFixes);
	      if (figure) {
	        notLayeredfigures.push(figure);
	      }
	    }
	  });
	  if (notLayeredfigures.length > 0 || layers.length === 0) {
	    // There is always an implicit layer, even if there are no figures on it
	    layers.push(new Layer({ figures: notLayeredfigures }));
	  }
	  return layers;
	};
	
	var Layers = exports.Layers = {};
	
	Layers.flattenRelease = function (layers) {
	  return (0, _gear.flatMap)(layers, function (layer) {
	    return layer.release();
	  });
	};
	
	Layers.flatten = function (layers) {
	  return (0, _gear.flatMap)(layers, 'figures');
	};
	
	Layers.bounds$ = function (layers) {
	  return _figure.Figures.bounds$(Layers.flatten(layers));
	};
	
	Layer.arrayToXmlString = function (layers) {
	  var xml = _util.Xml.fromString('<Cdl></Cdl>'),
	      root = xml.documentElement;
	  // root.setAttribute('xmlns', 'http://www.vectorx.com/2007/Cdl');
	  (0, _lodash.forEach)(layers, function (layer) {
	    layer.buildXml(root);
	  });
	  return _util.Xml.toString(xml);
	};
	
	function topTargetLayer(layers) {
	  for (var k = 0, kEnd = layers.length; k < kEnd; ++k) {
	    var layer = layers[k];
	    if (!(layer._locked || layer._hidden)) {
	      return layer;
	    }
	  }
	}
	
	function filterTargetLayers(layers) {
	  var r = [];
	  for (var k = 0, kEnd = layers.length; k < kEnd; ++k) {
	    var layer = layers[k];
	    if (!(layer._locked || layer._hidden)) {
	      r.push(layer);
	    }
	  }
	  return r;
	}

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Pages = exports.Page = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	var _figure = __webpack_require__(35);
	
	var _layer = __webpack_require__(79);
	
	var _contentLayer = __webpack_require__(81);
	
	var Page = exports.Page = _gear.OwnedObject.extend((0, _figure.updateMethods)(), { typeName: 'Page', __debugProps: true,
	
	  Properties: {
	    id: { type: 'string', def: null, dropDef: true },
	    name: { type: 'string', def: null, dropDef: true },
	    locked: { type: 'boolean', def: false, dropDef: true },
	    hidden: { type: 'boolean', def: false, dropDef: true },
	    xType: { type: 'string', def: null, dropDef: true },
	    activeLayer: { type: 'Layer', def: null, owned: false,
	      get: function () {
	        if (!this._activeLayer) {
	          this._activeLayer = this.initialActiveLayer();
	        }
	        return this._activeLayer;
	      },
	
	      manualParsing: true,
	      manualCloning: true,
	      onChange: function () {
	        var o = this._owner;
	        if (o && o._activePage === this) {
	          // Forward if active page
	          o._activeLayerChanged = true;
	          o.fireEvent('activelayerchanged', o, this.activeLayer);
	        }
	      }
	    },
	    layers: { type: 'Layer[]', def: [],
	      onChange: function (added, removed) {
	        this.lock();
	
	        var doc = this.document;
	        if (doc) {
	          doc.fireEvent('layerschanged', doc, added, removed);
	        }
	
	        if (!(0, _lodash.includes)(this._layers, this._activeLayer)) {
	          this.activeLayer = (0, _lodash.last)(this._layers);
	        }
	        var o = this._owner;
	        if (o && o._activePage === this) {
	          // Forward if active page
	          o.fireEvent('activelayerchanged', o, this.activeLayer);
	        }
	      },
	
	      member: '_layers',
	      manualParsing: true
	    },
	    metadata: { type: 'Metadata', def: new _util.Metadata({}), manualParsing: true }
	  },
	
	  get isPage() {
	    return true;
	  },
	
	  get activeLayerIndex() {
	    return (0, _lodash.indexOf)(this._layers, this.activeLayer);
	  },
	  set activeLayerIndex(i) {
	    this.activeLayer = this._layers[i];
	  },
	
	  initialActiveLayer: function () {
	    var layers = this._layers;
	    return (0, _lodash.findLast)(layers, function (layer) {
	      return layer.visible && layer instanceof _contentLayer.ContentLayer.Figure;
	    }) || (0, _layer.topTargetLayer)(layers) || (0, _lodash.last)(layers);
	  },
	
	
	  get visibleFigures() {
	    return (0, _lodash.filter)(_layer.Layers.flatten((0, _lodash.filter)(this.layers, 'visible')), 'visible');
	  },
	
	  get figures() {
	    return _layer.Layers.flatten(this.layers);
	  },
	
	  forEachFigure: function (func) {
	    var layers = this.layers;
	
	    for (var k = 0, kEnd = layers.length; k < kEnd; ++k) {
	      var stop = layers[k].forEachFigure(func);
	      if (stop) {
	        return false;
	      }
	    }
	  },
	
	
	  // [TODO] This decides if the page is encoded in the CDL, it is really weak
	  isDefault: function () {
	    return !this._id && !this._name && !this._xType && !this._locked && !this._hidden && this._metadata.isEmpty;
	  },
	
	
	  get document() {
	    return this._owner;
	  },
	
	  get visible() {}, // [TODO] ?
	  get active() {},
	
	  clone: function () {
	    var ali = this.activeLayerIndex;
	    var c = new this.constructor(this);
	    c._activeLayer = c._layers[ali];
	    return c;
	  },
	  buildXml: function (node) {
	    return _util.Xml.addObject(node, this, 'Page');
	  },
	  setupXml: function (node) {
	    _util.Xml.setupProperties(node, this);
	    this._metadata.setupXml(node);
	    var layersNode = _util.Xml.appendElement(node, 'Layers');
	    _util.Xml.addObjectArray(layersNode, this._layers);
	    return node;
	  },
	  init: function (config) {
	    this.callParent(config);
	    var layers = this._layers;
	    if (layers.length === 0) {
	      layers.push(new _layer.Layer());
	    }
	  },
	  release: function (ls) {
	    return ls === undefined ? this._layers.clear() : this._layers.remove(ls);
	  },
	  lock: function (originator) {
	    if (this._owner) {
	      this._owner.lock(originator || this);
	    }
	  },
	  update$: function (type) {
	    return (0, _figure.updateArray$)(this._layers, type);
	  },
	  bounds$: function () {
	    return _layer.Layers.bounds$((0, _lodash.filter)(this.layers, function (layer) {
	      return layer.figures.length > 0;
	    }));
	  },
	  layerBy: function (selector) {
	    return (0, _lodash.find)(this._layers, selector);
	  },
	  prepareToDraw$: function (zoom) {
	    return (0, _gear.invokeMap$)(this._layers, 'prepareToDraw$', zoom);
	  },
	  spawnContentLayersFor: function (figure, point) {
	    var layers = this.layers;
	    var layer = figure.layer;
	
	    // The layer will be empty after this point, to avoid clonning
	
	    var content = layer.spawnContentLayersFor(figure, point);
	
	    var content_layers = content.layers,
	        content_active = content.active;
	
	    var prev = content_layers.indexOf(content_active);
	
	    this.contentInfo(content_active, {
	      prev: prev,
	      next: content_layers.length - prev - 1
	    });
	
	    // Insert content layers after the edited layer and make it invisible
	    layers.insert(layers.indexOf(layer) + 1, content_layers);
	    this.activeLayer = content_active;
	
	    // We only leave the original figure, that will be used as reference
	    // when assembling back the content layers
	    layer.hidden = true;
	
	    return this;
	  },
	  editingContent: function () {
	    return this.activeLayer instanceof _contentLayer.ContentLayer;
	  },
	  contentInfo: function (layer, info) {
	    // We resort to metadata, so this is saved directly as part of CDL
	    // This allows for seamesly history and can documents can even be saved
	    // in a content edition state if required, for example to serialize
	    // current state
	
	    var metadata = layer.metadata;
	
	    if (info === undefined) {
	      return {
	        prev: metadata.get('contentPrev'),
	        next: metadata.get('contentNext')
	      };
	    } else {
	      metadata.set('contentPrev', info.prev);
	      metadata.set('contentNext', info.next);
	      return this;
	    }
	  },
	  commitContent$: function () {
	    var _this = this,
	        contentLayer = _this.activeLayer,
	        layers = _this._layers,
	        info = _this.contentInfo(contentLayer),
	        contentIdx = layers.indexOf(contentLayer),
	        originalLayer = layers[contentIdx - info.prev - 1],
	        originalFigure = originalLayer.release()[0];
	
	    // Replace the old figure with the new assembled one
	    return contentLayer.assemble$(originalFigure).then(function (figure) {
	
	      var content_layers = layers.slice(contentIdx - info.prev, contentIdx + info.next + 1);
	
	      // Remove content layers and make the layer visible again
	      layers.remove(content_layers);
	
	      originalLayer.hidden = false;
	
	      originalLayer.figures = (0, _lodash.compact)((0, _gear.flatten)([(0, _lodash.head)(content_layers).release(), figure, (0, _lodash.last)(content_layers).release()]));
	
	      _this.activeLayer = originalLayer;
	
	      return figure;
	    });
	  },
	  revertContentLayer: function (layer) {
	    this._layers.replace(layer._contentLayers, layer._original);
	    return this;
	  }
	});
	
	Page.parseXml = function (node, bcFixes) {
	  var PageType = arguments.length <= 2 || arguments[2] === undefined ? Page : arguments[2];
	
	  var p = _util.Xml.parseProperties(node, PageType);
	  var layersNode = _util.Xml.child(node, 'Layers');
	  p.layers = layersNode ? _layer.Layer.arrayFromXml(layersNode, bcFixes) : [new _layer.Layer()];
	  var page = new PageType(p);
	  page._metadata = _util.Metadata.parseXml(node, page);
	  return page;
	};
	
	Page.arrayFromXml = function (node, bcFixes) {
	  var PageType = arguments.length <= 2 || arguments[2] === undefined ? Page : arguments[2];
	
	  var pages = [];
	
	  var notPagedLayers = [],
	      notLayeredFigures = [];
	
	  var clearNotLayeredFigures = function () {
	    if (notLayeredFigures.length > 0) {
	      // Create a new unnamed layer
	      notPagedLayers.push(new _layer.Layer({ figures: notLayeredFigures }));
	      notLayeredFigures = [];
	    }
	  };
	
	  var clearNotPagedLayers = function () {
	    clearNotLayeredFigures();
	    if (notPagedLayers.length > 0) {
	      // Create a new unnamed page
	      pages.push(new PageType({ layers: notPagedLayers }));
	      notPagedLayers = [];
	    }
	  };
	
	  (0, _lodash.forEach)(_util.Xml.children_(node), function (child) {
	
	    var name = child.nodeName;
	
	    if (name === 'Page') {
	      clearNotPagedLayers();
	
	      pages.push(PageType.parseXml(child, bcFixes));
	    }
	    if (name === 'Layer') {
	      clearNotLayeredFigures();
	
	      var layer = _layer.Layer.parseXml(child, bcFixes);
	      if (layer) {
	        notPagedLayers.push(layer);
	      }
	    } else {
	      var figure = _figure.Figure.parseXml(child, bcFixes);
	      if (figure) {
	        notLayeredFigures.push(figure);
	      }
	    }
	  });
	
	  clearNotPagedLayers();
	
	  if (pages.length === 0) {
	    // There is always an implicit page, even if there are no layers on it
	    pages.push(new PageType());
	  }
	  return pages;
	};
	
	var Pages = exports.Pages = {};
	
	Pages.flatten = function (pages) {
	  return (0, _gear.flatMap)(pages, function (page) {
	    return _layer.Layers.flatten(page.layers);
	  });
	};

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ContentLayer = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _style = __webpack_require__(29);
	
	var _figure = __webpack_require__(35);
	
	var _layer = __webpack_require__(79);
	
	var editContentFigureAlpha = 0.6;
	
	var ContentLayer = exports.ContentLayer = _layer.Layer.ContentLayer = _layer.Layer.extend({ typeName: 'ContentLayer',
	  init: function (config) {
	    this.callParent(config);
	    this.metadata.set('contentType', this._type);
	  }
	});
	
	var ContentLayerType = function (figure /*,point*/) {
	  if (figure.isGroup) {
	    return ContentLayer.Group;
	  } else if (figure.isText && figure.isMultiPart) {
	    return ContentLayer.MultiPartText;
	  } else if (figure._powerClipContents.length > 0) {
	    return ContentLayer.PowerClip;
	  } else if (figure.isShape) {
	    return ContentLayer.Shape;
	  }
	  return null;
	};
	
	ContentLayer.extract = function (original, figure, point) {
	  return ContentLayerType(figure, point).extract(figure, point);
	};
	
	ContentLayer.Background = ContentLayer.extend({ typeName: 'BackgroundContentLayer',
	  _type: 'Background'
	});
	
	// Background
	//------------------------------------------------------------------------------
	
	ContentLayer.FigureBackground = ContentLayer.extend({ typeName: 'FigureBackgroundContentLayer',
	  _type: 'FigureBackground',
	
	  // [TODO] This should go to \ui
	  beforeDraw: function (context, config) {
	    if (config.editingContent) {
	      context.globalAlpha *= editContentFigureAlpha;
	    }
	  },
	  afterDraw: function (context, config) {
	    if (config.editingContent) {
	      context.globalAlpha /= editContentFigureAlpha;
	    }
	  }
	});
	
	ContentLayer.Figure = ContentLayer.extend({ typeName: 'FigureContentLayer',
	  beforeDraw: function () /* context, config */{
	    // Leave as is...
	  },
	  afterDraw: function () /* context, config */{
	    // Leave as is...
	  },
	  initialSelectedFigures: function () /*point*/{
	    return this._figures;
	  }
	});
	
	ContentLayer.Foreground = ContentLayer.extend({ typeName: 'ForegroundContentLayer',
	  _type: 'Foreground'
	});
	
	// Editing Content
	//------------------------------------------------------------------------------
	
	function simpleContent(ContentLayerType, content) {
	  var main = new ContentLayerType({ figures: content });
	  return { layers: [main], main: main };
	}
	
	function groupedSelectedFigures(point) {
	  var figures = this.figures;
	
	  return [point && _figure.Figures.figureAtPoint_(figures, point) || (0, _lodash.last)(figures)];
	}
	
	var preserveProperties = function (newFigure, originalFigure) {
	  (0, _lodash.forEach)(['id', 'name', 'alpha', 'metadata'], function (prop) {
	    newFigure[prop](originalFigure[prop]());
	  });
	  return newFigure;
	};
	
	ContentLayer.Group = ContentLayer.Figure.extend({ typeName: 'GroupContentLayer',
	
	  _type: 'Group',
	
	  assemble$: function (originalFigure) {
	    var figures = this.figures;
	
	    return (0, _gear.resolve)(figures.length === 0 ? null : originalFigure.regroup(figures));
	  },
	
	
	  initialSelectedFigures: groupedSelectedFigures,
	
	  statusMessage: function () {
	    return 'Group';
	  }
	});
	
	ContentLayer.Group.extract = function (figure /*,point*/) {
	  return simpleContent(ContentLayer.Group, figure.ungroup());
	};
	
	ContentLayer.PowerClip = ContentLayer.Figure.extend({ typeName: 'PowerClipContentLayer',
	
	  _type: 'PowerClip',
	
	  assemble$: function (originalFigure) {
	    // [TODO] Add supoort for multiple power clip contents
	    var powerClipContents = originalFigure.powerClipContents;
	
	    var pcc = powerClipContents[0];
	
	    var figures = this.figures;
	
	    if (figures.length > 0) {
	      var pccN = _figure.PowerClipContent.createForFigure('id', figures, originalFigure);
	      pcc.figures.set(pccN.figures.clear());
	    } else {
	      powerClipContents.remove(pcc);
	    }
	
	    return (0, _gear.resolve)(originalFigure);
	  },
	  initialSelectedFigures: function (point) {
	    var figures = this.figures;
	
	    if (point) {
	      var figure = _figure.Figures.figureAtPoint_(figures, point);
	      return figure ? [figure] : figures;
	    } else {
	      return figures;
	    }
	  },
	  statusMessage: function () {
	    return 'Power Clip Content';
	  }
	});
	ContentLayer.PowerClip.extract = function (figure /*, point*/) {
	  var pcc = figure._powerClipContents[0],
	      content = pcc.extractFigures(),
	      cf = figure.clone(),
	      background = [cf];
	
	  if (figure.isText) {
	    if (figure.powerClipId === pcc._id) {
	      var fc = cf.clone();
	      fc.brush = new _style.Brush({ color: _style.Color.Transparent() });
	      fc.pen = new _style.DisplayPen();
	      background.push(fc);
	    }
	  } else if (figure.isShape) {
	    (function () {
	      var polyregions = cf.polyregions;
	
	      (0, _lodash.forEach)((0, _lodash.filter)(polyregions, 'powerClipId', pcc.id), function (p) {
	        var pc = p.clone();
	        pc.brush = new _style.Brush({ color: _style.Color.Transparent() });
	        pc.pen = new _style.DisplayPen();
	        polyregions.insert(polyregions.indexOf(p), pc);
	      });
	    })();
	  }
	
	  var backgroundLayer = new ContentLayer.FigureBackground({ figures: background });
	  var main = new ContentLayer.PowerClip({ figures: content });
	  return { layers: [backgroundLayer, main], main: main };
	};
	
	ContentLayer.MultiPartText = ContentLayer.Figure.extend({ typeName: 'MultiPartTextContentLayer',
	
	  _type: 'MultiPartText',
	
	  assemble$: function (originalFigure) {
	    var figures = this.figures;
	
	    // [TODO] We can flatten the multi part text and regroup here
	
	    return figures.length === 0 ? (0, _gear.resolve)(null) : (0, _lodash.every)(figures, function (f) {
	      return f.isText && !f.isMultiPart;
	    }) ? originalFigure.regroupParts$(figures) :
	
	    // Fallback to normal grouping
	    (0, _gear.resolve)(preserveProperties(_figure.Group.create(figures), originalFigure));
	  },
	
	
	  initialSelectedFigures: groupedSelectedFigures,
	
	  statusMessage: function () {
	    return 'Multi Part Text';
	  }
	});
	ContentLayer.MultiPartText.extract = function (figure /*, point*/) {
	  return simpleContent(ContentLayer.MultiPartText, figure.breakIntoParts());
	};
	
	ContentLayer.Shape = ContentLayer.Figure.extend({ typeName: 'ShapeContentLayer',
	
	  _type: 'Shape',
	
	  assemble$: function (originalFigure) {
	    var figures = this.figures;
	
	    return (0, _gear.resolve)(figures.length === 0 ? (0, _gear.resolve)(null) : (0, _lodash.every)(figures, 'isShape') ?
	
	    // Reconstruct the shape
	    originalFigure.regroupShapes(figures) :
	
	    // Resort to group to be able to include text and rasters
	    preserveProperties(_figure.Group.create(figures), originalFigure));
	  },
	
	
	  initialSelectedFigures: groupedSelectedFigures,
	
	  statusMessage: function () {
	    return 'Shape';
	  }
	});
	ContentLayer.Shape.extract = function (figure /*, point*/) {
	  return simpleContent(ContentLayer.Shape, figure.breakApartPolyregions());
	};

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Template = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _figure = __webpack_require__(35);
	
	var Template = exports.Template = _gear.Base.extend({ typeName: 'Template',
	
	  init: function (doc) {
	    this.doc = doc;
	  },
	  document: function () {
	    return this.doc;
	  },
	  addClipart$: function (clipart) {
	    if (!(0, _gear.isArray)(clipart)) {
	      clipart = [clipart];
	    }
	
	    var doc = this.doc;
	    doc.lock();
	
	    clipart = _gear.OwnedObject.adopt(clipart, null);
	
	    return doc.bounds$().then(function (bounds) {
	
	      return _figure.Figures.center$(clipart, bounds).then(function () {
	
	        return _figure.Figures.setSize$(clipart, { width: bounds.width / 2, height: bounds.height / 2, fit: 'Mean' }).then(function () {
	
	          doc.add(clipart);
	          return clipart;
	        });
	      });
	    });
	  },
	  replaceClipart$: function (old, clipart) {
	    var doc = this.doc;
	
	    if (!(0, _gear.isArray)(old)) {
	      old = [old];
	    }
	    if (!(0, _gear.isArray)(clipart)) {
	      clipart = [clipart];
	    }
	
	    _figure.Figures.lock(old);
	
	    clipart = _gear.OwnedObject.adopt(clipart, null);
	
	    // Replace colors of the new clipart with the previous colors (using tags)
	    var oldColors = {};
	    _figure.Figures.forEachColor(old, function (c) {
	      var t = c._tag;
	      if (t && !oldColors[t]) {
	        oldColors[t] = c;
	      }
	    });
	    _figure.Figures.forEachColor(clipart, function (c) {
	      var t = c._tag;
	      if (t && oldColors[t]) {
	        c.replace(oldColors[t]);
	      }
	    });
	
	    if (old.length === 1 && old[0]._owner && old[0]._owner.isGroup) {
	      var _ret = function () {
	        var lGroup = old[0]._owner;
	        var lFigures = lGroup.ungroup();
	        var i = lFigures.indexOf(old[0]);
	        lFigures.splice(i, 1);
	        var matrix22 = old[0]._matrix22;
	        _figure.Figures.transform(clipart, matrix22);
	
	        return {
	          v: _figure.Figures.fit$(clipart, old, { fit: 'Mean' }).then(function () {
	
	            var xType = 'System.Clipart';
	            (0, _lodash.forEach)(clipart, function (c) {
	              return c.xType = xType;
	            });
	
	            lFigures.insert(i, clipart);
	            var lNG = Cx.Group.create(lFigures);
	            doc.replace(lGroup, lNG);
	            return clipart;
	          })
	        };
	      }();
	
	      if (typeof _ret === "object") return _ret.v;
	    } else {
	      var _matrix = old.length === 1 ? old[0]._matrix22 : _figure.Figures.composedIsometricMatrix22(old);
	      _figure.Figures.transform(clipart, _matrix);
	
	      return _figure.Figures.fit$(clipart, old, { fit: 'Mean' }).then(function () {
	
	        var xType = 'System.Clipart';
	        (0, _lodash.forEach)(clipart, function (c) {
	          return c.xType = xType;
	        });
	
	        doc.replace(old, clipart);
	        return clipart;
	      });
	    }
	  }
	});

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Document3D = exports.Model3D = exports.Material3D = exports.Material3D_Props = exports.TextureMap3D = exports.ModelData3D = exports.isModelIslandFor = exports.isDocIslandFor = exports.isModelIslandWithName = exports.isDocIslandWithName = undefined;
	exports.filterIslandsFor = filterIslandsFor;
	exports.textureIslandName = textureIslandName;
	exports.isTextureIsland = isTextureIsland;
	exports.isTextureIslandWithName = isTextureIslandWithName;
	exports.isTextureIslandFor = isTextureIslandFor;
	exports.newTextureIslandsLayer = newTextureIslandsLayer;
	exports.docIslandsLayerFrom = docIslandsLayerFrom;
	exports.docIslandsFrom = docIslandsFrom;
	exports.designLayersFrom = designLayersFrom;
	exports.designFiguresFrom = designFiguresFrom;
	exports.docToModelMatrix = docToModelMatrix;
	exports.modelToDocMatrix = modelToDocMatrix;
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _util = __webpack_require__(17);
	
	var _geometry = __webpack_require__(21);
	
	var _style = __webpack_require__(29);
	
	var _quantumImage = __webpack_require__(44);
	
	var _figure = __webpack_require__(35);
	
	var _layer = __webpack_require__(79);
	
	var _page = __webpack_require__(80);
	
	var _document = __webpack_require__(78);
	
	// [TODO]
	function filterIslandsByName(islands, name) {
	  var r = [];
	  for (var k = 0, kEnd = islands.length; k < kEnd; ++k) {
	    var island = islands[k];
	    if (textureIslandName(island) === name) {
	      r.push(island);
	    }
	  }
	  return r;
	}
	
	function changeTextureIslandsName(islands, oldName, newName) {
	  (0, _lodash.forEach)(islands, function (island) {
	    if (textureIslandName(island) === oldName) {
	      island.metadata.set('textureIslandName', newName);
	    }
	  });
	}
	
	function filterIslandsFor(islands, targetIsland) {
	  return filterIslandsByName(islands, textureIslandName(targetIsland));
	}
	
	function findIslandByName(islands, name) {
	  for (var k = 0, kEnd = islands.length; k < kEnd; ++k) {
	    var island = islands[k];
	    if (textureIslandName(island) === name) {
	      return island;
	    }
	  }
	}
	
	function findIslandFor(islands, targetIsland) {
	  return findIslandByName(islands, textureIslandName(targetIsland));
	}
	
	function findLastIslandByName(islands, name) {
	  for (var k = islands.length - 1; k >= 0; --k) {
	    var island = islands[k];
	    if (textureIslandName(island) === name) {
	      return island;
	    }
	  }
	}
	
	/*
	function findLastIslandFor( islands, targetIsland ) {
	  return findLastIslandByName( islands, textureIslandName(targetIsland) );
	}
	*/
	
	function removeChildByTag(node, tag) {
	  return node.removeChild(_util.Xml.child(node, tag));
	}
	
	function textureIslandName(island) {
	  return island.metadata.get('textureIslandName');
	}
	
	function isTextureIsland(figure) {
	  return !!textureIslandName(figure);
	}
	
	function isTextureIslandWithName(name) {
	  return function (figure) {
	    return name === textureIslandName(figure);
	  };
	}
	var isDocIslandWithName = exports.isDocIslandWithName = isTextureIslandWithName;
	var isModelIslandWithName = exports.isModelIslandWithName = isTextureIslandWithName;
	
	// find( figures, isDocIslandWithName(name) )
	// filter( figures, isDocIslandWithName(name) )
	
	function isTextureIslandFor(modelIsland) {
	  return isDocIslandWithName(textureIslandName(modelIsland));
	}
	var isDocIslandFor = exports.isDocIslandFor = isTextureIslandFor;
	var isModelIslandFor = exports.isModelIslandFor = isTextureIslandFor;
	
	// find( figures, isDocIslandFor(textureIsland) )
	// filter( figures, isDocIslandFor(textureIsland) )
	
	function newTextureIslandsLayer(islands) {
	  return new _layer.Layer({ figures: islands, xType: 'System.TextureIslands' });
	}
	
	function isBleedTextureIslandLayer(_ref) {
	  var xType = _ref.xType;
	
	  return xType === 'System.TextureIslands_Bleed' || xType === 'System.OffsetedTextureIslands'; // Backward compatibility
	}
	
	function isCutTextureIslandLayer(_ref2) {
	  var xType = _ref2.xType;
	
	  return xType === 'System.TextureIslands_Cut';
	}
	
	function isSafetyTextureIslandLayer(_ref3) {
	  var xType = _ref3.xType;
	
	  return xType === 'System.TextureIslands_Safety' || xType === 'System.TextureIslands';
	}
	
	function docIslandsLayerFrom(page) {
	  return (0, _lodash.head)(page.layers);
	}
	
	function docIslandsFrom(page) {
	  return docIslandsLayerFrom(page).figures;
	}
	
	function designLayersFrom(page) {
	  return (0, _lodash.tail)(page.layers);
	}
	
	function designFiguresFrom(page) {
	  return _layer.Layers.flatten(designLayersFrom(page));
	}
	
	function docToModelMatrix(docIsland, modelIsland) {
	  return _geometry.Matrix.m(modelIsland.matrix_(), docIsland.matrix_().inverted());
	}
	
	function modelToDocMatrix(docIsland, modelIsland) {
	  return _geometry.Matrix.m(docIsland.matrix_(), modelIsland.matrix_().inverted());
	}
	
	var ModelData3D = exports.ModelData3D = _gear.OwnedObject.extend({ typeName: 'ModelData3D',
	
	  Properties: {
	    data: { type: 'json', def: null, owned: false, onChange: function () {
	        var owner = this._owner;
	        if (owner) {
	          owner._id = null; // Model3D
	          // owner.fireEvent('modeldata3dchanged'); [TODO], for the moment, doc.invalidateModelData3D() needs to be called
	        }
	        this._id = null;
	      } },
	    id: { type: 'string', def: null }
	  },
	
	  saveCopy$: function () {
	    this.id = null;
	    return this.save$();
	  },
	  save$: function () {
	    if (this.id) {
	      // Do not overwrite
	      return (0, _gear.resolve)(this);
	    }
	    var manager = this._resources || _config.Config.GlobalResourceManager;
	    return manager.saveModelData3D$(this);
	  }
	});
	
	ModelData3D.load$ = function (id) {
	  return _config.Config.GlobalResourceManager.loadModelData3D$(id);
	};
	
	var TextureMap3D_local = new Map();
	
	var TextureMap3D_images = new Map();
	
	var TextureMapCache = {
	  cacheFile: function (file) {
	    var localId = file.name;
	    TextureMap3D_local.set(localId, { file: file, id: null });
	    return localId;
	  },
	  isLocal: function (id) {
	    return TextureMap3D_local.has(id);
	  },
	  saveLocal$: function (id) {
	    var local = TextureMap3D_local.get(id);
	    if (local.savePromise) {
	      return local.savePromise;
	    } else if (local.file) {
	      var manager = _config.Config.GlobalResourceManager;
	      var promise = local.savePromise = manager.createTextureMap3D$(local.file).then(function (textureMap) {
	        local.file = null;
	        local.savePromise = null;
	        var id = local.id = textureMap.id;
	        return id;
	      });
	      return promise;
	    } else {
	      (0, _gear.resolve)(local.id);
	    }
	  },
	  loadImage$: function (id, size) {
	    var imagesMap = TextureMap3D_images.get(id);
	    if (!imagesMap) {
	      imagesMap = new Map();
	      TextureMap3D_images.set(id, imagesMap);
	    }
	    var cache = imagesMap.get(size);
	    if (cache === undefined) {
	      cache = {};
	      imagesMap.set(size, cache);
	    }
	    if (cache.image) {
	      return (0, _gear.resolve)(cache.image);
	    } else if (cache.promise) {
	      return cache.promise;
	    } else {
	      var local = TextureMap3D_local.get(id);
	      if (local && local.file) {
	        var promise = cache.promise = (0, _gear.imagePromise)(URL.createObjectURL(local.file)).then(function (rawImage) {
	          if (rawImage.width > size) {
	            return (0, _quantumImage.downScaleQuantum$)(rawImage, size).then(function (image) {
	              cache.image = image;
	              cache.promise = null;
	              return image;
	            });
	          } else {
	            if (rawImage.width < size) {
	              console.log('TextureMap too small');
	            }
	            cache.image = rawImage;
	            cache.promise = null;
	            return rawImage;
	          }
	        });
	        return promise;
	      } else {
	        var manager = _config.Config.GlobalResourceManager;
	        console.log('get ' + id + ' with size ' + size);
	        var _promise = cache.promise = manager.renderTexture3D$({ id: id, size: size }).then(_gear.imagePromise).then(function (image) {
	          cache.image = image;
	          cache.promise = null;
	          return image;
	        });
	        return _promise;
	      }
	    }
	  },
	  loadTextureTile$: function (id) {
	    var manager = _config.Config.GlobalResourceManager;
	    return manager.renderImage$({ id: id }).then(_gear.imagePromise);
	  }
	};
	
	var TextureMap3D = exports.TextureMap3D = _gear.OwnedObject.extend({ typeName: 'TextureMap3D',
	
	  Properties: {
	    id: { type: 'string', def: null },
	    scale: { type: 'number', def: 1, dropDef: true },
	    wrap: { type: 'string', def: 'Stretch', dropDef: true }, // 'Stretch' uses Texture3D store, 'Repeat' uses Image store
	    repeat: { type: 'number', def: 1, dropDef: true }
	  },
	
	  init: function () {
	    // Cache here the base64 representation
	
	  },
	  loadImage$: function (size) {
	    return TextureMapCache.loadImage$(this.id, size);
	  },
	  loadTextureTile$: function () {
	    return TextureMapCache.loadTextureTile$(this.id);
	  },
	  save$: function () {
	    var _this = this;
	
	    if (TextureMapCache.isLocal(this.id)) {
	      console.log('uploading texture ' + this.id);
	      return TextureMapCache.saveLocal$(this.id).then(function (id) {
	        _this.id = id;
	        return _this;
	      });
	    } else {
	      return (0, _gear.resolve)(this);
	    }
	  }
	});
	
	_util.Xml.addDefaultParseXml(TextureMap3D);
	_util.Xml.addDefaultSetupXml(TextureMap3D);
	
	TextureMap3D.fromFile = function (file) {
	  var localId = TextureMapCache.cacheFile(file);
	  return new TextureMap3D({ id: localId });
	};
	
	var textureMaps = ['colorMap', 'specularMap', 'normalMap', 'bumpMap', 'displacementMap', 'alphaMap'];
	
	function createModelIsland(name, polyregion) {
	  var shape = _figure.Shape.createFromPolyregion(polyregion);
	  shape.metadata.set('textureIslandName', name);
	  return shape;
	}
	
	function onTextureChange() {
	  var document = this.document;
	
	  if (document) {
	    document.fireEvent('model3dchanged');
	    document._id = null;
	  }
	}
	
	var Material3D_Props = exports.Material3D_Props = _gear.OwnedObject.extend({ typeName: 'Material3D_Props',
	  Properties: {
	    colorMap: { type: 'TextureMap3D', def: null, manualParsing: true, onChange: onTextureChange },
	    specularMap: { type: 'TextureMap3D', def: null, manualParsing: true, onChange: onTextureChange },
	    normalMap: { type: 'TextureMap3D', def: null, manualParsing: true, onChange: onTextureChange },
	    bumpMap: { type: 'TextureMap3D', def: null, manualParsing: true, onChange: onTextureChange },
	    alphaMap: { type: 'TextureMap3D', def: null, manualParsing: true, onChange: onTextureChange },
	    displacementMap: { type: 'TextureMap3D', def: null, manualParsing: true, onChange: onTextureChange },
	    textureWidth: { type: 'number', def: 2048, onChange: onTextureChange },
	    textureHeight: { type: 'number', def: 2048, onChange: onTextureChange },
	    backSide: { type: 'string', def: 'Solid', dropDef: true, onChange: onTextureChange }
	  },
	
	  getTextureMap: function (textureType) {
	    return this[textureType + 'Map'];
	  },
	  getFixedTextureMap: function (textureType) {
	    return textureType === 'bump' ? this.normalMap ? null : this.bumpMap : this.getTextureMap(textureType);
	  },
	  buildXml: function (node) {
	    return _util.Xml.addObject(node, this, 'Material');
	  },
	  setupXml: function (node) {
	    var _this2 = this;
	
	    _util.Xml.setupProperties(node, this);
	    (0, _lodash.forEach)(textureMaps, function (map) {
	      if (_this2[map]) {
	        var textureMapNode = _util.Xml.appendElement(node, _util.Xml.toXmlCase(map));
	        _this2[map].setupXml(textureMapNode);
	      }
	    });
	  },
	
	
	  get document() {
	    return this._owner.document;
	  }
	});
	
	Material3D_Props.fromXml = function (node) {
	  return Material3D_Props.parseXml(node); // Xml.getObject(node,Material3D_Props,'Material');
	};
	Material3D_Props.parseXml = function (node) {
	  var p = _util.Xml.parseProperties(node, Material3D_Props);
	  (0, _lodash.forEach)(_util.Xml.children_(node), function (mapNode) {
	    var nodeName = mapNode.nodeName;
	    var name = _util.Xml.toObjectCase(nodeName);
	    if ((0, _lodash.includes)(textureMaps, name) && !(name === 'normalMap' && (_config.Config.bumpMap || _config.Config.tiledBumpMap || _config.Config.tiledNormalMap))) {
	      p[name] = TextureMap3D.parseXml(mapNode);
	    }
	  });
	
	  return new Material3D_Props(p);
	};
	
	_util.Xml.addFromBuild(Material3D_Props);
	
	Material3D_Props.arrayFromXml = function (node) {
	  var materialsNode = _util.Xml.child(node, 'Materials');
	  if (materialsNode) {
	    node = materialsNode;
	  }
	  return _util.Xml.getObjectArray(node, Material3D_Props, 'Material');
	};
	
	Material3D_Props.arrayBuildXml = function (node, v) {
	  if ((0, _lodash.isEmpty)(v)) {
	    return;
	  }
	  var materialsNode = _util.Xml.appendElement(node, 'Materials');
	  _util.Xml.addObjectArray(materialsNode, v);
	};
	
	_util.Xml.Parser['Material3D_Props'] = _util.Xml.makeObjectParser(Material3D_Props);
	_util.Xml.Parser['Material3D_Props[]'] = _util.Xml.makeArrayObjectParser(Material3D_Props);
	
	var Material3D = exports.Material3D = _page.Page.extend((0, _gear.forwardPropertiesFrom)(Material3D_Props, 'properties', { typeName: 'Material3D',
	
	  Properties: {
	    properties: { type: 'Material3D_Props', owned: true, def: new Material3D_Props(), manualParsing: true, onChange: function () {} }
	  },
	
	  init: function (config) {
	    this.callParent(config);
	    if (this.layers.length === 1) {
	      this.initModelIslandsLayers();
	    }
	
	    // Backward Compatibility, textureWidth, textureHeight at the layer level
	    var layer = this.layers[0];
	    var metadata = layer.metadata;
	    var textureWidth = parseFloat(metadata.get('textureWidth'));
	    var textureHeight = parseFloat(metadata.get('textureHeight'));
	    if (textureWidth && textureHeight) {
	      this.properties._textureWidth = textureWidth;
	      this.properties._textureHeight = textureHeight;
	    }
	    metadata.delete('textureWidth');
	    metadata.delete('textureHeight');
	  },
	  isDefault: function () {
	    return false;
	  },
	  initModelIslandsLayers: function () {
	    this.layers = [new _layer.Layer({ xType: 'System.TextureIslands_Cut' }), new _layer.Layer({ xType: 'System.TextureIslands_Safety' }), new _layer.Layer({ xType: 'System.TextureIslands_Bleed' })];
	  },
	  addWholeModelIsland: function () {
	    var bounds = new _geometry.Bounds(0, 0, this.textureWidth, this.textureHeight);
	    var polyregion = _figure.Polyregion.CreateRectangle({ bounds: bounds,
	      brush: new _style.EmptyBrush(), pen: new _style.DisplayPen(), fillMode: 'Alternate'
	    });
	    this.addModelIsland({ name: 'Texture',
	      safety: polyregion, cut: polyregion, bleed: polyregion
	    });
	  },
	  addModelIsland: function (_ref4) {
	    var name = _ref4.name;
	    var safety = _ref4.safety;
	    var cut = _ref4.cut;
	    var bleed = _ref4.bleed;
	
	    this.modelIslandsLayer.add(createModelIsland(name, safety));
	    this.cutModelIslandsLayer.add(createModelIsland(name, cut));
	    this.bleedModelIslandsLayer.add(createModelIsland(name, bleed));
	  },
	
	
	  get modelIslandsLayer() {
	    // return find( this.layers, isSafetyTextureIslandLayer );
	    var layers = this.layers;
	
	    for (var i = 0, iEnd = layers.length; i < iEnd; ++i) {
	      var layer = layers[i];
	      if (isSafetyTextureIslandLayer(layer)) {
	        return layer;
	      }
	    }
	  },
	
	  get cutModelIslandsLayer() {
	    // return find( this.layers, isCutTextureIslandLayer );
	    var layers = this.layers;
	
	    for (var i = 0, iEnd = layers.length; i < iEnd; ++i) {
	      var layer = layers[i];
	      if (isCutTextureIslandLayer(layer)) {
	        return layer;
	      }
	    }
	  },
	
	  get bleedModelIslandsLayer() {
	    // return find( this.layers, isBleedTextureIslandLayer );
	    var layers = this.layers;
	
	    for (var i = 0, iEnd = layers.length; i < iEnd; ++i) {
	      var layer = layers[i];
	      if (isBleedTextureIslandLayer(layer)) {
	        return layer;
	      }
	    }
	  },
	
	  get clipModelIslandsLayer() {
	    return this.bleedModelIslandsLayer || this.cutModelIslandsLayer || this.modelIslandsLayer;
	  },
	
	  // Most of Model3D should go here...
	
	  getTextureMap: function (textureType) {
	    return this.properties.getTextureMap(textureType);
	  },
	  getFixedTextureMap: function (textureType) {
	    return this.properties.getFixedTextureMap(textureType);
	  },
	  setTextureMap: function (textureType, textureMap) {
	    this[textureType + 'Map'] = textureMap;
	    var document = this.document;
	
	    if (document) {
	      document.fireEvent('model3dchanged');
	    }
	  },
	  setupXml: function (node) {
	    var _this3 = this;
	
	    // BackwardCompatibility
	    (0, _lodash.forEach)(this.layers, function (_ref5) {
	      var metadata = _ref5.metadata;
	
	      metadata.set('textureWidth', _this3.textureWidth);
	      metadata.set('textureHeight', _this3.textureHeight);
	    });
	
	    // const materialNode = Xml.appendElement(node,'Material');
	    this.properties.setupXml(node);
	
	    this.callParent(node);
	
	    // BackwardCompatibility
	    (0, _lodash.forEach)(this.layers, function (_ref6) {
	      var metadata = _ref6.metadata;
	
	      metadata.delete('textureWidth');
	      metadata.delete('textureHeight');
	    });
	  },
	  save$: function () {
	    var _this4 = this;
	
	    return (0, _gear.map$)(textureMaps, function (map) {
	      var textureMap = _this4[map];
	      return textureMap && textureMap.save$();
	    });
	  }
	}));
	
	Material3D.arrayFromXml = function (node, bcFixes) {
	  return _page.Page.arrayFromXml(node, bcFixes, Material3D);
	};
	Material3D.parseXml = function (node, bcFixes) {
	  var page = _page.Page.parseXml(node, bcFixes, Material3D);
	  page.properties = Material3D_Props.fromXml(node);
	  return page;
	};
	
	_util.Xml.addFromBuild(Material3D, 'Material');
	_util.Xml.Parser['Material3D'] = _util.Xml.makeObjectParser(Material3D);
	
	var Model3D = exports.Model3D = _document.Document.extend({ typeName: 'Model3D',
	
	  Properties: {
	    modelData3D: { type: 'ModelData3D', owned: true, manualParsing: true, def: new ModelData3D() }
	  },
	
	  get materials() {
	    return this.pages;
	  },
	  set materials(materials_) {
	    this.pages = materials_;
	  },
	
	  get document3D() {
	    // [TODO] We are going to ask for manual invalidation for the moment
	    // doc3D.invalidateModel3D();
	    // doc3D.invalidateModelData3d();
	    return null; // this._owner;
	  },
	
	  /* [TODO]
	  fireDoc3DEvent( eventName ) {
	    const { document3D } = this;
	    if( document3D ) {
	      document3D.fireEvent(eventName,document3D,this);
	    }
	  },
	  */
	
	  init: function (config) {
	
	    this._loadingModelData3D = null;
	    this.modelData3D_id = null;
	
	    this.callParent(config);
	    this._xType = 'System.Model3D';
	
	    // We do not want history
	    this.undoLimit = 0;
	  },
	  modelIslandWithName: function (name) {
	    return findIslandByName(this.modelIslands, name);
	  },
	  modelIslandFor: function (docIsland) {
	    return findIslandFor(this.modelIslands, docIsland);
	  },
	  bleedModelIslandWithName: function (name) {
	    return findIslandByName(this.bleedModelIslands, name);
	  },
	  bleedModelIslandFor: function (docIsland) {
	    return findIslandFor(this.bleedModelIslands, docIsland);
	  },
	  modelToDocMatrixFor: function (docIsland) {
	    var modelIsland = this.modelIslandFor(docIsland);
	    return modelToDocMatrix(docIsland, modelIsland);
	  },
	  docToModelMatrixFor: function (docIsland) {
	    var modelIsland = this.modelIslandFor(docIsland);
	    return docToModelMatrix(docIsland, modelIsland);
	  },
	
	
	  get modelIslandsLayer() {
	    return this.materials[0].modelIslandsLayer;
	  },
	
	  get cutModelIslandsLayer() {
	    return this.materials[0].cutModelIslandsLayer;
	  },
	
	  get bleedModelIslandsLayer() {
	    return this.materials[0].bleedModelIslandsLayer;
	  },
	
	  get clipModelIslandsLayer() {
	    return this.materials[0].clipModelIslandsLayer;
	  },
	
	  get modelIslands() {
	    return this.modelIslandsLayer.figures;
	  },
	
	  get cutModelIslands() {
	    return this.cutModelIslandsLayer.figures;
	  },
	
	  get bleedModelIslands() {
	    return this.bleedModelIslandsLayer.figures;
	  },
	
	  get textureWidth() {
	    return this.materials[0].textureWidth;
	  },
	  get textureHeight() {
	    return this.materials[0].textureHeight;
	  },
	
	  changeIslandName: function (island, newName) {
	    var oldName = typeof island === 'string' ? island : textureIslandName(island);
	    changeTextureIslandsName(this.modelIslands, oldName, newName);
	    changeTextureIslandsName(this.cutModelIslands, oldName, newName);
	    changeTextureIslandsName(this.bleedModelIslands, oldName, newName);
	    this.id = null; // Force the creation of a new model3D
	  },
	  uvToModel: function (uv) {
	    return new _geometry.Point(this.textureWidth * uv.x, this.textureHeight * uv.y);
	  },
	  modelIslandAt: function (modelPoint) {
	    // [CHECK]
	    var modelIslands = this.modelIslands;
	
	    for (var i = modelIslands.length - 1; i >= 0; --i) {
	      var modelIsland = modelIslands[i];
	      if (modelIsland.bounds_().contains(modelPoint)) {
	        return modelIsland;
	      }
	    }
	  },
	  createCustomPage: function () {
	    var name = arguments.length <= 0 || arguments[0] === undefined ? 'Custom' : arguments[0];
	
	    var modelIslandsLayer = this.modelIslandsLayer.clone();
	    modelIslandsLayer.xType = 'System.TextureIslands';
	
	    (0, _lodash.forEach)(this.bleedModelIslands, function (bleedIsland) {
	
	      var bleed = bleedIsland.polyregions[0].clone();
	      bleed.pen = new _style.MaskPen();
	      bleed.brush = new _style.Brush({ color: _style.Color.Transparent() });
	
	      var island = findIslandFor(modelIslandsLayer.figures, bleedIsland);
	
	      // The bleed mask goes under the safety
	      island.polyregions.unshift(bleed);
	    });
	
	    return new _page.Page({ name: name, layers: [modelIslandsLayer, new _layer.Layer() // Empty layer for the figures
	      ] });
	  },
	  createDocument3D$: function () {
	    var doc3D = new Document3D({
	      pages: [this.createCustomPage('Base')],
	      model3D: this,
	      modelData3D: this.modelData3D
	    });
	    return (0, _gear.resolve)(doc3D);
	  },
	  save$: function () {
	    var _this5 = this;
	
	    var modelData3D = this.modelData3D;
	
	    return modelData3D.save$().then(function () {
	      return (0, _gear.invokeMap$)(_this5.materials, 'save$').then(function () {
	        var manager = _this5._resources || _config.Config.GlobalResourceManager;
	        return manager.saveModel3D$(_this5);
	      });
	    });
	  },
	  loadModelData3D$: function () {
	    var _this6 = this;
	
	    if (this._loadingModelData3D) {
	      return this._loadingModelData3D;
	    } else if (!this.modelData3D_id) {
	      return this.modelData3D;
	    } else {
	      var promise = this._loadingModelData3D = ModelData3D.load$(this.modelData3D_id).then(function (modelData3D) {
	        _this6.modelData3D = modelData3D;
	        _this6._loadingModelData3D = null;
	        _this6.modelData3D_id = null;
	        return modelData3D;
	      });
	      return promise;
	    }
	  },
	  extraSetupProperties: function (docNode) {
	    var id = this.modelData3D_id || this.modelData3D.id;
	    if (!id) {
	      return console.log('No modelData3D id');
	    }
	    docNode.setAttribute('ModelData3D', id);
	
	    // For the moment, set the material node in the Document if there is only
	    // one material. This will be removed soon [TODO]
	    if (this.materials.length === 1) {
	
	      var pageNode = removeChildByTag(removeChildByTag(docNode, 'Pages'), 'Page');
	
	      // docNode.appendChild( removeChildByTag(pageNode,'Material') );
	      var materialNode = _util.Xml.appendElement(docNode, 'Material');
	      this.materials[0].properties.setupXml(materialNode);
	      docNode.appendChild(removeChildByTag(pageNode, 'Layers'));
	    }
	  },
	  extraXmlParsing: function (docNode) {
	    var _this7 = this;
	
	    this.modelData3D_id = docNode.getAttribute('ModelData3D');
	
	    // Backward compatibility, the <Material> node was at the doc level before
	    var materialNode = _util.Xml.child(docNode, 'Material');
	    if (materialNode) {
	      var material = this.materials[0];
	      // TextureWidth, TextureHeight was not at the Material at that point
	      var textureWidth = material.textureWidth;
	      var textureHeight = material.textureHeight;
	
	      material.properties = Material3D_Props.parseXml(materialNode);
	      (0, _lodash.assign)(material, { textureWidth: textureWidth, textureHeight: textureHeight });
	    }
	
	    (0, _lodash.forEach)(textureMaps, function (map) {
	      var forcedMap = _config.Config[map];
	      if (forcedMap) {
	        console.log('Forcing ' + map + ' with ' + forcedMap);
	        var scale = _config.Config[map + 'Scale'],
	            repeat = _config.Config[map + 'Repeat'];
	        _this7.materials[0][map] = TextureMap3D({
	          id: forcedMap,
	          scale: scale ? parseFloat(scale) : 1,
	          wrap: _config.Config[map + 'Wrap'] || 'Stretch',
	          repeat: repeat ? parseInt(repeat) : 1
	        });
	      }
	    });
	  }
	});
	
	Model3D.PageType = Material3D;
	
	(0, _document.registerDocumentType)('System.Model3D', Model3D);
	
	Model3D.load$ = function (id) {
	  return _config.Config.GlobalResourceManager.loadModel3D$(id);
	};
	
	Model3D.fromXml = function (o) {
	  var doc = _document.Document.fromXml(o);
	  return doc;
	};
	
	Model3D.fromXmlString = function (s) {
	  return _document.Document.fromXmlString(s);
	};
	
	// Backward compatibility code, maybe it should be removed already
	function applyBackwardCompatibleFixes(doc3D) {
	  (0, _lodash.forEach)(doc3D.pages, function (page) {
	
	    // If the islands layer is at the end, move it to the back
	    var layers = page.layers;
	    var figure = (0, _lodash.last)(layers).figures[0];
	    if (figure && isTextureIsland(figure)) {
	      layers.unshift(layers.pop());
	    }
	
	    docIslandsLayerFrom(page).forEachFigure(function (island) {
	      var polyregions = island.polyregions;
	
	      if (polyregions && Cx.isArray(polyregions) && polyregions.length > 0) {
	        if (polyregions[0].pen instanceof _style.DisplayPen) {
	          // Place the bleed island under the safety polyregion
	          polyregions.unshift(polyregions.pop());
	        }
	
	        // Make sure that the bleed island doens't have a transparent brush
	        if (polyregions[0].brush._empty) {
	          polyregions[0].brush = new _style.Brush({ color: _style.Color.White() });
	        }
	      }
	    });
	  });
	}
	
	var Document3D = exports.Document3D = _document.Document.extend({ typeName: 'Document3D',
	
	  Properties: {
	    model3D: { type: 'Model3D', owned: false, def: new Model3D(), manualParsing: true, set: function (model) {
	        this._setModel3D(model);
	      }
	    },
	    materials: { type: 'Material3D_Props[]', owned: true, def: [new Material3D_Props()], onChange: function () {
	        this.invalidateModel3D();
	      }
	    }
	  },
	
	  save$: function (attr) {
	    var _this8 = this;
	
	    if (this.model3D.id) {
	      return this.callParent(attr);
	    } else {
	      return this.model3D.save$().then(function () {
	        return _this8.save$(attr);
	      });
	    }
	  },
	
	
	  get is3D() {
	    return true;
	  },
	
	  get modelData3D() {
	    return this.model3D.modelData3D;
	  },
	
	  invalidateMaterials: function () {
	    this.fireEvent('materialschanged', this, this.model3D);
	  },
	  invalidateModel3D: function () {
	    this.fireEvent('model3dchanged', this, this.model3D);
	    // [TODO] Review
	    this.invalidateModelData3D();
	  },
	  invalidateModelData3D: function () {
	    this.fireEvent('modeldata3dchanged', this, this.modelData3D);
	  },
	  extraSetupProperties: function (docNode) {
	
	    var model3D_id = this.model3D_id || this.model3D.id;
	    if (!model3D_id) {
	      return console.log('No model3D id');
	    }
	    docNode.setAttribute('Model3D', model3D_id);
	
	    var modelData3D_id = this.modelData3D_id || this.model3D.modelData3D_id || this.modelData3D.id;
	    if (!modelData3D_id) {
	      return console.log('No ModelData3D id');
	    }
	    docNode.setAttribute('ModelData3D', modelData3D_id);
	  },
	  init: function (config) {
	
	    this.callParent(config);
	    this._xType = 'System.Document3D';
	    this._docType = 'Doc3D';
	
	    applyBackwardCompatibleFixes(this);
	  },
	  _setModel3D: function (model3D) {
	    this._model3D = model3D;
	    this._model3D.id = model3D.id;
	    // this.fireEvent('model3dchanged'); // [TODO]
	  },
	
	
	  // Overwrite add(), this simplify the creation of clients
	  // because the normal addition pattern works as expected.
	  add: function (figures) {
	    this._changeActiveLayerForAdding(figures);
	    return this.callParent(figures);
	  },
	  _changeActiveLayerForAdding: function (figures) {
	    var f = (0, _gear.isArray)(figures) ? figures[0] : figures;
	    var activePage = this.activePage;
	
	    var islandsLayer = docIslandsLayerFrom(activePage);
	    if (f._xType === 'System.TextureIsland') {
	      this.activeLayer = islandsLayer;
	    } else if (this.activeLayer === islandsLayer) {
	      var designLayers = designLayersFrom(activePage);
	      var layer = (0, _layer.topTargetLayer)(designLayers);
	      this.activeLayer = layer || (0, _lodash.last)(designLayers);
	    }
	  },
	  loadData3D$: function () {
	    return this.loadModelData3D$();
	  },
	  loadModel3D$: function () {
	    var _this9 = this;
	
	    if (this._loadingModel3D) {
	      return this._loadingModel3D;
	    } else if (!this.model3D_id) {
	      return (0, _gear.resolve)(this.model3D);
	    } else {
	      var promise = this._loadingModel3D = Model3D.load$(this.model3D_id).then(function (model3D) {
	        _this9.model3D = model3D;
	        _this9.model3D_id = null;
	        _this9.modelData3D_id = null;
	        _this9._loadingModel3D = null;
	        return model3D;
	      });
	      return promise;
	    }
	  },
	  loadModelData3D$: function () {
	    return this.loadModel3D$().then(function (model) {
	      return model.loadModelData3D$();
	    });
	  },
	
	
	  // This function allows to copy the design of one size to other sizes
	  // It is expected that the arrangements/views in both documents are similar
	  copyDesignTo$: function (doc) {
	    var config = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var me = this;
	    var scaled = config.scaled === undefined ? false : config.scaled;
	    return (0, _gear.map$)(me._pages, function (pageFrom, pi) {
	      var pageTo = doc._pages[pi];
	      if (pageTo) {
	        var islandsLayerFrom = docIslandsLayerFrom(pageFrom),
	            islandsLayerTo = docIslandsLayerFrom(pageTo);
	        return (0, _gear.whenAll)([islandsLayerFrom.bounds$(), islandsLayerTo.bounds$()]).then(function (bounds) {
	          var boundsFrom = bounds[0],
	              boundsTo = bounds[1];
	          var scale = 1.0;
	          if (scaled) {
	            scale = Math.min(boundsTo.width / boundsFrom.width, boundsTo.height / boundsFrom.height);
	          }
	
	          var layersFrom = designLayersFrom(pageFrom),
	              layersTo = designLayersFrom(pageTo);
	          for (var li = 0, liEnd = layersFrom.length; li < liEnd; ++li) {
	            var layerFrom = layersFrom[li],
	                layerTo = layersTo[li];
	            if (layerTo) {
	              // const islandsBaseDone = {};
	              for (var fi = 0, fiEnd = layerFrom._figures.length; fi < fiEnd; ++fi) {
	                var figureFrom = layerFrom._figures[fi];
	
	                // Normal design figures
	                var figure = figureFrom.clone();
	                if (scaled) {
	                  figure.transform(_geometry.Matrix.scale(scale));
	                }
	                figure.pin = boundsTo.interpolate(boundsFrom.deinterpolate(figureFrom.pin));
	                layerTo._figures.add(figure);
	              }
	            }
	          }
	        });
	      }
	    });
	  },
	  docIslandsFor: function (modelIsland) {
	    return (0, _gear.flatMap)(this.pages, function (page) {
	      return filterIslandsFor(docIslandsFrom(page), modelIsland);
	    });
	  },
	
	
	  get topDocIsland() {
	    return (0, _lodash.last)(docIslandsFrom((0, _lodash.last)(this.pages)));
	  },
	
	  topDocIslandWithName: function (name) {
	    // [TODO] All pages should be considered, not only the last one
	    return findLastIslandByName(docIslandsFrom((0, _lodash.last)(this.pages)), name);
	  },
	  topDocIslandFor: function (modelIsland) {
	    return this.topDocIslandWithName(textureIslandName(modelIsland));
	  },
	  extraXmlParsing: function (docNode) {
	    this.model3D_id = docNode.getAttribute('Model3D');
	    this.modelData3D_id = docNode.getAttribute('ModelData3D');
	  },
	  changeIslandName: function (island, newName) {
	    var oldName = typeof island === 'string' ? island : textureIslandName(island);
	    (0, _lodash.forEach)(this.pages, function (page) {
	      changeTextureIslandsName(docIslandsFrom(page), oldName, newName);
	    });
	    this.model3D.changeIslandName(oldName, newName);
	  },
	  clearDesignFigures: function () {
	    var _this10 = this;
	
	    return (0, _gear.flatMap)(this.pages, function (page) {
	      return _this10.remove(designFiguresFrom(page));
	    });
	  },
	
	
	  // From apps, it is more clear to say doc3D.designFiguresFrom(page)
	  designFiguresFrom: function (page) {
	    return designFiguresFrom(page);
	  },
	  docIslandsFrom: function (page) {
	    return docIslandsFrom(page);
	  }
	});
	
	Document3D.load$ = function (config, options) {
	  return _config.Config.GlobalResourceManager.loadDocument3D$(config, options);
	};
	
	(0, _document.registerDocumentType)('System.Document3D', Document3D);

/***/ },
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var Util = _interopRequireWildcard(_gear);
	
	var _cdl = __webpack_require__(15);
	
	var Cdl = _interopRequireWildcard(_cdl);
	
	var _resources = __webpack_require__(131);
	
	var Resources = _interopRequireWildcard(_resources);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Avoid polluting the global space with the lodash variable
	window._.noConflict();
	
	var _window = window;
	var Cx = _window.Cx;
	
	// Assign properties from CoreJS Cx.Config, compatibility with Cx.Config.set(...)
	
	if (Cx.Config) {
	  (0, _lodash.assign)(_config.Config, Cx.Config);
	}
	
	// Cx.Base, Cx.map$ ...
	(0, _lodash.assign)(Cx, Util);
	
	// Cx.Document, Cx.Figure, Cx.Point ...
	(0, _lodash.assign)(Cx, Cdl);
	
	// Cx.translate, Cx.bounds$, ...
	(0, _lodash.assign)(Cx, Cdl.Figures);
	
	// Cx.GlobalCoreResourceManager, ...
	(0, _lodash.assign)(Cx, Resources);
	
	// The global resource manager is used by global methods like Document.load$(id)
	// Default to Core, applications can define their own resource managers
	_config.Config.GlobalResourceManager = _config.Config.coreX ? new Cx.CoreXResourceManager({ app: _config.Config.coreX }) : new Cx.GlobalCoreResourceManager();

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _coreUtil = __webpack_require__(132);
	
	Object.keys(_coreUtil).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _coreUtil[key];
	    }
	  });
	});
	
	var _coreFontData = __webpack_require__(133);
	
	Object.keys(_coreFontData).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _coreFontData[key];
	    }
	  });
	});
	
	var _core = __webpack_require__(134);
	
	Object.keys(_core).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _core[key];
	    }
	  });
	});
	
	var _coreX = __webpack_require__(135);
	
	Object.keys(_coreX).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _coreX[key];
	    }
	  });
	});

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.figureCacheModel = exports.objectFromCore = exports.propertiesFromCore = exports.propertiesToCore = exports.objectToCoreCase = exports.toCoreCase = undefined;
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _cdl = __webpack_require__(15);
	
	var _window = window;
	var Cx = _window.Cx;
	var toCoreCase = exports.toCoreCase = function (string) {
	  return string.charAt(0).toUpperCase() + string.substr(1);
	};
	
	var objectToCoreCase = exports.objectToCoreCase = function (object) {
	  var co = {};
	  (0, _lodash.forOwn)(object, function (value, key) {
	    co[toCoreCase(key)] = value;
	  });
	  return co;
	};
	
	var propertiesToCore = exports.propertiesToCore = function (object) {
	  var co = {};
	  (0, _lodash.forOwn)(object.prototype.Properties, function (c, name) {
	    var v = object[name]();
	    if (v !== undefined) {
	      co[c.tag || toCoreCase(name)] = v;
	    }
	  });
	  return co;
	};
	
	var propertiesFromCore = exports.propertiesFromCore = function (object, rm) {
	  var co = {};
	  (0, _lodash.forOwn)(object.prototype.Properties, function (c, name) {
	    var v = rm[c.tag || toCoreCase(name)];
	    if (v !== undefined) {
	      co[name] = v;
	    }
	  });
	  return co;
	};
	
	var objectFromCore = exports.objectFromCore = function (object, rm) {
	  return new object(propertiesFromCore(object, rm));
	};
	
	var figureCacheModel = exports.figureCacheModel = function (cacheId, transform, pin) {
	  return {
	    CacheId: cacheId,
	    Pin: { X: pin.x, Y: pin.y },
	    Transform: transform.toCore(),
	    RelativePin: { X: pin.relX, Y: pin.relY }, // deprecate
	    UseAnchor: pin.use !== "bounds", // deprecate
	    Constraint: { Width: 0, Height: 0 // deprecate
	    } };
	};
	
	_cdl.Figure.cacheModel = function (figure, overwrite) {
	  return figureCacheModel(figure._cacheId, overwrite && overwrite.matrix22 || figure._matrix22.toMatrix22(), overwrite && overwrite.pin || figure._pin); // do not use pin til bounds pinning is gone
	};
	
	_cdl.Figure.toCoreModel = function (figure) {
	  return figure._cacheId ? { CachedCdl: _cdl.Figure.cacheModel(figure) } : { Cdl: figure.toXmlString(_config.Config.serverCache) };
	};
	
	var parseCoreMetrics = function (figure, metrics) {
	  var cache = figure._cache;
	
	  cache.set('prePin', _cdl.Point.fromCore(metrics.PreAnchor));
	  cache.set('preVectorBounds', _cdl.Bounds.fromCore(metrics.PreVectorBounds));
	  cache.set('preBounds', _cdl.Bounds.fromCore(metrics.PreBounds));
	
	  cache.set('matrix', _cdl.Matrix.fromCore(metrics.Matrix));
	  cache.set('vectorBounds', _cdl.Bounds.fromCore(metrics.VectorBounds));
	  cache.set('bounds', _cdl.Bounds.fromCore(metrics.Bounds));
	
	  if (_config.Config.materialBounds && !metrics.MaterialBounds) {
	    console.log('MaterialBounds not present');
	  }
	  cache.set('materialBounds', Cx.Bounds.fromCore(metrics.MaterialBounds || metrics.Bounds));
	
	  if (metrics.GlobalPreMatrix) {
	    cache.set('globalPreMatrix', _cdl.Matrix.fromCore(metrics.GlobalPreMatrix));
	    cache.set('globalPreVectorBounds', _cdl.Bounds.fromCore(metrics.GlobalPreVectorBounds));
	    cache.set('globalPreBounds', _cdl.Bounds.fromCore(metrics.GlobalPreBounds));
	  } else {
	    var parent = figure._owner;
	    if (parent && parent.isGroup) {
	      if (parent.isGrouped) {
	        void 0;
	        // Parent is a grouped Group
	        // ... do not touch globalPre metrics
	      } else {
	        // Parent is a top level Group
	        cache.copy('matrix', 'globalPreMatrix');
	        cache.copy('vectorBounds', 'globalPreVectorBounds');
	        cache.copy('bounds', 'globalPreBounds');
	      }
	    } else {
	      // Top level figure
	      cache.set('globalPreMatrix', new _cdl.Matrix());
	      cache.copy('preVectorBounds', 'globalPreVectorBounds');
	      cache.copy('preBounds', 'globalPreBounds');
	    }
	  }
	
	  if (metrics.GlobalMatrix) {
	    cache.set('globalMatrix', _cdl.Matrix.fromCore(metrics.GlobalMatrix));
	    cache.set('globalVectorBounds', _cdl.Bounds.fromCore(metrics.GlobalVectorBounds));
	    cache.set('globalBounds', _cdl.Bounds.fromCore(metrics.GlobalBounds));
	
	    if (_config.Config.materialBounds && !metrics.GlobalMaterialBounds) {
	      console.log('GlobalMaterialBounds not present');
	    }
	    cache.set('globalMaterialBounds', _cdl.Bounds.fromCore(metrics.GlobalMaterialBounds || metrics.GlobalBounds));
	  } else {
	    var _parent = figure._owner;
	    if (_parent && _parent.isGroup) {
	      void 0;
	      // Parent is a group
	      // ... do not touch global metrics
	    } else {
	      // Top level figure
	      cache.copy('matrix', 'globalMatrix');
	      cache.copy('vectorBounds', 'globalVectorBounds');
	      cache.copy('bounds', 'globalBounds');
	      cache.copy('materialBounds', 'globalMaterialBounds');
	    }
	  }
	
	  // [TODO] Reference Point, this will be removed as soon as we can remove the bounds based
	  // pin system. I am not doing this for this release to avoid disruption.
	  var referencePoint = _cdl.Point.fromCore(metrics.RefPoint);
	  var preReferencePoint = referencePoint.transformed(cache.get('matrix').inverted());
	  cache.set('preReferencePoint', preReferencePoint);
	
	  // Used for concrete font size mechanics
	  var metrics_PreScale = metrics.PreAccumulatedScale;
	  var preScale = metrics_PreScale ? _cdl.Point.fromCore(metrics_PreScale) : new _cdl.Point(1, 1);
	  figure._computedPreScale = preScale;
	};
	
	function parentGlobalMatrix(figure) {
	  var model = {};
	  if (!_config.Config.computeFigureGeometryLocally || !figure.supportsLocalMetrics()) {
	    var parent = figure._owner;
	    if (parent && parent.isGroup) {
	      model.ParentGlobalMatrix = parent.globalMatrix_().toCore();
	      if (parent.isGrouped) {
	        model.ParentGlobalPreMatrix = parent.globalPreMatrix_().toCore();
	      }
	    }
	  }
	  return model;
	}
	
	var requestCoreToProcessFigure = function (figureModel) {
	  return Cx.Core.Figure.process$({ Figures: [figureModel] }).then(function (m) {
	    return m.Figures[0];
	  });
	};
	
	_cdl.Figure.processUsingServer$ = function (figure, options) {
	  // console.log(figure.toXmlString( Config.serverCache ));
	
	  var processModel = (0, _lodash.assign)({
	    Cdl: figure.toXmlString(_config.Config.serverCache),
	    GetOutput: options.getOutput,
	    StoreInCache: options.storeInCache,
	    GetMaterialBounds: _config.Config.materialBounds
	  }, parentGlobalMatrix(figure));
	
	  return requestCoreToProcessFigure(processModel).then(function (figureModel) {
	
	    parseCoreMetrics(figure, figureModel.Metrics);
	
	    var cachedCdl = figureModel.CachedCdl;
	    figure.cacheId = cachedCdl ? cachedCdl.CacheId : null;
	
	    var outputFigureXml = figureModel.OutputCdl;
	    var outputFigure = null;
	    if (outputFigureXml) {
	      outputFigure = _cdl.Figure.fromXmlString(outputFigureXml);
	      figure.outputFigure = outputFigure;
	
	      // Complete Raster Metadata avoiding possible processing later
	      if (figure.isRaster) {
	        if (figure._width === null) {
	          var width = outputFigure._width;
	          if (width !== 0) {
	            figure._width = width;
	          }
	        }
	        if (figure._height === null) {
	          var height = outputFigure._height;
	          if (height !== null) {
	            figure._height = height;
	          }
	        }
	      }
	    } else if (figure.isProxyGroup) {
	      // We create an outline output figure so our bounds system will work correctly
	      outputFigure = _cdl.Figure.createProxyGroupOutput(figure, figure.preBounds_(), figure.prePin_());
	    }
	    figure.outputFigure = outputFigure;
	
	    return figure;
	  });
	};
	
	_cdl.Figure.measureUsingCore$ = function (figure) {
	  // console.log('Update measurements in the server');
	
	  var processModel = (0, _lodash.assign)({
	    CachedCdl: _cdl.Figure.cacheModel(figure),
	    GetOutput: false
	  }, parentGlobalMatrix(figure));
	
	  return requestCoreToProcessFigure(processModel).then(function (figureModel) {
	
	    // Return a function so Grafika can decide when to apply the result
	    // We want to ask the server for the processing right away, but the
	    // outputFigure and metrics needs to be applied in the order the
	    // commits were issued. This lets users generate independent actions
	    // without risk of invalid states
	
	    // console.log('Metrics arrived')
	    parseCoreMetrics(figure, figureModel.Metrics);
	
	    return figure;
	  });
	};
	
	// We need to implement these functions using javascript and C++ modules
	
	_cdl.Figures.toCoreModel = function (figures) {
	  return (0, _lodash.map)(figures, function (f) {
	    return _cdl.Figure.toCoreModel(f);
	  });
	};
	
	_cdl.Figures.fromCoreModel = function (model) {
	  return (0, _lodash.map)(model.Figures, function (f) {
	    return _cdl.Figure.fromXmlString(f.Cdl);
	  });
	};
	
	// @action: Cx.E.ReshapeAction
	_cdl.Figures.reshape$ = function (figures, action) {
	  return Cx.Core.Figure.reshape$({
	    Figures: _cdl.Figures.toCoreModel(figures), Action: action
	  }).then(_cdl.Figures.fromCoreModel);
	};
	
	function condensedReshape$(figures, action) {
	  return _cdl.Figures.reshape$(figures, action).then(_lodash.first);
	}
	
	_cdl.Figures.combine$ = function (figures) {
	  return condensedReshape$(figures, 'Combine');
	};
	
	_cdl.Figures.weld$ = function (figures) {
	  return condensedReshape$(figures, 'Weld');
	};
	
	_cdl.Figures.frontMinusBack$ = function (figures) {
	  return condensedReshape$(figures, 'FrontMinusBack');
	};
	
	_cdl.Figures.backMinusFront$ = function (figures) {
	  return condensedReshape$(figures, 'BackMinusFront');
	};
	
	_cdl.Figures.condense$ = function (figures) {
	  return condensedReshape$(figures, 'Condense');
	};
	
	_cdl.Figures.cutOutline$ = function (figures, options) {
	  figures = { Figures: _cdl.Figures.toCoreModel(figures) };
	  return Cx.Core.Figure.cutOutline$(options ? (0, _lodash.assign)(figures, objectToCoreCase(options)) : figures).then(_cdl.Figures.fromCoreModel);
	};
	
	_cdl.Figures.rasterize$ = function (figures, options) {
	  figures = { Figures: _cdl.Figures.toCoreModel(figures) };
	  return Cx.Core.Figure.rasterize$(options ? (0, _lodash.assign)(figures, objectToCoreCase(options)) : figures).then(_cdl.Figures.fromCoreModel);
	};
	
	_cdl.Figures.vectorize$ = function (figures, options) {
	  figures = { Figures: _cdl.Figures.toCoreModel(figures) };
	  return Cx.Core.Figure.vectorize$(options ? (0, _lodash.assign)(figures, objectToCoreCase(options)) : figures).then(_cdl.Figures.fromCoreModel);
	};
	
	_cdl.Figures.colorAt$ = function (figures, point) {
	  if (!(0, _gear.isArray)(figures)) {
	    figures = [figures];
	  }
	  return Cx.Core.Figure.colorAt$({
	    Figures: _cdl.Figures.toCoreModel(figures),
	    Point: point.toCore()
	  }).then(function (colorModel) {
	    if (!colorModel) {
	      return null;
	    }
	    var argb = colorModel.ARGB;
	    return (0, _cdl.Color)({ alpha: parseInt(argb.substring(0, 2), 16) / 255, rgb: argb.substring(2, argb.length) });
	  });
	};

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadFontDataFromCore$ = exports.CoreFontData = undefined;
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _cdl = __webpack_require__(15);
	
	var _window = window;
	var Cx = _window.Cx;
	
	/*
	{
	  Info: { Id: ..., ... }
	  Metrics: {
	    Ascent: ...,
	    Descent: ...,
	    Height: ...,
	    AveCharWidth: ...,
	    InternalLeading: ...
	  },
	  Glyphs: [
	    { Id: 'A', AX: 50, AY: 100, D: "svg path..." },
	    { Id: 'B', AX: 45, AY: 100, D: "svg path..." },
	    ...
	  ],
	  Kerning: { "AV": "-25", "AT": -15, ... }
	}
	*/
	
	//===============================================================
	
	var basicChars = ' ' + 'A~BCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789' + '!"#$%&()*+,-./:;<=>?@[]^_`{|}~\\' + "'";
	//===============================================================
	
	var CoreFontData = exports.CoreFontData = _cdl.FontData.extend({ typeName: 'CoreFontData',
	
	  init: function (fontInfo, requestedGlyphs, sizeRef) {
	
	    this._kTable = {};
	    this._glyphs = {};
	    this._glyphsString = "";
	    this._sizeReferenceChar = sizeRef;
	
	    //console.log(`  CoreFontData init. sizeRef=${this._sizeReferenceChar}`);
	
	    this.parseInfo(fontInfo, requestedGlyphs);
	
	    var tm = fontInfo.Metrics;
	
	    this._referenceSize = tm.RequestedSize || tm.Size;
	
	    // Parse metrics, we leave them at the reference size to be able to share the
	    // same font for multiple font sizes. The desire size is passed as a parameter when
	    // asked for the metrics
	
	    this._ascent = tm.Ascent;
	    this._descent = tm.Descent;
	    this._height = tm.Height;
	    this._lineSpacing = tm.LineSpacing;
	
	    this._width = tm.AverageWidth;
	
	    // See http://www.emdpi.com/fontsize.html
	    // Maybe we should find a better name for this property
	    this._upperSize = tm.UpperSize;
	
	    this._spaceWidth = tm.SpaceWidth;
	    this._spaceHeight = tm.SpaceHeight;
	
	    this.initFontData();
	
	    this._metaData = fontInfo.Info.AdvancedSpacing;
	
	    // Sample for local testing purposes    
	    // this._metaData = '{"50.8" : { "2" : [ { "L": "S", "R": "A", "S": 10 }, { "L": "P", "R": "L", "S": 15 }, { "S" : 10 } ], "3" : [ { "L": "M", "R": "P", "S": 20 }, { "L": "L", "R": "E", "S": 25 } , { "S" : 15 }] }}' ;
	  },
	  parseInfo: function (fontInfo, requestedGlyphs) {
	    this.parseKerning(fontInfo.Kerning);
	    this.parseGlyphs(fontInfo.Glyphs, requestedGlyphs);
	  },
	  parseGlyphs: function (gc, requestedGlyphs) {
	    var _this = this,
	        glyphs = _this._glyphs;
	    (0, _lodash.forEach)(gc, function (glyph) {
	      var id = glyph.Id,
	          aX = glyph.AX,
	          aY = glyph.AY;
	      //console.log("    GlyphID:" + id + " AX:" + aX + " AY:" + aY);
	      var outlines = null,
	          bounds = void 0;
	      if (glyph.D) {
	        outlines = (0, _cdl.curvesFromSvgPath)(glyph.D);
	        bounds = _cdl.Bounds.ofThings(outlines);
	      } else {
	        bounds = (0, _cdl.Bounds)(0, 0, aX, aY);
	      }
	
	      if (glyphs[id] === undefined) {
	        _this._glyphsString += id;
	      }
	      glyphs[id] = new _cdl.Glyph(id, outlines, bounds, 0, aX, aY, 0);
	    });
	
	    // The server is not returning the glyph it doesn't exist.
	    // We need to cache it here to avoid asking it again
	    (0, _lodash.forEach)(requestedGlyphs, function (c) {
	      if (glyphs[c] === undefined) {
	        //console.log("    Glyph:" + c + " was not returned from the server!");
	        glyphs[c] = null;
	        _this._glyphsString += c;
	      }
	    });
	  },
	  parseKerning: function (kerns) {
	    var kTable = this._kTable;
	    (0, _lodash.forOwn)(kerns, function (kern, ab) {
	      kTable[ab] = parseFloat(kern);
	    });
	  },
	
	
	  get metaData() {
	    return JSON.parse(this._metaData);
	  }
	});
	
	// Load and cache full data requests from Core in memory
	// A cached version with only the latin characters is loaded first, then missing
	// glyphs are requested when needed.
	
	var fontDataStore = {/* textualizedFont: { fontData, extensionQueue, extending } */};
	var temporalFontDataStore = {};
	var currentRequests = {};
	
	var processExtensions = function (entry) {
	  var queue = entry.extensionQueue,
	      fontData = entry.data;
	  if (!entry.extending && queue.length > 0) {
	    (function () {
	      entry.extending = true;
	      var e = queue.shift();
	
	      //console.log(`Calling matchFullData for Glyphs:${e.GlyphsToRequest} Match:${e.Match} (for missing glyphs)`);
	
	      Cx.Core.Font.matchFullData$({
	        Match: e.Match,
	        GlyphsToRequest: e.GlyphsToRequest,
	        ExtraKerningGlyphs: fontData._glyphsString,
	        time: Date.now()
	      }).then(function (m) {
	        //console.log("  matchFullData returned (for missing glyphs)");
	        fontData.parseInfo(m, e.GlyphsToRequest);
	        e.deferred.resolve(fontData);
	        entry.extending = false;
	        processExtensions(entry);
	      });
	    })();
	  }
	};
	
	var fetchMissingGlyphs$ = function (fc, fontDataEntry, chars, sizeRef) {
	
	  //console.log("  Fetching missing glyphs...");
	
	  var fontData = fontDataEntry.data;
	  fontData._sizeReferenceChar = sizeRef;
	  var glyphs = fontData._glyphs;
	  var missingGlyphs = '';
	  (0, _lodash.forEach)((0, _lodash.uniq)(chars + sizeRef), function (c) {
	    if (c !== '\n' && c !== '\r') {
	      if (glyphs[c] === undefined) {
	        // null means it doesn't exist but was already requested
	        missingGlyphs += c;
	      }
	    }
	  });
	  if (missingGlyphs !== '') {
	
	    //console.log(`  missingGlyphs:${missingGlyphs}`);
	
	    // We need to serialize the extension of fontData, if not we could end up with missing kerning information
	    var extensionDeferred = new _gear.Deferred();
	    fontDataEntry.extensionQueue.push({ Match: fc, GlyphsToRequest: missingGlyphs, deferred: extensionDeferred });
	    processExtensions(fontDataEntry);
	    return extensionDeferred.promise;
	  } else {
	    //console.log("  no glyphs are missing");
	    return (0, _gear.resolve)(fontData);
	  }
	};
	
	_cdl.FontData.coreFontData$ = function (font, _fc, _t, sizeRef) {
	  var fc = _fc || font.toCore(),
	      t = _t || font.textualize();
	
	  //console.log(`  FontData.coreFontData$. Font:${t} sizeRef:${sizeRef}`);
	
	  var alreadyCachedFontData = fontDataStore[t];
	  if (alreadyCachedFontData) {
	    //console.log("    font already cached..");
	    return (0, _gear.resolve)(alreadyCachedFontData);
	  }
	
	  var currentlyAskingIt = currentRequests[t];
	  if (currentlyAskingIt) {
	    //console.log("    font is being currently requested..");
	    return currentlyAskingIt;
	  }
	
	  //console.log("    Calling matchFullData for ALL glyphs...");
	  var request = currentRequests[t] = Cx.Core.Font.matchFullData$({ Match: fc, GlyphsToRequest: basicChars + sizeRef, UseCache: _config.Config.useCoreFontCache, time: Date.now() }).then(function (m) {
	    delete currentRequests[t];
	    //console.log("      Creating CoreFontData with ALL glyphs...");
	    var fontData = new CoreFontData(m, "", sizeRef);
	    fontDataStore[t] = { data: fontData, extensionQueue: [], extending: false };
	    delete temporalFontDataStore[t];
	    return fontData;
	  });
	  return request;
	};
	
	var loadFontDataFromCore$ = exports.loadFontDataFromCore$ = function (font, chars, sizeRef) {
	
	  var fc = font.toCore();
	  var t = font.textualize();
	
	  //console.log(`loadFontDataFromCore$. Font:${t} Chars:${chars} SizeRef:${sizeRef}`);
	
	  if (!_config.Config.serverFontParsing) {
	
	    //console.log("  ... using OpenType instead of the server");
	    // Direct download of the font using opentype
	    var src = font.coreSrc();
	    return _cdl.FontData.localLoad$(font, src);
	  } else {
	
	    // Server font store, if serverFontParsing is false this will be empty
	    var fontDataEntry = fontDataStore[t];
	    if (fontDataEntry) {
	      //console.log("  ... font is in the store already");
	      return fetchMissingGlyphs$(fc, fontDataEntry, chars, sizeRef);
	    }
	
	    if (_config.Config.preReadNeededGlyphs) {
	
	      //console.log("  preReadNeededGlyphs configuration");
	
	      // We request only the needed glyphs to the server to speed up rendering
	      // In the background we are going to ask for the whole set of latin chars
	      var neededGlyphs = '';
	      (0, _lodash.forEach)((0, _lodash.uniq)(chars + ' MA' + sizeRef), function (c) {
	        if (c !== '\n' && c !== '\r') {
	          neededGlyphs += c;
	        }
	      });
	      if (neededGlyphs === '') {
	        // Looks like the server is returning everything if we send an empty string
	        neededGlyphs = ' ';
	      }
	
	      // We save the temporal fast calls in case a figure is updated twice before the basic glyphs set is on the client
	      if (!temporalFontDataStore[t]) {
	        temporalFontDataStore[t] = {};
	      }
	      var tfds = temporalFontDataStore[t];
	      var alreadyRequested = tfds[neededGlyphs];
	      if (alreadyRequested) {
	        return alreadyRequested;
	      }
	
	      var promise = tfds[neededGlyphs] = Cx.Core.Font.matchFullData$({ Match: fc, GlyphsToRequest: neededGlyphs + sizeRef, time: Date.now() }).then(function (m) {
	        return new CoreFontData(m, "", sizeRef);
	      });
	
	      // Read the basic set on the background
	      _cdl.FontData.coreFontData$(font, fc, t, sizeRef);
	
	      return promise;
	    } else {
	      return _cdl.FontData.coreFontData$(font, fc, t, sizeRef).then(function () {
	        return fetchMissingGlyphs$(fc, fontDataStore[t], chars, sizeRef);
	      });
	    }
	  }
	};
	
	/*
	if( Config.localDebugFont ) {
	  Cx.Core.Font.matchFullData$ = function() {
	    return resolve(Font._varsityFontData);
	  };
	}
	*/

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GlobalCoreResourceManager = undefined;
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _cdl = __webpack_require__(15);
	
	var _coreUtil = __webpack_require__(132);
	
	var _coreFontData = __webpack_require__(133);
	
	var _window = window;
	var Cx = _window.Cx;
	
	
	_cdl.DocumentTag.fromCore = function (rm) {
	  return (0, _coreUtil.objectFromCore)(_cdl.DocumentTag, rm);
	};
	
	_cdl.Document.fromCore = function (model, bcFixes) {
	  var doc = _cdl.Document.fromXmlString(model.Cdl, bcFixes);
	
	  doc.name = model.Name;
	  doc.class1 = model.Class1;
	  doc.class2 = model.Class2;
	  doc.class3 = model.Class3;
	  doc.modified = model.Modified;
	  doc.notes = model.Notes;
	  doc.owned = model.Owned;
	  doc.docType = model.DocType; // We should check here, docType: Doc3D and xType: System.Document3D should be consistent
	
	  if (doc._owned) {
	    doc.id = model.Id; // sets the ID, which means by default the user saves over the top
	    doc._isSaved = true;
	    doc.externalId = model.ExternalId;
	  }
	  // Tags
	  doc.tags = (0, _lodash.map)(model.Tags, _cdl.DocumentTag.fromCore);
	
	  doc.dropPreviousHistoryOnNextCommit();
	  return doc;
	};
	
	_cdl.Document.fromCore$ = function (model) {
	  return _cdl.Document.backwardCompatibleDecoding$(_cdl.Document.fromCore, model);
	};
	
	// Point
	//-----------------------------------------------------------------------------
	
	_cdl.Point.prototype.toCore = function () {
	  return { X: this.x, Y: this.y };
	};
	_cdl.Point.fromCore = function (c) {
	  return new _cdl.Point(c.X, c.Y);
	};
	
	// Matrix
	//-----------------------------------------------------------------------------
	
	var _toFixed = function (x) {
	  return +x.toFixed(4);
	};
	
	_cdl.Matrix.prototype.toCore = function () {
	  var _this = this;
	  return { S00: _toFixed(_this.s00), S01: _toFixed(_this.s01),
	    S10: _toFixed(_this.s10), S11: _toFixed(_this.s11),
	    DX: _toFixed(_this.dx), DY: _toFixed(_this.dy) };
	};
	
	_cdl.Matrix.fromCore = function (m) {
	  return new _cdl.Matrix({ s00: m.S00, s01: m.S01,
	    s10: m.S10, s11: m.S11,
	    dx: m.DX, dy: m.DY });
	};
	
	// Bounds
	//-----------------------------------------------------------------------------
	
	_cdl.Bounds.fromCore = function (m) {
	  return new _cdl.Bounds(m.LX, m.LY, m.HX, m.HY);
	};
	
	// Color
	//-----------------------------------------------------------------------------
	
	_cdl.Color.prototype.toCore = function () {
	  return (0, _coreUtil.propertiesToCore)(this);
	};
	_cdl.Color.fromCore = function (rm) {
	  return (0, _coreUtil.objectFromCore)(_cdl.Color, rm);
	};
	
	// Font
	//-----------------------------------------------------------------------------
	
	(0, _lodash.assign)(_cdl.Font.prototype, {
	  coreSrc: function () {
	    // [TODO] Core.Font.Url.MatchData is wrong
	    return Cx.Core.getUrl('Core2/Font/MatchData', this.toCore());
	  },
	  toCore: function () {
	    var _this = this,
	        co = {};
	    (0, _lodash.forEach)(_this.Properties, function (c, p) {
	      var v = _this[p];
	      if (v !== null) {
	        co[p === 'id' ? 'Id' : c.tag || (0, _coreUtil.toCoreCase)(p)] = v;
	      }
	    });
	    return co;
	  }
	});
	
	_cdl.Font.fromCore = function (rm) {
	  var font = (0, _coreUtil.objectFromCore)(_cdl.Font, rm);
	  var id = rm.Id;
	  if (id) {
	    font._id = id;
	  }
	  return font;
	};
	
	var GlobalCoreResourceManager = exports.GlobalCoreResourceManager = Cx.GlobalCoreResourceManager = function (config) {
	  (0, _lodash.assign)(this, config);
	};
	
	GlobalCoreResourceManager.prototype = {
	
	  get id() {
	    return Cx.Core.getConfig();
	  },
	
	  // Font
	
	  loadFontData$: function (font, chars, sizeRef) {
	    return (0, _coreFontData.loadFontDataFromCore$)(font, chars, sizeRef);
	  },
	  fontThumbnailUrl: function (font, config) {
	    var coreConfig = (0, _coreUtil.objectToCoreCase)(config);
	    return Cx.Core.Font.thumbnailUrl((0, _lodash.assign)({ Font: font.toCore() }, coreConfig));
	  },
	
	
	  // Image
	
	  // { id, preview } => { width, height, preview:base64 }
	  imageInfo$: function (m) {
	    return Cx.Core.Image.readInfo$({
	      Id: m.id, Preview: m.preview,
	      Compress: _config.Config.compressQuantums
	    }).then(function (r) {
	      var preview = r.Preview;
	      return { width: r.Width, height: r.Height,
	        preview: preview && 'data:image/png;base64,' + preview };
	    });
	  },
	
	
	  // { id, size } => base64
	  renderImage$: function (m) {
	    return Cx.Core.Image.readData$({ AsBase64: true,
	      Id: m.id, Quantum: m.size || null,
	      Compress: _config.Config.compressQuantums
	    }).then(function (r) {
	      return 'data:image/png;base64,' + r.Data;
	    });
	  },
	
	
	  // { id, size } => url
	  imageUrl: function (m) {
	    return Cx.Core.Image.readDataUrl({
	      Id: m.id, Quantum: m.size || null,
	      Compress: _config.Config.compressQuantums
	    });
	  },
	
	
	  // Document
	
	  loadDocument$: function (model, options) {
	    if ((0, _lodash.isString)(model)) {
	      model = { Id: model };
	    } else {
	      model = (0, _coreUtil.objectToCoreCase)(model);
	    }
	    return Cx.Core.Document.read$(model, options).then(_cdl.Document.fromCore$);
	  },
	  saveDocument$: function (doc) {
	
	    var requestModel = {
	      Cdl: doc.toXmlString(),
	      Name: doc._name,
	      Class1: doc._class1,
	      Class2: doc._class2,
	      Class3: doc._class3,
	      Modified: doc._modified,
	      Notes: doc._notes,
	      DocType: doc._docType,
	      ExternalId: doc._externalId
	    };
	
	    requestModel.Tags = [];
	    if (doc._category) {
	      requestModel.Tags.push({ Name: doc._category });
	    }
	
	    // If we have an id because we owned this document, overwrite the old one
	    if (doc._id) {
	      requestModel.Id = doc._id;
	    }
	
	    var operation = requestModel.Id ? 'update$' : 'create$';
	
	    return Cx.Core.Document[operation](requestModel).then(function (responseModel) {
	
	      doc.archived = true;
	      doc.owned = true;
	      if (responseModel.Id) {
	        doc.id = responseModel.Id;
	      }
	    });
	  },
	
	
	  // 3D Resources
	
	  loadDocument3D$: function (config, options) {
	    return this.loadDocument$(config, options);
	  },
	  saveDocument3D$: function (doc) {
	    return this.saveDocument$(doc);
	  },
	  loadModel3D$: function (id) {
	    return Cx.Core.Model3D.read$({ Id: id }).then(function (model) {
	      var model3D = _cdl.Model3D.fromXmlString(model.Data);
	      model3D.id = id;
	      return model3D;
	    });
	  },
	  saveModel3D$: function (model3D) {
	    var operation = model3D._id ? 'update$' : 'create$';
	
	    return Cx.Core.Model3D[operation]({ Data: model3D.toXmlString() }).then(function (responseModel) {
	
	      if (responseModel.Id) {
	        model3D.id = responseModel.Id;
	      }
	      return model3D;
	    });
	  },
	  loadModelData3D$: function (id) {
	    return Cx.Core.ModelData3D.read$({ Id: id }).then(function (model) {
	      var modelData3D = new _cdl.ModelData3D({ data: JSON.parse(model.Data) });
	      modelData3D.id = id;
	      return modelData3D;
	    });
	  },
	  saveModelData3D$: function (modelData3D) {
	    var jsonString = JSON.stringify(modelData3D.data);
	    var operation = modelData3D.id ? 'update$' : 'create$';
	    return Cx.Core.ModelData3D[operation]({ Data: jsonString }).then(function (responseModel) {
	      if (responseModel.Id) {
	        modelData3D.id = responseModel.Id;
	      }
	      return modelData3D;
	    });
	  },
	  createTextureMap3D$: function (file) {
	    return Cx.Core.Texture3D.create$(file).then(function (response) {
	      return new _cdl.TextureMap3D({ id: response.Id });
	    });
	  },
	  renderTexture3D$: function (model) {
	    return Cx.Core.Texture3D.render$({ Id: model.id, Size: model.size }).then(function (model) {
	      return model.Data;
	    });
	  },
	
	
	  // Figure Operations
	
	  optimizeFigures$: function (figures) {
	    return Cx.Core.Document.optimize$({ Cdl: _cdl.Figures.toXmlString(figures) }).then(function (optimizedDocModel) {
	      return _cdl.Figures.fromXmlString(optimizedDocModel.Cdl);
	    });
	  }
	};
	
	// Hack Cx.Core.fileUpload$, this is going to be a formal part
	// of Grafika at one point in the future
	
	if (_cdl.QuantumImage.downScaleQuantumsLocally()) {
	  (function () {
	
	    // We need to discuss with Justin about this. To create togehter a good abstraction
	    // for our apps
	
	    // I am overloading Cx.Core.fileUpload$ to be able to grab images directly without
	    // calling to ReadInfo/ReadData
	    // We could also explore importing the file without waiting for the file to upload
	    // But this will require a little bit more work
	    var core_fileUpload$ = Cx.Core.fileUpload$;
	
	    Cx.Core.fileUpload$ = function (url, file, requestModel, progressHandler, options) {
	      return core_fileUpload$(url, file, requestModel, progressHandler, options).then(function (response) {
	
	        if (url.indexOf('Texture3D/Create') !== -1) {
	          return response;
	        }
	
	        var type = file.type;
	
	        if (type === 'image/jpeg' || type === 'image/png') {
	
	          var imageLink = void 0;
	
	          // If the user issue a Doc/Import with the image
	          var cdl = response.Cdl;
	          if (cdl) {
	            imageLink = _cdl.Figure.fromXmlString(cdl).imageLink;
	          }
	
	          // If the user issue a Image/Create
	          if (!imageLink && url.indexOf('Image/Create') !== -1) {
	            imageLink = response.Id;
	          }
	
	          if (imageLink) {
	
	            // Cache the quantums locally
	            _cdl.QuantumImage.cacheFromFile$(imageLink, file);
	
	            // Ask the server to generate the quantum images so they are ready next time
	            Cx.Core.Image.generateQuantums$({ Id: imageLink });
	          }
	        }
	        return response;
	      });
	    };
	  })();
	}

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CoreXResourceManager = undefined;
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _cdl = __webpack_require__(15);
	
	var _window = window;
	var Cx = _window.Cx;
	
	/*
	Document.fromCoreX = function(model,bcFixes) {
	  const doc = Document.fromXmlString(model.Cdl,bcFixes);
	
	  doc.name =     model.Name;
	  doc.modified = model.Modified;
	  doc.notes =    model.Notes;
	  doc.owned =    model.Owned;
	  doc.docType =  model.DocType; // We should check here, docType: Doc3D and xType: System.Document3D should be consistent
	
	  if( doc._owned ) {
	    doc.id = model.Id; // sets the ID, which means by default the user saves over the top
	    doc._isSaved = true;
	    doc.externalId = model.ExternalId;
	  }
	  // Tags
	  doc.tags = []; // map( model.Tags, DocumentTag.fromCore );
	
	  doc.dropPreviousHistoryOnNextCommit();
	  return doc ;
	};
	
	Document.fromCore$ = function(model) {
	  return Document.backwardCompatibleDecoding$(Document.fromCore,model);
	};
	*/
	
	// https://gist.github.com/jed/982883
	
	function uuid(a) {
	  return a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, uuid);
	}
	
	// config: { app, uuid }
	var CoreXResourceManager = exports.CoreXResourceManager = function (config) {
	  (0, _lodash.assign)(this, config);
	  if (!this.namespace) {
	    this.namespace = 'Dev';
	  }
	  if (!config.uuid) {
	    this.uuid = uuid;
	  }
	};
	
	function splitCoreXId(id) {
	  var parts = id.split('/');
	  return {
	    namespace: parts[0],
	    id: parts[1]
	  };
	}
	
	CoreXResourceManager.prototype = {
	
	  get id() {
	    return this.namespace;
	  },
	
	  serverUrl: function () {
	    var protocol = _config.Config.ssl ? 'https' : 'http';
	    return protocol + '://' + (_config.Config.coreX_server || 'cadxcorextest.azurewebsites.net') + '/';
	  },
	
	
	  // Font
	
	  loadFontData$: function (font) {
	    var src = this.fontSrc(font);
	    return _cdl.FontData.localLoad$(font, src);
	  },
	  fontSrc: function (font) {
	    // [TODO] Remove, testing until there are resources uploaded
	    if (_config.Config.fontTest || !font.id) {
	      return 'http://cadworx-master-edge.azurewebsites.net/Core2/Font/MatchData?{"config":"Dev","model":{"FamilyName":"Stahls varsity"},"log":{"Environment":null,"ServerAccessToken":null},"ident":{"SessionId":"45f22658-87e3-4a3e-b8ac-4c044b947892","SuperUser":false}}';
	    }
	    var parts = splitCoreXId(font.id);
	    return this.serverUrl() + parts.namespace + '/resource/' + parts.id;
	  },
	  fontThumbnailUrl: function () /* font, config */{
	    return '[TODO]';
	  },
	
	
	  // Image
	
	  // { id, preview } => { width, height, preview:base64 }
	  imageInfo$: function (m) {
	    var parts = splitCoreXId(m.id);
	    return fetch(this.serverUrl() + parts.namespace + '/meta-image/' + parts.id).then(function (response) {
	      return response.json();
	    }).then(function (meta) {
	      return {
	        width: meta.width,
	        height: meta.height,
	        preview: 'data:image/png;base64,' + meta.b64thumb
	      };
	    });
	  },
	
	
	  // { id, size } => base64
	  renderImage$: function (m) {
	    var parts = splitCoreXId(m.id);
	    return fetch(this.serverUrl() + parts.namespace + '/image/' + parts.id + '/' + m.size + '?format=base64').then(function (response) {
	      return response.text();
	    }).then(function (data) {
	      return 'data:image/png;base64,' + data;
	    });
	  },
	
	
	  // { id, size } => url
	  imageUrl: function (m) {
	    var parts = splitCoreXId(m.id);
	    return this.serverUrl() + parts.namespace + '/image/' + parts.id + '/' + m.size;
	  },
	
	
	  // => image$( ... ) => Image
	
	
	  // Document
	
	  loadDocument$: function (id) {
	    var parts = splitCoreXId(id);
	    return fetch(this.serverUrl() + parts.namespace + '/resource/' + parts.id).then(function (response) {
	      return response.text();
	    }).then(function (xmlString) {
	      return _cdl.Document.fromXmlString$(xmlString).then(function (doc) {
	        doc.id = id;
	        doc._isSaved = true;
	        return doc;
	      });
	    });
	  },
	  saveDocument$: function (doc) {
	    // Always create a new uuid
	
	    var id = this.uuid();
	    var namespace = this.namespace;
	    // POST to id
	
	    var formData = new FormData();
	
	    formData.append(name, data[name]);
	
	    /*
	    fetch(url, {
	      method: 'POST',
	      body: formData
	    });
	      return fetch( this.serverUrl() + '/meta-resource/', {
	      method: 'POST',
	      mode: 'CORS',
	      headers: {
	        "Content-Type": "multipart/form-data"
	      },
	      body: ''
	    }) .then( responseModel => {
	      doc.id = id;
	    doc._isSaved = true;
	    });
	    */
	  },
	
	
	  // 3D Resources
	
	  loadDocument3D$: function (config, options) {
	    return this.loadDocument$(config, options);
	  },
	  saveDocument3D$: function (doc) {
	    return this.saveDocument$(doc);
	  },
	  loadModel3D$: function (id) {
	    return Cx.Core.Model3D.read$({ Id: id }).then(function (model) {
	      var model3D = _cdl.Model3D.fromXmlString(model.Data);
	      model3D.id = id;
	      return model3D;
	    });
	  },
	  saveModel3D$: function (model3D) {
	    var operation = model3D._id ? 'update$' : 'create$';
	
	    return Cx.Core.Model3D[operation]({ Data: model3D.toXmlString() }).then(function (responseModel) {
	
	      if (responseModel.Id) {
	        model3D.id = responseModel.Id;
	      }
	      return model3D;
	    });
	  },
	  loadModelData3D$: function (id) {
	    return Cx.Core.ModelData3D.read$({ Id: id }).then(function (model) {
	      var modelData3D = new _cdl.ModelData3D({ data: JSON.parse(model.Data) });
	      modelData3D.id = id;
	      return modelData3D;
	    });
	  },
	  saveModelData3D$: function (modelData3D) {
	    var jsonString = JSON.stringify(modelData3D.data);
	    var operation = modelData3D.id ? 'update$' : 'create$';
	    return Cx.Core.ModelData3D[operation]({ Data: jsonString }).then(function (responseModel) {
	      if (responseModel.Id) {
	        modelData3D.id = responseModel.Id;
	      }
	      return modelData3D;
	    });
	  },
	  createTextureMap3D$: function (file) {
	    return Cx.Core.Texture3D.create$(file).then(function (response) {
	      return new _cdl.TextureMap3D({ id: response.Id });
	    });
	  },
	  renderTexture3D$: function (model) {
	    return Cx.Core.Texture3D.render$({ Id: model.id, Size: model.size }).then(function (model) {
	      return model.Data;
	    });
	  }
	};

/***/ }
])
});
;


/** WEBPACK FOOTER **
 ** cdl.js
 **/